import { TypedDocumentNode as DocumentNode } from "@graphql-typed-document-node/core";
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = {
  [K in keyof T]: T[K];
};
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & {
  [SubKey in K]?: Maybe<T[SubKey]>;
};
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & {
  [SubKey in K]: Maybe<T[SubKey]>;
};
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  Date: any;
  DateTime: any;
  /** Used to represent numerical financial values */
  Decimal: string | number;
  /** Valid email address */
  EmailAddress: any;
  /** JSON */
  JSON: any;
  /** An integer greater than or equal to zero */
  PositiveInteger: any;
  URL: any;
  /** The `Upload` scalar type represents a file upload. */
  Upload: any;
};

export type AcceptRequestConnectionInput = {
  brandId: Scalars["ID"];
  retailerId: Scalars["ID"];
};

export type AcceptRequestConnectionPayload = {
  __typename?: "AcceptRequestConnectionPayload";
  brandId: Scalars["ID"];
  connectionStatus: LgConnectionStatus;
  error?: Maybe<Scalars["String"]>;
  retailerId: Scalars["ID"];
};

/** Accepts a PENDING membership invite */
export type AcceptUserMembershipInviteInput = {
  membershipInviteId: Scalars["ID"];
  password: Scalars["String"];
  userName: Scalars["String"];
};

/** Accepts a pending request for membership */
export type AcceptUserMembershipRequestInput = {
  userMembershipRequestId: Scalars["ID"];
};

/** Returns either the user created or an error. */
export type AcceptUserMembershipRequestPayload = {
  __typename?: "AcceptUserMembershipRequestPayload";
  success?: Maybe<Scalars["Boolean"]>;
};

export type Account = Node & {
  __typename?: "Account";
  accountManagerEmail?: Maybe<Scalars["String"]>;
  aliasedName?: Maybe<Scalars["String"]>;
  assortmentIntegrations?: Maybe<Array<AssortmentIntegration>>;
  hasAssortmentIntegrations?: Maybe<AvailableAssortmentIntegrations>;
  id: Scalars["ID"];
  logoUrl?: Maybe<Scalars["String"]>;
  name: Scalars["String"];
  privacy: Scalars["Boolean"];
  tier?: Maybe<AccountTier>;
  type?: Maybe<AccountType>;
};

export type AccountCasepack = Node & {
  __typename?: "AccountCasepack";
  id: Scalars["ID"];
  name?: Maybe<Scalars["String"]>;
  skus: CasepackSkuConnection;
};

export type AccountCasepackSkusArgs = {
  withDeleted?: InputMaybe<Scalars["Boolean"]>;
};

export type AccountCasepackConnection = {
  __typename?: "AccountCasepackConnection";
  edges: Array<AccountCasepackEdge>;
};

export type AccountCasepackEdge = {
  __typename?: "AccountCasepackEdge";
  node: AccountCasepack;
};

export type AccountConnectionRequest = {
  action: Action;
  otherAccountId: Scalars["ID"];
  priceTypeIds?: InputMaybe<Array<Scalars["ID"]>>;
};

export type AccountConnectionStatus = {
  __typename?: "AccountConnectionStatus";
  accountId: Scalars["ID"];
  otherAccountId: Scalars["ID"];
  status: Status;
};

export type AccountCustomerCode = {
  __typename?: "AccountCustomerCode";
  alias?: Maybe<Scalars["String"]>;
  code?: Maybe<Scalars["String"]>;
  otherAccountId: Scalars["ID"];
};

export type AccountCustomerCodeInput = {
  alias?: InputMaybe<Scalars["String"]>;
  code?: InputMaybe<Scalars["String"]>;
  otherAccountId: Scalars["ID"];
};

export type AccountIdAndDisplayName = {
  __typename?: "AccountIdAndDisplayName";
  displayName?: Maybe<Scalars["String"]>;
  id: Scalars["ID"];
};

export type AccountPaymentProvider = {
  __typename?: "AccountPaymentProvider";
  accountId: Scalars["ID"];
  brandNotificationEmail?: Maybe<Scalars["String"]>;
  connectionDetails?: Maybe<ConnectionDetails>;
  externalIdentifier: Scalars["String"];
  isAchEnabled?: Maybe<Scalars["Boolean"]>;
  isSepaEnabled?: Maybe<Scalars["Boolean"]>;
  paymentProvider: Scalars["String"];
  retailersCanSeeInvoices?: Maybe<Scalars["Boolean"]>;
  sendBrandMailPaymentProcessed?: Maybe<Scalars["Boolean"]>;
  sendRetailerMailPaymentProcessed?: Maybe<Scalars["Boolean"]>;
};

export type AccountProfile = Node & {
  __typename?: "AccountProfile";
  id: Scalars["ID"];
  logoUrl?: Maybe<Scalars["String"]>;
  name: Scalars["String"];
};

export enum AccountTier {
  Lite = "LITE",
  Pro = "PRO",
}

export enum AccountType {
  Admin = "ADMIN",
  Brand = "BRAND",
  Retailer = "RETAILER",
}

export type AccountUserGeoRestrictions = Node & {
  __typename?: "AccountUserGeoRestrictions";
  accountId: Scalars["ID"];
  exceptionAccounts: Array<PermissionsAccount>;
  id: Scalars["ID"];
  possibleExceptionAccounts: Array<PermissionsAccount>;
  regionAssignedOverride: Scalars["Boolean"];
  regions: RegionConnection;
  userId: Scalars["ID"];
};

export enum Action {
  Accept = "ACCEPT",
  Send = "SEND",
  Unknown = "UNKNOWN",
}

/** Adds doors to an assortment */
export type AddAssortmentDoorsInput = {
  /** Id of the assortment to add doors */
  assortmentId: Scalars["ID"];
  /** Ids of the doors to add */
  doorIds: Array<Scalars["ID"]>;
};

export type AddAssortmentDoorsPayload = {
  __typename?: "AddAssortmentDoorsPayload";
  assortment: Assortment;
};

export type AddColorsToAssortmentInput = {
  assortmentId: Scalars["ID"];
  collectionId?: InputMaybe<Scalars["ID"]>;
  colorIds: Array<Scalars["ID"]>;
  priceTypeId: Scalars["ID"];
};

export type AddColorsToAssortmentPayload = {
  __typename?: "AddColorsToAssortmentPayload";
  assortment?: Maybe<Assortment>;
};

export type AddColorsToAssortmentProductRequest = {
  colors: Array<AssortmentProductColorRequest>;
  productId: Scalars["ID"];
};

export type AddFavoriteAccountInput = {
  brandAccountId: Scalars["ID"];
  tradeShowEventId?: InputMaybe<Scalars["ID"]>;
};

export type AddInventoryAvailabilityGroupInput = {
  inventoryDate: Scalars["Date"];
  inventoryNumber: Scalars["String"];
  warehouseId: Scalars["String"];
};

export type AddInventoryAvailabilityGroupPayload = {
  __typename?: "AddInventoryAvailabilityGroupPayload";
  availability: Availability;
  id: Scalars["ID"];
  inventoryNumber: Scalars["String"];
  warehouseId: Scalars["String"];
};

export type AddProductAndSkusToCollectionInput = {
  orderNumber?: InputMaybe<Scalars["Int"]>;
  productId: Scalars["ID"];
  skus?: InputMaybe<Array<SkuDeliveryInput>>;
};

export type AddProductToCollectionInput = {
  comments?: InputMaybe<Scalars["String"]>;
  orderNbr?: InputMaybe<Scalars["Int"]>;
  productId: Scalars["ID"];
  skuIds?: InputMaybe<Array<Scalars["ID"]>>;
};

export type AddProductsAndSkusToCollectionInput = {
  collectionId: Scalars["ID"];
  collectionProducts?: InputMaybe<Array<AddProductAndSkusToCollectionInput>>;
};

export type AddProductsToOrdersInput = {
  newOrdersInfo?: InputMaybe<NewOrdersInfo>;
  orderId?: InputMaybe<Scalars["ID"]>;
  products?: InputMaybe<Array<ProductInfo>>;
};

export type AddProductsToOrdersPayload = {
  __typename?: "AddProductsToOrdersPayload";
  createdOrderIds?: Maybe<Array<Scalars["ID"]>>;
  createdWebOrderIds?: Maybe<Array<Scalars["ID"]>>;
  modifiedOrderIds?: Maybe<Array<Scalars["ID"]>>;
};

/** Add existing skus to an assortment. Does not support custom skus (from the retailer side) */
export type AddSkusToAssortmentInput = {
  assortmentId: Scalars["ID"];
  priceTypeId: Scalars["ID"];
  skuIds: Array<Scalars["ID"]>;
};

export type AddSkusToAssortmentPayload = {
  __typename?: "AddSkusToAssortmentPayload";
  assortment?: Maybe<Assortment>;
};

export type AddStyleboardCommentInput = {
  message: Scalars["String"];
  styleboardId: Scalars["String"];
};

export type AddUnitsInProgressInput = {
  /** To pass bulk quantities to be added to the orders in progress */
  bulkQuantities?: InputMaybe<Array<BulkQuantity>>;
  /** To pass casepack quantities to be added to the orders in progress */
  casepackQuantities?: InputMaybe<Array<CasepackQuantity>>;
  /** To assign a hub to the orders */
  hubId?: InputMaybe<Scalars["ID"]>;
  /** Context to get or create orders */
  orderInfo: OrderInfo;
  /** To pass SKU quantities to be added to the orders in progress */
  skuQuantities?: InputMaybe<Array<SkuQuantity>>;
};

export type AddUnitsInProgressPayload = {
  __typename?: "AddUnitsInProgressPayload";
  createdOrderIds?: Maybe<Array<Scalars["ID"]>>;
};

export type AddVariantsInProgressInput = {
  hubId?: InputMaybe<Scalars["ID"]>;
  orderInfo: OrderInfo;
  /** This field is deprecated please use variantItems */
  variantIds?: InputMaybe<Array<Scalars["ID"]>>;
  variantItems?: InputMaybe<Array<VariantItemsInput>>;
};

export type AddVariantsInProgressPayload = {
  __typename?: "AddVariantsInProgressPayload";
  orderIds?: Maybe<Array<Scalars["ID"]>>;
};

export type AddWarehousePayload = {
  __typename?: "AddWarehousePayload";
  code: Scalars["String"];
  id: Scalars["ID"];
  name: Scalars["String"];
  orderNbr?: Maybe<Scalars["Int"]>;
};

export type AddWarehousesInput = {
  code: Scalars["String"];
  name: Scalars["String"];
};

export type AddressInput = {
  city?: InputMaybe<Scalars["String"]>;
  companyName?: InputMaybe<Scalars["String"]>;
  country?: InputMaybe<Scalars["String"]>;
  line1?: InputMaybe<Scalars["String"]>;
  line2?: InputMaybe<Scalars["String"]>;
  name?: InputMaybe<Scalars["String"]>;
  recipientName?: InputMaybe<Scalars["String"]>;
  state?: InputMaybe<Scalars["String"]>;
  zip?: InputMaybe<Scalars["String"]>;
};

export type AddressUpdateInput = {
  city?: InputMaybe<Scalars["String"]>;
  companyName?: InputMaybe<Scalars["String"]>;
  country?: InputMaybe<Scalars["String"]>;
  line1?: InputMaybe<Scalars["String"]>;
  line2?: InputMaybe<Scalars["String"]>;
  state?: InputMaybe<Scalars["String"]>;
  zip?: InputMaybe<Scalars["String"]>;
};

export enum AdjustmentTypeEnum {
  Additive = "ADDITIVE",
  Markup = "MARKUP",
  Override = "OVERRIDE",
  Subtractive = "SUBTRACTIVE",
}

export type AggregateSkuInventoryItem = {
  __typename?: "AggregateSkuInventoryItem";
  availableQuantity: Scalars["Int"];
  groups?: Maybe<Array<AggregateSkuInventoryItemGroup>>;
  skuId: Scalars["ID"];
};

export type AggregateSkuInventoryItemGroup = {
  __typename?: "AggregateSkuInventoryItemGroup";
  availableQuantity: Scalars["Int"];
  group?: Maybe<InventoryAvailabilityGroup>;
  items: Array<InventoryItem>;
};

export type AggregateSkuInventoryItemsFilter = {
  productIds: Array<Scalars["ID"]>;
};

export type AliasAddressInput = {
  address: AddressInput;
  code?: InputMaybe<Scalars["String"]>;
  id?: InputMaybe<Scalars["ID"]>;
  phoneNumber?: InputMaybe<Scalars["String"]>;
};

export type AliasAddressUpdateInput = {
  address: AddressUpdateInput;
  buyerId?: InputMaybe<Scalars["ID"]>;
  code?: InputMaybe<Scalars["String"]>;
  id: Scalars["ID"];
  phoneNumber?: InputMaybe<Scalars["String"]>;
};

export type ApplyAssortmentSkuAttributesInput = {
  assortmentId?: InputMaybe<Scalars["ID"]>;
  /** Ids of the attribute options to apply */
  attributeOptionIds: Array<Scalars["ID"]>;
  /** Ids of the assortment sku override values being attributed */
  overrideIds: Array<Scalars["ID"]>;
};

export type ApplyAssortmentSkuColorAttributesPayload = {
  __typename?: "ApplyAssortmentSkuColorAttributesPayload";
  /** NOTE: There's a known bug with querying images and swatch on these nodes */
  colors?: Maybe<Array<AssortmentSkuColor>>;
  errors?: Maybe<Array<Error>>;
  /** Required to query the assortment in the mutation response */
  query: Query;
};

export type ApplySizeCurveToDoorColorsRequest = {
  assortmentId: Scalars["ID"];
  requests: Array<DoorColorsRequest>;
};

export type ApplySizeCurveToDoorColorsResponse = {
  __typename?: "ApplySizeCurveToDoorColorsResponse";
  assortment?: Maybe<Assortment>;
  query?: Maybe<Query>;
};

export type AssignProductColorImageResult = {
  __typename?: "AssignProductColorImageResult";
  colorId: Scalars["ID"];
};

export type Assortment = BaseAssortment &
  Node & {
    __typename?: "Assortment";
    /** Object version for this assortment */
    _version: Scalars["String"];
    /** The selected attributes for this assortment */
    attributeOptions: AttributeOptionConnection;
    /** Assortment/item attribute fields whose values are required before the assortment can be exported */
    attributeValidationRequirements: Array<AttributeValidation>;
    /** Merchandising hierarchy nodes available to apply to this assortment */
    availableMerchandisingHierarchy: MerchandisingHierarchyNodeConnection;
    /** The attribute options available to be applied to assortment sku colors on this assortment */
    availableSkuColorAttributeOptions: AttributeOptionConnection;
    /** The retailer brand linked to this assortment */
    brand?: Maybe<RetailerBrandEdge>;
    /** Brand Name associated with Assortment itself (not trough brand_id field) */
    brandName?: Maybe<Scalars["String"]>;
    brandV2?: Maybe<RetailerBrand>;
    /**
     * The bulk line items contained in this assortment
     * @deprecated Use skus field instead
     */
    bulkLineItems: AssortmentBulkLineItemConnection;
    /** Linesheet */
    collection?: Maybe<Collection>;
    /** Visible Linesheet Code for this Assortment */
    collectionCode?: Maybe<Scalars["String"]>;
    /** Visible Linesheet Name for this Assortment */
    collectionName?: Maybe<Scalars["String"]>;
    /** The user who created this assortment */
    createdByUser: RetailerUserEdge;
    /** The date the assortment was created */
    createdDate: Scalars["Date"];
    /** The currency information for this assortment */
    currencies: AssortmentCurrencies;
    /** Delivery window details */
    deliveryWindow: AssortmentDeliveryWindow;
    /** A list of clusters to for this assortment */
    doorClusters: AssortmentDoorClusterConnection;
    /** A list of doors and clusters for this assortment */
    doorRuns: AssortmentDoorRunConnection;
    /** A list of doors to for this assortment */
    doors: AssortmentDoorConnection;
    /** The users able to edit this assortment */
    editableByUsers: RetailerUserConnection;
    /** The message associated with the most recent export attempt */
    exportMessage?: Maybe<Scalars["String"]>;
    /** Financial Overview associated with this assortment */
    financialOverview: AssortmentFinancialOverview;
    financials: AssortmentFinancials;
    id: Scalars["ID"];
    /** The success status of the most recent export attempt */
    latestExport?: Maybe<AssortmentExportStatus>;
    /**
     * The line items contained in this assortment
     * @deprecated Use skus field instead
     */
    lineItems: AssortmentLineItemConnection;
    /** The merchandising hierarchy nodes selected for this assortment */
    merchandisingHierarchy: MerchandisingHierarchyNodeConnection;
    /** The date the assortment was last modified */
    modifiedDate: Scalars["Date"];
    /** The name of the assortment */
    name: Scalars["String"];
    /** The assortment's sync status with a brand order */
    orderAssortmentSyncStatus?: Maybe<OrderAssortmentSyncStatus>;
    /** The PO number for this assortment */
    poNumber: Scalars["String"];
    /** The price modifiers applied to this assortment */
    priceModifiers: PriceModifierConnection;
    /** The retailer that owns this assortment */
    retailer: RetailerEdge;
    /** The season associated with this assortment */
    season?: Maybe<SeasonEdge>;
    /** List of assortment sharing details */
    shares: Array<AssortmentShare>;
    /** The SKUs that are listed on this assortment */
    skus: AssortmentSkuConnection;
    /** The current status of the assortment status */
    status: AssortmentStatus;
    /**
     * Similar to bulk line items but not assigned to a destination
     * @deprecated Use skus field instead
     */
    unassignedBulkLineItems: AssortmentBulkLineItemConnection;
    /**
     * Similar to line items but not assigned to a destination
     * @deprecated Use skus field instead
     */
    unassignedLineItems: AssortmentLineItemConnection;
    /** Total count of the unread notifications on this assortment for the querying user */
    unreadNotificationsCount: Scalars["Int"];
    /** Entries in this array represent a field whose value is required before the assortment can be exported */
    validationRequirements: Array<Validation>;
    /**
     * Assortments may be a part of a Workspace. If this Assortment is a part of a Workspace, this field will contain
     * information about that workspace. However, if this Assortment is not part of a Workspace, this field will be null.
     */
    workspace?: Maybe<RetailWorkspace>;
  };

export type AssortmentAvailableSkuColorAttributeOptionsArgs = {
  selectedOptionIds: Array<Scalars["ID"]>;
};

export type AssortmentSharesArgs = {
  onlyToMe?: InputMaybe<Scalars["Boolean"]>;
};

/** Filter assortments on archived fields */
export type AssortmentArchivedFilter = {
  /** If true then return only archived assortments */
  value: Scalars["Boolean"];
};

/** Filter assortments on brand fields */
export type AssortmentBrandFilter = {
  /** Filter on brand ids */
  ids?: InputMaybe<Array<Scalars["ID"]>>;
  /** Filter on brand name */
  name?: InputMaybe<AssortmentFilterValue>;
};

export type AssortmentBulkLineItemConnection = {
  __typename?: "AssortmentBulkLineItemConnection";
  count: Scalars["Int"];
  edges?: Maybe<Array<AssortmentBulkLineItemEdge>>;
};

export type AssortmentBulkLineItemEdge = {
  __typename?: "AssortmentBulkLineItemEdge";
  /** The line item containing the SKU, its quantity, and destination details */
  node?: Maybe<BulkLineItem>;
};

export type AssortmentConnection = {
  __typename?: "AssortmentConnection";
  edges: Array<AssortmentEdge>;
  /** Fetch the unique, sorted values for particular assortment fields, without considering pagination or filtering */
  fieldValues: FieldValues;
  pageInfo: PageInfo;
  /** Total number of filtered assortments without considering pagination */
  totalCount: Scalars["Int"];
  /** Total number of filtered workspaces and ungrouped assortments without considering pagination */
  totalCountWorkspaces: Scalars["Int"];
  /** This fetches a list that can contain both workspaces and ungrouped PO's. */
  workspaces: Array<WorkspaceOrAssortmentEdge>;
};

/** Filter assortments on retailer fields */
export type AssortmentCreatedByUserFilter = {
  /** Filter on created-by user name */
  name?: InputMaybe<AssortmentFilterValue>;
};

export type AssortmentCurrencies = {
  __typename?: "AssortmentCurrencies";
  /** @deprecated Get currency codes from financialDetails instead */
  assortmentCurrencyCodes: Array<Scalars["String"]>;
  currencyConversions?: Maybe<Array<CurrencyConversion>>;
  /** @deprecated Get currency codes from financialDetails instead */
  linesheetCurrencyCodes: Array<Scalars["String"]>;
};

export type AssortmentCurrencyConversion = {
  __typename?: "AssortmentCurrencyConversion";
  /** The assortment whose conversions were updated */
  assortment: Assortment;
  /**
   * The ID of the assortment to update
   * @deprecated Use field `assortment` instead
   */
  assortmentId: Scalars["ID"];
  /** Multiplicative conversion rate applied */
  factor: Scalars["Decimal"];
  /** Initial currency */
  fromCurrencyCode: Scalars["String"];
  /** Final currency */
  toCurrencyCode: Scalars["String"];
};

export type AssortmentDateRangeFilter = {
  end?: InputMaybe<Scalars["Date"]>;
  start?: InputMaybe<Scalars["Date"]>;
};

export type AssortmentDeliveryWindow = {
  __typename?: "AssortmentDeliveryWindow";
  completeShip?: Maybe<Scalars["Date"]>;
  due?: Maybe<Scalars["Date"]>;
  startShip?: Maybe<Scalars["Date"]>;
};

export type AssortmentDoorClusterConnection = {
  __typename?: "AssortmentDoorClusterConnection";
  count: Scalars["Int"];
  edges?: Maybe<Array<AssortmentDoorClusterEdge>>;
};

export type AssortmentDoorClusterEdge = {
  __typename?: "AssortmentDoorClusterEdge";
  node?: Maybe<DoorCluster>;
};

export type AssortmentDoorConnection = {
  __typename?: "AssortmentDoorConnection";
  edges?: Maybe<Array<AssortmentDoorEdge>>;
};

export type AssortmentDoorEdge = {
  __typename?: "AssortmentDoorEdge";
  node?: Maybe<Door>;
};

export type AssortmentDoorRun = {
  __typename?: "AssortmentDoorRun";
  id: Scalars["ID"];
  orderNbr?: Maybe<Scalars["Int"]>;
};

export type AssortmentDoorRunConnection = {
  __typename?: "AssortmentDoorRunConnection";
  edges?: Maybe<Array<AssortmentDoorRunEdge>>;
};

export type AssortmentDoorRunEdge = {
  __typename?: "AssortmentDoorRunEdge";
  node?: Maybe<AssortmentDoorRun>;
};

export type AssortmentEdge = {
  __typename?: "AssortmentEdge";
  cursor: Scalars["String"];
  node: Assortment;
};

export enum AssortmentExportStatus {
  Confirmed = "CONFIRMED",
  Exported = "EXPORTED",
  ExportFailure = "EXPORT_FAILURE",
  ExternalFailure = "EXTERNAL_FAILURE",
  Failure = "FAILURE",
  None = "NONE",
  ReExport = "RE_EXPORT",
  Success = "SUCCESS",
}

export type AssortmentExportTask = Node & {
  __typename?: "AssortmentExportTask";
  /** The export's download url, if the task's status is SUCCESS */
  downloadUrl?: Maybe<Scalars["URL"]>;
  id: Scalars["ID"];
  status: AssortmentExportStatus;
};

/** Filter for assortments query */
export type AssortmentFilter = {
  /**
   * Group of AssortmentFilters that will be joined by an AND condition
   * (All filters contained within a group will be joined by AND.)
   */
  and?: InputMaybe<Array<AssortmentFilter>>;
  /** Filter on archived */
  archived?: InputMaybe<AssortmentArchivedFilter>;
  /** Filter on brand name or brand ids */
  brand?: InputMaybe<AssortmentBrandFilter>;
  /** Filter on complete ship date (date only), use valid format such as m-d-yyyy */
  completeShip?: InputMaybe<AssortmentFilterValue>;
  /** Filter on created-by user name or created-by user ids */
  createdByUser?: InputMaybe<AssortmentCreatedByUserFilter>;
  /** Filter on created date (date only), use valid format such as m-d-yyyy */
  createdDate?: InputMaybe<AssortmentFilterValue>;
  /** Filter on assortment ids */
  ids?: InputMaybe<Array<Scalars["ID"]>>;
  /** Filter on modified date (date only), use valid format such as m-d-yyyy */
  modifiedDate?: InputMaybe<AssortmentFilterValue>;
  /** Filter on assortment name */
  name?: InputMaybe<AssortmentFilterValue>;
  /**
   * Group of AssortmentFilters that will be joined by an OR condition.
   * (All filters contained within a group will be joined by AND.)
   */
  or?: InputMaybe<Array<AssortmentFilter>>;
  /** Filter on assortment po number */
  poNumber?: InputMaybe<AssortmentFilterValue>;
  /** Filter on retailer name or retailer ids */
  retailer?: InputMaybe<AssortmentRetailerFilter>;
  /** Filter on season name or year */
  season?: InputMaybe<AssortmentSeasonFilter>;
  /** Filter on start ship date (date only), use valid format such as m-d-yyyy */
  startShip?: InputMaybe<AssortmentFilterValue>;
  /** Filter on assortment status */
  status?: InputMaybe<AssortmentFilterValue>;
  /** Filter on workspace */
  workspace?: InputMaybe<AssortmentWorkspaceFilter>;
};

/** Operator used to check equivalency of a field to filter assortments on */
export enum AssortmentFilterOperator {
  Contains = "CONTAINS",
  Equal = "EQUAL",
  GreaterThan = "GREATER_THAN",
  LessThan = "LESS_THAN",
}

/** Value and operator used to check equivalency of a field to filter assortments on */
export type AssortmentFilterValue = {
  /** Operator to use for field comparison e.g. equals, less than, greater than */
  operator: AssortmentFilterOperator;
  /** Value to match field on */
  value: Scalars["String"];
};

export type AssortmentFinancialDetails = {
  __typename?: "AssortmentFinancialDetails";
  currencyCode: Scalars["String"];
  isBrandCurrency?: Maybe<Scalars["Boolean"]>;
  priceLevels: Array<FinancialPriceLevel>;
  units: AssortmentUnits;
};

export type AssortmentFinancialOverview = {
  __typename?: "AssortmentFinancialOverview";
  /** @deprecated Get currency codes from financialDetails instead */
  assortmentCurrencyCode: Scalars["String"];
  assortmentUnits: AssortmentUnits;
  assortmentUnitsOverview: AssortmentUnitsOverview;
  financialDetails: Array<AssortmentFinancialDetails>;
  financialTargets: AssortmentFinancialTargets;
  /** @deprecated Get currency codes from financialDetails instead */
  linesheetCurrencyCode: Scalars["String"];
};

export type AssortmentFinancialPriceTargets = FinancialPrices & {
  __typename?: "AssortmentFinancialPriceTargets";
  averageUnitCost?: Maybe<Money>;
  averageUnitRetail?: Maybe<Money>;
  cost?: Maybe<Money>;
  initialMarkup?: Maybe<Scalars["Decimal"]>;
  retail?: Maybe<Money>;
};

export type AssortmentFinancialTargets = {
  __typename?: "AssortmentFinancialTargets";
  priceTargets: AssortmentFinancialPriceTargets;
  priceTargetsVariance: AssortmentFinancialPriceTargets;
  targetUnits: AssortmentUnits;
  targetUnitsVariance: AssortmentUnits;
};

export type AssortmentFinancials = Node & {
  __typename?: "AssortmentFinancials";
  doors: Array<DoorPriceLevels>;
  id: Scalars["ID"];
  products: Array<ProductPriceLevels>;
  total: TotalPriceLevels;
};

export type AssortmentIntegration = Node & {
  __typename?: "AssortmentIntegration";
  id: Scalars["ID"];
  name: Scalars["String"];
};

export type AssortmentLineItemConnection = {
  __typename?: "AssortmentLineItemConnection";
  count: Scalars["Int"];
  edges?: Maybe<Array<AssortmentLineItemEdge>>;
};

export type AssortmentLineItemEdge = {
  __typename?: "AssortmentLineItemEdge";
  /** The line item containing the SKU, its quantity, and destination details */
  node?: Maybe<LineItem>;
};

export type AssortmentLineItemFinancialTotals = {
  __typename?: "AssortmentLineItemFinancialTotals";
  finalAdjustedRetail?: Maybe<Scalars["Decimal"]>;
  finalCost?: Maybe<Scalars["Decimal"]>;
  finalExtendedCost?: Maybe<Scalars["Decimal"]>;
  finalExtendedInternalMarkup?: Maybe<Scalars["Decimal"]>;
  finalExtendedRetail?: Maybe<Scalars["Decimal"]>;
  finalRetail?: Maybe<Scalars["Decimal"]>;
  modifiedCost?: Maybe<Scalars["Decimal"]>;
  modifiedRetail?: Maybe<Scalars["Decimal"]>;
  originalCost?: Maybe<Scalars["Decimal"]>;
  originalRetail?: Maybe<Scalars["Decimal"]>;
  quantity?: Maybe<Scalars["Int"]>;
};

export type AssortmentLineItemFinancials = {
  __typename?: "AssortmentLineItemFinancials";
  /** The price modifiers applied to this line item */
  priceModifiers: PriceModifierConnection;
  /** This is the financials totaled for the entire line item quantity */
  total: AssortmentLineItemFinancialTotals;
  /** The financials at the unit level */
  unit: AssortmentLineItemUnitFinancials;
};

export type AssortmentLineItemUnitFinancials = {
  __typename?: "AssortmentLineItemUnitFinancials";
  finalAdjustedRetail?: Maybe<Scalars["Decimal"]>;
  finalCost?: Maybe<Scalars["Decimal"]>;
  finalExtendedCost?: Maybe<Scalars["Decimal"]>;
  finalExtendedInternalMarkup?: Maybe<Scalars["Decimal"]>;
  finalExtendedRetail?: Maybe<Scalars["Decimal"]>;
  finalRetail?: Maybe<Scalars["Decimal"]>;
  modifiedCost?: Maybe<Scalars["Decimal"]>;
  modifiedRetail?: Maybe<Scalars["Decimal"]>;
  originalCost?: Maybe<Scalars["Decimal"]>;
  originalRetail?: Maybe<Scalars["Decimal"]>;
};

export enum AssortmentOrder {
  Ascending = "ASCENDING",
  Descending = "DESCENDING",
}

export enum AssortmentOrderByField {
  Date = "DATE",
}

export type AssortmentProductColorRequest = {
  code?: InputMaybe<Scalars["String"]>;
  comment?: InputMaybe<Scalars["String"]>;
  name: Scalars["String"];
};

export type AssortmentProductProductRequest = {
  categories?: InputMaybe<Scalars["String"]>;
  code?: InputMaybe<Scalars["String"]>;
  comment?: InputMaybe<Scalars["String"]>;
  countryOfOrigin?: InputMaybe<Scalars["String"]>;
  description?: InputMaybe<Scalars["String"]>;
  fabrication?: InputMaybe<Scalars["String"]>;
  heelHeight?: InputMaybe<Scalars["String"]>;
  materials?: InputMaybe<Scalars["String"]>;
  measurements?: InputMaybe<Scalars["String"]>;
  modelHeight?: InputMaybe<Scalars["Int"]>;
  name: Scalars["String"];
  retailPrice?: InputMaybe<Scalars["Decimal"]>;
  silhouette?: InputMaybe<Scalars["String"]>;
  sourceOfMaterials?: InputMaybe<Scalars["String"]>;
  wholesaleCurrencyCode?: InputMaybe<Scalars["String"]>;
  wholesalePrice?: InputMaybe<Scalars["Decimal"]>;
};

export type AssortmentProductRequest = {
  colors: Array<AssortmentProductColorRequest>;
  product: AssortmentProductProductRequest;
  sizes: Array<AssortmentProductSizeRequest>;
};

export type AssortmentProductSizeRequest = {
  code?: InputMaybe<Scalars["String"]>;
  name: Scalars["String"];
};

/** Filter assortments on retailer fields */
export type AssortmentRetailerFilter = {
  /** Filter on retailer ids */
  ids?: InputMaybe<Array<Scalars["ID"]>>;
  /** Filter on retailer name */
  name?: InputMaybe<AssortmentFilterValue>;
};

export type AssortmentSkuColor = {
  __typename?: "AssortmentSKUColor";
  attributeOptions: AttributeOptionConnection;
  /** The bulk quantity for this color, aka color bulk */
  bulkQuantity: Scalars["Int"];
  code: Scalars["String"];
  comment?: Maybe<Scalars["String"]>;
  doorQuantities: Array<AssortmentSkuColorDoorQuantity>;
  id: Scalars["ID"];
  images: ImageConnection;
  missingRequiredAttributes: AttributeConnection;
  name: Scalars["String"];
  /** Financial price level rollup for this color */
  priceLevels: ProductColorPriceLevels;
  /** Size curves that can be applied to this product color */
  sizeCurves: RetailSizeCurves;
  /** All the assortment skus that share this color */
  skus: Array<AssortmentSkuEdge>;
  swatch: ColorSwatch;
  /**
   * The sum of all sized quantities for this color, aka color total
   * If a product has sizes small, medium and large and two doors, and each size
   * has 10 units for each size in each door, the total_sized_quantity will be:
   * Door1: 10 (small) + 10 (medium) + 10 (large) = 30
   * Door2: 10 (small) + 10 (medium) + 10 (large) = 30
   * totalSizedQuantity = 60
   */
  totalSizedQuantity: Scalars["Int"];
};

export type AssortmentSkuColorDoorQuantity = Node & {
  __typename?: "AssortmentSKUColorDoorQuantity";
  /** The bulk quantity for this door, aka door color bulk */
  bulkQuantity: Scalars["Int"];
  door?: Maybe<Door>;
  id: Scalars["ID"];
  /**
   * The sum of all sized quantities for this door, aka door color total
   * If a product has sizes small, medium and large and each size has 10
   * units for *this door*, the totalSizedQuantity will be:
   * 10 (small) + 10 (medium) + 10 (large) = 30
   */
  totalSizedQuantity: Scalars["Int"];
};

export type AssortmentSkuConnection = {
  __typename?: "AssortmentSKUConnection";
  edges?: Maybe<Array<AssortmentSkuEdge>>;
};

export type AssortmentSkuDoorQuantity = Node & {
  __typename?: "AssortmentSKUDoorQuantity";
  /** The size curve ratio applied to the sku */
  appliedSizeRatio?: Maybe<Scalars["Decimal"]>;
  door?: Maybe<Door>;
  id: Scalars["ID"];
  /** The sized quantity for this door */
  quantity: Scalars["Int"];
};

export type AssortmentSkuEdge = {
  __typename?: "AssortmentSKUEdge";
  _id: Scalars["ID"];
  /**
   * Sku-level finanical details in the assortment currency.
   *
   * Note that this field does not support multi-currency assortments.
   * @deprecated Use financials field with filter isBrandCurrency:false
   */
  actualCurrencyFinancials?: Maybe<AssortmentSkuFinancials>;
  attributeOptions: AttributeOptionConnection;
  availableRetailSizeOptions: Array<RetailSize>;
  availableSizeRuns: Array<SizeRun>;
  /** The size bulk quantity for this sku, aka size bulk */
  bulkQuantity: Scalars["Int"];
  /** @deprecated use colorV2 instead */
  color: Color;
  colorV2: AssortmentSkuColor;
  comment?: Maybe<Scalars["String"]>;
  /** Sized quantities for each door */
  doorQuantities: Array<AssortmentSkuDoorQuantity>;
  financials: Array<AssortmentSkuFinancials>;
  isCustom?: Maybe<Scalars["Boolean"]>;
  legacyItemId: Scalars["ID"];
  /**
   * Sku-level financial details in the linesheet currency.
   *
   * Note that this field does not support multi-currency assortments.
   * @deprecated Use financials field with filter isBrandCurrency:true
   */
  linesheetCurrencyFinancials?: Maybe<AssortmentSkuFinancials>;
  mainImage?: Maybe<Image>;
  node: Sku;
  priceLevels: Array<PriceLevel>;
  /** Retail currency code of this sku (actually a product-level value) */
  retailCurrencyCode?: Maybe<Scalars["String"]>;
  retailSize?: Maybe<RetailSize>;
  size: Size;
  sizeRun?: Maybe<SizeRunEdge>;
  style: Style;
  /** Assortment SKU-level UPC if available, otherwise use the brand product UPC */
  upc?: Maybe<Scalars["String"]>;
  /** Wholesale currency code of this sku (actually a product-level value) */
  wholesaleCurrencyCode?: Maybe<Scalars["String"]>;
};

export type AssortmentSkuEdgePriceLevelsArgs = {
  filters?: InputMaybe<PriceLevelsFilter>;
};

export type AssortmentSkuFinancials = {
  __typename?: "AssortmentSKUFinancials";
  currencyCode: Scalars["String"];
  finalCost?: Maybe<Scalars["Decimal"]>;
  /**
   * Calculated initial markup:
   * (finalRetail - finalCost) / finalRetail
   */
  finalIMU?: Maybe<Scalars["Decimal"]>;
  finalRetail?: Maybe<Scalars["Decimal"]>;
  isBrandCurrency?: Maybe<Scalars["Boolean"]>;
  modifiedCost?: Maybe<Scalars["Decimal"]>;
  /**
   * Calculated initial markup:
   * (modifiedRetail - modifiedCost) / modifiedRetail
   */
  modifiedIMU?: Maybe<Scalars["Decimal"]>;
  modifiedRetail?: Maybe<Scalars["Decimal"]>;
  originalCost?: Maybe<Scalars["Decimal"]>;
  /**
   * Calculated initial markup:
   * (originalRetail - originalCost) / originalRetail
   */
  originalIMU?: Maybe<Scalars["Decimal"]>;
  originalRetail?: Maybe<Scalars["Decimal"]>;
};

/** Filter assortments on season fields */
export type AssortmentSeasonFilter = {
  ids?: InputMaybe<Array<Scalars["ID"]>>;
  /** If true then return assortments without a season (i.e. brand notes) */
  isNull?: InputMaybe<Scalars["Boolean"]>;
  /** Filter on season name */
  name?: InputMaybe<AssortmentFilterValue>;
  /** Filter on season year */
  year?: InputMaybe<AssortmentFilterValue>;
};

export type AssortmentShare = {
  __typename?: "AssortmentShare";
  createdDate: Scalars["Date"];
  id: Scalars["ID"];
  user: User;
  visited?: Maybe<Scalars["Date"]>;
};

export type AssortmentShareInput = {
  userId: Scalars["ID"];
};

export type AssortmentSkuDoorLineItemBulkQuantity = {
  assortmentId: Scalars["ID"];
  destinationId: Scalars["ID"];
  destinationType: AssortmentSkuDoorLineItemBulkQuantityDestinationType;
  quantity: Scalars["Int"];
  skuId: Scalars["ID"];
};

export enum AssortmentSkuDoorLineItemBulkQuantityDestinationType {
  Door = "DOOR",
  DoorCluster = "DOOR_CLUSTER",
}

export type AssortmentSkuDoorLineItemBulkQuantityDoorOrCluster =
  | Door
  | DoorCluster;

export type AssortmentSkuDoorLineItemQuantityInput = {
  assortmentId: Scalars["ID"];
  /** An ID for a door or cluster is required as this mutation is for an assigned line item */
  doorOrClusterId: Scalars["ID"];
  /** This will be the quantity to set for each assigned line item at a door level */
  quantity: Scalars["Int"];
  skuId: Scalars["ID"];
};

export type AssortmentSkuDoorLineItemQuantityPayload = {
  __typename?: "AssortmentSkuDoorLineItemQuantityPayload";
  /** Allow mutations to query the Assortment. */
  assortment: Assortment;
  /**
   * This is the assortment ID of the assortment being edited
   * @deprecated query the assortment object instead
   */
  assortmentId: Scalars["ID"];
  /**
   * Allow mutations to query the AssortmentSKUs modified.
   * @deprecated use generic query response instead
   */
  assortmentSkus: AssortmentSkuConnection;
  /**
   * This is the list of assigned line items that were set with the request's quantity
   * @deprecated query the assortment object instead
   */
  lineItems: AssortmentLineItemConnection;
  /** Generic top level query field to query updated skus */
  query?: Maybe<Query>;
};

export type AssortmentSkuDoorLineItemQuantityPayloadAssortmentSkusArgs = {
  ids: Array<Scalars["ID"]>;
};

export type AssortmentSkuUnassignedLineItemQuantityInput = {
  assortmentId: Scalars["ID"];
  /** This will be the quantity to set for each unassigned line item */
  quantity: Scalars["Int"];
  skuId: Scalars["ID"];
};

export type AssortmentSkuUnassignedLineItemQuantityPayload = {
  __typename?: "AssortmentSkuUnassignedLineItemQuantityPayload";
  /** This is the assortment ID of the assortment being edited */
  assortmentId: Scalars["ID"];
  /** This is the list of unassigned line items that were set with the request's quantity */
  unassignedLineItems: AssortmentLineItemConnection;
};

export enum AssortmentStatus {
  Archived = "ARCHIVED",
  Done = "DONE",
  InReview = "IN_REVIEW",
  InWork = "IN_WORK",
  Unknown = "UNKNOWN",
}

export type AssortmentSummary = BaseAssortment &
  Node & {
    __typename?: "AssortmentSummary";
    /** Object version for this assortment */
    _version: Scalars["String"];
    /** The retailer brand linked to this assortment */
    brand?: Maybe<RetailerBrandEdge>;
    /** Brand Name associated with Assortment itself (not trough brand_id field) */
    brandName?: Maybe<Scalars["String"]>;
    brandV2?: Maybe<RetailerBrand>;
    /** Linesheet */
    collection?: Maybe<Collection>;
    /** Visible Linesheet Code for this Assortment */
    collectionCode?: Maybe<Scalars["String"]>;
    /** Visible Linesheet Name for this Assortment */
    collectionName?: Maybe<Scalars["String"]>;
    /** The user who created this assortment */
    createdByUser: RetailerUserEdge;
    /** The date the assortment was created */
    createdDate: Scalars["Date"];
    /** Delivery window details */
    deliveryWindow: AssortmentDeliveryWindow;
    /** The users able to edit this assortment */
    editableByUsers: RetailerUserConnection;
    /** The message associated with the most recent export attempt */
    exportMessage?: Maybe<Scalars["String"]>;
    /** Financial Overview associated with this assortment */
    financialOverview: AssortmentFinancialOverview;
    id: Scalars["ID"];
    /** The success status of the most recent export attempt */
    latestExport?: Maybe<AssortmentExportStatus>;
    /** The date the assortment was last modified */
    modifiedDate: Scalars["Date"];
    /** The name of the assortment */
    name: Scalars["String"];
    /** The assortment's sync status with a brand order */
    orderAssortmentSyncStatus?: Maybe<OrderAssortmentSyncStatus>;
    /** The PO number for this assortment */
    poNumber: Scalars["String"];
    /** The retailer that owns this assortment */
    retailer: RetailerEdge;
    /** The season associated with this assortment */
    season?: Maybe<SeasonEdge>;
    /** List of assortment sharing details */
    shares: Array<AssortmentShare>;
    /** The current status of the assortment status */
    status: AssortmentStatus;
    /** Total count of the unread notifications on this assortment for the querying user */
    unreadNotificationsCount: Scalars["Int"];
  };

export type AssortmentSummarySharesArgs = {
  onlyToMe?: InputMaybe<Scalars["Boolean"]>;
};

export type AssortmentSummaryConnection = {
  __typename?: "AssortmentSummaryConnection";
  edges?: Maybe<Array<AssortmentSummaryEdge>>;
};

export type AssortmentSummaryEdge = {
  __typename?: "AssortmentSummaryEdge";
  node?: Maybe<AssortmentSummary>;
};

export type AssortmentUi_RowColorBulkQuantities = {
  __typename?: "AssortmentUI_RowColorBulkQuantities";
  assortment: Assortment;
  colors: Array<AssortmentUi__ColorUnitQuantity>;
  /** Generic top level query field to query updated skus */
  query?: Maybe<Query>;
  skus: Array<AssortmentUi__SkuUnitQuantity>;
};

export type AssortmentUi_RowSizeBulkQuantities = {
  __typename?: "AssortmentUI_RowSizeBulkQuantities";
  assortment: Assortment;
  /** Generic top level query field to query updated skus */
  query?: Maybe<Query>;
  sizes: Array<AssortmentUi__SizeUnitQuantity>;
  skus: Array<AssortmentUi__SkuUnitQuantity>;
};

export type AssortmentUi__AddColorsToAssortmentProductRequest = {
  colors: Array<AssortmentUi__AssortmentProductColorRequest>;
  productId: Scalars["ID"];
};

export type AssortmentUi__Assortment = {
  __typename?: "AssortmentUI__Assortment";
  doors: Array<AssortmentUi__AssortmentDoor>;
  id: Scalars["ID"];
  /**
   * Generic top level query field to query for assortment
   * from this namespace
   */
  query?: Maybe<Query>;
  skus: Array<AssortmentUi__AssortmentSku>;
};

export type AssortmentUi__AssortmentDoor = {
  __typename?: "AssortmentUI__AssortmentDoor";
  code: Scalars["String"];
  groupName?: Maybe<Scalars["String"]>;
  id: Scalars["ID"];
  name: Scalars["String"];
};

export type AssortmentUi__AssortmentProductColorRequest = {
  code?: InputMaybe<Scalars["String"]>;
  comment?: InputMaybe<Scalars["String"]>;
  name: Scalars["String"];
};

export type AssortmentUi__AssortmentProductProductRequest = {
  categories?: InputMaybe<Scalars["String"]>;
  code?: InputMaybe<Scalars["String"]>;
  comment?: InputMaybe<Scalars["String"]>;
  countryOfOrigin?: InputMaybe<Scalars["String"]>;
  description?: InputMaybe<Scalars["String"]>;
  fabrication?: InputMaybe<Scalars["String"]>;
  heelHeight?: InputMaybe<Scalars["String"]>;
  materials?: InputMaybe<Scalars["String"]>;
  measurements?: InputMaybe<Scalars["String"]>;
  modelHeight?: InputMaybe<Scalars["Int"]>;
  name: Scalars["String"];
  retailPrice?: InputMaybe<Scalars["Decimal"]>;
  silhouette?: InputMaybe<Scalars["String"]>;
  sourceOfMaterials?: InputMaybe<Scalars["String"]>;
  wholesaleCurrencyCode?: InputMaybe<Scalars["String"]>;
  wholesalePrice?: InputMaybe<Scalars["Decimal"]>;
};

export type AssortmentUi__AssortmentProductRequest = {
  colors: Array<AssortmentUi__AssortmentProductColorRequest>;
  product: AssortmentUi__AssortmentProductProductRequest;
  sizes: Array<AssortmentUi__AssortmentProductSizeRequest>;
};

export type AssortmentUi__AssortmentProductSizeRequest = {
  code?: InputMaybe<Scalars["String"]>;
  name: Scalars["String"];
};

export type AssortmentUi__AssortmentSku = AssortmentUi__WithUnitQuantities & {
  __typename?: "AssortmentUI__AssortmentSku";
  assortmentPrices: AssortmentUi__AssortmentSkuPrices;
  brandCatalogSku?: Maybe<Sku>;
  color: AssortmentUi__AssortmentSkuColor;
  comment?: Maybe<Scalars["String"]>;
  doorQuantities: Array<AssortmentUi__AssortmentSkuDoorQuantities>;
  id: Scalars["ID"];
  initialMarkup: Scalars["Decimal"];
  isCustom?: Maybe<Scalars["Boolean"]>;
  linesheetPrices: AssortmentUi__AssortmentSkuPrices;
  product: AssortmentUi__AssortmentSkuProduct;
  size: AssortmentUi__AssortmentSkuSize;
  /** Units target is a target quantity for this sku */
  unitsTarget: Scalars["Int"];
  /** Units total is a quantity explicitly allocated for this sku */
  unitsTotal: Scalars["Int"];
  /** Units variance is the difference between the actual and bulk. If left null it is intended for this to be dynamically calculated */
  unitsVariance?: Maybe<Scalars["Int"]>;
  upc?: Maybe<Scalars["String"]>;
};

export type AssortmentUi__AssortmentSkuColor =
  AssortmentUi__WithUnitQuantities & {
    __typename?: "AssortmentUI__AssortmentSkuColor";
    code: Scalars["String"];
    comment?: Maybe<Scalars["String"]>;
    id: Scalars["ID"];
    images?: Maybe<Array<Image>>;
    name: Scalars["String"];
    swatch?: Maybe<AssortmentUi__Swatch>;
    /** Units target is a target quantity for this sku */
    unitsTarget: Scalars["Int"];
    /** Units total is a quantity explicitly allocated for this sku */
    unitsTotal: Scalars["Int"];
    /** Units variance is the difference between the actual and bulk. If left null it is intended for this to be dynamically calculated */
    unitsVariance?: Maybe<Scalars["Int"]>;
  };

export type AssortmentUi__AssortmentSkuDoorQuantities =
  AssortmentUi__WithUnitQuantities & {
    __typename?: "AssortmentUI__AssortmentSkuDoorQuantities";
    door: AssortmentUi__AssortmentDoor;
    id: Scalars["ID"];
    /** Units target is a target quantity for this sku */
    unitsTarget: Scalars["Int"];
    /** Units total is a quantity explicitly allocated for this sku */
    unitsTotal: Scalars["Int"];
    /** Units variance is the difference between the actual and bulk. If left null it is intended for this to be dynamically calculated */
    unitsVariance?: Maybe<Scalars["Int"]>;
  };

export type AssortmentUi__AssortmentSkuPrices = {
  __typename?: "AssortmentUI__AssortmentSkuPrices";
  costCurrencyCode: Scalars["String"];
  costFinal: Scalars["Decimal"];
  costFinalExtended: Scalars["Decimal"];
  costModified: Scalars["Decimal"];
  costOriginal: Scalars["Decimal"];
  retailCurrencyCode: Scalars["String"];
  retailFinal: Scalars["Decimal"];
  retailFinalExtended: Scalars["Decimal"];
  retailModified: Scalars["Decimal"];
  retailOriginal: Scalars["Decimal"];
};

export type AssortmentUi__AssortmentSkuProduct = {
  __typename?: "AssortmentUI__AssortmentSkuProduct";
  categories?: Maybe<Array<Scalars["String"]>>;
  code: Scalars["String"];
  comment?: Maybe<Scalars["String"]>;
  containsFur: Scalars["Boolean"];
  countryOfOrigin?: Maybe<Scalars["String"]>;
  description?: Maybe<Scalars["String"]>;
  fabrication?: Maybe<Scalars["String"]>;
  heelHeight?: Maybe<Scalars["String"]>;
  id: Scalars["ID"];
  images?: Maybe<Array<Image>>;
  materials?: Maybe<Array<Scalars["String"]>>;
  measurements?: Maybe<Scalars["String"]>;
  modelHeight?: Maybe<Scalars["String"]>;
  name: Scalars["String"];
  silhouette?: Maybe<Scalars["String"]>;
  sourceOfMaterials?: Maybe<Scalars["String"]>;
};

export type AssortmentUi__AssortmentSkuSize = {
  __typename?: "AssortmentUI__AssortmentSkuSize";
  code: Scalars["String"];
  id: Scalars["ID"];
  name: Scalars["String"];
};

export type AssortmentUi__BulkAddColorsToAssortmentProductRequest = {
  assortmentId: Scalars["ID"];
  requests: Array<AssortmentUi__AddColorsToAssortmentProductRequest>;
};

export type AssortmentUi__BulkAddColorsToAssortmentProductResponse = {
  __typename?: "AssortmentUI__BulkAddColorsToAssortmentProductResponse";
  assortment?: Maybe<Assortment>;
};

export type AssortmentUi__BulkColorUnitUpdate = {
  quantity: Scalars["Int"];
  skuId: Scalars["ID"];
};

export type AssortmentUi__BulkCreateAssortmentProductRequest = {
  assortmentId: Scalars["ID"];
  products: Array<AssortmentUi__AssortmentProductRequest>;
};

export type AssortmentUi__BulkSizeUnitUpdate = {
  quantity: Scalars["Int"];
  skuId: Scalars["ID"];
};

export type AssortmentUi__ColorUnitQuantity = {
  __typename?: "AssortmentUI__ColorUnitQuantity";
  colorId: Scalars["ID"];
  quantity: Scalars["Int"];
};

export type AssortmentUi__CreateRetailerExclusiveSkuRequest = {
  assortmentId: Scalars["ID"];
  color: AssortmentUi__RetailerExclusiveSkuColorRequest;
  product: AssortmentUi__RetailerExclusiveSkuProductRequest;
  size: AssortmentUi__RetailerExclusiveSkuSizeRequest;
};

export type AssortmentUi__CreateRetailerExclusiveSkuResponse = {
  __typename?: "AssortmentUI__CreateRetailerExclusiveSkuResponse";
  success?: Maybe<Scalars["Boolean"]>;
};

export type AssortmentUi__RetailerExclusiveSkuColorRequest = {
  code: Scalars["String"];
  comment: Scalars["String"];
  name: Scalars["String"];
};

export type AssortmentUi__RetailerExclusiveSkuProductRequest = {
  categories?: InputMaybe<Scalars["String"]>;
  code: Scalars["String"];
  comment?: InputMaybe<Scalars["String"]>;
  countryOfOrigin?: InputMaybe<Scalars["String"]>;
  description?: InputMaybe<Scalars["String"]>;
  fabrication?: InputMaybe<Scalars["String"]>;
  heelHeight?: InputMaybe<Scalars["String"]>;
  materials?: InputMaybe<Scalars["String"]>;
  measurements?: InputMaybe<Scalars["String"]>;
  modelHeight?: InputMaybe<Scalars["Int"]>;
  name: Scalars["String"];
  retailPrice?: InputMaybe<Scalars["Decimal"]>;
  silhouette?: InputMaybe<Scalars["String"]>;
  sourceOfMaterials?: InputMaybe<Scalars["String"]>;
  wholesalePrice?: InputMaybe<Scalars["Decimal"]>;
};

export type AssortmentUi__RetailerExclusiveSkuSizeRequest = {
  code: Scalars["String"];
  name: Scalars["String"];
};

export type AssortmentUi__RowUnits = {
  __typename?: "AssortmentUI__RowUnits";
  bulk?: Maybe<Scalars["Int"]>;
};

export type AssortmentUi__SizeUnitQuantity = {
  __typename?: "AssortmentUI__SizeUnitQuantity";
  quantity: Scalars["Int"];
  sizeId: Scalars["ID"];
};

export type AssortmentUi__SkuRow = {
  __typename?: "AssortmentUI__SkuRow";
  sku: Sku;
  units?: Maybe<AssortmentUi__SkuRowUnits>;
};

export type AssortmentUi__SkuRowUnits = {
  __typename?: "AssortmentUI__SkuRowUnits";
  color?: Maybe<AssortmentUi__RowUnits>;
  size?: Maybe<AssortmentUi__RowUnits>;
};

export type AssortmentUi__SkuUnitQuantity = {
  __typename?: "AssortmentUI__SkuUnitQuantity";
  quantity: Scalars["Int"];
  sku: Sku;
};

export type AssortmentUi__Swatch = Hex | Image | Rgb;

export type AssortmentUi__UpdateRetailerExclusiveSkuRequest = {
  assortmentId: Scalars["ID"];
  color: AssortmentUi__RetailerExclusiveSkuColorRequest;
  product: AssortmentUi__RetailerExclusiveSkuProductRequest;
  size: AssortmentUi__RetailerExclusiveSkuSizeRequest;
  skuId: Scalars["ID"];
};

export type AssortmentUi__UpdateRetailerExclusiveSkuResponse = {
  __typename?: "AssortmentUI__UpdateRetailerExclusiveSkuResponse";
  success?: Maybe<Scalars["Boolean"]>;
};

export type AssortmentUi__WithUnitQuantities = {
  /** Units target is a target quantity for this sku */
  unitsTarget: Scalars["Int"];
  /** Units total is a quantity explicitly allocated for this sku */
  unitsTotal: Scalars["Int"];
  /** Units variance is the difference between the actual and bulk. If left null it is intended for this to be dynamically calculated */
  unitsVariance?: Maybe<Scalars["Int"]>;
};

export type AssortmentUi__BulkCreateAssortmentProductResponse = {
  __typename?: "AssortmentUI__bulkCreateAssortmentProductResponse";
  assortment?: Maybe<Assortment>;
};

export type AssortmentUnits = {
  __typename?: "AssortmentUnits";
  colorCount?: Maybe<Scalars["Int"]>;
  productCount?: Maybe<Scalars["Int"]>;
  skuCount?: Maybe<Scalars["Int"]>;
  unitCount?: Maybe<Scalars["Int"]>;
  unitDepth?: Maybe<Scalars["String"]>;
};

export type AssortmentUnitsOverview = {
  __typename?: "AssortmentUnitsOverview";
  colorCount?: Maybe<Scalars["Int"]>;
  productCount?: Maybe<Scalars["Int"]>;
  skuCount?: Maybe<Scalars["Int"]>;
};

/** Enum of all fields that are supported for validation */
export enum AssortmentValidationField {
  AssortmentName = "ASSORTMENT_NAME",
  Brand = "BRAND",
  ColorCode = "COLOR_CODE",
  ColorName = "COLOR_NAME",
  Comment = "COMMENT",
  CountryOfOrigin = "COUNTRY_OF_ORIGIN",
  Delivery = "DELIVERY",
  Description = "DESCRIPTION",
  DueDate = "DUE_DATE",
  Fabrication = "FABRICATION",
  HeelHeight = "HEEL_HEIGHT",
  Hierarchy = "HIERARCHY",
  Materials = "MATERIALS",
  Measurements = "MEASUREMENTS",
  Missing = "MISSING",
  ModelHeight = "MODEL_HEIGHT",
  OriginalCost = "ORIGINAL_COST",
  OriginalRetail = "ORIGINAL_RETAIL",
  PoNumber = "PO_NUMBER",
  Season = "SEASON",
  Silhouette = "SILHOUETTE",
  Sizes = "SIZES",
  SizeDoorQuantities = "SIZE_DOOR_QUANTITIES",
  SourceOfMaterials = "SOURCE_OF_MATERIALS",
  StyleCode = "STYLE_CODE",
  StyleName = "STYLE_NAME",
}

/** Filter assortments on workspace fields */
export type AssortmentWorkspaceFilter = {
  /** Filter on workspace id */
  ids?: InputMaybe<Array<Scalars["ID"]>>;
  /** Filter on workspace name */
  name?: InputMaybe<AssortmentFilterValue>;
};

export type AssortmentsOrderBy = {
  field?: InputMaybe<AssortmentOrderByField>;
  order?: InputMaybe<AssortmentOrder>;
};

export enum AssortmentsQueryOrder {
  Ascending = "ASCENDING",
  Descending = "DESCENDING",
}

export type AssortmentsQueryOrderBy = {
  /** The field used to order the results of an assortments query */
  field: AssortmentsQueryOrderField;
  /** The direction of the ordering (or DESCENDING if not specified) */
  order?: InputMaybe<AssortmentsQueryOrder>;
};

export enum AssortmentsQueryOrderField {
  /** Brand account profile name, as alphanumeric */
  BrandName = "BRAND_NAME",
  /** Delivery window, as datetime */
  CompleteShip = "COMPLETE_SHIP",
  /** Created by user's name, as alphanumeric */
  CreatedByUser = "CREATED_BY_USER",
  /** Created date, as datetime */
  CreatedDate = "CREATED_DATE",
  /** Modified date, as datetime */
  ModifiedDate = "MODIFIED_DATE",
  /** Assortment name, as alphanumeric */
  Name = "NAME",
  /** PO Number, as numeric */
  PoNumber = "PO_NUMBER",
  /** Season name, as alphanumeric */
  Season = "SEASON",
  /** Delivery window start shipment date, as datetime */
  StartShip = "START_SHIP",
  /** Assortment status, as enum */
  Status = "STATUS",
}

export type Attachment = {
  __typename?: "Attachment";
  fileName: Scalars["String"];
  url: Scalars["String"];
};

export type AttachmentInput = {
  fileName: Scalars["String"];
  url: Scalars["String"];
};

/**
 * A user defined field which can apply to a Assortment, Item Color, etc.
 * Attributes can have a parent-child relationship with other assortment attributes.
 */
export type Attribute = Node & {
  __typename?: "Attribute";
  availableOptions: AttributeOptionConnection;
  code: Scalars["String"];
  id: Scalars["ID"];
  isMultiSelect: Scalars["Boolean"];
  isRequired: Scalars["Boolean"];
  name: Scalars["String"];
  options: AttributeOptionConnection;
  parent?: Maybe<AttributeEdge>;
  position: Scalars["Int"];
  type: AttributeType;
};

/**
 * A user defined field which can apply to a Assortment, Item Color, etc.
 * Attributes can have a parent-child relationship with other assortment attributes.
 */
export type AttributeAvailableOptionsArgs = {
  assortmentId?: InputMaybe<Scalars["ID"]>;
};

/**
 * A user defined field which can apply to a Assortment, Item Color, etc.
 * Attributes can have a parent-child relationship with other assortment attributes.
 */
export type AttributeOptionsArgs = {
  filterBy?: InputMaybe<AttributeOptionFilterInput>;
};

export type AttributeConnection = {
  __typename?: "AttributeConnection";
  edges?: Maybe<Array<AttributeEdge>>;
};

export type AttributeEdge = {
  __typename?: "AttributeEdge";
  node?: Maybe<Attribute>;
};

/**
 * Attribute options are individual selections for an attribute.
 * Options can be filtered by:
 * 1. other assortment attribute options
 * 1. retailer brands
 * 1. merchandising hierarchy nodes
 */
export type AttributeOption = Node & {
  __typename?: "AttributeOption";
  /** The Attribute that this option belongs to */
  attribute: AttributeEdge;
  /** Attribute options that filter this option */
  attributeOptionFilters: AttributeOptionFilterConnection;
  /** A unique identifier */
  code: Scalars["String"];
  id: Scalars["ID"];
  /** Merchandising hierarchies that filter this option */
  merchandisingHierarchyFilters: MerchandisingHierarchyFilterConnection;
  /** Retailer brands that filter this option */
  retailerBrandFilters: RetailerBrandFilterConnection;
  /** The value of this option */
  value: Scalars["String"];
};

export type AttributeOptionConnection = {
  __typename?: "AttributeOptionConnection";
  edges?: Maybe<Array<AttributeOptionEdge>>;
};

export type AttributeOptionEdge = {
  __typename?: "AttributeOptionEdge";
  node?: Maybe<AttributeOption>;
};

export type AttributeOptionFilter = {
  __typename?: "AttributeOptionFilter";
  cursor?: Maybe<Scalars["String"]>;
  node?: Maybe<AttributeOption>;
};

export type AttributeOptionFilterConnection = {
  __typename?: "AttributeOptionFilterConnection";
  edges?: Maybe<Array<AttributeOptionFilter>>;
};

export type AttributeOptionFilterInput = {
  brandAccountIds: Array<Scalars["ID"]>;
  merchandisingHierarchyNodeIds: Array<Scalars["ID"]>;
  selectedOptionIds: Array<Scalars["ID"]>;
};

export enum AttributeType {
  /** This attribute applies to an assortment */
  Assortment = "ASSORTMENT",
  /** This attribute applies to an item-color */
  ItemColor = "ITEM_COLOR",
}

export type AttributeValidation = {
  __typename?: "AttributeValidation";
  attribute: Attribute;
  /** Whether the field(s) is "valid", i.e. for assortment-level fields, whether it has been set to a value, for product-level fields, whether all products have been assigned a value */
  valid: Scalars["Boolean"];
};

export type Availability = {
  __typename?: "Availability";
  availableOn?: Maybe<Scalars["Date"]>;
  isImmediate: Scalars["Boolean"];
};

export enum AvailableAssortmentIntegrations {
  Both = "BOTH",
  None = "NONE",
  NonSchedulable = "NON_SCHEDULABLE",
}

export type BackupProduct = {
  __typename?: "BackupProduct";
  backupVariants: BackupVariantConnection;
  casepacks: ProductCasepackConnection;
  orderId: Scalars["ID"];
  orderMinimum?: Maybe<Scalars["Int"]>;
  productId: Scalars["ID"];
  productImage: Scalars["String"];
  productName: Scalars["String"];
  productNumber: Scalars["String"];
  skus: SkuConnection;
};

export type BackupProductCasepacksArgs = {
  withDeleted?: InputMaybe<Scalars["Boolean"]>;
};

export type BackupProductSkusArgs = {
  withCasepacks?: InputMaybe<Scalars["Boolean"]>;
  withDeleted?: InputMaybe<Scalars["Boolean"]>;
  withDeletedTraits?: InputMaybe<Array<TraitCode>>;
  withInactive?: InputMaybe<Scalars["Boolean"]>;
};

export type BackupProductConnection = {
  __typename?: "BackupProductConnection";
  edges?: Maybe<Array<BackupProductEdge>>;
};

export type BackupProductEdge = {
  __typename?: "BackupProductEdge";
  node?: Maybe<BackupProduct>;
};

export type BackupVariantConnection = {
  __typename?: "BackupVariantConnection";
  edges?: Maybe<Array<BackupVariantEdge>>;
};

export type BackupVariantEdge = {
  __typename?: "BackupVariantEdge";
  node: VariantTrait;
  values: VariantValueConnection;
};

export type Badge = {
  __typename?: "Badge";
  brand?: Maybe<Brand>;
  id: Scalars["ID"];
  image?: Maybe<Media>;
  name: Scalars["String"];
  visible?: Maybe<Scalars["Boolean"]>;
};

export type BadgeConnection = {
  __typename?: "BadgeConnection";
  edges: Array<BadgeEdge>;
};

export type BadgeEdge = {
  __typename?: "BadgeEdge";
  node: Badge;
};

export type BadgeFilter = {
  collectionIds?: InputMaybe<Array<Scalars["ID"]>>;
};

export type BadgeOrderBy = {
  field?: InputMaybe<BadgeOrderByField>;
};

export enum BadgeOrderByField {
  Name = "NAME",
}

export type BankAccount = PaymentMethodI & {
  __typename?: "BankAccount";
  bankName: Scalars["String"];
  billingEmail: Scalars["String"];
  billingName: Scalars["String"];
  last4: Scalars["String"];
  paymentMethodId: Scalars["String"];
  status: BankAccountStatus;
  type: Scalars["String"];
};

export enum BankAccountStatus {
  Error = "ERROR",
  New = "NEW",
  Unknown = "UNKNOWN",
  Verified = "VERIFIED",
}

export enum BannerType {
  Image = "IMAGE",
  Text = "TEXT",
  Video = "VIDEO",
}

export type Banners = {
  __typename?: "Banners";
  imageBanners: Array<CollectionImageBanner>;
  textBanners: Array<CollectionTextBanner>;
  videoBanners: Array<CollectionVideoBanner>;
};

export type BaseAssortment = {
  /** The retailer brand linked to this assortment */
  brand?: Maybe<RetailerBrandEdge>;
  /** Brand Name associated with Assortment itself (not trough brand_id field) */
  brandName?: Maybe<Scalars["String"]>;
  brandV2?: Maybe<RetailerBrand>;
  /** Linesheet */
  collection?: Maybe<Collection>;
  /** Visible Linesheet Code for this Assortment */
  collectionCode?: Maybe<Scalars["String"]>;
  /** Visible Linesheet Name for this Assortment */
  collectionName?: Maybe<Scalars["String"]>;
  /** The user who created this assortment */
  createdByUser: RetailerUserEdge;
  /** The date the assortment was created */
  createdDate: Scalars["Date"];
  /** Delivery window details */
  deliveryWindow: AssortmentDeliveryWindow;
  /** The users able to edit this assortment */
  editableByUsers: RetailerUserConnection;
  /** The message associated with the most recent export attempt */
  exportMessage?: Maybe<Scalars["String"]>;
  id: Scalars["ID"];
  /** The success status of the most recent export attempt */
  latestExport?: Maybe<AssortmentExportStatus>;
  /** The date the assortment was last modified */
  modifiedDate: Scalars["Date"];
  /** The name of the assortment */
  name: Scalars["String"];
  /** The assortment's sync status with a brand order */
  orderAssortmentSyncStatus?: Maybe<OrderAssortmentSyncStatus>;
  /** The PO number for this assortment */
  poNumber: Scalars["String"];
  /** The retailer that owns this assortment */
  retailer: RetailerEdge;
  /** The season associated with this assortment */
  season?: Maybe<SeasonEdge>;
  /** List of assortment sharing details */
  shares: Array<AssortmentShare>;
  /** The current status of the assortment status */
  status: AssortmentStatus;
  /** Total count of the unread notifications on this assortment for the querying user */
  unreadNotificationsCount: Scalars["Int"];
};

export type BaseAssortmentSharesArgs = {
  onlyToMe?: InputMaybe<Scalars["Boolean"]>;
};

export type BillingAddress = {
  __typename?: "BillingAddress";
  address?: Maybe<HyperionAddress>;
  code?: Maybe<Scalars["String"]>;
  id: Scalars["ID"];
  phoneNumber?: Maybe<Scalars["String"]>;
};

export type BillingAddressInput = {
  brandId?: InputMaybe<Scalars["String"]>;
  buyerName: Scalars["String"];
  city: Scalars["String"];
  country?: InputMaybe<Scalars["String"]>;
  externalId: Scalars["String"];
  id?: InputMaybe<Scalars["String"]>;
  phone: Scalars["String"];
  postalCode?: InputMaybe<Scalars["String"]>;
  retailerId: Scalars["String"];
  state?: InputMaybe<Scalars["String"]>;
  storeName: Scalars["String"];
  streetAddress1: Scalars["String"];
  streetAddress2?: InputMaybe<Scalars["String"]>;
};

export type BillingAddressPayload = {
  __typename?: "BillingAddressPayload";
  city?: Maybe<Scalars["String"]>;
  code?: Maybe<Scalars["String"]>;
  company?: Maybe<Scalars["String"]>;
  country?: Maybe<Scalars["String"]>;
  id: Scalars["ID"];
  line1?: Maybe<Scalars["String"]>;
  line2?: Maybe<Scalars["String"]>;
  name?: Maybe<Scalars["String"]>;
  phone?: Maybe<Scalars["String"]>;
  state?: Maybe<Scalars["String"]>;
  zip?: Maybe<Scalars["String"]>;
};

export type BillingInfo = {
  address?: InputMaybe<AddressInput>;
  billingAddressId?: InputMaybe<Scalars["ID"]>;
  code?: InputMaybe<Scalars["String"]>;
  paymentMethodId?: InputMaybe<Scalars["ID"]>;
  phoneNumber?: InputMaybe<Scalars["String"]>;
  taxIdNumber?: InputMaybe<Scalars["String"]>;
};

export type BillingProfile = {
  billingAddress: BillingProfileAddress;
  birthdate?: InputMaybe<Scalars["String"]>;
  email: Scalars["String"];
  name: Scalars["String"];
  phone: Scalars["String"];
};

export type BillingProfileAddress = {
  city: Scalars["String"];
  country: Scalars["String"];
  region?: InputMaybe<Scalars["String"]>;
  street: Scalars["String"];
  zipCode?: InputMaybe<Scalars["String"]>;
};

/** A JOOR brand account */
export type Brand = {
  __typename?: "Brand";
  brandUsers?: Maybe<BrandUserConnection>;
  connectedAccounts: BrandRetailerConnection;
  divisions?: Maybe<Array<Division>>;
  id: Scalars["ID"];
  /** Account name on JOOR */
  name: Scalars["String"];
  orderEvents: Array<LibraryValue>;
  orderSettings?: Maybe<OrderSettings>;
  orderTypes: OrderTypeConnection;
  paymentMethods: PaymentMethodConnection;
  priceTypes: PriceTypeConnection;
  seasons: BrandSeasonConnection;
  shippingMethods: ShippingMethodConnection;
  tagGroups: TagGroupConnection;
  /** Brand users for this account */
  users: Array<User>;
  warehouses: WarehouseConnection;
};

/** A JOOR brand account */
export type BrandBrandUsersArgs = {
  filter?: InputMaybe<UsersFilter>;
};

/** A JOOR brand account */
export type BrandConnectedAccountsArgs = {
  filter?: InputMaybe<ConnectedAccountsFilter>;
  limit?: InputMaybe<Scalars["Int"]>;
  offset?: InputMaybe<Scalars["Int"]>;
};

/** A JOOR brand account */
export type BrandOrderEventsArgs = {
  orderBy?: InputMaybe<LibraryValuesOrderBy>;
};

/** A JOOR brand account */
export type BrandUsersArgs = {
  filter?: InputMaybe<UsersFilter>;
};

export type BrandAssortmentDetailsProfile = {
  __typename?: "BrandAssortmentDetailsProfile";
  brandId: Scalars["ID"];
  brandImage?: Maybe<Media>;
  brandName: Scalars["String"];
  id: Scalars["ID"];
  linesheetName: Scalars["String"];
  /** @deprecated Use orderTimestamp instead */
  orderTime: Scalars["Date"];
  orderTimestamp: Scalars["Date"];
  poNumber: Scalars["String"];
};

export type BrandBudget = Node & {
  __typename?: "BrandBudget";
  collection?: Maybe<Collection>;
  division?: Maybe<Division>;
  door?: Maybe<BrandDoor>;
  id: Scalars["ID"];
  priceType: PriceType;
  retailerId: Scalars["ID"];
  totalUnits: Scalars["Decimal"];
  totalUnitsPriorYear: Scalars["Decimal"];
  totalWholesale: Scalars["Decimal"];
  totalWholesalePriorYear: Scalars["Decimal"];
};

export type BrandBudgetConnection = {
  __typename?: "BrandBudgetConnection";
  edges?: Maybe<Array<BrandBudgetEdge>>;
};

export type BrandBudgetEdge = {
  __typename?: "BrandBudgetEdge";
  node: BrandBudget;
};

export type BrandBudgetFilter = {
  priceTypeIds?: InputMaybe<Array<Scalars["ID"]>>;
  retailerIds?: InputMaybe<Array<Scalars["ID"]>>;
};

export type BrandBuyer = {
  __typename?: "BrandBuyer";
  email?: Maybe<Scalars["String"]>;
  id: Scalars["ID"];
  name?: Maybe<Scalars["String"]>;
};

export type BrandConnection = {
  __typename?: "BrandConnection";
  edges: Array<BrandEdge>;
};

export type BrandDoor = Node & {
  __typename?: "BrandDoor";
  code?: Maybe<Scalars["String"]>;
  id: Scalars["ID"];
  name: Scalars["String"];
};

export type BrandDoorConnection = {
  __typename?: "BrandDoorConnection";
  edges: Array<BrandDoorEdge>;
};

export type BrandDoorEdge = {
  __typename?: "BrandDoorEdge";
  node: BrandDoor;
};

export type BrandEdge = {
  __typename?: "BrandEdge";
  node?: Maybe<Brand>;
};

export type BrandMedia = {
  __typename?: "BrandMedia";
  filename?: Maybe<Scalars["String"]>;
  id?: Maybe<Scalars["ID"]>;
  mediaType?: Maybe<MediaType>;
  url?: Maybe<Scalars["String"]>;
};

export type BrandMediaFilters = {
  mediaType?: InputMaybe<MediaType>;
  searchFilename?: InputMaybe<Scalars["String"]>;
};

export type BrandMediaPayload = {
  __typename?: "BrandMediaPayload";
  media: Array<BrandMedia>;
  totalCount?: Maybe<Scalars["Int"]>;
};

export type BrandOrder = {
  __typename?: "BrandOrder";
  brandId: Scalars["ID"];
  brandImage?: Maybe<Media>;
  brandName: Scalars["String"];
  id: Scalars["ID"];
  linesheetName: Scalars["String"];
  orderTime: Scalars["Date"];
  poNumber: Scalars["String"];
};

export type BrandOrderCombination = {
  __typename?: "BrandOrderCombination";
  collection: Collection;
  division?: Maybe<Division>;
  door?: Maybe<BrandDoor>;
  priceTypeId: Scalars["ID"];
  retailerId: Scalars["ID"];
  totalUnits: Scalars["Float"];
  totalWholesale: Scalars["Float"];
  traitValues: ProductTraitValueConnection;
  variant?: Maybe<SkuTraitValue>;
};

export type BrandPaymentMethodPayload = {
  __typename?: "BrandPaymentMethodPayload";
  code?: Maybe<Scalars["String"]>;
  id: Scalars["ID"];
  name?: Maybe<Scalars["String"]>;
};

export type BrandPriceType = {
  __typename?: "BrandPriceType";
  currency: ConnectionCurrency;
  id: Scalars["ID"];
  name: Scalars["String"];
  retailCurrency: ConnectionCurrency;
};

export type BrandProductLine = Node & {
  __typename?: "BrandProductLine";
  active: Scalars["Boolean"];
  id: Scalars["ID"];
  name: Scalars["String"];
};

export type BrandProfile = {
  /** Account media url */
  accountMedia?: Maybe<BrandMedia>;
  brandId: Scalars["ID"];
  /** Cover media url */
  coverMedia?: Maybe<BrandMedia>;
  /** Custom JOOR URL Handle */
  customUrlHandle?: Maybe<Scalars["String"]>;
  /** Description */
  description?: Maybe<Scalars["String"]>;
  /** @deprecated Use brandId instead */
  id: Scalars["ID"];
  /** If the brand is a lite brand */
  isLiteBrand?: Maybe<Scalars["Boolean"]>;
  /** Logo image id */
  logoId?: Maybe<Scalars["ID"]>;
  /** Logo image url */
  logoUrl?: Maybe<Scalars["String"]>;
  /** Account name on JOOR */
  name?: Maybe<Scalars["String"]>;
  /** Product lines/categories */
  productLines: Array<Scalars["String"]>;
  /** Profile images associated with account. Usually found in about me section. */
  profileImageUrls: Array<Scalars["String"]>;
  /** Retail max */
  retailMax?: Maybe<Scalars["Int"]>;
  /** Retail min */
  retailMin?: Maybe<Scalars["Int"]>;
  /** Social media accounts */
  socialMediaAccounts: Array<SocialMediaAccount>;
  /** Website URL */
  websiteUrl?: Maybe<Scalars["String"]>;
  /** Wholesale max */
  wholesaleMax?: Maybe<Scalars["Int"]>;
  /** Wholesale min */
  wholesaleMin?: Maybe<Scalars["Int"]>;
  /** Year established */
  yearEstablished?: Maybe<Scalars["Int"]>;
};

export type BrandRetailerConnection = {
  __typename?: "BrandRetailerConnection";
  edges: Array<BrandRetailerEdge>;
};

export type BrandRetailerEdge = {
  __typename?: "BrandRetailerEdge";
  alias?: Maybe<Scalars["String"]>;
  billingAddresses: Array<BillingAddress>;
  buyers: Array<BrandBuyer>;
  code?: Maybe<Scalars["String"]>;
  node?: Maybe<Retailer>;
  paymentMethods: Array<BrandRetailerPaymentMethod>;
  shippingAddresses: Array<ShippingAddress>;
  shippingMethods: Array<BrandRetailerShippingMethod>;
};

export type BrandRetailerIdentifiers = {
  brandId?: InputMaybe<Scalars["ID"]>;
  retailerId: Scalars["ID"];
};

export type BrandRetailerPaymentMethod = {
  __typename?: "BrandRetailerPaymentMethod";
  default?: Maybe<Scalars["Boolean"]>;
  paymentMethod: PaymentMethod;
};

export type BrandRetailerShippingMethod = {
  __typename?: "BrandRetailerShippingMethod";
  default?: Maybe<Scalars["Boolean"]>;
  shippingMethod?: Maybe<ShippingMethod>;
};

/** A specific selling period used to group assortments */
export type BrandSeason = Node & {
  __typename?: "BrandSeason";
  id: Scalars["ID"];
  /** A display name */
  name: Scalars["String"];
};

export type BrandSeasonConnection = {
  __typename?: "BrandSeasonConnection";
  edges: Array<BrandSeasonEdge>;
};

export type BrandSeasonEdge = {
  __typename?: "BrandSeasonEdge";
  node: BrandSeason;
};

export type BrandShippingMethodPayload = {
  __typename?: "BrandShippingMethodPayload";
  code?: Maybe<Scalars["String"]>;
  id: Scalars["ID"];
  name?: Maybe<Scalars["String"]>;
};

export enum BrandStatus {
  Active = "ACTIVE",
  Invisible = "INVISIBLE",
  OutOfNetwork = "OUT_OF_NETWORK",
  PreActive = "PRE_ACTIVE",
}

export enum BrandSubType {
  All = "ALL",
  Lite = "LITE",
  Pro = "PRO",
  Unknown = "UNKNOWN",
}

export type BrandTag = {
  __typename?: "BrandTag";
  code: Scalars["String"];
  id: Scalars["ID"];
  value: Scalars["String"];
};

export type BrandTagConnection = {
  __typename?: "BrandTagConnection";
  edges: Array<BrandTagEdge>;
};

export type BrandTagEdge = {
  __typename?: "BrandTagEdge";
  node: BrandTag;
};

export type BrandTermsAndConditions = {
  __typename?: "BrandTermsAndConditions";
  brand: Brand;
  termsAndConditions?: Maybe<Array<TermsAndConditions>>;
};

export type BrandTermsAndConditionsConnection = {
  __typename?: "BrandTermsAndConditionsConnection";
  edges?: Maybe<Array<BrandTermsAndConditionsEdge>>;
};

export type BrandTermsAndConditionsEdge = {
  __typename?: "BrandTermsAndConditionsEdge";
  node: BrandTermsAndConditions;
};

export type BrandUserConnection = {
  __typename?: "BrandUserConnection";
  edges: Array<BrandUserEdge>;
};

export type BrandUserEdge = {
  __typename?: "BrandUserEdge";
  /** Data Permission Configuration for this user in relation to a specific brand */
  dataPermissionConfiguration?: Maybe<DataPermissionConfiguration>;
  /** Display for this user in relation to a specific brand */
  displayName?: Maybe<Scalars["String"]>;
  node?: Maybe<User>;
};

export type BrandUserIdList = {
  __typename?: "BrandUserIdList";
  brandId: Scalars["ID"];
  users: Array<User>;
};

export type BrandsFilter = {
  allowUnconnectedBrands?: InputMaybe<Scalars["Boolean"]>;
  brandIds?: InputMaybe<Array<Scalars["ID"]>>;
  ipadEnabled?: InputMaybe<Scalars["Boolean"]>;
  searchName?: InputMaybe<Scalars["String"]>;
  status?: InputMaybe<Array<BrandStatus>>;
  subtype?: InputMaybe<BrandSubType>;
};

/**
 * Budgets allow retailers to define planned spending
 * by a set of purchase terms:
 * 1. brand
 * 1. currency
 * 1. door
 * 1. merchandising hierarchy
 * 1. season
 */
export type Budget = Node & {
  __typename?: "Budget";
  /** Brand that filters this budget */
  brand?: Maybe<RetailerBrandEdge>;
  /** Currency that filters this budget */
  currencyCode: Scalars["String"];
  /** Retail door that filters this budget */
  door?: Maybe<Door>;
  /** Spending targets defined by this budget */
  goals: Array<BudgetGoal>;
  id: Scalars["ID"];
  /** Merchandising hierarchy leaf nodes that filter this budget */
  merchandisingHierarchyNodes: MerchandisingHierarchyNodeConnection;
  /** Season that filters this budget */
  season?: Maybe<Season>;
};

export type BudgetConnection = {
  __typename?: "BudgetConnection";
  edges?: Maybe<Array<BudgetEdge>>;
};

export type BudgetEdge = {
  __typename?: "BudgetEdge";
  node?: Maybe<Budget>;
};

/** Goal for a financial metric of a given type */
export type BudgetGoal = {
  __typename?: "BudgetGoal";
  /** Goal type */
  type: BudgetGoalType;
  /** Goal target */
  value: Scalars["Decimal"];
};

/** Goal types */
export enum BudgetGoalType {
  /** Number of style colors for a budget. See numberOfStyleColors */
  Breadth = "BREADTH",
  /** Calculation of numberOfUnits divided by numberOfStyleColors */
  Depth = "DEPTH",
  /** Purchasing cost */
  NetCostAmount = "NET_COST_AMOUNT",
  /** Initial markup value */
  NetImuValue = "NET_IMU_VALUE",
  /** Selling price */
  NetRetailAmount = "NET_RETAIL_AMOUNT",
  /** Number of styles for a budget */
  NumberOfStyles = "NUMBER_OF_STYLES",
  /** Number of style colors for a budget */
  NumberOfStyleColors = "NUMBER_OF_STYLE_COLORS",
  /** Number of units for a budget */
  NumberOfUnits = "NUMBER_OF_UNITS",
}

/** Supported budget types */
export enum BudgetType {
  Assortment = "ASSORTMENT",
  Workspace = "WORKSPACE",
}

export type BulkAddColorsToAssortmentProductRequest = {
  assortmentId: Scalars["ID"];
  requests: Array<AddColorsToAssortmentProductRequest>;
};

export type BulkAddColorsToAssortmentProductResponse = {
  __typename?: "BulkAddColorsToAssortmentProductResponse";
  assortment?: Maybe<Assortment>;
};

export type BulkAddOrdersToHubInput = {
  hubOrders: Array<BulkAddOrdersToHubValues>;
};

export type BulkAddOrdersToHubOutput = {
  __typename?: "BulkAddOrdersToHubOutput";
  hubId: Scalars["ID"];
  orderIds: Array<Scalars["ID"]>;
};

export type BulkAddOrdersToHubPayload = {
  __typename?: "BulkAddOrdersToHubPayload";
  hubOrders: Array<BulkAddOrdersToHubOutput>;
};

export type BulkAddOrdersToHubValues = {
  hubId: Scalars["ID"];
  orderIds: Array<Scalars["ID"]>;
};

export type BulkAddProductsAndSkusError = GenericError & {
  __typename?: "BulkAddProductsAndSkusError";
  code?: Maybe<GenericErrorCode>;
  details?: Maybe<BulkAddProductsAndSkusErrorDetail>;
  message: Scalars["String"];
};

export type BulkAddProductsAndSkusErrorDetail = {
  __typename?: "BulkAddProductsAndSkusErrorDetail";
  collectionId: Scalars["ID"];
  productId: Scalars["ID"];
  skuId: Scalars["ID"];
};

export type BulkAddProductsAndSkusToCollectionsInput = {
  collectionsProducts?: InputMaybe<Array<AddProductsAndSkusToCollectionInput>>;
};

export type BulkAddProductsAndSkusToCollectionsPayload = {
  __typename?: "BulkAddProductsAndSkusToCollectionsPayload";
  collections?: Maybe<Array<Collection>>;
  errors?: Maybe<Array<BulkAddProductsAndSkusError>>;
};

export type BulkAddProductsToCollectionInput = {
  collectionId: Scalars["ID"];
  collectionProducts?: InputMaybe<Array<AddProductToCollectionInput>>;
};

export type BulkAddProductsToCollectionPayload = {
  __typename?: "BulkAddProductsToCollectionPayload";
  collections?: Maybe<Array<Collection>>;
};

export type BulkAddProductsToInventoryAvailabilityGroupInput = {
  inventoryAvailabilityGroupId: Scalars["ID"];
  productIds: Array<Scalars["ID"]>;
};

export type BulkAddProductsToInventoryAvailabilityGroupPayload = {
  __typename?: "BulkAddProductsToInventoryAvailabilityGroupPayload";
  createdInventoryAvailabilityGroupItemIds: Array<Scalars["ID"]>;
};

export type BulkAddWarehousesInput = {
  warehouses: Array<AddWarehousesInput>;
};

export type BulkAddWarehousesPayload = {
  __typename?: "BulkAddWarehousesPayload";
  warehouses: Array<AddWarehousePayload>;
};

export type BulkCancelOrdersVariantsInput = {
  orderIds: Array<Scalars["ID"]>;
  variantIds: Array<Scalars["ID"]>;
};

export type BulkCancelOrdersVariantsPayload = {
  __typename?: "BulkCancelOrdersVariantsPayload";
  cancelledVariantIds: Array<Scalars["ID"]>;
};

export type BulkCopyOrdersInput = {
  orderForAccountId: Scalars["ID"];
  orderIds: Array<Scalars["ID"]>;
};

export type BulkCopyOrdersPayload = {
  __typename?: "BulkCopyOrdersPayload";
  copiedOrderIds: Array<Scalars["ID"]>;
};

export type BulkCreateAssortmentProductRequest = {
  assortmentId: Scalars["ID"];
  products: Array<AssortmentProductRequest>;
};

export type BulkCreateAssortmentProductResponse = {
  __typename?: "BulkCreateAssortmentProductResponse";
  assortment?: Maybe<Assortment>;
};

export type BulkCreateCollaborationInvitesInput = {
  requestInput: Array<CreateCollaborationInviteInput>;
};

export type BulkCreateCollaborationInvitesPayload = {
  __typename?: "BulkCreateCollaborationInvitesPayload";
  collaborationInvites: CollaborationInviteConnection;
};

export type BulkCreateCollaborationInvitesToAccountsInput = {
  invitedAccountIds: Array<CreateCollaborationInviteToAccountInput>;
};

export type BulkCreateCollectionGroupPayload = {
  __typename?: "BulkCreateCollectionGroupPayload";
  collectionGroups?: Maybe<Array<CollectionGroup>>;
  collectionId: Scalars["ID"];
};

export type BulkCreateCollectionGroupsInput = {
  createCollectionGroups: Array<CreateCollectionGroupsInput>;
};

export type BulkCreateCollectionGroupsPayload = {
  __typename?: "BulkCreateCollectionGroupsPayload";
  createdCollectionGroups: Array<BulkCreateCollectionGroupPayload>;
};

export type BulkCreateCollectionsInput = {
  brandId: Scalars["ID"];
  collections: Array<CreateCollectionInput>;
};

export type BulkCreateCollectionsPayload = {
  __typename?: "BulkCreateCollectionsPayload";
  collections?: Maybe<Array<Collection>>;
  errors?: Maybe<Array<CreateCollectionError>>;
};

export type BulkCreateProductsInput = {
  products: Array<CreateProductInput>;
};

export type BulkCreateProductsPayload = {
  __typename?: "BulkCreateProductsPayload";
  errors: Array<Maybe<CreateProductError>>;
  products: Array<Product>;
};

export type BulkCreateSkuPricesInput = {
  prices: Array<CreateSkuPriceInput>;
};

export type BulkCreateSkuPricesPayload = {
  __typename?: "BulkCreateSkuPricesPayload";
  errors?: Maybe<Array<CreateSkuPriceError>>;
  prices?: Maybe<Array<SkuPrice>>;
};

export type BulkCreateSkuTraitValuesError = GenericError & {
  __typename?: "BulkCreateSkuTraitValuesError";
  code?: Maybe<GenericErrorCode>;
  details?: Maybe<BulkCreateSkuTraitValuesErrorDetail>;
  message: Scalars["String"];
};

export type BulkCreateSkuTraitValuesErrorDetail = {
  __typename?: "BulkCreateSkuTraitValuesErrorDetail";
  externalIdentifier?: Maybe<Scalars["String"]>;
  orderMinimum?: Maybe<Scalars["Int"]>;
  orderNbr?: Maybe<Scalars["Int"]>;
  productId: Scalars["ID"];
  skuTraitId: Scalars["ID"];
  status?: Maybe<SkuTraitValueStatus>;
  value: Scalars["String"];
};

export type BulkCreateSkuTraitValuesInput = {
  skuTraitValues?: InputMaybe<Array<CreateSkuTraitValueInput>>;
};

export type BulkCreateSkuTraitValuesPayload = {
  __typename?: "BulkCreateSkuTraitValuesPayload";
  errors?: Maybe<Array<BulkCreateSkuTraitValuesError>>;
  skuTraitValues?: Maybe<Array<SkuTraitValue>>;
};

export type BulkCreateUserMembershipRequestsInput = {
  requestInput: Array<CreateUserMembershipRequestInputForBulk>;
};

export type BulkCreateUserMembershipRequestsPayload = {
  __typename?: "BulkCreateUserMembershipRequestsPayload";
  results?: Maybe<Array<BulkCreateUserMembershipResult>>;
};

/** One of error or userMembershipId will be returned. */
export type BulkCreateUserMembershipResult = {
  __typename?: "BulkCreateUserMembershipResult";
  accountId: Scalars["ID"];
  error?: Maybe<Error>;
  userId: Scalars["ID"];
  userMembershipId?: Maybe<Scalars["ID"]>;
};

export type BulkDeleteCollectionGroupsInput = {
  collectionGroupIds: Array<Scalars["ID"]>;
};

export type BulkDeleteCollectionGroupsPayload = {
  __typename?: "BulkDeleteCollectionGroupsPayload";
  collectionGroupIds?: Maybe<Array<Scalars["ID"]>>;
};

export type BulkDeleteCollectionsInput = {
  collectionIds: Array<Scalars["ID"]>;
};

export type BulkDeleteCollectionsPayload = {
  __typename?: "BulkDeleteCollectionsPayload";
  collectionIds?: Maybe<Array<Maybe<Scalars["ID"]>>>;
};

export type BulkDeleteDataPermissionConfigurationsInput = {
  ids: Array<Scalars["ID"]>;
};

export type BulkDeleteDataPermissionConfigurationsPayload = {
  __typename?: "BulkDeleteDataPermissionConfigurationsPayload";
  success: Scalars["Boolean"];
};

export type BulkDeleteExternalProviderAuthsInput = {
  externalProviderAuthsIds: Array<Scalars["ID"]>;
};

export type BulkDeleteExternalProviderAuthsPayload = {
  __typename?: "BulkDeleteExternalProviderAuthsPayload";
  externalProviderAuthsIds: Array<Scalars["ID"]>;
};

export type BulkDeleteProductsFromAvailabilityGroupInput = {
  inventoryId: Scalars["ID"];
  productIds: Array<Scalars["ID"]>;
};

export type BulkDeleteProductsFromAvailabilityGroupPayload = {
  __typename?: "BulkDeleteProductsFromAvailabilityGroupPayload";
  deletedProductIds: Array<Scalars["ID"]>;
};

export type BulkDeleteProductsInput = {
  products: Array<DeleteProductInput>;
};

export type BulkDeleteProductsPayload = {
  __typename?: "BulkDeleteProductsPayload";
  errors?: Maybe<Array<Maybe<DeleteProductError>>>;
  products: Array<Product>;
};

export type BulkDeleteRetailerLocations = {
  __typename?: "BulkDeleteRetailerLocations";
  retailerLocationIds?: Maybe<Array<Maybe<Scalars["ID"]>>>;
};

export type BulkDeleteRetailerLocationsInput = {
  retailerLocationIds: Array<Scalars["ID"]>;
};

export type BulkDeleteRetailerUploads = {
  __typename?: "BulkDeleteRetailerUploads";
  error?: Maybe<Scalars["String"]>;
  retailerUploadIds?: Maybe<Array<Maybe<Scalars["ID"]>>>;
};

export type BulkDeleteRetailerUploadsInput = {
  retailerUploadIds: Array<Scalars["ID"]>;
};

export type BulkDeleteWarehousesInput = {
  warehouseIds: Array<Scalars["ID"]>;
};

export type BulkDeleteWarehousesPayload = {
  __typename?: "BulkDeleteWarehousesPayload";
  deletedWarehouseIds: Array<Scalars["ID"]>;
};

export type BulkDuplicateCollectionsInput = {
  collectionIds: Array<Scalars["ID"]>;
};

export type BulkDuplicateCollectionsPayload = {
  __typename?: "BulkDuplicateCollectionsPayload";
  collections?: Maybe<Array<Collection>>;
};

/**
 * A bulk line item is a unit of transaction that represents an intent to buy some amount of an item with vairious
 * characteristics, distinguishable from a (non-bulk) line item by a lack of size details.
 */
export type BulkLineItem = Node & {
  __typename?: "BulkLineItem";
  /** The destination information of the bulk line item */
  destination?: Maybe<Destination>;
  id: Scalars["ID"];
  /** The quantity of this line item */
  quantity?: Maybe<Scalars["Int"]>;
  /** The SKU for this line item */
  skus?: Maybe<BulkLineItemSkuConnection>;
};

export type BulkLineItemSkuConnection = {
  __typename?: "BulkLineItemSKUConnection";
  edges?: Maybe<Array<SkuEdge>>;
};

export type BulkMarkInventoryAvailabilityGroupsAsReceivedInput = {
  inventoryAvailabilityGroupIds: Array<Scalars["ID"]>;
};

export type BulkMarkInventoryAvailabilityGroupsAsReceivedPayload = {
  __typename?: "BulkMarkInventoryAvailabilityGroupsAsReceivedPayload";
  payload: Scalars["String"];
  updatedInventoryAvailabilityGroupIds: Array<Scalars["ID"]>;
};

export type BulkMarkOrdersAsExportedInput = {
  orderExportIntegrationId: Scalars["ID"];
  orderIds: Array<Scalars["ID"]>;
};

export type BulkMarkOrdersAsExportedPayload = {
  __typename?: "BulkMarkOrdersAsExportedPayload";
  updatedOrderIds: Array<Scalars["ID"]>;
};

export type BulkQuantity = {
  bulkVariantValue: Scalars["String"];
  doorId?: InputMaybe<Scalars["ID"]>;
  productId: Scalars["ID"];
  quantity?: InputMaybe<Scalars["Int"]>;
};

export type BulkRemoveProductsAndSkusFromCollectionsInput = {
  collectionsProducts?: InputMaybe<
    Array<RemoveProductsAndSkusFromCollectionInput>
  >;
};

export type BulkRemoveProductsAndSkusFromCollectionsPayload = {
  __typename?: "BulkRemoveProductsAndSkusFromCollectionsPayload";
  collections?: Maybe<Array<Collection>>;
  errors?: Maybe<Array<Error>>;
};

export type BulkReplaceOrdersVariantInput = {
  emailMessage?: InputMaybe<Scalars["String"]>;
  newVariantId: Scalars["ID"];
  notifyByEmail?: InputMaybe<Scalars["Boolean"]>;
  oldVariantId: Scalars["ID"];
  orderIds: Array<Scalars["ID"]>;
};

export type BulkReplaceOrdersVariantPayload = {
  __typename?: "BulkReplaceOrdersVariantPayload";
  updatedOrderIds: Array<Scalars["ID"]>;
};

export type BulkScheduleForExportInput = {
  orderIds: Array<Scalars["ID"]>;
};

export type BulkScheduleForExportPayload = {
  __typename?: "BulkScheduleForExportPayload";
  scheduledOrderIds: Array<Scalars["ID"]>;
};

export type BulkSetCollectionsDeliveryInput = {
  collections: Array<SetCollectionDeliveryInput>;
};

export type BulkSetCollectionsDeliveryPayload = {
  __typename?: "BulkSetCollectionsDeliveryPayload";
  collections?: Maybe<Array<Collection>>;
  errors?: Maybe<Array<Error>>;
};

export type BulkSetOrdersToReexportInput = {
  orderIds: Array<Scalars["ID"]>;
};

export type BulkSetOrdersToReexportPayload = {
  __typename?: "BulkSetOrdersToReexportPayload";
  updatedOrderIds: Array<Scalars["ID"]>;
};

export type BulkSetProductsTraitValuesInput = {
  productTraitValues: Array<SetProductTraitValueInput>;
};

export type BulkSetProductsTraitValuesPayload = {
  __typename?: "BulkSetProductsTraitValuesPayload";
  errors: Array<Maybe<UpdateProductError>>;
  products: Array<Product>;
};

export type BulkSetSkuItemPropertiesPayload = {
  __typename?: "BulkSetSkuItemPropertiesPayload";
  assortment?: Maybe<Assortment>;
  properties?: Maybe<Array<BulkSkuItemProperty>>;
  query?: Maybe<Query>;
};

export type BulkSetSkuUpcsInput = {
  skuUpcs?: InputMaybe<Array<SetSkuUpcInput>>;
};

export type BulkSetSkuUpcsPayload = {
  __typename?: "BulkSetSkuUpcsPayload";
  errors?: Maybe<Array<Error>>;
  skus?: Maybe<Array<Sku>>;
};

export type BulkSkuItemProperty = {
  __typename?: "BulkSkuItemProperty";
  id: Scalars["ID"];
  propertyName: Scalars["String"];
  propertyValue: Scalars["String"];
};

export type BulkUnscheduleForExportInput = {
  orderIds: Array<Scalars["ID"]>;
};

export type BulkUnscheduleForExportPayload = {
  __typename?: "BulkUnscheduleForExportPayload";
  updatedOrderIds: Array<Scalars["ID"]>;
};

export type BulkUpdateAssortmentDetailsPayload = {
  __typename?: "BulkUpdateAssortmentDetailsPayload";
  assortmentIds: Array<Scalars["ID"]>;
};

export type BulkUpdateCollectionGroupsInput = {
  collectionGroups: Array<UpdateCollectionGroupInput>;
};

export type BulkUpdateCollectionGroupsPayload = {
  __typename?: "BulkUpdateCollectionGroupsPayload";
  collectionGroups?: Maybe<Array<CollectionGroup>>;
};

export type BulkUpdateCollectionProductsInput = {
  collectionProducts: Array<UpdateCollectionProductInput>;
};

export type BulkUpdateCollectionProductsPayload = {
  __typename?: "BulkUpdateCollectionProductsPayload";
  collectionProducts: Array<CollectionProduct>;
};

export type BulkUpdateCollectionsInput = {
  collections: Array<UpdateCollectionInput>;
};

export type BulkUpdateCollectionsPayload = {
  __typename?: "BulkUpdateCollectionsPayload";
  collections?: Maybe<Array<Collection>>;
  errors?: Maybe<Array<UpdateCollectionError>>;
};

export type BulkUpdateCollectionsPositionInput = {
  collectionsPositions: Array<UpdateCollectionsPositionInput>;
};

export type BulkUpdateCollectionsPositionPayload = {
  __typename?: "BulkUpdateCollectionsPositionPayload";
  collections?: Maybe<Array<Collection>>;
};

export type BulkUpdateCollectionsPublicInput = {
  publicCollections: Array<UpdateCollectionsPublicInput>;
};

export type BulkUpdateCollectionsPublicPayload = {
  __typename?: "BulkUpdateCollectionsPublicPayload";
  collections?: Maybe<Array<Collection>>;
};

export type BulkUpdateInventoryItemsInput = {
  itemsToUpdate: Array<UpdateInventoryItemQuantity>;
};

export type BulkUpdateInventoryItemsPayload = {
  __typename?: "BulkUpdateInventoryItemsPayload";
  updatedInventoryItemIds: Array<Scalars["String"]>;
};

export type BulkUpdateOrderPricingByFiltersInput = {
  appliedFilters?: InputMaybe<OrderFilterInput>;
  searchFilter?: InputMaybe<Scalars["String"]>;
};

export type BulkUpdateOrderPricingByFiltersPayload = {
  __typename?: "BulkUpdateOrderPricingByFiltersPayload";
  success: Scalars["Boolean"];
};

export type BulkUpdateOrderPricingByIdsInput = {
  orderIds: Array<Scalars["ID"]>;
};

export type BulkUpdateOrderPricingByIdsPayload = {
  __typename?: "BulkUpdateOrderPricingByIdsPayload";
  notUpdatedOrdersCount: Scalars["Int"];
  updatedOrdersCount: Scalars["Int"];
};

export type BulkUpdateOrderStatusInput = {
  customMessage?: InputMaybe<Scalars["String"]>;
  customSubject?: InputMaybe<Scalars["String"]>;
  orderIds: Array<Scalars["ID"]>;
  sendToBrand?: InputMaybe<Scalars["Boolean"]>;
  sendToRetailer?: InputMaybe<Scalars["Boolean"]>;
  status: OrderStatus;
};

export type BulkUpdateOrderStatusPayload = {
  __typename?: "BulkUpdateOrderStatusPayload";
  errors: Array<Error>;
  updatedOrderIds: Array<Scalars["ID"]>;
};

export type BulkUpdateProductsInput = {
  products: Array<UpdateProductInput>;
};

export type BulkUpdateProductsPayload = {
  __typename?: "BulkUpdateProductsPayload";
  errors: Array<Maybe<UpdateProductError>>;
  products: Array<Product>;
};

export type BulkUpdateRetailerGoogleAddressesInput = {
  accepted: Scalars["Boolean"];
  id: Scalars["ID"];
};

export type BulkUpdateRetailerGoogleAddressesPayload = {
  __typename?: "BulkUpdateRetailerGoogleAddressesPayload";
  retailerGoogleAddressIds?: Maybe<Array<Maybe<Scalars["ID"]>>>;
};

export type BulkUpdateSkuPricesInput = {
  prices: Array<UpdateSkuPriceInput>;
};

export type BulkUpdateSkuPricesPayload = {
  __typename?: "BulkUpdateSkuPricesPayload";
  errors?: Maybe<Array<UpdateSkuPriceError>>;
  prices?: Maybe<Array<SkuPrice>>;
};

export type BulkUpdateSkuTraitValuesError = GenericError & {
  __typename?: "BulkUpdateSkuTraitValuesError";
  code?: Maybe<GenericErrorCode>;
  details?: Maybe<BulkUpdateSkuTraitValuesErrorDetail>;
  message: Scalars["String"];
};

export type BulkUpdateSkuTraitValuesErrorDetail = {
  __typename?: "BulkUpdateSkuTraitValuesErrorDetail";
  externalIdentifier?: Maybe<Scalars["String"]>;
  id: Scalars["ID"];
  orderMinimum?: Maybe<Scalars["Int"]>;
  status?: Maybe<SkuTraitValueStatus>;
  value?: Maybe<Scalars["String"]>;
};

export type BulkUpdateSkuTraitValuesInput = {
  skuTraitValues?: InputMaybe<Array<UpdateSkuTraitValueInput>>;
};

export type BulkUpdateSkuTraitValuesPayload = {
  __typename?: "BulkUpdateSkuTraitValuesPayload";
  errors?: Maybe<Array<BulkUpdateSkuTraitValuesError>>;
  skuTraitValues?: Maybe<Array<SkuTraitValue>>;
};

export type BulkUpdateStorefrontsInput = {
  storefronts: Array<UpdateStorefrontInput>;
};

export type BulkUpdateUserFavoriteCollectionsInput = {
  favoriteCollections: Array<UpdateUserFavoriteCollectionsInput>;
};

export type BulkUpdateUserFavoriteCollectionsPayload = {
  __typename?: "BulkUpdateUserFavoriteCollectionsPayload";
  success?: Maybe<Scalars["Boolean"]>;
};

export type BulkUpdateWarehousesInput = {
  warehouses: Array<UpdateWarehousesInput>;
};

export type BulkUpdateWarehousesPayload = {
  __typename?: "BulkUpdateWarehousesPayload";
  updatedWarehouseIds: Array<Scalars["ID"]>;
};

export type BulkUpsertOrderEventsInput = {
  eventId: Scalars["String"];
  orderIds: Array<Scalars["ID"]>;
};

export type BulkUpsertOrderEventsPayload = {
  __typename?: "BulkUpsertOrderEventsPayload";
  updatedOrderIds: Array<Scalars["ID"]>;
};

export type BulkUpsertRetailerLocations = {
  __typename?: "BulkUpsertRetailerLocations";
  locations: Array<Location>;
};

export type BulkUpsertRetailerLocationsInput = {
  locations: Array<LocationInput>;
};

export type BulkUpsertRetailerUploadsInput = {
  uploads: Array<Scalars["ID"]>;
};

export type BulkUpsertRetailerUploadsPayload = {
  __typename?: "BulkUpsertRetailerUploadsPayload";
  retailerUploadIds?: Maybe<Array<Scalars["ID"]>>;
};

export type BulkUpsertSkuExternalIdentifiersError = GenericError & {
  __typename?: "BulkUpsertSkuExternalIdentifiersError";
  code?: Maybe<GenericErrorCode>;
  details?: Maybe<BulkUpsertSkuExternalIdentifiersErrorDetail>;
  message: Scalars["String"];
};

export type BulkUpsertSkuExternalIdentifiersErrorDetail = {
  __typename?: "BulkUpsertSkuExternalIdentifiersErrorDetail";
  externalId?: Maybe<Scalars["String"]>;
  skuId: Scalars["ID"];
  skuIdentifier?: Maybe<Scalars["String"]>;
};

export type BulkUpsertSkuExternalIdentifiersInput = {
  skuExternalIdentifiers?: InputMaybe<Array<SkuExternalIdentifierInput>>;
};

export type BulkUpsertSkuExternalIdentifiersPayload = {
  __typename?: "BulkUpsertSkuExternalIdentifiersPayload";
  errors?: Maybe<Array<BulkUpsertSkuExternalIdentifiersError>>;
  skuExternalIdentifiers?: Maybe<Array<SkuExternalIdentifier>>;
};

export enum BusinessStatus {
  ClosedPermanently = "CLOSED_PERMANENTLY",
  ClosedTemporarily = "CLOSED_TEMPORARILY",
  Operational = "OPERATIONAL",
  Unknown = "UNKNOWN",
}

export type BuyerInput = {
  email?: InputMaybe<Scalars["String"]>;
  name?: InputMaybe<Scalars["String"]>;
};

export type CarriedBrand = {
  __typename?: "CarriedBrand";
  accountId?: Maybe<Scalars["ID"]>;
  id: Scalars["ID"];
  name?: Maybe<Scalars["String"]>;
};

export type CasepackFilterInput = {
  casepackIds?: InputMaybe<Array<Scalars["String"]>>;
};

export type CasepackLineItem = {
  __typename?: "CasepackLineItem";
  casepack: AccountCasepack;
  collection: LineItemCollection;
  inventory?: Maybe<InventoryAvailabilityGroup>;
  orderId: Scalars["ID"];
  productId: Scalars["ID"];
  quantity: Scalars["Int"];
  suggestedRetailPrice: Scalars["Decimal"];
  variantInfo?: Maybe<VariantByCasepackLineItem>;
  wholesalePrice: Scalars["Decimal"];
};

export type CasepackQuantity = {
  casepackId: Scalars["ID"];
  doorId?: InputMaybe<Scalars["ID"]>;
  productId: Scalars["ID"];
  quantity?: InputMaybe<Scalars["Int"]>;
  variantValue?: InputMaybe<Scalars["String"]>;
};

export type CasepackSkuEdge = {
  __typename?: "CasepackSKUEdge";
  node: Sku;
  quantity: Scalars["Int"];
};

export type CasepackSkuConnection = {
  __typename?: "CasepackSkuConnection";
  edges: Array<CasepackSkuEdge>;
};

export type Category = {
  __typename?: "Category";
  department?: Maybe<Scalars["String"]>;
  id?: Maybe<Scalars["ID"]>;
  name: Scalars["String"];
  parentName?: Maybe<Scalars["String"]>;
};

export type CategoryConnection = {
  __typename?: "CategoryConnection";
  edges: Array<CategoryEdge>;
};

export type CategoryEdge = {
  __typename?: "CategoryEdge";
  node: Category;
};

export type CeleryJob = Node & {
  __typename?: "CeleryJob";
  account?: Maybe<Account>;
  createdAt?: Maybe<Scalars["Date"]>;
  id: Scalars["ID"];
  inputFileUrl?: Maybe<Scalars["String"]>;
  jobId?: Maybe<Scalars["String"]>;
  status: CeleryJobStatus;
  type: CeleryJobType;
  updatedAt?: Maybe<Scalars["Date"]>;
  user?: Maybe<User>;
};

export type CeleryJobConnection = {
  __typename?: "CeleryJobConnection";
  edges: Array<CeleryJobEdge>;
};

export type CeleryJobEdge = {
  __typename?: "CeleryJobEdge";
  node: CeleryJob;
};

export type CeleryJobFilter = {
  jobsIds?: InputMaybe<Array<Scalars["ID"]>>;
};

export enum CeleryJobStatus {
  Completed = "COMPLETED",
  Failed = "FAILED",
  InProgress = "IN_PROGRESS",
}

export enum CeleryJobType {
  OrderImport = "ORDER_IMPORT",
}

export type ClienteleDescription = {
  __typename?: "ClienteleDescription";
  id: Scalars["ID"];
  name?: Maybe<Scalars["String"]>;
};

/** CLIENTELE DESCRIPTION */
export type ClienteleDescriptionConnection = {
  __typename?: "ClienteleDescriptionConnection";
  edges?: Maybe<Array<ClienteleDescriptionEdge>>;
};

export type ClienteleDescriptionEdge = {
  __typename?: "ClienteleDescriptionEdge";
  node?: Maybe<ClienteleDescription>;
};

export type ClienteleInfo = {
  __typename?: "ClienteleInfo";
  clienteleAge?: Maybe<Scalars["String"]>;
  clienteleDescriptions?: Maybe<Array<ClienteleDescription>>;
  clienteleFemale?: Maybe<Scalars["Boolean"]>;
  clienteleInterests?: Maybe<Array<ClienteleInterest>>;
  clienteleMale?: Maybe<Scalars["Boolean"]>;
};

export type ClienteleInfoInput = {
  clienteleAge?: InputMaybe<Scalars["String"]>;
  clienteleDescriptions?: InputMaybe<Array<Scalars["ID"]>>;
  clienteleFemale?: InputMaybe<Scalars["Boolean"]>;
  clienteleInterests?: InputMaybe<Array<Scalars["ID"]>>;
  clienteleMale?: InputMaybe<Scalars["Boolean"]>;
};

export type ClienteleInterest = {
  __typename?: "ClienteleInterest";
  id: Scalars["ID"];
  name?: Maybe<Scalars["String"]>;
};

/** CLIENTELE INTEREST */
export type ClienteleInterestConnection = {
  __typename?: "ClienteleInterestConnection";
  edges?: Maybe<Array<ClienteleInterestEdge>>;
};

export type ClienteleInterestEdge = {
  __typename?: "ClienteleInterestEdge";
  node?: Maybe<ClienteleInterest>;
};

export type CollaborationInvite = Node & {
  __typename?: "CollaborationInvite";
  created?: Maybe<Scalars["Date"]>;
  id: Scalars["ID"];
  invitedEmail: Scalars["String"];
  invitedUser?: Maybe<User>;
  invitingAccount: AccountProfile;
  invitingUser: CollaborationUser;
};

export type CollaborationInviteConnection = {
  __typename?: "CollaborationInviteConnection";
  edges: Array<CollaborationInviteEdge>;
};

export type CollaborationInviteEdge = {
  __typename?: "CollaborationInviteEdge";
  node?: Maybe<CollaborationInvite>;
};

/**
 * Used to access user information in the context of
 * a received collaboration invite
 */
export type CollaborationUser = Node & {
  __typename?: "CollaborationUser";
  displayName?: Maybe<Scalars["String"]>;
  email?: Maybe<Scalars["String"]>;
  id: Scalars["ID"];
  profileImage?: Maybe<Scalars["String"]>;
};

export type Collection = {
  __typename?: "Collection";
  archived?: Maybe<Scalars["Boolean"]>;
  brand: Brand;
  code?: Maybe<Scalars["String"]>;
  created?: Maybe<Scalars["Date"]>;
  delivery?: Maybe<Delivery>;
  description?: Maybe<Scalars["String"]>;
  groups: Array<CollectionGroup>;
  id: Scalars["ID"];
  /** @deprecated Get from madeToOrder */
  ignores_inventory?: Maybe<Scalars["Boolean"]>;
  image?: Maybe<Media>;
  isCustom?: Maybe<Scalars["Boolean"]>;
  isVisibleToRetailer?: Maybe<Scalars["Boolean"]>;
  /** @deprecated Get from isCustom */
  is_custom?: Maybe<Scalars["Boolean"]>;
  items: CollectionItemsConnection;
  madeToOrder?: Maybe<Scalars["Boolean"]>;
  modified?: Maybe<Scalars["Date"]>;
  name: Scalars["String"];
  owner?: Maybe<BrandUserEdge>;
  position?: Maybe<Scalars["Int"]>;
  retailers: Array<RetailerAccount>;
  season?: Maybe<Season>;
  skus?: Maybe<SkuConnection>;
  source?: Maybe<CollectionSource>;
  syncToIpad?: Maybe<Scalars["Boolean"]>;
  textStyles?: Maybe<Array<CollectionTextStyle>>;
  visibility?: Maybe<CollectionVisibility>;
  visibleToViewer: Scalars["Boolean"];
};

export type CollectionIsVisibleToRetailerArgs = {
  retailerId: Scalars["ID"];
};

export type CollectionSkusArgs = {
  skip: Scalars["Int"];
  take: Scalars["Int"];
};

export type CollectionBanner = {
  bannerType: BannerType;
  id: Scalars["ID"];
  orderNbr: Scalars["Int"];
  presentation?: Maybe<Scalars["String"]>;
};

export type CollectionBannerConnection = {
  __typename?: "CollectionBannerConnection";
  edges: Array<CollectionBannerEdge>;
};

export type CollectionBannerEdge = {
  __typename?: "CollectionBannerEdge";
  node: CollectionBanners;
};

export type CollectionBanners = {
  __typename?: "CollectionBanners";
  collectionId: Scalars["ID"];
  imageBanners: Array<CollectionImageBanner>;
  textBanners: Array<CollectionTextBanner>;
  videoBanners: Array<CollectionVideoBanner>;
};

export type CollectionConnection = {
  __typename?: "CollectionConnection";
  deliveryWindow?: Maybe<CollectionDeliveryWindow>;
  edges: Array<Maybe<CollectionEdge>>;
  totalCount?: Maybe<Scalars["Int"]>;
};

export type CollectionDeliveryWindow = {
  __typename?: "CollectionDeliveryWindow";
  maxCompleteShipDate?: Maybe<Scalars["Date"]>;
  minStartShipDate?: Maybe<Scalars["Date"]>;
};

export type CollectionEdge = {
  __typename?: "CollectionEdge";
  node: Collection;
};

export type CollectionGroup = {
  __typename?: "CollectionGroup";
  header: Scalars["String"];
  id: Scalars["ID"];
  orderNbr: Scalars["Int"];
};

export type CollectionImageBanner = CollectionBanner & {
  __typename?: "CollectionImageBanner";
  bannerType: BannerType;
  id: Scalars["ID"];
  imageId?: Maybe<Scalars["ID"]>;
  imageUrl?: Maybe<Scalars["String"]>;
  orderNbr: Scalars["Int"];
  presentation?: Maybe<Scalars["String"]>;
};

export type CollectionInputInfo = {
  id: Scalars["ID"];
  name?: InputMaybe<Scalars["String"]>;
};

export type CollectionItems = {
  __typename?: "CollectionItems";
  orderNumber?: Maybe<Scalars["Int"]>;
  productId: Scalars["ID"];
  skuDeliveries: SkuDeliveryConnection;
  /** @deprecated Use skuDeliveries instead */
  skus?: Maybe<Array<SkuIdWithDelivery>>;
};

export type CollectionItemsConnection = {
  __typename?: "CollectionItemsConnection";
  edges: Array<CollectionItemsEdge>;
};

export type CollectionItemsEdge = {
  __typename?: "CollectionItemsEdge";
  node: CollectionItems;
};

export type CollectionName = {
  __typename?: "CollectionName";
  name?: Maybe<Scalars["String"]>;
};

export enum CollectionOrderByField {
  Name = "NAME",
  Position = "POSITION",
}

export type CollectionPayload = {
  __typename?: "CollectionPayload";
  code?: Maybe<Scalars["String"]>;
  endShipDate?: Maybe<Scalars["Date"]>;
  id: Scalars["ID"];
  name: Scalars["String"];
  startShipDate?: Maybe<Scalars["Date"]>;
};

export type CollectionProduct = Node & {
  __typename?: "CollectionProduct";
  casepacks: ProductCasepackConnection;
  collection: Collection;
  comments: Scalars["String"];
  groupedBy?: Maybe<CollectionProductGroupBy>;
  id: Scalars["ID"];
  orderNbr: Scalars["Int"];
  priceTypes: PriceTypeConnection;
  product: Product;
  skus: SkuConnection;
  variantTotal: Scalars["Int"];
  variants: ProductSkuVariantConnection;
};

export type CollectionProductCasepacksArgs = {
  withDeleted?: InputMaybe<Scalars["Boolean"]>;
};

export type CollectionProductSkusArgs = {
  withDeleted?: InputMaybe<Scalars["Boolean"]>;
  withDeletedTraits?: InputMaybe<Array<TraitCode>>;
};

export type CollectionProductVariantTotalArgs = {
  code?: InputMaybe<Scalars["String"]>;
  withDeleted?: InputMaybe<Scalars["Boolean"]>;
};

export type CollectionProductVariantsArgs = {
  withDeleted?: InputMaybe<Scalars["Boolean"]>;
  withDeletedTraits?: InputMaybe<Array<TraitCode>>;
};

export type CollectionProductConnection = {
  __typename?: "CollectionProductConnection";
  edges: Array<CollectionProductEdge>;
  pageInfo: PageInfo;
};

export type CollectionProductEdge = {
  __typename?: "CollectionProductEdge";
  cursor: Scalars["String"];
  node: CollectionProduct;
};

export type CollectionProductGroupBy = {
  __typename?: "CollectionProductGroupBy";
  id?: Maybe<Scalars["ID"]>;
  name: Scalars["String"];
  value: Scalars["String"];
};

export enum CollectionProductGroupByField {
  Badge = "BADGE",
  Collgroup = "COLLGROUP",
  Dispcat = "DISPCAT",
  Division = "DIVISION",
  Fabname = "FABNAME",
  Silhouette = "SILHOUETTE",
  Styletag = "STYLETAG",
}

export type CollectionProductGroupByInput = {
  groupBy: CollectionProductGroupByField;
  subGroupById?: InputMaybe<Scalars["ID"]>;
};

export type CollectionProductGroupTotal = {
  __typename?: "CollectionProductGroupTotal";
  collection: Collection;
  groupId?: Maybe<Scalars["ID"]>;
  total: Scalars["Int"];
};

export type CollectionProductInput = {
  collectionId: Scalars["ID"];
  productId: Scalars["ID"];
  variantId?: InputMaybe<Scalars["ID"]>;
};

export enum CollectionProductOrder {
  Ascending = "ASCENDING",
  Descending = "DESCENDING",
}

export type CollectionProductOrderByField = {
  order?: InputMaybe<CollectionProductOrder>;
  orderByField?: InputMaybe<CollectionProductSortableField>;
};

export type CollectionProductOrderByInput = {
  field?: InputMaybe<CollectionProductOrderByField>;
  price?: InputMaybe<CollectionProductOrderByPrice>;
};

export type CollectionProductOrderByPrice = {
  order?: InputMaybe<CollectionProductOrder>;
  priceTypeId: Scalars["ID"];
};

export enum CollectionProductSortableField {
  ColorCode = "COLOR_CODE",
  ColorName = "COLOR_NAME",
  FabricationCode = "FABRICATION_CODE",
  FabricationName = "FABRICATION_NAME",
  ProductName = "PRODUCT_NAME",
  ProductNumber = "PRODUCT_NUMBER",
  SilhouetteCode = "SILHOUETTE_CODE",
  SilhouetteName = "SILHOUETTE_NAME",
}

export type CollectionSeasonInput = {
  code?: InputMaybe<Scalars["String"]>;
  name: Scalars["String"];
  year: Scalars["Int"];
};

export type CollectionSource = Node & {
  __typename?: "CollectionSource";
  id: Scalars["ID"];
  name: Scalars["String"];
};

export type CollectionTextBanner = CollectionBanner & {
  __typename?: "CollectionTextBanner";
  bannerType: BannerType;
  content?: Maybe<Scalars["String"]>;
  id: Scalars["ID"];
  orderNbr: Scalars["Int"];
  presentation?: Maybe<Scalars["String"]>;
};

export type CollectionTextStyle = Node & {
  __typename?: "CollectionTextStyle";
  id: Scalars["ID"];
  name: Scalars["String"];
  orderNbr: Scalars["Int"];
  size: Scalars["String"];
  typeface: Scalars["String"];
  weight: Scalars["String"];
};

export type CollectionTextStyleInput = {
  id?: InputMaybe<Scalars["ID"]>;
  name: Scalars["String"];
  orderNbr: Scalars["Int"];
  size: Scalars["String"];
  typeface: Scalars["String"];
  weight: Scalars["String"];
};

export type CollectionVideoBanner = CollectionBanner & {
  __typename?: "CollectionVideoBanner";
  bannerType: BannerType;
  id: Scalars["ID"];
  orderNbr: Scalars["Int"];
  presentation?: Maybe<Scalars["String"]>;
  videoId?: Maybe<Scalars["ID"]>;
  videoUrl?: Maybe<Scalars["String"]>;
};

export enum CollectionVisibility {
  AllConnections = "ALL_CONNECTIONS",
  Owner = "OWNER",
  OwnerAllConnections = "OWNER_ALL_CONNECTIONS",
  OwnerPublic = "OWNER_PUBLIC",
  Public = "PUBLIC",
  SelectedConnections = "SELECTED_CONNECTIONS",
}

export type CollectionsFilter = {
  archived?: InputMaybe<Scalars["Boolean"]>;
  collectionIds?: InputMaybe<Array<Scalars["ID"]>>;
  createdEndDate?: InputMaybe<Scalars["Date"]>;
  createdStartDate?: InputMaybe<Scalars["Date"]>;
  includeArchived?: InputMaybe<Scalars["Boolean"]>;
  ipadEnabled?: InputMaybe<Scalars["Boolean"]>;
  isCustom?: InputMaybe<Scalars["Boolean"]>;
  limitByProfileSettingsMax?: InputMaybe<Scalars["Boolean"]>;
  priceTypeIds?: InputMaybe<Array<Scalars["ID"]>>;
  searchText?: InputMaybe<Scalars["String"]>;
  seasonIds?: InputMaybe<Array<Scalars["ID"]>>;
  sharedWith?: InputMaybe<Array<Scalars["String"]>>;
  visibleForRetailerId?: InputMaybe<Scalars["ID"]>;
  visibleToAllMatches?: InputMaybe<Scalars["Boolean"]>;
};

export type CollectionsOrderBy = {
  field?: InputMaybe<CollectionOrderByField>;
};

export type Color = Node & {
  __typename?: "Color";
  /** Attribute options applied to this color */
  attributeOptions: AttributeOptionConnection;
  /** A unique identifier */
  code: Scalars["String"];
  /** A user input comment */
  comment?: Maybe<Scalars["String"]>;
  id: Scalars["ID"];
  /** Images of the unit with this color */
  images: ImageConnection;
  /** A display name */
  name: Scalars["String"];
  /** Swatch that represents this color */
  swatch: ColorSwatch;
};

export type ColorSwatch = {
  __typename?: "ColorSwatch";
  hex?: Maybe<Scalars["String"]>;
  image?: Maybe<ImageEdge>;
  rgb?: Maybe<Rgb>;
};

export type CommentAccountUserTag = Node & {
  __typename?: "CommentAccountUserTag";
  accountName: Scalars["String"];
  displayName: Scalars["String"];
  id: Scalars["ID"];
  userEmail: Scalars["String"];
  userName: Scalars["String"];
};

export type CommentAccountUserTagConnection = {
  __typename?: "CommentAccountUserTagConnection";
  edges: Array<CommentAccountUserTagEdge>;
  pageInfo: PageInfo;
};

export type CommentAccountUserTagEdge = {
  __typename?: "CommentAccountUserTagEdge";
  cursor: Scalars["String"];
  node: CommentAccountUserTag;
};

export type Configuration = {
  __typename?: "Configuration";
  accountId: Scalars["ID"];
  created?: Maybe<Scalars["Date"]>;
  data: Scalars["String"];
  default?: Maybe<Scalars["Boolean"]>;
  id: Scalars["ID"];
  name?: Maybe<Scalars["String"]>;
  projectName?: Maybe<Scalars["String"]>;
  sharedUserIds?: Maybe<Array<Scalars["ID"]>>;
  userId: Scalars["ID"];
  visibility: ConfigurationVisibility;
};

export type ConfigurationInput = {
  accountId: Scalars["ID"];
  data: Scalars["String"];
  default?: InputMaybe<Scalars["Boolean"]>;
  name: Scalars["String"];
  projectName: Scalars["String"];
  sharedUserIds?: InputMaybe<Array<Scalars["ID"]>>;
  userId: Scalars["ID"];
  visibility: ConfigurationVisibility;
};

export enum ConfigurationVisibility {
  Account = "ACCOUNT",
  All = "ALL",
  User = "USER",
}

export type ConnectPaymentProviderInput = {
  accountId: Scalars["ID"];
  authorizationCode: Scalars["String"];
  hmacSecret?: InputMaybe<Scalars["String"]>;
  merchantId?: InputMaybe<Scalars["String"]>;
  password?: InputMaybe<Scalars["String"]>;
  paymentProvider: Scalars["String"];
  username?: InputMaybe<Scalars["String"]>;
};

export type ConnectedAccountsFilter = {
  connectedAccountIds?: InputMaybe<Array<Scalars["ID"]>>;
};

export type ConnectionBuyer = {
  __typename?: "ConnectionBuyer";
  email?: Maybe<Scalars["String"]>;
  id: Scalars["ID"];
  name?: Maybe<Scalars["String"]>;
  retailerId: Scalars["ID"];
};

export type ConnectionBuyersPayload = {
  __typename?: "ConnectionBuyersPayload";
  connection_buyers: Array<ConnectionBuyer>;
  errors?: Maybe<Array<CustomerError>>;
};

export type ConnectionCurrency = {
  __typename?: "ConnectionCurrency";
  code?: Maybe<Scalars["String"]>;
  id: Scalars["ID"];
  name?: Maybe<Scalars["String"]>;
};

export type ConnectionDetails = {
  __typename?: "ConnectionDetails";
  hmacSecret: Scalars["String"];
  merchantId: Scalars["String"];
  password: Scalars["String"];
  username: Scalars["String"];
};

export type ConnectionDiscount = {
  __typename?: "ConnectionDiscount";
  amount?: Maybe<Scalars["String"]>;
  divisionId?: Maybe<Scalars["ID"]>;
  id: Scalars["ID"];
  level: DiscountLevel;
  retailerId: Scalars["ID"];
};

export type ConnectionDiscountsPayload = {
  __typename?: "ConnectionDiscountsPayload";
  connectionDiscounts: Array<ConnectionDiscount>;
  errors?: Maybe<Array<CustomerError>>;
};

export type ConnectionDoor = {
  __typename?: "ConnectionDoor";
  code?: Maybe<Scalars["String"]>;
  id: Scalars["ID"];
  name: Scalars["String"];
  retailerId: Scalars["ID"];
  shippingAddressId?: Maybe<Scalars["ID"]>;
};

export type ConnectionDoorInput = {
  code?: InputMaybe<Scalars["String"]>;
  id: Scalars["ID"];
  name: Scalars["String"];
  retailerId: Scalars["ID"];
  shippingAddressId?: InputMaybe<Scalars["ID"]>;
};

export type ConnectionPaymentMethod = {
  __typename?: "ConnectionPaymentMethod";
  isDefault: Scalars["Boolean"];
  paymentMethodId: Scalars["ID"];
  retailerId: Scalars["ID"];
};

export type ConnectionPaymentMethodInput = {
  isDefault?: InputMaybe<Scalars["Boolean"]>;
  paymentMethodId: Scalars["ID"];
  retailerId: Scalars["ID"];
};

export type ConnectionPriceType = {
  __typename?: "ConnectionPriceType";
  id: Scalars["ID"];
  priceTypeId: Scalars["ID"];
  retailerId: Scalars["ID"];
  termsConditionId?: Maybe<Scalars["ID"]>;
};

export type ConnectionPriceTypeResponse = {
  __typename?: "ConnectionPriceTypeResponse";
  id: Scalars["ID"];
  priceType: BrandPriceType;
  retailerId: Scalars["ID"];
  termsCondition?: Maybe<TermsAndCondition>;
};

export type ConnectionPriceTypesPayload = {
  __typename?: "ConnectionPriceTypesPayload";
  connectionPriceTypes: Array<ConnectionPriceTypeResponse>;
  errors?: Maybe<Array<CustomerError>>;
};

export type ConnectionSalesRep = {
  __typename?: "ConnectionSalesRep";
  divisionId?: Maybe<Scalars["ID"]>;
  id: Scalars["ID"];
  retailerId: Scalars["ID"];
  userId?: Maybe<Scalars["ID"]>;
};

export type ConnectionSalesRepsPayload = {
  __typename?: "ConnectionSalesRepsPayload";
  connectionSalesReps: Array<ConnectionSalesRep>;
  errors?: Maybe<Array<CustomerError>>;
};

export type ConnectionShippingMethod = {
  __typename?: "ConnectionShippingMethod";
  isDefault: Scalars["Boolean"];
  retailerId: Scalars["ID"];
  shippingMethodId: Scalars["ID"];
};

export type ConnectionShippingMethodInput = {
  isDefault?: InputMaybe<Scalars["Boolean"]>;
  retailerId: Scalars["ID"];
  shippingMethodId: Scalars["ID"];
};

export type ConnectionWarehouse = {
  __typename?: "ConnectionWarehouse";
  isDefault: Scalars["Boolean"];
  retailerId: Scalars["ID"];
  warehouseId: Scalars["ID"];
};

export type ConnectionWarehouseInput = {
  isDefault?: InputMaybe<Scalars["Boolean"]>;
  retailerId: Scalars["ID"];
  warehouseId: Scalars["ID"];
};

export type CopyAssortmentsInput = {
  /** Ids of the assortments to copy */
  ids: Array<Scalars["ID"]>;
};

export type CopyAssortmentsPayload = {
  __typename?: "CopyAssortmentsPayload";
  assortments: Array<AssortmentSummary>;
};

export type CountryCurrency = {
  __typename?: "CountryCurrency";
  countryCode: Scalars["String"];
  countryName: Scalars["String"];
  currencyCode: Scalars["String"];
};

/** Creates an assortment for a given collection. */
export type CreateAssortmentInput = {
  /** The name of the assortment that is being created */
  assortmentName?: InputMaybe<Scalars["String"]>;
  /** Collection that we're making this assortment for. Also known as 'linesheet' */
  collectionId?: InputMaybe<Scalars["ID"]>;
  /** The retail currency of the assortment */
  retailCurrencyId?: InputMaybe<Scalars["ID"]>;
  /** Retailer account that we're making this assortment for */
  retailerId: Scalars["ID"];
  /** The retail season that the created assortment will be associated with */
  seasonId?: InputMaybe<Scalars["ID"]>;
  /** The wholesale currency of the assortment */
  wholesaleCurrencyId?: InputMaybe<Scalars["ID"]>;
  /** The Retail Workspace Id that created assortment will be associated with */
  workspaceId?: InputMaybe<Scalars["ID"]>;
};

export type CreateAssortmentPayload = {
  __typename?: "CreateAssortmentPayload";
  assortment?: Maybe<Assortment>;
};

export type CreateAssortmentWithColorsInput = {
  assortmentName: Scalars["String"];
  collectionId: Scalars["ID"];
  colorIds: Array<Scalars["ID"]>;
  priceTypeId: Scalars["ID"];
  retailCurrencyId: Scalars["ID"];
  retailerId: Scalars["ID"];
  seasonId: Scalars["ID"];
  wholesaleCurrencyId: Scalars["ID"];
};

export type CreateAssortmentsExportRecordInput = {
  assortmentId: Scalars["ID"];
  success: Scalars["Boolean"];
};

export type CreateAssortmentsExportRecordPayload = {
  __typename?: "CreateAssortmentsExportRecordPayload";
  assortmentId: Scalars["ID"];
};

/** Creates a new attribute */
export type CreateAttributeInput = {
  /** A unique identifier */
  code: Scalars["String"];
  /** If true allows more than one option to be selected for this attribute */
  isMultiSelect: Scalars["Boolean"];
  /** If true requires an option to be selected for this attribute */
  isRequired: Scalars["Boolean"];
  /** A display name */
  name: Scalars["String"];
  /** Parent attribute */
  parentId?: InputMaybe<Scalars["ID"]>;
  /** Defines display order */
  position: Scalars["Int"];
  /** The ID of the retailer for which to create this attribute */
  retailerId: Scalars["ID"];
  /** Determines an attributes applicable objects */
  type: AttributeType;
};

/** Creates a new attribute option */
export type CreateAttributeOptionInput = {
  /** The Attribute that this option belongs to */
  attributeId: Scalars["ID"];
  /** A unique identifier */
  code: Scalars["String"];
  /** The value of the option */
  value: Scalars["String"];
};

export type CreateAttributeOptionPayload = {
  __typename?: "CreateAttributeOptionPayload";
  attributeOption?: Maybe<AttributeOption>;
  errors?: Maybe<Array<Error>>;
};

/** Creates the attribute option rules for a price modifier */
export type CreateAttributeOptionRuleForPriceModifierInput = {
  /** Values for the updated rules */
  attributeOptionIds: Array<Scalars["ID"]>;
  /** The factor to apply for this rule */
  factor: Scalars["Decimal"];
  /** Id of the object to update */
  priceModifierGroupId: Scalars["ID"];
  /** The name to display for this rule */
  ruleName: Scalars["String"];
};

export type CreateAttributeOptionRuleForPriceModifierPayload = {
  __typename?: "CreateAttributeOptionRuleForPriceModifierPayload";
  priceModifierRule: PriceModifierRule;
};

export type CreateAttributePayload = {
  __typename?: "CreateAttributePayload";
  attribute?: Maybe<Attribute>;
  errors?: Maybe<Array<Error>>;
};

export type CreateBrandDoorInput = {
  code?: InputMaybe<Scalars["String"]>;
  name: Scalars["String"];
  retailerAccountId: Scalars["ID"];
};

export type CreateBrandDoorPayload = {
  __typename?: "CreateBrandDoorPayload";
  brandDoorId: Scalars["ID"];
};

/** Creates the brand rules of a price modifier */
export type CreateBrandRuleForPriceModifierInput = {
  /** Value for the updated rule */
  brandId: Scalars["ID"];
  /** The factor to apply for this rule */
  factor: Scalars["Decimal"];
  /** Id of the object to update */
  priceModifierGroupId: Scalars["ID"];
  /** The name to display for this rule */
  ruleName: Scalars["String"];
};

export type CreateBrandRuleForPriceModifierPayload = {
  __typename?: "CreateBrandRuleForPriceModifierPayload";
  priceModifierRule: PriceModifierRule;
};

/** Updates budget details */
export type CreateBudgetInput = {
  /** Id of the Brand that filters this budget */
  brandId?: InputMaybe<Scalars["ID"]>;
  /** Currency that filters this budget */
  currencyCode: Scalars["String"];
  /** Id of the door that filters this budget */
  doorId?: InputMaybe<Scalars["ID"]>;
  /** A list of goals for this budget */
  goals?: InputMaybe<Array<SetBudgetGoalInput>>;
  /** Ids of the merchandising hierarchy leaf nodes that filter this budget */
  merchandisingHierarchyNodeIds?: InputMaybe<Array<Scalars["ID"]>>;
  /** Id of the Season that filters this budget */
  seasonId?: InputMaybe<Scalars["ID"]>;
};

export type CreateBudgetPayload = {
  __typename?: "CreateBudgetPayload";
  budget?: Maybe<Budget>;
  errors?: Maybe<Array<Error>>;
};

export type CreateCollaborationInvitePayload = {
  __typename?: "CreateCollaborationInvitePayload";
  collaborationInvite?: Maybe<CollaborationInvite>;
};

/** Creates a new collaboration invite for a given Account ID. */
export type CreateCollaborationInviteToAccountInput = {
  invitedAccountId: Scalars["ID"];
};

export type CreateCollectionBannerInput = {
  imageBanners?: InputMaybe<Array<CreateCollectionImageBannerInput>>;
  textBanners?: InputMaybe<Array<CreateCollectionTextBannerInput>>;
  videoBanners?: InputMaybe<Array<CreateCollectionVideoBannerInput>>;
};

export type CreateCollectionBannersInput = {
  banners: CreateCollectionBannerInput;
  collectionId: Scalars["ID"];
};

export type CreateCollectionBannersPayload = {
  __typename?: "CreateCollectionBannersPayload";
  imageBanners?: Maybe<Array<CollectionImageBanner>>;
  textBanners?: Maybe<Array<CollectionTextBanner>>;
  videoBanners?: Maybe<Array<CollectionVideoBanner>>;
};

export type CreateCollectionError = GenericError & {
  __typename?: "CreateCollectionError";
  code?: Maybe<GenericErrorCode>;
  details?: Maybe<CreateCollectionErrorDetail>;
  message: Scalars["String"];
};

export type CreateCollectionErrorDetail = {
  __typename?: "CreateCollectionErrorDetail";
  archived?: Maybe<Scalars["Boolean"]>;
  brandId: Scalars["ID"];
  code?: Maybe<Scalars["String"]>;
  ignores_inventory?: Maybe<Scalars["Boolean"]>;
  name: Scalars["String"];
  seasonId: Scalars["ID"];
};

export type CreateCollectionGroupInput = {
  header: Scalars["String"];
  orderNbr: Scalars["Int"];
};

export type CreateCollectionGroupsInput = {
  collectionGroups: Array<CreateCollectionGroupInput>;
  collectionId: Scalars["ID"];
};

export type CreateCollectionImageBannerInput = {
  imageId?: InputMaybe<Scalars["ID"]>;
  imageUrl?: InputMaybe<Scalars["String"]>;
  orderNbr: Scalars["Int"];
  presentation?: InputMaybe<Scalars["String"]>;
};

export type CreateCollectionInput = {
  archived?: InputMaybe<Scalars["Boolean"]>;
  code?: InputMaybe<Scalars["String"]>;
  completeShipDate?: InputMaybe<Scalars["Date"]>;
  cutoffDate?: InputMaybe<Scalars["Date"]>;
  description?: InputMaybe<Scalars["String"]>;
  ignores_inventory?: InputMaybe<Scalars["Boolean"]>;
  madeToOrder?: InputMaybe<Scalars["Boolean"]>;
  minimumShippingWindow?: InputMaybe<Scalars["Int"]>;
  name: Scalars["String"];
  season?: InputMaybe<CollectionSeasonInput>;
  seasonId?: InputMaybe<Scalars["ID"]>;
  startShipDate?: InputMaybe<Scalars["Date"]>;
  visibleToAllMatches?: InputMaybe<Scalars["Boolean"]>;
};

export type CreateCollectionTextBannerInput = {
  content: Scalars["String"];
  orderNbr: Scalars["Int"];
  presentation?: InputMaybe<Scalars["String"]>;
};

export type CreateCollectionVideoBannerInput = {
  orderNbr: Scalars["Int"];
  presentation?: InputMaybe<Scalars["String"]>;
  videoId?: InputMaybe<Scalars["ID"]>;
  videoUrl?: InputMaybe<Scalars["String"]>;
};

export type CreateConfigurationInput = {
  configuration: ConfigurationInput;
};

export type CreateConnectionBuyerInput = {
  email?: InputMaybe<Scalars["String"]>;
  name?: InputMaybe<Scalars["String"]>;
  retailerId: Scalars["ID"];
};

export type CreateConnectionDiscountInput = {
  amount?: InputMaybe<Scalars["String"]>;
  divisionId?: InputMaybe<Scalars["ID"]>;
  level: DiscountLevel;
  retailerId: Scalars["ID"];
};

export type CreateConnectionPriceTypeInput = {
  priceTypeId: Scalars["ID"];
  retailerId: Scalars["ID"];
  termsConditionId?: InputMaybe<Scalars["ID"]>;
};

export type CreateConnectionSalesRepInput = {
  divisionId?: InputMaybe<Scalars["ID"]>;
  retailerId: Scalars["ID"];
  userId: Scalars["ID"];
};

export type CreateCustomAssortmentInput = {
  assortmentName?: InputMaybe<Scalars["String"]>;
  retailCurrencyId: Scalars["ID"];
  retailerId: Scalars["ID"];
  wholesaleCurrencyId: Scalars["ID"];
};

export type CreateDataPermissionConfigurationInput = {
  configuration: PermissionConfigurationInput;
  name: Scalars["String"];
};

export type CreateDataPermissionConfigurationPayload = {
  __typename?: "CreateDataPermissionConfigurationPayload";
  dataPermissionConfiguration: DataPermissionConfiguration;
};

/** Creates a new door */
export type CreateDoorInput = {
  /** A unique identifier */
  code: Scalars["String"];
  /** A display name */
  name: Scalars["String"];
};

export type CreateDoorPayload = {
  __typename?: "CreateDoorPayload";
  door?: Maybe<Door>;
  errors?: Maybe<Array<Error>>;
};

export type CreateEventInput = {
  code: Scalars["String"];
  name: Scalars["String"];
};

export type CreateExportIntegrationConfigInput = {
  autoStatus: Array<Scalars["Int"]>;
  columnConfig: Scalars["String"];
  combineExportsIntoSingleFile?: InputMaybe<Scalars["Boolean"]>;
  convertImagesUrlsToColumns?: InputMaybe<Scalars["Boolean"]>;
  convertSingleDoorToCluster?: InputMaybe<Scalars["Boolean"]>;
  csvDelimiter?: InputMaybe<CsvDelimiterType>;
  csvEncodingType?: InputMaybe<ExportCsvEncodingType>;
  defaultClusterDoors?: InputMaybe<Array<Scalars["String"]>>;
  doorQuantityColumn?: InputMaybe<Scalars["Boolean"]>;
  excludeSkusWithZeroQuantities?: InputMaybe<Scalars["Boolean"]>;
  fileExtension: ExportFileExtensionType;
  fileName?: InputMaybe<Scalars["String"]>;
  fileNameDelimiter?: InputMaybe<Scalars["String"]>;
  fileNameParts: Array<ExportFileNameParts>;
  fileNamePrefix?: InputMaybe<Scalars["String"]>;
  ftpPath?: InputMaybe<Scalars["String"]>;
  isActive?: InputMaybe<Scalars["Boolean"]>;
  isGlobal?: InputMaybe<Scalars["Boolean"]>;
  level: ExportLevel;
  name: Scalars["String"];
  onlySkuQuantities?: InputMaybe<Scalars["Boolean"]>;
  overwrittenFileExtension?: InputMaybe<Scalars["String"]>;
  removeHeader?: InputMaybe<Scalars["Boolean"]>;
  textQualifier?: InputMaybe<Scalars["String"]>;
  type: ExportType;
  unzipFilesToFTPPath?: InputMaybe<Scalars["Boolean"]>;
};

export type CreateExternalPaymentInput = {
  amount: Scalars["Float"];
  attachments: Array<AttachmentInput>;
  billingAddress: Scalars["String"];
  billingCity: Scalars["String"];
  billingCountry: Scalars["String"];
  billingPostalCode: Scalars["String"];
  billingState: Scalars["String"];
  brandContactEmail: Scalars["EmailAddress"];
  brandContactName: Scalars["String"];
  brandId: Scalars["ID"];
  brandName: Scalars["String"];
  currency: Scalars["String"];
  dueDate?: InputMaybe<Scalars["Date"]>;
  notes?: InputMaybe<Scalars["String"]>;
  paymentId: Scalars["String"];
  retailerEmails: Array<Scalars["EmailAddress"]>;
  retailerId?: InputMaybe<Scalars["ID"]>;
  retailerName: Scalars["String"];
};

export type CreateExternalProviderAuthInput = {
  apiKey: Scalars["String"];
  provider: Scalars["String"];
};

export type CreateHubInput = {
  name: Scalars["String"];
  number?: InputMaybe<Scalars["String"]>;
  retailerId: Scalars["ID"];
};

export type CreateIdentityProviderInput = {
  domain: Scalars["String"];
  sigCert: Scalars["String"];
  ssoLoginUrl: Scalars["String"];
};

export type CreateIdentityProviderPayload = {
  __typename?: "CreateIdentityProviderPayload";
  errors?: Maybe<Array<Scalars["String"]>>;
  idpConfig?: Maybe<IdpConfig>;
  success: Scalars["Boolean"];
};

export type CreateInProgressOrdersWithUnitsInput = {
  /** Billing info for the order */
  billingInfo?: InputMaybe<BillingInfo>;
  /** To pass bulk quantities to be added to the created order */
  bulkQuantities?: InputMaybe<Array<InputMaybe<BulkQuantity>>>;
  buyer?: InputMaybe<BuyerInput>;
  /** To pass casepack quantities to be added to the created order */
  casepackQuantities?: InputMaybe<Array<InputMaybe<CasepackQuantity>>>;
  /** Context to create orders */
  orderInfo: OrderInfo;
  /** Shipping info for the order */
  shippingInfo?: InputMaybe<ShippingInfo>;
  /** To add comments to skus on the created order */
  skuComments?: InputMaybe<Array<InputMaybe<SkuComment>>>;
  /** To pass SKU quantities to be added to the created order */
  skuQuantities?: InputMaybe<Array<InputMaybe<SkuQuantity>>>;
};

export type CreateInProgressOrdersWithUnitsPayload = {
  __typename?: "CreateInProgressOrdersWithUnitsPayload";
  createdOrderIds?: Maybe<Array<Maybe<Scalars["ID"]>>>;
};

export type CreateInvoicesInput = {
  amount?: InputMaybe<Scalars["String"]>;
  currency?: InputMaybe<Scalars["String"]>;
  dueDate?: InputMaybe<Scalars["Date"]>;
  isPartialPaymentRequest?: InputMaybe<Scalars["Boolean"]>;
  name?: InputMaybe<Scalars["String"]>;
  orderIds: Array<Scalars["ID"]>;
  retailerId: Scalars["ID"];
};

export type CreateManualPaymentRecordInput = {
  amount: Scalars["Float"];
  brandId: Scalars["ID"];
  currency: Scalars["String"];
  notes?: InputMaybe<Scalars["String"]>;
  orderId: Scalars["ID"];
  paymentDate: Scalars["Date"];
  paymentMethod: ManualPaymentMethod;
  recordedBy?: InputMaybe<Scalars["String"]>;
  referenceNumber?: InputMaybe<Scalars["String"]>;
  retailerId: Scalars["ID"];
};

/** Creates a new merchandising hierarchy node */
export type CreateMerchandisingHierarchyNodeInput = {
  /** A unique identifier */
  code: Scalars["String"];
  /** The merchandising hierarchy level */
  levelId: Scalars["ID"];
  /** A display name */
  name: Scalars["String"];
  /** The ID of the parent merchandising hierarchy node */
  parentId?: InputMaybe<Scalars["ID"]>;
};

export type CreateMerchandisingHierarchyNodePayload = {
  __typename?: "CreateMerchandisingHierarchyNodePayload";
  errors?: Maybe<Array<Error>>;
  merchandisingHierarchyNode?: Maybe<MerchandisingHierarchyNode>;
};

/** Creates the merchandising hierarchy rules for a price modifier */
export type CreateMerchandisingHierarchyRuleForPriceModifierInput = {
  /** The factor to apply for this rule */
  factor: Scalars["Decimal"];
  /** Values for the updated rules */
  merchandisingHierarchyNodeId: Scalars["ID"];
  /** Id of the object to update */
  priceModifierGroupId: Scalars["ID"];
  /** The name to display for this rule */
  ruleName: Scalars["String"];
};

export type CreateMerchandisingHierarchyRuleForPriceModifierPayload = {
  __typename?: "CreateMerchandisingHierarchyRuleForPriceModifierPayload";
  priceModifierRule: PriceModifierRule;
};

/** Creates a message given sender and recipient account ids, subject, and body. */
export type CreateMessageInput = {
  attachment?: InputMaybe<Scalars["Upload"]>;
  body: Scalars["String"];
  messageType: MessageType;
  recipientAccountId: Scalars["ID"];
  senderAccountId: Scalars["ID"];
  subject: Scalars["String"];
};

/** Creates new workspace with blank assortment */
export type CreateNewRetailWorkspaceInput = {
  /** Name of the initial assortment in the new retail workspace */
  assortmentName: Scalars["String"];
  /** The retailer account id */
  retailerId: Scalars["String"];
  /** Season to assign to the initial assortment */
  seasonId: Scalars["ID"];
  /** Name of the new retail workspace */
  workspaceName: Scalars["String"];
};

export type CreateOrderFromAssortmentInput = {
  assortmentId: Scalars["ID"];
  brandSalesRepresentativeEmail: Scalars["String"];
  ccSenderOnEmail?: InputMaybe<Scalars["Boolean"]>;
  customMessage?: InputMaybe<Scalars["String"]>;
};

export type CreateOrderFromAssortmentPayload = {
  __typename?: "CreateOrderFromAssortmentPayload";
  assortment: Assortment;
  query?: Maybe<Query>;
};

export type CreateOrphanInProgressOrdersWithUnitsInput = {
  /** Billing info for the order */
  billingInfo?: InputMaybe<OrphanBillingInfo>;
  /** To pass bulk quantities to be added to the created order */
  bulkQuantities?: InputMaybe<Array<BulkQuantity>>;
  buyer?: InputMaybe<BuyerInput>;
  /** To pass casepack quantities to be added to the created order */
  casepackQuantities?: InputMaybe<Array<CasepackQuantity>>;
  /** Context to create orders */
  orderInfo: OrphanOrderInfo;
  /** Shipping info for the order */
  shippingInfo?: InputMaybe<OrphanShippingInfo>;
  /** To add comments to skus on the created order */
  skuComments?: InputMaybe<Array<SkuComment>>;
  /** To pass SKU quantities to be added to the created order */
  skuQuantities?: InputMaybe<Array<SkuQuantity>>;
};

export type CreateOrphanInProgressOrdersWithUnitsPayload = {
  __typename?: "CreateOrphanInProgressOrdersWithUnitsPayload";
  createdOrderIds?: Maybe<Array<Scalars["ID"]>>;
};

export type CreatePaymentWithPaymentMethodInput = {
  amount: Scalars["Float"];
  billingProfile?: InputMaybe<BillingProfile>;
  brandId: Scalars["ID"];
  callbackUrl?: InputMaybe<Scalars["String"]>;
  currency: Scalars["String"];
  externalPaymentId?: InputMaybe<Scalars["ID"]>;
  extraData?: InputMaybe<ExtraData>;
  invoiceCurrency?: InputMaybe<Scalars["String"]>;
  orderId?: InputMaybe<Scalars["ID"]>;
  paymentMethodId?: InputMaybe<Scalars["String"]>;
  paymentProvider: Scalars["String"];
  rateOfferId?: InputMaybe<Scalars["String"]>;
  retailerId?: InputMaybe<Scalars["ID"]>;
  taxAmount?: InputMaybe<Scalars["Float"]>;
  userId?: InputMaybe<Scalars["String"]>;
  viaAgent?: InputMaybe<Scalars["Boolean"]>;
};

export type CreateProductError = GenericError & {
  __typename?: "CreateProductError";
  code?: Maybe<GenericErrorCode>;
  details?: Maybe<CreateProductErrorDetail>;
  message: Scalars["String"];
};

export type CreateProductErrorDetail = {
  __typename?: "CreateProductErrorDetail";
  categoryIds?: Maybe<Array<Maybe<Scalars["ID"]>>>;
  description?: Maybe<Scalars["String"]>;
  externalIdentifier: Scalars["String"];
  name?: Maybe<Scalars["String"]>;
  orderMinimum?: Maybe<Scalars["Int"]>;
  productIdentifier?: Maybe<Scalars["String"]>;
};

export type CreateProductInput = {
  badgeIds?: InputMaybe<Array<Scalars["ID"]>>;
  brandId: Scalars["String"];
  categoryIds?: InputMaybe<Array<Scalars["ID"]>>;
  description?: InputMaybe<Scalars["String"]>;
  externalIdentifier?: InputMaybe<Scalars["String"]>;
  name: Scalars["String"];
  orderMinimum: Scalars["Int"];
  productIdentifier?: InputMaybe<Scalars["String"]>;
  tags?: InputMaybe<Array<TagInput>>;
};

export type CreateRawOrdersExportPayload = {
  __typename?: "CreateRawOrdersExportPayload";
  taskId: Scalars["ID"];
};

export type CreateReachPaymentPayload = {
  __typename?: "CreateReachPaymentPayload";
  errors?: Maybe<Array<Scalars["String"]>>;
  sessionId: Scalars["String"];
};

export type CreateRegionInput = {
  geographyIds: Array<Scalars["ID"]>;
  name: Scalars["String"];
};

/** Converts the assortment to retail workspace */
export type CreateRetailWorkspaceInput = {
  /** The assortments to convert to a retail workspace */
  assortmentIds?: InputMaybe<Array<Scalars["String"]>>;
  /** The name of the new retail workspace */
  name: Scalars["String"];
  /** The retailer account id */
  retailerId: Scalars["String"];
};

export type CreateSeasonError = GenericError & {
  __typename?: "CreateSeasonError";
  code?: Maybe<GenericErrorCode>;
  details?: Maybe<CreateSeasonErrorDetail>;
  message: Scalars["String"];
};

export type CreateSeasonErrorDetail = {
  __typename?: "CreateSeasonErrorDetail";
  /** A unique identifier */
  code: Scalars["String"];
  /** A display name */
  name: Scalars["String"];
  /** A calendar year */
  year: Scalars["Int"];
};

/** Creates a new season */
export type CreateSeasonInput = {
  /** A unique identifier */
  code: Scalars["String"];
  /** A display name */
  name: Scalars["String"];
  /** A calendar year */
  year: Scalars["Int"];
};

export type CreateSeasonPayload = {
  __typename?: "CreateSeasonPayload";
  errors?: Maybe<Array<CreateSeasonError>>;
  season?: Maybe<Season>;
};

export type CreateSkuPriceError = GenericError & {
  __typename?: "CreateSkuPriceError";
  code?: Maybe<GenericErrorCode>;
  details?: Maybe<CreateSkuPriceErrorDetail>;
  message: Scalars["String"];
};

export type CreateSkuPriceErrorDetail = {
  __typename?: "CreateSkuPriceErrorDetail";
  priceTypeId: Scalars["ID"];
  skuId: Scalars["ID"];
  suggestedRetailPrice?: Maybe<Scalars["Decimal"]>;
  wholesalePrice: Scalars["Decimal"];
};

export type CreateSkuPriceInput = {
  priceTypeId: Scalars["ID"];
  skuId: Scalars["ID"];
  suggestedRetailPrice?: InputMaybe<Scalars["Decimal"]>;
  wholesalePrice: Scalars["Decimal"];
};

export type CreateSkuTraitValueInput = {
  externalIdentifier?: InputMaybe<Scalars["String"]>;
  orderMinimum?: InputMaybe<Scalars["Int"]>;
  orderNbr?: InputMaybe<Scalars["Int"]>;
  productId: Scalars["ID"];
  skuTraitId: Scalars["ID"];
  status?: InputMaybe<SkuTraitValueStatus>;
  value: Scalars["String"];
};

/** Creates a user given an email and password. */
export type CreateUserInput = {
  /** The unique email of the new user */
  email: Scalars["String"];
  /** The password for the new user */
  password: Scalars["String"];
};

/** Creates a PENDING membership invite from the given user and account to given email */
export type CreateUserMembershipInviteInput = {
  invitedEmail: Scalars["String"];
  invitingAccountId: Scalars["ID"];
  invitingUserId: Scalars["ID"];
};

/** Creates a pending request for membership by the given user to the given account */
export type CreateUserMembershipRequestInput = {
  accountId: Scalars["ID"];
  userId: Scalars["ID"];
};

export type CreateUserMembershipRequestInputForBulk = {
  accountId: Scalars["ID"];
  userId: Scalars["ID"];
};

/** Returns either the user created or an error. */
export type CreateUserPayload = {
  __typename?: "CreateUserPayload";
  error?: Maybe<Error>;
  user?: Maybe<User>;
};

export type CreditCard = PaymentMethodI & {
  __typename?: "CreditCard";
  billingEmail: Scalars["String"];
  billingName: Scalars["String"];
  brand: Scalars["String"];
  expMonth?: Maybe<Scalars["Int"]>;
  expYear?: Maybe<Scalars["Int"]>;
  last4: Scalars["String"];
  paymentMethodId: Scalars["String"];
  type: Scalars["String"];
};

export enum CsvDelimiterType {
  Asterisk = "ASTERISK",
  Backtick = "BACKTICK",
  Colon = "COLON",
  Comma = "COMMA",
  Dash = "DASH",
  Hash = "HASH",
  Pipe = "PIPE",
  Semicolon = "SEMICOLON",
  Space = "SPACE",
  Tab = "TAB",
}

export type Currency = Node & {
  __typename?: "Currency";
  code: Scalars["String"];
  decimal_separator?: Maybe<Scalars["String"]>;
  decimals: Scalars["Int"];
  id: Scalars["ID"];
  name: Scalars["String"];
  symbol: Scalars["String"];
  thousands_separator?: Maybe<Scalars["String"]>;
};

export enum CurrencyCode {
  Aed = "AED",
  Afn = "AFN",
  All = "ALL",
  Amd = "AMD",
  Aoa = "AOA",
  Ars = "ARS",
  Aud = "AUD",
  Awg = "AWG",
  Azn = "AZN",
  Bam = "BAM",
  Bbd = "BBD",
  Bdt = "BDT",
  Bgn = "BGN",
  Bhd = "BHD",
  Bif = "BIF",
  Bmd = "BMD",
  Bnd = "BND",
  Bob = "BOB",
  Bov = "BOV",
  Brl = "BRL",
  Bsd = "BSD",
  Btn = "BTN",
  Bwp = "BWP",
  Byn = "BYN",
  Bzd = "BZD",
  Cad = "CAD",
  Cdf = "CDF",
  Che = "CHE",
  Chf = "CHF",
  Chw = "CHW",
  Clf = "CLF",
  Clp = "CLP",
  Cny = "CNY",
  Cop = "COP",
  Cou = "COU",
  Crc = "CRC",
  Cuc = "CUC",
  Cup = "CUP",
  Cve = "CVE",
  Czk = "CZK",
  Djf = "DJF",
  Dkk = "DKK",
  Dop = "DOP",
  Dzd = "DZD",
  Egp = "EGP",
  Ern = "ERN",
  Etb = "ETB",
  Eur = "EUR",
  Fjd = "FJD",
  Fkp = "FKP",
  Gbp = "GBP",
  Gel = "GEL",
  Ghs = "GHS",
  Gip = "GIP",
  Gmd = "GMD",
  Gnf = "GNF",
  Gtq = "GTQ",
  Gyd = "GYD",
  Hkd = "HKD",
  Hnl = "HNL",
  Hrk = "HRK",
  Htg = "HTG",
  Huf = "HUF",
  Idr = "IDR",
  Ils = "ILS",
  Inr = "INR",
  Iqd = "IQD",
  Irr = "IRR",
  Isk = "ISK",
  Jmd = "JMD",
  Jod = "JOD",
  Jpy = "JPY",
  Kes = "KES",
  Kgs = "KGS",
  Khr = "KHR",
  Kmf = "KMF",
  Kpw = "KPW",
  Krw = "KRW",
  Kwd = "KWD",
  Kyd = "KYD",
  Kzt = "KZT",
  Lak = "LAK",
  Lbp = "LBP",
  Lkr = "LKR",
  Lrd = "LRD",
  Lsl = "LSL",
  Ltl = "LTL",
  Lvl = "LVL",
  Lyd = "LYD",
  Mad = "MAD",
  Mdl = "MDL",
  Mga = "MGA",
  Mkd = "MKD",
  Mmk = "MMK",
  Mnt = "MNT",
  Mop = "MOP",
  Mru = "MRU",
  Mur = "MUR",
  Mvr = "MVR",
  Mwk = "MWK",
  Mxn = "MXN",
  Mxv = "MXV",
  Myr = "MYR",
  Mzn = "MZN",
  Nad = "NAD",
  Ngn = "NGN",
  Nio = "NIO",
  Nok = "NOK",
  Npr = "NPR",
  Nzd = "NZD",
  Omr = "OMR",
  Pab = "PAB",
  Pen = "PEN",
  Pgk = "PGK",
  Php = "PHP",
  Pkr = "PKR",
  Pln = "PLN",
  Pyg = "PYG",
  Qar = "QAR",
  Ron = "RON",
  Rsd = "RSD",
  Rub = "RUB",
  Rwf = "RWF",
  Sar = "SAR",
  Sbd = "SBD",
  Scr = "SCR",
  Sdg = "SDG",
  Sek = "SEK",
  Sgd = "SGD",
  Shp = "SHP",
  Sll = "SLL",
  Sos = "SOS",
  Srd = "SRD",
  Ssp = "SSP",
  Stn = "STN",
  Svc = "SVC",
  Syp = "SYP",
  Szl = "SZL",
  Thb = "THB",
  Tjs = "TJS",
  Tmt = "TMT",
  Tnd = "TND",
  Top = "TOP",
  Try = "TRY",
  Ttd = "TTD",
  Twd = "TWD",
  Tzs = "TZS",
  Uah = "UAH",
  Ugx = "UGX",
  Usd = "USD",
  Usn = "USN",
  Uss = "USS",
  Uyi = "UYI",
  Uyu = "UYU",
  Uzs = "UZS",
  Ves = "VES",
  Vnd = "VND",
  Vuv = "VUV",
  Wst = "WST",
  Yer = "YER",
  Zar = "ZAR",
  Zmw = "ZMW",
  Zwl = "ZWL",
}

export type CurrencyConnection = {
  __typename?: "CurrencyConnection";
  edges?: Maybe<Array<CurrencyEdge>>;
};

/** A conversion between two currencies. */
export type CurrencyConversion = {
  __typename?: "CurrencyConversion";
  /** Multiplicative conversion rate applied */
  factor: Scalars["Decimal"];
  /** Initial currency */
  fromCurrencyCode: Scalars["String"];
  /** Final currency */
  toCurrencyCode: Scalars["String"];
};

export type CurrencyEdge = {
  __typename?: "CurrencyEdge";
  node?: Maybe<Currency>;
};

export enum CurrencyFilter {
  AssortmentCurrency = "ASSORTMENT_CURRENCY",
  LinesheetCurrency = "LINESHEET_CURRENCY",
  LinesheetRetailCurrency = "LINESHEET_RETAIL_CURRENCY",
  LinesheetWholesaleCurrency = "LINESHEET_WHOLESALE_CURRENCY",
}

export type CurrencyFilterInput = {
  priceChangeCurrenciesOnly?: InputMaybe<Scalars["Boolean"]>;
};

export type CustomSizeRequest = {
  code?: InputMaybe<Scalars["String"]>;
  name: Scalars["String"];
};

export type CustomerCode = {
  __typename?: "CustomerCode";
  alias?: Maybe<Scalars["String"]>;
  code?: Maybe<Scalars["String"]>;
  id: Scalars["ID"];
};

export type CustomerError = {
  __typename?: "CustomerError";
  code?: Maybe<Scalars["String"]>;
  details?: Maybe<Scalars["String"]>;
  message?: Maybe<Scalars["String"]>;
};

export type CustomerPayload = {
  __typename?: "CustomerPayload";
  buyerName?: Maybe<Scalars["String"]>;
  code?: Maybe<Scalars["String"]>;
  id: Scalars["ID"];
  name?: Maybe<Scalars["String"]>;
};

export type CustomerRecordPaymentMethodError = {
  __typename?: "CustomerRecordPaymentMethodError";
  message?: Maybe<Scalars["String"]>;
};

export type CustomerWarehouse = {
  __typename?: "CustomerWarehouse";
  code?: Maybe<Scalars["String"]>;
  id: Scalars["ID"];
  isDefault: Scalars["Boolean"];
  name: Scalars["String"];
};

/**
 * DataPermissionConfiguration represents a grouping of permissions with unique names between accounts
 * this data permissions could be:
 * 1 - groups of divisions and categories that the users in the group are allowed to see
 * 2 - divisions that the users in the groups are allowed to see
 */
export type DataPermissionConfiguration = Node & {
  __typename?: "DataPermissionConfiguration";
  configuration?: Maybe<PermissionConfiguration>;
  id: Scalars["ID"];
  name: Scalars["String"];
};

export type DataPermissionConfigurationConnection = {
  __typename?: "DataPermissionConfigurationConnection";
  edges: Array<DataPermissionConfigurationEdge>;
};

export type DataPermissionConfigurationEdge = {
  __typename?: "DataPermissionConfigurationEdge";
  node: DataPermissionConfiguration;
};

export type DataPermissionConfigurationFilter = {
  ids?: InputMaybe<Array<Scalars["ID"]>>;
};

export enum DateFormat {
  DayFirst = "DAY_FIRST",
  MonthFirst = "MONTH_FIRST",
  YearFirst = "YEAR_FIRST",
}

export type DateRange = {
  endDate?: InputMaybe<Scalars["Date"]>;
  startDate?: InputMaybe<Scalars["Date"]>;
};

export type DeleteBulkLineItem = {
  orderId: Scalars["ID"];
  variantId: Scalars["ID"];
};

export type DeleteCasepackLineItem = {
  casepackId: Scalars["ID"];
  casepackName?: InputMaybe<Scalars["String"]>;
  orderId: Scalars["ID"];
};

export type DeleteCollectionBannerInput = {
  imageBannerIds?: InputMaybe<Array<Scalars["ID"]>>;
  textBannerIds?: InputMaybe<Array<Scalars["ID"]>>;
  videoBannerIds?: InputMaybe<Array<Scalars["ID"]>>;
};

export type DeleteCollectionBannersInput = {
  banners: DeleteCollectionBannerInput;
  collectionId: Scalars["ID"];
};

export type DeleteCollectionBannersPayload = {
  __typename?: "DeleteCollectionBannersPayload";
  imageBannerIds?: Maybe<Array<Scalars["ID"]>>;
  textBannerIds?: Maybe<Array<Scalars["ID"]>>;
  videoBannerIds?: Maybe<Array<Scalars["ID"]>>;
};

export type DeleteConfigurationInput = {
  id: Scalars["ID"];
};

export type DeleteConnectionBuyerInput = {
  id: Scalars["ID"];
};

export type DeleteConnectionDiscountInput = {
  id: Scalars["ID"];
};

export type DeleteConnectionDiscountsResponse = {
  __typename?: "DeleteConnectionDiscountsResponse";
  errors?: Maybe<Array<CustomerError>>;
  ids: Array<Scalars["ID"]>;
};

export type DeleteConnectionPriceTypeInput = {
  id: Scalars["ID"];
};

export type DeleteConnectionPriceTypesResponse = {
  __typename?: "DeleteConnectionPriceTypesResponse";
  errors?: Maybe<Array<CustomerError>>;
  ids: Array<Scalars["ID"]>;
};

export type DeleteConnectionSalesRepInput = {
  id: Scalars["ID"];
};

export type DeleteConnectionSalesRepsResponse = {
  __typename?: "DeleteConnectionSalesRepsResponse";
  errors?: Maybe<Array<CustomerError>>;
  ids: Array<Scalars["ID"]>;
};

export type DeleteExportIntegrationConfigsInput = {
  ids: Array<Scalars["String"]>;
};

export type DeleteExternalPaymentInput = {
  /** must be `ExternalPayment:<id>` encoded in base64 */
  id: Scalars["ID"];
};

export type DeleteExternalPaymentPayload = {
  __typename?: "DeleteExternalPaymentPayload";
  ok: Scalars["Boolean"];
};

export type DeleteFavoriteAccountInput = {
  brandAccountId: Scalars["ID"];
};

export type DeleteIdentityProviderInput = {
  domain: Scalars["String"];
};

export type DeleteIdentityProviderPayload = {
  __typename?: "DeleteIdentityProviderPayload";
  errors?: Maybe<Array<Scalars["String"]>>;
  success: Scalars["Boolean"];
};

export type DeleteManualPaymentRecordInput = {
  id: Scalars["ID"];
};

export type DeleteManualPaymentRecordPayload = {
  __typename?: "DeleteManualPaymentRecordPayload";
  ok: Scalars["Boolean"];
};

export type DeleteOrderLineItemsInput = {
  /** To pass bulk quantities to be deleted */
  bulkLineItems?: InputMaybe<Array<DeleteBulkLineItem>>;
  /** To pass casepack quantities to be deleted */
  casepackLineItems?: InputMaybe<Array<DeleteCasepackLineItem>>;
  /** To pass the order line item ids to be deleted */
  orderLineItemIds?: InputMaybe<Array<Scalars["ID"]>>;
  /** To pass SKU quantities to be deleted */
  skuLineItems?: InputMaybe<Array<DeleteSkuLineItem>>;
};

export type DeleteOrderLineItemsPayload = {
  __typename?: "DeleteOrderLineItemsPayload";
  success?: Maybe<Scalars["Boolean"]>;
};

export type DeleteOrderVariantsInput = {
  orderId: Scalars["ID"];
  variantIds: Array<Scalars["ID"]>;
};

export type DeleteOrderVariantsPayload = {
  __typename?: "DeleteOrderVariantsPayload";
  success?: Maybe<Scalars["Boolean"]>;
  updatedOrderId: Scalars["ID"];
};

export type DeletePayload = {
  __typename?: "DeletePayload";
  success?: Maybe<Scalars["Boolean"]>;
};

export type DeletePaymentMethodPayload = {
  __typename?: "DeletePaymentMethodPayload";
  ok: Scalars["Boolean"];
};

export type DeleteProductError = GenericError & {
  __typename?: "DeleteProductError";
  code?: Maybe<GenericErrorCode>;
  details?: Maybe<DeleteProductErrorDetail>;
  message: Scalars["String"];
};

export type DeleteProductErrorDetail = {
  __typename?: "DeleteProductErrorDetail";
  externalIdentifier?: Maybe<Scalars["String"]>;
  id?: Maybe<Scalars["ID"]>;
  productIdentifier?: Maybe<Scalars["String"]>;
};

export type DeleteProductInput = {
  externalIdentifier?: InputMaybe<Scalars["String"]>;
  id?: InputMaybe<Scalars["ID"]>;
  productIdentifier?: InputMaybe<Scalars["String"]>;
};

export type DeleteRegionInput = {
  id: Scalars["ID"];
};

export type DeleteShowroomCollectionPayload = {
  __typename?: "DeleteShowroomCollectionPayload";
  id: Scalars["ID"];
};

export type DeleteShowroomCollectionsInput = {
  ids: Array<Scalars["ID"]>;
};

export type DeleteSkuLineItem = {
  orderId: Scalars["ID"];
  skuId: Scalars["ID"];
};

export type DeleteStorefrontsPayload = {
  __typename?: "DeleteStorefrontsPayload";
  error?: Maybe<Scalars["String"]>;
  success: Scalars["Boolean"];
};

export type DeleteStyleboardPayload = {
  __typename?: "DeleteStyleboardPayload";
  id: Scalars["ID"];
};

export type DeleteStyleboardsInput = {
  ids: Array<Scalars["ID"]>;
};

export type DeleteUrl3dShowroomInput = {
  ids: Array<Scalars["ID"]>;
};

export type DeleteUrl3dShowroomPayload = {
  __typename?: "DeleteUrl3dShowroomPayload";
  ids: Array<Scalars["ID"]>;
};

export type Delivery = {
  __typename?: "Delivery";
  /** @deprecated Get from cutoffDate */
  cancelDate?: Maybe<Scalars["Date"]>;
  completeShipDate?: Maybe<Scalars["Date"]>;
  cutoffDate?: Maybe<Scalars["Date"]>;
  id: Scalars["ID"];
  minimumShippingWindow?: Maybe<Scalars["Int"]>;
  startShipDate?: Maybe<Scalars["Date"]>;
};

export type Destination = {
  __typename?: "Destination";
  node?: Maybe<Door>;
};

export type Discount = Node & {
  __typename?: "Discount";
  brandId: Scalars["ID"];
  factor?: Maybe<Scalars["Decimal"]>;
  id: Scalars["ID"];
  retailerId: Scalars["ID"];
};

export type DiscountConnection = {
  __typename?: "DiscountConnection";
  edges: Array<Maybe<DiscountEdge>>;
};

export type DiscountEdge = {
  __typename?: "DiscountEdge";
  node?: Maybe<Discount>;
};

export enum DiscountLevel {
  LineItem = "LINE_ITEM",
  Order = "ORDER",
}

export enum DisplayFormatEnum {
  All = "ALL",
  Decimal = "DECIMAL",
  Percent = "PERCENT",
  Price = "PRICE",
}

export type Division = Node & {
  __typename?: "Division";
  code: Scalars["String"];
  id: Scalars["ID"];
  name: Scalars["String"];
};

export type DivisionCategory = {
  __typename?: "DivisionCategory";
  category: Category;
  division: Division;
};

export type DivisionCategoryInput = {
  categoryId: Scalars["ID"];
  divisionId: Scalars["ID"];
};

/** Doors represent physical locations or selling channels of your business. */
export type Door = Node & {
  __typename?: "Door";
  /** A unique identifier */
  code: Scalars["String"];
  id: Scalars["ID"];
  /** A display name */
  name: Scalars["String"];
};

/** DoorCluster represent a grouping of doors */
export type DoorCluster = Node & {
  __typename?: "DoorCluster";
  /** A unique identifier */
  code?: Maybe<Scalars["String"]>;
  /** The doors in the cluster */
  doors?: Maybe<DoorClusterDoorConnection>;
  id: Scalars["ID"];
  /** A display name */
  name?: Maybe<Scalars["String"]>;
};

export type DoorClusterDoorConnection = {
  __typename?: "DoorClusterDoorConnection";
  edges?: Maybe<Array<DoorClusterDoorEdge>>;
};

export type DoorClusterDoorEdge = {
  __typename?: "DoorClusterDoorEdge";
  node?: Maybe<Door>;
};

/**
 * Single door cluster input for creating or updating assortment clusters
 * If the id is provided, we update the cluster, if not we create a cluster.
 * Code and name are optional for both cases.
 */
export type DoorClusterInput = {
  code?: InputMaybe<Scalars["String"]>;
  doorIds: Array<Scalars["ID"]>;
  id?: InputMaybe<Scalars["ID"]>;
  name?: InputMaybe<Scalars["String"]>;
};

export type DoorColorsRequest = {
  colorId: Scalars["ID"];
  doorId: Scalars["ID"];
};

export type DoorConnection = {
  __typename?: "DoorConnection";
  edges?: Maybe<Array<DoorEdge>>;
};

export type DoorEdge = {
  __typename?: "DoorEdge";
  node?: Maybe<Door>;
};

export type DoorInputInfo = {
  code: Scalars["String"];
  id: Scalars["ID"];
  name: Scalars["String"];
};

/** Upserts a quantity for an assigned SKU-door line item */
export enum DoorOrCluster {
  Cluster = "CLUSTER",
  Door = "DOOR",
}

export type DoorPriceLevels = Node & {
  __typename?: "DoorPriceLevels";
  id: Scalars["ID"];
  node: Door;
  priceLevels: Array<PriceLevel>;
  quantity: Scalars["Int"];
  skuCount: Scalars["Int"];
};

export type DoorPriceLevelsPriceLevelsArgs = {
  filters?: InputMaybe<PriceLevelsFilter>;
};

export enum ElementType {
  About = "ABOUT",
  Collection = "COLLECTION",
  Image = "IMAGE",
  Instagram = "INSTAGRAM",
  Lookbook = "LOOKBOOK",
  Orb360 = "ORB360",
  Product = "PRODUCT",
  ShowroomBrand = "SHOWROOM_BRAND",
  ShowroomCollection = "SHOWROOM_COLLECTION",
  Text = "TEXT",
  Video = "VIDEO",
}

export type Error = {
  __typename?: "Error";
  code?: Maybe<ErrorCode>;
  field?: Maybe<Array<Scalars["String"]>>;
  message: Scalars["String"];
};

export enum ErrorCode {
  MaxPaymentAmountExceeded = "MAX_PAYMENT_AMOUNT_EXCEEDED",
  UnknownError = "UNKNOWN_ERROR",
}

export enum ErrorType {
  Account = "ACCOUNT",
  Collection = "COLLECTION",
  Door = "DOOR",
  Price = "PRICE",
  PriceType = "PRICE_TYPE",
  Product = "PRODUCT",
  ProductColor = "PRODUCT_COLOR",
  ProductSize = "PRODUCT_SIZE",
  Quantity = "QUANTITY",
  SkuIdentifier = "SKU_IDENTIFIER",
  Upc = "UPC",
}

export type Event = {
  __typename?: "Event";
  code?: Maybe<Scalars["String"]>;
  event?: Maybe<Scalars["String"]>;
};

export enum ExportCsvEncodingType {
  Ascii = "ASCII",
  Utf8 = "UTF8",
  Utf8Sig = "UTF8SIG",
  Win1252 = "WIN1252",
}

export enum ExportFileExtensionType {
  Csv = "CSV",
  Xls = "XLS",
  Xlsx = "XLSX",
}

export enum ExportFileNameParts {
  Date = "DATE",
  Datetime = "DATETIME",
  Designer = "DESIGNER",
  Id = "ID",
  SeasonCode = "SEASON_CODE",
  Time = "TIME",
  UnknownName = "UNKNOWN_NAME",
}

export type ExportIntegrationConfig = {
  __typename?: "ExportIntegrationConfig";
  accountId?: Maybe<Scalars["ID"]>;
  autoStatus: Array<Scalars["Int"]>;
  columnConfig: Scalars["String"];
  combineExportsIntoSingleFile?: Maybe<Scalars["Boolean"]>;
  convertImagesUrlsToColumns?: Maybe<Scalars["Boolean"]>;
  convertSingleDoorToCluster?: Maybe<Scalars["Boolean"]>;
  createdAt: Scalars["Date"];
  csvDelimiter?: Maybe<CsvDelimiterType>;
  csvEncodingType?: Maybe<ExportCsvEncodingType>;
  defaultClusterDoors?: Maybe<Array<Maybe<Scalars["String"]>>>;
  doorQuantityColumn?: Maybe<Scalars["Boolean"]>;
  excludeSkusWithZeroQuantities?: Maybe<Scalars["Boolean"]>;
  fileExtension?: Maybe<ExportFileExtensionType>;
  fileName: Scalars["String"];
  fileNameDelimiter?: Maybe<Scalars["String"]>;
  fileNameParts: Array<ExportFileNameParts>;
  fileNamePrefix?: Maybe<Scalars["String"]>;
  ftpPath?: Maybe<Scalars["String"]>;
  id: Scalars["ID"];
  isActive?: Maybe<Scalars["Boolean"]>;
  isGlobal?: Maybe<Scalars["Boolean"]>;
  level?: Maybe<ExportLevel>;
  name: Scalars["String"];
  onlySkuQuantities?: Maybe<Scalars["Boolean"]>;
  overwrittenFileExtension?: Maybe<Scalars["String"]>;
  removeHeader?: Maybe<Scalars["Boolean"]>;
  textQualifier: Scalars["String"];
  type?: Maybe<ExportType>;
  unzipFilesToFTPPath?: Maybe<Scalars["Boolean"]>;
  updatedAt: Scalars["Date"];
};

export enum ExportLevel {
  LineItem = "LINE_ITEM",
  Sku = "SKU",
  StyleColor = "STYLE_COLOR",
  TopLevel = "TOP_LEVEL",
}

export enum ExportType {
  AssortmentExport = "ASSORTMENT_EXPORT",
  OrderExport = "ORDER_EXPORT",
  OrderImport = "ORDER_IMPORT",
  ProductExport = "PRODUCT_EXPORT",
}

export type ExternalMedia = Node & {
  __typename?: "ExternalMedia";
  format: Scalars["String"];
  id: Scalars["ID"];
  payload: Scalars["String"];
  thumbnailUrl: Scalars["String"];
  type: Scalars["String"];
  url: Scalars["String"];
};

export type ExternalPayment = {
  __typename?: "ExternalPayment";
  amount: Scalars["Float"];
  attachments?: Maybe<Array<Attachment>>;
  billingAddress: Scalars["String"];
  billingCity: Scalars["String"];
  billingCountry: Scalars["String"];
  billingPostalCode: Scalars["String"];
  billingState: Scalars["String"];
  brandContactEmail: Scalars["EmailAddress"];
  brandContactName: Scalars["String"];
  brandId: Scalars["ID"];
  brandName: Scalars["String"];
  created?: Maybe<Scalars["Date"]>;
  currency: Scalars["String"];
  deletedAt?: Maybe<Scalars["Date"]>;
  dueDate?: Maybe<Scalars["Date"]>;
  id: Scalars["ID"];
  link: Scalars["String"];
  notes?: Maybe<Scalars["String"]>;
  paymentId: Scalars["String"];
  paymentProvider?: Maybe<ReachPaymentProvider>;
  paymentStatus: ExternalPaymentStatus;
  retailerEmails: Array<Scalars["EmailAddress"]>;
  retailerId?: Maybe<Scalars["ID"]>;
  retailerName: Scalars["String"];
  sent: Scalars["Boolean"];
  sentDate?: Maybe<Scalars["Date"]>;
};

export enum ExternalPaymentStatus {
  FullyPaid = "FULLY_PAID",
  NotPaid = "NOT_PAID",
  PartiallyPaid = "PARTIALLY_PAID",
}

export type ExternalProviderAuth = {
  __typename?: "ExternalProviderAuth";
  apiKey: Scalars["String"];
  brandId: Scalars["ID"];
  id: Scalars["ID"];
  provider: Scalars["String"];
};

export type ExternalProviderAuthFilters = {
  ids?: InputMaybe<Array<Scalars["ID"]>>;
};

export type ExternalRecipient = {
  accountId: Scalars["ID"];
  email: Scalars["String"];
  message?: InputMaybe<Scalars["String"]>;
  sendCopy: Scalars["Boolean"];
};

export type ExtraData = {
  brandName?: InputMaybe<Scalars["String"]>;
  orderTotalAmount?: InputMaybe<Scalars["Float"]>;
  poNumber?: InputMaybe<Scalars["String"]>;
  retailerEmail?: InputMaybe<Scalars["String"]>;
  retailerName?: InputMaybe<Scalars["String"]>;
};

export type Fabrication = {
  __typename?: "Fabrication";
  name: Scalars["String"];
};

export type Favorite = {
  __typename?: "Favorite";
  brandAccountId: Scalars["ID"];
  id: Scalars["ID"];
  tradeShowEventId?: Maybe<Scalars["ID"]>;
};

export type FavoriteBrandAccountPayload = {
  __typename?: "FavoriteBrandAccountPayload";
  brandAccountId: Scalars["ID"];
  id: Scalars["ID"];
  tradeShowEventId?: Maybe<Scalars["ID"]>;
};

export type FavoritedBrand = {
  __typename?: "FavoritedBrand";
  id: Scalars["ID"];
  mainImage?: Maybe<Scalars["String"]>;
  profileName?: Maybe<Scalars["String"]>;
  tradeShowEventSlug?: Maybe<Scalars["String"]>;
};

export type FavoritedBrandsOrderBy = {
  field: FavoritedBrandsOrderByField;
};

export enum FavoritedBrandsOrderByField {
  Name = "NAME",
}

/** A Keycloak Federated Identity */
export type FederatedIdentity = {
  __typename?: "FederatedIdentity";
  identityProvider?: Maybe<Scalars["String"]>;
  userId?: Maybe<Scalars["String"]>;
  userName?: Maybe<Scalars["String"]>;
};

export type FieldValues = {
  __typename?: "FieldValues";
  brand: Array<RetailerBrandEdge>;
  brandV2: Array<RetailerBrand>;
  createdByUser: Array<RetailerUserEdge>;
  name: Array<Scalars["String"]>;
  poNumber: Array<Scalars["String"]>;
  season: Array<SeasonEdge>;
};

export enum FileToGenerate {
  OrdersDetails = "ORDERS_DETAILS",
  OrderErrors = "ORDER_ERRORS",
}

export type FilterItem = {
  __typename?: "FilterItem";
  id: Scalars["ID"];
  name?: Maybe<Scalars["String"]>;
};

export type FinancialPriceLevel = FinancialPrices & {
  __typename?: "FinancialPriceLevel";
  averageUnitCost: Money;
  averageUnitRetail: Money;
  cost: Money;
  extendedCost: Money;
  extendedRetail: Money;
  initialMarkup: Scalars["Decimal"];
  name: FinancialPriceLevelName;
  retail: Money;
};

export enum FinancialPriceLevelName {
  Final = "FINAL",
  Modified = "MODIFIED",
  Original = "ORIGINAL",
}

export type FinancialPrices = {
  averageUnitCost?: Maybe<Money>;
  averageUnitRetail?: Maybe<Money>;
  cost?: Maybe<Money>;
  initialMarkup?: Maybe<Scalars["Decimal"]>;
  retail?: Maybe<Money>;
};

export enum FurStatus {
  ContainsFur = "CONTAINS_FUR",
  DoesNotContainFur = "DOES_NOT_CONTAIN_FUR",
  Unspecified = "UNSPECIFIED",
}

export type GenerateSummaryFileInput = {
  fileToGenerate: FileToGenerate;
  validatedOrdersIdentifier: Scalars["String"];
};

export type GenerateSummaryFilePayload = {
  __typename?: "GenerateSummaryFilePayload";
  url?: Maybe<Scalars["String"]>;
};

export type GenericError = {
  code?: Maybe<GenericErrorCode>;
  message: Scalars["String"];
};

export enum GenericErrorCode {
  DataError = "DATA_ERROR",
  Duplicated = "DUPLICATED",
  NotFound = "NOT_FOUND",
  ValidationError = "VALIDATION_ERROR",
}

/** Update details of a price modifier */
export type GenericSetPriceModifierValueInput = {
  /** Id of assortment */
  assortmentId: Scalars["ID"];
  /** Id of price_modifier_field */
  groupId: Scalars["ID"];
  /** Id of the object to update */
  priceModifierId?: InputMaybe<Scalars["ID"]>;
  /** The value to apply */
  value?: InputMaybe<PriceModifierValueInput>;
};

export type Geography = Node & {
  __typename?: "Geography";
  abbreviation?: Maybe<Scalars["String"]>;
  geographyParentId: Scalars["ID"];
  id: Scalars["ID"];
  name: Scalars["String"];
  taxLabel?: Maybe<Scalars["String"]>;
  type: GeographyType;
};

export type GeographyConnection = {
  __typename?: "GeographyConnection";
  edges: Array<GeographyEdge>;
};

export type GeographyEdge = {
  __typename?: "GeographyEdge";
  node: Geography;
};

export type GeographyFilter = {
  geographyParentId: Scalars["ID"];
};

export enum GeographyType {
  City = "CITY",
  Continent = "CONTINENT",
  Country = "COUNTRY",
  County = "COUNTY",
  Neighborhood = "NEIGHBORHOOD",
  Planet = "PLANET",
  State = "STATE",
}

export type GetAccountCustomerCodesInput = {
  otherAccountIds?: InputMaybe<Array<Scalars["ID"]>>;
};

export type GetOrCreatePendingUsersInput = {
  emails: Array<Scalars["String"]>;
};

export type GetOrCreatePendingUsersPayload = {
  __typename?: "GetOrCreatePendingUsersPayload";
  users?: Maybe<Array<GetOrCreateUserPayload>>;
};

/** Returns either the user who matches this email or an error. */
export type GetOrCreateUserPayload = {
  __typename?: "GetOrCreateUserPayload";
  email: Scalars["String"];
  error?: Maybe<Error>;
  user?: Maybe<User>;
};

export type GetOrderCustomerDataPayload = {
  __typename?: "GetOrderCustomerDataPayload";
  customerBillingAddressId?: Maybe<Scalars["ID"]>;
  customerRecordId?: Maybe<Scalars["ID"]>;
  customerShippingAddressId?: Maybe<Scalars["ID"]>;
  errors: Array<Error>;
};

export type GetShowroomCollectionTokenizedLinkInput = {
  showroomCollectionId: Scalars["ID"];
  tokenActiveDays?: InputMaybe<Scalars["Int"]>;
};

export type GoogleAddress = {
  __typename?: "GoogleAddress";
  accepted?: Maybe<Scalars["Boolean"]>;
  accountId: Scalars["ID"];
  address1?: Maybe<Scalars["String"]>;
  businessStatus?: Maybe<BusinessStatus>;
  city?: Maybe<Scalars["String"]>;
  country?: Maybe<Scalars["String"]>;
  created?: Maybe<Scalars["Date"]>;
  id: Scalars["ID"];
  locationId: Scalars["ID"];
  modified?: Maybe<Scalars["Date"]>;
  phone?: Maybe<Scalars["String"]>;
  placeId?: Maybe<Scalars["String"]>;
  state?: Maybe<Scalars["String"]>;
  url?: Maybe<Scalars["String"]>;
  website?: Maybe<Scalars["String"]>;
  zip?: Maybe<Scalars["String"]>;
};

export type GoogleAddressConnection = {
  __typename?: "GoogleAddressConnection";
  edges: Array<GoogleAddressEdge>;
};

export type GoogleAddressEdge = {
  __typename?: "GoogleAddressEdge";
  node: GoogleAddress;
};

export type HandleRemoveAccountUserInput = {
  account_id: Scalars["String"];
  user_id: Scalars["String"];
};

export type HandleRemoveAccountUserPayload = {
  __typename?: "HandleRemoveAccountUserPayload";
  error?: Maybe<Scalars["String"]>;
  success: Scalars["Boolean"];
};

export type Hex = {
  __typename?: "Hex";
  value: Scalars["String"];
};

export type Hub = Node & {
  __typename?: "Hub";
  brand: Brand;
  creator: User;
  id: Scalars["ID"];
  lastModified?: Maybe<Scalars["Date"]>;
  name: Scalars["String"];
  number: Scalars["String"];
  orders: HubOrderConnection;
  retailer: Retailer;
  shared: Scalars["Boolean"];
  status: HubStatus;
};

export type HubOrdersArgs = {
  limit?: InputMaybe<Scalars["Int"]>;
  offset?: InputMaybe<Scalars["Int"]>;
};

export type HubConnection = {
  __typename?: "HubConnection";
  edges: Array<HubEdge>;
};

export type HubEdge = {
  __typename?: "HubEdge";
  node: Hub;
};

export type HubFilter = {
  hubIds?: InputMaybe<Array<Scalars["ID"]>>;
  name?: InputMaybe<Scalars["String"]>;
  retailerId?: InputMaybe<Scalars["ID"]>;
  /** Search by hub name, hub number and retailer name */
  searchText?: InputMaybe<Scalars["String"]>;
};

export type HubOrderConnection = {
  __typename?: "HubOrderConnection";
  buyers: Array<OrderBuyer>;
  collections: Array<Collection>;
  divisions: Array<Division>;
  doors: Array<BrandDoor>;
  edges: Array<HubOrderEdge>;
  events: Array<OrderEvent>;
  numberOfColors: Scalars["Int"];
  numberOfProducts: Scalars["Int"];
  numberOfUnits: Scalars["Int"];
  priceTypes: Array<PriceType>;
  salesRepresentatives: Array<User>;
  totalOrders: Scalars["Int"];
  warehouses: Array<Warehouse>;
  wholesaleTotals: Array<WholesaleTotalsByPriceType>;
};

export type HubOrderEdge = {
  __typename?: "HubOrderEdge";
  node: Order;
};

export enum HubStatus {
  Active = "ACTIVE",
  Archived = "ARCHIVED",
}

export enum HubStatusInput {
  Active = "ACTIVE",
  Archived = "ARCHIVED",
}

export type HyperionAddress = {
  __typename?: "HyperionAddress";
  city?: Maybe<Scalars["String"]>;
  companyName?: Maybe<Scalars["String"]>;
  country?: Maybe<Scalars["String"]>;
  line1?: Maybe<Scalars["String"]>;
  line2?: Maybe<Scalars["String"]>;
  name?: Maybe<Scalars["String"]>;
  state?: Maybe<Scalars["String"]>;
  zip?: Maybe<Scalars["String"]>;
};

/** A Keycloak Identity Provider */
export type IdentityProvider = {
  __typename?: "IdentityProvider";
  alias: Scalars["String"];
};

/**
 * A Keycloak Identity Provider
 * alias - IdP id
 * acesUrl - Assertion consumer service url (url which should be redirected back to after logging into IdP)
 */
export type IdpConfig = {
  __typename?: "IdpConfig";
  acsUrl: Scalars["String"];
  domain: Scalars["String"];
  enabled?: Maybe<Scalars["Boolean"]>;
  entityId: Scalars["String"];
  sigCert: Scalars["String"];
  ssoLoginUrl: Scalars["String"];
};

export type IdpConfigConnection = {
  __typename?: "IdpConfigConnection";
  count: Scalars["Int"];
  edges?: Maybe<Array<IdpConfigEdge>>;
};

export type IdpConfigEdge = {
  __typename?: "IdpConfigEdge";
  node: IdpConfig;
};

export type Image = Node & {
  __typename?: "Image";
  /** A Base64 Encoding of the image. The default size is 114x114 */
  base64Data?: Maybe<Scalars["String"]>;
  id: Scalars["ID"];
  owner?: Maybe<ImageOwnerAccount>;
  url: Scalars["URL"];
};

export type ImageBase64DataArgs = {
  dimensions?: InputMaybe<ImageSize>;
};

export type ImageConnection = {
  __typename?: "ImageConnection";
  edges: Array<ImageEdge>;
};

export type ImageEdge = {
  __typename?: "ImageEdge";
  node: Image;
};

export type ImageOwnerAccount = Node & {
  __typename?: "ImageOwnerAccount";
  id: Scalars["ID"];
};

export type ImageRemoved = {
  __typename?: "ImageRemoved";
  id: Scalars["ID"];
};

/**
 * All valid supported dimensions. For more info regarding dimensions see: https://jooraccess.atlassian.net/wiki/spaces/TECH/pages/17465352/Image+Resizing
 * Source: https://github.com/joor/aws-lambda/blob/master/src/imgixRedirect/constants.js
 */
export enum ImageSize {
  D_18x18W = "D_18x18W",
  D_36x136W = "D_36x136W",
  D_37x37W = "D_37x37W",
  D_40x40W = "D_40x40W",
  D_50x50 = "D_50x50",
  D_50x50W = "D_50x50W",
  D_50x50Wf = "D_50x50WF",
  D_56x56W = "D_56x56W",
  D_56x75W = "D_56x75W",
  D_65x65W = "D_65x65W",
  D_82x112W = "D_82x112W",
  D_84x112 = "D_84x112",
  D_100x100W = "D_100x100W",
  D_114x114W = "D_114x114W",
  D_120x160W = "D_120x160W",
  D_136x181W = "D_136x181W",
  D_138x181W = "D_138x181W",
  D_140x140 = "D_140x140",
  D_150x150W = "D_150x150W",
  D_150x150Wf = "D_150x150WF",
  D_152x88W = "D_152x88W",
  D_165x112W = "D_165x112W",
  D_165x225G2 = "D_165x225G2",
  D_165x225W = "D_165x225W",
  D_188x125W = "D_188x125W",
  D_213x283W = "D_213x283W",
  D_216x144W = "D_216x144W",
  D_216x276 = "D_216x276",
  D_220x300W = "D_220x300W",
  D_220x300Wc = "D_220x300WC",
  D_222x222W = "D_222x222W",
  D_222x222Wf = "D_222x222WF",
  D_250x300Wc = "D_250x300WC",
  D_330x450W = "D_330x450W",
  D_345x470W = "D_345x470W",
  D_400x70W = "D_400x70W",
  D_400x10000C = "D_400x10000C",
  D_424x238Wc = "D_424x238WC",
  D_450x600W = "D_450x600W",
  D_472x348Wc = "D_472x348WC",
  D_494x238Wc = "D_494x238WC",
  D_498x664 = "D_498x664",
  D_540x300W = "D_540x300W",
  D_660x100W = "D_660x100W",
  D_660x900Wc = "D_660x900WC",
  D_700x390W = "D_700x390W",
  D_848x476Gc = "D_848x476GC",
  D_918x1236 = "D_918x1236",
  D_1200x800W = "D_1200x800W",
  D_1350x1406W = "D_1350x1406W",
  D_1350x1406Wf = "D_1350x1406WF",
  D_1536x2048 = "D_1536x2048",
  D_1650x2250W = "D_1650x2250W",
}

export type ImportValidatedOrdersInput = {
  validatedOrdersIdentifier: Scalars["String"];
  validatedOrdersUrl: Scalars["String"];
};

export type ImportValidatedOrdersPayload = {
  __typename?: "ImportValidatedOrdersPayload";
  importJobIdentifier?: Maybe<Scalars["String"]>;
};

export type InstagramAccount = {
  __typename?: "InstagramAccount";
  brandId: Scalars["ID"];
  expiresAt: Scalars["Date"];
  id: Scalars["ID"];
  userId: Scalars["String"];
  userName: Scalars["String"];
};

export type InstagramAccountFilters = {
  ids?: InputMaybe<Array<Scalars["ID"]>>;
};

export type InstagramAccountImages = {
  __typename?: "InstagramAccountImages";
  imageUrls: Array<Scalars["String"]>;
  instagramAccountId: Scalars["ID"];
};

export type InterestedBrand = {
  __typename?: "InterestedBrand";
  brandId: Scalars["ID"];
  logoUrl?: Maybe<Scalars["String"]>;
  name: Scalars["String"];
};

export type InvalidSkuLineItem = {
  __typename?: "InvalidSkuLineItem";
  colorCode?: Maybe<Scalars["String"]>;
  colorName?: Maybe<Scalars["String"]>;
  doorCode?: Maybe<Scalars["String"]>;
  doorName?: Maybe<Scalars["String"]>;
  payload?: Maybe<Scalars["JSON"]>;
  productIdentifier?: Maybe<Scalars["String"]>;
  productNumber?: Maybe<Scalars["String"]>;
  quantity?: Maybe<Scalars["Int"]>;
  sizeName?: Maybe<Scalars["String"]>;
  skuIdentifier?: Maybe<Scalars["String"]>;
  upc?: Maybe<Scalars["String"]>;
  wholesalePrice?: Maybe<Scalars["String"]>;
};

export enum InventoryAvailability {
  All = "ALL",
  FutureDates = "FUTURE_DATES",
  Immediate = "IMMEDIATE",
}

export type InventoryAvailabilityGroup = Node & {
  __typename?: "InventoryAvailabilityGroup";
  availability: Availability;
  id: Scalars["ID"];
  /**
   * This field allows us to know if the Inventory Availability Group has
   * items and if a productId is passed it will tell us if it has items for
   * the product
   */
  isEmpty?: Maybe<Scalars["Boolean"]>;
  items: InventoryItemConnection;
};

export type InventoryAvailabilityGroupIsEmptyArgs = {
  productId?: InputMaybe<Scalars["ID"]>;
};

export type InventoryAvailabilityGroupItemsArgs = {
  filter?: InputMaybe<InventoryItemsFilterInput>;
};

export type InventoryAvailabilityGroupConnection = {
  __typename?: "InventoryAvailabilityGroupConnection";
  edges: Array<Maybe<InventoryAvailabilityGroupEdge>>;
};

export type InventoryAvailabilityGroupEdge = {
  __typename?: "InventoryAvailabilityGroupEdge";
  node: InventoryAvailabilityGroup;
};

export type InventoryFilter = {
  availability?: InputMaybe<InventoryAvailability>;
  unitsRange?: InputMaybe<UnitRange>;
  warehouseIds?: InputMaybe<Array<Scalars["ID"]>>;
};

export type InventoryItem = Node & {
  __typename?: "InventoryItem";
  availableQuantity: Scalars["Int"];
  id: Scalars["ID"];
  skuId: Scalars["ID"];
  submittedQuantity: Scalars["Int"];
};

export type InventoryItemConnection = {
  __typename?: "InventoryItemConnection";
  edges?: Maybe<Array<InventoryItemEdge>>;
};

export type InventoryItemEdge = {
  __typename?: "InventoryItemEdge";
  node: InventoryItem;
};

export type InventoryItemsFilterInput = {
  productIds: Array<Scalars["ID"]>;
};

export type InventoryVisibilityGroupSettings = {
  __typename?: "InventoryVisibilityGroupSettings";
  applyToAllRetailers?: Maybe<Scalars["Boolean"]>;
  applyToRetailerIds: Array<Scalars["ID"]>;
  options?: Maybe<Array<InventoryVisibilityGroupSettingsOption>>;
};

export type InventoryVisibilityGroupSettingsOption = {
  __typename?: "InventoryVisibilityGroupSettingsOption";
  field: Scalars["String"];
  value: Scalars["String"];
};

export type InventoryVisibilitySettings = {
  __typename?: "InventoryVisibilitySettings";
  brandId: Scalars["ID"];
  groupSettings: Array<InventoryVisibilityGroupSettings>;
};

export type InvoiceBrandDoorConnection = {
  __typename?: "InvoiceBrandDoorConnection";
  id?: Maybe<Scalars["String"]>;
  name?: Maybe<Scalars["String"]>;
};

export type InvoiceData = {
  __typename?: "InvoiceData";
  billingCity?: Maybe<Scalars["String"]>;
  billingCompany?: Maybe<Scalars["String"]>;
  billingCountry?: Maybe<Scalars["String"]>;
  billingFirstAddress?: Maybe<Scalars["String"]>;
  billingPhone?: Maybe<Scalars["String"]>;
  billingSecondAddress?: Maybe<Scalars["String"]>;
  billingState?: Maybe<Scalars["String"]>;
  billingZip?: Maybe<Scalars["String"]>;
  brand?: Maybe<AccountIdAndDisplayName>;
  collections?: Maybe<InvoiceOrderCollections>;
  deliveryComplete?: Maybe<Scalars["String"]>;
  deliveryStart?: Maybe<Scalars["String"]>;
  discountAmount?: Maybe<Scalars["Float"]>;
  door?: Maybe<InvoiceBrandDoorConnection>;
  id: Scalars["ID"];
  lastModifier?: Maybe<LastModifier>;
  lineItems?: Maybe<LineItems>;
  modified: Scalars["Date"];
  /** @deprecated Get from paymentInfo */
  partialPaymentRequests?: Maybe<Array<PartialPaymentRequest>>;
  paymentInfo?: Maybe<PaymentInfo>;
  paymentMethod?: Maybe<InvoicePaymentMethodConnection>;
  priceType?: Maybe<InvoiceOrderPriceType>;
  referenceNumber?: Maybe<Scalars["String"]>;
  retailer?: Maybe<AccountIdAndDisplayName>;
  salesRepresentative?: Maybe<SalesRepresentative>;
  seasonYear?: Maybe<OrderSeasonYear>;
  shippingCity?: Maybe<Scalars["String"]>;
  shippingCompany?: Maybe<Scalars["String"]>;
  shippingCountry?: Maybe<Scalars["String"]>;
  shippingEmail?: Maybe<Scalars["String"]>;
  shippingFirstAddress?: Maybe<Scalars["String"]>;
  shippingPhone?: Maybe<Scalars["String"]>;
  shippingPrice?: Maybe<Scalars["Float"]>;
  shippingSecondAddress?: Maybe<Scalars["String"]>;
  shippingState?: Maybe<Scalars["String"]>;
  shippingZip?: Maybe<Scalars["String"]>;
  status?: Maybe<Scalars["String"]>;
  taxAmount?: Maybe<Scalars["Float"]>;
  taxIdNumber?: Maybe<Scalars["String"]>;
  warehouse?: Maybe<InvoiceWarehouseConnection>;
  webOrderLookupId?: Maybe<Scalars["String"]>;
};

export type InvoiceDelivery = {
  __typename?: "InvoiceDelivery";
  orderId: Scalars["ID"];
  sentOn: Scalars["Date"];
  sentTo: Scalars["String"];
};

export type InvoiceExportPaymentDetails = {
  __typename?: "InvoiceExportPaymentDetails";
  dueDate: Scalars["String"];
  issuedDate: Scalars["String"];
  orderId: Scalars["ID"];
  paidAmount: Scalars["Float"];
};

export type InvoiceOrderCollectionEdge = {
  __typename?: "InvoiceOrderCollectionEdge";
  node?: Maybe<CollectionName>;
};

export type InvoiceOrderCollections = {
  __typename?: "InvoiceOrderCollections";
  edges?: Maybe<Array<InvoiceOrderCollectionEdge>>;
};

export type InvoiceOrderCurrency = {
  __typename?: "InvoiceOrderCurrency";
  code?: Maybe<Scalars["String"]>;
  decimals?: Maybe<Scalars["Int"]>;
  symbol?: Maybe<Scalars["String"]>;
};

export type InvoiceOrderPriceType = {
  __typename?: "InvoiceOrderPriceType";
  currency?: Maybe<InvoiceOrderCurrency>;
};

export type InvoiceParameter = {
  amount?: InputMaybe<Scalars["String"]>;
  attachments?: InputMaybe<Array<AttachmentInput>>;
  billingAddress?: InputMaybe<Scalars["String"]>;
  brandContactName?: InputMaybe<Scalars["String"]>;
  brandName: Scalars["String"];
  brandUsername: Scalars["String"];
  currency?: InputMaybe<Scalars["String"]>;
  customMessage?: InputMaybe<Scalars["String"]>;
  customSubject?: InputMaybe<Scalars["String"]>;
  destinationAccountId: Scalars["ID"];
  dueDate?: InputMaybe<Scalars["Date"]>;
  isPartialPaymentRequest?: InputMaybe<Scalars["Boolean"]>;
  language: Scalars["String"];
  name?: InputMaybe<Scalars["String"]>;
  orderBrandId: Scalars["ID"];
  orderId: Scalars["ID"];
  paymentName?: InputMaybe<Scalars["String"]>;
  poNumber: Scalars["String"];
  retailerEmail?: InputMaybe<Scalars["String"]>;
  retailerName?: InputMaybe<Scalars["String"]>;
  sentBcc?: InputMaybe<Array<Scalars["EmailAddress"]>>;
  sentFrom: Scalars["String"];
  sentTo: Scalars["EmailAddress"];
  webOrderId: Scalars["ID"];
};

export type InvoicePaymentMethodConnection = {
  __typename?: "InvoicePaymentMethodConnection";
  id?: Maybe<Scalars["String"]>;
  paymentName?: Maybe<Scalars["String"]>;
};

export type InvoiceWarehouseConnection = {
  __typename?: "InvoiceWarehouseConnection";
  id?: Maybe<Scalars["String"]>;
  name?: Maybe<Scalars["String"]>;
};

export type ItemVisibility = {
  __typename?: "ItemVisibility";
  collectionProduct?: Maybe<CollectionProduct>;
  variantId?: Maybe<Scalars["ID"]>;
  visible: Scalars["Boolean"];
};

/** A Keycloak User */
export type KeycloakUser = {
  __typename?: "KeycloakUser";
  email: Scalars["String"];
  federatedIdentities?: Maybe<Array<FederatedIdentity>>;
  /** User id on Keycloak */
  id: Scalars["ID"];
};

export type LgBrandCarried = Node & {
  __typename?: "LGBrandCarried";
  accountId?: Maybe<Scalars["ID"]>;
  id: Scalars["ID"];
  name: Scalars["String"];
};

export type LgBrandCarriedEdge = {
  __typename?: "LGBrandCarriedEdge";
  node: LgBrandCarried;
};

export type LgBrandsCarriedConnection = {
  __typename?: "LGBrandsCarriedConnection";
  edges: Array<LgBrandCarriedEdge>;
  totalCount: Scalars["Int"];
};

export type LgBuyer = {
  __typename?: "LGBuyer";
  isBuyer?: Maybe<Scalars["Boolean"]>;
  isOwner?: Maybe<Scalars["Boolean"]>;
  name?: Maybe<Scalars["String"]>;
};

export type LgBuyerInput = {
  isBuyer: Scalars["Boolean"];
  isOwner: Scalars["Boolean"];
  name: Scalars["String"];
};

export type LgClienteleInfo = {
  __typename?: "LGClienteleInfo";
  age?: Maybe<Scalars["String"]>;
  descriptions?: Maybe<Array<LgClienteleInfoBit>>;
  female?: Maybe<Scalars["Boolean"]>;
  interests?: Maybe<Array<LgClienteleInfoBit>>;
  male?: Maybe<Scalars["Boolean"]>;
};

export type LgClienteleInfoBit = {
  __typename?: "LGClienteleInfoBit";
  id: Scalars["ID"];
  name?: Maybe<Scalars["String"]>;
};

export type LgClienteleInfoInput = {
  clienteleAge?: InputMaybe<Scalars["String"]>;
  clienteleDescriptionIds?: InputMaybe<Array<Scalars["ID"]>>;
  clienteleFemale?: InputMaybe<Scalars["Boolean"]>;
  clienteleInterestIds?: InputMaybe<Array<Scalars["ID"]>>;
  clienteleMale?: InputMaybe<Scalars["Boolean"]>;
};

export enum LgConnectionStatus {
  Connected = "CONNECTED",
  PendingBrand = "PENDING_BRAND",
  PendingRetailer = "PENDING_RETAILER",
  Unconnected = "UNCONNECTED",
}

export type LgFindRetailersFilters = {
  brandsCarried?: InputMaybe<Array<Scalars["String"]>>;
  categories?: InputMaybe<Array<Scalars["ID"]>>;
  location?: InputMaybe<LgRetailersLocationFilter>;
  retailerId?: InputMaybe<Scalars["ID"]>;
  wholesalePriceRange?: InputMaybe<LgRetailersWholesalePriceRange>;
};

export type LgFindRetailersOrderBy = {
  field: LgFindRetailersOrderByField;
  order: LgFindRetailersOrderByOrder;
};

export enum LgFindRetailersOrderByField {
  ProfileName = "PROFILE_NAME",
  ProfileScore = "PROFILE_SCORE",
}

export enum LgFindRetailersOrderByOrder {
  Ascending = "ASCENDING",
  Descending = "DESCENDING",
}

export type LgLocationInput = {
  address1: Scalars["String"];
  address2?: InputMaybe<Scalars["String"]>;
  carriedBrandIds?: InputMaybe<Array<Scalars["ID"]>>;
  categoryIds?: InputMaybe<Array<Scalars["ID"]>>;
  city: Scalars["String"];
  clienteleInfo?: InputMaybe<LgClienteleInfoInput>;
  country: Scalars["String"];
  id?: InputMaybe<Scalars["ID"]>;
  isPrimaryLocation: Scalars["Boolean"];
  name: Scalars["String"];
  phone?: InputMaybe<Scalars["String"]>;
  state?: InputMaybe<Scalars["String"]>;
  type: LocationType;
  wholesaleMax?: InputMaybe<Scalars["Int"]>;
  wholesaleMin?: InputMaybe<Scalars["Int"]>;
  yearEstablished?: InputMaybe<Scalars["Int"]>;
  zip?: InputMaybe<Scalars["String"]>;
};

export type LgLogo = {
  __typename?: "LGLogo";
  id?: Maybe<Scalars["ID"]>;
  url?: Maybe<Scalars["String"]>;
};

export type LgOtherUserBrands = Node & {
  __typename?: "LGOtherUserBrands";
  id: Scalars["ID"];
  name: Scalars["String"];
  priceTypes: Array<Maybe<LgPriceType>>;
};

export type LgPriceType = Node & {
  __typename?: "LGPriceType";
  currencyCode: Scalars["String"];
  currencyId: Scalars["String"];
  currencyName: Scalars["String"];
  id: Scalars["ID"];
  name: Scalars["String"];
};

export type LgProfileImage = {
  __typename?: "LGProfileImage";
  id: Scalars["ID"];
  upload?: Maybe<RetailerUpload>;
};

export type LgRequestConnectionData = {
  __typename?: "LGRequestConnectionData";
  inviteMessage?: Maybe<Scalars["String"]>;
  otherUserBrands: Array<Maybe<LgOtherUserBrands>>;
  parentCompany?: Maybe<Scalars["String"]>;
  priceTypes: Array<Maybe<LgPriceType>>;
  termsConditions: Array<Maybe<LgTermsConditions>>;
};

export type LgRetailer = Node & {
  __typename?: "LGRetailer";
  autoConnect: Scalars["Boolean"];
  connectionStatus: LgConnectionStatus;
  description?: Maybe<Scalars["String"]>;
  id: Scalars["ID"];
  location?: Maybe<LgRetailerLocation>;
  logoUrl?: Maybe<Scalars["String"]>;
  name: Scalars["String"];
};

export type LgRetailerConnection = {
  __typename?: "LGRetailerConnection";
  edges: Array<LgRetailerEdge>;
  totalCount: Scalars["Int"];
};

export type LgRetailerEdge = {
  __typename?: "LGRetailerEdge";
  node: LgRetailer;
};

export type LgRetailerLocation = Node & {
  __typename?: "LGRetailerLocation";
  address1?: Maybe<Scalars["String"]>;
  address2?: Maybe<Scalars["String"]>;
  city?: Maybe<Scalars["String"]>;
  country?: Maybe<Scalars["String"]>;
  id: Scalars["ID"];
  state?: Maybe<Scalars["String"]>;
  zip?: Maybe<Scalars["String"]>;
};

export type LgRetailerProfile = {
  __typename?: "LGRetailerProfile";
  autoConnect?: Maybe<Scalars["Boolean"]>;
  buyer?: Maybe<LgBuyer>;
  connectionStatus?: Maybe<LgConnectionStatus>;
  description?: Maybe<Scalars["String"]>;
  displayName?: Maybe<Scalars["String"]>;
  id: Scalars["ID"];
  locations?: Maybe<Array<LgRetailerProfileLocation>>;
  logo?: Maybe<LgLogo>;
  name?: Maybe<Scalars["String"]>;
  people?: Maybe<Array<PersonInformation>>;
  primaryLocation?: Maybe<LgRetailerProfileLocation>;
  profileImages?: Maybe<Array<LgProfileImage>>;
  profileSnoozeCounter?: Maybe<Scalars["Int"]>;
  socialMediaAccounts?: Maybe<Array<LgSocialMediaAccounts>>;
  websiteUrl?: Maybe<Scalars["String"]>;
};

export type LgRetailerProfileLocation = {
  __typename?: "LGRetailerProfileLocation";
  address1?: Maybe<Scalars["String"]>;
  address2?: Maybe<Scalars["String"]>;
  brandsCarried?: Maybe<Array<LgBrandCarried>>;
  categories?: Maybe<Array<ProductLine>>;
  city?: Maybe<Scalars["String"]>;
  clienteleInfo?: Maybe<LgClienteleInfo>;
  country?: Maybe<Scalars["String"]>;
  id: Scalars["ID"];
  name?: Maybe<Scalars["String"]>;
  phone?: Maybe<Scalars["String"]>;
  /** @deprecated Use categories instead */
  productLines: Array<Scalars["String"]>;
  state?: Maybe<Scalars["String"]>;
  /** @deprecated Use carriedBrands instead */
  topBrands: Array<Scalars["String"]>;
  type?: Maybe<LocationType>;
  wholesaleRange?: Maybe<LgRetailerProfileWholesaleRange>;
  yearEstablished?: Maybe<Scalars["String"]>;
  zip?: Maybe<Scalars["String"]>;
};

export type LgRetailerProfileWholesaleRange = {
  __typename?: "LGRetailerProfileWholesaleRange";
  max?: Maybe<Scalars["String"]>;
  min?: Maybe<Scalars["String"]>;
};

export type LgRetailersLocationFilter = {
  city?: InputMaybe<Scalars["String"]>;
  country?: InputMaybe<Scalars["String"]>;
  state?: InputMaybe<Scalars["String"]>;
  zip?: InputMaybe<Scalars["String"]>;
};

export type LgRetailersWholesalePriceRange = {
  max?: InputMaybe<Scalars["Int"]>;
  min?: InputMaybe<Scalars["Int"]>;
};

export type LgSocialMediaAccounts = {
  __typename?: "LGSocialMediaAccounts";
  type: SocialMediaType;
  url: Scalars["String"];
};

export type LgTermsConditions = Node & {
  __typename?: "LGTermsConditions";
  id: Scalars["ID"];
  name: Scalars["String"];
};

export type LastModifier = {
  __typename?: "LastModifier";
  byAdmin: Scalars["Boolean"];
  email: Scalars["String"];
};

export type LatestBrandProfile = {
  __typename?: "LatestBrandProfile";
  accountMedia?: Maybe<Media>;
  categories: Array<Scalars["String"]>;
  id: Scalars["ID"];
  name: Scalars["String"];
};

export type LatestFavoriteBrandProfile = {
  __typename?: "LatestFavoriteBrandProfile";
  accountMedia?: Maybe<Media>;
  id: Scalars["ID"];
  name: Scalars["String"];
};

export type LibraryValue = {
  __typename?: "LibraryValue";
  code?: Maybe<Scalars["String"]>;
  id: Scalars["ID"];
  name: Scalars["String"];
};

export type LibraryValuesOrderBy = {
  field: LibraryValuesOrderByField;
  order?: InputMaybe<LibraryValuesOrdering>;
};

export enum LibraryValuesOrderByField {
  CreationDate = "CREATION_DATE",
  Name = "NAME",
}

export enum LibraryValuesOrdering {
  Ascending = "ASCENDING",
  Descending = "DESCENDING",
}

/**
 * A line item is a unit of transaction that represents a SKU, destination information, and a quantity.
 *
 * Represents an amount of an single SKU being delivered to a destination.
 */
export type LineItem = Node & {
  __typename?: "LineItem";
  /** Information pertaining to the shipping location of this line item */
  destination?: Maybe<Destination>;
  id: Scalars["ID"];
  /** An amount of the SKU to send to the destination */
  quantity?: Maybe<Scalars["Int"]>;
  /** The SKU for this line item */
  sku?: Maybe<SkuEdge>;
};

export type LineItemCollection = Node & {
  __typename?: "LineItemCollection";
  id: Scalars["ID"];
  ignoresInventory?: Maybe<Scalars["Boolean"]>;
};

export type LineItemIdsPayload = {
  __typename?: "LineItemIdsPayload";
  assortmentId: Scalars["ID"];
  lineItemIds: Array<Scalars["ID"]>;
};

export type LineItems = {
  __typename?: "LineItems";
  discountedPrice?: Maybe<Scalars["String"]>;
  totalPrice?: Maybe<Scalars["String"]>;
  totalRetailPrice?: Maybe<Scalars["String"]>;
  totalUnits?: Maybe<Scalars["String"]>;
};

export type Linesheet = {
  __typename?: "Linesheet";
  items: LinesheetItemConnection;
};

export type LinesheetItemConnection = {
  __typename?: "LinesheetItemConnection";
  edges?: Maybe<LinesheetItemEdge>;
};

export type LinesheetItemEdge = {
  __typename?: "LinesheetItemEdge";
  node?: Maybe<Sku>;
};

export type ListConnectedBrandsFilter = {
  searchText?: InputMaybe<Scalars["String"]>;
};

export type ListConnectionBuyersInput = {
  retailerId: Scalars["ID"];
};

export type ListConnectionDiscountInput = {
  retailerId: Scalars["ID"];
};

export type ListConnectionDoorsInput = {
  retailerId: Scalars["ID"];
};

export type ListConnectionPaymentMethodsInput = {
  retailerId: Scalars["ID"];
};

export type ListConnectionPriceTypeInput = {
  orderId?: InputMaybe<Scalars["ID"]>;
  retailerId: Scalars["ID"];
};

export type ListConnectionSalesRepInput = {
  retailerId: Scalars["ID"];
};

export type ListConnectionShippingMethodsInput = {
  retailerId: Scalars["ID"];
};

export type ListConnectionWarehousesInput = {
  retailerId: Scalars["ID"];
};

export type ListOrderExportTasksInput = {
  ids: Array<Scalars["String"]>;
};

export type ListOrderExportTasksPayload = {
  __typename?: "ListOrderExportTasksPayload";
  exportTasks: Array<OrderExportTasks>;
};

export type ListPriceRangeGroupsFilter = {
  orderIds?: InputMaybe<Array<Scalars["ID"]>>;
  priceTypeIds?: InputMaybe<Array<Scalars["ID"]>>;
  productIds?: InputMaybe<Array<Scalars["ID"]>>;
  withCasepacks?: InputMaybe<Scalars["Boolean"]>;
  withInactive?: InputMaybe<Scalars["Boolean"]>;
};

export type LiteBrandInput = {
  address?: InputMaybe<Scalars["String"]>;
  city?: InputMaybe<Scalars["String"]>;
  country?: InputMaybe<Scalars["String"]>;
  postalCode?: InputMaybe<Scalars["String"]>;
  primaryContactEmailAddress: Scalars["String"];
  primaryContactFullName?: InputMaybe<Scalars["String"]>;
  state?: InputMaybe<Scalars["String"]>;
  storeName: Scalars["String"];
  taxId?: InputMaybe<Scalars["String"]>;
  userId: Scalars["String"];
  website?: InputMaybe<Scalars["String"]>;
};

export type LiteBrandPayload = {
  __typename?: "LiteBrandPayload";
  address?: Maybe<Scalars["String"]>;
  country?: Maybe<Scalars["String"]>;
  id: Scalars["ID"];
  postalCode?: Maybe<Scalars["String"]>;
  primaryContactFullName?: Maybe<Scalars["String"]>;
  state?: Maybe<Scalars["String"]>;
  storeName: Scalars["String"];
};

export type Location = {
  __typename?: "Location";
  address1?: Maybe<Scalars["String"]>;
  address2?: Maybe<Scalars["String"]>;
  carriedBrands?: Maybe<Array<CarriedBrand>>;
  categories?: Maybe<Array<ProductLine>>;
  city?: Maybe<Scalars["String"]>;
  clienteleInfo?: Maybe<ClienteleInfo>;
  country?: Maybe<Scalars["String"]>;
  id: Scalars["ID"];
  isPrimaryLocation: Scalars["Boolean"];
  name?: Maybe<Scalars["String"]>;
  phone?: Maybe<Scalars["String"]>;
  /** @deprecated Use categories instead */
  productLines: Array<Scalars["String"]>;
  state?: Maybe<Scalars["String"]>;
  /** @deprecated Use carriedBrands instead */
  topBrands: Array<Scalars["String"]>;
  type?: Maybe<LocationType>;
  wholesaleMax?: Maybe<Scalars["String"]>;
  wholesaleMin?: Maybe<Scalars["String"]>;
  yearEstablished?: Maybe<Scalars["String"]>;
  zip?: Maybe<Scalars["String"]>;
};

export type LocationInput = {
  address1: Scalars["String"];
  address2?: InputMaybe<Scalars["String"]>;
  carriedBrands?: InputMaybe<Array<Scalars["ID"]>>;
  categories?: InputMaybe<Array<Scalars["ID"]>>;
  city: Scalars["String"];
  clienteleInfo?: InputMaybe<ClienteleInfoInput>;
  country: Scalars["String"];
  id?: InputMaybe<Scalars["ID"]>;
  isPrimaryLocation: Scalars["Boolean"];
  name: Scalars["String"];
  phone?: InputMaybe<Scalars["String"]>;
  state?: InputMaybe<Scalars["String"]>;
  type: LocationType;
  wholesaleMax?: InputMaybe<Scalars["String"]>;
  wholesaleMin?: InputMaybe<Scalars["String"]>;
  yearEstablished?: InputMaybe<Scalars["String"]>;
  zip?: InputMaybe<Scalars["String"]>;
};

export enum LocationType {
  Office = "OFFICE",
  Store = "STORE",
}

export type Look = Node & {
  __typename?: "Look";
  id: Scalars["ID"];
  items: Array<ItemVisibility>;
  layout: Scalars["String"];
  media: Array<LookMedia>;
  textContents: Array<LookTextContent>;
};

export type LookConnection = {
  __typename?: "LookConnection";
  edges?: Maybe<Array<LookEdge>>;
  pageInfo: PageInfo;
};

export type LookEdge = {
  __typename?: "LookEdge";
  cursor: Scalars["String"];
  node: Look;
};

export type LookItemConnection = {
  collectionId: Scalars["ID"];
  productId: Scalars["ID"];
  variantId?: InputMaybe<Scalars["ID"]>;
};

export type LookMedia = {
  __typename?: "LookMedia";
  id: Scalars["ID"];
  streamingUrl: Scalars["String"];
  type: LookMediaType;
  url: Scalars["String"];
};

export enum LookMediaType {
  Image = "IMAGE",
  Streaming = "STREAMING",
  Video = "VIDEO",
}

export type LookTextContent = {
  __typename?: "LookTextContent";
  content: Scalars["String"];
  layoutKey: Scalars["String"];
  presentation: Scalars["String"];
};

export type LookTextContentInput = {
  content: Scalars["String"];
  layoutKey: Scalars["String"];
  presentation: Scalars["String"];
};

export type Lookbook = Node & {
  __typename?: "Lookbook";
  brandId: Scalars["ID"];
  id: Scalars["ID"];
  name?: Maybe<Scalars["String"]>;
  notifiedConnections?: Maybe<Scalars["Boolean"]>;
  pdfName?: Maybe<Scalars["String"]>;
  pdfUrl?: Maybe<Scalars["String"]>;
  position?: Maybe<Scalars["Int"]>;
  thumbnailUrl?: Maybe<Scalars["String"]>;
};

export type LookbookConnection = {
  __typename?: "LookbookConnection";
  edges?: Maybe<Array<LookbookEdge>>;
};

export type LookbookEdge = {
  __typename?: "LookbookEdge";
  node: Lookbook;
};

export enum ManualPaymentMethod {
  BankTransfer = "BANK_TRANSFER",
  Cash = "CASH",
  Check = "CHECK",
  CreditCard = "CREDIT_CARD",
  CreditMemo = "CREDIT_MEMO",
  InvoiceFactoring = "INVOICE_FACTORING",
  Other = "OTHER",
  Wire = "WIRE",
}

export type ManualPaymentRecord = {
  __typename?: "ManualPaymentRecord";
  amount: Scalars["Float"];
  brandId: Scalars["ID"];
  currency: Scalars["String"];
  id: Scalars["ID"];
  notes?: Maybe<Scalars["String"]>;
  orderId: Scalars["ID"];
  paymentDate?: Maybe<Scalars["Date"]>;
  paymentMethod: ManualPaymentMethod;
  recordedBy?: Maybe<Scalars["String"]>;
  referenceNumber?: Maybe<Scalars["String"]>;
  retailerId?: Maybe<Scalars["ID"]>;
};

export type MarkAssortmentVisitedInput = {
  assortmentId: Scalars["ID"];
};

export type MarkAssortmentVisitedPayload = {
  __typename?: "MarkAssortmentVisitedPayload";
  assortment: Assortment;
};

export type Material = {
  __typename?: "Material";
  name: Scalars["String"];
};

/** Used to reperesent Media such as images and videos */
export type Media = {
  __typename?: "Media";
  fileName?: Maybe<Scalars["String"]>;
  id?: Maybe<Scalars["ID"]>;
  mimeType?: Maybe<Scalars["String"]>;
  url?: Maybe<Scalars["String"]>;
};

export enum MediaType {
  Image = "IMAGE",
  Unknown = "UNKNOWN",
  Video = "VIDEO",
}

export type MembershipInvite = Node & {
  __typename?: "MembershipInvite";
  expiresAt?: Maybe<Scalars["Date"]>;
  id: Scalars["ID"];
  invitedEmail: Scalars["String"];
  invitedUser?: Maybe<User>;
  invitingAccount: AccountProfile;
  invitingUser: User;
  status?: Maybe<UserMembershipInviteStatus>;
};

export type MembershipInvitePayload = {
  __typename?: "MembershipInvitePayload";
  membershipInvite?: Maybe<MembershipInvite>;
};

export type MerchandisingHierarchyFilter = {
  __typename?: "MerchandisingHierarchyFilter";
  cursor?: Maybe<Scalars["String"]>;
  node?: Maybe<MerchandisingHierarchyNode>;
};

export type MerchandisingHierarchyFilterConnection = {
  __typename?: "MerchandisingHierarchyFilterConnection";
  edges?: Maybe<Array<MerchandisingHierarchyFilter>>;
};

export type MerchandisingHierarchyLevel = Node & {
  __typename?: "MerchandisingHierarchyLevel";
  /** A unique identifier */
  code: Scalars["String"];
  /** The numeric depth of this level */
  depth: Scalars["String"];
  id: Scalars["ID"];
  /** Display name */
  name: Scalars["String"];
};

export type MerchandisingHierarchyLevelEdge = {
  __typename?: "MerchandisingHierarchyLevelEdge";
  node?: Maybe<MerchandisingHierarchyLevel>;
};

/** Representation of a node withing a retailer's merchandising organization. */
export type MerchandisingHierarchyNode = Node & {
  __typename?: "MerchandisingHierarchyNode";
  /** A unique identifier */
  code: Scalars["String"];
  id: Scalars["ID"];
  /** The merchandising hierarchy level */
  level?: Maybe<MerchandisingHierarchyLevelEdge>;
  /** A display name */
  name: Scalars["String"];
  parent?: Maybe<MerchandisingHierarchyNodeEdge>;
};

export type MerchandisingHierarchyNodeConnection = {
  __typename?: "MerchandisingHierarchyNodeConnection";
  edges: Array<MerchandisingHierarchyNodeEdge>;
};

export type MerchandisingHierarchyNodeEdge = {
  __typename?: "MerchandisingHierarchyNodeEdge";
  node?: Maybe<MerchandisingHierarchyNode>;
};

export type MergeAccountsInput = {
  accountIds: Array<Scalars["ID"]>;
  targetAccountId: Scalars["ID"];
};

export type MergeAccountsPayload = {
  __typename?: "MergeAccountsPayload";
  success?: Maybe<Scalars["Boolean"]>;
};

export type MergeOrderBulkLineItemInfo = {
  variantId: Scalars["ID"];
};

export type MergeOrderCasepackLineItemInfo = {
  casepackId: Scalars["ID"];
};

export type MergeOrderInput = {
  orders: Array<MergedOrderInfo>;
  targetOrderId: Scalars["ID"];
};

export type MergeOrderSkuLineItemInfo = {
  skuId: Scalars["ID"];
};

export type MergeOrdersPayload = {
  __typename?: "MergeOrdersPayload";
  success: Scalars["Boolean"];
};

export type MergedOrderInfo = {
  bulkLineItems: Array<MergeOrderBulkLineItemInfo>;
  casepackLineItems: Array<MergeOrderCasepackLineItemInfo>;
  id: Scalars["ID"];
  skuLineItems: Array<MergeOrderSkuLineItemInfo>;
};

export type MergingAccountCriteriaPayload = {
  __typename?: "MergingAccountCriteriaPayload";
  ids: Array<Scalars["String"]>;
};

export type MergingOrderCriteriaPayload = {
  __typename?: "MergingOrderCriteriaPayload";
  message: Array<Scalars["String"]>;
  success: Scalars["Boolean"];
};

export type Message = {
  __typename?: "Message";
  /** ID of sender account */
  accountId: Scalars["ID"];
  attachment?: Maybe<Media>;
  body: Scalars["String"];
  id: Scalars["ID"];
  messageType?: Maybe<MessageType>;
  /** ID of message sent immediately previous to this message */
  parentId?: Maybe<Scalars["ID"]>;
  subject: Scalars["String"];
  /** ID of first message in thread sent between accounts */
  threadId: Scalars["ID"];
};

export type MessageCount = {
  __typename?: "MessageCount";
  count: Scalars["Int"];
};

export enum MessageType {
  Invitation = "INVITATION",
  Message = "MESSAGE",
}

export type Money = {
  __typename?: "Money";
  currencyCode: Scalars["String"];
  value: Scalars["Decimal"];
};

export type MoveToRetailWorkspaceInput = {
  /** The assortment to move to a retail workspace */
  assortmentId: Scalars["ID"];
  /** The id of the retail workspace to move the assortment to */
  retailWorkspaceId?: InputMaybe<Scalars["ID"]>;
  /** Season to assign to the moved assortment, overriding the existing season */
  seasonId?: InputMaybe<Scalars["ID"]>;
};

export type Mutation = {
  __typename?: "Mutation";
  AssortmentUI__assignProductColorImage?: Maybe<UploadColorImage>;
  AssortmentUI__bulkAddColorsToAssortmentProduct: AssortmentUi__BulkAddColorsToAssortmentProductResponse;
  AssortmentUI__bulkCreateAssortmentProduct: AssortmentUi__BulkCreateAssortmentProductResponse;
  AssortmentUI__createConfiguration?: Maybe<Configuration>;
  AssortmentUI__createRetailerExclusiveSku?: Maybe<AssortmentUi__CreateRetailerExclusiveSkuResponse>;
  AssortmentUI__deleteConfiguration?: Maybe<DeletePayload>;
  AssortmentUI__deleteSkuColorsForAssortment?: Maybe<AssortmentUi__Assortment>;
  AssortmentUI__removeProductImage?: Maybe<ImageRemoved>;
  AssortmentUI__updateConfiguration?: Maybe<Configuration>;
  AssortmentUI__updateRetailerExclusiveSku?: Maybe<AssortmentUi__UpdateRetailerExclusiveSkuResponse>;
  AssortmentUI__updateRowColorBulk: AssortmentUi_RowColorBulkQuantities;
  AssortmentUI__updateRowSizeBulk: AssortmentUi_RowSizeBulkQuantities;
  AssortmentUI__uploadProductColorImage?: Maybe<UploadColorImage>;
  AssortmentUI__uploadProductImage?: Maybe<UploadItemImage>;
  AssortmentUI__uploadSwatchImage?: Maybe<UploadSwatchImage>;
  UpdateRetailerPrimaryAccount: UpdateRetailerPrimaryAccount;
  _empty?: Maybe<Scalars["String"]>;
  acceptRequestConnection: AcceptRequestConnectionPayload;
  acceptUserMembershipRequest: AcceptUserMembershipRequestPayload;
  addAssortmentDoors: AddAssortmentDoorsPayload;
  addColorsToAssortment: AddColorsToAssortmentPayload;
  addInventoryAvailabilityGroup: AddInventoryAvailabilityGroupPayload;
  addProductsToOrders: AddProductsToOrdersPayload;
  addSkusToAssortment: AddSkusToAssortmentPayload;
  addStyleboardComment: StyleboardComment;
  addUnitsInProgress: AddUnitsInProgressPayload;
  addVariantsInProgress: AddVariantsInProgressPayload;
  anonymousCreateReachPayment: CreateReachPaymentPayload;
  anonymousUpdatePayment: UpdatePaymentPayload;
  applyAssortmentSkuColorAttributes: ApplyAssortmentSkuColorAttributesPayload;
  applySizeCurveToDoorColors: ApplySizeCurveToDoorColorsResponse;
  assignProductColorImage?: Maybe<AssignProductColorImageResult>;
  /** Move an assortment to a new retail workspace */
  assortmentMoveToRetailWorkspace?: Maybe<RetailWorkspacePayload>;
  bulkAddColorsToAssortmentProduct: BulkAddColorsToAssortmentProductResponse;
  bulkAddOrdersToHub: BulkAddOrdersToHubPayload;
  bulkAddProductsAndSkusToCollections: BulkAddProductsAndSkusToCollectionsPayload;
  bulkAddProductsToCollection: BulkAddProductsToCollectionPayload;
  bulkAddProductsToInventoryAvailabilityGroup: BulkAddProductsToInventoryAvailabilityGroupPayload;
  bulkAddWarehouses: BulkAddWarehousesPayload;
  bulkCancelOrdersVariants: BulkCancelOrdersVariantsPayload;
  bulkCopyOrders: BulkCopyOrdersPayload;
  bulkCreateAssortmentProduct: BulkCreateAssortmentProductResponse;
  bulkCreateCollaborationInvites: BulkCreateCollaborationInvitesPayload;
  bulkCreateCollaborationInvitesToAccounts: BulkCreateCollaborationInvitesPayload;
  bulkCreateCollectionGroups: BulkCreateCollectionGroupsPayload;
  bulkCreateCollections: BulkCreateCollectionsPayload;
  bulkCreateProducts: BulkCreateProductsPayload;
  bulkCreateSkuTraitValues: BulkCreateSkuTraitValuesPayload;
  bulkCreateUserMembershipRequests: BulkCreateUserMembershipRequestsPayload;
  bulkDeleteCollectionGroups: BulkDeleteCollectionGroupsPayload;
  bulkDeleteCollections: BulkDeleteCollectionsPayload;
  bulkDeleteDataPermissionConfigurations: BulkDeleteDataPermissionConfigurationsPayload;
  bulkDeleteExternalProviderAuths: BulkDeleteExternalProviderAuthsPayload;
  bulkDeleteProducts: BulkDeleteProductsPayload;
  bulkDeleteProductsFromAvailabilityGroup: BulkDeleteProductsFromAvailabilityGroupPayload;
  bulkDeleteRetailerLocations: BulkDeleteRetailerLocations;
  /** DELETE OPERATIONS */
  bulkDeleteRetailerUploads: BulkDeleteRetailerUploads;
  bulkDeleteWarehouses: BulkDeleteWarehousesPayload;
  bulkDuplicateCollections: BulkDuplicateCollectionsPayload;
  bulkMarkInventoryAvailabilityGroupsAsReceived: BulkMarkInventoryAvailabilityGroupsAsReceivedPayload;
  bulkMarkOrdersAsExported: BulkMarkOrdersAsExportedPayload;
  bulkRemoveProductsAndSkusFromCollections: BulkRemoveProductsAndSkusFromCollectionsPayload;
  bulkReplaceOrdersVariant: BulkReplaceOrdersVariantPayload;
  bulkScheduleForExport: BulkScheduleForExportPayload;
  bulkSetCollectionsDelivery: BulkSetCollectionsDeliveryPayload;
  bulkSetOrdersToReexport: BulkSetOrdersToReexportPayload;
  bulkSetProductsTraitValues: BulkSetProductsTraitValuesPayload;
  bulkSetSkuItemProperties: BulkSetSkuItemPropertiesPayload;
  bulkSetSkuUpcs: BulkSetSkuUpcsPayload;
  bulkUnscheduleForExport: BulkUnscheduleForExportPayload;
  bulkUpdateAssortmentDetails: BulkUpdateAssortmentDetailsPayload;
  bulkUpdateCollectionGroups: BulkUpdateCollectionGroupsPayload;
  bulkUpdateCollectionProducts?: Maybe<BulkUpdateCollectionProductsPayload>;
  bulkUpdateCollections: BulkUpdateCollectionsPayload;
  bulkUpdateCollectionsPosition: BulkUpdateCollectionsPositionPayload;
  bulkUpdateCollectionsPublic: BulkUpdateCollectionsPublicPayload;
  bulkUpdateInventoryItems: BulkUpdateInventoryItemsPayload;
  bulkUpdateOrderPricingByFilters: BulkUpdateOrderPricingByFiltersPayload;
  bulkUpdateOrderPricingByIds: BulkUpdateOrderPricingByIdsPayload;
  bulkUpdateOrderStatus: BulkUpdateOrderStatusPayload;
  bulkUpdateProducts: BulkUpdateProductsPayload;
  bulkUpdateRetailerGoogleAddresses: BulkUpdateRetailerGoogleAddressesPayload;
  bulkUpdateSkuTraitValues: BulkUpdateSkuTraitValuesPayload;
  bulkUpdateStorefronts: Array<Storefront>;
  bulkUpdateUserFavoriteCollections: BulkUpdateUserFavoriteCollectionsPayload;
  bulkUpdateWarehouses: BulkUpdateWarehousesPayload;
  bulkUpsertOrderEvents: BulkUpsertOrderEventsPayload;
  /** UPDATE OPERATIONS */
  bulkUpsertRetailerLocations: BulkUpsertRetailerLocations;
  bulkUpsertRetailerUploads: BulkUpsertRetailerUploadsPayload;
  bulkUpsertSkuExternalIdentifiers: BulkUpsertSkuExternalIdentifiersPayload;
  connectPaymentProvider: AccountPaymentProvider;
  copyAssortments: CopyAssortmentsPayload;
  createAchPayment: PaymentPayload;
  createAssortment: CreateAssortmentPayload;
  createAssortmentWithColors: CreateAssortmentPayload;
  createAssortmentsExportRecord: CreateAssortmentsExportRecordPayload;
  createAttribute: CreateAttributePayload;
  createAttributeOption: CreateAttributeOptionPayload;
  createAttributeOptionRuleForPriceModifier: CreateAttributeOptionRuleForPriceModifierPayload;
  createBrandDoor: CreateBrandDoorPayload;
  createBrandRuleForPriceModifier: CreateBrandRuleForPriceModifierPayload;
  createCollaborationInvite: CreateCollaborationInvitePayload;
  createCollectionBanners: CreateCollectionBannersPayload;
  createConfiguration?: Maybe<Configuration>;
  createConnectionBuyers?: Maybe<ConnectionBuyersPayload>;
  createConnectionDiscounts?: Maybe<ConnectionDiscountsPayload>;
  createConnectionDoors: Array<ConnectionDoor>;
  createConnectionPaymentMethods: Array<ConnectionPaymentMethod>;
  createConnectionPriceTypes?: Maybe<ConnectionPriceTypesPayload>;
  createConnectionSalesReps?: Maybe<ConnectionSalesRepsPayload>;
  createConnectionShippingMethods: Array<ConnectionShippingMethod>;
  createConnectionWarehouses: Array<ConnectionWarehouse>;
  createCustomAssortment: CreateAssortmentPayload;
  createDataPermissionConfiguration: CreateDataPermissionConfigurationPayload;
  createEvent?: Maybe<LibraryValue>;
  createExportIntegrationConfig: ExportIntegrationConfig;
  createExternalPayment: ExternalPayment;
  createExternalProviderAuth: ExternalProviderAuth;
  createFavoriteAccount: Favorite;
  createHub?: Maybe<Hub>;
  createIdentityProvider?: Maybe<CreateIdentityProviderPayload>;
  createInProgressOrdersWithUnits: CreateInProgressOrdersWithUnitsPayload;
  createInvoices: Array<OrderInvoice>;
  createManualPaymentRecord: ManualPaymentRecord;
  createMerchandisingHierarchyNode: CreateMerchandisingHierarchyNodePayload;
  createMerchandisingHierarchyRuleForPriceModifier: CreateMerchandisingHierarchyRuleForPriceModifierPayload;
  createMessage: Message;
  /** Create a new retail workspace with a single empty assortment */
  createNewRetailWorkspace: RetailWorkspacePayload;
  createOrderFromAssortment: CreateOrderFromAssortmentPayload;
  createOrphanInProgressOrdersWithUnits: CreateOrphanInProgressOrdersWithUnitsPayload;
  createPayment: PaymentPayload;
  createPaymentWithPaymentMethod: PaymentPayload;
  createRawOrdersExport: CreateRawOrdersExportPayload;
  createReachPayment: CreateReachPaymentPayload;
  createRegion: Region;
  /** Convert a bare assortment to a new retail workspace */
  createRetailWorkspace: RetailWorkspacePayload;
  createSeason: CreateSeasonPayload;
  createSepaPayment: PaymentPayload;
  createSkuPrices: BulkCreateSkuPricesPayload;
  createUser: CreateUserPayload;
  createUserMembershipInvite: MembershipInvitePayload;
  deleteAchBankAccount: DeletePaymentMethodPayload;
  deleteCollectionBanners: DeleteCollectionBannersPayload;
  deleteConfiguration?: Maybe<DeletePayload>;
  deleteConnectionBuyers?: Maybe<ConnectionBuyersPayload>;
  deleteConnectionDiscounts?: Maybe<DeleteConnectionDiscountsResponse>;
  deleteConnectionDoors: Array<Scalars["ID"]>;
  deleteConnectionPaymentMethods: Array<Scalars["ID"]>;
  deleteConnectionPriceTypes?: Maybe<DeleteConnectionPriceTypesResponse>;
  deleteConnectionSalesReps?: Maybe<DeleteConnectionSalesRepsResponse>;
  deleteConnectionShippingMethods: Array<Scalars["ID"]>;
  deleteConnectionWarehouses: Array<Scalars["ID"]>;
  deleteExportIntegrationConfigs?: Maybe<DeletePayload>;
  /** This mutation is used to soft delete external payments. */
  deleteExternalPayment: DeleteExternalPaymentPayload;
  deleteFavoriteAccount?: Maybe<DeletePayload>;
  deleteIdentityProvider?: Maybe<DeleteIdentityProviderPayload>;
  deleteManualPaymentRecord?: Maybe<DeleteManualPaymentRecordPayload>;
  deleteOrderLineItems?: Maybe<DeleteOrderLineItemsPayload>;
  deleteOrderVariants?: Maybe<DeleteOrderVariantsPayload>;
  deletePaymentMethod: DeletePaymentMethodPayload;
  deleteRegion?: Maybe<DeletePayload>;
  deleteShowroomCollections: Array<DeleteShowroomCollectionPayload>;
  deleteStorefronts: DeleteStorefrontsPayload;
  deleteStyleboards: Array<DeleteStyleboardPayload>;
  deleteUnavailableProducts: DeleteUnavailableProductsPayload;
  deleteUrl3dShowroom: DeleteUrl3dShowroomPayload;
  generateSummaryFile?: Maybe<GenerateSummaryFilePayload>;
  genericSetPriceModifierValue: Array<SetPriceModifierValuePayload>;
  getOrCreatePendingUsers: GetOrCreatePendingUsersPayload;
  getShowroomCollectionTokenizedLink: ShowroomCollectionTokenizedLink;
  handleRemoveAccountUser?: Maybe<HandleRemoveAccountUserPayload>;
  importValidatedOrders?: Maybe<ImportValidatedOrdersPayload>;
  /**
   * Marks a shared assortment as having been visited
   * @deprecated Sharing no longer supported
   */
  markAssortmentVisited: MarkAssortmentVisitedPayload;
  mergeAccounts: MergeAccountsPayload;
  mergeOrders: MergeOrdersPayload;
  public: PublicMutation;
  /** Removes door clusters from an assortment */
  removeAssortmentDoorClusters: RemoveAssortmentDoorClustersPayload;
  /** Removes doors from an assortment */
  removeAssortmentDoors: RemoveAssortmentDoorsPayload;
  removeAssortmentSkuColorAttributes: RemoveAssortmentSkuColorAttributesPayload;
  removeSelectedAssortmentAttributeOptions: RemoveSelectedAssortmentAttributeOptionsPayload;
  requestAssortmentOrderUpdate: RequestAssortmentOrderUpdatePayload;
  requestConnectionToRetailer: Array<RequestConnectionToRetailerPayload>;
  resetPaymentRecords?: Maybe<ResetPaymentRecordsPayload>;
  saveAchBankAccount: BankAccount;
  saveCreditCard: CreditCard;
  saveMethodAndCreatePayment: PaymentPayload;
  sendCollectionsToConnections: SendCollectionsToConnectionsPayload;
  sendEmailConfirmation: SendEmailConfirmationPayload;
  sendInvoicesForOrders?: Maybe<Array<Maybe<InvoiceDelivery>>>;
  sendJoorPayImInterestedEmail: SendJoorPayImInterestedEmailPayload;
  sendMessageToConnection: SendMessageToConnectionPayload;
  sendPayment: PaymentDelivery;
  sendStyleboardsToEmails: SendStyleboardsToEmailsPayload;
  setAssortmentColorBulkDoorQuantity?: Maybe<SetAssortmentColorBulkDoorQuantityPayload>;
  /** Creates or updates the fields of a Assortment Currency object */
  setAssortmentCurrencyConversion: Array<SetAssortmentCurrencyConversionPayload>;
  setAssortmentDefaultDoorClusters: SetAssortmentDefaultDoorClustersPayload;
  /** Creates or updates door clusters in an assortment */
  setAssortmentDoorClusters: SetAssortmentDoorClustersPayload;
  setAssortmentDoors: SetAssortmentDoorsPayload;
  setAssortmentMerchandisingHierarchy: SetAssortmentMerchandisingHierarchyPayload;
  setAssortmentProductRetailPrice: SetAssortmentProductPricePayload;
  setAssortmentProductWholesalePrice: SetAssortmentProductWholesalePricePayload;
  /**
   * Set the users that the assortment should be shared to
   * @deprecated Sharing no longer supported
   */
  setAssortmentShares: SetAssortmentSharesPayload;
  setAssortmentSizedDoorQuantity?: Maybe<SetAssortmentSizedDoorQuantityPayload>;
  setAssortmentSkuDoorLineItemBulkQuantity: Array<SetAssortmentSkuDoorLineItemBulkQuantityPayload>;
  setAssortmentSkuDoorLineItemQuantities: Array<AssortmentSkuDoorLineItemQuantityPayload>;
  setAssortmentSkuFinalRetailPrice: SetAssortmentSkuFinalRetailPricePayload;
  setAssortmentSkuRetailPrice: SetAssortmentSkuRetailPricePayload;
  /** Upserts a quantity for an unassigned SKU line item (no door or cluster) */
  setAssortmentSkuUnassignedLineItemQuantities: Array<AssortmentSkuUnassignedLineItemQuantityPayload>;
  /** Set or override the UPC for a SKU within a particular assortment */
  setAssortmentSkuUpc: SetAssortmentSkuUpcPayload;
  setAssortmentSkuWholesalePrice: SetAssortmentSkuWholesalePricePayload;
  setAttributeOptionFilterForAttributeOption: SetAttributeOptionFilterForAttributeOptionPayload;
  /** Creates or updates the fields of a currency conversion object */
  setCurrencyConversion: SetCurrencyConversionPayload;
  setDisplayLanguageForUser: SetDisplayLanguageForUserPayload;
  setImpersonatedUser?: Maybe<SetImpersonatedUserPayload>;
  setMerchandisingHierarchyFilterForAttributeOption: SetMerchandisingHierarchyFilterForAttributeOptionPayload;
  /** @deprecated Use genericSetPriceModifierValue instead */
  setPriceModifierValue: Array<SetPriceModifierValuePayload>;
  setProductSizeRun?: Maybe<SetProductSizeRunResponse>;
  setRetailerBrandFilterForAttributeOption: SetRetailerBrandFilterForAttributeOptionPayload;
  /**
   * Set custom retailer product sizes on an Assortment
   *
   * This will remove existing sizes associated with a product
   */
  setRetailerProductSizesOnAssortment: SetRetailerProductSizesOnAssortmentPayload;
  setSelectedAccount?: Maybe<SetSelectedAccountPayload>;
  /**
   * This mutation allows for setting multiple assortment attributes at a time. However,
   * this should not be used to set attributes that have a parent/child relationship in
   * the same request. Doing so will result in the option selected for the child attribute
   * to be overwritten.
   */
  setSelectedAssortmentAttributeOptions: SetSelectedAssortmentAttributeOptionsPayload;
  setSkuItemProperty: SetSkuItemPropertyPayload;
  /** sets the retail size on a sku note: assortmentId is required for this mutation to work properly */
  setSkuRetailSize?: Maybe<SetSkuRetailSizeResponse>;
  setUserPassword?: Maybe<SetUserPasswordPayload>;
  shareAndSendLinesheetsWithCollaborationInvitesEmails: ShareAndSendLinesheetsWithCollaborationInvitesEmailsPayload;
  shareAndSendStyleboardsWithCollaborationInvitesEmails: ShareAndSendStyleboardsWithCollaborationInvitesEmailsPayload;
  shareCollectionsWithRetailers: ShareCollectionsWithRetailersPayload;
  shareShowroomCollection: Array<ShowroomCollectionShare>;
  shareShowroomCollectionWithTeamMembers: TeamMemberShowroomCollectionShare;
  shareStyleboard: Array<StyleboardShare>;
  subscribeUserToFeature: SubscribeUserToFeaturePayload;
  /** Trigger a task to generate a generic assortment excel export */
  triggerAssortmentExcelExportTasks: TriggerAssortmentExcelExportTasksPayload;
  /** Trigger a custom self-serve assortment export */
  triggerAssortmentExport: TriggerAssortmentExportPayload;
  /** Trigger a task to generate a generic assortment PDF export */
  triggerAssortmentPdfExportTasks: TriggerAssortmentPdfExportTasksPayload;
  /** Trigger multiple custom self-serve assortment exports in bulk */
  triggerBulkAssortmentExport: TriggerAssortmentExportPayload;
  /** Trigger multiple custom self-serve product exports in bulk */
  triggerBulkProductExport: TriggerProductExportPayload;
  triggerOrdersPdfExportTasks: TriggerOrdersPdfExportTasksPayload;
  triggerResetPassword?: Maybe<TriggerResetPasswordPayload>;
  unSubscribeUserToFeature: UnSubscribeUserToFeaturePayload;
  unshareCollectionsWithRetailers: UnshareCollectionsWithRetailersPayload;
  unshareShowroomCollection: Array<ShowroomCollectionShare>;
  updateAccountPermissionAccess: UpdateAccountPermissionAccessPayload;
  updateAccountPrivacy: UpdateAccountPrivacyPayload;
  updateAccountProvider: AccountPaymentProvider;
  updateAccountUserDataPermissionConfiguration: UpdateAccountUserDataPermissionConfigurationPayload;
  updateAccountUserGeoRestrictions: AccountUserGeoRestrictions;
  updateAccountUserPossibleExceptions: Array<PermissionsAccount>;
  updateAccountUsersPermissionAccess: UpdateAccountUsersPermissionAccessPayload;
  updateAssortmentDetails: UpdateAssortmentDetailsPayload;
  updateAssortmentImportStatus: UpdateAssortmentImportStatusPayload;
  updateAttribute: UpdateAttributePayload;
  updateAttributeOption: UpdateAttributeOptionPayload;
  updateAttributeOptionRuleForPriceModifier: UpdateAttributeOptionRuleForPriceModifierPayload;
  updateAvailablePaymentMethods: AccountPaymentProvider;
  updateBrandRuleForPriceModifier: UpdateBrandRuleForPriceModifierPayload;
  updateCollaborationInvitesToAccount: UpdateUserCollaborationInvitePayload;
  updateCollectionBanners: UpdateCollectionBannersPayload;
  updateConfiguration?: Maybe<Configuration>;
  updateConnectionBuyers?: Maybe<ConnectionBuyersPayload>;
  updateConnectionDiscounts?: Maybe<ConnectionDiscountsPayload>;
  updateConnectionDoors: Array<ConnectionDoor>;
  updateConnectionPaymentMethods: Array<ConnectionPaymentMethod>;
  updateConnectionPriceTypes?: Maybe<ConnectionPriceTypesPayload>;
  updateConnectionSalesReps?: Maybe<ConnectionSalesRepsPayload>;
  updateConnectionShippingMethods: Array<ConnectionShippingMethod>;
  updateConnectionWarehouses: Array<ConnectionWarehouse>;
  updateDataPermissionConfiguration: CreateDataPermissionConfigurationPayload;
  updateExportIntegrationConfig: ExportIntegrationConfig;
  updateHub?: Maybe<Hub>;
  updateIdentityProvider?: Maybe<UpdateIdentityProviderPayload>;
  updateManualPaymentRecord: ManualPaymentRecord;
  updateMerchandisingHierarchyNode: UpdateMerchandisingHierarchyNodePayload;
  updateMerchandisingHierarchyRuleForPriceModifier: UpdateMerchandisingHierarchyRuleForPriceModifierPayload;
  updateOrderBilling: UpdateOrderPayload;
  updateOrderComments: UpdateOrderCommentsPayload;
  updateOrderCustomerRecordId: UpdateOrderCustomerRecordIdPayload;
  updateOrderCustomerShippingBilling: UpdateOrderPayload;
  updateOrderDeliveryInfo: UpdateOrderDeliveryInfoPayload;
  updateOrderDiscount?: Maybe<UpdateOrderDiscountPayload>;
  updateOrderInfo: UpdateOrderPayload;
  updateOrderProductDiscounts?: Maybe<UpdateOrderProductDiscountsPayload>;
  updateOrderShipping: UpdateOrderPayload;
  updateOrderShippingBilling: UpdateOrderPayload;
  updateOrders: OrdersPayload;
  updatePayment: UpdatePaymentPayload;
  updatePaymentSettings: AccountPaymentProvider;
  updateRegion: Region;
  /** Update retail workspace name */
  updateRetailWorkspaceName: RetailWorkspacePayload;
  updateRetailerImpersonationFeedback: UpdateRetailerImpersonationFeedbackPayload;
  updateRetailerProfile: LgRetailerProfile;
  updateSeason: UpdateSeasonPayload;
  updateShowroomCollections: Array<ShowroomCollection>;
  updateSkuPrices: BulkUpdateSkuPricesPayload;
  updateStyleboards: Array<Styleboard>;
  updateUserCollaborationInvite: UpdateUserCollaborationInvitePayload;
  uploadAttachmentToS3?: Maybe<UploadAttachmentToS3Payload>;
  uploadFileToS3?: Maybe<Media>;
  uploadProductColorImage?: Maybe<UploadProductColorImageResult>;
  uploadProductImage?: Maybe<UploadProductImageResult>;
  /**
   * Create or update the status of an account connection.
   * Currently only implemented for a retailer accepting a pending brand connection request
   * and a retailer sending a connection request to a brand.
   */
  upsertAccountConnectionStatuses: UpsertAccountConnectionStatusesPayload;
  /** Create or update the customer codes associated with other accounts. */
  upsertAccountCustomerCodes: Array<AccountCustomerCode>;
  upsertBillingAddresses: UpsertBillingAddressesPayload;
  upsertBrandProfile: PrivateBrandProfile;
  upsertCollectionTextStyles: UpsertCollectionTextStylesPayload;
  upsertOrderQuantities: UpsertOrderQuantitiesPayload;
  upsertRetailBudget?: Maybe<RetailBudget>;
  upsertShowroomCollection: ShowroomCollection;
  upsertStorefront: Storefront;
  upsertStorefrontTextStyles: Array<TextStyle>;
  upsertStyleboard: Styleboard;
  upsertUrl3dShowroom: Array<Url3dShowroom>;
  validateOrders?: Maybe<ValidateOrdersPayload>;
  verifyAchBankAccount: BankAccount;
  verifyUserEmail: VerifyUserEmailPayload;
};

export type MutationAssortmentUi__AssignProductColorImageArgs = {
  imageId: Scalars["String"];
  productColorId: Scalars["String"];
};

export type MutationAssortmentUi__BulkAddColorsToAssortmentProductArgs = {
  input: AssortmentUi__BulkAddColorsToAssortmentProductRequest;
};

export type MutationAssortmentUi__BulkCreateAssortmentProductArgs = {
  input: AssortmentUi__BulkCreateAssortmentProductRequest;
};

export type MutationAssortmentUi__CreateConfigurationArgs = {
  input: CreateConfigurationInput;
};

export type MutationAssortmentUi__CreateRetailerExclusiveSkuArgs = {
  input: AssortmentUi__CreateRetailerExclusiveSkuRequest;
};

export type MutationAssortmentUi__DeleteConfigurationArgs = {
  input: DeleteConfigurationInput;
};

export type MutationAssortmentUi__DeleteSkuColorsForAssortmentArgs = {
  assortmentId: Scalars["ID"];
  colorIds: Array<Scalars["ID"]>;
};

export type MutationAssortmentUi__RemoveProductImageArgs = {
  imageId: Scalars["String"];
};

export type MutationAssortmentUi__UpdateConfigurationArgs = {
  input: UpdateConfigurationInput;
};

export type MutationAssortmentUi__UpdateRetailerExclusiveSkuArgs = {
  input: AssortmentUi__UpdateRetailerExclusiveSkuRequest;
};

export type MutationAssortmentUi__UpdateRowColorBulkArgs = {
  assortmentId: Scalars["ID"];
  updates: Array<AssortmentUi__BulkColorUnitUpdate>;
};

export type MutationAssortmentUi__UpdateRowSizeBulkArgs = {
  assortmentId: Scalars["ID"];
  updates: Array<AssortmentUi__BulkSizeUnitUpdate>;
};

export type MutationAssortmentUi__UploadProductColorImageArgs = {
  file: Scalars["Upload"];
  productColorId: Scalars["String"];
};

export type MutationAssortmentUi__UploadProductImageArgs = {
  assortmentId: Scalars["String"];
  file: Scalars["Upload"];
  productId: Scalars["String"];
};

export type MutationAssortmentUi__UploadSwatchImageArgs = {
  assortmentId: Scalars["String"];
  colorId: Scalars["String"];
  file: Scalars["Upload"];
};

export type MutationUpdateRetailerPrimaryAccountArgs = {
  input: UpdateRetailerPrimaryAccountInput;
};

export type MutationAcceptRequestConnectionArgs = {
  input: AcceptRequestConnectionInput;
};

export type MutationAcceptUserMembershipRequestArgs = {
  input: AcceptUserMembershipRequestInput;
};

export type MutationAddAssortmentDoorsArgs = {
  input: AddAssortmentDoorsInput;
};

export type MutationAddColorsToAssortmentArgs = {
  input: AddColorsToAssortmentInput;
};

export type MutationAddInventoryAvailabilityGroupArgs = {
  input: AddInventoryAvailabilityGroupInput;
};

export type MutationAddProductsToOrdersArgs = {
  input: AddProductsToOrdersInput;
};

export type MutationAddSkusToAssortmentArgs = {
  input: AddSkusToAssortmentInput;
};

export type MutationAddStyleboardCommentArgs = {
  input: AddStyleboardCommentInput;
};

export type MutationAddUnitsInProgressArgs = {
  input: AddUnitsInProgressInput;
};

export type MutationAddVariantsInProgressArgs = {
  input: AddVariantsInProgressInput;
};

export type MutationAnonymousCreateReachPaymentArgs = {
  input: CreatePaymentWithPaymentMethodInput;
};

export type MutationAnonymousUpdatePaymentArgs = {
  input: UpdatePaymentInput;
};

export type MutationApplyAssortmentSkuColorAttributesArgs = {
  input: ApplyAssortmentSkuAttributesInput;
};

export type MutationApplySizeCurveToDoorColorsArgs = {
  input: ApplySizeCurveToDoorColorsRequest;
};

export type MutationAssignProductColorImageArgs = {
  imageId: Scalars["ID"];
  productColorId: Scalars["ID"];
};

export type MutationAssortmentMoveToRetailWorkspaceArgs = {
  input: MoveToRetailWorkspaceInput;
};

export type MutationBulkAddColorsToAssortmentProductArgs = {
  input: BulkAddColorsToAssortmentProductRequest;
};

export type MutationBulkAddOrdersToHubArgs = {
  input: BulkAddOrdersToHubInput;
};

export type MutationBulkAddProductsAndSkusToCollectionsArgs = {
  input: BulkAddProductsAndSkusToCollectionsInput;
};

export type MutationBulkAddProductsToCollectionArgs = {
  input: BulkAddProductsToCollectionInput;
};

export type MutationBulkAddProductsToInventoryAvailabilityGroupArgs = {
  input: BulkAddProductsToInventoryAvailabilityGroupInput;
};

export type MutationBulkAddWarehousesArgs = {
  input: BulkAddWarehousesInput;
};

export type MutationBulkCancelOrdersVariantsArgs = {
  input: BulkCancelOrdersVariantsInput;
};

export type MutationBulkCopyOrdersArgs = {
  input: BulkCopyOrdersInput;
};

export type MutationBulkCreateAssortmentProductArgs = {
  input: BulkCreateAssortmentProductRequest;
};

export type MutationBulkCreateCollaborationInvitesArgs = {
  input: BulkCreateCollaborationInvitesInput;
};

export type MutationBulkCreateCollaborationInvitesToAccountsArgs = {
  input: BulkCreateCollaborationInvitesToAccountsInput;
};

export type MutationBulkCreateCollectionGroupsArgs = {
  input: BulkCreateCollectionGroupsInput;
};

export type MutationBulkCreateCollectionsArgs = {
  input: BulkCreateCollectionsInput;
};

export type MutationBulkCreateProductsArgs = {
  input: BulkCreateProductsInput;
};

export type MutationBulkCreateSkuTraitValuesArgs = {
  input: BulkCreateSkuTraitValuesInput;
};

export type MutationBulkCreateUserMembershipRequestsArgs = {
  input: BulkCreateUserMembershipRequestsInput;
};

export type MutationBulkDeleteCollectionGroupsArgs = {
  input: BulkDeleteCollectionGroupsInput;
};

export type MutationBulkDeleteCollectionsArgs = {
  input: BulkDeleteCollectionsInput;
};

export type MutationBulkDeleteDataPermissionConfigurationsArgs = {
  input: BulkDeleteDataPermissionConfigurationsInput;
};

export type MutationBulkDeleteExternalProviderAuthsArgs = {
  input: BulkDeleteExternalProviderAuthsInput;
};

export type MutationBulkDeleteProductsArgs = {
  input: BulkDeleteProductsInput;
};

export type MutationBulkDeleteProductsFromAvailabilityGroupArgs = {
  input: BulkDeleteProductsFromAvailabilityGroupInput;
};

export type MutationBulkDeleteRetailerLocationsArgs = {
  input: BulkDeleteRetailerLocationsInput;
};

export type MutationBulkDeleteRetailerUploadsArgs = {
  input: BulkDeleteRetailerUploadsInput;
};

export type MutationBulkDeleteWarehousesArgs = {
  input: BulkDeleteWarehousesInput;
};

export type MutationBulkDuplicateCollectionsArgs = {
  input: BulkDuplicateCollectionsInput;
};

export type MutationBulkMarkInventoryAvailabilityGroupsAsReceivedArgs = {
  input: BulkMarkInventoryAvailabilityGroupsAsReceivedInput;
};

export type MutationBulkMarkOrdersAsExportedArgs = {
  input: BulkMarkOrdersAsExportedInput;
};

export type MutationBulkRemoveProductsAndSkusFromCollectionsArgs = {
  input: BulkRemoveProductsAndSkusFromCollectionsInput;
};

export type MutationBulkReplaceOrdersVariantArgs = {
  input: BulkReplaceOrdersVariantInput;
};

export type MutationBulkScheduleForExportArgs = {
  input: BulkScheduleForExportInput;
};

export type MutationBulkSetCollectionsDeliveryArgs = {
  input: BulkSetCollectionsDeliveryInput;
};

export type MutationBulkSetOrdersToReexportArgs = {
  input: BulkSetOrdersToReexportInput;
};

export type MutationBulkSetProductsTraitValuesArgs = {
  input: BulkSetProductsTraitValuesInput;
};

export type MutationBulkSetSkuItemPropertiesArgs = {
  input?: InputMaybe<Array<SetSkuItemPropertyInput>>;
};

export type MutationBulkSetSkuUpcsArgs = {
  input: BulkSetSkuUpcsInput;
};

export type MutationBulkUnscheduleForExportArgs = {
  input: BulkUnscheduleForExportInput;
};

export type MutationBulkUpdateAssortmentDetailsArgs = {
  input: Array<UpdateAssortmentDetailsInput>;
};

export type MutationBulkUpdateCollectionGroupsArgs = {
  input: BulkUpdateCollectionGroupsInput;
};

export type MutationBulkUpdateCollectionProductsArgs = {
  input: BulkUpdateCollectionProductsInput;
};

export type MutationBulkUpdateCollectionsArgs = {
  input: BulkUpdateCollectionsInput;
};

export type MutationBulkUpdateCollectionsPositionArgs = {
  input: BulkUpdateCollectionsPositionInput;
};

export type MutationBulkUpdateCollectionsPublicArgs = {
  input: BulkUpdateCollectionsPublicInput;
};

export type MutationBulkUpdateInventoryItemsArgs = {
  input: BulkUpdateInventoryItemsInput;
};

export type MutationBulkUpdateOrderPricingByFiltersArgs = {
  input: BulkUpdateOrderPricingByFiltersInput;
};

export type MutationBulkUpdateOrderPricingByIdsArgs = {
  input: BulkUpdateOrderPricingByIdsInput;
};

export type MutationBulkUpdateOrderStatusArgs = {
  input: BulkUpdateOrderStatusInput;
};

export type MutationBulkUpdateProductsArgs = {
  input: BulkUpdateProductsInput;
};

export type MutationBulkUpdateRetailerGoogleAddressesArgs = {
  input: Array<BulkUpdateRetailerGoogleAddressesInput>;
};

export type MutationBulkUpdateSkuTraitValuesArgs = {
  input: BulkUpdateSkuTraitValuesInput;
};

export type MutationBulkUpdateStorefrontsArgs = {
  input: BulkUpdateStorefrontsInput;
};

export type MutationBulkUpdateUserFavoriteCollectionsArgs = {
  input: BulkUpdateUserFavoriteCollectionsInput;
};

export type MutationBulkUpdateWarehousesArgs = {
  input: BulkUpdateWarehousesInput;
};

export type MutationBulkUpsertOrderEventsArgs = {
  input: BulkUpsertOrderEventsInput;
};

export type MutationBulkUpsertRetailerLocationsArgs = {
  input: BulkUpsertRetailerLocationsInput;
};

export type MutationBulkUpsertRetailerUploadsArgs = {
  input: BulkUpsertRetailerUploadsInput;
};

export type MutationBulkUpsertSkuExternalIdentifiersArgs = {
  input: BulkUpsertSkuExternalIdentifiersInput;
};

export type MutationConnectPaymentProviderArgs = {
  input: ConnectPaymentProviderInput;
};

export type MutationCopyAssortmentsArgs = {
  input: CopyAssortmentsInput;
};

export type MutationCreateAchPaymentArgs = {
  input: CreatePaymentWithPaymentMethodInput;
};

export type MutationCreateAssortmentArgs = {
  input: CreateAssortmentInput;
};

export type MutationCreateAssortmentWithColorsArgs = {
  input: CreateAssortmentWithColorsInput;
};

export type MutationCreateAssortmentsExportRecordArgs = {
  input: CreateAssortmentsExportRecordInput;
};

export type MutationCreateAttributeArgs = {
  input: CreateAttributeInput;
};

export type MutationCreateAttributeOptionArgs = {
  input: CreateAttributeOptionInput;
};

export type MutationCreateAttributeOptionRuleForPriceModifierArgs = {
  input: CreateAttributeOptionRuleForPriceModifierInput;
};

export type MutationCreateBrandDoorArgs = {
  input: CreateBrandDoorInput;
};

export type MutationCreateBrandRuleForPriceModifierArgs = {
  input: CreateBrandRuleForPriceModifierInput;
};

export type MutationCreateCollaborationInviteArgs = {
  input: CreateCollaborationInviteInput;
};

export type MutationCreateCollectionBannersArgs = {
  input: CreateCollectionBannersInput;
};

export type MutationCreateConfigurationArgs = {
  input: CreateConfigurationInput;
};

export type MutationCreateConnectionBuyersArgs = {
  input: Array<CreateConnectionBuyerInput>;
};

export type MutationCreateConnectionDiscountsArgs = {
  input: Array<CreateConnectionDiscountInput>;
};

export type MutationCreateConnectionDoorsArgs = {
  input: Array<ConnectionDoorInput>;
};

export type MutationCreateConnectionPaymentMethodsArgs = {
  input: Array<ConnectionPaymentMethodInput>;
};

export type MutationCreateConnectionPriceTypesArgs = {
  input: Array<CreateConnectionPriceTypeInput>;
};

export type MutationCreateConnectionSalesRepsArgs = {
  input: Array<CreateConnectionSalesRepInput>;
};

export type MutationCreateConnectionShippingMethodsArgs = {
  input: Array<ConnectionShippingMethodInput>;
};

export type MutationCreateConnectionWarehousesArgs = {
  input: Array<ConnectionWarehouseInput>;
};

export type MutationCreateCustomAssortmentArgs = {
  input: CreateCustomAssortmentInput;
};

export type MutationCreateDataPermissionConfigurationArgs = {
  input: CreateDataPermissionConfigurationInput;
};

export type MutationCreateEventArgs = {
  input: CreateEventInput;
};

export type MutationCreateExportIntegrationConfigArgs = {
  input: CreateExportIntegrationConfigInput;
};

export type MutationCreateExternalPaymentArgs = {
  input: CreateExternalPaymentInput;
};

export type MutationCreateExternalProviderAuthArgs = {
  input: CreateExternalProviderAuthInput;
};

export type MutationCreateFavoriteAccountArgs = {
  input: AddFavoriteAccountInput;
};

export type MutationCreateHubArgs = {
  input: CreateHubInput;
};

export type MutationCreateIdentityProviderArgs = {
  input: CreateIdentityProviderInput;
};

export type MutationCreateInProgressOrdersWithUnitsArgs = {
  input: CreateInProgressOrdersWithUnitsInput;
};

export type MutationCreateInvoicesArgs = {
  input: CreateInvoicesInput;
};

export type MutationCreateManualPaymentRecordArgs = {
  input: CreateManualPaymentRecordInput;
};

export type MutationCreateMerchandisingHierarchyNodeArgs = {
  input: CreateMerchandisingHierarchyNodeInput;
};

export type MutationCreateMerchandisingHierarchyRuleForPriceModifierArgs = {
  input: CreateMerchandisingHierarchyRuleForPriceModifierInput;
};

export type MutationCreateMessageArgs = {
  input: CreateMessageInput;
};

export type MutationCreateNewRetailWorkspaceArgs = {
  input: CreateNewRetailWorkspaceInput;
};

export type MutationCreateOrderFromAssortmentArgs = {
  input: CreateOrderFromAssortmentInput;
};

export type MutationCreateOrphanInProgressOrdersWithUnitsArgs = {
  input: CreateOrphanInProgressOrdersWithUnitsInput;
};

export type MutationCreatePaymentArgs = {
  input: CreatePaymentWithPaymentMethodInput;
};

export type MutationCreatePaymentWithPaymentMethodArgs = {
  input: CreatePaymentWithPaymentMethodInput;
};

export type MutationCreateReachPaymentArgs = {
  input: CreatePaymentWithPaymentMethodInput;
};

export type MutationCreateRegionArgs = {
  input: CreateRegionInput;
};

export type MutationCreateRetailWorkspaceArgs = {
  input: CreateRetailWorkspaceInput;
};

export type MutationCreateSeasonArgs = {
  input: CreateSeasonInput;
};

export type MutationCreateSepaPaymentArgs = {
  input: CreatePaymentWithPaymentMethodInput;
};

export type MutationCreateSkuPricesArgs = {
  input: BulkCreateSkuPricesInput;
};

export type MutationCreateUserArgs = {
  input: CreateUserInput;
};

export type MutationCreateUserMembershipInviteArgs = {
  input: CreateUserMembershipInviteInput;
};

export type MutationDeleteAchBankAccountArgs = {
  input: PaymentMethodInput;
};

export type MutationDeleteCollectionBannersArgs = {
  input: DeleteCollectionBannersInput;
};

export type MutationDeleteConfigurationArgs = {
  input: DeleteConfigurationInput;
};

export type MutationDeleteConnectionBuyersArgs = {
  input: Array<DeleteConnectionBuyerInput>;
};

export type MutationDeleteConnectionDiscountsArgs = {
  input: Array<DeleteConnectionDiscountInput>;
};

export type MutationDeleteConnectionDoorsArgs = {
  input: Array<ConnectionDoorInput>;
};

export type MutationDeleteConnectionPaymentMethodsArgs = {
  input: Array<ConnectionPaymentMethodInput>;
};

export type MutationDeleteConnectionPriceTypesArgs = {
  input: Array<DeleteConnectionPriceTypeInput>;
};

export type MutationDeleteConnectionSalesRepsArgs = {
  input: Array<DeleteConnectionSalesRepInput>;
};

export type MutationDeleteConnectionShippingMethodsArgs = {
  input: Array<ConnectionShippingMethodInput>;
};

export type MutationDeleteConnectionWarehousesArgs = {
  input: Array<ConnectionWarehouseInput>;
};

export type MutationDeleteExportIntegrationConfigsArgs = {
  input: DeleteExportIntegrationConfigsInput;
};

export type MutationDeleteExternalPaymentArgs = {
  input: DeleteExternalPaymentInput;
};

export type MutationDeleteFavoriteAccountArgs = {
  input: DeleteFavoriteAccountInput;
};

export type MutationDeleteIdentityProviderArgs = {
  input: DeleteIdentityProviderInput;
};

export type MutationDeleteManualPaymentRecordArgs = {
  input: DeleteManualPaymentRecordInput;
};

export type MutationDeleteOrderLineItemsArgs = {
  input: DeleteOrderLineItemsInput;
};

export type MutationDeleteOrderVariantsArgs = {
  input: DeleteOrderVariantsInput;
};

export type MutationDeletePaymentMethodArgs = {
  input: PaymentMethodInput;
};

export type MutationDeleteRegionArgs = {
  input: DeleteRegionInput;
};

export type MutationDeleteShowroomCollectionsArgs = {
  input: DeleteShowroomCollectionsInput;
};

export type MutationDeleteStorefrontsArgs = {
  ids: Array<Scalars["ID"]>;
};

export type MutationDeleteStyleboardsArgs = {
  input: DeleteStyleboardsInput;
};

export type MutationDeleteUnavailableProductsArgs = {
  input: DeleteUnavailableProductsInput;
};

export type MutationDeleteUrl3dShowroomArgs = {
  input: DeleteUrl3dShowroomInput;
};

export type MutationGenerateSummaryFileArgs = {
  input: GenerateSummaryFileInput;
};

export type MutationGenericSetPriceModifierValueArgs = {
  input: Array<GenericSetPriceModifierValueInput>;
};

export type MutationGetOrCreatePendingUsersArgs = {
  input: GetOrCreatePendingUsersInput;
};

export type MutationGetShowroomCollectionTokenizedLinkArgs = {
  input: GetShowroomCollectionTokenizedLinkInput;
};

export type MutationHandleRemoveAccountUserArgs = {
  input: HandleRemoveAccountUserInput;
};

export type MutationImportValidatedOrdersArgs = {
  input: ImportValidatedOrdersInput;
};

export type MutationMarkAssortmentVisitedArgs = {
  input: MarkAssortmentVisitedInput;
};

export type MutationMergeAccountsArgs = {
  input: MergeAccountsInput;
};

export type MutationMergeOrdersArgs = {
  input: MergeOrderInput;
};

export type MutationRemoveAssortmentDoorClustersArgs = {
  input: RemoveAssortmentDoorClustersInput;
};

export type MutationRemoveAssortmentDoorsArgs = {
  input: RemoveAssortmentDoorsInput;
};

export type MutationRemoveAssortmentSkuColorAttributesArgs = {
  input: RemoveAssortmentSkuAttributesInput;
};

export type MutationRemoveSelectedAssortmentAttributeOptionsArgs = {
  input: RemoveSelectedAssortmentAttributeOptionsInput;
};

export type MutationRequestAssortmentOrderUpdateArgs = {
  input: RequestAssortmentOrderUpdateInput;
};

export type MutationRequestConnectionToRetailerArgs = {
  input: RequestConnectionToRetailerInput;
};

export type MutationResetPaymentRecordsArgs = {
  input: ResetPaymentRecordsInput;
};

export type MutationSaveAchBankAccountArgs = {
  input: PaymentMethodInput;
};

export type MutationSaveCreditCardArgs = {
  input: PaymentMethodInput;
};

export type MutationSaveMethodAndCreatePaymentArgs = {
  input: CreatePaymentWithPaymentMethodInput;
};

export type MutationSendCollectionsToConnectionsArgs = {
  input: SendCollectionsToConnectionsInput;
};

export type MutationSendEmailConfirmationArgs = {
  input: SendEmailConfirmationInput;
};

export type MutationSendInvoicesForOrdersArgs = {
  input: SendInvoicesForOrdersInput;
};

export type MutationSendJoorPayImInterestedEmailArgs = {
  input: SendJoorPayImInterestedEmailInput;
};

export type MutationSendMessageToConnectionArgs = {
  input: SendMessageToConnectionInput;
};

export type MutationSendPaymentArgs = {
  input: SendPaymentInput;
};

export type MutationSendStyleboardsToEmailsArgs = {
  input: SendStyleboardsToEmailsInput;
};

export type MutationSetAssortmentColorBulkDoorQuantityArgs = {
  input: SetAssortmentColorBulkDoorQuantityInput;
};

export type MutationSetAssortmentCurrencyConversionArgs = {
  input: Array<SetAssortmentCurrencyConversionInput>;
};

export type MutationSetAssortmentDefaultDoorClustersArgs = {
  input: SetAssormentDefaultDoorClustersInput;
};

export type MutationSetAssortmentDoorClustersArgs = {
  input: SetAssortmentDoorClustersInput;
};

export type MutationSetAssortmentDoorsArgs = {
  input: SetAssortmentDoorsInput;
};

export type MutationSetAssortmentMerchandisingHierarchyArgs = {
  input: SetAssortmentMerchandisingHierarchyInput;
};

export type MutationSetAssortmentProductRetailPriceArgs = {
  input: SetAssortmentProductRetailPriceInput;
};

export type MutationSetAssortmentProductWholesalePriceArgs = {
  input: SetAssortmentProductWholesalePriceInput;
};

export type MutationSetAssortmentSharesArgs = {
  input: SetAssortmentSharesInput;
};

export type MutationSetAssortmentSizedDoorQuantityArgs = {
  input: SetAssortmentSizedDoorQuantityInput;
};

export type MutationSetAssortmentSkuDoorLineItemBulkQuantityArgs = {
  input: Array<AssortmentSkuDoorLineItemBulkQuantity>;
};

export type MutationSetAssortmentSkuDoorLineItemQuantitiesArgs = {
  input: Array<AssortmentSkuDoorLineItemQuantityInput>;
};

export type MutationSetAssortmentSkuFinalRetailPriceArgs = {
  input: SetAssortmentSkuFinalRetailPriceInput;
};

export type MutationSetAssortmentSkuRetailPriceArgs = {
  input: SetAssortmentSkuRetailPriceInput;
};

export type MutationSetAssortmentSkuUnassignedLineItemQuantitiesArgs = {
  input: Array<AssortmentSkuUnassignedLineItemQuantityInput>;
};

export type MutationSetAssortmentSkuUpcArgs = {
  input: SetAssortmentSkuUpcInput;
};

export type MutationSetAssortmentSkuWholesalePriceArgs = {
  input: SetAssortmentSkuWholesalePriceInput;
};

export type MutationSetAttributeOptionFilterForAttributeOptionArgs = {
  input: SetAttributeOptionFilterForAttributeOptionInput;
};

export type MutationSetCurrencyConversionArgs = {
  input: SetCurrencyConversionInput;
};

export type MutationSetDisplayLanguageForUserArgs = {
  input: SetDisplayLanguageForUserInput;
};

export type MutationSetImpersonatedUserArgs = {
  input: SetImpersonatedUserInput;
};

export type MutationSetMerchandisingHierarchyFilterForAttributeOptionArgs = {
  input: SetMerchandisingHierarchyFilterForAttributeOptionInput;
};

export type MutationSetPriceModifierValueArgs = {
  input: Array<SetPriceModifierValueInput>;
};

export type MutationSetProductSizeRunArgs = {
  productId: Scalars["ID"];
  sizeRunId: Scalars["ID"];
};

export type MutationSetRetailerBrandFilterForAttributeOptionArgs = {
  input: SetRetailerBrandFilterForAttributeOptionInput;
};

export type MutationSetRetailerProductSizesOnAssortmentArgs = {
  input: SetRetailerProductSizesOnAssortmentInput;
};

export type MutationSetSelectedAccountArgs = {
  input: SetSelectedAccountInput;
};

export type MutationSetSelectedAssortmentAttributeOptionsArgs = {
  input: SetSelectedAssortmentAttributeOptionsInput;
};

export type MutationSetSkuItemPropertyArgs = {
  input: SetSkuItemPropertyInput;
};

export type MutationSetSkuRetailSizeArgs = {
  assortmentId?: InputMaybe<Scalars["ID"]>;
  retailSizeId: Scalars["ID"];
  skuId: Scalars["ID"];
};

export type MutationSetUserPasswordArgs = {
  input: SetUserPasswordInput;
};

export type MutationShareAndSendLinesheetsWithCollaborationInvitesEmailsArgs = {
  input: ShareAndSendLinesheetsWithCollaborationInvitesEmailsInput;
};

export type MutationShareAndSendStyleboardsWithCollaborationInvitesEmailsArgs =
  {
    input: ShareAndSendStyleboardsWithCollaborationInvitesEmailsInput;
  };

export type MutationShareCollectionsWithRetailersArgs = {
  input: ShareCollectionsWithRetailersInput;
};

export type MutationShareShowroomCollectionArgs = {
  input: ShareShowroomCollectionInput;
};

export type MutationShareShowroomCollectionWithTeamMembersArgs = {
  input: ShareShowroomCollectionWithTeamMembersInput;
};

export type MutationShareStyleboardArgs = {
  input: ShareStyleboardInput;
};

export type MutationSubscribeUserToFeatureArgs = {
  input: SubscribeUserToFeatureInput;
};

export type MutationTriggerAssortmentExcelExportTasksArgs = {
  input: TriggerAssortmentExcelExportTasksInput;
};

export type MutationTriggerAssortmentExportArgs = {
  input: TriggerAssortmentExportInput;
};

export type MutationTriggerAssortmentPdfExportTasksArgs = {
  input: TriggerAssortmentPdfExportTasksInput;
};

export type MutationTriggerBulkAssortmentExportArgs = {
  input: TriggerBulkAssortmentExportInput;
};

export type MutationTriggerBulkProductExportArgs = {
  input: TriggerBulkProductExportInput;
};

export type MutationTriggerOrdersPdfExportTasksArgs = {
  input: TriggerOrdersPdfExportTasksInput;
};

export type MutationTriggerResetPasswordArgs = {
  input: TriggerResetPasswordInput;
};

export type MutationUnSubscribeUserToFeatureArgs = {
  input: UnSubscribeUserToFeatureInput;
};

export type MutationUnshareCollectionsWithRetailersArgs = {
  input: Array<UnshareCollectionsWithRetailersInput>;
};

export type MutationUnshareShowroomCollectionArgs = {
  input: UnshareShowroomCollectionInput;
};

export type MutationUpdateAccountPermissionAccessArgs = {
  input: UpdateAccountPermissionAccessInput;
};

export type MutationUpdateAccountPrivacyArgs = {
  input: UpdateAccountPrivacyInput;
};

export type MutationUpdateAccountProviderArgs = {
  input: ConnectPaymentProviderInput;
};

export type MutationUpdateAccountUserDataPermissionConfigurationArgs = {
  input: UpdateAccountUserDataPermissionConfigurationInput;
};

export type MutationUpdateAccountUserGeoRestrictionsArgs = {
  input: UpdateAccountUserGeoRestrictionsInput;
};

export type MutationUpdateAccountUserPossibleExceptionsArgs = {
  input: UpdateAccountUserPossibleExceptionsInput;
};

export type MutationUpdateAccountUsersPermissionAccessArgs = {
  input: UpdateAccountUsersPermissionAccessInput;
};

export type MutationUpdateAssortmentDetailsArgs = {
  input: UpdateAssortmentDetailsInput;
};

export type MutationUpdateAssortmentImportStatusArgs = {
  input: UpdateAssortmentImportStatusInput;
};

export type MutationUpdateAttributeArgs = {
  input: UpdateAttributeInput;
};

export type MutationUpdateAttributeOptionArgs = {
  input: UpdateAttributeOptionInput;
};

export type MutationUpdateAttributeOptionRuleForPriceModifierArgs = {
  input: UpdateAttributeOptionRuleForPriceModifierInput;
};

export type MutationUpdateAvailablePaymentMethodsArgs = {
  input: UpdateAvailablePaymentMethodsInput;
};

export type MutationUpdateBrandRuleForPriceModifierArgs = {
  input: UpdateBrandRuleForPriceModifierInput;
};

export type MutationUpdateCollaborationInvitesToAccountArgs = {
  input: UpdateCollaborationInvitesToAccountInput;
};

export type MutationUpdateCollectionBannersArgs = {
  input: UpdateCollectionBannersInput;
};

export type MutationUpdateConfigurationArgs = {
  input: UpdateConfigurationInput;
};

export type MutationUpdateConnectionBuyersArgs = {
  input: Array<UpdateConnectionBuyerInput>;
};

export type MutationUpdateConnectionDiscountsArgs = {
  input: Array<UpdateConnectionDiscountInput>;
};

export type MutationUpdateConnectionDoorsArgs = {
  input: Array<ConnectionDoorInput>;
};

export type MutationUpdateConnectionPaymentMethodsArgs = {
  input: Array<ConnectionPaymentMethodInput>;
};

export type MutationUpdateConnectionPriceTypesArgs = {
  input: Array<UpdateConnectionPriceTypeInput>;
};

export type MutationUpdateConnectionSalesRepsArgs = {
  input: Array<UpdateConnectionSalesRepInput>;
};

export type MutationUpdateConnectionShippingMethodsArgs = {
  input: Array<ConnectionShippingMethodInput>;
};

export type MutationUpdateConnectionWarehousesArgs = {
  input: Array<ConnectionWarehouseInput>;
};

export type MutationUpdateDataPermissionConfigurationArgs = {
  input: UpdateDataPermissionConfigurationInput;
};

export type MutationUpdateExportIntegrationConfigArgs = {
  input: UpdateExportIntegrationConfigInput;
};

export type MutationUpdateHubArgs = {
  input: UpdateHubInput;
};

export type MutationUpdateIdentityProviderArgs = {
  input: UpdateIdentityProviderInput;
};

export type MutationUpdateManualPaymentRecordArgs = {
  input: UpdateManualPaymentRecordInput;
};

export type MutationUpdateMerchandisingHierarchyNodeArgs = {
  input: UpdateMerchandisingHierarchyNodeInput;
};

export type MutationUpdateMerchandisingHierarchyRuleForPriceModifierArgs = {
  input: UpdateMerchandisingHierarchyRuleForPriceModifierInput;
};

export type MutationUpdateOrderBillingArgs = {
  input: UpdateOrderBillingInput;
};

export type MutationUpdateOrderCommentsArgs = {
  input: UpdateOrderCommentsInput;
};

export type MutationUpdateOrderCustomerRecordIdArgs = {
  input: UpdateOrderCustomerRecordIdInput;
};

export type MutationUpdateOrderCustomerShippingBillingArgs = {
  input: UpdateOrderCustomerShippingBillingInput;
};

export type MutationUpdateOrderDeliveryInfoArgs = {
  input: UpdateOrderDeliveryInfoInput;
};

export type MutationUpdateOrderDiscountArgs = {
  input: UpdateOrderDiscountInput;
};

export type MutationUpdateOrderInfoArgs = {
  input?: InputMaybe<UpdateOrderInfoInput>;
};

export type MutationUpdateOrderProductDiscountsArgs = {
  input: UpdateOrderProductDiscountsInput;
};

export type MutationUpdateOrderShippingArgs = {
  input: UpdateOrderShippingInput;
};

export type MutationUpdateOrderShippingBillingArgs = {
  input: UpdateOrderShippingBillingInput;
};

export type MutationUpdateOrdersArgs = {
  input: UpdateOrdersConnection;
};

export type MutationUpdatePaymentArgs = {
  input: UpdatePaymentInput;
};

export type MutationUpdatePaymentSettingsArgs = {
  input: UpdatePaymentSettingsInput;
};

export type MutationUpdateRegionArgs = {
  input: UpdateRegionInput;
};

export type MutationUpdateRetailWorkspaceNameArgs = {
  input: UpdateRetailWorkspaceNameInput;
};

export type MutationUpdateRetailerImpersonationFeedbackArgs = {
  input: RetailerImpersonationFeedbackInput;
};

export type MutationUpdateRetailerProfileArgs = {
  input: UpdateRetailerProfileInput;
};

export type MutationUpdateSeasonArgs = {
  input: UpdateSeasonInput;
};

export type MutationUpdateShowroomCollectionsArgs = {
  input: UpdateShowroomCollectionsInput;
};

export type MutationUpdateSkuPricesArgs = {
  input: BulkUpdateSkuPricesInput;
};

export type MutationUpdateStyleboardsArgs = {
  input: UpdateStyleboardsInput;
};

export type MutationUpdateUserCollaborationInviteArgs = {
  input: UpdateUserCollaborationInviteInput;
};

export type MutationUploadAttachmentToS3Args = {
  input: UploadAttachmentToS3Input;
};

export type MutationUploadFileToS3Args = {
  input: UploadFileToS3Input;
};

export type MutationUploadProductColorImageArgs = {
  file: Scalars["Upload"];
  productColorId: Scalars["ID"];
};

export type MutationUploadProductImageArgs = {
  assortmentId: Scalars["ID"];
  file: Scalars["Upload"];
  productId: Scalars["ID"];
};

export type MutationUpsertAccountConnectionStatusesArgs = {
  input: UpsertAccountConnectionStatusesInput;
};

export type MutationUpsertAccountCustomerCodesArgs = {
  input: UpsertAccountCustomerCodesInput;
};

export type MutationUpsertBillingAddressesArgs = {
  input: Array<BillingAddressInput>;
};

export type MutationUpsertBrandProfileArgs = {
  input: UpsertBrandProfileInput;
};

export type MutationUpsertCollectionTextStylesArgs = {
  input: UpsertCollectionTextStylesInput;
};

export type MutationUpsertOrderQuantitiesArgs = {
  input: UpsertOrderQuantitiesInput;
};

export type MutationUpsertRetailBudgetArgs = {
  input: RetailBudgetInput;
};

export type MutationUpsertShowroomCollectionArgs = {
  input: UpsertShowroomCollectionInput;
};

export type MutationUpsertStorefrontArgs = {
  input: UpsertStorefrontInput;
};

export type MutationUpsertStorefrontTextStylesArgs = {
  input: UpsertStorefrontTextStylesInput;
};

export type MutationUpsertStyleboardArgs = {
  input: UpsertStyleboardInput;
};

export type MutationUpsertUrl3dShowroomArgs = {
  input: UpsertUrl3dShowroomInput;
};

export type MutationValidateOrdersArgs = {
  orderSettings: OrderInputSettings;
  settings?: InputMaybe<ValidateOrdersSettings>;
  templateId: Scalars["ID"];
  url: Scalars["String"];
};

export type MutationVerifyAchBankAccountArgs = {
  input: VerifyAchBankAccountInput;
};

export type MutationVerifyUserEmailArgs = {
  input: VerifyUserEmailInput;
};

export type NewOrdersInfo = {
  brandId: Scalars["ID"];
  buyerEmail?: InputMaybe<Scalars["String"]>;
  buyerName?: InputMaybe<Scalars["String"]>;
  doorIds?: InputMaybe<Array<Scalars["ID"]>>;
  eventId?: InputMaybe<Scalars["ID"]>;
  inventoryId?: InputMaybe<Scalars["ID"]>;
  priceTypeId: Scalars["ID"];
  retailerId: Scalars["ID"];
  status?: InputMaybe<NewOrdersStatus>;
  typeId?: InputMaybe<Scalars["ID"]>;
  userId?: InputMaybe<Scalars["ID"]>;
  warehouseId?: InputMaybe<Scalars["ID"]>;
};

export enum NewOrdersStatus {
  InProgress = "IN_PROGRESS",
  Notes = "NOTES",
  Pending = "PENDING",
}

export type Node = {
  /** Identifier used to fetch a specific node */
  id: Scalars["ID"];
};

export type Orb360Product = Node & {
  __typename?: "Orb360Product";
  externalMedia: Array<ExternalMedia>;
  id: Scalars["ID"];
  images: Array<Media>;
  name: Scalars["String"];
};

export type Orb360ProductPayload = {
  __typename?: "Orb360ProductPayload";
  products: Array<Orb360Product>;
  totalCount: Scalars["Int"];
};

export type Order = {
  __typename?: "Order";
  agreesWithTerms: Scalars["Boolean"];
  author: User;
  billing: OrderBilling;
  brand: Brand;
  buyer?: Maybe<OrderBuyer>;
  /** @deprecated Use collections instead */
  collection: Collection;
  collections: CollectionConnection;
  created: Scalars["Date"];
  createdByRetailer: Scalars["Boolean"];
  discount?: Maybe<OrderProductDiscount>;
  discountedProductRange: OrderPriceRange;
  discountedTotalRange: OrderPriceRange;
  divisions: Array<Division>;
  doors: BrandDoorConnection;
  event?: Maybe<OrderEvent>;
  grandTotal: OrderPriceRange;
  hasCancelledProducts: Scalars["Boolean"];
  hasEmptyLineItems: Scalars["Boolean"];
  id: Scalars["ID"];
  internalComments?: Maybe<Scalars["String"]>;
  isOrphan: Scalars["Boolean"];
  lastModifier?: Maybe<LastModifier>;
  latestExports: Array<OrderExportRecord>;
  modified: Scalars["Date"];
  name: Scalars["String"];
  orderComments?: Maybe<Scalars["String"]>;
  paymentInfo?: Maybe<PaymentInfo>;
  paymentMethod?: Maybe<PaymentMethodDesc>;
  priceType?: Maybe<PriceType>;
  /** @deprecated Moved this attr to ProductEdge as each product has his own comment not one comment per order. */
  productComment: Scalars["String"];
  products: OrderProductConnection;
  quantity: Scalars["Int"];
  referenceNumber?: Maybe<Scalars["String"]>;
  /** @deprecated Use retailTotalRange instead. */
  retailTotal: Scalars["Decimal"];
  retailTotalRange: OrderPriceRange;
  /** @deprecated Returns only matching brand retailers. Use retailerProfile instead */
  retailer: Retailer;
  retailerProfile?: Maybe<PublicRetailerProfile>;
  salesComissions?: Maybe<Array<SalesComission>>;
  salesRepresentative?: Maybe<User>;
  season?: Maybe<Season>;
  shared: Scalars["Boolean"];
  shipping: OrderShipping;
  /** @deprecated Use shipping instead */
  shippingInfo: OrderShippingInfo;
  status?: Maybe<OrderStatus>;
  statusModified?: Maybe<Scalars["Date"]>;
  subtotalWholesale: OrderPriceRange;
  tax?: Maybe<Tax>;
  /** @deprecated Use OrderTermsAndConditions */
  terms?: Maybe<Scalars["String"]>;
  termsAndConditions?: Maybe<OrderTermsAndConditions>;
  totalDiscount: OrderPriceRange;
  trackingNumber?: Maybe<Scalars["String"]>;
  types: Array<OrderType>;
  unavailableProducts?: Maybe<OrderUnavailableProductConnection>;
  warehouses: WarehouseConnection;
  /** @deprecated It will be deleted in the future */
  webOrderLookupId: Scalars["ID"];
  /** @deprecated Use wholesaleTotalRange instead. */
  wholesaleTotal: Scalars["Decimal"];
  wholesaleTotalRange: OrderPriceRange;
};

export type OrderProductsArgs = {
  filters?: InputMaybe<OrderProductFilterInput>;
};

export type OrderAddress = {
  city?: Maybe<Scalars["String"]>;
  company?: Maybe<Scalars["String"]>;
  country?: Maybe<Scalars["String"]>;
  firstAddress?: Maybe<Scalars["String"]>;
  name?: Maybe<Scalars["String"]>;
  phone?: Maybe<Scalars["String"]>;
  secondAddress?: Maybe<Scalars["String"]>;
  state?: Maybe<Scalars["String"]>;
  zip?: Maybe<Scalars["String"]>;
};

export enum OrderAssortmentSyncStatus {
  Draft = "DRAFT",
  Locked = "LOCKED",
  Missing = "MISSING",
  SubmittedInSync = "SUBMITTED_IN_SYNC",
  SubmittedOutOfSync = "SUBMITTED_OUT_OF_SYNC",
}

export type OrderBilling = {
  __typename?: "OrderBilling";
  address: OrderBillingAddress;
};

export type OrderBillingAddress = OrderAddress & {
  __typename?: "OrderBillingAddress";
  city?: Maybe<Scalars["String"]>;
  company?: Maybe<Scalars["String"]>;
  country?: Maybe<Scalars["String"]>;
  firstAddress?: Maybe<Scalars["String"]>;
  name?: Maybe<Scalars["String"]>;
  phone?: Maybe<Scalars["String"]>;
  secondAddress?: Maybe<Scalars["String"]>;
  /** Address used to initially populate the order address fields */
  sourceBillingAddress?: Maybe<BillingAddress>;
  state?: Maybe<Scalars["String"]>;
  zip?: Maybe<Scalars["String"]>;
};

export type OrderBulkLineItem = {
  __typename?: "OrderBulkLineItem";
  collection: LineItemCollection;
  inventory?: Maybe<InventoryAvailabilityGroup>;
  orderId: Scalars["ID"];
  productId: Scalars["ID"];
  quantity: Scalars["Int"];
  suggestedRetailPrice: Scalars["Decimal"];
  variant?: Maybe<SkuTraitValue>;
  /** @deprecated Get variantId from variant instead */
  variantId: Scalars["ID"];
  /** @deprecated Use wholesalePriceRange */
  wholesalePrice: Scalars["Decimal"];
  wholesalePriceRange: OrderPriceRange;
};

export type OrderBuyer = {
  __typename?: "OrderBuyer";
  email?: Maybe<Scalars["String"]>;
  id: Scalars["ID"];
  name?: Maybe<Scalars["String"]>;
};

export type OrderCheckMinimums = {
  __typename?: "OrderCheckMinimums";
  colorMinimums: Scalars["Boolean"];
  orderAmount: Scalars["Boolean"];
  orderQuantity: Scalars["Boolean"];
  productMinimums: Scalars["Boolean"];
};

export type OrderConnection = {
  __typename?: "OrderConnection";
  edges: Array<OrderEdge>;
  totalCount: Scalars["Int"];
};

export type OrderDeliveryInfo = {
  delivery?: InputMaybe<OrderDeliveryInput>;
  doorId?: InputMaybe<Scalars["ID"]>;
  purchaseOrderCode?: InputMaybe<Scalars["String"]>;
  season?: InputMaybe<SeasonInput>;
  warehouseId?: InputMaybe<Scalars["ID"]>;
};

export type OrderDeliveryInput = {
  completeShipDate: Scalars["Date"];
  startShipDate: Scalars["Date"];
};

export type OrderDetails = {
  agreesWithTerms?: InputMaybe<Scalars["Boolean"]>;
  buyerEmail?: InputMaybe<Scalars["String"]>;
  buyerName?: InputMaybe<Scalars["String"]>;
  deliveryWindowEnd?: InputMaybe<Scalars["Date"]>;
  deliveryWindowStart?: InputMaybe<Scalars["Date"]>;
  eventId?: InputMaybe<Scalars["ID"]>;
  internalComments?: InputMaybe<Scalars["String"]>;
  name?: InputMaybe<Scalars["String"]>;
  orderComments?: InputMaybe<Scalars["String"]>;
  orderCommissions?: InputMaybe<Array<Scalars["String"]>>;
  priceTypeId?: InputMaybe<Scalars["ID"]>;
  salesRepId?: InputMaybe<Scalars["ID"]>;
  termsAndConditions?: InputMaybe<OrderTermsAndConditionsInput>;
  typeId?: InputMaybe<Scalars["ID"]>;
};

export type OrderDiscount = {
  factor: Scalars["Decimal"];
  type: OrderDiscountType;
};

export enum OrderDiscountLevel {
  EntireOrder = "ENTIRE_ORDER",
  Sku = "SKU",
}

export enum OrderDiscountType {
  Numeric = "NUMERIC",
  Percent = "PERCENT",
}

export type OrderEdge = {
  __typename?: "OrderEdge";
  checkMinimums: OrderCheckMinimums;
  node: Order;
};

export type OrderEvent = {
  __typename?: "OrderEvent";
  code?: Maybe<Scalars["String"]>;
  id?: Maybe<Scalars["ID"]>;
  name?: Maybe<Scalars["String"]>;
};

export type OrderExportRecord = {
  __typename?: "OrderExportRecord";
  created: Scalars["Date"];
  exportDescription?: Maybe<Scalars["String"]>;
  id: Scalars["ID"];
  name?: Maybe<Scalars["String"]>;
  status: OrderExportRecordStatus;
};

export enum OrderExportRecordStatus {
  Failure = "FAILURE",
  None = "NONE",
  Scheduled = "SCHEDULED",
  Success = "SUCCESS",
}

export enum OrderExportStatus {
  Any = "ANY",
  False = "FALSE",
  True = "TRUE",
  Undefined = "UNDEFINED",
}

export type OrderExportStatusFilterInput = {
  failed?: InputMaybe<Array<Scalars["ID"]>>;
  modified?: InputMaybe<Scalars["Boolean"]>;
  none?: InputMaybe<Array<Scalars["ID"]>>;
  scheduled?: InputMaybe<Array<Scalars["ID"]>>;
  success?: InputMaybe<Array<Scalars["ID"]>>;
};

export enum OrderExportTaskStatus {
  Failure = "FAILURE",
  None = "NONE",
  Success = "SUCCESS",
}

export type OrderExportTasks = {
  __typename?: "OrderExportTasks";
  downloadUrl: Scalars["String"];
  id: Scalars["ID"];
  status: OrderExportTaskStatus;
};

export type OrderFilterInput = {
  collections?: InputMaybe<Array<Scalars["ID"]>>;
  createdByRetailer?: InputMaybe<Scalars["Boolean"]>;
  createdDateRange?: InputMaybe<DateRange>;
  deliveryCompleteDateRange?: InputMaybe<DateRange>;
  deliveryStartDateRange?: InputMaybe<DateRange>;
  divisions?: InputMaybe<Array<Scalars["ID"]>>;
  events?: InputMaybe<Array<Scalars["ID"]>>;
  exportStatus?: InputMaybe<OrderExportStatusFilterInput>;
  hasPayments?: InputMaybe<Scalars["Boolean"]>;
  hubIds?: InputMaybe<Array<Scalars["ID"]>>;
  ids?: InputMaybe<Array<Scalars["ID"]>>;
  isHubUnassigned?: InputMaybe<Scalars["Boolean"]>;
  isUnassigned?: InputMaybe<Scalars["Boolean"]>;
  modifiedDateRange?: InputMaybe<DateRange>;
  orderGroupId?: InputMaybe<Scalars["ID"]>;
  priceTypeIds?: InputMaybe<Array<Scalars["ID"]>>;
  retailerIds?: InputMaybe<Array<Scalars["ID"]>>;
  salesRepresentative?: InputMaybe<Array<Scalars["ID"]>>;
  searchText?: InputMaybe<Scalars["String"]>;
  source?: InputMaybe<OrderSource>;
  status?: InputMaybe<Array<InputMaybe<OrderStatus>>>;
  styleColorIds?: InputMaybe<Array<Scalars["ID"]>>;
  types?: InputMaybe<Array<Scalars["ID"]>>;
  webIds?: InputMaybe<Array<Scalars["ID"]>>;
};

export type OrderIdentifiers = {
  orderIds: Array<Scalars["ID"]>;
};

export type OrderInfo = {
  agreesWithTerms?: InputMaybe<Scalars["Boolean"]>;
  brandId?: InputMaybe<Scalars["ID"]>;
  collectionId: Scalars["ID"];
  eventId?: InputMaybe<Scalars["ID"]>;
  inventoryAvailabilityId?: InputMaybe<Scalars["ID"]>;
  orderDelivery?: InputMaybe<OrderDeliveryInput>;
  orderGroupExternalId?: InputMaybe<Scalars["String"]>;
  priceTypeId: Scalars["ID"];
  purchaseOrderCode?: InputMaybe<Scalars["String"]>;
  retailerId: Scalars["ID"];
  typeId?: InputMaybe<Scalars["ID"]>;
  userId?: InputMaybe<Scalars["ID"]>;
  warehouseId?: InputMaybe<Scalars["ID"]>;
};

export type OrderInputSettings = {
  billingAddressId?: InputMaybe<Scalars["ID"]>;
  collection: CollectionInputInfo;
  customerBillingAddressId?: InputMaybe<Scalars["ID"]>;
  customerDoor?: InputMaybe<DoorInputInfo>;
  customerId: Scalars["ID"];
  customerShippingAddressId?: InputMaybe<Scalars["ID"]>;
  door?: InputMaybe<DoorInputInfo>;
  orderStatus: OrderStatus;
  paymentMethodId?: InputMaybe<Scalars["ID"]>;
  priceTypeId: Scalars["ID"];
  shippingAddressId?: InputMaybe<Scalars["ID"]>;
  shippingMethodId?: InputMaybe<Scalars["ID"]>;
};

export type OrderInvoice = {
  __typename?: "OrderInvoice";
  invoiceId: Scalars["String"];
  orderId: Scalars["ID"];
};

export type OrderLineItems = {
  __typename?: "OrderLineItems";
  bulkLineItems: Array<Maybe<OrderBulkLineItem>>;
  casepackLineItems: Array<Maybe<CasepackLineItem>>;
  skuLineItems: Array<Maybe<SkuLineItem>>;
};

export type OrderLineItemsFilter = {
  variantIds: Array<Scalars["ID"]>;
};

export enum OrderOrdering {
  Ascending = "ASCENDING",
  Descending = "DESCENDING",
}

export type OrderPayload = {
  __typename?: "OrderPayload";
  billingAddress?: Maybe<BillingAddressPayload>;
  brandPaymentMethod?: Maybe<BrandPaymentMethodPayload>;
  buyer?: Maybe<OrderBuyer>;
  collection?: Maybe<CollectionPayload>;
  collectionId: Scalars["ID"];
  comments?: Maybe<Scalars["String"]>;
  customer?: Maybe<CustomerPayload>;
  deliveryWindowEnd?: Maybe<Scalars["Date"]>;
  deliveryWindowStart?: Maybe<Scalars["Date"]>;
  exportDescription?: Maybe<Scalars["String"]>;
  exportStatus: OrderExportStatus;
  exportSuccess: Scalars["Boolean"];
  exportedOn?: Maybe<Scalars["Date"]>;
  id: Scalars["ID"];
  internalComments?: Maybe<Scalars["String"]>;
  poNumber: Scalars["String"];
  priceType?: Maybe<PriceTypePayload>;
  priceTypeId: Scalars["ID"];
  retailerId: Scalars["ID"];
  salesRepresentative?: Maybe<SalesRepresentativePayload>;
  shippingAddress?: Maybe<ShippingAddressPayload>;
  shippingMethod?: Maybe<BrandShippingMethodPayload>;
  status?: Maybe<OrderStatus>;
  tax?: Maybe<Tax>;
  taxAmount?: Maybe<Scalars["Float"]>;
  trackingNumber?: Maybe<Scalars["String"]>;
};

export type OrderPaymentMethod = {
  __typename?: "OrderPaymentMethod";
  id: Scalars["ID"];
  paymentMethod?: Maybe<PaymentMethodDesc>;
};

export type OrderPriceRange = {
  __typename?: "OrderPriceRange";
  maxPrice: Scalars["String"];
  minPrice: Scalars["String"];
};

export type OrderProductComment = {
  comment: Scalars["String"];
  orderId: Scalars["ID"];
  productId: Scalars["ID"];
};

export type OrderProductConnection = {
  __typename?: "OrderProductConnection";
  discountedTotal?: Maybe<Scalars["Decimal"]>;
  edges: Array<OrderProductEdge>;
  retailTotal?: Maybe<Scalars["Decimal"]>;
  totalDiscount: OrderPriceRange;
  totalProducts?: Maybe<Scalars["Int"]>;
  totalUnits?: Maybe<Scalars["Int"]>;
  totalVariant?: Maybe<Scalars["Int"]>;
  wholesaleTotal?: Maybe<Scalars["Decimal"]>;
};

export type OrderProductConnectionTotalVariantArgs = {
  filter?: InputMaybe<OrderTotalVariantFilter>;
};

export type OrderProductDiscount = {
  __typename?: "OrderProductDiscount";
  factor: Scalars["Decimal"];
  level: OrderDiscountLevel;
  orderId: Scalars["ID"];
  productId?: Maybe<Scalars["ID"]>;
  type: OrderDiscountType;
};

export type OrderProductDiscountConnection = {
  __typename?: "OrderProductDiscountConnection";
  edges?: Maybe<Array<OrderProductDiscountEdge>>;
};

export type OrderProductDiscountEdge = {
  __typename?: "OrderProductDiscountEdge";
  node?: Maybe<OrderProductDiscount>;
};

export type OrderProductDiscountInput = {
  factor: Scalars["Decimal"];
  orderId: Scalars["ID"];
  productId: Scalars["ID"];
  type: OrderDiscountType;
};

export type OrderProductEdge = {
  __typename?: "OrderProductEdge";
  attributes?: Maybe<Array<ProductAttribute>>;
  backupProduct?: Maybe<BackupProduct>;
  collectionProduct?: Maybe<CollectionProduct>;
  discounts: Array<Maybe<OrderProductDiscount>>;
  node: Product;
  orderLineItems: OrderLineItems;
  orderProductComment?: Maybe<Scalars["String"]>;
  priceRange?: Maybe<PriceRange>;
  quantity?: Maybe<Scalars["Int"]>;
  variantTotals: OrderVariantTotalsConnection;
  wholesaleFinalPrice: OrderPriceRange;
  wholesaleRangeOverwritten?: Maybe<OrderPriceRange>;
  wholesaleTotalPrice: OrderPriceRange;
};

export type OrderProductEdgeDiscountsArgs = {
  level?: InputMaybe<OrderDiscountLevel>;
};

export type OrderProductEdgeOrderLineItemsArgs = {
  filter?: InputMaybe<OrderLineItemsFilter>;
};

export type OrderProductFilterInput = {
  pagination?: InputMaybe<PaginationInfo>;
  quantifyByBulk?: InputMaybe<Scalars["Boolean"]>;
  status?: InputMaybe<OrderProductStatus>;
  variantValueIds?: InputMaybe<Array<Scalars["ID"]>>;
};

export enum OrderProductStatus {
  Active = "ACTIVE",
  Cancelled = "CANCELLED",
}

export type OrderRequirementChecks = {
  __typename?: "OrderRequirementChecks";
  checksInventory?: Maybe<Scalars["Boolean"]>;
  checksMinimums?: Maybe<Scalars["Boolean"]>;
  orderId: Scalars["ID"];
  sizeRunChanged?: Maybe<Scalars["Boolean"]>;
};

export type OrderSeasonYear = {
  __typename?: "OrderSeasonYear";
  season?: Maybe<SeasonName>;
  year?: Maybe<Scalars["String"]>;
};

export type OrderSettings = {
  __typename?: "OrderSettings";
  allowOrderDiscounts?: Maybe<Scalars["Boolean"]>;
  allowSkuDiscounts?: Maybe<Scalars["Boolean"]>;
  brandId: Scalars["ID"];
  displayCountryOfOrigin?: Maybe<Scalars["Boolean"]>;
  displayInternalOrderId?: Maybe<Scalars["Boolean"]>;
  displayShippingCode?: Maybe<Scalars["Boolean"]>;
  minAmount?: Maybe<Scalars["Float"]>;
  minDetail?: Maybe<Scalars["String"]>;
  minUnits?: Maybe<Scalars["Int"]>;
  multipleDivisionsAllowed?: Maybe<Scalars["Boolean"]>;
  restrictEditNotesAndReturnedOrders?: Maybe<Scalars["Boolean"]>;
  retailerRestrictedFromEditing?: Maybe<Scalars["Boolean"]>;
  salesComissions?: Maybe<Array<Scalars["String"]>>;
  shippingRates?: Maybe<Scalars["String"]>;
  terms?: Maybe<Scalars["String"]>;
};

export type OrderShipping = {
  __typename?: "OrderShipping";
  address: OrderShippingAddress;
  deliveryWindow?: Maybe<OrderShippingDeliveryWindow>;
  method?: Maybe<ShippingMethod>;
  /** @deprecated Use priceString instead */
  price?: Maybe<Scalars["Decimal"]>;
  priceString?: Maybe<Scalars["String"]>;
};

export type OrderShippingAddress = OrderAddress & {
  __typename?: "OrderShippingAddress";
  account?: Maybe<Scalars["String"]>;
  city?: Maybe<Scalars["String"]>;
  company?: Maybe<Scalars["String"]>;
  country?: Maybe<Scalars["String"]>;
  email?: Maybe<Scalars["String"]>;
  firstAddress?: Maybe<Scalars["String"]>;
  name?: Maybe<Scalars["String"]>;
  phone?: Maybe<Scalars["String"]>;
  secondAddress?: Maybe<Scalars["String"]>;
  /** Address used to initially populate the order address fields */
  sourceShippingAddress?: Maybe<ShippingAddress>;
  state?: Maybe<Scalars["String"]>;
  zip?: Maybe<Scalars["String"]>;
};

export type OrderShippingDeliveryWindow = {
  __typename?: "OrderShippingDeliveryWindow";
  completeDate?: Maybe<Scalars["Date"]>;
  startDate?: Maybe<Scalars["Date"]>;
};

export type OrderShippingInfo = {
  __typename?: "OrderShippingInfo";
  id: Scalars["ID"];
  /** @deprecated Use OrderShippingDeliveryWindow.shippingComplete instead */
  shippingComplete?: Maybe<Scalars["Date"]>;
  /** @deprecated Use OrderShipping.price instead */
  shippingPrice?: Maybe<Scalars["Decimal"]>;
  /** @deprecated Use OrderShippingDeliveryWindow.shippingStart instead */
  shippingStart?: Maybe<Scalars["Date"]>;
};

export enum OrderSource {
  BrandApp = "BRAND_APP",
  CreatedByRetailer = "CREATED_BY_RETAILER",
  ExcelImport = "EXCEL_IMPORT",
  HistoricalOrderImport = "HISTORICAL_ORDER_IMPORT",
  Integration = "INTEGRATION",
  RetailerApp = "RETAILER_APP",
  Web = "WEB",
}

export enum OrderStatus {
  AllNotes = "ALL_NOTES",
  Approved = "APPROVED",
  Cancelled = "CANCELLED",
  InProgress = "IN_PROGRESS",
  Notes = "NOTES",
  NotesWithoutQuantities = "NOTES_WITHOUT_QUANTITIES",
  NotesWithQuantities = "NOTES_WITH_QUANTITIES",
  Pending = "PENDING",
  Returned = "RETURNED",
  Shipped = "SHIPPED",
}

export type OrderTermsAndConditions = {
  __typename?: "OrderTermsAndConditions";
  agreesWithTerms: Scalars["Boolean"];
  dateCreated?: Maybe<Scalars["Date"]>;
  dateModified?: Maybe<Scalars["Date"]>;
  id: Scalars["ID"];
  name: Scalars["String"];
  platform: OrderTermsAndConditionsPlatform;
  terms: Scalars["String"];
  title: Scalars["String"];
};

export type OrderTermsAndConditionsInput = {
  name?: InputMaybe<Scalars["String"]>;
  platform?: InputMaybe<OrderTermsAndConditionsPlatform>;
  title?: InputMaybe<Scalars["String"]>;
};

export enum OrderTermsAndConditionsPlatform {
  App = "APP",
  Unknown = "UNKNOWN",
  Web = "WEB",
}

export type OrderToImport = {
  __typename?: "OrderToImport";
  doorId?: Maybe<Scalars["ID"]>;
  orderIdentifier?: Maybe<Scalars["String"]>;
  poNumber?: Maybe<Scalars["String"]>;
  skuLineItems?: Maybe<Array<SkuLineItemToImport>>;
};

export type OrderTotalVariantFilter = {
  productFilters?: InputMaybe<OrderProductFilterInput>;
  traitCodes: VariantFilterValuesInput;
};

export type OrderType = Node & {
  __typename?: "OrderType";
  code?: Maybe<Scalars["String"]>;
  id: Scalars["ID"];
  name: Scalars["String"];
};

export type OrderTypeConnection = {
  __typename?: "OrderTypeConnection";
  edges: Array<OrderTypeEdge>;
};

export type OrderTypeEdge = {
  __typename?: "OrderTypeEdge";
  node?: Maybe<OrderType>;
};

export type OrderUnavailableProduct = {
  __typename?: "OrderUnavailableProduct";
  casepackLineItems: Array<CasepackLineItem>;
  product: Product;
  quantity?: Maybe<Scalars["Int"]>;
  skuLineItems: Array<SkuLineItem>;
};

export type OrderUnavailableProductConnection = {
  __typename?: "OrderUnavailableProductConnection";
  edges?: Maybe<Array<OrderUnavailableProductEdge>>;
};

export type OrderUnavailableProductEdge = {
  __typename?: "OrderUnavailableProductEdge";
  node: OrderUnavailableProduct;
};

export type OrderVariantComment = {
  comment: Scalars["String"];
  orderId: Scalars["ID"];
  variantId: Scalars["ID"];
};

export type OrderVariantTotals = {
  __typename?: "OrderVariantTotals";
  orderId: Scalars["ID"];
  productComment: Scalars["String"];
  productId: Scalars["ID"];
  quantity: Scalars["Int"];
  retailTotal: Scalars["Decimal"];
  variant: SkuTraitValue;
  variantComment: Scalars["String"];
  /** @deprecated Get variantId from variant instead */
  variantId: Scalars["ID"];
  /** @deprecated Use wholesaleTotalRange.maxPrice instead */
  wholesaleTotal: Scalars["Decimal"];
  wholesaleTotalRange: OrderPriceRange;
};

export type OrderVariantTotalsConnection = {
  __typename?: "OrderVariantTotalsConnection";
  edges?: Maybe<Array<OrderVariantTotalsEdge>>;
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars["Int"]>;
};

export type OrderVariantTotalsEdge = {
  __typename?: "OrderVariantTotalsEdge";
  cursor: Scalars["String"];
  node?: Maybe<OrderVariantTotals>;
};

export type OrderVariantTotalsFilter = {
  onlyCancelled?: InputMaybe<Scalars["Boolean"]>;
  productIds?: InputMaybe<Array<Scalars["ID"]>>;
  searchText?: InputMaybe<Scalars["String"]>;
};

export type OrderVariantTotalsOrderBy = {
  field: OrderVariantTotalsOrderByField;
  order: OrderOrdering;
};

export enum OrderVariantTotalsOrderByField {
  ProductName = "PRODUCT_NAME",
  Quantity = "QUANTITY",
  RetailTotal = "RETAIL_TOTAL",
  WholesaleTotal = "WHOLESALE_TOTAL",
}

export type OrdersPayload = {
  __typename?: "OrdersPayload";
  errors: Array<Error>;
  orders: Array<OrderPayload>;
};

export type OrphanBillingInfo = {
  address: AddressInput;
  code: Scalars["String"];
  paymentMethodId?: InputMaybe<Scalars["ID"]>;
  phoneNumber: Scalars["String"];
};

export type OrphanOrderInfo = {
  agreesWithTerms?: InputMaybe<Scalars["Boolean"]>;
  brandId?: InputMaybe<Scalars["ID"]>;
  collectionId: Scalars["ID"];
  eventId?: InputMaybe<Scalars["ID"]>;
  inventoryAvailabilityId?: InputMaybe<Scalars["ID"]>;
  orderDelivery?: InputMaybe<OrderDeliveryInput>;
  orderGroupExternalId?: InputMaybe<Scalars["String"]>;
  priceTypeId: Scalars["ID"];
  purchaseOrderCode?: InputMaybe<Scalars["String"]>;
  typeId?: InputMaybe<Scalars["ID"]>;
  userId?: InputMaybe<Scalars["ID"]>;
  warehouseId?: InputMaybe<Scalars["ID"]>;
};

export type OrphanShippingInfo = {
  address: AddressInput;
  code: Scalars["String"];
  email: Scalars["String"];
  phoneNumber: Scalars["String"];
  shippingMethodId?: InputMaybe<Scalars["ID"]>;
};

/**
 * PageInfo is required to fit the Relay Connection specification
 * More info here: https://facebook.github.io/relay/docs/en/graphql-server-specification.html#connections
 *
 * The resolution for these fields is handled by the graphql-relay library
 * https://github.com/graphql/graphql-relay-js
 *
 * NOTE: They implement a naive and shallow version of pagination:
 * 1) For a given connection we still need to fetch a _full_ list of
 * object ids that will be sliced using graphql-relay-js and the
 * pagination params. So this type of pagination will not help if
 * there are any performance issues with fetching the full id list.
 * 2) For the slicing results to remain consistent over time we need
 * to have a reliable sort order.
 * WE ARE NOT EXPLICITLY HANDLING THIS ANYWHERE AT THE MOMENT.
 * So, it's possible for the experience to change from one request
 * to another if the backend sends elements in a different order
 * in subsequent requests (though based on experience of the team
 * it seems like postgres 'defaults' to a pk sort, which should work
 * in most of our cases).
 */
export type PageInfo = {
  __typename?: "PageInfo";
  /** The cursor to continue when paginating forwards. */
  endCursor?: Maybe<Scalars["String"]>;
  /** Whether there is a next page when paginating. */
  hasNextPage: Scalars["Boolean"];
  /** Whether there is a previous page when paginating. */
  hasPreviousPage: Scalars["Boolean"];
  /** The cursor to continue when paginating backwards. */
  startCursor?: Maybe<Scalars["String"]>;
};

export type PaginationInfo = {
  limit?: InputMaybe<Scalars["Int"]>;
  offset?: InputMaybe<Scalars["Int"]>;
};

export type PaidAmount = {
  __typename?: "PaidAmount";
  orderId: Scalars["ID"];
  paidAmount: Scalars["Float"];
};

export type PartialPaymentRequest = {
  __typename?: "PartialPaymentRequest";
  active?: Maybe<Scalars["Boolean"]>;
  amount: Scalars["String"];
  currency: Scalars["String"];
  id: Scalars["ID"];
  name?: Maybe<Scalars["String"]>;
};

export type PaymentDelivery = {
  __typename?: "PaymentDelivery";
  id: Scalars["ID"];
  sentOn: Scalars["Date"];
};

export type PaymentId = {
  __typename?: "PaymentId";
  secret: Scalars["String"];
};

export type PaymentInfo = {
  __typename?: "PaymentInfo";
  dueDate?: Maybe<Scalars["Date"]>;
  firstRequest?: Maybe<Scalars["Date"]>;
  lastNotifiedDate?: Maybe<Scalars["Date"]>;
  lastTransaction?: Maybe<Scalars["Date"]>;
  paidAmount: Scalars["String"];
  partialPaymentRequests?: Maybe<Array<PartialPaymentRequest>>;
  paymentStatus: PaymentStatus;
  remainingBalance: Scalars["String"];
  requestStatus: RequestStatus;
};

export type PaymentMethod = Node & {
  __typename?: "PaymentMethod";
  code: Scalars["String"];
  id: Scalars["ID"];
  name: Scalars["String"];
};

export type PaymentMethodConnection = {
  __typename?: "PaymentMethodConnection";
  edges: Array<PaymentMethodEdge>;
};

export type PaymentMethodDesc = {
  __typename?: "PaymentMethodDesc";
  code?: Maybe<Scalars["String"]>;
  id: Scalars["ID"];
  name?: Maybe<Scalars["String"]>;
};

export type PaymentMethodEdge = {
  __typename?: "PaymentMethodEdge";
  node: PaymentMethod;
};

export type PaymentMethodI = {
  billingEmail: Scalars["String"];
  billingName: Scalars["String"];
  last4: Scalars["String"];
  paymentMethodId: Scalars["String"];
  type: Scalars["String"];
};

export type PaymentMethodIdentifier = {
  paymentMethodExternalId?: InputMaybe<Scalars["String"]>;
  paymentMethodId?: InputMaybe<Scalars["String"]>;
};

export type PaymentMethodInput = {
  brandId: Scalars["ID"];
  paymentMethodId: Scalars["String"];
  paymentProvider: Scalars["String"];
  retailerId?: InputMaybe<Scalars["ID"]>;
};

export enum PaymentMethodType {
  Ach = "ACH",
  CreditCard = "CREDIT_CARD",
  Sepa = "SEPA",
}

export type PaymentPayload = {
  __typename?: "PaymentPayload";
  error?: Maybe<Error>;
  paymentId?: Maybe<PaymentId>;
};

export type PaymentProvider = {
  __typename?: "PaymentProvider";
  connectUrl: Scalars["String"];
  loginUrl: Scalars["String"];
  name: Scalars["String"];
};

export type PaymentRecord = {
  __typename?: "PaymentRecord";
  amount?: Maybe<Scalars["Float"]>;
  brandId: Scalars["ID"];
  created?: Maybe<Scalars["Date"]>;
  currency: Scalars["String"];
  errorMessage?: Maybe<Scalars["String"]>;
  externalIdentifier?: Maybe<Scalars["String"]>;
  id: Scalars["ID"];
  localAmount?: Maybe<Scalars["Float"]>;
  localCurrency?: Maybe<Scalars["String"]>;
  orderId: Scalars["ID"];
  paymentMethod?: Maybe<PaymentMethodI>;
  paymentProvider: Scalars["String"];
  retailerId?: Maybe<Scalars["ID"]>;
  sourceUserId?: Maybe<Scalars["ID"]>;
  status?: Maybe<PaymentRecordStatus>;
};

export enum PaymentRecordStatus {
  Error = "ERROR",
  Processing = "PROCESSING",
  Refund = "REFUND",
  RefundProcessing = "REFUND_PROCESSING",
  Success = "SUCCESS",
}

export enum PaymentStatus {
  FullyPaid = "FULLY_PAID",
  NotPaid = "NOT_PAID",
  PartiallyPaid = "PARTIALLY_PAID",
  Processing = "PROCESSING",
}

export type Permission = Node & {
  __typename?: "Permission";
  id: Scalars["ID"];
};

export type PermissionConfiguration = {
  __typename?: "PermissionConfiguration";
  collectionPermissions: Array<Collection>;
  divisionCategoryPermissions: Array<DivisionCategory>;
  divisionPermissions: Array<Division>;
  priceTypePermissions: Array<PriceType>;
};

export type PermissionConfigurationInput = {
  collectionIds?: InputMaybe<Array<Scalars["ID"]>>;
  divisionCategories: Array<DivisionCategoryInput>;
  divisionIds: Array<Scalars["ID"]>;
  priceTypeIds?: InputMaybe<Array<Scalars["ID"]>>;
};

export type PermissionConnection = {
  __typename?: "PermissionConnection";
  edges: Array<PermissionEdge>;
};

export type PermissionEdge = {
  __typename?: "PermissionEdge";
  node: Permission;
};

export type PermissionState = {
  active: Scalars["Boolean"];
  permissionId: Scalars["ID"];
};

export type PermissionsAccount = Node & {
  __typename?: "PermissionsAccount";
  id: Scalars["ID"];
  name: Scalars["String"];
};

export type PersonInformation = {
  __typename?: "PersonInformation";
  jobTitle?: Maybe<Scalars["String"]>;
  name?: Maybe<Scalars["String"]>;
  phone?: Maybe<Scalars["String"]>;
  profilePictureUrl?: Maybe<Scalars["String"]>;
};

export type Press = Node & {
  __typename?: "Press";
  description?: Maybe<Scalars["String"]>;
  id: Scalars["ID"];
  image?: Maybe<PressImage>;
  name: Scalars["String"];
};

export type PressConnection = {
  __typename?: "PressConnection";
  edges?: Maybe<Array<PressEdge>>;
};

export type PressEdge = {
  __typename?: "PressEdge";
  node?: Maybe<Press>;
};

export type PressImage = {
  __typename?: "PressImage";
  id: Scalars["ID"];
  url: Scalars["String"];
};

export type PriceLevel = Node & {
  __typename?: "PriceLevel";
  currencyCode: Scalars["String"];
  currencySource?: Maybe<CurrencyFilter>;
  extendedRetail: Scalars["Decimal"];
  extendedWholesale: Scalars["Decimal"];
  id: Scalars["ID"];
  maxRetail: Scalars["Decimal"];
  maxWholesale: Scalars["Decimal"];
  name: FinancialPriceLevelName;
};

export enum PriceLevelTypeEnum {
  Retail = "RETAIL",
  Wholesale = "WHOLESALE",
}

export type PriceLevelsFilter = {
  currency?: InputMaybe<CurrencyFilter>;
  currencyCode?: InputMaybe<Scalars["String"]>;
  name?: InputMaybe<FinancialPriceLevelName>;
};

/** User defined modifier that contains a factor to apply and a nested set of rules that determine when it should be applied */
export type PriceModifier = Node & {
  __typename?: "PriceModifier";
  /** Factor to apply */
  factor?: Maybe<Scalars["Decimal"]>;
  /** The price modifier group that this object belongs to */
  group: PriceModifierGroupEdge;
  id: Scalars["ID"];
  /** The factor for this price modifier displayed as a percentage */
  percent?: Maybe<Scalars["Decimal"]>;
};

export type PriceModifierConnection = {
  __typename?: "PriceModifierConnection";
  edges?: Maybe<Array<PriceModifierEdge>>;
};

export type PriceModifierEdge = {
  __typename?: "PriceModifierEdge";
  node?: Maybe<PriceModifier>;
};

/** Price Modifier Groups contain all of the high lieve details common accross price modifiers */
export type PriceModifierGroup = Node & {
  __typename?: "PriceModifierGroup";
  /** Adjustment type for the price modifier class */
  adjustmentType?: Maybe<AdjustmentTypeEnum>;
  /** Unique identifier for this proce modifier class */
  code: Scalars["String"];
  /** Display format for the price modifier class */
  displayFormat?: Maybe<DisplayFormatEnum>;
  id: Scalars["ID"];
  /** Level index for price modifier class */
  levelIndex?: Maybe<Scalars["Int"]>;
  /** Display name for the price modifier class */
  name: Scalars["String"];
  /** Price level type for price modifier class */
  priceLevelType?: Maybe<PriceLevelTypeEnum>;
  /** Set of rules which determine when the factor will be applied */
  rules: PriceModifierRuleConnection;
  /** The type of object that this proce modifier applies to */
  type: PriceModifierGroupType;
};

export type PriceModifierGroupConnection = {
  __typename?: "PriceModifierGroupConnection";
  edges?: Maybe<Array<PriceModifierGroupEdge>>;
};

export type PriceModifierGroupEdge = {
  __typename?: "PriceModifierGroupEdge";
  node: PriceModifierGroup;
};

export enum PriceModifierGroupType {
  /** This price modifier group applies to an assortment */
  Assortment = "ASSORTMENT",
  /** This price modifier group applies to an item-color */
  ItemColor = "ITEM_COLOR",
}

export type PriceModifierRule = Node & {
  __typename?: "PriceModifierRule";
  id: Scalars["ID"];
  /** The set of rules that determine this rule should apply */
  ruleSet?: Maybe<RuleSet>;
};

export type PriceModifierRuleConnection = {
  __typename?: "PriceModifierRuleConnection";
  edges: Array<PriceModifierRuleEdge>;
};

export type PriceModifierRuleEdge = {
  __typename?: "PriceModifierRuleEdge";
  node: PriceModifierRule;
};

export type PriceModifierValueInput = {
  /** The type of value that is being supplied */
  type: PriceModifierValueType;
  /** The Factor or Percentage to apply */
  value: Scalars["Decimal"];
};

export enum PriceModifierValueType {
  Factor = "FACTOR",
  Percent = "PERCENT",
}

export type PriceRange = {
  __typename?: "PriceRange";
  maxRetailValue: Scalars["Float"];
  maxWholesaleValue: Scalars["Float"];
  minRetailValue: Scalars["Float"];
  minWholesaleValue: Scalars["Float"];
};

export type PriceRangeFilterInput = {
  max?: InputMaybe<Scalars["PositiveInteger"]>;
  min?: InputMaybe<Scalars["PositiveInteger"]>;
};

export type PriceRangeGroup = {
  __typename?: "PriceRangeGroup";
  colorId?: Maybe<Scalars["ID"]>;
  priceRange: PriceRange;
  priceType: PriceType;
  product: Product;
  sizeId?: Maybe<Scalars["ID"]>;
};

export enum PriceRangeGroupBy {
  Color = "COLOR",
  PriceType = "PRICE_TYPE",
  Product = "PRODUCT",
  Size = "SIZE",
}

export type PriceRangeGroupConnection = {
  __typename?: "PriceRangeGroupConnection";
  edges: Array<PriceRangeGroupEdge>;
  pageInfo: PageInfo;
};

export type PriceRangeGroupEdge = {
  __typename?: "PriceRangeGroupEdge";
  cursor: Scalars["String"];
  node: PriceRangeGroup;
};

export type PriceRangeInput = {
  maxValue?: InputMaybe<Scalars["Decimal"]>;
  minValue?: InputMaybe<Scalars["Decimal"]>;
  priceTypeId: Scalars["ID"];
};

export type PriceType = Node & {
  __typename?: "PriceType";
  currency: Currency;
  /** @deprecated Get from currency.code */
  currencyCode: Scalars["String"];
  id: Scalars["ID"];
  name: Scalars["String"];
  retailCurrency: Currency;
  /** @deprecated Get from retailCurrency.code */
  retailCurrencyCode: Scalars["String"];
};

export type PriceTypeConnection = {
  __typename?: "PriceTypeConnection";
  edges: Array<PriceTypeEdge>;
};

export type PriceTypeEdge = {
  __typename?: "PriceTypeEdge";
  node: PriceType;
};

export type PriceTypePayload = {
  __typename?: "PriceTypePayload";
  currency?: Maybe<Scalars["String"]>;
  currencyRetail?: Maybe<Scalars["String"]>;
  id: Scalars["ID"];
  name?: Maybe<Scalars["String"]>;
};

export type PriceTypesFilter = {
  collectionIds?: InputMaybe<Array<Scalars["ID"]>>;
  currencyCodes?: InputMaybe<Array<Scalars["String"]>>;
  ids?: InputMaybe<Array<Scalars["ID"]>>;
  names?: InputMaybe<Array<Scalars["String"]>>;
  retailCurrencyCodes?: InputMaybe<Array<Scalars["String"]>>;
  retailerIds?: InputMaybe<Array<Scalars["ID"]>>;
};

/** A JOOR brand private-viewable account profile */
export type PrivateBrandProfile = BrandProfile & {
  __typename?: "PrivateBrandProfile";
  /** Account media url */
  accountMedia?: Maybe<BrandMedia>;
  brandId: Scalars["ID"];
  /** Optional Connected status of current account and brand account */
  connected?: Maybe<Status>;
  /** Cover media url */
  coverMedia?: Maybe<BrandMedia>;
  /** Custom JOOR URL Handle */
  customUrlHandle?: Maybe<Scalars["String"]>;
  /** Description */
  description?: Maybe<Scalars["String"]>;
  /** @deprecated Use brandId instead */
  id: Scalars["ID"];
  /** If the brand is a lite brand */
  isLiteBrand?: Maybe<Scalars["Boolean"]>;
  /** The number of line sheets shown in the profile */
  lineSheetLimit?: Maybe<Scalars["Int"]>;
  /** Logo image id */
  logoId?: Maybe<Scalars["ID"]>;
  /** Logo image url */
  logoUrl?: Maybe<Scalars["String"]>;
  /** Lookbooks associated with the account */
  lookbooks: LookbookConnection;
  /** Account name on JOOR */
  name?: Maybe<Scalars["String"]>;
  /** Press associated with account */
  press?: Maybe<PressConnection>;
  /** Product lines/categories */
  productLines: Array<Scalars["String"]>;
  /** Profile images associated with account. Usually found in about me section. */
  profileImageUrls: Array<Scalars["String"]>;
  /** Retail max */
  retailMax?: Maybe<Scalars["Int"]>;
  /** Retail min */
  retailMin?: Maybe<Scalars["Int"]>;
  /** Social media accounts */
  socialMediaAccounts: Array<SocialMediaAccount>;
  /** Team users associated with account */
  teamUsers: TeamUserConnection;
  /** Website URL */
  websiteUrl?: Maybe<Scalars["String"]>;
  /** Wholesale max */
  wholesaleMax?: Maybe<Scalars["Int"]>;
  /** Wholesale min */
  wholesaleMin?: Maybe<Scalars["Int"]>;
  /** Year established */
  yearEstablished?: Maybe<Scalars["Int"]>;
};

export type PrivateBrandProfileConnection = {
  __typename?: "PrivateBrandProfileConnection";
  edges: Array<PrivateBrandProfileEdge>;
};

export type PrivateBrandProfileEdge = {
  __typename?: "PrivateBrandProfileEdge";
  node?: Maybe<PrivateBrandProfile>;
};

export type Product = Node & {
  __typename?: "Product";
  badges: BadgeConnection;
  brandProfile: PrivateBrandProfile;
  casepacks: ProductCasepackConnection;
  categories: CategoryConnection;
  /** Warning! This node is only available for retailers and not for brands. */
  collections: Array<Collection>;
  description: Scalars["String"];
  externalIdentifier: Scalars["String"];
  externalMedia: Array<ExternalMedia>;
  id: Scalars["ID"];
  images: Array<Media>;
  mainImage?: Maybe<Media>;
  modified?: Maybe<Scalars["Date"]>;
  name: Scalars["String"];
  orderMinimum: Scalars["Int"];
  priceRange?: Maybe<PriceRange>;
  priceTypes: Array<PriceType>;
  productIdentifier: Scalars["String"];
  skus: SkuConnection;
  stylePrices: Array<StylePrice>;
  tagValues: TagValueConnection;
  /** @deprecated Use tagValues instead */
  tags: TagConnection;
  traitValues: ProductTraitValueConnection;
  variants: ProductSkuVariantConnection;
  videos: Array<Media>;
};

export type ProductCasepacksArgs = {
  withDeleted?: InputMaybe<Scalars["Boolean"]>;
};

export type ProductPriceRangeArgs = {
  priceTypeId: Scalars["ID"];
};

export type ProductSkusArgs = {
  withCasepacks?: InputMaybe<Scalars["Boolean"]>;
  withDeleted?: InputMaybe<Scalars["Boolean"]>;
  withDeletedTraits?: InputMaybe<Array<TraitCode>>;
  withInactive?: InputMaybe<Scalars["Boolean"]>;
};

export type ProductStylePricesArgs = {
  priceTypeIds?: InputMaybe<Array<Scalars["ID"]>>;
};

export type ProductVariantsArgs = {
  withDeleted?: InputMaybe<Scalars["Boolean"]>;
  withDeletedTraits?: InputMaybe<Array<TraitCode>>;
};

export type ProductAttribute = {
  __typename?: "ProductAttribute";
  externalIdentifier?: Maybe<Scalars["String"]>;
  id: Scalars["ID"];
  name: Scalars["String"];
  type: ProductAttributeType;
  value: Scalars["String"];
};

export enum ProductAttributeType {
  Tag = "TAG",
  Trait = "TRAIT",
}

export type ProductCasepack = Node & {
  __typename?: "ProductCasepack";
  description?: Maybe<Scalars["String"]>;
  externalIdentifier?: Maybe<Scalars["String"]>;
  id: Scalars["ID"];
  name?: Maybe<Scalars["String"]>;
  skus: CasepackSkuConnection;
};

export type ProductCasepackSkusArgs = {
  withDeleted?: InputMaybe<Scalars["Boolean"]>;
};

export type ProductCasepackConnection = {
  __typename?: "ProductCasepackConnection";
  edges: Array<ProductCasepackEdge>;
};

export type ProductCasepackEdge = {
  __typename?: "ProductCasepackEdge";
  node: ProductCasepack;
};

export type ProductColorPriceLevels = Node & {
  __typename?: "ProductColorPriceLevels";
  colorId: Scalars["ID"];
  doors: Array<DoorPriceLevels>;
  id: Scalars["ID"];
  priceLevels: Array<PriceLevel>;
  quantity: Scalars["Int"];
  skuCount: Scalars["Int"];
};

export type ProductColorPriceLevelsPriceLevelsArgs = {
  filters?: InputMaybe<PriceLevelsFilter>;
};

export type ProductConnection = {
  __typename?: "ProductConnection";
  edges: Array<ProductEdge>;
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars["Int"]>;
};

export type ProductDetail = {
  __typename?: "ProductDetail";
  id: Scalars["String"];
  images: Array<Image>;
};

export type ProductDiscount = Node & {
  __typename?: "ProductDiscount";
  factor?: Maybe<Scalars["Decimal"]>;
  id: Scalars["ID"];
  productId: Scalars["ID"];
};

export type ProductDiscountConnection = {
  __typename?: "ProductDiscountConnection";
  edges: Array<Maybe<ProductDiscountEdge>>;
};

export type ProductDiscountEdge = {
  __typename?: "ProductDiscountEdge";
  node?: Maybe<ProductDiscount>;
};

export type ProductEdge = {
  __typename?: "ProductEdge";
  cursor: Scalars["String"];
  node: Product;
};

export type ProductInfo = {
  collectionId: Scalars["ID"];
  productId: Scalars["ID"];
  variantId?: InputMaybe<Scalars["ID"]>;
};

export type ProductLine = {
  __typename?: "ProductLine";
  id: Scalars["ID"];
  name?: Maybe<Scalars["String"]>;
};

export enum ProductOrder {
  Ascending = "ASCENDING",
  Descending = "DESCENDING",
}

export type ProductOrderByField = {
  order?: InputMaybe<ProductOrder>;
  orderByField?: InputMaybe<ProductSortableField>;
};

export type ProductOrderByInput = {
  field?: InputMaybe<ProductOrderByField>;
};

export type ProductPriceLevels = Node & {
  __typename?: "ProductPriceLevels";
  colorPriceLevels: Array<ProductColorPriceLevels>;
  id: Scalars["ID"];
  productId: Scalars["ID"];
  skuPriceLevels: Array<ProductSkuPriceLevels>;
};

export type ProductSkuPriceLevels = Node & {
  __typename?: "ProductSkuPriceLevels";
  id: Scalars["ID"];
  node: Sku;
  priceLevels: Array<PriceLevel>;
  quantity: Scalars["Int"];
  skuCount: Scalars["Int"];
};

export type ProductSkuPriceLevelsPriceLevelsArgs = {
  filters?: InputMaybe<PriceLevelsFilter>;
};

export type ProductSkuVariantConnection = {
  __typename?: "ProductSkuVariantConnection";
  edges: Array<ProductSkuVariantEdge>;
};

export type ProductSkuVariantEdge = {
  __typename?: "ProductSkuVariantEdge";
  node: SkuTrait;
  values: SkuTraitValueConnection;
};

export enum ProductSortableField {
  Modified = "MODIFIED",
  Name = "NAME",
  Unspecified = "UNSPECIFIED",
}

export type ProductTrait = Trait & {
  __typename?: "ProductTrait";
  code: Scalars["String"];
  id: Scalars["ID"];
  name: Scalars["String"];
};

export enum ProductTraitCode {
  Catgender = "CATGENDER",
  Dispcat = "DISPCAT",
  Dispsubcat = "DISPSUBCAT",
  Division = "DIVISION",
  Fabname = "FABNAME",
  Silname = "SILNAME",
}

export type ProductTraitConnection = {
  __typename?: "ProductTraitConnection";
  edges: Array<ProductTraitEdge>;
};

export type ProductTraitEdge = {
  __typename?: "ProductTraitEdge";
  node: ProductTrait;
};

export type ProductTraitValue = TraitValue & {
  __typename?: "ProductTraitValue";
  externalIdentifier: Scalars["String"];
  id: Scalars["ID"];
  trait: ProductTrait;
  value: Scalars["String"];
};

export type ProductTraitValueConnection = {
  __typename?: "ProductTraitValueConnection";
  edges: Array<ProductTraitValueEdge>;
};

export type ProductTraitValueEdge = {
  __typename?: "ProductTraitValueEdge";
  node: ProductTraitValue;
};

export type ProductTraitValueInput = {
  traitCode: ProductTraitCode;
  traitValueIds: Array<Scalars["ID"]>;
};

export type ProductTraitValuesFilter = {
  collectionIds?: InputMaybe<Array<Scalars["ID"]>>;
  otherAccountId?: InputMaybe<Scalars["ID"]>;
};

export type ProductsCollectionFilter = {
  badgeIds?: InputMaybe<Array<Scalars["ID"]>>;
  collectionIds?: InputMaybe<Array<Scalars["ID"]>>;
  deliveryDates?: InputMaybe<Array<DateRange>>;
  inventoryFilter?: InputMaybe<InventoryFilter>;
  ipadEnabled?: InputMaybe<Scalars["Boolean"]>;
  priceRange?: InputMaybe<PriceRangeInput>;
  priceTypeId?: InputMaybe<Scalars["ID"]>;
  productIds?: InputMaybe<Array<Scalars["ID"]>>;
  searchText?: InputMaybe<Scalars["String"]>;
  seasonIds?: InputMaybe<Array<Scalars["ID"]>>;
  tagIds?: InputMaybe<Array<Scalars["ID"]>>;
  tagValueIds?: InputMaybe<Array<Scalars["String"]>>;
  traitValueInputs?: InputMaybe<Array<TraitValueInput>>;
  upc?: InputMaybe<Scalars["String"]>;
  withArchivedCollections?: InputMaybe<Scalars["Boolean"]>;
  withDeleted?: InputMaybe<Scalars["Boolean"]>;
};

export type ProductsFilter = {
  badgeIds?: InputMaybe<Array<Scalars["ID"]>>;
  collectionIds?: InputMaybe<Array<Scalars["ID"]>>;
  colorNames?: InputMaybe<Array<Scalars["String"]>>;
  countryOfOriginNames?: InputMaybe<Array<Scalars["String"]>>;
  deliveryDates?: InputMaybe<Array<DateRange>>;
  divisionExternalIds?: InputMaybe<Array<Scalars["String"]>>;
  divisionNames?: InputMaybe<Array<Scalars["String"]>>;
  fabricationExternalIds?: InputMaybe<Array<Scalars["String"]>>;
  fabricationNames?: InputMaybe<Array<Scalars["String"]>>;
  inventoryFilter?: InputMaybe<InventoryFilter>;
  materialsNames?: InputMaybe<Array<Scalars["String"]>>;
  orderIds?: InputMaybe<Array<Scalars["ID"]>>;
  priceTypesFilter?: InputMaybe<PriceTypesFilter>;
  productExternalIds?: InputMaybe<Array<Scalars["String"]>>;
  productIds?: InputMaybe<Array<Scalars["ID"]>>;
  searchText?: InputMaybe<Scalars["String"]>;
  seasonIds?: InputMaybe<Array<Scalars["ID"]>>;
  seasonNames?: InputMaybe<Array<Scalars["String"]>>;
  seasonYears?: InputMaybe<Array<Scalars["String"]>>;
  silhouetteExternalIds?: InputMaybe<Array<Scalars["String"]>>;
  silhouetteNames?: InputMaybe<Array<Scalars["String"]>>;
  sizeNames?: InputMaybe<Array<Scalars["String"]>>;
  tagIds?: InputMaybe<Array<Scalars["ID"]>>;
  tagValues?: InputMaybe<Array<Scalars["String"]>>;
  traitValueInputs?: InputMaybe<Array<ProductTraitValueInput>>;
  withDeleted?: InputMaybe<Scalars["Boolean"]>;
};

export enum Provider3dShowroom {
  Istaging = "ISTAGING",
  Matterport = "MATTERPORT",
}

/** A JOOR brand publicly-viewable account profile */
export type PublicBrandProfile = BrandProfile & {
  __typename?: "PublicBrandProfile";
  /** Account media url */
  accountMedia?: Maybe<BrandMedia>;
  brandId: Scalars["ID"];
  /** Cover media url */
  coverMedia?: Maybe<BrandMedia>;
  /** Custom JOOR URL Handle */
  customUrlHandle?: Maybe<Scalars["String"]>;
  /** Description */
  description?: Maybe<Scalars["String"]>;
  /** @deprecated Use brandId instead */
  id: Scalars["ID"];
  /** If the brand is a lite brand */
  isLiteBrand?: Maybe<Scalars["Boolean"]>;
  /** Logo image id */
  logoId?: Maybe<Scalars["ID"]>;
  /** Logo image url */
  logoUrl?: Maybe<Scalars["String"]>;
  /** Account name on JOOR */
  name?: Maybe<Scalars["String"]>;
  /** Product lines/categories */
  productLines: Array<Scalars["String"]>;
  /** Profile images associated with account. Usually found in about me section. */
  profileImageUrls: Array<Scalars["String"]>;
  /** Retail max */
  retailMax?: Maybe<Scalars["Int"]>;
  /** Retail min */
  retailMin?: Maybe<Scalars["Int"]>;
  /** Social media accounts */
  socialMediaAccounts: Array<SocialMediaAccount>;
  /** Website URL */
  websiteUrl?: Maybe<Scalars["String"]>;
  /** Wholesale max */
  wholesaleMax?: Maybe<Scalars["Int"]>;
  /** Wholesale min */
  wholesaleMin?: Maybe<Scalars["Int"]>;
  /** Year established */
  yearEstablished?: Maybe<Scalars["Int"]>;
};

export type PublicBrandProfileConnection = {
  __typename?: "PublicBrandProfileConnection";
  edges: Array<PublicBrandProfileEdge>;
};

export type PublicBrandProfileEdge = {
  __typename?: "PublicBrandProfileEdge";
  node?: Maybe<PublicBrandProfile>;
};

export type PublicCollection = {
  __typename?: "PublicCollection";
  id: Scalars["ID"];
  name: Scalars["String"];
  products: Array<PublicProduct>;
};

export type PublicCollectionsFilter = {
  collectionIds?: InputMaybe<Array<Scalars["ID"]>>;
  productIds?: InputMaybe<Array<Scalars["ID"]>>;
  skipLimitByProfileSettings?: InputMaybe<Scalars["Boolean"]>;
};

export type PublicDelivery = {
  __typename?: "PublicDelivery";
  completeShipDate?: Maybe<Scalars["Date"]>;
  id: Scalars["ID"];
  startShipDate?: Maybe<Scalars["Date"]>;
};

export type PublicItemVisibility = {
  __typename?: "PublicItemVisibility";
  collectionId: Scalars["ID"];
  collectionProductId: Scalars["ID"];
  colorVariantTotal: Scalars["Int"];
  id: Scalars["ID"];
  productId: Scalars["ID"];
  productImageUrl?: Maybe<Scalars["String"]>;
  productName: Scalars["String"];
  productNumber: Scalars["String"];
  variantId?: Maybe<Scalars["ID"]>;
  visible: Scalars["Boolean"];
};

export type PublicLook = Node & {
  __typename?: "PublicLook";
  id: Scalars["ID"];
  items: Array<PublicItemVisibility>;
  layout: Scalars["String"];
  media: Array<LookMedia>;
  textContents: Array<LookTextContent>;
};

export type PublicLookConnection = {
  __typename?: "PublicLookConnection";
  edges: Array<PublicLookEdge>;
  pageInfo: PageInfo;
};

export type PublicLookEdge = {
  __typename?: "PublicLookEdge";
  cursor: Scalars["String"];
  node: PublicLook;
};

/** Publicly accessible mutation */
export type PublicMutation = {
  __typename?: "PublicMutation";
  _empty?: Maybe<Scalars["String"]>;
  acceptUserMembershipInvite: MembershipInvitePayload;
  createLiteBrand: LiteBrandPayload;
  createPaymentAnonymously: PaymentPayload;
  createUserMembershipRequest: PublicUserMembershipRequestPayload;
};

/** Publicly accessible mutation */
export type PublicMutationAcceptUserMembershipInviteArgs = {
  input: AcceptUserMembershipInviteInput;
};

/** Publicly accessible mutation */
export type PublicMutationCreateLiteBrandArgs = {
  input: LiteBrandInput;
};

/** Publicly accessible mutation */
export type PublicMutationCreatePaymentAnonymouslyArgs = {
  input: CreatePaymentWithPaymentMethodInput;
  invoiceId: Scalars["String"];
};

/** Publicly accessible mutation */
export type PublicMutationCreateUserMembershipRequestArgs = {
  input: CreateUserMembershipRequestInput;
};

export type PublicPriceType = {
  __typename?: "PublicPriceType";
  currency: Currency;
  id: Scalars["ID"];
  name: Scalars["String"];
  retailCurrency: Currency;
};

export type PublicProduct = Node & {
  __typename?: "PublicProduct";
  description?: Maybe<Scalars["String"]>;
  externalMedia: Array<ExternalMedia>;
  id: Scalars["ID"];
  images: Array<Media>;
  keyImage?: Maybe<Media>;
  name: Scalars["String"];
  variants: PublicProductVariant;
};

export type PublicProductVariant = {
  __typename?: "PublicProductVariant";
  colors: Array<PublicProductVariantColor>;
};

export type PublicProductVariantColor = {
  __typename?: "PublicProductVariantColor";
  id: Scalars["ID"];
  image?: Maybe<Media>;
  name: Scalars["String"];
  swatch: PublicProductVariantColorSwatch;
};

export type PublicProductVariantColorSwatch = {
  __typename?: "PublicProductVariantColorSwatch";
  hexColor: Scalars["String"];
  image?: Maybe<Media>;
};

/** Publicly accessible query */
export type PublicQuery = {
  __typename?: "PublicQuery";
  _empty?: Maybe<Scalars["String"]>;
  brandProfiles: PublicBrandProfileConnection;
  collectionParamsByShareToken: SharedCollectionParams;
  collectionProductsByShareToken: SharedCollectionProductConnection;
  collections: Array<PublicCollection>;
  geographies: GeographyConnection;
  getOrderByInvoice: InvoiceData;
  identityProvider?: Maybe<IdentityProvider>;
  publicShowroomCollection: PublicShowroomCollection;
  retailerProfile: Array<PublicRetailerProfile>;
  storefronts: Array<Storefront>;
  tradeShowBrands: TradeShowEventBrandConnection;
  tradeShowBrandsCategories: TradeShowEventBrandCategoriesConnection;
  tradeShows: TradeShowEventConnection;
  useJoorPay: Scalars["Boolean"];
  useJoorPayLocalPayments: Scalars["Boolean"];
};

/** Publicly accessible query */
export type PublicQueryBrandProfilesArgs = {
  brandIds: Array<Scalars["ID"]>;
};

/** Publicly accessible query */
export type PublicQueryCollectionParamsByShareTokenArgs = {
  token: Scalars["String"];
};

/** Publicly accessible query */
export type PublicQueryCollectionProductsByShareTokenArgs = {
  after?: InputMaybe<Scalars["String"]>;
  before?: InputMaybe<Scalars["String"]>;
  first?: InputMaybe<Scalars["Int"]>;
  last?: InputMaybe<Scalars["Int"]>;
  limit?: InputMaybe<Scalars["Int"]>;
  offset?: InputMaybe<Scalars["Int"]>;
  token: Scalars["String"];
};

/** Publicly accessible query */
export type PublicQueryCollectionsArgs = {
  brandId: Scalars["ID"];
  filters?: InputMaybe<PublicCollectionsFilter>;
};

/** Publicly accessible query */
export type PublicQueryGeographiesArgs = {
  filter?: InputMaybe<GeographyFilter>;
  types: Array<Scalars["String"]>;
};

/** Publicly accessible query */
export type PublicQueryGetOrderByInvoiceArgs = {
  invoiceId: Scalars["String"];
};

/** Publicly accessible query */
export type PublicQueryIdentityProviderArgs = {
  email: Scalars["String"];
};

/** Publicly accessible query */
export type PublicQueryPublicShowroomCollectionArgs = {
  showroomCollectionShareToken: Scalars["String"];
};

/** Publicly accessible query */
export type PublicQueryRetailerProfileArgs = {
  retailerIds: Array<Scalars["ID"]>;
};

/** Publicly accessible query */
export type PublicQueryStorefrontsArgs = {
  brandIds: Array<Scalars["ID"]>;
  filters?: InputMaybe<StorefrontFilters>;
};

/** Publicly accessible query */
export type PublicQueryTradeShowBrandsArgs = {
  filter?: InputMaybe<TradeShowEventBrandFilter>;
  pagination?: InputMaybe<TradeShowPageInfo>;
};

/** Publicly accessible query */
export type PublicQueryTradeShowBrandsCategoriesArgs = {
  filter?: InputMaybe<TradeShowEventBrandFilter>;
};

/** Publicly accessible query */
export type PublicQueryTradeShowsArgs = {
  filter?: InputMaybe<TradeShowEventFilter>;
  pagination?: InputMaybe<TradeShowPageInfo>;
};

/** Publicly accessible query */
export type PublicQueryUseJoorPayArgs = {
  brandAccountId: Scalars["ID"];
};

/** Publicly accessible query */
export type PublicQueryUseJoorPayLocalPaymentsArgs = {
  brandAccountId: Scalars["ID"];
};

export type PublicRetailerProfile = {
  __typename?: "PublicRetailerProfile";
  buyerName?: Maybe<Scalars["String"]>;
  code?: Maybe<Scalars["String"]>;
  description?: Maybe<Scalars["String"]>;
  displayName?: Maybe<Scalars["String"]>;
  email?: Maybe<Scalars["String"]>;
  id: Scalars["ID"];
  isBuyer?: Maybe<Scalars["Boolean"]>;
  isOwner?: Maybe<Scalars["Boolean"]>;
  logoId?: Maybe<Scalars["ID"]>;
  logoUrl?: Maybe<Scalars["String"]>;
  name?: Maybe<Scalars["String"]>;
  primaryLocation?: Maybe<Location>;
  profileImages?: Maybe<Array<RetailerProfileImage>>;
  profileSnoozeCounter?: Maybe<Scalars["Int"]>;
  socialMediaAccounts?: Maybe<Array<SocialMediaAccount>>;
  websiteUrl?: Maybe<Scalars["String"]>;
};

export type PublicShowroomCollection = Node & {
  __typename?: "PublicShowroomCollection";
  id: Scalars["ID"];
  looks: PublicLookConnection;
  name: Scalars["String"];
  url3dShowroom?: Maybe<Url3dShowroom>;
};

export type PublicUserMembershipRequestPayload = Node & {
  __typename?: "PublicUserMembershipRequestPayload";
  id: Scalars["ID"];
};

export type Query = {
  __typename?: "Query";
  AssortmentUI__assortment?: Maybe<AssortmentUi__Assortment>;
  AssortmentUI__assortmentSku?: Maybe<AssortmentUi__AssortmentSku>;
  AssortmentUI__configurations?: Maybe<Array<Maybe<Configuration>>>;
  AssortmentUI__getRowColorBulk: AssortmentUi_RowColorBulkQuantities;
  AssortmentUI__getRowSizeBulk: AssortmentUi_RowSizeBulkQuantities;
  /** @deprecated Use 'brandProfiles' instead */
  _brandProfiles: Array<PrivateBrandProfile>;
  _empty?: Maybe<Scalars["String"]>;
  _products: Array<Maybe<Product>>;
  /** Query account connections between an account and other specified accounts */
  accountConnectionStatuses: Array<AccountConnectionStatus>;
  /** Query customer codes between the first active account and other specified accounts */
  accountCustomerCodes: Array<AccountCustomerCode>;
  accountExportIntegrationConfigs: Array<ExportIntegrationConfig>;
  accountPaymentProviders: Array<AccountPaymentProvider>;
  accountPermissionAccess: PermissionConnection;
  accountUserDataPermissionConfiguration?: Maybe<DataPermissionConfiguration>;
  accountUserGeoRestrictions: AccountUserGeoRestrictions;
  accountUserPermissionAccess: PermissionConnection;
  activeViewingAccount: Account;
  aggregateSkuInventoryItems: Array<WarehouseAggregateSkuInventoryItemList>;
  /** Query an assortment by its id */
  assortment?: Maybe<Assortment>;
  assortmentSkus: AssortmentSkuConnection;
  assortments: Array<AssortmentSummary>;
  assortmentsForBrand: Array<Assortment>;
  assortmentsForCollection: Array<Assortment>;
  assortmentsQuery: AssortmentConnection;
  backupProducts: BackupProductConnection;
  badges: BadgeConnection;
  brandBudgets: BrandBudgetConnection;
  brandDoors: BrandDoorConnection;
  brandMedia: BrandMediaPayload;
  brandProductLines: Array<BrandProductLine>;
  brandProfiles: PrivateBrandProfileConnection;
  brands: BrandConnection;
  casepacks: AccountCasepackConnection;
  categories: CategoryConnection;
  checkMergingAccountCriteria?: Maybe<MergingAccountCriteriaPayload>;
  checkMergingOrderCriteria?: Maybe<MergingOrderCriteriaPayload>;
  collectionBanners: CollectionBannerConnection;
  collectionProducts: CollectionProductConnection;
  collectionProductsGroupTotal: Array<CollectionProductGroupTotal>;
  collectionProductsTotal: Scalars["Int"];
  collections: CollectionConnection;
  configurations?: Maybe<Array<Maybe<Configuration>>>;
  countriesCurrencies: Array<CountryCurrency>;
  currencies?: Maybe<CurrencyConnection>;
  dataPermissionConfigurations: DataPermissionConfigurationConnection;
  deliveryReportFeature?: Maybe<Scalars["Boolean"]>;
  externalPaymentByLink: ExternalPayment;
  externalPaymentRecords: Array<PaymentRecord>;
  externalPayments: Array<ExternalPayment>;
  externalProviderAuths: Array<ExternalProviderAuth>;
  /** Query brands favorited by retail account user */
  favoritedBrandsByRetailAccountUser: Array<FavoritedBrand>;
  /** Query brands carried by name */
  findBrandsCarried: LgBrandsCarriedConnection;
  /** Query account connections between an account and other specified accounts */
  findInterestedBrands: Array<Maybe<InterestedBrand>>;
  /** Query retailers available for brands */
  findRetailers: LgRetailerConnection;
  geographies: GeographyConnection;
  getOrderCustomerData?: Maybe<GetOrderCustomerDataPayload>;
  hubs: HubConnection;
  idpConfigs: IdpConfigConnection;
  instagramAccountImages: Array<InstagramAccountImages>;
  instagramAccounts: Array<InstagramAccount>;
  inventoryAvailabilityGroups: InventoryAvailabilityGroupConnection;
  inventoryVisibilitySettings: InventoryVisibilitySettings;
  invoiceExportPaymentDetailsByOrderIds: Array<InvoiceExportPaymentDetails>;
  invoices: Array<InvoiceDelivery>;
  keycloakUser?: Maybe<KeycloakUser>;
  lgGetRequestConnectionData: LgRequestConnectionData;
  /** Details about triggered assortment export tasks */
  listAssortmentExportTasks: Array<AssortmentExportTask>;
  listClienteleDescriptions: ClienteleDescriptionConnection;
  listClienteleInterests: ClienteleInterestConnection;
  /** Query Buyers for a given customer record */
  listConnectionBuyers: Array<ConnectionBuyer>;
  listConnectionDiscounts: Array<ConnectionDiscount>;
  listConnectionDoors: Array<ConnectionDoor>;
  listConnectionPaymentMethods: Array<ConnectionPaymentMethod>;
  listConnectionPriceTypes: Array<ConnectionPriceTypeResponse>;
  listConnectionSalesReps: Array<ConnectionSalesRep>;
  listConnectionShippingMethods: Array<ConnectionShippingMethod>;
  listConnectionWarehouses: Array<ConnectionWarehouse>;
  listJobs: CeleryJobConnection;
  listLatestBrands: Array<LatestBrandProfile>;
  listLatestFavoriteBrands: Array<LatestFavoriteBrandProfile>;
  listOrderExportTasks: ListOrderExportTasksPayload;
  listRecentBrandAssortments: Array<BrandAssortmentDetailsProfile>;
  listRecentBrandOrders: Array<BrandOrder>;
  /** Query last 5 shared linesheets/showroom collections */
  listRecentSharedCollections: Array<SharedCollection>;
  listRetailerGoogleAddresses: GoogleAddressConnection;
  listRetailerImpersonationFeedback: RetailerImpersonationFeedbackConnection;
  look: Look;
  manualPaymentRecords: Array<ManualPaymentRecord>;
  newInvitationCount: MessageCount;
  orb360Products: Orb360ProductPayload;
  orderDiscounts: DiscountConnection;
  orderLineItems: OrderLineItems;
  orderProductDiscounts: OrderProductDiscountConnection;
  orderRequirementChecks: Array<OrderRequirementChecks>;
  orderSettings: Array<OrderSettings>;
  /** @deprecated Use order.products instead */
  orderVariantTotals: OrderVariantTotalsConnection;
  orders: OrderConnection;
  paidAmountsByOrderId: Array<PaidAmount>;
  paymentErrors: Array<PaymentRecord>;
  paymentMethods: Array<PaymentMethodI>;
  paymentProviders: Array<PaymentProvider>;
  paymentRecords: Array<PaymentRecord>;
  priceRangeGroups: PriceRangeGroupConnection;
  priceTypes: PriceTypeConnection;
  productDetail: ProductDetail;
  productDiscounts: ProductDiscountConnection;
  productTraitValues: ProductTraitValueConnection;
  productTraits: ProductTraitConnection;
  products: ProductConnection;
  public: PublicQuery;
  regions: RegionConnection;
  /** Get a specific retailBudget given the RetailWorkspace or Assortment that it is linked to */
  retailBudget?: Maybe<RetailBudget>;
  /** Get a retail workspace by ID */
  retailWorkspace?: Maybe<RetailWorkspace>;
  /** Get retail workspaces from a list of ids */
  retailWorkspaces: Array<RetailWorkspace>;
  /** List all the workspaces and bare assortments in a single query */
  retailWorkspacesAndAssortments: Array<WorkspaceOrAssortment>;
  /** Query a retailer by its id */
  retailer?: Maybe<Retailer>;
  /** Query for private retailer profile */
  retailerProfile: LgRetailerProfile;
  /** Query percentage completed for retailer profile */
  retailerProfileCompletion: RetailerProfileCompletion;
  retailerUsers: RetailerUserConnection;
  /** Query a list of retailers */
  retailers: RetailerConnection;
  /** Query retailers that have liked a brand */
  retailersThatFavoritedBrand: Array<RetailerThatFavoritedBrand>;
  seasons: SeasonConnection;
  shipments: ShipmentConnection;
  showroomCollection: ShowroomCollection;
  showroomCollectionListFilters: ShowroomCollectionFilterList;
  showroomCollections: ShowroomCollectionConnection;
  /** List all available size runs, optionally filtered by some criteria */
  sizeRuns: Array<SizeRun>;
  skuDeliveries: SkuDeliveryConnection;
  skuTraits: Array<SkuTrait>;
  skus: SkuConnection;
  storefronts: Array<Storefront>;
  styleboard: Styleboard;
  styleboardComments: StyleboardCommentConnection;
  styleboardLastModified: StyleboardLastModified;
  styleboardListFilters: StyleboardFilterList;
  styleboardVisibleToAccountUsers: CommentAccountUserTagConnection;
  styleboards: StyleboardConnection;
  termsAndConditions: BrandTermsAndConditionsConnection;
  totalInOrders: Array<BrandOrderCombination>;
  /** Query retailers that have liked a brand */
  tradeShowEvents: Array<TradeShowEvent>;
  uniqueTagValues: TagValueConnection;
  unreadMessageCount: MessageCount;
  url3dShowroom: Array<Maybe<Url3dShowroom>>;
  user?: Maybe<User>;
  /** Query a list of User Collaboration Invites */
  userCollaborationInvites: CollaborationInviteConnection;
  userMembershipRequests: UserMembershipRequestConnection;
  users: UserConnection;
  usesNewEditAndCreate: Scalars["Boolean"];
  variantsInCart: Array<VariantInCart>;
  viewingAccounts: Array<Account>;
  viewingUser: User;
  warehouses: WarehouseConnection;
  zendeskUser: ZendeskUser;
};

export type QueryAssortmentUi__AssortmentArgs = {
  assortmentId: Scalars["ID"];
};

export type QueryAssortmentUi__AssortmentSkuArgs = {
  skuId: Scalars["ID"];
};

export type QueryAssortmentUi__GetRowColorBulkArgs = {
  assortmentId: Scalars["ID"];
};

export type QueryAssortmentUi__GetRowSizeBulkArgs = {
  assortmentId: Scalars["ID"];
};

export type Query_BrandProfilesArgs = {
  brandIds: Array<Scalars["ID"]>;
};

export type Query_ProductsArgs = {
  productIds: Array<Scalars["ID"]>;
};

export type QueryAccountConnectionStatusesArgs = {
  accountId: Scalars["ID"];
  otherAccountIds: Array<Scalars["ID"]>;
};

export type QueryAccountCustomerCodesArgs = {
  otherAccountIds: Array<Scalars["ID"]>;
};

export type QueryAccountExportIntegrationConfigsArgs = {
  accountId?: InputMaybe<Scalars["ID"]>;
  integrationTypes: Array<ExportType>;
  isActive?: InputMaybe<Scalars["Boolean"]>;
  isGlobal?: InputMaybe<Scalars["Boolean"]>;
};

export type QueryAccountPaymentProvidersArgs = {
  destinationAccountId: Scalars["ID"];
};

export type QueryAccountPermissionAccessArgs = {
  accountId: Scalars["ID"];
};

export type QueryAccountUserDataPermissionConfigurationArgs = {
  accountId: Scalars["ID"];
  userId: Scalars["ID"];
};

export type QueryAccountUserGeoRestrictionsArgs = {
  accountId: Scalars["ID"];
  userId: Scalars["ID"];
};

export type QueryAccountUserPermissionAccessArgs = {
  accountId: Scalars["ID"];
  userId: Scalars["ID"];
};

export type QueryAggregateSkuInventoryItemsArgs = {
  endDate?: InputMaybe<Scalars["String"]>;
  filter?: InputMaybe<AggregateSkuInventoryItemsFilter>;
  includeImmediate?: InputMaybe<Scalars["Boolean"]>;
  startDate?: InputMaybe<Scalars["String"]>;
  warehouseIds: Array<Scalars["ID"]>;
};

export type QueryAssortmentArgs = {
  id: Scalars["ID"];
};

export type QueryAssortmentSkusArgs = {
  ids: Array<Scalars["ID"]>;
};

export type QueryAssortmentsArgs = {
  ids?: InputMaybe<Array<Scalars["ID"]>>;
};

export type QueryAssortmentsForBrandArgs = {
  brandId: Scalars["ID"];
};

export type QueryAssortmentsForCollectionArgs = {
  collectionId: Scalars["ID"];
  includeCustom?: InputMaybe<Scalars["Boolean"]>;
};

export type QueryAssortmentsQueryArgs = {
  after?: InputMaybe<Scalars["String"]>;
  filters?: InputMaybe<AssortmentFilter>;
  first?: InputMaybe<Scalars["Int"]>;
  orderBy?: InputMaybe<AssortmentsQueryOrderBy>;
};

export type QueryBackupProductsArgs = {
  orderIds: Array<Scalars["ID"]>;
  productIds: Array<Scalars["ID"]>;
};

export type QueryBadgesArgs = {
  brandIds?: InputMaybe<Array<Scalars["ID"]>>;
  filter?: InputMaybe<BadgeFilter>;
  orderBy?: InputMaybe<BadgeOrderBy>;
};

export type QueryBrandBudgetsArgs = {
  filters?: InputMaybe<BrandBudgetFilter>;
};

export type QueryBrandDoorsArgs = {
  brandId: Scalars["ID"];
};

export type QueryBrandMediaArgs = {
  filters?: InputMaybe<BrandMediaFilters>;
  limit?: InputMaybe<Scalars["Int"]>;
  offset?: InputMaybe<Scalars["Int"]>;
};

export type QueryBrandProfilesArgs = {
  brandIds: Array<Scalars["ID"]>;
};

export type QueryBrandsArgs = {
  filter?: InputMaybe<BrandsFilter>;
  limit?: InputMaybe<Scalars["Int"]>;
  offset?: InputMaybe<Scalars["Int"]>;
};

export type QueryCasepacksArgs = {
  filters: CasepackFilterInput;
};

export type QueryCheckMergingAccountCriteriaArgs = {
  accountIdsToMerge?: InputMaybe<Array<Scalars["ID"]>>;
  targetAccountId?: InputMaybe<Scalars["ID"]>;
};

export type QueryCheckMergingOrderCriteriaArgs = {
  orderIds: Array<Scalars["ID"]>;
  targetOrderId?: InputMaybe<Scalars["ID"]>;
};

export type QueryCollectionBannersArgs = {
  collectionIds: Array<Scalars["ID"]>;
};

export type QueryCollectionProductsArgs = {
  after?: InputMaybe<Scalars["String"]>;
  before?: InputMaybe<Scalars["String"]>;
  brandIds?: InputMaybe<Array<Scalars["ID"]>>;
  filter?: InputMaybe<ProductsCollectionFilter>;
  first?: InputMaybe<Scalars["Int"]>;
  groupBy?: InputMaybe<CollectionProductGroupByInput>;
  last?: InputMaybe<Scalars["Int"]>;
  limit?: InputMaybe<Scalars["Int"]>;
  offset?: InputMaybe<Scalars["Int"]>;
  orderBy?: InputMaybe<CollectionProductOrderByInput>;
};

export type QueryCollectionProductsGroupTotalArgs = {
  brandIds?: InputMaybe<Array<Scalars["ID"]>>;
  filter?: InputMaybe<ProductsCollectionFilter>;
  groupBy?: InputMaybe<CollectionProductGroupByInput>;
};

export type QueryCollectionProductsTotalArgs = {
  brandIds?: InputMaybe<Array<Scalars["ID"]>>;
  filter?: InputMaybe<ProductsCollectionFilter>;
};

export type QueryCollectionsArgs = {
  brandId?: InputMaybe<Scalars["ID"]>;
  brandIds?: InputMaybe<Array<Scalars["ID"]>>;
  filters?: InputMaybe<CollectionsFilter>;
  limit?: InputMaybe<Scalars["Int"]>;
  offset?: InputMaybe<Scalars["Int"]>;
  orderBy?: InputMaybe<CollectionsOrderBy>;
};

export type QueryCountriesCurrenciesArgs = {
  countriesNames: Array<Scalars["String"]>;
};

export type QueryCurrenciesArgs = {
  filters?: InputMaybe<CurrencyFilterInput>;
  ids?: InputMaybe<Array<Scalars["ID"]>>;
};

export type QueryDataPermissionConfigurationsArgs = {
  filter?: InputMaybe<DataPermissionConfigurationFilter>;
};

export type QueryDeliveryReportFeatureArgs = {
  accountId: Scalars["ID"];
};

export type QueryExternalPaymentByLinkArgs = {
  uuid: Scalars["String"];
};

export type QueryExternalPaymentRecordsArgs = {
  externalPaymentId: Scalars["ID"];
};

export type QueryExternalPaymentsArgs = {
  accountId: Scalars["ID"];
};

export type QueryExternalProviderAuthsArgs = {
  filters?: InputMaybe<ExternalProviderAuthFilters>;
};

export type QueryFavoritedBrandsByRetailAccountUserArgs = {
  orderBy?: InputMaybe<FavoritedBrandsOrderBy>;
};

export type QueryFindBrandsCarriedArgs = {
  first?: InputMaybe<Scalars["Int"]>;
  searchText?: InputMaybe<Scalars["String"]>;
};

export type QueryFindRetailersArgs = {
  filters?: InputMaybe<LgFindRetailersFilters>;
  first?: InputMaybe<Scalars["Int"]>;
  offset?: InputMaybe<Scalars["Int"]>;
  orderBy?: InputMaybe<LgFindRetailersOrderBy>;
  searchText?: InputMaybe<Scalars["String"]>;
};

export type QueryGeographiesArgs = {
  filter?: InputMaybe<GeographyFilter>;
  types: Array<Scalars["String"]>;
};

export type QueryGetOrderCustomerDataArgs = {
  orderId: Scalars["ID"];
};

export type QueryHubsArgs = {
  filter?: InputMaybe<HubFilter>;
  pagination?: InputMaybe<PaginationInfo>;
};

export type QueryInstagramAccountImagesArgs = {
  instagramAccountIds: Array<Scalars["ID"]>;
};

export type QueryInstagramAccountsArgs = {
  filters?: InputMaybe<InstagramAccountFilters>;
};

export type QueryInventoryAvailabilityGroupsArgs = {
  warehouseId: Scalars["ID"];
};

export type QueryInventoryVisibilitySettingsArgs = {
  brandId: Scalars["ID"];
};

export type QueryInvoiceExportPaymentDetailsByOrderIdsArgs = {
  accountId: Scalars["ID"];
  orderIds: Array<Scalars["ID"]>;
};

export type QueryInvoicesArgs = {
  accountId: Scalars["ID"];
  orderIds: Array<Scalars["ID"]>;
};

export type QueryKeycloakUserArgs = {
  email: Scalars["String"];
};

export type QueryLgGetRequestConnectionDataArgs = {
  brandId: Scalars["ID"];
  retailerId: Scalars["ID"];
};

export type QueryListAssortmentExportTasksArgs = {
  ids: Array<Scalars["ID"]>;
};

export type QueryListConnectionBuyersArgs = {
  input: ListConnectionBuyersInput;
};

export type QueryListConnectionDiscountsArgs = {
  input: ListConnectionDiscountInput;
};

export type QueryListConnectionDoorsArgs = {
  input: ListConnectionDoorsInput;
};

export type QueryListConnectionPaymentMethodsArgs = {
  input: ListConnectionPaymentMethodsInput;
};

export type QueryListConnectionPriceTypesArgs = {
  input: ListConnectionPriceTypeInput;
};

export type QueryListConnectionSalesRepsArgs = {
  input: ListConnectionSalesRepInput;
};

export type QueryListConnectionShippingMethodsArgs = {
  input: ListConnectionShippingMethodsInput;
};

export type QueryListConnectionWarehousesArgs = {
  input: ListConnectionWarehousesInput;
};

export type QueryListJobsArgs = {
  filters: CeleryJobFilter;
};

export type QueryListOrderExportTasksArgs = {
  input: ListOrderExportTasksInput;
};

export type QueryListRetailerGoogleAddressesArgs = {
  retailerIds?: InputMaybe<Array<Scalars["ID"]>>;
};

export type QueryListRetailerImpersonationFeedbackArgs = {
  accountIds?: InputMaybe<Array<Scalars["ID"]>>;
};

export type QueryLookArgs = {
  id: Scalars["ID"];
};

export type QueryManualPaymentRecordsArgs = {
  accountId: Scalars["ID"];
  orderIds: Array<Scalars["ID"]>;
};

export type QueryOrb360ProductsArgs = {
  limit?: InputMaybe<Scalars["Int"]>;
  offset?: InputMaybe<Scalars["Int"]>;
  searchText?: InputMaybe<Scalars["String"]>;
};

export type QueryOrderDiscountsArgs = {
  brandId?: InputMaybe<Scalars["ID"]>;
  brandRetailerIds?: InputMaybe<Array<BrandRetailerIdentifiers>>;
  retailerId?: InputMaybe<Scalars["ID"]>;
};

export type QueryOrderLineItemsArgs = {
  filter?: InputMaybe<OrderLineItemsFilter>;
  orderIds: Array<Scalars["ID"]>;
};

export type QueryOrderProductDiscountsArgs = {
  level?: InputMaybe<OrderDiscountLevel>;
  orderIds: Array<Scalars["ID"]>;
  productIds: Array<Scalars["ID"]>;
};

export type QueryOrderRequirementChecksArgs = {
  orderIds: Array<Scalars["ID"]>;
};

export type QueryOrderSettingsArgs = {
  brandIds?: InputMaybe<Array<Scalars["ID"]>>;
};

export type QueryOrderVariantTotalsArgs = {
  after?: InputMaybe<Scalars["String"]>;
  before?: InputMaybe<Scalars["String"]>;
  filter?: InputMaybe<OrderVariantTotalsFilter>;
  first?: InputMaybe<Scalars["Int"]>;
  last?: InputMaybe<Scalars["Int"]>;
  limit?: InputMaybe<Scalars["Int"]>;
  offset?: InputMaybe<Scalars["Int"]>;
  orderBy?: InputMaybe<OrderVariantTotalsOrderBy>;
  orderIds: Array<Scalars["ID"]>;
};

export type QueryOrdersArgs = {
  filters: OrderFilterInput;
  limit?: InputMaybe<Scalars["Int"]>;
  offset?: InputMaybe<Scalars["Int"]>;
};

export type QueryPaidAmountsByOrderIdArgs = {
  accountId: Scalars["ID"];
  orderIds: Array<Scalars["ID"]>;
};

export type QueryPaymentErrorsArgs = {
  accountId: Scalars["ID"];
  orderIds: Array<Scalars["ID"]>;
};

export type QueryPaymentMethodsArgs = {
  brandId: Scalars["ID"];
  paymentProvider?: InputMaybe<Scalars["String"]>;
  retailerId: Scalars["ID"];
};

export type QueryPaymentRecordsArgs = {
  accountId: Scalars["ID"];
  orderIds: Array<Scalars["ID"]>;
};

export type QueryPriceRangeGroupsArgs = {
  brandIds?: InputMaybe<Array<Scalars["ID"]>>;
  filter?: InputMaybe<ListPriceRangeGroupsFilter>;
  groupBy?: InputMaybe<PriceRangeGroupBy>;
};

export type QueryPriceTypesArgs = {
  brandIds: Array<Scalars["ID"]>;
  filter?: InputMaybe<PriceTypesFilter>;
};

export type QueryProductDetailArgs = {
  id: Scalars["String"];
};

export type QueryProductDiscountsArgs = {
  brandId?: InputMaybe<Scalars["ID"]>;
  productIds: Array<Scalars["ID"]>;
  retailerId: Scalars["ID"];
};

export type QueryProductTraitValuesArgs = {
  brandIds?: InputMaybe<Array<Scalars["ID"]>>;
  filter?: InputMaybe<ProductTraitValuesFilter>;
};

export type QueryProductsArgs = {
  after?: InputMaybe<Scalars["String"]>;
  before?: InputMaybe<Scalars["String"]>;
  brandId?: InputMaybe<Scalars["ID"]>;
  brandIds?: InputMaybe<Array<Scalars["ID"]>>;
  filter?: InputMaybe<ProductsFilter>;
  first?: InputMaybe<Scalars["Int"]>;
  last?: InputMaybe<Scalars["Int"]>;
  limit?: InputMaybe<Scalars["Int"]>;
  offset?: InputMaybe<Scalars["Int"]>;
  orderBy?: InputMaybe<ProductOrderByInput>;
};

export type QueryRegionsArgs = {
  accountId: Scalars["ID"];
};

export type QueryRetailBudgetArgs = {
  assortmentOrWorkspaceId: Scalars["ID"];
};

export type QueryRetailWorkspaceArgs = {
  id: Scalars["ID"];
};

export type QueryRetailWorkspacesArgs = {
  ids?: InputMaybe<Array<Scalars["ID"]>>;
};

export type QueryRetailerArgs = {
  id: Scalars["ID"];
};

export type QueryRetailerProfileArgs = {
  id: Scalars["ID"];
};

export type QueryRetailerProfileCompletionArgs = {
  id: Scalars["ID"];
};

export type QueryRetailerUsersArgs = {
  retailerIds?: InputMaybe<Array<Scalars["ID"]>>;
};

export type QueryRetailersArgs = {
  retailerIds?: InputMaybe<Array<Scalars["ID"]>>;
};

export type QueryRetailersThatFavoritedBrandArgs = {
  brandAccountId: Scalars["ID"];
  days?: InputMaybe<Scalars["Int"]>;
};

export type QueryShowroomCollectionArgs = {
  id: Scalars["ID"];
};

export type QueryShowroomCollectionListFiltersArgs = {
  status?: InputMaybe<ShowroomCollectionStatus>;
};

export type QueryShowroomCollectionsArgs = {
  after?: InputMaybe<Scalars["String"]>;
  before?: InputMaybe<Scalars["String"]>;
  filter?: InputMaybe<ShowroomCollectionsFilter>;
  first?: InputMaybe<Scalars["Int"]>;
  last?: InputMaybe<Scalars["Int"]>;
  orderBy?: InputMaybe<ShowroomCollectionOrderBy>;
};

export type QuerySizeRunsArgs = {
  filters?: InputMaybe<SizeRunFilters>;
};

export type QuerySkuDeliveriesArgs = {
  brandIds?: InputMaybe<Array<Scalars["ID"]>>;
  collectionIds: Array<Scalars["ID"]>;
  filter?: InputMaybe<SkuDeliveryFilter>;
};

export type QuerySkusArgs = {
  ids: Array<Scalars["ID"]>;
  withDeleted?: InputMaybe<Scalars["Boolean"]>;
};

export type QueryStorefrontsArgs = {
  brandIds: Array<Scalars["ID"]>;
  filters?: InputMaybe<StorefrontFilters>;
};

export type QueryStyleboardArgs = {
  id: Scalars["ID"];
};

export type QueryStyleboardCommentsArgs = {
  after?: InputMaybe<Scalars["String"]>;
  before?: InputMaybe<Scalars["String"]>;
  filter?: InputMaybe<StyleboardCommentsQueryFilter>;
  first?: InputMaybe<Scalars["Int"]>;
  last?: InputMaybe<Scalars["Int"]>;
};

export type QueryStyleboardLastModifiedArgs = {
  id: Scalars["ID"];
};

export type QueryStyleboardListFiltersArgs = {
  status?: InputMaybe<StyleboardStatus>;
};

export type QueryStyleboardVisibleToAccountUsersArgs = {
  limit?: InputMaybe<Scalars["Int"]>;
  searchText?: InputMaybe<Scalars["String"]>;
  styleboardId: Scalars["ID"];
};

export type QueryStyleboardsArgs = {
  after?: InputMaybe<Scalars["String"]>;
  before?: InputMaybe<Scalars["String"]>;
  filter?: InputMaybe<StyleboardsFilter>;
  first?: InputMaybe<Scalars["Int"]>;
  last?: InputMaybe<Scalars["Int"]>;
  orderBy?: InputMaybe<StyleboardOrderBy>;
};

export type QueryTermsAndConditionsArgs = {
  brandIds: Array<Scalars["ID"]>;
};

export type QueryTotalInOrdersArgs = {
  filters?: InputMaybe<OrderFilterInput>;
};

export type QueryTradeShowEventsArgs = {
  tradeShowEventIds: Array<Scalars["ID"]>;
};

export type QueryUniqueTagValuesArgs = {
  brandIds?: InputMaybe<Array<Scalars["ID"]>>;
  filter?: InputMaybe<UniqueTagValuesFilter>;
};

export type QueryUrl3dShowroomArgs = {
  filter?: InputMaybe<Url3dShowroomFilter>;
};

export type QueryUserArgs = {
  id: Scalars["ID"];
};

export type QueryUserCollaborationInvitesArgs = {
  filter?: InputMaybe<UserCollaborationInviteFilter>;
};

export type QueryUserMembershipRequestsArgs = {
  accountId: Scalars["ID"];
  filter?: InputMaybe<UserMembershipRequestFilter>;
};

export type QueryUsersArgs = {
  brandIds?: InputMaybe<Array<Scalars["ID"]>>;
  filter?: InputMaybe<UsersFilter>;
};

export type QueryUsesNewEditAndCreateArgs = {
  accountId: Scalars["ID"];
};

export type QueryVariantsInCartArgs = {
  filterBy?: InputMaybe<VariantsInCartFilter>;
};

export type QueryWarehousesArgs = {
  brandId?: InputMaybe<Scalars["ID"]>;
};

export type Rgb = {
  __typename?: "RGB";
  blue: Scalars["Int"];
  green: Scalars["Int"];
  red: Scalars["Int"];
};

export type ReachPaymentProvider = {
  __typename?: "ReachPaymentProvider";
  merchantId?: Maybe<Scalars["String"]>;
};

export type Region = Node & {
  __typename?: "Region";
  custom: Scalars["Boolean"];
  geographies: GeographyConnection;
  id: Scalars["ID"];
  name: Scalars["String"];
};

export type RegionConnection = {
  __typename?: "RegionConnection";
  edges: Array<RegionEdge>;
};

export type RegionEdge = {
  __typename?: "RegionEdge";
  node: Region;
};

export type RemoveAssortmentDoorClustersInput = {
  /** Id of the assortment to remove door clusters */
  assortmentId: Scalars["ID"];
  /** Ids of the door clusters to remove */
  doorClusterIds: Array<Scalars["ID"]>;
};

export type RemoveAssortmentDoorClustersPayload = {
  __typename?: "RemoveAssortmentDoorClustersPayload";
  assortment: Assortment;
};

export type RemoveAssortmentDoorsInput = {
  /** Id of the assortment to remove doors */
  assortmentId: Scalars["ID"];
  /** Ids of the doors to remove */
  doorIds: Array<Scalars["ID"]>;
};

export type RemoveAssortmentDoorsPayload = {
  __typename?: "RemoveAssortmentDoorsPayload";
  assortment: Assortment;
};

export type RemoveAssortmentSkuAttributesInput = {
  assortmentId?: InputMaybe<Scalars["ID"]>;
  /** Ids of the attribute options to remove */
  attributeOptionIds: Array<Scalars["ID"]>;
  /** Ids of the assortment sku override values being attributed */
  overrideIds: Array<Scalars["ID"]>;
};

export type RemoveAssortmentSkuColorAttributesPayload = {
  __typename?: "RemoveAssortmentSkuColorAttributesPayload";
  assortment?: Maybe<Assortment>;
  /** NOTE: There's a known bug with querying images and swatch on these nodes */
  colors?: Maybe<Array<AssortmentSkuColor>>;
  errors?: Maybe<Array<Error>>;
  /** Required to query the assortment in the mutation response */
  query?: Maybe<Query>;
};

export type RemoveProductsAndSkusFromCollectionInput = {
  collectionId: Scalars["ID"];
  productIds?: InputMaybe<Array<Scalars["ID"]>>;
};

export type RemoveSelectedAssortmentAttributeOptionsInput = {
  assortmentId: Scalars["ID"];
  attributeOptionIds: Array<Scalars["ID"]>;
};

export type RemoveSelectedAssortmentAttributeOptionsPayload = {
  __typename?: "RemoveSelectedAssortmentAttributeOptionsPayload";
  assortment?: Maybe<Assortment>;
  errors?: Maybe<Array<Error>>;
  query?: Maybe<Query>;
};

export type RequestAssortmentOrderUpdateInput = {
  assortmentId: Scalars["ID"];
  brandSalesRepresentativeEmail: Scalars["String"];
  ccSenderOnEmail?: InputMaybe<Scalars["Boolean"]>;
  customMessage?: InputMaybe<Scalars["String"]>;
};

export type RequestAssortmentOrderUpdatePayload = {
  __typename?: "RequestAssortmentOrderUpdatePayload";
  assortment: Assortment;
  query?: Maybe<Query>;
};

export type RequestConnectionToRetailerInput = {
  brandId: Scalars["ID"];
  invitationMessage?: InputMaybe<Scalars["String"]>;
  otherUserBrands?: InputMaybe<Array<RequestOtherUserBrand>>;
  priceTypes: Array<RequestPriceType>;
  retailerId: Scalars["ID"];
};

export type RequestConnectionToRetailerPayload = {
  __typename?: "RequestConnectionToRetailerPayload";
  brandId: Scalars["ID"];
  connectionStatus: LgConnectionStatus;
  error?: Maybe<Scalars["String"]>;
};

export type RequestOtherUserBrand = {
  brandId: Scalars["ID"];
  priceTypes: Array<RequestPriceType>;
};

export type RequestPriceType = {
  priceTypeId: Scalars["ID"];
  termsAndConditionsId?: InputMaybe<Scalars["ID"]>;
};

export enum RequestStatus {
  NotSent = "NOT_SENT",
  Sent = "SENT",
}

export type ResetPaymentRecordsInput = {
  accountId: Scalars["ID"];
  paymentProvider: Scalars["String"];
};

export type ResetPaymentRecordsPayload = {
  __typename?: "ResetPaymentRecordsPayload";
  ok: Scalars["Boolean"];
};

export type RetailAssortmentsFilters = {
  /** This will default to false, ignored if status filter is ARCHIVED */
  archived?: InputMaybe<Scalars["Boolean"]>;
  createdDateRange?: InputMaybe<AssortmentDateRangeFilter>;
  fullTextSearch?: InputMaybe<Scalars["String"]>;
  modifiedDateRange?: InputMaybe<AssortmentDateRangeFilter>;
  status?: InputMaybe<AssortmentStatus>;
};

/** A retail budget is either an Assortment budget or a Workspace budget */
export type RetailBudget = {
  __typename?: "RetailBudget";
  budgetType: BudgetType;
  categoryAmounts: Array<RetailBudgetCategoryAmount>;
  /** The Sum of all top level budget categories in the budget */
  categoryTotals: RetailBudgetCategoryTotals;
  finalExtCost?: Maybe<Scalars["Decimal"]>;
  finalExtCostCurrency?: Maybe<Scalars["String"]>;
  finalExtRetail?: Maybe<Scalars["Decimal"]>;
  finalExtRetailCurrency?: Maybe<Scalars["String"]>;
  id: Scalars["ID"];
  /** The sum of the total metric amounts for all products in the budget */
  productTotals: RetailBudgetCategoryTotals;
  topLevelBudgetCategory?: Maybe<RetailBudgetCategory>;
  totalUnits?: Maybe<Scalars["Decimal"]>;
  workspaceOrAssortmentId: Scalars["ID"];
};

/**
 * A RetailBudgetCategory can have Brand, Hierarchy, or Order attribute as type. It is a self-referencing type to allow multiple levels of budgeting. One can budget by _Brand_ as the top-level budget category and then break it down further by _Order attribute_ on the second level. This allows you to specify a budget for each order attribute per brand. For example:
 *
 * Budget Level 1: Brand
 * Selections: Balenciaga, Falke, Missoni
 *
 * Budget Level 2: Order attribute
 * Selections: Phase -> Pre-collection, Phase -> Main Collection, Phase -> Chase.
 *
 * With the budget levels above, we can budget each brand's pre-collection amount:
 * Balenciaga -> Pre-collection has a budget of $10,000.00
 * Falke -> Pre-collection has a budget of $20,000.00
 * Missoni -> Pre-collection has a budget of $30,000.00
 *
 * Similarly, we can budget for all the other second-level categories per brand.
 */
export type RetailBudgetCategory = {
  __typename?: "RetailBudgetCategory";
  categoryType: RetailBudgetCategoryType;
  child?: Maybe<RetailBudgetCategory>;
  id: Scalars["ID"];
};

/** Holds data related to the amount for a BudgetCategory. */
export type RetailBudgetCategoryAmount = {
  __typename?: "RetailBudgetCategoryAmount";
  categoryAmounts?: Maybe<Array<RetailBudgetCategoryAmount>>;
  /** The sum of all category amounts associated with this RetailBudgetCategoryAmount */
  categoryTotals: RetailBudgetCategoryTotals;
  finalExtCost?: Maybe<Scalars["Decimal"]>;
  finalExtRetail?: Maybe<Scalars["Decimal"]>;
  id: Scalars["ID"];
  /** Sum of all metric amounts (including parent amounts) for products that apply to the selection */
  productTotals: RetailBudgetCategoryTotals;
  selection: RetailCategorySelection;
  totalUnits?: Maybe<Scalars["Decimal"]>;
};

export type RetailBudgetCategoryAmountInput = {
  /**
   * one of brandId, orderAttributeId or hierarchyElementId must be specified
   * the resolver will throw an error if none of them are specified
   */
  brandId?: InputMaybe<Scalars["ID"]>;
  categoryAmounts?: InputMaybe<Array<RetailBudgetCategoryAmountInput>>;
  finalExtCost?: InputMaybe<Scalars["Decimal"]>;
  finalExtRetail?: InputMaybe<Scalars["Decimal"]>;
  hierarchyElementId?: InputMaybe<Scalars["ID"]>;
  /** A new budget category amount will be created if id is omitted */
  id?: InputMaybe<Scalars["ID"]>;
  orderAttributeId?: InputMaybe<Scalars["ID"]>;
  totalUnits?: InputMaybe<Scalars["Decimal"]>;
};

export type RetailBudgetCategoryInput = {
  categoryType: RetailBudgetCategoryType;
  /**
   * "
   * NOTE: Omitting a child category will delete the child categorry.
   */
  child?: InputMaybe<RetailBudgetCategoryInput>;
  /** A new budget category will be created if id is omitted */
  id?: InputMaybe<Scalars["ID"]>;
};

export type RetailBudgetCategoryTotals = {
  __typename?: "RetailBudgetCategoryTotals";
  finalExtCost: Scalars["Decimal"];
  finalExtRetail: Scalars["Decimal"];
  totalUnits: Scalars["Decimal"];
};

/** The supported types that a RetailBudget can be. */
export enum RetailBudgetCategoryType {
  Brand = "BRAND",
  Hierarchy = "HIERARCHY",
  OrderAttribute = "ORDER_ATTRIBUTE",
}

export type RetailBudgetInput = {
  /**
   * "
   * NOTE: If id is included in the input, budgetType, workspaceOrAssortmentId
   * and metric will be ignored. One cannot update the budgetType,
   * workspaceOrAssortmentId or metric of an existing budget
   */
  budgetType: BudgetType;
  /**
   * "
   * NOTE: Omitting amounts when updating an existing budget will delete amounts.
   * categoryAmounts need to contain the completed desired state of the budget.
   */
  categoryAmounts?: InputMaybe<Array<RetailBudgetCategoryAmountInput>>;
  finalExtCost?: InputMaybe<Scalars["Decimal"]>;
  finalExtCostCurrency?: InputMaybe<Scalars["String"]>;
  finalExtRetail?: InputMaybe<Scalars["Decimal"]>;
  finalExtRetailCurrency?: InputMaybe<Scalars["String"]>;
  /**
   * A new budget will be created if id is omitted. The RetailBudgetInput needs
   * to included the entire desired state of the budget. Any categories or
   * amounts that are omitted on subsequent edits will be deleted. Any categories
   * and amounts that specifies `id` will be updated. Categories and amounts
   * without `id` will be created.
   */
  id?: InputMaybe<Scalars["ID"]>;
  topLevelBudgetCategory?: InputMaybe<RetailBudgetCategoryInput>;
  totalUnits?: InputMaybe<Scalars["Decimal"]>;
  workspaceOrAssortmentId: Scalars["ID"];
};

/** A RetailCategorySelection is associated with either a Brand, Hierarchy, or Assortment Attribute */
export type RetailCategorySelection =
  | AttributeOption
  | MerchandisingHierarchyNode
  | RetailerBrand;

export type RetailDoorSizeCurves = {
  __typename?: "RetailDoorSizeCurves";
  /** Applicable size curve ratios for this door and product color */
  curveRatios: Array<SizeCurveRatio>;
  door: Door;
};

export type RetailSize = Node & {
  __typename?: "RetailSize";
  code?: Maybe<Scalars["String"]>;
  id: Scalars["ID"];
  name?: Maybe<Scalars["String"]>;
};

export type RetailSizeCurves = {
  __typename?: "RetailSizeCurves";
  /** Size curves available for this color by door */
  doorSizeCurves: Array<RetailDoorSizeCurves>;
  /** Indicates a missing required field for a size curve to be applicable */
  missingFields: Array<RetailSizeCurvesMissingFields>;
};

export enum RetailSizeCurvesMissingFields {
  AttributeOptions = "ATTRIBUTE_OPTIONS",
  Brand = "BRAND",
  Hierarchy = "HIERARCHY",
  Season = "SEASON",
  SizeRun = "SIZE_RUN",
}

export type RetailWorkspace = Node & {
  __typename?: "RetailWorkspace";
  /** A list of currencies common to the assortment POs in the workspace. */
  assortmentCurrencies: Array<RetailWorkspaceAssortmentCurrency>;
  /** Price level roll-ups for the assortment POs in the workspace. */
  assortmentPriceLevels: Array<RetailWorkspaceAssortmentPriceLevel>;
  /** The assortment POs that make up the workspace */
  assortments: Array<Assortment>;
  id: Scalars["ID"];
  /** The name of the workspace */
  name: Scalars["String"];
};

export type RetailWorkspaceAssortmentCurrenciesArgs = {
  filters?: InputMaybe<RetailWorkspaceAssortmentCurrencyFilters>;
};

export type RetailWorkspaceAssortmentPriceLevelsArgs = {
  filters?: InputMaybe<RetailWorkspaceAssortmentPriceLevelFilters>;
};

export type RetailWorkspaceAssortmentCurrency = Node & {
  __typename?: "RetailWorkspaceAssortmentCurrency";
  assortments: Array<Assortment>;
  currencyCode: CurrencyCode;
  id: Scalars["ID"];
  isCommonCurrency: Scalars["Boolean"];
  workspace: RetailWorkspace;
};

export type RetailWorkspaceAssortmentCurrencyFilters = {
  commonCurrenciesOnly?: InputMaybe<Scalars["Boolean"]>;
};

export type RetailWorkspaceAssortmentPriceLevel = Node & {
  __typename?: "RetailWorkspaceAssortmentPriceLevel";
  currency: RetailWorkspaceAssortmentCurrency;
  extendedCost: RetailWorkspaceAssortmentPriceRange;
  extendedRetail: RetailWorkspaceAssortmentPriceRange;
  id: Scalars["ID"];
  name: FinancialPriceLevelName;
  totalUnitCount: Scalars["Int"];
  workspace: RetailWorkspace;
};

export type RetailWorkspaceAssortmentPriceLevelFilters = {
  commonCurrenciesOnly?: InputMaybe<Scalars["Boolean"]>;
  name?: InputMaybe<FinancialPriceLevelName>;
};

export type RetailWorkspaceAssortmentPriceRange = {
  __typename?: "RetailWorkspaceAssortmentPriceRange";
  max: Scalars["Decimal"];
  min: Scalars["Decimal"];
};

export type RetailWorkspacePayload = {
  __typename?: "RetailWorkspacePayload";
  retailWorkspace?: Maybe<RetailWorkspace>;
};

/** A JOOR retailer account */
export type Retailer = Node & {
  __typename?: "Retailer";
  accountProfile?: Maybe<AccountProfile>;
  /** Query an assortment by its id */
  assortment: Assortment;
  /** Assortment attributes */
  assortmentAttributes: AttributeConnection;
  /** Assortment price modifiers */
  assortmentPriceModifierGroups: PriceModifierGroupConnection;
  /** A list of assortments */
  assortments: AssortmentSummaryConnection;
  attributes: AttributeConnection;
  /** The attribute options available to be applied to assortment sku colors for this retailer */
  availableItemColorAttributeOptions: AttributeOptionConnection;
  /** Brand connections on JOOR */
  brands: RetailerBrandConnection;
  categories?: Maybe<Array<Scalars["String"]>>;
  /** Currency conversion defaults */
  currencyConversions: Array<CurrencyConversion>;
  displayName: Scalars["String"];
  /** Retailer doors */
  doors: DoorConnection;
  id: Scalars["ID"];
  /** Item color attributes */
  itemColorAttributes: AttributeConnection;
  /** Item color price modifiers */
  itemColorPriceModifierGroups: PriceModifierGroupConnection;
  locations?: Maybe<Array<Location>>;
  /** Flattened merchandising hierarchy */
  merchandisingHierarchy: MerchandisingHierarchyNodeConnection;
  /** A display name */
  name: Scalars["String"];
  /** Set of public information about the retailer */
  publicRetailerProfile?: Maybe<PublicRetailerProfile>;
  /** Specific selling periods used to group assortments */
  seasons: SeasonConnection;
};

/** A JOOR retailer account */
export type RetailerAssortmentArgs = {
  id: Scalars["ID"];
};

/** A JOOR retailer account */
export type RetailerAssortmentsArgs = {
  filters?: InputMaybe<RetailAssortmentsFilters>;
  hasBeenImported?: InputMaybe<Scalars["Boolean"]>;
  orderBy?: InputMaybe<AssortmentsOrderBy>;
  skip?: InputMaybe<Scalars["Int"]>;
  take?: InputMaybe<Scalars["Int"]>;
};

/** A JOOR retailer account */
export type RetailerAttributesArgs = {
  ids: Array<Scalars["ID"]>;
};

/** A JOOR retailer account */
export type RetailerAvailableItemColorAttributeOptionsArgs = {
  brandAccountId: Scalars["ID"];
  buyerHierarchyNodeId?: InputMaybe<Scalars["ID"]>;
  selectedOptionIds: Array<Scalars["ID"]>;
};

/** A JOOR retailer account */
export type RetailerBrandsArgs = {
  allConnections?: InputMaybe<Scalars["Boolean"]>;
  filters?: InputMaybe<ListConnectedBrandsFilter>;
};

export type RetailerAccount = {
  __typename?: "RetailerAccount";
  /** @deprecated Get account id from the retailerAccount node instead */
  account: Scalars["ID"];
  customer_codes?: Maybe<Array<Maybe<CustomerCode>>>;
  retailerAccount: AccountProfile;
};

export type RetailerBrand = Node & {
  __typename?: "RetailerBrand";
  alias?: Maybe<Scalars["String"]>;
  code?: Maybe<Scalars["String"]>;
  id: Scalars["ID"];
  name: Scalars["String"];
};

export type RetailerBrandConnection = {
  __typename?: "RetailerBrandConnection";
  edges: Array<RetailerBrandEdge>;
};

/**
 * A connection between a retailer account and brand account on JOOR
 * represents the ability to do business
 */
export type RetailerBrandEdge = {
  __typename?: "RetailerBrandEdge";
  /** A display name */
  alias?: Maybe<Scalars["String"]>;
  /** A user defined identifier used to distinguish connections to brands. */
  code?: Maybe<Scalars["String"]>;
  id: Scalars["ID"];
  /** A brand account */
  node?: Maybe<Brand>;
  profileName?: Maybe<Scalars["String"]>;
};

export type RetailerBrandFilter = {
  __typename?: "RetailerBrandFilter";
  cursor?: Maybe<Scalars["String"]>;
  node?: Maybe<RetailerBrandEdge>;
};

export type RetailerBrandFilterConnection = {
  __typename?: "RetailerBrandFilterConnection";
  edges?: Maybe<Array<RetailerBrandFilter>>;
};

export type RetailerConnection = {
  __typename?: "RetailerConnection";
  edges?: Maybe<Array<RetailerEdge>>;
};

export type RetailerEdge = {
  __typename?: "RetailerEdge";
  node?: Maybe<Retailer>;
};

export type RetailerImpersonationFeedback = {
  __typename?: "RetailerImpersonationFeedback";
  accountId: Scalars["ID"];
  comment?: Maybe<Scalars["String"]>;
  created?: Maybe<Scalars["Date"]>;
  id: Scalars["ID"];
  modified?: Maybe<Scalars["Date"]>;
  option: RetailerImpersonationFeedbackOption;
};

export type RetailerImpersonationFeedbackConnection = {
  __typename?: "RetailerImpersonationFeedbackConnection";
  edges: Array<RetailerImpersonationFeedbackEdge>;
};

export type RetailerImpersonationFeedbackEdge = {
  __typename?: "RetailerImpersonationFeedbackEdge";
  node: RetailerImpersonationFeedback;
};

export type RetailerImpersonationFeedbackInput = {
  accountId: Scalars["ID"];
  comment?: InputMaybe<Scalars["String"]>;
  option: RetailerImpersonationFeedbackOption;
};

export enum RetailerImpersonationFeedbackOption {
  Other = "OTHER",
  PersonalShopper = "PERSONAL_SHOPPER",
  RetailerRepresentative = "RETAILER_REPRESENTATIVE",
  UnconnectedOrders = "UNCONNECTED_ORDERS",
  Unknown = "UNKNOWN",
}

export type RetailerProfileCompletion = {
  __typename?: "RetailerProfileCompletion";
  id: Scalars["ID"];
  percentage: Scalars["Int"];
};

export type RetailerProfileImage = {
  __typename?: "RetailerProfileImage";
  id: Scalars["ID"];
  upload?: Maybe<RetailerUpload>;
};

export type RetailerRecipient = {
  accountId: Scalars["ID"];
  email: Scalars["String"];
};

export type RetailerSize = Node & {
  __typename?: "RetailerSize";
  /** A unique identifier */
  code: Scalars["String"];
  id: Scalars["ID"];
  /** A display name */
  name: Scalars["String"];
};

export type RetailerThatFavoritedBrand = {
  __typename?: "RetailerThatFavoritedBrand";
  retailerAccountId: Scalars["ID"];
  retailerUser?: Maybe<RetailerUserThatFavoritedBrand>;
  timeFavorited: Scalars["Date"];
  tradeShowEvent?: Maybe<TradeShowEvent>;
};

export type RetailerUpload = {
  __typename?: "RetailerUpload";
  id: Scalars["ID"];
  mediaType: Scalars["String"];
  name?: Maybe<Scalars["String"]>;
  url: Scalars["String"];
};

export type RetailerUser = Node & {
  __typename?: "RetailerUser";
  code: Scalars["String"];
  displayName: Scalars["String"];
  email: Scalars["String"];
  id: Scalars["ID"];
};

export type RetailerUserConnection = {
  __typename?: "RetailerUserConnection";
  edges?: Maybe<Array<RetailerUserEdge>>;
};

export type RetailerUserEdge = {
  __typename?: "RetailerUserEdge";
  node?: Maybe<RetailerUser>;
};

export type RetailerUserThatFavoritedBrand = {
  __typename?: "RetailerUserThatFavoritedBrand";
  email?: Maybe<Scalars["String"]>;
  id: Scalars["ID"];
  name?: Maybe<Scalars["String"]>;
};

/** Conditional relationships between rules that evaluate if a price modifier is applicable */
export enum RuleConectivity {
  /** Rules will be required to ALL be true */
  And = "AND",
  /** Rules will require AT LEAST ONE to be true */
  Or = "OR",
}

export type RuleItem = RuleSet | SimpleRule;

/** Relationships which evaluate a field-value pair */
export enum RuleRelation {
  /** Evaluate the equality of two values */
  Is = "IS",
  IsNot = "IS_NOT",
}

/**
 * Nested collection of individually evaluated rule-sets which itself evaluates to true or false. The connectivity field
 * determines how the entire collection evaluates in relation to those rule-sets
 */
export type RuleSet = {
  __typename?: "RuleSet";
  /** Setting which determines how this collection will evaluate its nested set of rules */
  connectivity: RuleConectivity;
  /** Collection of rules which are individually evaluated */
  rules?: Maybe<Array<RuleItem>>;
};

export type Sku = Node & {
  __typename?: "SKU";
  collections: CollectionConnection;
  /** The color properties of this unit */
  color: Color;
  description?: Maybe<Scalars["String"]>;
  doorPrices: SkuDoorPriceConnection;
  /** External SKU identifiers */
  external_id?: Maybe<Scalars["String"]>;
  id: Scalars["ID"];
  /**
   * List of prices with their price types for this unit
   * TODO(smarsh): replace array with a Connection before exposing to external users
   */
  prices: Array<SkuPrice>;
  /** The size properties of this unit */
  size: Size;
  sku_identifier?: Maybe<Scalars["String"]>;
  /** List of prices that by default only reads from the sku_prices table */
  sku_prices: Array<SkuPrice>;
  /** Designates whether this unit was created by a brand of a retailer */
  source: Source;
  /** The style properties of this unit */
  style: Style;
  traitValues: SkuTraitValueConnection;
  upc?: Maybe<Scalars["String"]>;
  variantValues: SkuTraitValueConnection;
};

export type SkuDoorPricesArgs = {
  doorIds?: InputMaybe<Array<Scalars["ID"]>>;
  orderTypeIds?: InputMaybe<Array<Scalars["ID"]>>;
  priceTypeId: Scalars["ID"];
  retailerId: Scalars["ID"];
};

export type SkuPricesArgs = {
  priceTypeIds?: InputMaybe<Array<Scalars["ID"]>>;
};

export type SkuConnection = {
  __typename?: "SKUConnection";
  edges?: Maybe<Array<SkuEdge>>;
};

export type SkuEdge = {
  __typename?: "SKUEdge";
  node?: Maybe<Sku>;
};

export type SalesComission = {
  __typename?: "SalesComission";
  amount?: Maybe<Scalars["String"]>;
  name: Scalars["String"];
  orderId: Scalars["ID"];
};

export type SalesRepresentative = {
  __typename?: "SalesRepresentative";
  email?: Maybe<Scalars["String"]>;
  name?: Maybe<Scalars["String"]>;
};

export type SalesRepresentativePayload = {
  __typename?: "SalesRepresentativePayload";
  code?: Maybe<Scalars["String"]>;
  id: Scalars["ID"];
  username?: Maybe<Scalars["String"]>;
};

/** A specific selling period used to group assortments */
export type Season = Node & {
  __typename?: "Season";
  /** A unique identifier */
  code: Scalars["String"];
  id: Scalars["ID"];
  /** A display name */
  name: Scalars["String"];
  /** A calendar year */
  year?: Maybe<Scalars["Int"]>;
};

export type SeasonConnection = {
  __typename?: "SeasonConnection";
  edges: Array<SeasonEdge>;
};

export type SeasonEdge = {
  __typename?: "SeasonEdge";
  node: Season;
};

export type SeasonInput = {
  code: Scalars["String"];
  name: Scalars["String"];
  year: Scalars["Int"];
};

export type SeasonName = {
  __typename?: "SeasonName";
  name?: Maybe<Scalars["String"]>;
};

export type SendCollectionsToConnectionsInput = {
  collectionIds: Array<Scalars["ID"]>;
  externalEmails?: InputMaybe<Array<Scalars["String"]>>;
  messageAttachmentId?: InputMaybe<Scalars["ID"]>;
  messageBody: Scalars["String"];
  messageSubject: Scalars["String"];
  notify?: InputMaybe<Scalars["Boolean"]>;
  priceTypeId: Scalars["ID"];
  retailerIds?: InputMaybe<Array<Scalars["ID"]>>;
  sendToAllConnections?: InputMaybe<Scalars["Boolean"]>;
  tokenActiveDays?: InputMaybe<Scalars["Int"]>;
};

export type SendCollectionsToConnectionsPayload = {
  __typename?: "SendCollectionsToConnectionsPayload";
  collections?: Maybe<CollectionConnection>;
};

export type SendEmailConfirmationInput = {
  orderId: Scalars["ID"];
};

export type SendEmailConfirmationPayload = {
  __typename?: "SendEmailConfirmationPayload";
  error?: Maybe<Scalars["String"]>;
  success: Scalars["Boolean"];
};

export type SendInvoicesForOrdersInput = {
  accountId: Scalars["ID"];
  invoicesParameters: Array<InvoiceParameter>;
};

export type SendJoorPayImInterestedEmailInput = {
  language?: InputMaybe<Scalars["String"]>;
  orderId: Scalars["ID"];
};

export type SendJoorPayImInterestedEmailPayload = {
  __typename?: "SendJoorPayImInterestedEmailPayload";
  success: Scalars["Boolean"];
};

export type SendMessageToConnectionInput = {
  body?: InputMaybe<Scalars["String"]>;
  recipientId: Scalars["ID"];
  subject?: InputMaybe<Scalars["String"]>;
  uploadId?: InputMaybe<Scalars["ID"]>;
};

export type SendMessageToConnectionPayload = {
  __typename?: "SendMessageToConnectionPayload";
  error?: Maybe<Scalars["String"]>;
  messageId: Scalars["ID"];
};

export type SendPaymentInput = {
  bccEmails?: InputMaybe<Array<Scalars["String"]>>;
  customMessage?: InputMaybe<Scalars["String"]>;
  customSubject?: InputMaybe<Scalars["String"]>;
  id: Scalars["ID"];
  language?: InputMaybe<Scalars["String"]>;
};

export type SendStyleboardsToEmailsInput = {
  emails: Array<Scalars["String"]>;
  message: Scalars["String"];
  sendCopyToSender: Scalars["Boolean"];
  styleboardIds: Array<Scalars["ID"]>;
};

export type SendStyleboardsToEmailsPayload = {
  __typename?: "SendStyleboardsToEmailsPayload";
  errors?: Maybe<Array<Error>>;
};

export type SetAssormentDefaultDoorClustersInput = {
  /** List of default cluster ids */
  clusterIds?: InputMaybe<Array<Scalars["ID"]>>;
  /** List of default door ids */
  doorIds?: InputMaybe<Array<Scalars["ID"]>>;
};

export type SetAssortmentColorBulkDoorQuantityInput = {
  assortmentId: Scalars["ID"];
  bulkQuantity: Scalars["Int"];
  clusterId?: InputMaybe<Scalars["ID"]>;
  colorId: Scalars["ID"];
  doorId?: InputMaybe<Scalars["ID"]>;
  skuId: Scalars["ID"];
};

export type SetAssortmentColorBulkDoorQuantityPayload = {
  __typename?: "SetAssortmentColorBulkDoorQuantityPayload";
  assortment: Assortment;
  color: AssortmentSkuColor;
  query?: Maybe<Query>;
};

export type SetAssortmentCurrencyConversionInput = {
  /** The ID of the assortment to update */
  assortmentId: Scalars["ID"];
  /** Multiplicative conversion rate applied */
  factor: Scalars["Decimal"];
  /** Initial currency */
  fromCurrencyCode: Scalars["String"];
  /** Final currency */
  toCurrencyCode: Scalars["String"];
};

export type SetAssortmentCurrencyConversionPayload = {
  __typename?: "SetAssortmentCurrencyConversionPayload";
  assortmentCurrencyConversion?: Maybe<AssortmentCurrencyConversion>;
  errors?: Maybe<Array<Error>>;
};

export type SetAssortmentDefaultDoorClustersPayload = {
  __typename?: "SetAssortmentDefaultDoorClustersPayload";
  /** List of default cluster ids */
  clusterIds?: Maybe<Array<Scalars["ID"]>>;
  /** List of default door ids */
  doorIds?: Maybe<Array<Scalars["ID"]>>;
};

export type SetAssortmentDoorClustersInput = {
  /** Id of the assortment to create or update door clusters */
  assortmentId: Scalars["ID"];
  /** Door clusters to create or update */
  doorClusters: Array<DoorClusterInput>;
};

export type SetAssortmentDoorClustersPayload = {
  __typename?: "SetAssortmentDoorClustersPayload";
  assortment: Assortment;
};

export type SetAssortmentDoorsInput = {
  /** Id of the assortment to create or update door clusters */
  assortmentId: Scalars["ID"];
  /** Door clusters to create or update */
  doorClusters: Array<DoorClusterInput>;
  /** Ids of the doors to include */
  doorIds: Array<Scalars["ID"]>;
};

export type SetAssortmentDoorsPayload = {
  __typename?: "SetAssortmentDoorsPayload";
  assortment: Assortment;
};

export type SetAssortmentMerchandisingHierarchyInput = {
  assortmentId: Scalars["ID"];
  merchandisingHierarchyNodeId: Scalars["ID"];
};

export type SetAssortmentMerchandisingHierarchyPayload = {
  __typename?: "SetAssortmentMerchandisingHierarchyPayload";
  assortment?: Maybe<Assortment>;
};

export type SetAssortmentProductPricePayload = {
  __typename?: "SetAssortmentProductPricePayload";
  assortment?: Maybe<Assortment>;
  query?: Maybe<Query>;
};

export type SetAssortmentProductRetailPriceInput = {
  assortmentId: Scalars["ID"];
  itemId: Scalars["ID"];
  retailCurrencyCode?: InputMaybe<CurrencyCode>;
  retailPrice?: InputMaybe<Scalars["Decimal"]>;
};

export type SetAssortmentProductWholesalePriceInput = {
  assortmentId: Scalars["ID"];
  itemId: Scalars["ID"];
  wholesaleCurrencyCode?: InputMaybe<CurrencyCode>;
  wholesalePrice?: InputMaybe<Scalars["Decimal"]>;
};

export type SetAssortmentProductWholesalePricePayload = {
  __typename?: "SetAssortmentProductWholesalePricePayload";
  assortment?: Maybe<Assortment>;
  query?: Maybe<Query>;
};

export type SetAssortmentSharesInput = {
  assortmentId: Scalars["ID"];
  shares: Array<AssortmentShareInput>;
};

export type SetAssortmentSharesPayload = {
  __typename?: "SetAssortmentSharesPayload";
  assortment: Assortment;
};

export type SetAssortmentSizedDoorQuantityInput = {
  assortmentId: Scalars["ID"];
  doorId: Scalars["ID"];
  quantity: Scalars["Int"];
  skuId: Scalars["ID"];
};

export type SetAssortmentSizedDoorQuantityPayload = {
  __typename?: "SetAssortmentSizedDoorQuantityPayload";
  assortment: Assortment;
  sku: AssortmentSkuEdge;
};

export type SetAssortmentSkuDoorLineItemBulkQuantityPayload = {
  __typename?: "SetAssortmentSkuDoorLineItemBulkQuantityPayload";
  assortment: Assortment;
  destination?: Maybe<AssortmentSkuDoorLineItemBulkQuantityDoorOrCluster>;
  lineItems: Array<LineItem>;
  quantity: Scalars["Int"];
  query?: Maybe<Query>;
};

export type SetAssortmentSkuFinalRetailPriceInput = {
  assortmentId: Scalars["ID"];
  finalRetailPrice: Scalars["Decimal"];
  finalRetailPriceCurrencyCode: CurrencyCode;
  skuIds: Array<Scalars["ID"]>;
};

export type SetAssortmentSkuFinalRetailPricePayload = {
  __typename?: "SetAssortmentSkuFinalRetailPricePayload";
  assortment: Assortment;
  doors: Array<DoorPriceLevels>;
  products: Array<ProductPriceLevels>;
  query?: Maybe<Query>;
  total: TotalPriceLevels;
};

export type SetAssortmentSkuRetailPriceInput = {
  assortmentId: Scalars["ID"];
  currencyCode?: InputMaybe<Scalars["String"]>;
  retailPrice?: InputMaybe<Scalars["Decimal"]>;
  skuIds: Array<Scalars["ID"]>;
};

export type SetAssortmentSkuRetailPricePayload = {
  __typename?: "SetAssortmentSkuRetailPricePayload";
  assortment: Assortment;
  doors?: Maybe<Array<DoorPriceLevels>>;
  products: Array<ProductPriceLevels>;
  query?: Maybe<Query>;
  total: TotalPriceLevels;
};

export type SetAssortmentSkuUpcInput = {
  itemColorId: Scalars["String"];
  itemSizeId: Scalars["String"];
  upc: Scalars["String"];
};

export type SetAssortmentSkuUpcPayload = {
  __typename?: "SetAssortmentSkuUpcPayload";
  assortment?: Maybe<Assortment>;
  error?: Maybe<Error>;
  query?: Maybe<Query>;
};

export type SetAssortmentSkuWholesalePriceInput = {
  assortmentId: Scalars["ID"];
  currencyCode?: InputMaybe<Scalars["String"]>;
  skuIds: Array<Scalars["ID"]>;
  wholesalePrice?: InputMaybe<Scalars["Decimal"]>;
};

export type SetAssortmentSkuWholesalePricePayload = {
  __typename?: "SetAssortmentSkuWholesalePricePayload";
  assortment: Assortment;
  doors: Array<DoorPriceLevels>;
  products: Array<ProductPriceLevels>;
  query?: Maybe<Query>;
  total: TotalPriceLevels;
};

/** Overwrite the attribute options filters for an attribute option */
export type SetAttributeOptionFilterForAttributeOptionInput = {
  /** Id of the object to update */
  attributeOptionId: Scalars["ID"];
  /** The other attribute option IDs that will filter this attribute option */
  filterAttributeOptionIds: Array<Scalars["ID"]>;
};

export type SetAttributeOptionFilterForAttributeOptionPayload = {
  __typename?: "SetAttributeOptionFilterForAttributeOptionPayload";
  attributeOption?: Maybe<AttributeOption>;
  errors?: Maybe<Array<Error>>;
};

export type SetBudgetGoalInput = {
  /** The goal to update */
  goal: BudgetGoalType;
  /** The value to set for this goal */
  value: Scalars["String"];
};

/** Overwirtes goals for a budget */
export type SetBudgetGoalsInput = {
  /** Id of the object to update */
  budgetId: Scalars["ID"];
  /** The goals to set for this budget */
  goals: Array<SetBudgetGoalInput>;
};

export type SetBudgetGoalsPayload = {
  __typename?: "SetBudgetGoalsPayload";
  budget?: Maybe<Budget>;
  errors?: Maybe<Array<Error>>;
};

export type SetCollectionDeliveryInput = {
  cancelDate?: InputMaybe<Scalars["Date"]>;
  collectionId: Scalars["ID"];
  completeShipDate?: InputMaybe<Scalars["Date"]>;
  minimumShippingWindow?: InputMaybe<Scalars["Int"]>;
  startShipDate?: InputMaybe<Scalars["Date"]>;
};

export type SetCurrencyConversionInput = {
  /** Multiplicative conversion rate applied */
  factor: Scalars["Decimal"];
  /** Initial currency */
  fromCurrencyCode: Scalars["String"];
  /** The ID of the retailer for which to create this currency conversion */
  retailerId: Scalars["ID"];
  /** Final currency */
  toCurrencyCode: Scalars["String"];
};

export type SetCurrencyConversionPayload = {
  __typename?: "SetCurrencyConversionPayload";
  currencyConversion?: Maybe<CurrencyConversion>;
  errors?: Maybe<Array<Error>>;
};

export type SetCustomerRecordPaymentMethodRequest = {
  customerRecordId: Scalars["ID"];
  paymentMethodsIds: Array<PaymentMethodIdentifier>;
};

/**
 * Sets the default display language for a user.
 * Valid language codes are listed in app/View/Accounts/settings.ctp and correspond to Localize.js codes.
 * If the language code inputted is invalid, there will be no error thrown and the display language will not be changed.
 */
export type SetDisplayLanguageForUserInput = {
  /** The ID of the user */
  id: Scalars["ID"];
  /** The language code to set the user's display language to */
  languageCode: Scalars["String"];
};

/** Return the user id and language code for the user's updated display language. */
export type SetDisplayLanguageForUserPayload = {
  __typename?: "SetDisplayLanguageForUserPayload";
  displayLanguage: Scalars["String"];
  id: Scalars["ID"];
};

export type SetImpersonatedUserInput = {
  impersonated_account_id?: InputMaybe<Scalars["String"]>;
  impersonated_user_id: Scalars["String"];
};

export type SetImpersonatedUserPayload = {
  __typename?: "SetImpersonatedUserPayload";
  error?: Maybe<Scalars["String"]>;
  success: Scalars["Boolean"];
};

/** Overwrite the merchandising hierarchy filters for an attribute option */
export type SetMerchandisingHierarchyFilterForAttributeOptionInput = {
  /** Id of the object to update */
  attributeOptionId: Scalars["ID"];
  /** The merchandising hierarchy node IDs that will filter this attribute option */
  filterMerchandisingHierarchyNodeIds: Array<Scalars["ID"]>;
};

export type SetMerchandisingHierarchyFilterForAttributeOptionPayload = {
  __typename?: "SetMerchandisingHierarchyFilterForAttributeOptionPayload";
  attributeOption?: Maybe<AttributeOption>;
  errors?: Maybe<Array<Error>>;
};

/** Update details of a price modifier */
export type SetPriceModifierValueInput = {
  /** Id of assortment */
  assortmentId: Scalars["ID"];
  /** Factor to apply */
  factor?: InputMaybe<Scalars["Decimal"]>;
  /** Id of price_modifier_field */
  groupId: Scalars["ID"];
  /** Id of the object to update */
  priceModifierId?: InputMaybe<Scalars["ID"]>;
};

export type SetPriceModifierValuePayload = {
  __typename?: "SetPriceModifierValuePayload";
  /** The assortment whose price modifiers were updated */
  assortment: Assortment;
  deletePriceModifierId?: Maybe<Scalars["ID"]>;
  priceModifier?: Maybe<PriceModifier>;
};

export type SetProductSizeRunResponse = {
  __typename?: "SetProductSizeRunResponse";
  assortment?: Maybe<Assortment>;
  /** Generic top level query field to query updated skus */
  query?: Maybe<Query>;
  sizeRun?: Maybe<SizeRun>;
};

export type SetProductTraitValueInput = {
  externalIdentifier?: InputMaybe<Scalars["String"]>;
  productId: Scalars["ID"];
  traitId: Scalars["String"];
  value: Scalars["String"];
};

/** Overwrite the brand filters for an attribute option */
export type SetRetailerBrandFilterForAttributeOptionInput = {
  /** Id of the object to update */
  attributeOptionId: Scalars["ID"];
  /** The brand IDs that will filter this attribute option */
  filterRetailerBrandIds: Array<Scalars["ID"]>;
};

export type SetRetailerBrandFilterForAttributeOptionPayload = {
  __typename?: "SetRetailerBrandFilterForAttributeOptionPayload";
  attributeOption?: Maybe<AttributeOption>;
  errors?: Maybe<Array<Error>>;
};

export type SetRetailerProductSizesOnAssortmentInput = {
  productId: Scalars["ID"];
  sizes: Array<CustomSizeRequest>;
};

export type SetRetailerProductSizesOnAssortmentPayload = {
  __typename?: "SetRetailerProductSizesOnAssortmentPayload";
  assortment?: Maybe<Assortment>;
};

export type SetSelectedAccountInput = {
  account_id: Scalars["String"];
};

export type SetSelectedAccountPayload = {
  __typename?: "SetSelectedAccountPayload";
  error?: Maybe<Scalars["String"]>;
  success: Scalars["Boolean"];
};

export type SetSelectedAssortmentAttributeOptionsInput = {
  assortmentId: Scalars["ID"];
  attributeOptionIds: Array<Scalars["ID"]>;
};

export type SetSelectedAssortmentAttributeOptionsPayload = {
  __typename?: "SetSelectedAssortmentAttributeOptionsPayload";
  assortment?: Maybe<Assortment>;
  errors?: Maybe<Array<Error>>;
  query?: Maybe<Query>;
};

export type SetSkuItemPropertyInput = {
  id: Scalars["ID"];
  propertyName: Scalars["String"];
  propertyValue: Scalars["String"];
};

export type SetSkuItemPropertyPayload = {
  __typename?: "SetSkuItemPropertyPayload";
  assortment?: Maybe<Assortment>;
  id: Scalars["ID"];
  propertyName: Scalars["String"];
  propertyValue: Scalars["String"];
  /** Generic top level query field to query updated skus */
  query?: Maybe<Query>;
};

export type SetSkuRetailSizeResponse = {
  __typename?: "SetSkuRetailSizeResponse";
  assortment?: Maybe<Assortment>;
  /** Generic top level query field to query updated skus */
  query?: Maybe<Query>;
  retailSize?: Maybe<RetailSize>;
};

export type SetSkuUpcInput = {
  skuId: Scalars["ID"];
  upc: Scalars["String"];
};

export type SetUserPasswordInput = {
  email: Scalars["String"];
  password: Scalars["String"];
};

export type SetUserPasswordPayload = {
  __typename?: "SetUserPasswordPayload";
  errors?: Maybe<Array<Scalars["String"]>>;
  success: Scalars["Boolean"];
};

export type ShareAndSendLinesheetsWithCollaborationInvitesEmailsInput = {
  collaborationInviteRequests: Array<CreateCollaborationInviteInput>;
  collectionIds: Array<Scalars["ID"]>;
  messageAttachmentId?: InputMaybe<Scalars["ID"]>;
  messageBody: Scalars["String"];
  messageSubject: Scalars["String"];
  notify?: InputMaybe<Scalars["Boolean"]>;
  priceTypeId: Scalars["ID"];
  tokenActiveDays?: InputMaybe<Scalars["Int"]>;
};

export type ShareAndSendLinesheetsWithCollaborationInvitesEmailsPayload = {
  __typename?: "ShareAndSendLinesheetsWithCollaborationInvitesEmailsPayload";
  errors?: Maybe<Array<Error>>;
};

export type ShareAndSendStyleboardsWithCollaborationInvitesEmailsInput = {
  collaborationInviteRequests: Array<CreateCollaborationInviteInput>;
  message: Scalars["String"];
  sendCopyToSender: Scalars["Boolean"];
  styleboardIds: Array<Scalars["ID"]>;
};

export type ShareAndSendStyleboardsWithCollaborationInvitesEmailsPayload = {
  __typename?: "ShareAndSendStyleboardsWithCollaborationInvitesEmailsPayload";
  errors?: Maybe<Array<Error>>;
};

export type ShareBrand = {
  __typename?: "ShareBrand";
  id: Scalars["ID"];
  name: Scalars["String"];
};

export type ShareCollection = {
  __typename?: "ShareCollection";
  delivery: PublicDelivery;
  description: Scalars["String"];
  id: Scalars["ID"];
  name: Scalars["String"];
};

export type ShareCollectionsWithRetailersInput = {
  collectionIds: Array<Scalars["ID"]>;
  retailerIds: Array<Scalars["ID"]>;
};

export type ShareCollectionsWithRetailersPayload = {
  __typename?: "ShareCollectionsWithRetailersPayload";
  collections: CollectionConnection;
};

export type ShareParamsCollection = {
  __typename?: "ShareParamsCollection";
  banners?: Maybe<Banners>;
  code?: Maybe<Scalars["String"]>;
  delivery?: Maybe<Delivery>;
  description?: Maybe<Scalars["String"]>;
  id: Scalars["ID"];
  madeToOrder: Scalars["Boolean"];
  name: Scalars["String"];
  season?: Maybe<Season>;
  textStyles?: Maybe<Array<CollectionTextStyle>>;
};

export type ShareShowroomCollectionInput = {
  extraEmailRecipients?: InputMaybe<Array<Scalars["String"]>>;
  message?: InputMaybe<Scalars["String"]>;
  retailerRecipients: Array<RetailerRecipient>;
  sendCopy: Scalars["Boolean"];
  sendTokenizedLink?: InputMaybe<Scalars["Boolean"]>;
  showroomCollectionId: Scalars["ID"];
  teamRecipientIds: Array<Scalars["ID"]>;
  tokenActiveDays?: InputMaybe<Scalars["Int"]>;
};

export type ShareShowroomCollectionWithTeamMembersInput = {
  message?: InputMaybe<Scalars["String"]>;
  sendCopyToSender: Scalars["Boolean"];
  showroomCollectionId: Scalars["ID"];
  teamRecipientIds: Array<Scalars["ID"]>;
};

export type ShareStyleboardInput = {
  externalRecipients: Array<ExternalRecipient>;
  styleboardId: Scalars["ID"];
  teamRecipientIds: Array<Scalars["ID"]>;
};

export type SharedCollection = {
  __typename?: "SharedCollection";
  brandId: Scalars["ID"];
  brandImage?: Maybe<Media>;
  brandName: Scalars["String"];
  collectionType: Scalars["String"];
  id: Scalars["ID"];
  name: Scalars["String"];
  /** @deprecated Use sharedOnDate instead */
  sharedOn: Scalars["Date"];
  sharedOnDate: Scalars["Date"];
};

export type SharedCollectionParams = {
  __typename?: "SharedCollectionParams";
  brand: ShareBrand;
  collection: ShareParamsCollection;
  hasAccess: Scalars["Boolean"];
  id: Scalars["ID"];
  priceType: PublicPriceType;
};

export type SharedCollectionProduct = Node & {
  __typename?: "SharedCollectionProduct";
  collection: ShareCollection;
  comments: Scalars["String"];
  id: Scalars["ID"];
  product: SharedProduct;
  variants: Array<SharedVariants>;
};

export type SharedCollectionProductConnection = {
  __typename?: "SharedCollectionProductConnection";
  edges: Array<SharedCollectionProductEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars["Int"];
};

export type SharedCollectionProductEdge = {
  __typename?: "SharedCollectionProductEdge";
  cursor: Scalars["String"];
  node: SharedCollectionProduct;
};

export type SharedProduct = {
  __typename?: "SharedProduct";
  badges: Array<Badge>;
  externalMedia: Array<ExternalMedia>;
  id: Scalars["ID"];
  imageUrls: Array<Scalars["String"]>;
  name: Scalars["String"];
  priceRange?: Maybe<PriceRange>;
  traitValues: Array<SharedProductTraitValue>;
};

export type SharedProductTraitValue = {
  __typename?: "SharedProductTraitValue";
  /** @deprecated use externalIdentifier instead */
  customerCode?: Maybe<Scalars["String"]>;
  externalIdentifier: Scalars["String"];
  id: Scalars["ID"];
  trait: SharedTrait;
  value: Scalars["String"];
};

export type SharedTrait = {
  __typename?: "SharedTrait";
  code: Scalars["String"];
  id: Scalars["ID"];
  name: Scalars["String"];
};

export type SharedValues = {
  __typename?: "SharedValues";
  /** @deprecated use externalIdentifier instead */
  customerCode: Scalars["String"];
  displayDetails: TraitValueDisplayDetails;
  externalIdentifier: Scalars["String"];
  id: Scalars["ID"];
  trait: SharedTrait;
  value: Scalars["String"];
};

export type SharedVariants = {
  __typename?: "SharedVariants";
  code: Scalars["String"];
  id: Scalars["ID"];
  name: Scalars["String"];
  values: Array<SharedValues>;
};

export type Shipment = {
  __typename?: "Shipment";
  brand: Brand;
  confirmedUnits: Scalars["Int"];
  expectedDeliveryDate: Scalars["Date"];
  externalId: Scalars["String"];
  id: Scalars["ID"];
  openUnits: Scalars["Int"];
  requestedDeliveryDate: Scalars["Date"];
  requestedUnits: Scalars["Int"];
  retailer: Retailer;
  shippedUnits: Scalars["Int"];
  shippingDeliveryDate?: Maybe<Scalars["Date"]>;
  status: ShipmentStatus;
};

export type ShipmentConnection = {
  __typename?: "ShipmentConnection";
  edges: Array<ShipmentEdge>;
};

export type ShipmentEdge = {
  __typename?: "ShipmentEdge";
  node: Shipment;
};

export enum ShipmentStatus {
  Approved = "APPROVED",
  Cancelled = "CANCELLED",
  Confirmed = "CONFIRMED",
  Invoiced = "INVOICED",
  InPreparation = "IN_PREPARATION",
  NotConfirmed = "NOT_CONFIRMED",
  PartiallyInvoiced = "PARTIALLY_INVOICED",
  Shipped = "SHIPPED",
  Unknown = "UNKNOWN",
}

export type ShippingAddress = {
  __typename?: "ShippingAddress";
  address?: Maybe<HyperionAddress>;
  code?: Maybe<Scalars["String"]>;
  email?: Maybe<Scalars["String"]>;
  id: Scalars["ID"];
  phoneNumber?: Maybe<Scalars["String"]>;
};

export type ShippingAddressPayload = {
  __typename?: "ShippingAddressPayload";
  city?: Maybe<Scalars["String"]>;
  code?: Maybe<Scalars["String"]>;
  company?: Maybe<Scalars["String"]>;
  country?: Maybe<Scalars["String"]>;
  email?: Maybe<Scalars["String"]>;
  fax?: Maybe<Scalars["String"]>;
  id: Scalars["ID"];
  line1?: Maybe<Scalars["String"]>;
  line2?: Maybe<Scalars["String"]>;
  name?: Maybe<Scalars["String"]>;
  phone?: Maybe<Scalars["String"]>;
  price?: Maybe<Scalars["String"]>;
  state?: Maybe<Scalars["String"]>;
  zip?: Maybe<Scalars["String"]>;
};

export type ShippingInfo = {
  address?: InputMaybe<AddressInput>;
  code?: InputMaybe<Scalars["String"]>;
  email?: InputMaybe<Scalars["String"]>;
  phoneNumber?: InputMaybe<Scalars["String"]>;
  shippingAccount?: InputMaybe<Scalars["String"]>;
  shippingAddressId?: InputMaybe<Scalars["ID"]>;
  shippingMethodId?: InputMaybe<Scalars["ID"]>;
  shippingPrice?: InputMaybe<Scalars["Float"]>;
  trackingNumber?: InputMaybe<Scalars["String"]>;
};

export type ShippingMethod = Node & {
  __typename?: "ShippingMethod";
  code: Scalars["String"];
  id: Scalars["ID"];
  name: Scalars["String"];
};

export type ShippingMethodConnection = {
  __typename?: "ShippingMethodConnection";
  edges: Array<ShippingMethodEdge>;
};

export type ShippingMethodEdge = {
  __typename?: "ShippingMethodEdge";
  node: ShippingMethod;
};

export type ShowroomCollection = Node & {
  __typename?: "ShowroomCollection";
  brand: Brand;
  created: Scalars["Date"];
  id: Scalars["ID"];
  lastModified: Scalars["Date"];
  looks: LookConnection;
  name: Scalars["String"];
  owner: ShowroomCollectionOwner;
  showroomCollectionShares: ShowroomCollectionShare;
  status: ShowroomCollectionStatus;
  url3dShowroom?: Maybe<Url3dShowroom>;
  visibleToAllConnected: Scalars["Boolean"];
};

export type ShowroomCollectionConnection = {
  __typename?: "ShowroomCollectionConnection";
  edges: Array<ShowroomCollectionEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars["Int"];
};

export type ShowroomCollectionEdge = {
  __typename?: "ShowroomCollectionEdge";
  cursor: Scalars["String"];
  node: ShowroomCollection;
};

export type ShowroomCollectionFilterList = {
  __typename?: "ShowroomCollectionFilterList";
  brands: Array<FilterItem>;
  ownerUsers: Array<FilterItem>;
  sharedAccounts: Array<FilterItem>;
  sharedUsers: Array<FilterItem>;
  showroomCollections: Array<FilterItem>;
};

export enum ShowroomCollectionOrder {
  Ascending = "ASCENDING",
  Descending = "DESCENDING",
}

export type ShowroomCollectionOrderBy = {
  field?: InputMaybe<ShowroomCollectionOrderByField>;
  order?: InputMaybe<ShowroomCollectionOrder>;
};

export enum ShowroomCollectionOrderByField {
  Brand = "BRAND",
  CreatedDate = "CREATED_DATE",
  CreatorName = "CREATOR_NAME",
  ModifiedDate = "MODIFIED_DATE",
  SharedDate = "SHARED_DATE",
  ShowroomCollectionName = "SHOWROOM_COLLECTION_NAME",
}

export type ShowroomCollectionOwner = {
  __typename?: "ShowroomCollectionOwner";
  displayName: Scalars["String"];
  userEmail: Scalars["String"];
  userId: Scalars["ID"];
};

export type ShowroomCollectionShare = {
  __typename?: "ShowroomCollectionShare";
  retailerRecipients: Array<ShowroomCollectionShareRetailerRecipient>;
  showroomCollectionId: Scalars["ID"];
  teamRecipients: Array<ShowroomCollectionShareTeamRecipient>;
};

export type ShowroomCollectionShareRetailerRecipient = {
  __typename?: "ShowroomCollectionShareRetailerRecipient";
  email: Scalars["String"];
  retailer: Retailer;
  shareDate?: Maybe<Scalars["Date"]>;
};

export type ShowroomCollectionShareTeamRecipient = {
  __typename?: "ShowroomCollectionShareTeamRecipient";
  brand: Brand;
  shareDate?: Maybe<Scalars["Date"]>;
  user: User;
};

export enum ShowroomCollectionStatus {
  Active = "ACTIVE",
  Archived = "ARCHIVED",
}

export type ShowroomCollectionTokenizedLink = {
  __typename?: "ShowroomCollectionTokenizedLink";
  showroomCollectionId: Scalars["ID"];
  tokenizedLink: Scalars["String"];
};

export type ShowroomCollectionsFilter = {
  brandIds?: InputMaybe<Array<Scalars["ID"]>>;
  createdDate?: InputMaybe<DateRange>;
  modifiedDate?: InputMaybe<DateRange>;
  ownerUserIds?: InputMaybe<Array<Scalars["ID"]>>;
  sharedAccountIds?: InputMaybe<Array<Scalars["ID"]>>;
  sharedUserIds?: InputMaybe<Array<Scalars["ID"]>>;
  showroomCollectionIds?: InputMaybe<Array<Scalars["ID"]>>;
  status?: InputMaybe<ShowroomCollectionStatus>;
};

export type Silhouette = {
  __typename?: "Silhouette";
  name: Scalars["String"];
};

/** Rule which is evaluated based on a conditional relationship between a fetched and a given value */
export type SimpleRule = {
  __typename?: "SimpleRule";
  /** Field on which the rule will act */
  field: Scalars["String"];
  /** Relation between the field and value which will be evaluated */
  relation: RuleRelation;
  /** Value of to compare the field to */
  value: Scalars["ID"];
};

export type Size = Node & {
  __typename?: "Size";
  /** A unique identifier */
  code: Scalars["String"];
  id: Scalars["ID"];
  /** A display name */
  name: Scalars["String"];
};

export type SizeCurveRatio = {
  __typename?: "SizeCurveRatio";
  ratio: Scalars["Decimal"];
  retailSize: RetailSize;
};

export type SizeRun = Node & {
  __typename?: "SizeRun";
  code?: Maybe<Scalars["String"]>;
  id: Scalars["ID"];
  name?: Maybe<Scalars["String"]>;
};

export type SizeRunEdge = {
  __typename?: "SizeRunEdge";
  node?: Maybe<SizeRun>;
};

export type SizeRunFilters = {
  /** Filter by a list of selected attribute options */
  attributeOptionIds?: InputMaybe<Array<Scalars["ID"]>>;
  /** Filter by brand account */
  brandId?: InputMaybe<Scalars["ID"]>;
  /** Filter by applied merchandising hierarchy */
  merchandisingHierarchyId?: InputMaybe<Scalars["ID"]>;
};

export type SkuComment = {
  comment: Scalars["String"];
  skuId: Scalars["ID"];
};

export type SkuDelivery = {
  __typename?: "SkuDelivery";
  collection: Collection;
  completeShipDate?: Maybe<Scalars["Date"]>;
  id: Scalars["ID"];
  product: Product;
  sku: Sku;
  startShipDate?: Maybe<Scalars["Date"]>;
};

export type SkuDeliveryConnection = {
  __typename?: "SkuDeliveryConnection";
  edges: Array<SkuDeliveryEdge>;
};

export type SkuDeliveryEdge = {
  __typename?: "SkuDeliveryEdge";
  node: SkuDelivery;
};

export type SkuDeliveryFilter = {
  onlyActive?: InputMaybe<Scalars["Boolean"]>;
  productIds?: InputMaybe<Array<Scalars["ID"]>>;
};

export type SkuDeliveryInput = {
  completeShipDate?: InputMaybe<Scalars["Date"]>;
  id: Scalars["ID"];
  startShipDate?: InputMaybe<Scalars["Date"]>;
};

export type SkuDoorPrice = {
  __typename?: "SkuDoorPrice";
  door: BrandDoor;
  orderType?: Maybe<OrderType>;
  priceType: PriceType;
  retailValue: Scalars["Float"];
  skuId: Scalars["ID"];
  totalDiscount: Scalars["Float"];
  wholesaleAdjustedValue: Scalars["Float"];
  wholesaleFinalValue: Scalars["Float"];
  wholesaleValue: Scalars["Float"];
};

export type SkuDoorPriceConnection = {
  __typename?: "SkuDoorPriceConnection";
  edges?: Maybe<Array<SkuDoorPriceEdge>>;
};

export type SkuDoorPriceEdge = {
  __typename?: "SkuDoorPriceEdge";
  node?: Maybe<SkuDoorPrice>;
};

export type SkuExternalIdentifier = {
  __typename?: "SkuExternalIdentifier";
  externalId?: Maybe<Scalars["String"]>;
  skuId: Scalars["ID"];
  skuIdentifier?: Maybe<Scalars["String"]>;
};

export type SkuExternalIdentifierInput = {
  externalId?: InputMaybe<Scalars["String"]>;
  skuId: Scalars["ID"];
  skuIdentifier?: InputMaybe<Scalars["String"]>;
};

export type SkuIdWithDelivery = {
  __typename?: "SkuIdWithDelivery";
  completeShipDate?: Maybe<Scalars["Date"]>;
  id: Scalars["ID"];
  startShipDate?: Maybe<Scalars["Date"]>;
};

export type SkuLineItem = {
  __typename?: "SkuLineItem";
  collection: LineItemCollection;
  inventory?: Maybe<InventoryAvailabilityGroup>;
  orderId: Scalars["ID"];
  productId: Scalars["ID"];
  quantity: Scalars["Int"];
  sku: Sku;
  suggestedRetailPrice: Scalars["Decimal"];
  wholesalePrice: Scalars["Decimal"];
};

export type SkuLineItemToImport = {
  __typename?: "SkuLineItemToImport";
  colorCode?: Maybe<Scalars["String"]>;
  colorId?: Maybe<Scalars["ID"]>;
  colorName?: Maybe<Scalars["String"]>;
  doorCode?: Maybe<Scalars["String"]>;
  doorId?: Maybe<Scalars["ID"]>;
  doorName?: Maybe<Scalars["String"]>;
  multiplier?: Maybe<Scalars["Int"]>;
  orderIdentifier?: Maybe<Scalars["String"]>;
  payload?: Maybe<Scalars["JSON"]>;
  productId?: Maybe<Scalars["ID"]>;
  productIdentifier?: Maybe<Scalars["String"]>;
  productNumber?: Maybe<Scalars["String"]>;
  quantity?: Maybe<Scalars["Int"]>;
  sizeId?: Maybe<Scalars["ID"]>;
  sizeName?: Maybe<Scalars["String"]>;
  wholesalePrice?: Maybe<Scalars["String"]>;
};

export type SkuPrice = Node & {
  __typename?: "SkuPrice";
  id: Scalars["ID"];
  priceType: PriceType;
  skuId: Scalars["ID"];
  suggestedRetailPrice?: Maybe<Scalars["Decimal"]>;
  wholesalePrice: Scalars["Decimal"];
};

export type SkuQuantity = {
  /** NOTE: This is field is not yet implemented */
  discountFactor?: InputMaybe<Scalars["Float"]>;
  doorId?: InputMaybe<Scalars["ID"]>;
  quantity?: InputMaybe<Scalars["Int"]>;
  skuId: Scalars["ID"];
};

export type SkuTrait = Trait & {
  __typename?: "SkuTrait";
  code: Scalars["String"];
  id: Scalars["ID"];
  name: Scalars["String"];
};

export type SkuTraitConnection = {
  __typename?: "SkuTraitConnection";
  edges?: Maybe<Array<SkuTraitEdge>>;
};

export type SkuTraitEdge = {
  __typename?: "SkuTraitEdge";
  node?: Maybe<SkuTrait>;
};

export type SkuTraitValue = TraitValue & {
  __typename?: "SkuTraitValue";
  description?: Maybe<Scalars["String"]>;
  displayDetails?: Maybe<TraitValueDisplayDetails>;
  externalIdentifier?: Maybe<Scalars["String"]>;
  id: Scalars["ID"];
  orderMinimum?: Maybe<Scalars["Int"]>;
  orderNbr?: Maybe<Scalars["Int"]>;
  productId?: Maybe<Scalars["ID"]>;
  status?: Maybe<SkuTraitValueStatus>;
  trait: SkuTrait;
  value: Scalars["String"];
};

export type SkuTraitValueConnection = {
  __typename?: "SkuTraitValueConnection";
  edges?: Maybe<Array<SkuTraitValueEdge>>;
};

export type SkuTraitValueEdge = {
  __typename?: "SkuTraitValueEdge";
  node?: Maybe<SkuTraitValue>;
};

export enum SkuTraitValueStatus {
  Active = "ACTIVE",
  Inactive = "INACTIVE",
  Unknown = "UNKNOWN",
}

export type SocialMediaAccount = {
  __typename?: "SocialMediaAccount";
  socialMediaType?: Maybe<SocialMediaType>;
  url?: Maybe<Scalars["String"]>;
};

export type SocialMediaAccountInput = {
  type: SocialMediaType;
  url: Scalars["String"];
};

export enum SocialMediaType {
  Facebook = "FACEBOOK",
  Instagram = "INSTAGRAM",
  Twitter = "TWITTER",
  Unknown = "UNKNOWN",
}

export enum Source {
  /** Designates that the source of this object is from a brand */
  Brand = "BRAND",
  /** Designates that the source of this object is from a retailer */
  Retailer = "RETAILER",
  /** Designates that the sku has not a proper style_size_id match in the db */
  UnmatchedSize = "UNMATCHED_SIZE",
}

export enum Status {
  Connected = "CONNECTED",
  None = "NONE",
  Pending = "PENDING",
  Sent = "SENT",
}

export type Storefront = Node & {
  __typename?: "Storefront";
  brandId: Scalars["ID"];
  displayName: Scalars["String"];
  id: Scalars["ID"];
  isHome: Scalars["Boolean"];
  isOnline: Scalars["Boolean"];
  modified: Scalars["Date"];
  orderNbr: Scalars["Int"];
  projectId: Scalars["ID"];
  rows: StorefrontRowConnection;
  statusSince: Scalars["Date"];
  textStyles?: Maybe<Array<TextStyle>>;
  uniqueName: Scalars["String"];
};

export type StorefrontAboutElement = StorefrontElement & {
  __typename?: "StorefrontAboutElement";
  elementType: ElementType;
  id: Scalars["ID"];
  orderNbr: Scalars["Int"];
  presentation?: Maybe<Scalars["String"]>;
  settings: Scalars["String"];
};

export type StorefrontAboutElementInput = {
  id?: InputMaybe<Scalars["ID"]>;
  orderNbr: Scalars["Int"];
  presentation?: InputMaybe<Scalars["String"]>;
  settings: Scalars["String"];
};

export type StorefrontCollectionElement = StorefrontElement & {
  __typename?: "StorefrontCollectionElement";
  collectionId: Scalars["ID"];
  collectionTitle: Scalars["String"];
  coverId?: Maybe<Scalars["ID"]>;
  coverUrl?: Maybe<Scalars["String"]>;
  elementType: ElementType;
  id: Scalars["ID"];
  orderNbr: Scalars["Int"];
  presentation?: Maybe<Scalars["String"]>;
};

export type StorefrontCollectionElementInput = {
  collectionId: Scalars["ID"];
  collectionTitle: Scalars["String"];
  coverId?: InputMaybe<Scalars["ID"]>;
  id?: InputMaybe<Scalars["ID"]>;
  orderNbr: Scalars["Int"];
  presentation?: InputMaybe<Scalars["String"]>;
};

export type StorefrontElement = {
  elementType: ElementType;
  id: Scalars["ID"];
  orderNbr: Scalars["Int"];
  presentation?: Maybe<Scalars["String"]>;
};

export type StorefrontFilters = {
  ids?: InputMaybe<Array<Scalars["ID"]>>;
  inMenu?: InputMaybe<Scalars["Boolean"]>;
  isHome?: InputMaybe<Scalars["Boolean"]>;
  isOnline?: InputMaybe<Scalars["Boolean"]>;
  uniqueName?: InputMaybe<Scalars["String"]>;
};

export type StorefrontImageElement = StorefrontElement & {
  __typename?: "StorefrontImageElement";
  elementType: ElementType;
  id: Scalars["ID"];
  imageExternalLink?: Maybe<Scalars["String"]>;
  imageId: Scalars["ID"];
  imageUrl: Scalars["String"];
  orderNbr: Scalars["Int"];
  presentation?: Maybe<Scalars["String"]>;
};

export type StorefrontImageElementInput = {
  id?: InputMaybe<Scalars["ID"]>;
  imageExternalLink?: InputMaybe<Scalars["String"]>;
  imageId: Scalars["ID"];
  orderNbr: Scalars["Int"];
  presentation?: InputMaybe<Scalars["String"]>;
};

export type StorefrontInstagramElement = StorefrontElement & {
  __typename?: "StorefrontInstagramElement";
  elementType: ElementType;
  id: Scalars["ID"];
  imageUrls: Array<Maybe<Scalars["String"]>>;
  instagramAuthId: Scalars["ID"];
  orderNbr: Scalars["Int"];
  presentation?: Maybe<Scalars["String"]>;
};

export type StorefrontInstagramElementInput = {
  id?: InputMaybe<Scalars["ID"]>;
  instagramAuthId: Scalars["ID"];
  orderNbr: Scalars["Int"];
  presentation?: InputMaybe<Scalars["String"]>;
};

export type StorefrontLookbookElement = StorefrontElement & {
  __typename?: "StorefrontLookbookElement";
  coverId?: Maybe<Scalars["ID"]>;
  coverUrl?: Maybe<Scalars["String"]>;
  elementType: ElementType;
  id: Scalars["ID"];
  lookbookId: Scalars["ID"];
  lookbookTitle: Scalars["String"];
  lookbookUrl: Scalars["String"];
  orderNbr: Scalars["Int"];
  presentation?: Maybe<Scalars["String"]>;
};

export type StorefrontLookbookElementInput = {
  coverId?: InputMaybe<Scalars["ID"]>;
  id?: InputMaybe<Scalars["ID"]>;
  lookbookId: Scalars["ID"];
  lookbookTitle: Scalars["String"];
  orderNbr: Scalars["Int"];
  presentation?: InputMaybe<Scalars["String"]>;
};

export type StorefrontOrb360Element = StorefrontElement & {
  __typename?: "StorefrontOrb360Element";
  elementType: ElementType;
  externalVideoId?: Maybe<Scalars["String"]>;
  externalVideoLink?: Maybe<Scalars["String"]>;
  externalVideoPayload?: Maybe<Scalars["String"]>;
  id: Scalars["ID"];
  orderNbr: Scalars["Int"];
  presentation?: Maybe<Scalars["String"]>;
};

export type StorefrontOrb360ElementInput = {
  externalVideoId: Scalars["String"];
  id?: InputMaybe<Scalars["ID"]>;
  orderNbr: Scalars["Int"];
  presentation?: InputMaybe<Scalars["String"]>;
};

export type StorefrontProductElement = StorefrontElement & {
  __typename?: "StorefrontProductElement";
  collectionId: Scalars["ID"];
  elementType: ElementType;
  id: Scalars["ID"];
  orderNbr: Scalars["Int"];
  presentation?: Maybe<Scalars["String"]>;
  productId: Scalars["ID"];
};

export type StorefrontProductElementInput = {
  collectionId: Scalars["ID"];
  id?: InputMaybe<Scalars["ID"]>;
  orderNbr: Scalars["Int"];
  presentation?: InputMaybe<Scalars["String"]>;
  productId: Scalars["ID"];
};

export type StorefrontRow = Node & {
  __typename?: "StorefrontRow";
  elements: Array<StorefrontElement>;
  id: Scalars["ID"];
  orderNbr: Scalars["Int"];
  template: Scalars["String"];
  title?: Maybe<Scalars["String"]>;
};

export type StorefrontRowConnection = {
  __typename?: "StorefrontRowConnection";
  edges?: Maybe<Array<StorefrontRowEdge>>;
};

export type StorefrontRowEdge = {
  __typename?: "StorefrontRowEdge";
  cursor: Scalars["String"];
  node?: Maybe<StorefrontRow>;
};

export type StorefrontRowInput = {
  aboutElements?: InputMaybe<Array<StorefrontAboutElementInput>>;
  collectionElements?: InputMaybe<Array<StorefrontCollectionElementInput>>;
  id?: InputMaybe<Scalars["ID"]>;
  imageElements?: InputMaybe<Array<StorefrontImageElementInput>>;
  instagramElements?: InputMaybe<Array<StorefrontInstagramElementInput>>;
  lookbookElements?: InputMaybe<Array<StorefrontLookbookElementInput>>;
  orb360Elements?: InputMaybe<Array<StorefrontOrb360ElementInput>>;
  orderNbr: Scalars["Int"];
  productElements?: InputMaybe<Array<StorefrontProductElementInput>>;
  showroomBrandElements?: InputMaybe<
    Array<StorefrontShowroomBrandElementInput>
  >;
  showroomCollectionElements?: InputMaybe<
    Array<StorefrontShowroomCollectionElementInput>
  >;
  template: Scalars["String"];
  textElements?: InputMaybe<Array<StorefrontTextElementInput>>;
  title?: InputMaybe<Scalars["String"]>;
  videoElements?: InputMaybe<Array<StorefrontVideoElementInput>>;
};

export type StorefrontShowroomBrandElement = StorefrontElement & {
  __typename?: "StorefrontShowroomBrandElement";
  elementType: ElementType;
  id: Scalars["ID"];
  orderNbr: Scalars["Int"];
  presentation?: Maybe<Scalars["String"]>;
  showroomBrandId: Scalars["ID"];
};

export type StorefrontShowroomBrandElementInput = {
  id?: InputMaybe<Scalars["ID"]>;
  orderNbr: Scalars["Int"];
  presentation?: InputMaybe<Scalars["String"]>;
  showroomBrandId: Scalars["ID"];
};

export type StorefrontShowroomCollectionElement = StorefrontElement & {
  __typename?: "StorefrontShowroomCollectionElement";
  coverId?: Maybe<Scalars["ID"]>;
  coverUrl?: Maybe<Scalars["String"]>;
  elementType: ElementType;
  id: Scalars["ID"];
  orderNbr: Scalars["Int"];
  presentation?: Maybe<Scalars["String"]>;
  showroomCollectionId: Scalars["ID"];
  showroomCollectionTitle: Scalars["String"];
};

export type StorefrontShowroomCollectionElementInput = {
  coverId?: InputMaybe<Scalars["ID"]>;
  id?: InputMaybe<Scalars["ID"]>;
  orderNbr: Scalars["Int"];
  presentation?: InputMaybe<Scalars["String"]>;
  showroomCollectionId: Scalars["ID"];
  showroomCollectionTitle: Scalars["String"];
};

export type StorefrontTextElement = StorefrontElement & {
  __typename?: "StorefrontTextElement";
  content: Scalars["String"];
  elementType: ElementType;
  id: Scalars["ID"];
  orderNbr: Scalars["Int"];
  presentation?: Maybe<Scalars["String"]>;
};

export type StorefrontTextElementInput = {
  content: Scalars["String"];
  id?: InputMaybe<Scalars["ID"]>;
  orderNbr: Scalars["Int"];
  presentation?: InputMaybe<Scalars["String"]>;
};

export type StorefrontVideoElement = StorefrontElement & {
  __typename?: "StorefrontVideoElement";
  elementType: ElementType;
  id: Scalars["ID"];
  orderNbr: Scalars["Int"];
  presentation?: Maybe<Scalars["String"]>;
  videoId?: Maybe<Scalars["ID"]>;
  videoUrl?: Maybe<Scalars["String"]>;
};

export type StorefrontVideoElementInput = {
  id?: InputMaybe<Scalars["ID"]>;
  orderNbr: Scalars["Int"];
  presentation?: InputMaybe<Scalars["String"]>;
  videoId?: InputMaybe<Scalars["ID"]>;
  videoUrl?: InputMaybe<Scalars["String"]>;
};

export type Style = Node & {
  __typename?: "Style";
  /** A unique identifier */
  code?: Maybe<Scalars["String"]>;
  /** A description of the style */
  description?: Maybe<Scalars["String"]>;
  /** Details of this style */
  details: StyleDetails;
  id: Scalars["ID"];
  /** Images related to this style */
  images: ImageConnection;
  /** A display name */
  name?: Maybe<Scalars["String"]>;
  /** Sizes available */
  sizes_available?: Maybe<Scalars["String"]>;
};

export type StyleDetails = {
  __typename?: "StyleDetails";
  categories: Array<Category>;
  countryOfOrigin?: Maybe<Scalars["String"]>;
  fabrication?: Maybe<Fabrication>;
  furStatus?: Maybe<FurStatus>;
  heelHeight?: Maybe<Scalars["String"]>;
  materials?: Maybe<Array<Maybe<Material>>>;
  measurements?: Maybe<Scalars["String"]>;
  modelHeightInches?: Maybe<Scalars["Int"]>;
  silhouette?: Maybe<Silhouette>;
  sourceOfMaterials?: Maybe<Scalars["String"]>;
};

export type StylePrice = Node & {
  __typename?: "StylePrice";
  id: Scalars["ID"];
  priceType: PriceType;
  styleId: Scalars["ID"];
  suggestedRetailPrice?: Maybe<Scalars["Decimal"]>;
  wholesalePrice: Scalars["Decimal"];
};

export type Styleboard = Node & {
  __typename?: "Styleboard";
  brand: Brand;
  comments: StyleboardCommentConnection;
  created: Scalars["Date"];
  id: Scalars["ID"];
  items: Array<StyleboardItem>;
  lastModified: Scalars["String"];
  layout: Scalars["String"];
  name: Scalars["String"];
  owner: StyleboardOwner;
  status: StyleboardStatus;
  styleboardShares?: Maybe<StyleboardShare>;
  textContents: Array<StyleboardTextContent>;
};

export type StyleboardCommentsArgs = {
  filter?: InputMaybe<StyleboardCommentsFilter>;
};

export type StyleboardComment = Node & {
  __typename?: "StyleboardComment";
  created: Scalars["DateTime"];
  id: Scalars["ID"];
  message: Scalars["String"];
  owner: StyleboardCommentOwner;
  taggedAccountUsers: CommentAccountUserTagConnection;
};

export type StyleboardCommentConnection = {
  __typename?: "StyleboardCommentConnection";
  edges: Array<StyleboardCommentEdge>;
  pageInfo: PageInfo;
};

export type StyleboardCommentEdge = {
  __typename?: "StyleboardCommentEdge";
  cursor: Scalars["String"];
  node: StyleboardComment;
};

export type StyleboardCommentOwner = {
  __typename?: "StyleboardCommentOwner";
  accountProfileName: Scalars["String"];
  accountType?: Maybe<AccountType>;
  userDisplayName: Scalars["String"];
  userEmail: Scalars["String"];
  userId: Scalars["ID"];
};

export type StyleboardCommentsFilter = {
  createdStartDateTime?: InputMaybe<Scalars["DateTime"]>;
};

export type StyleboardCommentsQueryFilter = {
  createdStartDateTime?: InputMaybe<Scalars["DateTime"]>;
  styleboardIds?: InputMaybe<Array<Scalars["ID"]>>;
};

export type StyleboardConnection = {
  __typename?: "StyleboardConnection";
  edges?: Maybe<Array<StyleboardEdge>>;
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars["Int"]>;
};

export type StyleboardEdge = {
  __typename?: "StyleboardEdge";
  cursor: Scalars["String"];
  node: Styleboard;
};

export type StyleboardFilterList = {
  __typename?: "StyleboardFilterList";
  brands: Array<FilterItem>;
  ownerUsers: Array<FilterItem>;
  sharedAccounts: Array<FilterItem>;
  sharedUsers: Array<FilterItem>;
  styleboards: Array<FilterItem>;
};

export type StyleboardItem = {
  __typename?: "StyleboardItem";
  collectionProduct: CollectionProduct;
  look?: Maybe<Look>;
  variantId?: Maybe<Scalars["ID"]>;
};

export type StyleboardLastModified = {
  __typename?: "StyleboardLastModified";
  lastModified: Scalars["String"];
};

export enum StyleboardOrder {
  Ascending = "ASCENDING",
  Descending = "DESCENDING",
}

export type StyleboardOrderBy = {
  field?: InputMaybe<StyleboardOrderByField>;
  order?: InputMaybe<StyleboardOrder>;
};

export enum StyleboardOrderByField {
  Brand = "BRAND",
  CreatedDate = "CREATED_DATE",
  CreatorName = "CREATOR_NAME",
  ModifiedDate = "MODIFIED_DATE",
  SharedDate = "SHARED_DATE",
  StyleboardName = "STYLEBOARD_NAME",
}

export type StyleboardOwner = {
  __typename?: "StyleboardOwner";
  displayName: Scalars["String"];
  logo: Scalars["String"];
  userEmail: Scalars["String"];
  userId: Scalars["ID"];
};

export type StyleboardShare = {
  __typename?: "StyleboardShare";
  externalRecipients: Array<StyleboardShareExternalRecipient>;
  styleboardId: Scalars["ID"];
  teamRecipients: Array<StyleboardShareTeamRecipient>;
};

export type StyleboardShareExternalRecipient = {
  __typename?: "StyleboardShareExternalRecipient";
  account: AccountProfile;
  email?: Maybe<Scalars["String"]>;
  shareDate: Scalars["Date"];
};

export type StyleboardShareTeamRecipient = {
  __typename?: "StyleboardShareTeamRecipient";
  shareDate: Scalars["Date"];
  user?: Maybe<User>;
};

export enum StyleboardStatus {
  Active = "ACTIVE",
  Archived = "ARCHIVED",
}

export type StyleboardTextContent = {
  __typename?: "StyleboardTextContent";
  content: Scalars["String"];
  layoutKey: Scalars["String"];
  presentation: Scalars["String"];
};

export type StyleboardsFilter = {
  brandIds?: InputMaybe<Array<Scalars["ID"]>>;
  createdDate?: InputMaybe<DateRange>;
  modifiedDate?: InputMaybe<DateRange>;
  ownerUserIds?: InputMaybe<Array<Scalars["ID"]>>;
  sharedAccountIds?: InputMaybe<Array<Scalars["ID"]>>;
  sharedUserIds?: InputMaybe<Array<Scalars["ID"]>>;
  status?: InputMaybe<StyleboardStatus>;
  styleboardIds?: InputMaybe<Array<Scalars["ID"]>>;
};

export type SubscribeUserToFeatureInput = {
  featureName: Scalars["String"];
  userId: Scalars["ID"];
};

export type SubscribeUserToFeaturePayload = {
  __typename?: "SubscribeUserToFeaturePayload";
  success?: Maybe<Scalars["Boolean"]>;
};

export type Subscription = {
  __typename?: "Subscription";
  _empty?: Maybe<Scalars["String"]>;
};

export type Tag = Node & {
  __typename?: "Tag";
  /** @deprecated Get from TagValue.externalIdentifier */
  code: Scalars["String"];
  groupName: Scalars["String"];
  id: Scalars["ID"];
  name: Scalars["String"];
  /** @deprecated This field wont make sense when TagValues is used */
  parentId: Scalars["ID"];
  /** @deprecated Get from TagValue object */
  value: Scalars["String"];
};

export type TagConnection = {
  __typename?: "TagConnection";
  edges: Array<TagEdge>;
};

export type TagEdge = {
  __typename?: "TagEdge";
  node: Tag;
};

export type TagGroup = {
  __typename?: "TagGroup";
  brandId: Scalars["ID"];
  id: Scalars["ID"];
  name: Scalars["String"];
  tags: BrandTagConnection;
};

export type TagGroupConnection = {
  __typename?: "TagGroupConnection";
  edges: Array<TagGroupEdge>;
};

export type TagGroupEdge = {
  __typename?: "TagGroupEdge";
  node: TagGroup;
};

export type TagInput = {
  code: Scalars["String"];
  name?: InputMaybe<Scalars["String"]>;
  parentId?: InputMaybe<Scalars["ID"]>;
  value: Scalars["String"];
};

export type TagValue = {
  __typename?: "TagValue";
  externalIdentifier: Scalars["String"];
  id: Scalars["ID"];
  tag: Tag;
  value: Scalars["String"];
};

export type TagValueConnection = {
  __typename?: "TagValueConnection";
  edges: Array<TagValueEdge>;
};

export type TagValueEdge = {
  __typename?: "TagValueEdge";
  node: TagValue;
};

export type Tax = {
  __typename?: "Tax";
  /** @deprecated Use amountString instead amount */
  amount?: Maybe<Scalars["Float"]>;
  amountString?: Maybe<Scalars["String"]>;
  label?: Maybe<Scalars["String"]>;
  number?: Maybe<Scalars["String"]>;
};

export type TeamMemberShowroomCollectionShare = {
  __typename?: "TeamMemberShowroomCollectionShare";
  showroomCollectionId: Scalars["ID"];
  teamRecipients: Array<ShowroomCollectionShareTeamRecipient>;
};

export type TeamUser = Node & {
  __typename?: "TeamUser";
  displayName?: Maybe<Scalars["String"]>;
  email?: Maybe<Scalars["String"]>;
  id: Scalars["ID"];
};

export type TeamUserConnection = {
  __typename?: "TeamUserConnection";
  edges: Array<TeamUserEdge>;
};

export type TeamUserEdge = {
  __typename?: "TeamUserEdge";
  node?: Maybe<TeamUser>;
};

export type TermsAndCondition = {
  __typename?: "TermsAndCondition";
  brandAccountId: Scalars["ID"];
  id: Scalars["ID"];
  name?: Maybe<Scalars["String"]>;
  terms?: Maybe<Scalars["String"]>;
};

export type TermsAndConditions = Node & {
  __typename?: "TermsAndConditions";
  brand: Brand;
  id: Scalars["ID"];
  name?: Maybe<Scalars["String"]>;
  terms?: Maybe<Scalars["String"]>;
};

export type TextContentInput = {
  content: Scalars["String"];
  layoutKey: Scalars["String"];
  presentation: Scalars["String"];
};

export type TextStyle = Node & {
  __typename?: "TextStyle";
  id: Scalars["ID"];
  name: Scalars["String"];
  orderNbr: Scalars["Int"];
  size: Scalars["String"];
  typeface: Scalars["String"];
  weight: Scalars["String"];
};

export type TextStyleInput = {
  id?: InputMaybe<Scalars["ID"]>;
  name: Scalars["String"];
  orderNbr: Scalars["Int"];
  size: Scalars["String"];
  typeface: Scalars["String"];
  weight: Scalars["String"];
};

export type TotalPriceLevels = Node & {
  __typename?: "TotalPriceLevels";
  id: Scalars["ID"];
  priceLevels: Array<PriceLevel>;
  quantity: Scalars["Int"];
  skuCount: Scalars["Int"];
};

export type TotalPriceLevelsPriceLevelsArgs = {
  filters?: InputMaybe<PriceLevelsFilter>;
};

export type TradeShowEvent = Node & {
  __typename?: "TradeShowEvent";
  endDate: Scalars["Date"];
  eventName: Scalars["String"];
  id: Scalars["ID"];
  slug: Scalars["String"];
  startDate: Scalars["Date"];
};

export type TradeShowEventBrand = Node & {
  __typename?: "TradeShowEventBrand";
  id: Scalars["ID"];
  mainPictureUrl: Scalars["String"];
  name: Scalars["String"];
  productLines: Array<Scalars["String"]>;
  profileImageUrls: Array<Scalars["String"]>;
  retailMax: Scalars["Int"];
  retailMin: Scalars["Int"];
  slug: Scalars["String"];
  tags: Array<Scalars["String"]>;
  wholesaleMax: Scalars["Int"];
  wholesaleMin: Scalars["Int"];
};

export type TradeShowEventBrandCategories = Node & {
  __typename?: "TradeShowEventBrandCategories";
  id: Scalars["ID"];
  name: Scalars["String"];
};

export type TradeShowEventBrandCategoriesConnection = {
  __typename?: "TradeShowEventBrandCategoriesConnection";
  edges?: Maybe<Array<TradeShowEventBrandCategoriesEdge>>;
};

export type TradeShowEventBrandCategoriesEdge = {
  __typename?: "TradeShowEventBrandCategoriesEdge";
  node: TradeShowEventBrandCategories;
};

export type TradeShowEventBrandConnection = {
  __typename?: "TradeShowEventBrandConnection";
  edges?: Maybe<Array<TradeShowEventBrandEdge>>;
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars["Int"]>;
};

export type TradeShowEventBrandEdge = {
  __typename?: "TradeShowEventBrandEdge";
  cursor: Scalars["String"];
  node: TradeShowEventBrand;
};

export type TradeShowEventBrandFilter = {
  categoryIds?: InputMaybe<Array<Scalars["ID"]>>;
  name?: InputMaybe<Scalars["String"]>;
  priceRange?: InputMaybe<PriceRangeFilterInput>;
  slugs?: InputMaybe<Array<Scalars["String"]>>;
  tagSlugs?: InputMaybe<Array<Scalars["String"]>>;
  tradeShowIds?: InputMaybe<Array<Scalars["ID"]>>;
};

export type TradeShowEventConnection = {
  __typename?: "TradeShowEventConnection";
  edges?: Maybe<Array<TradeShowEventEdge>>;
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars["Int"]>;
};

export type TradeShowEventEdge = {
  __typename?: "TradeShowEventEdge";
  cursor: Scalars["String"];
  node: TradeShowEvent;
};

export type TradeShowEventFilter = {
  slugs?: InputMaybe<Array<Scalars["String"]>>;
  tradeShowIds?: InputMaybe<Array<Scalars["ID"]>>;
};

export type TradeShowPageInfo = {
  limit: Scalars["Int"];
  offset: Scalars["Int"];
};

export type Trait = {
  code: Scalars["String"];
  id: Scalars["ID"];
  name: Scalars["String"];
};

export enum TraitCode {
  Color = "COLOR",
  Size = "SIZE",
}

export type TraitValue = {
  externalIdentifier?: Maybe<Scalars["String"]>;
  id: Scalars["ID"];
  trait: Trait;
  value: Scalars["String"];
};

export type TraitValueDisplayDetails = {
  __typename?: "TraitValueDisplayDetails";
  hexColor?: Maybe<Scalars["String"]>;
  merchandiseImages?: Maybe<Array<Image>>;
  swatchImage?: Maybe<Image>;
};

export type TraitValueInput = {
  traitCode: Scalars["String"];
  traitValueIds: Array<Scalars["ID"]>;
};

export type TriggerAssortmentExcelExportTasksInput = {
  assortmentIds: Array<Scalars["ID"]>;
  emailRequest?: InputMaybe<Scalars["Boolean"]>;
};

export type TriggerAssortmentExcelExportTasksPayload = {
  __typename?: "TriggerAssortmentExcelExportTasksPayload";
  responses: Array<Maybe<Scalars["ID"]>>;
};

export type TriggerAssortmentExportInput = {
  assortmentId: Scalars["ID"];
  integrationId: Scalars["ID"];
};

export type TriggerAssortmentExportPayload = {
  __typename?: "TriggerAssortmentExportPayload";
  downloadUrl: Scalars["String"];
};

export type TriggerAssortmentPdfExportTasksInput = {
  assortmentIds: Array<Scalars["ID"]>;
  emailRequest?: InputMaybe<Scalars["Boolean"]>;
};

export type TriggerAssortmentPdfExportTasksPayload = {
  __typename?: "TriggerAssortmentPDFExportTasksPayload";
  responses: Array<Maybe<Scalars["ID"]>>;
};

export type TriggerBulkAssortmentExportInput = {
  assortmentIds: Array<Scalars["ID"]>;
  integrationId: Scalars["ID"];
};

export type TriggerBulkProductExportInput = {
  collectionIds: Array<Scalars["ID"]>;
  integrationId: Scalars["ID"];
};

export type TriggerOrdersPdfExportTasksInput = {
  orderIds: Array<Scalars["ID"]>;
};

export type TriggerOrdersPdfExportTasksPayload = {
  __typename?: "TriggerOrdersPdfExportTasksPayload";
  taskIds: Array<Scalars["ID"]>;
};

export type TriggerProductExportPayload = {
  __typename?: "TriggerProductExportPayload";
  downloadUrl: Scalars["String"];
};

export type TriggerResetPasswordInput = {
  email: Scalars["String"];
};

export type TriggerResetPasswordPayload = {
  __typename?: "TriggerResetPasswordPayload";
  errors?: Maybe<Array<Scalars["String"]>>;
  success: Scalars["Boolean"];
};

export type UnSubscribeUserToFeatureInput = {
  featureName: Scalars["String"];
  userId: Scalars["ID"];
};

export type UnSubscribeUserToFeaturePayload = {
  __typename?: "UnSubscribeUserToFeaturePayload";
  success?: Maybe<Scalars["Boolean"]>;
};

export type UnitRange = {
  max?: InputMaybe<Scalars["Int"]>;
  min?: InputMaybe<Scalars["Int"]>;
};

export type UnshareCollectionsWithRetailersInput = {
  collectionId: Scalars["ID"];
  retailerIds: Array<Scalars["ID"]>;
};

export type UnshareCollectionsWithRetailersPayload = {
  __typename?: "UnshareCollectionsWithRetailersPayload";
  collections: CollectionConnection;
};

export type UnshareShowroomCollectionInput = {
  retailerAccountIds: Array<Scalars["ID"]>;
  showroomCollectionId: Scalars["ID"];
  teamRecipientIds: Array<Scalars["ID"]>;
};

export type UpdateAccountPermissionAccessInput = {
  accountId: Scalars["ID"];
  permissionStates: Array<PermissionState>;
};

export type UpdateAccountPermissionAccessPayload = {
  __typename?: "UpdateAccountPermissionAccessPayload";
  success: Scalars["Boolean"];
};

export type UpdateAccountPrivacyInput = {
  accountId: Scalars["ID"];
  privacy: Scalars["Boolean"];
};

export type UpdateAccountPrivacyPayload = {
  __typename?: "UpdateAccountPrivacyPayload";
  account?: Maybe<Account>;
};

export type UpdateAccountUserDataPermissionConfigurationInput = {
  accountId: Scalars["ID"];
  dataPermissionConfigurationId: Scalars["ID"];
  userId: Scalars["ID"];
};

export type UpdateAccountUserDataPermissionConfigurationPayload = {
  __typename?: "UpdateAccountUserDataPermissionConfigurationPayload";
  success: Scalars["Boolean"];
};

export type UpdateAccountUserGeoRestrictionsInput = {
  accountId: Scalars["ID"];
  exceptionAccountIds: Array<Scalars["ID"]>;
  regionAssignedOverride: Scalars["Boolean"];
  regionIds: Array<Scalars["ID"]>;
  userId: Scalars["ID"];
};

export type UpdateAccountUserPossibleExceptionsInput = {
  accountId: Scalars["ID"];
  regionIds: Array<Scalars["ID"]>;
  userId: Scalars["ID"];
};

export type UpdateAccountUsersPermissionAccessInput = {
  accountId: Scalars["ID"];
  permissionStates: Array<PermissionState>;
  userId: Scalars["ID"];
};

export type UpdateAccountUsersPermissionAccessPayload = {
  __typename?: "UpdateAccountUsersPermissionAccessPayload";
  success: Scalars["Boolean"];
};

/** Updates the import status of an assortment */
export type UpdateAssortmentDetailsInput = {
  archived?: InputMaybe<Scalars["Boolean"]>;
  /** Id of the object to update */
  assortmentId: Scalars["ID"];
  brandId?: InputMaybe<Scalars["ID"]>;
  collectionId?: InputMaybe<Scalars["ID"]>;
  completeShip?: InputMaybe<Scalars["String"]>;
  dueDate?: InputMaybe<Scalars["String"]>;
  /** note this only supports a list of one user at the moment */
  editableByUserIds?: InputMaybe<Array<Scalars["ID"]>>;
  name?: InputMaybe<Scalars["String"]>;
  poNumber?: InputMaybe<Scalars["String"]>;
  seasonId?: InputMaybe<Scalars["ID"]>;
  startShip?: InputMaybe<Scalars["String"]>;
  status?: InputMaybe<AssortmentStatus>;
  version?: InputMaybe<Scalars["String"]>;
};

export type UpdateAssortmentDetailsPayload = {
  __typename?: "UpdateAssortmentDetailsPayload";
  assortment?: Maybe<Assortment>;
  errors?: Maybe<Array<Error>>;
};

/** Updates the import status of an assortment */
export type UpdateAssortmentImportStatusInput = {
  /** Ids of the object to update */
  ids?: InputMaybe<Array<Scalars["ID"]>>;
};

export type UpdateAssortmentImportStatusPayload = {
  __typename?: "UpdateAssortmentImportStatusPayload";
  assortments?: Maybe<Array<Scalars["ID"]>>;
  errors?: Maybe<Array<Error>>;
};

/** Updates attribute details */
export type UpdateAttributeInput = {
  /** Id of the object to update */
  attributeId: Scalars["ID"];
  /** If true allows more than one option to be selected for this attribute */
  isMultiSelect?: InputMaybe<Scalars["Boolean"]>;
  /** If true requires an option to be selected for this attribute */
  isRequired?: InputMaybe<Scalars["Boolean"]>;
  /** A display name */
  name?: InputMaybe<Scalars["String"]>;
  /** Defines display order */
  position?: InputMaybe<Scalars["Int"]>;
};

/** Updates attribute option details */
export type UpdateAttributeOptionInput = {
  /** Id of the object to update */
  attributeOptionId: Scalars["ID"];
  /** The value of the option */
  value: Scalars["String"];
};

export type UpdateAttributeOptionPayload = {
  __typename?: "UpdateAttributeOptionPayload";
  attributeOption?: Maybe<AttributeOption>;
  errors?: Maybe<Array<Error>>;
};

/** Overwrites the attribute option rules for a price modifier */
export type UpdateAttributeOptionRuleForPriceModifierInput = {
  /** Values for the updated rules */
  attributeOptionIds: Array<Scalars["ID"]>;
  /** The factor to apply for this rule */
  factor: Scalars["Decimal"];
  /** Id of the object to update */
  priceModifierRuleId: Scalars["ID"];
  /** The name to display for this rule */
  ruleName: Scalars["String"];
};

export type UpdateAttributeOptionRuleForPriceModifierPayload = {
  __typename?: "UpdateAttributeOptionRuleForPriceModifierPayload";
  priceModifierRule: PriceModifierRule;
};

export type UpdateAttributePayload = {
  __typename?: "UpdateAttributePayload";
  attribute?: Maybe<Attribute>;
  errors?: Maybe<Array<Error>>;
};

export type UpdateAvailablePaymentMethodsInput = {
  accountId: Scalars["ID"];
  isAchEnabled: Scalars["Boolean"];
  isSepaEnabled: Scalars["Boolean"];
  paymentProvider: Scalars["String"];
};

/** Overwrites the brand rules of a price modifier */
export type UpdateBrandRuleForPriceModifierInput = {
  /** Value for the updated rule */
  brandId: Scalars["ID"];
  /** The factor to apply for this rule */
  factor: Scalars["Decimal"];
  /** Id of the object to update */
  priceModifierRuleId: Scalars["ID"];
  /** The name to display for this rule */
  ruleName: Scalars["String"];
};

export type UpdateBrandRuleForPriceModifierPayload = {
  __typename?: "UpdateBrandRuleForPriceModifierPayload";
  priceModifierRule: PriceModifierRule;
};

export type UpdateCollaborationInvitesToAccountInput = {
  invitingAccountId: Scalars["ID"];
  status: UserCollaborationInviteStatus;
};

export type UpdateCollectionBannerInput = {
  imageBanners?: InputMaybe<Array<UpdateCollectionImageBannerInput>>;
  textBanners?: InputMaybe<Array<UpdateCollectionTextBannerInput>>;
  videoBanners?: InputMaybe<Array<UpdateCollectionVideoBannerInput>>;
};

export type UpdateCollectionBannersInput = {
  banners: UpdateCollectionBannerInput;
  collectionId: Scalars["ID"];
};

export type UpdateCollectionBannersPayload = {
  __typename?: "UpdateCollectionBannersPayload";
  imageBanners?: Maybe<Array<CollectionImageBanner>>;
  textBanners?: Maybe<Array<CollectionTextBanner>>;
  videoBanners?: Maybe<Array<CollectionVideoBanner>>;
};

export type UpdateCollectionError = GenericError & {
  __typename?: "UpdateCollectionError";
  code?: Maybe<GenericErrorCode>;
  details?: Maybe<UpdateCollectionErrorDetail>;
  message: Scalars["String"];
};

export type UpdateCollectionErrorDetail = {
  __typename?: "UpdateCollectionErrorDetail";
  archived?: Maybe<Scalars["Boolean"]>;
  id: Scalars["ID"];
  ignores_inventory?: Maybe<Scalars["Boolean"]>;
  name?: Maybe<Scalars["String"]>;
  seasonId?: Maybe<Scalars["ID"]>;
  syncToIpad?: Maybe<Scalars["Boolean"]>;
  visibleToAllMatches?: Maybe<Scalars["Boolean"]>;
};

export type UpdateCollectionGroupInput = {
  header?: InputMaybe<Scalars["String"]>;
  id: Scalars["ID"];
  orderNbr?: InputMaybe<Scalars["Int"]>;
};

export type UpdateCollectionImageBannerInput = {
  id: Scalars["ID"];
  imageId?: InputMaybe<Scalars["ID"]>;
  imageUrl?: InputMaybe<Scalars["String"]>;
  orderNbr?: InputMaybe<Scalars["Int"]>;
  presentation?: InputMaybe<Scalars["String"]>;
};

export type UpdateCollectionInput = {
  archived?: InputMaybe<Scalars["Boolean"]>;
  code?: InputMaybe<Scalars["String"]>;
  completeShipDate?: InputMaybe<Scalars["Date"]>;
  cutoffDate?: InputMaybe<Scalars["Date"]>;
  description?: InputMaybe<Scalars["String"]>;
  id: Scalars["ID"];
  ignores_inventory?: InputMaybe<Scalars["Boolean"]>;
  isCustom?: InputMaybe<Scalars["Boolean"]>;
  madeToOrder?: InputMaybe<Scalars["Boolean"]>;
  minimumShippingWindow?: InputMaybe<Scalars["Int"]>;
  name?: InputMaybe<Scalars["String"]>;
  season?: InputMaybe<CollectionSeasonInput>;
  seasonId?: InputMaybe<Scalars["ID"]>;
  startShipDate?: InputMaybe<Scalars["Date"]>;
  syncToIpad?: InputMaybe<Scalars["Boolean"]>;
  visibleToAllMatches?: InputMaybe<Scalars["Boolean"]>;
};

export type UpdateCollectionProductInput = {
  comments?: InputMaybe<Scalars["String"]>;
  id: Scalars["ID"];
  orderNbr?: InputMaybe<Scalars["Int"]>;
};

export type UpdateCollectionTextBannerInput = {
  content?: InputMaybe<Scalars["String"]>;
  id: Scalars["ID"];
  orderNbr?: InputMaybe<Scalars["Int"]>;
  presentation?: InputMaybe<Scalars["String"]>;
};

export type UpdateCollectionVideoBannerInput = {
  id: Scalars["ID"];
  orderNbr?: InputMaybe<Scalars["Int"]>;
  presentation?: InputMaybe<Scalars["String"]>;
  videoId?: InputMaybe<Scalars["ID"]>;
  videoUrl?: InputMaybe<Scalars["String"]>;
};

export type UpdateCollectionsPositionInput = {
  collectionId: Scalars["ID"];
  position: Scalars["Int"];
};

export type UpdateCollectionsPublicInput = {
  collectionId: Scalars["ID"];
  public: Scalars["Boolean"];
};

export type UpdateConfigurationInput = {
  configuration: ConfigurationInput;
  id: Scalars["ID"];
};

export type UpdateConnectionBuyerInput = {
  email?: InputMaybe<Scalars["String"]>;
  id: Scalars["ID"];
  name?: InputMaybe<Scalars["String"]>;
  retailerId: Scalars["ID"];
};

export type UpdateConnectionDiscountInput = {
  amount?: InputMaybe<Scalars["String"]>;
  divisionId?: InputMaybe<Scalars["ID"]>;
  id: Scalars["ID"];
  level: DiscountLevel;
  retailerId?: InputMaybe<Scalars["ID"]>;
};

export type UpdateConnectionPriceTypeInput = {
  id: Scalars["ID"];
  priceTypeId: Scalars["ID"];
  retailerId: Scalars["ID"];
  termsConditionId?: InputMaybe<Scalars["ID"]>;
};

export type UpdateConnectionSalesRepInput = {
  divisionId?: InputMaybe<Scalars["ID"]>;
  id: Scalars["ID"];
  retailerId: Scalars["ID"];
  userId: Scalars["ID"];
};

export type UpdateDataPermissionConfigurationInput = {
  configuration?: InputMaybe<UpdatePermissionConfigurationInput>;
  id: Scalars["ID"];
  name?: InputMaybe<Scalars["String"]>;
};

export type UpdateDataPermissionConfigurationPayload = {
  __typename?: "UpdateDataPermissionConfigurationPayload";
  dataPermissionConfiguration?: Maybe<DataPermissionConfiguration>;
};

/** Updates information for a door */
export type UpdateDoorInput = {
  /** Id of the object to update */
  doorId: Scalars["ID"];
  /** A display name */
  name: Scalars["String"];
};

export type UpdateDoorPayload = {
  __typename?: "UpdateDoorPayload";
  door?: Maybe<Door>;
  errors?: Maybe<Array<Error>>;
};

export type UpdateExportIntegrationConfigInput = {
  autoStatus: Array<Scalars["Int"]>;
  columnConfig: Scalars["String"];
  combineExportsIntoSingleFile?: InputMaybe<Scalars["Boolean"]>;
  convertImagesUrlsToColumns?: InputMaybe<Scalars["Boolean"]>;
  convertSingleDoorToCluster?: InputMaybe<Scalars["Boolean"]>;
  csvDelimiter?: InputMaybe<CsvDelimiterType>;
  csvEncodingType?: InputMaybe<ExportCsvEncodingType>;
  defaultClusterDoors?: InputMaybe<Array<Scalars["String"]>>;
  doorQuantityColumn?: InputMaybe<Scalars["Boolean"]>;
  excludeSkusWithZeroQuantities?: InputMaybe<Scalars["Boolean"]>;
  fileExtension: ExportFileExtensionType;
  fileName?: InputMaybe<Scalars["String"]>;
  fileNameDelimiter?: InputMaybe<Scalars["String"]>;
  fileNameParts: Array<ExportFileNameParts>;
  fileNamePrefix?: InputMaybe<Scalars["String"]>;
  ftpPath?: InputMaybe<Scalars["String"]>;
  id: Scalars["ID"];
  isActive?: InputMaybe<Scalars["Boolean"]>;
  isGlobal?: InputMaybe<Scalars["Boolean"]>;
  level: ExportLevel;
  name: Scalars["String"];
  onlySkuQuantities?: InputMaybe<Scalars["Boolean"]>;
  overwrittenFileExtension?: InputMaybe<Scalars["String"]>;
  removeHeader?: InputMaybe<Scalars["Boolean"]>;
  textQualifier?: InputMaybe<Scalars["String"]>;
  type: ExportType;
  unzipFilesToFTPPath?: InputMaybe<Scalars["Boolean"]>;
};

export type UpdateHubInput = {
  id: Scalars["ID"];
  name?: InputMaybe<Scalars["String"]>;
  number?: InputMaybe<Scalars["String"]>;
  status?: InputMaybe<HubStatusInput>;
};

export type UpdateIdentityProviderInput = {
  domain: Scalars["String"];
  enabled?: InputMaybe<Scalars["Boolean"]>;
  sigCert: Scalars["String"];
  ssoLoginUrl: Scalars["String"];
};

export type UpdateIdentityProviderPayload = {
  __typename?: "UpdateIdentityProviderPayload";
  errors?: Maybe<Array<Scalars["String"]>>;
  idpConfig?: Maybe<IdpConfig>;
  success: Scalars["Boolean"];
};

export type UpdateInventoryItemQuantity = {
  availableQuantity: Scalars["Int"];
  inventoryItemId: Scalars["ID"];
};

export type UpdateManualPaymentRecordInput = {
  amount: Scalars["Float"];
  currency: Scalars["String"];
  id: Scalars["ID"];
  notes?: InputMaybe<Scalars["String"]>;
  paymentDate: Scalars["Date"];
  paymentMethod: ManualPaymentMethod;
  recordedBy?: InputMaybe<Scalars["String"]>;
  referenceNumber?: InputMaybe<Scalars["String"]>;
};

/** Update details for a merchandising hierarchy node */
export type UpdateMerchandisingHierarchyNodeInput = {
  /** Id of the merchandising hierarchy node to update */
  id: Scalars["ID"];
  /** A display name */
  name: Scalars["String"];
};

export type UpdateMerchandisingHierarchyNodePayload = {
  __typename?: "UpdateMerchandisingHierarchyNodePayload";
  errors?: Maybe<Array<Error>>;
  merchandisingHierarchyNode?: Maybe<MerchandisingHierarchyNode>;
};

/** Overwrites the merchandising hierarchy rules for a price modifier */
export type UpdateMerchandisingHierarchyRuleForPriceModifierInput = {
  /** The factor to apply for this rule */
  factor: Scalars["Decimal"];
  /** Values for the updated rules */
  merchandisingHierarchyNodeId: Scalars["ID"];
  /** Id of the object to update */
  priceModifierRuleId: Scalars["ID"];
  /** The name to display for this rule */
  ruleName: Scalars["String"];
};

export type UpdateMerchandisingHierarchyRuleForPriceModifierPayload = {
  __typename?: "UpdateMerchandisingHierarchyRuleForPriceModifierPayload";
  priceModifierRule: PriceModifierRule;
};

export type UpdateOrderBillingInput = {
  billingInfo: BillingInfo;
  orderId: Scalars["ID"];
  overrideSourceAddress?: InputMaybe<Scalars["Boolean"]>;
};

export type UpdateOrderCommentsInput = {
  productComments: Array<OrderProductComment>;
  variantComments: Array<OrderVariantComment>;
};

export type UpdateOrderCommentsPayload = {
  __typename?: "UpdateOrderCommentsPayload";
  updatedOrderIds: Array<Scalars["ID"]>;
};

export type UpdateOrderCustomerRecordIdInput = {
  customerRecordId: Scalars["ID"];
  orderId: Scalars["ID"];
};

export type UpdateOrderCustomerRecordIdPayload = {
  __typename?: "UpdateOrderCustomerRecordIdPayload";
  errors: Array<Error>;
  updatedOrderId: Scalars["String"];
};

export type UpdateOrderCustomerShippingBillingInput = {
  billingAddress?: InputMaybe<AliasAddressInput>;
  id: Scalars["ID"];
  shippingAddress?: InputMaybe<AliasAddressInput>;
};

export type UpdateOrderDeliveryInfoInput = {
  orderDeliveryInfo: OrderDeliveryInfo;
  orderId: Scalars["ID"];
};

export type UpdateOrderDeliveryInfoPayload = {
  __typename?: "UpdateOrderDeliveryInfoPayload";
  updatedOrderIds: Array<Scalars["ID"]>;
};

export type UpdateOrderDiscountInput = {
  discount: OrderDiscount;
  orderId: Scalars["ID"];
};

export type UpdateOrderDiscountPayload = {
  __typename?: "UpdateOrderDiscountPayload";
  orderId: Scalars["ID"];
};

export type UpdateOrderInfoInput = {
  orderDetails: OrderDetails;
  orderIdentifiers: OrderIdentifiers;
};

export type UpdateOrderInput = {
  billingAddressCode?: InputMaybe<Scalars["String"]>;
  billingAddressId?: InputMaybe<Scalars["ID"]>;
  buyerId?: InputMaybe<Scalars["ID"]>;
  comments?: InputMaybe<Scalars["String"]>;
  deliveryWindowEnd?: InputMaybe<Scalars["Date"]>;
  deliveryWindowStart?: InputMaybe<Scalars["Date"]>;
  exportDescription?: InputMaybe<Scalars["String"]>;
  exportStatus?: InputMaybe<OrderExportStatus>;
  id: Scalars["ID"];
  internalComments?: InputMaybe<Scalars["String"]>;
  paymentMethodCode?: InputMaybe<Scalars["String"]>;
  paymentMethodId?: InputMaybe<Scalars["ID"]>;
  poNumber?: InputMaybe<Scalars["String"]>;
  priceTypeId?: InputMaybe<Scalars["ID"]>;
  priceTypeName?: InputMaybe<Scalars["String"]>;
  retailerCode?: InputMaybe<Scalars["String"]>;
  retailerId?: InputMaybe<Scalars["ID"]>;
  salesRepCode?: InputMaybe<Scalars["String"]>;
  salesRepId?: InputMaybe<Scalars["ID"]>;
  shippingAddressCode?: InputMaybe<Scalars["String"]>;
  shippingAddressId?: InputMaybe<Scalars["ID"]>;
  shippingMethodCode?: InputMaybe<Scalars["String"]>;
  shippingMethodId?: InputMaybe<Scalars["ID"]>;
  taxAmount?: InputMaybe<Scalars["Float"]>;
  trackingNumber?: InputMaybe<Scalars["String"]>;
};

export type UpdateOrderPayload = {
  __typename?: "UpdateOrderPayload";
  errors?: Maybe<Array<Scalars["String"]>>;
  updatedOrderIds?: Maybe<Array<Scalars["ID"]>>;
  updatedOrders?: Maybe<OrderConnection>;
};

export type UpdateOrderProductDiscountsInput = {
  orderProductDiscounts: Array<OrderProductDiscountInput>;
};

export type UpdateOrderProductDiscountsPayload = {
  __typename?: "UpdateOrderProductDiscountsPayload";
  updatedOrderIds?: Maybe<Array<Scalars["ID"]>>;
};

export type UpdateOrderShippingBillingInput = {
  billingInfo?: InputMaybe<BillingInfo>;
  orderId: Scalars["ID"];
  overrideSourceAddress?: InputMaybe<Scalars["Boolean"]>;
  shippingInfo?: InputMaybe<ShippingInfo>;
};

export type UpdateOrderShippingInput = {
  orderId: Scalars["ID"];
  overrideSourceAddress?: InputMaybe<Scalars["Boolean"]>;
  shippingInfo: ShippingInfo;
};

export type UpdateOrdersConnection = {
  orders: Array<UpdateOrderInput>;
};

export type UpdatePaymentInput = {
  amount: Scalars["Float"];
  brandId: Scalars["ID"];
  externalIdentifier: Scalars["String"];
  paymentProvider: Scalars["String"];
  retailerId?: InputMaybe<Scalars["ID"]>;
};

export type UpdatePaymentPayload = {
  __typename?: "UpdatePaymentPayload";
  ok: Scalars["Boolean"];
};

export type UpdatePaymentSettingsInput = {
  accountId: Scalars["ID"];
  brandNotificationEmail?: InputMaybe<Scalars["String"]>;
  paymentProvider: Scalars["String"];
  retailersCanSeeInvoices: Scalars["Boolean"];
  sendBrandMailPaymentProcessed: Scalars["Boolean"];
  sendRetailerMailPaymentProcessed: Scalars["Boolean"];
};

export type UpdatePermissionConfigurationInput = {
  collectionIds?: InputMaybe<Array<Scalars["ID"]>>;
  divisionCategories?: InputMaybe<Array<DivisionCategoryInput>>;
  divisionIds?: InputMaybe<Array<Scalars["ID"]>>;
  priceTypeIds?: InputMaybe<Array<Scalars["ID"]>>;
};

export type UpdateProductError = GenericError & {
  __typename?: "UpdateProductError";
  code?: Maybe<GenericErrorCode>;
  details?: Maybe<UpdateProductErrorDetail>;
  message: Scalars["String"];
};

export type UpdateProductErrorDetail = {
  __typename?: "UpdateProductErrorDetail";
  categoryIds?: Maybe<Array<Scalars["ID"]>>;
  description?: Maybe<Scalars["String"]>;
  externalIdentifier?: Maybe<Scalars["String"]>;
  id?: Maybe<Scalars["ID"]>;
  name?: Maybe<Scalars["String"]>;
  orderMinimum?: Maybe<Scalars["Int"]>;
  productIdentifier?: Maybe<Scalars["String"]>;
};

export type UpdateProductInput = {
  badgeIds?: InputMaybe<Array<Scalars["ID"]>>;
  categoryIds?: InputMaybe<Array<Scalars["ID"]>>;
  description?: InputMaybe<Scalars["String"]>;
  externalIdentifier?: InputMaybe<Scalars["String"]>;
  id?: InputMaybe<Scalars["ID"]>;
  name?: InputMaybe<Scalars["String"]>;
  orderMinimum?: InputMaybe<Scalars["Int"]>;
  productIdentifier?: InputMaybe<Scalars["String"]>;
  tags?: InputMaybe<Array<TagInput>>;
};

export type UpdateRegionInput = {
  geographyIds?: InputMaybe<Array<Scalars["ID"]>>;
  id: Scalars["ID"];
  name?: InputMaybe<Scalars["String"]>;
};

export type UpdateRetailWorkspaceNameInput = {
  /** The new workspace name */
  name: Scalars["String"];
  /** The id of retail workspace to update */
  retailWorkspaceId: Scalars["ID"];
};

export type UpdateRetailerImpersonationFeedbackPayload = {
  __typename?: "UpdateRetailerImpersonationFeedbackPayload";
  node: RetailerImpersonationFeedback;
};

export type UpdateRetailerPrimaryAccount = {
  __typename?: "UpdateRetailerPrimaryAccount";
  retailerId: Scalars["ID"];
};

export type UpdateRetailerPrimaryAccountInput = {
  primaryAccount: Scalars["Boolean"];
  retailerId: Scalars["ID"];
};

export type UpdateRetailerProfileInput = {
  buyer?: InputMaybe<LgBuyerInput>;
  description: Scalars["String"];
  locations?: InputMaybe<Array<LgLocationInput>>;
  logoId?: InputMaybe<Scalars["ID"]>;
  profileSnoozeCounter?: InputMaybe<Scalars["Int"]>;
  retailerId: Scalars["ID"];
  socialMediaAccounts?: InputMaybe<Array<SocialMediaAccountInput>>;
  websiteUrl: Scalars["String"];
};

export type UpdateSeasonError = GenericError & {
  __typename?: "UpdateSeasonError";
  code?: Maybe<GenericErrorCode>;
  details?: Maybe<UpdateSeasonErrorDetail>;
  message: Scalars["String"];
};

export type UpdateSeasonErrorDetail = {
  __typename?: "UpdateSeasonErrorDetail";
  /** Id of the object to update */
  id: Scalars["ID"];
  /** A display name */
  name?: Maybe<Scalars["String"]>;
  /** A calendar year */
  year?: Maybe<Scalars["Int"]>;
};

/** Updates the details of a season */
export type UpdateSeasonInput = {
  /** Id of the object to update */
  id: Scalars["ID"];
  /** A display name */
  name?: InputMaybe<Scalars["String"]>;
  /** A calendar year */
  year?: InputMaybe<Scalars["Int"]>;
};

export type UpdateSeasonPayload = {
  __typename?: "UpdateSeasonPayload";
  errors?: Maybe<Array<UpdateSeasonError>>;
  season?: Maybe<Season>;
};

export type UpdateShowroomCollectionInput = {
  id: Scalars["ID"];
  name: Scalars["String"];
  status: ShowroomCollectionStatus;
  url3dShowroom?: InputMaybe<Scalars["ID"]>;
  visibleToAllConnected: Scalars["Boolean"];
};

export type UpdateShowroomCollectionsInput = {
  showroomCollections: Array<UpdateShowroomCollectionInput>;
};

export type UpdateSkuPriceError = GenericError & {
  __typename?: "UpdateSkuPriceError";
  code?: Maybe<GenericErrorCode>;
  details?: Maybe<UpdateSkuPriceErrorDetail>;
  message: Scalars["String"];
};

export type UpdateSkuPriceErrorDetail = {
  __typename?: "UpdateSkuPriceErrorDetail";
  id: Scalars["ID"];
  suggestedRetailPrice?: Maybe<Scalars["Decimal"]>;
  wholesalePrice?: Maybe<Scalars["Decimal"]>;
};

export type UpdateSkuPriceInput = {
  id: Scalars["ID"];
  suggestedRetailPrice?: InputMaybe<Scalars["Decimal"]>;
  wholesalePrice?: InputMaybe<Scalars["Decimal"]>;
};

export type UpdateSkuTraitValueInput = {
  externalIdentifier?: InputMaybe<Scalars["String"]>;
  id: Scalars["ID"];
  orderMinimum?: InputMaybe<Scalars["Int"]>;
  status?: InputMaybe<SkuTraitValueStatus>;
  value?: InputMaybe<Scalars["String"]>;
};

export type UpdateStorefrontInput = {
  displayName?: InputMaybe<Scalars["String"]>;
  id: Scalars["ID"];
  isHome?: InputMaybe<Scalars["Boolean"]>;
  isOnline?: InputMaybe<Scalars["Boolean"]>;
  orderNbr?: InputMaybe<Scalars["Int"]>;
  uniqueName?: InputMaybe<Scalars["String"]>;
};

export type UpdateStyleboardInput = {
  brandId?: InputMaybe<Scalars["ID"]>;
  id: Scalars["ID"];
  layout?: InputMaybe<Scalars["String"]>;
  name: Scalars["String"];
  status: StyleboardStatus;
};

export type UpdateStyleboardsInput = {
  styleboards: Array<UpdateStyleboardInput>;
};

export type UpdateUserCollaborationInviteInput = {
  collaborationInviteId: Scalars["ID"];
  status: UserCollaborationInviteStatus;
};

export type UpdateUserCollaborationInvitePayload = {
  __typename?: "UpdateUserCollaborationInvitePayload";
  success: Scalars["Boolean"];
};

export type UpdateUserFavoriteCollectionsInput = {
  collectionId: Scalars["ID"];
  favorite: Scalars["Boolean"];
};

export type UpdateWarehousesInput = {
  code: Scalars["String"];
  id: Scalars["ID"];
  name: Scalars["String"];
};

export type UploadAttachmentToS3Input = {
  file: Scalars["Upload"];
};

export type UploadAttachmentToS3Payload = {
  __typename?: "UploadAttachmentToS3Payload";
  fileName?: Maybe<Scalars["String"]>;
  mimeType?: Maybe<Scalars["String"]>;
  url?: Maybe<Scalars["String"]>;
};

export type UploadColorImage = {
  __typename?: "UploadColorImage";
  colorId?: Maybe<Scalars["String"]>;
  image?: Maybe<Image>;
};

export type UploadFileToS3Input = {
  file?: InputMaybe<Scalars["Upload"]>;
};

export type UploadItemImage = {
  __typename?: "UploadItemImage";
  assortmentId: Scalars["ID"];
};

export type UploadProductColorImageResult = {
  __typename?: "UploadProductColorImageResult";
  colorId: Scalars["ID"];
};

export type UploadProductImageResult = {
  __typename?: "UploadProductImageResult";
  assortmentId: Scalars["ID"];
};

export type UploadSwatchImage = {
  __typename?: "UploadSwatchImage";
  image?: Maybe<Image>;
};

export type UpsertAccountConnectionStatusesInput = {
  accountId: Scalars["ID"];
  customMessage?: InputMaybe<Scalars["String"]>;
  otherAccountConnectionActions: Array<AccountConnectionRequest>;
};

export type UpsertAccountConnectionStatusesPayload = {
  __typename?: "UpsertAccountConnectionStatusesPayload";
  accountConnectionStatuses: Array<AccountConnectionStatus>;
};

export type UpsertAccountCustomerCodesInput = {
  customerCodes: Array<AccountCustomerCodeInput>;
};

export type UpsertBillingAddressesPayload = {
  __typename?: "UpsertBillingAddressesPayload";
  billingAddresses?: Maybe<Array<Maybe<BillingAddress>>>;
  message: Array<Scalars["String"]>;
  success: Scalars["Boolean"];
};

export type UpsertBrandProfileInput = {
  customUrlHandle: Scalars["String"];
  description?: InputMaybe<Scalars["String"]>;
  facebookLink: Scalars["String"];
  instagramHandle: Scalars["String"];
  logoId?: InputMaybe<Scalars["ID"]>;
  mainPictureId?: InputMaybe<Scalars["ID"]>;
  productLineIds?: InputMaybe<Array<Scalars["ID"]>>;
  retailMax: Scalars["Int"];
  retailMin: Scalars["Int"];
  twitterHandle: Scalars["String"];
  websiteLink: Scalars["String"];
  wholesaleMax: Scalars["Int"];
  wholesaleMin: Scalars["Int"];
  yearEstablished: Scalars["Int"];
};

export type UpsertBulkQuantity = {
  collectionId?: InputMaybe<Scalars["ID"]>;
  inventoryId?: InputMaybe<Scalars["ID"]>;
  orderId: Scalars["ID"];
  productId: Scalars["ID"];
  quantity?: InputMaybe<Scalars["Int"]>;
  variantId: Scalars["ID"];
};

export type UpsertCasepackQuantity = {
  casepackId: Scalars["ID"];
  collectionId?: InputMaybe<Scalars["ID"]>;
  inventoryId?: InputMaybe<Scalars["ID"]>;
  orderId: Scalars["ID"];
  productId: Scalars["ID"];
  quantity?: InputMaybe<Scalars["Int"]>;
};

export type UpsertCollectionTextStylesInput = {
  collectionId: Scalars["ID"];
  textStyles: Array<CollectionTextStyleInput>;
};

export type UpsertCollectionTextStylesPayload = {
  __typename?: "UpsertCollectionTextStylesPayload";
  textStyles: Array<CollectionTextStyle>;
};

export type UpsertOrderQuantitiesInput = {
  /** To pass bulk quantities to be updated/added on the orders in progress */
  bulkQuantities?: InputMaybe<Array<UpsertBulkQuantity>>;
  /** To pass casepack quantities to be updated/added on the orders in progress */
  casepackQuantities?: InputMaybe<Array<UpsertCasepackQuantity>>;
  /** To pass SKU quantities to be updated/added on the orders in progress */
  skuQuantities?: InputMaybe<Array<UpsertSkuQuantity>>;
};

export type UpsertOrderQuantitiesPayload = {
  __typename?: "UpsertOrderQuantitiesPayload";
  orders?: Maybe<OrderConnection>;
  updatedOrderIds?: Maybe<Array<Scalars["ID"]>>;
};

export type UpsertShowroomCollectionInput = {
  id?: InputMaybe<Scalars["ID"]>;
  looks?: InputMaybe<Array<UpsertShowroomCollectionLookInput>>;
  name: Scalars["String"];
  status: ShowroomCollectionStatus;
  url3dShowroom?: InputMaybe<Scalars["ID"]>;
  visibleToAllConnected: Scalars["Boolean"];
};

export type UpsertShowroomCollectionLookInput = {
  id?: InputMaybe<Scalars["ID"]>;
  items: Array<LookItemConnection>;
  layout: Scalars["String"];
  media: Array<Scalars["ID"]>;
  textContents: Array<LookTextContentInput>;
};

export type UpsertSkuQuantity = {
  collectionId?: InputMaybe<Scalars["ID"]>;
  inventoryId?: InputMaybe<Scalars["ID"]>;
  orderId: Scalars["ID"];
  quantity?: InputMaybe<Scalars["Int"]>;
  skuId: Scalars["ID"];
};

/** Update or create a storefront */
export type UpsertStorefrontInput = {
  displayName: Scalars["String"];
  id?: InputMaybe<Scalars["ID"]>;
  isHome: Scalars["Boolean"];
  isOnline: Scalars["Boolean"];
  orderNbr: Scalars["Int"];
  rows: Array<StorefrontRowInput>;
  uniqueName: Scalars["String"];
};

export type UpsertStorefrontTextStylesInput = {
  textStyles: Array<TextStyleInput>;
};

export type UpsertStyleboardInput = {
  brandId?: InputMaybe<Scalars["String"]>;
  id?: InputMaybe<Scalars["ID"]>;
  items?: InputMaybe<Array<UpsertStyleboardItemsInput>>;
  layout?: InputMaybe<Scalars["String"]>;
  name: Scalars["String"];
  status: StyleboardStatus;
  textContents?: InputMaybe<Array<TextContentInput>>;
};

export type UpsertStyleboardItemsInput = {
  collectionProduct: CollectionProductInput;
  lookId?: InputMaybe<Scalars["String"]>;
};

export type UpsertUrl3dShowroomInput = {
  Url3dShowrooms: Array<Url3dShowroomInput>;
};

export type Url3dShowroom = {
  __typename?: "Url3dShowroom";
  displayUrl?: Maybe<Scalars["String"]>;
  id: Scalars["ID"];
  name: Scalars["String"];
  provider: Provider3dShowroom;
  url: Scalars["String"];
};

export type Url3dShowroomFilter = {
  provider?: InputMaybe<Provider3dShowroom>;
};

export type Url3dShowroomInput = {
  id?: InputMaybe<Scalars["ID"]>;
  name?: InputMaybe<Scalars["String"]>;
  provider?: InputMaybe<Provider3dShowroom>;
  url?: InputMaybe<Scalars["String"]>;
};

export type User = Node & {
  __typename?: "User";
  assortmentPlanning: Scalars["Boolean"];
  code?: Maybe<Scalars["String"]>;
  dateFormat?: Maybe<DateFormat>;
  displayName?: Maybe<Scalars["String"]>;
  email?: Maybe<Scalars["String"]>;
  favoriteCollections: Array<Scalars["ID"]>;
  id: Scalars["ID"];
  isAdmin: Scalars["Boolean"];
  isOwner: Scalars["Boolean"];
  loggedInAsAdmin: Scalars["Boolean"];
  profileImage?: Maybe<Scalars["String"]>;
};

/**
 * Used to filter the collaboration invites list by inviting/invited user id.
 * Typically only one of these filters will be filled out, though it is valid to
 * provide both.
 */
export type UserCollaborationInviteFilter = {
  invitedUserId?: InputMaybe<Scalars["ID"]>;
  invitingUserId?: InputMaybe<Scalars["ID"]>;
  searchText?: InputMaybe<Scalars["String"]>;
  status?: InputMaybe<UserCollaborationInviteStatus>;
};

export enum UserCollaborationInviteStatus {
  Accepted = "ACCEPTED",
  Cancelled = "CANCELLED",
  Denied = "DENIED",
  Pending = "PENDING",
}

export type UserConnection = {
  __typename?: "UserConnection";
  edges: Array<UserEdge>;
};

export type UserEdge = {
  __typename?: "UserEdge";
  brands: BrandConnection;
  node: User;
};

export enum UserMembershipInviteStatus {
  Accepted = "ACCEPTED",
  Cancelled = "CANCELLED",
  Pending = "PENDING",
}

export type UserMembershipRequest = Node & {
  __typename?: "UserMembershipRequest";
  email?: Maybe<Scalars["String"]>;
  id: Scalars["ID"];
  status?: Maybe<UserMembershipRequestStatus>;
  userId: Scalars["ID"];
};

export type UserMembershipRequestConnection = {
  __typename?: "UserMembershipRequestConnection";
  edges: Array<UserMembershipRequestEdge>;
};

export type UserMembershipRequestEdge = {
  __typename?: "UserMembershipRequestEdge";
  node?: Maybe<UserMembershipRequest>;
};

export type UserMembershipRequestFilter = {
  statuses?: InputMaybe<Array<UserMembershipRequestStatus>>;
};

export enum UserMembershipRequestStatus {
  Accepted = "ACCEPTED",
  Denied = "DENIED",
  Pending = "PENDING",
}

export enum UserRole {
  SalesRepresentative = "SALES_REPRESENTATIVE",
}

export type UsersFilter = {
  role?: InputMaybe<UserRole>;
};

export type ValidateOrdersError = {
  __typename?: "ValidateOrdersError";
  code?: Maybe<GenericErrorCode>;
  message: Scalars["String"];
  skuLineItem: InvalidSkuLineItem;
  type?: Maybe<ErrorType>;
};

export type ValidateOrdersPayload = {
  __typename?: "ValidateOrdersPayload";
  errors?: Maybe<Array<ValidateOrdersError>>;
  orders: Array<OrderToImport>;
  validatedOrdersIdentifier: Scalars["String"];
  validatedOrdersUrl?: Maybe<Scalars["String"]>;
};

export type ValidateOrdersSettings = {
  caseSensitiveColorNames?: InputMaybe<Scalars["Boolean"]>;
  caseSensitiveProductNumbers?: InputMaybe<Scalars["Boolean"]>;
  caseSensitiveSizeNames?: InputMaybe<Scalars["Boolean"]>;
};

export type Validation = {
  __typename?: "Validation";
  field: AssortmentValidationField;
  /** Whether the field(s) is "valid", i.e. for assortment-level fields, whether it has been set to a value, for product-level fields, whether all products have been assigned a value */
  valid: Scalars["Boolean"];
};

export type VariantByCasepackLineItem = {
  __typename?: "VariantByCasepackLineItem";
  casepackId: Scalars["ID"];
  colorName: Scalars["String"];
  sizeName: Scalars["String"];
  variantId: Scalars["ID"];
};

export enum VariantFilterValuesInput {
  Color = "COLOR",
  Size = "SIZE",
}

export type VariantInCart = {
  __typename?: "VariantInCart";
  brand: Brand;
  collection: Collection;
  door?: Maybe<BrandDoor>;
  orderId: Scalars["ID"];
  priceType: PriceType;
  product: Product;
  retailer: Retailer;
  variantId: Scalars["ID"];
  warehouse?: Maybe<Warehouse>;
};

export type VariantTrait = Trait & {
  __typename?: "VariantTrait";
  code: Scalars["String"];
  id: Scalars["ID"];
  name: Scalars["String"];
};

export type VariantValue = Node & {
  __typename?: "VariantValue";
  displayDetails?: Maybe<TraitValueDisplayDetails>;
  id: Scalars["ID"];
  orderMinimum?: Maybe<Scalars["Int"]>;
  trait: SkuTrait;
  value: Scalars["String"];
};

export type VariantValueConnection = {
  __typename?: "VariantValueConnection";
  edges?: Maybe<Array<VariantValueEdge>>;
};

export type VariantValueEdge = {
  __typename?: "VariantValueEdge";
  node: VariantValue;
};

export type VariantsInCartFilter = {
  brandIds?: InputMaybe<Array<Scalars["ID"]>>;
  retailerIds?: InputMaybe<Array<Scalars["ID"]>>;
};

export type VerifyAchBankAccountInput = {
  amounts: Array<Scalars["Int"]>;
  brandId: Scalars["String"];
  paymentMethodId: Scalars["String"];
  paymentProvider: Scalars["String"];
  retailerId: Scalars["String"];
};

/** Verify a user email. */
export type VerifyUserEmailInput = {
  /** The email verification token */
  token: Scalars["String"];
  /** The unique identifier for the user */
  uid: Scalars["String"];
};

/** Returns whether user email was verified and any errors */
export type VerifyUserEmailPayload = {
  __typename?: "VerifyUserEmailPayload";
  errorCode?: Maybe<Scalars["String"]>;
  verified: Scalars["Boolean"];
};

export type Warehouse = {
  __typename?: "Warehouse";
  availabilityGroups: InventoryAvailabilityGroupConnection;
  code: Scalars["String"];
  id: Scalars["ID"];
  name: Scalars["String"];
  orderNbr?: Maybe<Scalars["Int"]>;
};

export type WarehouseAggregateSkuInventoryItemList = {
  __typename?: "WarehouseAggregateSkuInventoryItemList";
  items?: Maybe<Array<AggregateSkuInventoryItem>>;
  warehouse: Warehouse;
};

export type WarehouseConnection = {
  __typename?: "WarehouseConnection";
  edges: Array<Maybe<WarehouseEdge>>;
};

export type WarehouseEdge = {
  __typename?: "WarehouseEdge";
  node?: Maybe<Warehouse>;
};

export type WholesaleTotalsByPriceType = {
  __typename?: "WholesaleTotalsByPriceType";
  priceType: PriceType;
  wholesaleTotal: Scalars["Decimal"];
};

export type WorkspaceOrAssortment = Assortment | RetailWorkspace;

/** Each node of this object is of type Assortment or RetailWorkspace, whereas the cursor is its index */
export type WorkspaceOrAssortmentEdge = {
  __typename?: "WorkspaceOrAssortmentEdge";
  cursor: Scalars["String"];
  node: WorkspaceOrAssortment;
};

export type ZendeskUser = {
  __typename?: "ZendeskUser";
  token: Scalars["String"];
};

/** Creates a new collaboration invite for a non Joor user. */
export type CreateCollaborationInviteInput = {
  invitedEmail: Scalars["String"];
  invitedFullname: Scalars["String"];
  invitingAccountId: Scalars["ID"];
};

export type DeleteUnavailableProductsInput = {
  orderId: Scalars["ID"];
};

export type DeleteUnavailableProductsPayload = {
  __typename?: "deleteUnavailableProductsPayload";
  sentMail: Scalars["Boolean"];
  success: Scalars["Boolean"];
};

export type UniqueTagValuesFilter = {
  collectionIds?: InputMaybe<Array<Scalars["ID"]>>;
};

export type VariantItemsInput = {
  doorId?: InputMaybe<Scalars["ID"]>;
  variantId: Scalars["ID"];
};

export type UpdateCurrencyCodesFragment = {
  __typename?: "AssortmentSKUEdge";
  wholesaleCurrencyCode?: string | null;
  retailCurrencyCode?: string | null;
};

export type UpdateSizeNameFragment = { __typename?: "Size"; name: string };

export type UpdateColorBulkQuantityFragment = {
  __typename?: "AssortmentSKUColor";
  bulkQuantity: number;
};

export type UpdateSizeBulkFragment = {
  __typename?: "AssortmentSKUEdge";
  bulkQuantity: number;
};

export type UpdateUpcFragment = {
  __typename?: "AssortmentSKUEdge";
  upc?: string | null;
};

export type ManageImagesRemoveTestProductImagesFragment = {
  __typename?: "Style";
  images: {
    __typename?: "ImageConnection";
    edges: Array<{
      __typename?: "ImageEdge";
      node: { __typename?: "Image"; id: string };
    }>;
  };
};

export type UpdateStyleNameFragment = {
  __typename?: "Style";
  name?: string | null;
};

export type UpdateStyleCodeFragment = {
  __typename?: "Style";
  code?: string | null;
};

export type UpdateColorNameFragment = {
  __typename?: "AssortmentSKUColor";
  name: string;
};

export type UpdateColorCodeFragment = {
  __typename?: "AssortmentSKUColor";
  code: string;
};

export type UpdateStyleDescriptionFragment = {
  __typename?: "Style";
  description?: string | null;
};

export type UpdateColorCommentFragment = {
  __typename?: "AssortmentSKUColor";
  comment?: string | null;
};

export type UpdateSkuCommentFragment = {
  __typename?: "AssortmentSKUEdge";
  comment?: string | null;
};

export type ProductAssortmentSkusFragment = {
  __typename?: "Assortment";
  skus: {
    __typename?: "AssortmentSKUConnection";
    edges?: Array<{
      __typename?: "AssortmentSKUEdge";
      _id: string;
      style: {
        __typename?: "Style";
        id: string;
        images: {
          __typename?: "ImageConnection";
          edges: Array<{
            __typename?: "ImageEdge";
            node: { __typename?: "Image"; id: string };
          }>;
        };
      };
      color: {
        __typename?: "Color";
        id: string;
        code: string;
        name: string;
        swatch: {
          __typename?: "ColorSwatch";
          hex?: string | null;
          rgb?: {
            __typename?: "RGB";
            red: number;
            green: number;
            blue: number;
          } | null;
          image?: {
            __typename?: "ImageEdge";
            node: { __typename?: "Image"; id: string; url: any };
          } | null;
        };
        images: {
          __typename?: "ImageConnection";
          edges: Array<{
            __typename?: "ImageEdge";
            node: {
              __typename?: "Image";
              id: string;
              url: any;
              owner?: { __typename?: "ImageOwnerAccount"; id: string } | null;
            };
          }>;
        };
      };
    }> | null;
  };
};

export type UploadedSwatchImageFragment = {
  __typename?: "Image";
  id: string;
  url: any;
  owner?: { __typename?: "ImageOwnerAccount"; id: string } | null;
};

export type UpdatePriceLevelsFragment = {
  __typename?: "AssortmentSKUEdge";
  priceLevels: Array<{
    __typename?: "PriceLevel";
    id: string;
    name: FinancialPriceLevelName;
    extendedWholesale: string | number;
    extendedRetail: string | number;
    maxRetail: string | number;
    maxWholesale: string | number;
    currencyCode: string;
    currencySource?: CurrencyFilter | null;
  }>;
};

export type AlAddAttributeOptionMutationVariables = Exact<{
  assortmentSkuIds: Array<Scalars["ID"]> | Scalars["ID"];
  input: ApplyAssortmentSkuAttributesInput;
}>;

export type AlAddAttributeOptionMutation = {
  __typename?: "Mutation";
  applyAssortmentSkuColorAttributes: {
    __typename?: "ApplyAssortmentSkuColorAttributesPayload";
    colors?: Array<{
      __typename?: "AssortmentSKUColor";
      id: string;
      name: string;
      images: {
        __typename?: "ImageConnection";
        edges: Array<{
          __typename?: "ImageEdge";
          node: {
            __typename?: "Image";
            id: string;
            url: any;
            owner?: { __typename?: "ImageOwnerAccount"; id: string } | null;
          };
        }>;
      };
      swatch: {
        __typename?: "ColorSwatch";
        hex?: string | null;
        rgb?: {
          __typename?: "RGB";
          red: number;
          green: number;
          blue: number;
        } | null;
        image?: {
          __typename?: "ImageEdge";
          node: {
            __typename?: "Image";
            id: string;
            url: any;
            owner?: { __typename?: "ImageOwnerAccount"; id: string } | null;
          };
        } | null;
      };
      attributes: {
        __typename?: "AttributeOptionConnection";
        edges?: Array<{
          __typename?: "AttributeOptionEdge";
          node?: {
            __typename?: "AttributeOption";
            id: string;
            code: string;
            name: string;
            attribute: {
              __typename?: "AttributeEdge";
              node?: {
                __typename?: "Attribute";
                id: string;
                name: string;
                position: number;
                isRequired: boolean;
                type: AttributeType;
                isMultiSelect: boolean;
                parent?: {
                  __typename?: "AttributeEdge";
                  node?: { __typename?: "Attribute"; id: string } | null;
                } | null;
              } | null;
            };
          } | null;
        }> | null;
      };
      required: {
        __typename?: "AttributeConnection";
        edges?: Array<{
          __typename?: "AttributeEdge";
          node?: {
            __typename?: "Attribute";
            id: string;
            name: string;
            position: number;
            isRequired: boolean;
            type: AttributeType;
            isMultiSelect: boolean;
            parent?: {
              __typename?: "AttributeEdge";
              node?: { __typename?: "Attribute"; id: string } | null;
            } | null;
          } | null;
        }> | null;
      };
      skus: Array<{
        __typename?: "AssortmentSKUEdge";
        _id: string;
        catalogSku: {
          __typename?: "SKU";
          id: string;
          size: { __typename?: "Size"; id: string; name: string };
        };
      }>;
      price: {
        __typename?: "ProductColorPriceLevels";
        id: string;
        levels: Array<{
          __typename?: "PriceLevel";
          id: string;
          source?: CurrencyFilter | null;
          currency: string;
          wholesale: string | number;
          retail: string | number;
        }>;
      };
    }> | null;
    query: {
      __typename?: "Query";
      assortmentSkus: {
        __typename?: "AssortmentSKUConnection";
        edges?: Array<{
          __typename?: "AssortmentSKUEdge";
          _id: string;
          color: {
            __typename?: "AssortmentSKUColor";
            id: string;
            name: string;
            images: {
              __typename?: "ImageConnection";
              edges: Array<{
                __typename?: "ImageEdge";
                node: {
                  __typename?: "Image";
                  id: string;
                  url: any;
                  owner?: {
                    __typename?: "ImageOwnerAccount";
                    id: string;
                  } | null;
                };
              }>;
            };
            swatch: {
              __typename?: "ColorSwatch";
              hex?: string | null;
              rgb?: {
                __typename?: "RGB";
                red: number;
                green: number;
                blue: number;
              } | null;
              image?: {
                __typename?: "ImageEdge";
                node: {
                  __typename?: "Image";
                  id: string;
                  url: any;
                  owner?: {
                    __typename?: "ImageOwnerAccount";
                    id: string;
                  } | null;
                };
              } | null;
            };
            attributes: {
              __typename?: "AttributeOptionConnection";
              edges?: Array<{
                __typename?: "AttributeOptionEdge";
                node?: {
                  __typename?: "AttributeOption";
                  id: string;
                  code: string;
                  name: string;
                  attribute: {
                    __typename?: "AttributeEdge";
                    node?: {
                      __typename?: "Attribute";
                      id: string;
                      name: string;
                      position: number;
                      isRequired: boolean;
                      type: AttributeType;
                      isMultiSelect: boolean;
                      parent?: {
                        __typename?: "AttributeEdge";
                        node?: { __typename?: "Attribute"; id: string } | null;
                      } | null;
                    } | null;
                  };
                } | null;
              }> | null;
            };
            required: {
              __typename?: "AttributeConnection";
              edges?: Array<{
                __typename?: "AttributeEdge";
                node?: {
                  __typename?: "Attribute";
                  id: string;
                  name: string;
                  position: number;
                  isRequired: boolean;
                  type: AttributeType;
                  isMultiSelect: boolean;
                  parent?: {
                    __typename?: "AttributeEdge";
                    node?: { __typename?: "Attribute"; id: string } | null;
                  } | null;
                } | null;
              }> | null;
            };
            skus: Array<{
              __typename?: "AssortmentSKUEdge";
              _id: string;
              catalogSku: {
                __typename?: "SKU";
                id: string;
                size: { __typename?: "Size"; id: string; name: string };
              };
            }>;
            price: {
              __typename?: "ProductColorPriceLevels";
              id: string;
              levels: Array<{
                __typename?: "PriceLevel";
                id: string;
                source?: CurrencyFilter | null;
                currency: string;
                wholesale: string | number;
                retail: string | number;
              }>;
            };
          };
        }> | null;
      };
    };
  };
};

export type AlAvailableAttributesQueryVariables = Exact<{
  workspaceId: Scalars["ID"];
  optionIds: Array<Scalars["ID"]> | Scalars["ID"];
}>;

export type AlAvailableAttributesQuery = {
  __typename?: "Query";
  workspace?: {
    __typename?: "Assortment";
    id: string;
    availableOptions: {
      __typename?: "AttributeOptionConnection";
      edges?: Array<{
        __typename?: "AttributeOptionEdge";
        node?: {
          __typename?: "AttributeOption";
          id: string;
          code: string;
          name: string;
          attribute: {
            __typename?: "AttributeEdge";
            node?: {
              __typename?: "Attribute";
              id: string;
              name: string;
              position: number;
              isRequired: boolean;
              type: AttributeType;
              isMultiSelect: boolean;
              parent?: {
                __typename?: "AttributeEdge";
                node?: { __typename?: "Attribute"; id: string } | null;
              } | null;
            } | null;
          };
        } | null;
      }> | null;
    };
  } | null;
};

export type AlRemoveAttributeOptionMutationVariables = Exact<{
  assortmentSkuIds: Array<Scalars["ID"]> | Scalars["ID"];
  input: RemoveAssortmentSkuAttributesInput;
}>;

export type AlRemoveAttributeOptionMutation = {
  __typename?: "Mutation";
  removeAssortmentSkuColorAttributes: {
    __typename?: "RemoveAssortmentSkuColorAttributesPayload";
    colors?: Array<{
      __typename?: "AssortmentSKUColor";
      id: string;
      name: string;
      images: {
        __typename?: "ImageConnection";
        edges: Array<{
          __typename?: "ImageEdge";
          node: {
            __typename?: "Image";
            id: string;
            url: any;
            owner?: { __typename?: "ImageOwnerAccount"; id: string } | null;
          };
        }>;
      };
      swatch: {
        __typename?: "ColorSwatch";
        hex?: string | null;
        rgb?: {
          __typename?: "RGB";
          red: number;
          green: number;
          blue: number;
        } | null;
        image?: {
          __typename?: "ImageEdge";
          node: {
            __typename?: "Image";
            id: string;
            url: any;
            owner?: { __typename?: "ImageOwnerAccount"; id: string } | null;
          };
        } | null;
      };
      attributes: {
        __typename?: "AttributeOptionConnection";
        edges?: Array<{
          __typename?: "AttributeOptionEdge";
          node?: {
            __typename?: "AttributeOption";
            id: string;
            code: string;
            name: string;
            attribute: {
              __typename?: "AttributeEdge";
              node?: {
                __typename?: "Attribute";
                id: string;
                name: string;
                position: number;
                isRequired: boolean;
                type: AttributeType;
                isMultiSelect: boolean;
                parent?: {
                  __typename?: "AttributeEdge";
                  node?: { __typename?: "Attribute"; id: string } | null;
                } | null;
              } | null;
            };
          } | null;
        }> | null;
      };
      required: {
        __typename?: "AttributeConnection";
        edges?: Array<{
          __typename?: "AttributeEdge";
          node?: {
            __typename?: "Attribute";
            id: string;
            name: string;
            position: number;
            isRequired: boolean;
            type: AttributeType;
            isMultiSelect: boolean;
            parent?: {
              __typename?: "AttributeEdge";
              node?: { __typename?: "Attribute"; id: string } | null;
            } | null;
          } | null;
        }> | null;
      };
      skus: Array<{
        __typename?: "AssortmentSKUEdge";
        _id: string;
        catalogSku: {
          __typename?: "SKU";
          id: string;
          size: { __typename?: "Size"; id: string; name: string };
        };
      }>;
      price: {
        __typename?: "ProductColorPriceLevels";
        id: string;
        levels: Array<{
          __typename?: "PriceLevel";
          id: string;
          source?: CurrencyFilter | null;
          currency: string;
          wholesale: string | number;
          retail: string | number;
        }>;
      };
    }> | null;
    query?: {
      __typename?: "Query";
      assortmentSkus: {
        __typename?: "AssortmentSKUConnection";
        edges?: Array<{
          __typename?: "AssortmentSKUEdge";
          _id: string;
          color: {
            __typename?: "AssortmentSKUColor";
            id: string;
            name: string;
            images: {
              __typename?: "ImageConnection";
              edges: Array<{
                __typename?: "ImageEdge";
                node: {
                  __typename?: "Image";
                  id: string;
                  url: any;
                  owner?: {
                    __typename?: "ImageOwnerAccount";
                    id: string;
                  } | null;
                };
              }>;
            };
            swatch: {
              __typename?: "ColorSwatch";
              hex?: string | null;
              rgb?: {
                __typename?: "RGB";
                red: number;
                green: number;
                blue: number;
              } | null;
              image?: {
                __typename?: "ImageEdge";
                node: {
                  __typename?: "Image";
                  id: string;
                  url: any;
                  owner?: {
                    __typename?: "ImageOwnerAccount";
                    id: string;
                  } | null;
                };
              } | null;
            };
            attributes: {
              __typename?: "AttributeOptionConnection";
              edges?: Array<{
                __typename?: "AttributeOptionEdge";
                node?: {
                  __typename?: "AttributeOption";
                  id: string;
                  code: string;
                  name: string;
                  attribute: {
                    __typename?: "AttributeEdge";
                    node?: {
                      __typename?: "Attribute";
                      id: string;
                      name: string;
                      position: number;
                      isRequired: boolean;
                      type: AttributeType;
                      isMultiSelect: boolean;
                      parent?: {
                        __typename?: "AttributeEdge";
                        node?: { __typename?: "Attribute"; id: string } | null;
                      } | null;
                    } | null;
                  };
                } | null;
              }> | null;
            };
            required: {
              __typename?: "AttributeConnection";
              edges?: Array<{
                __typename?: "AttributeEdge";
                node?: {
                  __typename?: "Attribute";
                  id: string;
                  name: string;
                  position: number;
                  isRequired: boolean;
                  type: AttributeType;
                  isMultiSelect: boolean;
                  parent?: {
                    __typename?: "AttributeEdge";
                    node?: { __typename?: "Attribute"; id: string } | null;
                  } | null;
                } | null;
              }> | null;
            };
            skus: Array<{
              __typename?: "AssortmentSKUEdge";
              _id: string;
              catalogSku: {
                __typename?: "SKU";
                id: string;
                size: { __typename?: "Size"; id: string; name: string };
              };
            }>;
            price: {
              __typename?: "ProductColorPriceLevels";
              id: string;
              levels: Array<{
                __typename?: "PriceLevel";
                id: string;
                source?: CurrencyFilter | null;
                currency: string;
                wholesale: string | number;
                retail: string | number;
              }>;
            };
          };
        }> | null;
      };
    } | null;
  };
};

export type AlAttributeFragment = {
  __typename?: "Attribute";
  id: string;
  name: string;
  position: number;
  isRequired: boolean;
  type: AttributeType;
  isMultiSelect: boolean;
  parent?: {
    __typename?: "AttributeEdge";
    node?: { __typename?: "Attribute"; id: string } | null;
  } | null;
};

export type AlOptionFragment = {
  __typename?: "AttributeOption";
  id: string;
  code: string;
  name: string;
  attribute: {
    __typename?: "AttributeEdge";
    node?: {
      __typename?: "Attribute";
      id: string;
      name: string;
      position: number;
      isRequired: boolean;
      type: AttributeType;
      isMultiSelect: boolean;
      parent?: {
        __typename?: "AttributeEdge";
        node?: { __typename?: "Attribute"; id: string } | null;
      } | null;
    } | null;
  };
};

export type AlColorFragment = {
  __typename?: "AssortmentSKUColor";
  id: string;
  name: string;
  images: {
    __typename?: "ImageConnection";
    edges: Array<{
      __typename?: "ImageEdge";
      node: {
        __typename?: "Image";
        id: string;
        url: any;
        owner?: { __typename?: "ImageOwnerAccount"; id: string } | null;
      };
    }>;
  };
  swatch: {
    __typename?: "ColorSwatch";
    hex?: string | null;
    rgb?: {
      __typename?: "RGB";
      red: number;
      green: number;
      blue: number;
    } | null;
    image?: {
      __typename?: "ImageEdge";
      node: {
        __typename?: "Image";
        id: string;
        url: any;
        owner?: { __typename?: "ImageOwnerAccount"; id: string } | null;
      };
    } | null;
  };
  attributes: {
    __typename?: "AttributeOptionConnection";
    edges?: Array<{
      __typename?: "AttributeOptionEdge";
      node?: {
        __typename?: "AttributeOption";
        id: string;
        code: string;
        name: string;
        attribute: {
          __typename?: "AttributeEdge";
          node?: {
            __typename?: "Attribute";
            id: string;
            name: string;
            position: number;
            isRequired: boolean;
            type: AttributeType;
            isMultiSelect: boolean;
            parent?: {
              __typename?: "AttributeEdge";
              node?: { __typename?: "Attribute"; id: string } | null;
            } | null;
          } | null;
        };
      } | null;
    }> | null;
  };
  required: {
    __typename?: "AttributeConnection";
    edges?: Array<{
      __typename?: "AttributeEdge";
      node?: {
        __typename?: "Attribute";
        id: string;
        name: string;
        position: number;
        isRequired: boolean;
        type: AttributeType;
        isMultiSelect: boolean;
        parent?: {
          __typename?: "AttributeEdge";
          node?: { __typename?: "Attribute"; id: string } | null;
        } | null;
      } | null;
    }> | null;
  };
  skus: Array<{
    __typename?: "AssortmentSKUEdge";
    _id: string;
    catalogSku: {
      __typename?: "SKU";
      id: string;
      size: { __typename?: "Size"; id: string; name: string };
    };
  }>;
  price: {
    __typename?: "ProductColorPriceLevels";
    id: string;
    levels: Array<{
      __typename?: "PriceLevel";
      id: string;
      source?: CurrencyFilter | null;
      currency: string;
      wholesale: string | number;
      retail: string | number;
    }>;
  };
};

export type AlProductFragment = {
  __typename?: "Style";
  id: string;
  name?: string | null;
  images: {
    __typename?: "ImageConnection";
    edges: Array<{
      __typename?: "ImageEdge";
      node: {
        __typename?: "Image";
        id: string;
        url: any;
        owner?: { __typename?: "ImageOwnerAccount"; id: string } | null;
      };
    }>;
  };
  details: {
    __typename?: "StyleDetails";
    fabrication?: { __typename?: "Fabrication"; name: string } | null;
    materials?: Array<{ __typename?: "Material"; name: string } | null> | null;
  };
};

export type AlRowFragment = {
  __typename?: "AssortmentSKUEdge";
  _id: string;
  product: {
    __typename?: "Style";
    id: string;
    name?: string | null;
    images: {
      __typename?: "ImageConnection";
      edges: Array<{
        __typename?: "ImageEdge";
        node: {
          __typename?: "Image";
          id: string;
          url: any;
          owner?: { __typename?: "ImageOwnerAccount"; id: string } | null;
        };
      }>;
    };
    details: {
      __typename?: "StyleDetails";
      fabrication?: { __typename?: "Fabrication"; name: string } | null;
      materials?: Array<{
        __typename?: "Material";
        name: string;
      } | null> | null;
    };
  };
  color: {
    __typename?: "AssortmentSKUColor";
    id: string;
    name: string;
    images: {
      __typename?: "ImageConnection";
      edges: Array<{
        __typename?: "ImageEdge";
        node: {
          __typename?: "Image";
          id: string;
          url: any;
          owner?: { __typename?: "ImageOwnerAccount"; id: string } | null;
        };
      }>;
    };
    swatch: {
      __typename?: "ColorSwatch";
      hex?: string | null;
      rgb?: {
        __typename?: "RGB";
        red: number;
        green: number;
        blue: number;
      } | null;
      image?: {
        __typename?: "ImageEdge";
        node: {
          __typename?: "Image";
          id: string;
          url: any;
          owner?: { __typename?: "ImageOwnerAccount"; id: string } | null;
        };
      } | null;
    };
    attributes: {
      __typename?: "AttributeOptionConnection";
      edges?: Array<{
        __typename?: "AttributeOptionEdge";
        node?: {
          __typename?: "AttributeOption";
          id: string;
          code: string;
          name: string;
          attribute: {
            __typename?: "AttributeEdge";
            node?: {
              __typename?: "Attribute";
              id: string;
              name: string;
              position: number;
              isRequired: boolean;
              type: AttributeType;
              isMultiSelect: boolean;
              parent?: {
                __typename?: "AttributeEdge";
                node?: { __typename?: "Attribute"; id: string } | null;
              } | null;
            } | null;
          };
        } | null;
      }> | null;
    };
    required: {
      __typename?: "AttributeConnection";
      edges?: Array<{
        __typename?: "AttributeEdge";
        node?: {
          __typename?: "Attribute";
          id: string;
          name: string;
          position: number;
          isRequired: boolean;
          type: AttributeType;
          isMultiSelect: boolean;
          parent?: {
            __typename?: "AttributeEdge";
            node?: { __typename?: "Attribute"; id: string } | null;
          } | null;
        } | null;
      }> | null;
    };
    skus: Array<{
      __typename?: "AssortmentSKUEdge";
      _id: string;
      catalogSku: {
        __typename?: "SKU";
        id: string;
        size: { __typename?: "Size"; id: string; name: string };
      };
    }>;
    price: {
      __typename?: "ProductColorPriceLevels";
      id: string;
      levels: Array<{
        __typename?: "PriceLevel";
        id: string;
        source?: CurrencyFilter | null;
        currency: string;
        wholesale: string | number;
        retail: string | number;
      }>;
    };
  };
};

export type AlTableRowsQueryVariables = Exact<{
  workspaceId: Scalars["ID"];
}>;

export type AlTableRowsQuery = {
  __typename?: "Query";
  workspace?: {
    __typename?: "Assortment";
    id: string;
    skus: {
      __typename?: "AssortmentSKUConnection";
      edges?: Array<{
        __typename?: "AssortmentSKUEdge";
        _id: string;
        product: {
          __typename?: "Style";
          id: string;
          name?: string | null;
          images: {
            __typename?: "ImageConnection";
            edges: Array<{
              __typename?: "ImageEdge";
              node: {
                __typename?: "Image";
                id: string;
                url: any;
                owner?: { __typename?: "ImageOwnerAccount"; id: string } | null;
              };
            }>;
          };
          details: {
            __typename?: "StyleDetails";
            fabrication?: { __typename?: "Fabrication"; name: string } | null;
            materials?: Array<{
              __typename?: "Material";
              name: string;
            } | null> | null;
          };
        };
        color: {
          __typename?: "AssortmentSKUColor";
          id: string;
          name: string;
          images: {
            __typename?: "ImageConnection";
            edges: Array<{
              __typename?: "ImageEdge";
              node: {
                __typename?: "Image";
                id: string;
                url: any;
                owner?: { __typename?: "ImageOwnerAccount"; id: string } | null;
              };
            }>;
          };
          swatch: {
            __typename?: "ColorSwatch";
            hex?: string | null;
            rgb?: {
              __typename?: "RGB";
              red: number;
              green: number;
              blue: number;
            } | null;
            image?: {
              __typename?: "ImageEdge";
              node: {
                __typename?: "Image";
                id: string;
                url: any;
                owner?: { __typename?: "ImageOwnerAccount"; id: string } | null;
              };
            } | null;
          };
          attributes: {
            __typename?: "AttributeOptionConnection";
            edges?: Array<{
              __typename?: "AttributeOptionEdge";
              node?: {
                __typename?: "AttributeOption";
                id: string;
                code: string;
                name: string;
                attribute: {
                  __typename?: "AttributeEdge";
                  node?: {
                    __typename?: "Attribute";
                    id: string;
                    name: string;
                    position: number;
                    isRequired: boolean;
                    type: AttributeType;
                    isMultiSelect: boolean;
                    parent?: {
                      __typename?: "AttributeEdge";
                      node?: { __typename?: "Attribute"; id: string } | null;
                    } | null;
                  } | null;
                };
              } | null;
            }> | null;
          };
          required: {
            __typename?: "AttributeConnection";
            edges?: Array<{
              __typename?: "AttributeEdge";
              node?: {
                __typename?: "Attribute";
                id: string;
                name: string;
                position: number;
                isRequired: boolean;
                type: AttributeType;
                isMultiSelect: boolean;
                parent?: {
                  __typename?: "AttributeEdge";
                  node?: { __typename?: "Attribute"; id: string } | null;
                } | null;
              } | null;
            }> | null;
          };
          skus: Array<{
            __typename?: "AssortmentSKUEdge";
            _id: string;
            catalogSku: {
              __typename?: "SKU";
              id: string;
              size: { __typename?: "Size"; id: string; name: string };
            };
          }>;
          price: {
            __typename?: "ProductColorPriceLevels";
            id: string;
            levels: Array<{
              __typename?: "PriceLevel";
              id: string;
              source?: CurrencyFilter | null;
              currency: string;
              wholesale: string | number;
              retail: string | number;
            }>;
          };
        };
      }> | null;
    };
  } | null;
};

export type AccountSeasonsQueryVariables = Exact<{ [key: string]: never }>;

export type AccountSeasonsQuery = {
  __typename?: "Query";
  seasons: {
    __typename?: "SeasonConnection";
    edges: Array<{
      __typename?: "SeasonEdge";
      node: {
        __typename?: "Season";
        id: string;
        code: string;
        name: string;
        year?: number | null;
      };
    }>;
  };
};

export type AddColorsToAssortmentProductMutationVariables = Exact<{
  input: AssortmentUi__BulkAddColorsToAssortmentProductRequest;
}>;

export type AddColorsToAssortmentProductMutation = {
  __typename?: "Mutation";
  AssortmentUI__bulkAddColorsToAssortmentProduct: {
    __typename?: "AssortmentUI__BulkAddColorsToAssortmentProductResponse";
    assortment?: {
      __typename?: "Assortment";
      id: string;
      financialOverview: {
        __typename?: "AssortmentFinancialOverview";
        assortmentCurrencyCode: string;
        linesheetCurrencyCode: string;
        assortmentUnits: {
          __typename?: "AssortmentUnits";
          productCount?: number | null;
          colorCount?: number | null;
          skuCount?: number | null;
          unitCount?: number | null;
          unitDepth?: string | null;
        };
        financialDetails: Array<{
          __typename?: "AssortmentFinancialDetails";
          currencyCode: string;
          isBrandCurrency?: boolean | null;
          priceLevels: Array<{
            __typename?: "FinancialPriceLevel";
            name: FinancialPriceLevelName;
            initialMarkup: string | number;
            cost: { __typename?: "Money"; value: string | number };
            retail: { __typename?: "Money"; value: string | number };
            extendedCost: { __typename?: "Money"; value: string | number };
            extendedRetail: { __typename?: "Money"; value: string | number };
            averageUnitCost: { __typename?: "Money"; value: string | number };
            averageUnitRetail: { __typename?: "Money"; value: string | number };
          }>;
          units: {
            __typename?: "AssortmentUnits";
            productCount?: number | null;
            colorCount?: number | null;
            skuCount?: number | null;
            unitCount?: number | null;
            unitDepth?: string | null;
          };
        }>;
        financialTargets: {
          __typename?: "AssortmentFinancialTargets";
          priceTargets: {
            __typename?: "AssortmentFinancialPriceTargets";
            initialMarkup?: string | number | null;
            cost?: { __typename?: "Money"; value: string | number } | null;
            retail?: { __typename?: "Money"; value: string | number } | null;
            averageUnitCost?: {
              __typename?: "Money";
              value: string | number;
            } | null;
            averageUnitRetail?: {
              __typename?: "Money";
              value: string | number;
            } | null;
          };
          priceTargetsVariance: {
            __typename?: "AssortmentFinancialPriceTargets";
            initialMarkup?: string | number | null;
            cost?: { __typename?: "Money"; value: string | number } | null;
            retail?: { __typename?: "Money"; value: string | number } | null;
            averageUnitCost?: {
              __typename?: "Money";
              value: string | number;
            } | null;
            averageUnitRetail?: {
              __typename?: "Money";
              value: string | number;
            } | null;
          };
        };
      };
      validationRequirements: Array<{
        __typename?: "Validation";
        field: AssortmentValidationField;
        valid: boolean;
      }>;
      attributeValidationRequirements: Array<{
        __typename?: "AttributeValidation";
        valid: boolean;
        attribute: { __typename?: "Attribute"; id: string };
      }>;
      doorClusters: {
        __typename?: "AssortmentDoorClusterConnection";
        edges?: Array<{
          __typename?: "AssortmentDoorClusterEdge";
          node?: {
            __typename?: "DoorCluster";
            id: string;
            name?: string | null;
            code?: string | null;
            doors?: {
              __typename?: "DoorClusterDoorConnection";
              edges?: Array<{
                __typename?: "DoorClusterDoorEdge";
                node?: {
                  __typename?: "Door";
                  id: string;
                  name: string;
                  code: string;
                } | null;
              }> | null;
            } | null;
          } | null;
        }> | null;
      };
      doors: {
        __typename?: "AssortmentDoorConnection";
        edges?: Array<{
          __typename?: "AssortmentDoorEdge";
          node?: {
            __typename?: "Door";
            id: string;
            name: string;
            code: string;
          } | null;
        }> | null;
      };
      skus: {
        __typename?: "AssortmentSKUConnection";
        edges?: Array<{
          __typename?: "AssortmentSKUEdge";
          _id: string;
          legacyItemId: string;
          comment?: string | null;
          isCustom?: boolean | null;
          upc?: string | null;
          wholesaleCurrencyCode?: string | null;
          retailCurrencyCode?: string | null;
          bulkQuantity: number;
          node: {
            __typename?: "SKU";
            id: string;
            color: { __typename?: "Color"; id: string };
            size: {
              __typename?: "Size";
              id: string;
              code: string;
              name: string;
            };
          };
          style: {
            __typename?: "Style";
            name?: string | null;
            code?: string | null;
            id: string;
            description?: string | null;
            images: {
              __typename?: "ImageConnection";
              edges: Array<{
                __typename?: "ImageEdge";
                node: {
                  __typename?: "Image";
                  id: string;
                  url: any;
                  owner?: {
                    __typename?: "ImageOwnerAccount";
                    id: string;
                  } | null;
                };
              }>;
            };
            details: {
              __typename?: "StyleDetails";
              countryOfOrigin?: string | null;
              furStatus?: FurStatus | null;
              heelHeight?: string | null;
              measurements?: string | null;
              modelHeightInches?: number | null;
              sourceOfMaterials?: string | null;
              categories: Array<{
                __typename?: "Category";
                id?: string | null;
                name: string;
              }>;
              materials?: Array<{
                __typename?: "Material";
                name: string;
              } | null> | null;
              silhouette?: { __typename?: "Silhouette"; name: string } | null;
              fabrication?: { __typename?: "Fabrication"; name: string } | null;
            };
          };
          color: {
            __typename?: "AssortmentSKUColor";
            id: string;
            name: string;
            code: string;
            comment?: string | null;
            totalSizedQuantity: number;
            bulkQuantity: number;
            swatch: {
              __typename?: "ColorSwatch";
              hex?: string | null;
              rgb?: {
                __typename?: "RGB";
                red: number;
                green: number;
                blue: number;
              } | null;
              image?: {
                __typename?: "ImageEdge";
                node: {
                  __typename?: "Image";
                  id: string;
                  url: any;
                  owner?: {
                    __typename?: "ImageOwnerAccount";
                    id: string;
                  } | null;
                };
              } | null;
            };
            images: {
              __typename?: "ImageConnection";
              edges: Array<{
                __typename?: "ImageEdge";
                node: {
                  __typename?: "Image";
                  id: string;
                  url: any;
                  owner?: {
                    __typename?: "ImageOwnerAccount";
                    id: string;
                  } | null;
                };
              }>;
            };
            doorQuantities: Array<{
              __typename?: "AssortmentSKUColorDoorQuantity";
              id: string;
              bulkQuantity: number;
              totalSizedQuantity: number;
              door?: { __typename?: "Door"; id: string } | null;
            }>;
            attributeOptions: {
              __typename?: "AttributeOptionConnection";
              edges?: Array<{
                __typename?: "AttributeOptionEdge";
                node?: {
                  __typename?: "AttributeOption";
                  id: string;
                  value: string;
                  attribute: {
                    __typename?: "AttributeEdge";
                    node?: {
                      __typename?: "Attribute";
                      id: string;
                      name: string;
                    } | null;
                  };
                } | null;
              }> | null;
            };
            sizeCurves: {
              __typename?: "RetailSizeCurves";
              missingFields: Array<RetailSizeCurvesMissingFields>;
              doorSizeCurves: Array<{
                __typename?: "RetailDoorSizeCurves";
                door: { __typename?: "Door"; id: string };
                curveRatios: Array<{
                  __typename?: "SizeCurveRatio";
                  ratio: string | number;
                  retailSize: {
                    __typename?: "RetailSize";
                    id: string;
                    code?: string | null;
                    name?: string | null;
                  };
                }>;
              }>;
            };
          };
          size: { __typename?: "Size"; id: string; code: string; name: string };
          sizeRun?: {
            __typename?: "SizeRunEdge";
            node?: {
              __typename?: "SizeRun";
              id: string;
              code?: string | null;
              name?: string | null;
            } | null;
          } | null;
          retailSize?: {
            __typename?: "RetailSize";
            code?: string | null;
            id: string;
            name?: string | null;
          } | null;
          availableRetailSizeOptions: Array<{
            __typename?: "RetailSize";
            code?: string | null;
            id: string;
            name?: string | null;
          }>;
          priceLevels: Array<{
            __typename?: "PriceLevel";
            id: string;
            name: FinancialPriceLevelName;
            extendedWholesale: string | number;
            extendedRetail: string | number;
            maxRetail: string | number;
            maxWholesale: string | number;
            currencyCode: string;
            currencySource?: CurrencyFilter | null;
          }>;
          doorQuantities: Array<{
            __typename?: "AssortmentSKUDoorQuantity";
            id: string;
            quantity: number;
            appliedSizeRatio?: string | number | null;
            door?: { __typename?: "Door"; id: string } | null;
          }>;
        }> | null;
      };
    } | null;
  };
};

export type ApplyAttributeOptionsMutationVariables = Exact<{
  assortmentSkuIds: Array<Scalars["ID"]> | Scalars["ID"];
  input: ApplyAssortmentSkuAttributesInput;
}>;

export type ApplyAttributeOptionsMutation = {
  __typename?: "Mutation";
  applyAssortmentSkuColorAttributes: {
    __typename?: "ApplyAssortmentSkuColorAttributesPayload";
    query: {
      __typename?: "Query";
      assortmentSkus: {
        __typename?: "AssortmentSKUConnection";
        edges?: Array<{
          __typename?: "AssortmentSKUEdge";
          _id: string;
          color: {
            __typename?: "AssortmentSKUColor";
            id: string;
            sizeCurves: {
              __typename?: "RetailSizeCurves";
              missingFields: Array<RetailSizeCurvesMissingFields>;
              doorSizeCurves: Array<{
                __typename?: "RetailDoorSizeCurves";
                door: { __typename?: "Door"; id: string };
                curveRatios: Array<{
                  __typename?: "SizeCurveRatio";
                  ratio: string | number;
                  retailSize: {
                    __typename?: "RetailSize";
                    id: string;
                    code?: string | null;
                    name?: string | null;
                  };
                }>;
              }>;
            };
            attributeOptions: {
              __typename?: "AttributeOptionConnection";
              edges?: Array<{
                __typename?: "AttributeOptionEdge";
                node?: {
                  __typename?: "AttributeOption";
                  id: string;
                  value: string;
                  attribute: {
                    __typename?: "AttributeEdge";
                    node?: {
                      __typename?: "Attribute";
                      id: string;
                      name: string;
                    } | null;
                  };
                } | null;
              }> | null;
            };
            missingRequiredAttributes: {
              __typename?: "AttributeConnection";
              edges?: Array<{
                __typename?: "AttributeEdge";
                node?: {
                  __typename?: "Attribute";
                  id: string;
                  name: string;
                } | null;
              }> | null;
            };
          };
        }> | null;
      };
    };
    colors?: Array<{
      __typename?: "AssortmentSKUColor";
      id: string;
      attributeOptions: {
        __typename?: "AttributeOptionConnection";
        edges?: Array<{
          __typename?: "AttributeOptionEdge";
          node?: {
            __typename?: "AttributeOption";
            id: string;
            value: string;
            attribute: {
              __typename?: "AttributeEdge";
              node?: {
                __typename?: "Attribute";
                id: string;
                name: string;
              } | null;
            };
          } | null;
        }> | null;
      };
    }> | null;
  };
};

export type ApplySizeCurveToDoorColorsMutationVariables = Exact<{
  input: ApplySizeCurveToDoorColorsRequest;
  assortmentSkuIds: Array<Scalars["ID"]> | Scalars["ID"];
}>;

export type ApplySizeCurveToDoorColorsMutation = {
  __typename?: "Mutation";
  applySizeCurveToDoorColors: {
    __typename?: "ApplySizeCurveToDoorColorsResponse";
    query?: {
      __typename?: "Query";
      assortmentSkus: {
        __typename?: "AssortmentSKUConnection";
        edges?: Array<{
          __typename?: "AssortmentSKUEdge";
          _id: string;
          node: { __typename?: "SKU"; id: string };
          color: {
            __typename?: "AssortmentSKUColor";
            id: string;
            bulkQuantity: number;
            totalSizedQuantity: number;
            doorQuantities: Array<{
              __typename?: "AssortmentSKUColorDoorQuantity";
              id: string;
              bulkQuantity: number;
              totalSizedQuantity: number;
              door?: { __typename?: "Door"; id: string } | null;
            }>;
          };
          priceLevels: Array<{
            __typename?: "PriceLevel";
            id: string;
            name: FinancialPriceLevelName;
            extendedWholesale: string | number;
            extendedRetail: string | number;
            maxRetail: string | number;
            maxWholesale: string | number;
            currencyCode: string;
            currencySource?: CurrencyFilter | null;
          }>;
          doorQuantities: Array<{
            __typename?: "AssortmentSKUDoorQuantity";
            id: string;
            quantity: number;
            appliedSizeRatio?: string | number | null;
            door?: { __typename?: "Door"; id: string } | null;
          }>;
        }> | null;
      };
    } | null;
  };
};

export type AssortmentQueryVariables = Exact<{
  assortmentId: Scalars["ID"];
}>;

export type AssortmentQuery = {
  __typename?: "Query";
  assortment?: {
    __typename?: "Assortment";
    id: string;
    name: string;
    retailer: {
      __typename?: "RetailerEdge";
      node?: {
        __typename?: "Retailer";
        id: string;
        itemColorAttributes: {
          __typename?: "AttributeConnection";
          edges?: Array<{
            __typename?: "AttributeEdge";
            node?: {
              __typename?: "Attribute";
              id: string;
              name: string;
              isRequired: boolean;
            } | null;
          }> | null;
        };
      } | null;
    };
    brand?: {
      __typename?: "RetailerBrandEdge";
      id: string;
      code?: string | null;
      alias?: string | null;
      node?: { __typename?: "Brand"; id: string; name: string } | null;
    } | null;
    skus: {
      __typename?: "AssortmentSKUConnection";
      edges?: Array<{
        __typename?: "AssortmentSKUEdge";
        _id: string;
        legacyItemId: string;
        comment?: string | null;
        isCustom?: boolean | null;
        upc?: string | null;
        wholesaleCurrencyCode?: string | null;
        retailCurrencyCode?: string | null;
        bulkQuantity: number;
        node: {
          __typename?: "SKU";
          id: string;
          color: { __typename?: "Color"; id: string };
          size: { __typename?: "Size"; id: string; code: string; name: string };
        };
        style: {
          __typename?: "Style";
          name?: string | null;
          code?: string | null;
          id: string;
          description?: string | null;
          images: {
            __typename?: "ImageConnection";
            edges: Array<{
              __typename?: "ImageEdge";
              node: {
                __typename?: "Image";
                id: string;
                url: any;
                owner?: { __typename?: "ImageOwnerAccount"; id: string } | null;
              };
            }>;
          };
          details: {
            __typename?: "StyleDetails";
            countryOfOrigin?: string | null;
            furStatus?: FurStatus | null;
            heelHeight?: string | null;
            measurements?: string | null;
            modelHeightInches?: number | null;
            sourceOfMaterials?: string | null;
            categories: Array<{
              __typename?: "Category";
              id?: string | null;
              name: string;
            }>;
            materials?: Array<{
              __typename?: "Material";
              name: string;
            } | null> | null;
            silhouette?: { __typename?: "Silhouette"; name: string } | null;
            fabrication?: { __typename?: "Fabrication"; name: string } | null;
          };
        };
        color: {
          __typename?: "AssortmentSKUColor";
          id: string;
          name: string;
          code: string;
          comment?: string | null;
          totalSizedQuantity: number;
          bulkQuantity: number;
          swatch: {
            __typename?: "ColorSwatch";
            hex?: string | null;
            rgb?: {
              __typename?: "RGB";
              red: number;
              green: number;
              blue: number;
            } | null;
            image?: {
              __typename?: "ImageEdge";
              node: {
                __typename?: "Image";
                id: string;
                url: any;
                owner?: { __typename?: "ImageOwnerAccount"; id: string } | null;
              };
            } | null;
          };
          images: {
            __typename?: "ImageConnection";
            edges: Array<{
              __typename?: "ImageEdge";
              node: {
                __typename?: "Image";
                id: string;
                url: any;
                owner?: { __typename?: "ImageOwnerAccount"; id: string } | null;
              };
            }>;
          };
          doorQuantities: Array<{
            __typename?: "AssortmentSKUColorDoorQuantity";
            id: string;
            bulkQuantity: number;
            totalSizedQuantity: number;
            door?: { __typename?: "Door"; id: string } | null;
          }>;
          attributeOptions: {
            __typename?: "AttributeOptionConnection";
            edges?: Array<{
              __typename?: "AttributeOptionEdge";
              node?: {
                __typename?: "AttributeOption";
                id: string;
                value: string;
                attribute: {
                  __typename?: "AttributeEdge";
                  node?: {
                    __typename?: "Attribute";
                    id: string;
                    name: string;
                  } | null;
                };
              } | null;
            }> | null;
          };
          sizeCurves: {
            __typename?: "RetailSizeCurves";
            missingFields: Array<RetailSizeCurvesMissingFields>;
            doorSizeCurves: Array<{
              __typename?: "RetailDoorSizeCurves";
              door: { __typename?: "Door"; id: string };
              curveRatios: Array<{
                __typename?: "SizeCurveRatio";
                ratio: string | number;
                retailSize: {
                  __typename?: "RetailSize";
                  id: string;
                  code?: string | null;
                  name?: string | null;
                };
              }>;
            }>;
          };
        };
        size: { __typename?: "Size"; id: string; code: string; name: string };
        sizeRun?: {
          __typename?: "SizeRunEdge";
          node?: {
            __typename?: "SizeRun";
            id: string;
            code?: string | null;
            name?: string | null;
          } | null;
        } | null;
        retailSize?: {
          __typename?: "RetailSize";
          code?: string | null;
          id: string;
          name?: string | null;
        } | null;
        availableRetailSizeOptions: Array<{
          __typename?: "RetailSize";
          code?: string | null;
          id: string;
          name?: string | null;
        }>;
        priceLevels: Array<{
          __typename?: "PriceLevel";
          id: string;
          name: FinancialPriceLevelName;
          extendedWholesale: string | number;
          extendedRetail: string | number;
          maxRetail: string | number;
          maxWholesale: string | number;
          currencyCode: string;
          currencySource?: CurrencyFilter | null;
        }>;
        doorQuantities: Array<{
          __typename?: "AssortmentSKUDoorQuantity";
          id: string;
          quantity: number;
          appliedSizeRatio?: string | number | null;
          door?: { __typename?: "Door"; id: string } | null;
        }>;
      }> | null;
    };
    doorClusters: {
      __typename?: "AssortmentDoorClusterConnection";
      edges?: Array<{
        __typename?: "AssortmentDoorClusterEdge";
        node?: {
          __typename?: "DoorCluster";
          id: string;
          name?: string | null;
          code?: string | null;
          doors?: {
            __typename?: "DoorClusterDoorConnection";
            edges?: Array<{
              __typename?: "DoorClusterDoorEdge";
              node?: {
                __typename?: "Door";
                id: string;
                name: string;
                code: string;
              } | null;
            }> | null;
          } | null;
        } | null;
      }> | null;
    };
    doors: {
      __typename?: "AssortmentDoorConnection";
      edges?: Array<{
        __typename?: "AssortmentDoorEdge";
        node?: {
          __typename?: "Door";
          id: string;
          name: string;
          code: string;
        } | null;
      }> | null;
    };
    doorRuns: {
      __typename?: "AssortmentDoorRunConnection";
      edges?: Array<{
        __typename?: "AssortmentDoorRunEdge";
        node?: {
          __typename?: "AssortmentDoorRun";
          id: string;
          orderNbr?: number | null;
        } | null;
      }> | null;
    };
    financialOverview: {
      __typename?: "AssortmentFinancialOverview";
      assortmentCurrencyCode: string;
      linesheetCurrencyCode: string;
      assortmentUnits: {
        __typename?: "AssortmentUnits";
        productCount?: number | null;
        colorCount?: number | null;
        skuCount?: number | null;
        unitCount?: number | null;
        unitDepth?: string | null;
      };
      financialDetails: Array<{
        __typename?: "AssortmentFinancialDetails";
        currencyCode: string;
        isBrandCurrency?: boolean | null;
        priceLevels: Array<{
          __typename?: "FinancialPriceLevel";
          name: FinancialPriceLevelName;
          initialMarkup: string | number;
          cost: { __typename?: "Money"; value: string | number };
          retail: { __typename?: "Money"; value: string | number };
          extendedCost: { __typename?: "Money"; value: string | number };
          extendedRetail: { __typename?: "Money"; value: string | number };
          averageUnitCost: { __typename?: "Money"; value: string | number };
          averageUnitRetail: { __typename?: "Money"; value: string | number };
        }>;
        units: {
          __typename?: "AssortmentUnits";
          productCount?: number | null;
          colorCount?: number | null;
          skuCount?: number | null;
          unitCount?: number | null;
          unitDepth?: string | null;
        };
      }>;
      financialTargets: {
        __typename?: "AssortmentFinancialTargets";
        priceTargets: {
          __typename?: "AssortmentFinancialPriceTargets";
          initialMarkup?: string | number | null;
          cost?: { __typename?: "Money"; value: string | number } | null;
          retail?: { __typename?: "Money"; value: string | number } | null;
          averageUnitCost?: {
            __typename?: "Money";
            value: string | number;
          } | null;
          averageUnitRetail?: {
            __typename?: "Money";
            value: string | number;
          } | null;
        };
        priceTargetsVariance: {
          __typename?: "AssortmentFinancialPriceTargets";
          initialMarkup?: string | number | null;
          cost?: { __typename?: "Money"; value: string | number } | null;
          retail?: { __typename?: "Money"; value: string | number } | null;
          averageUnitCost?: {
            __typename?: "Money";
            value: string | number;
          } | null;
          averageUnitRetail?: {
            __typename?: "Money";
            value: string | number;
          } | null;
        };
      };
    };
    validationRequirements: Array<{
      __typename?: "Validation";
      field: AssortmentValidationField;
      valid: boolean;
    }>;
    attributeValidationRequirements: Array<{
      __typename?: "AttributeValidation";
      valid: boolean;
      attribute: { __typename?: "Attribute"; id: string };
    }>;
  } | null;
};

export type AssortmentColorDoorQuantitiesFragment = {
  __typename?: "AssortmentSKUColor";
  doorQuantities: Array<{
    __typename?: "AssortmentSKUColorDoorQuantity";
    id: string;
    bulkQuantity: number;
    totalSizedQuantity: number;
    door?: { __typename?: "Door"; id: string } | null;
  }>;
};

export type AssortmentFinancialsAndSkusQueryVariables = Exact<{
  assortmentId: Scalars["ID"];
}>;

export type AssortmentFinancialsAndSkusQuery = {
  __typename?: "Query";
  assortment?: {
    __typename?: "Assortment";
    id: string;
    skus: {
      __typename?: "AssortmentSKUConnection";
      edges?: Array<{
        __typename?: "AssortmentSKUEdge";
        _id: string;
        legacyItemId: string;
        comment?: string | null;
        isCustom?: boolean | null;
        upc?: string | null;
        wholesaleCurrencyCode?: string | null;
        retailCurrencyCode?: string | null;
        bulkQuantity: number;
        node: {
          __typename?: "SKU";
          id: string;
          color: { __typename?: "Color"; id: string };
          size: { __typename?: "Size"; id: string; code: string; name: string };
        };
        style: {
          __typename?: "Style";
          name?: string | null;
          code?: string | null;
          id: string;
          description?: string | null;
          images: {
            __typename?: "ImageConnection";
            edges: Array<{
              __typename?: "ImageEdge";
              node: {
                __typename?: "Image";
                id: string;
                url: any;
                owner?: { __typename?: "ImageOwnerAccount"; id: string } | null;
              };
            }>;
          };
          details: {
            __typename?: "StyleDetails";
            countryOfOrigin?: string | null;
            furStatus?: FurStatus | null;
            heelHeight?: string | null;
            measurements?: string | null;
            modelHeightInches?: number | null;
            sourceOfMaterials?: string | null;
            categories: Array<{
              __typename?: "Category";
              id?: string | null;
              name: string;
            }>;
            materials?: Array<{
              __typename?: "Material";
              name: string;
            } | null> | null;
            silhouette?: { __typename?: "Silhouette"; name: string } | null;
            fabrication?: { __typename?: "Fabrication"; name: string } | null;
          };
        };
        color: {
          __typename?: "AssortmentSKUColor";
          id: string;
          name: string;
          code: string;
          comment?: string | null;
          totalSizedQuantity: number;
          bulkQuantity: number;
          swatch: {
            __typename?: "ColorSwatch";
            hex?: string | null;
            rgb?: {
              __typename?: "RGB";
              red: number;
              green: number;
              blue: number;
            } | null;
            image?: {
              __typename?: "ImageEdge";
              node: {
                __typename?: "Image";
                id: string;
                url: any;
                owner?: { __typename?: "ImageOwnerAccount"; id: string } | null;
              };
            } | null;
          };
          images: {
            __typename?: "ImageConnection";
            edges: Array<{
              __typename?: "ImageEdge";
              node: {
                __typename?: "Image";
                id: string;
                url: any;
                owner?: { __typename?: "ImageOwnerAccount"; id: string } | null;
              };
            }>;
          };
          doorQuantities: Array<{
            __typename?: "AssortmentSKUColorDoorQuantity";
            id: string;
            bulkQuantity: number;
            totalSizedQuantity: number;
            door?: { __typename?: "Door"; id: string } | null;
          }>;
          attributeOptions: {
            __typename?: "AttributeOptionConnection";
            edges?: Array<{
              __typename?: "AttributeOptionEdge";
              node?: {
                __typename?: "AttributeOption";
                id: string;
                value: string;
                attribute: {
                  __typename?: "AttributeEdge";
                  node?: {
                    __typename?: "Attribute";
                    id: string;
                    name: string;
                  } | null;
                };
              } | null;
            }> | null;
          };
          sizeCurves: {
            __typename?: "RetailSizeCurves";
            missingFields: Array<RetailSizeCurvesMissingFields>;
            doorSizeCurves: Array<{
              __typename?: "RetailDoorSizeCurves";
              door: { __typename?: "Door"; id: string };
              curveRatios: Array<{
                __typename?: "SizeCurveRatio";
                ratio: string | number;
                retailSize: {
                  __typename?: "RetailSize";
                  id: string;
                  code?: string | null;
                  name?: string | null;
                };
              }>;
            }>;
          };
        };
        size: { __typename?: "Size"; id: string; code: string; name: string };
        sizeRun?: {
          __typename?: "SizeRunEdge";
          node?: {
            __typename?: "SizeRun";
            id: string;
            code?: string | null;
            name?: string | null;
          } | null;
        } | null;
        retailSize?: {
          __typename?: "RetailSize";
          code?: string | null;
          id: string;
          name?: string | null;
        } | null;
        availableRetailSizeOptions: Array<{
          __typename?: "RetailSize";
          code?: string | null;
          id: string;
          name?: string | null;
        }>;
        priceLevels: Array<{
          __typename?: "PriceLevel";
          id: string;
          name: FinancialPriceLevelName;
          extendedWholesale: string | number;
          extendedRetail: string | number;
          maxRetail: string | number;
          maxWholesale: string | number;
          currencyCode: string;
          currencySource?: CurrencyFilter | null;
        }>;
        doorQuantities: Array<{
          __typename?: "AssortmentSKUDoorQuantity";
          id: string;
          quantity: number;
          appliedSizeRatio?: string | number | null;
          door?: { __typename?: "Door"; id: string } | null;
        }>;
      }> | null;
    };
    financialOverview: {
      __typename?: "AssortmentFinancialOverview";
      assortmentCurrencyCode: string;
      linesheetCurrencyCode: string;
      assortmentUnits: {
        __typename?: "AssortmentUnits";
        productCount?: number | null;
        colorCount?: number | null;
        skuCount?: number | null;
        unitCount?: number | null;
        unitDepth?: string | null;
      };
      financialDetails: Array<{
        __typename?: "AssortmentFinancialDetails";
        currencyCode: string;
        isBrandCurrency?: boolean | null;
        priceLevels: Array<{
          __typename?: "FinancialPriceLevel";
          name: FinancialPriceLevelName;
          initialMarkup: string | number;
          cost: { __typename?: "Money"; value: string | number };
          retail: { __typename?: "Money"; value: string | number };
          extendedCost: { __typename?: "Money"; value: string | number };
          extendedRetail: { __typename?: "Money"; value: string | number };
          averageUnitCost: { __typename?: "Money"; value: string | number };
          averageUnitRetail: { __typename?: "Money"; value: string | number };
        }>;
        units: {
          __typename?: "AssortmentUnits";
          productCount?: number | null;
          colorCount?: number | null;
          skuCount?: number | null;
          unitCount?: number | null;
          unitDepth?: string | null;
        };
      }>;
      financialTargets: {
        __typename?: "AssortmentFinancialTargets";
        priceTargets: {
          __typename?: "AssortmentFinancialPriceTargets";
          initialMarkup?: string | number | null;
          cost?: { __typename?: "Money"; value: string | number } | null;
          retail?: { __typename?: "Money"; value: string | number } | null;
          averageUnitCost?: {
            __typename?: "Money";
            value: string | number;
          } | null;
          averageUnitRetail?: {
            __typename?: "Money";
            value: string | number;
          } | null;
        };
        priceTargetsVariance: {
          __typename?: "AssortmentFinancialPriceTargets";
          initialMarkup?: string | number | null;
          cost?: { __typename?: "Money"; value: string | number } | null;
          retail?: { __typename?: "Money"; value: string | number } | null;
          averageUnitCost?: {
            __typename?: "Money";
            value: string | number;
          } | null;
          averageUnitRetail?: {
            __typename?: "Money";
            value: string | number;
          } | null;
        };
      };
    };
  } | null;
};

export type AssortmentSeasonsQueryVariables = Exact<{
  assortmentId: Scalars["ID"];
}>;

export type AssortmentSeasonsQuery = {
  __typename?: "Query";
  assortment?: {
    __typename?: "Assortment";
    id: string;
    retailer: {
      __typename?: "RetailerEdge";
      node?: {
        __typename?: "Retailer";
        id: string;
        seasons: {
          __typename?: "SeasonConnection";
          edges: Array<{
            __typename?: "SeasonEdge";
            node: {
              __typename?: "Season";
              id: string;
              name: string;
              code: string;
              year?: number | null;
            };
          }>;
        };
      } | null;
    };
  } | null;
};

export type SizeCurvesFragment = {
  __typename?: "AssortmentSKUColor";
  sizeCurves: {
    __typename?: "RetailSizeCurves";
    missingFields: Array<RetailSizeCurvesMissingFields>;
    doorSizeCurves: Array<{
      __typename?: "RetailDoorSizeCurves";
      door: { __typename?: "Door"; id: string };
      curveRatios: Array<{
        __typename?: "SizeCurveRatio";
        ratio: string | number;
        retailSize: {
          __typename?: "RetailSize";
          id: string;
          code?: string | null;
          name?: string | null;
        };
      }>;
    }>;
  };
};

export type AssortmentSizeCurvesQueryVariables = Exact<{
  assortmentId: Scalars["ID"];
}>;

export type AssortmentSizeCurvesQuery = {
  __typename?: "Query";
  assortment?: {
    __typename?: "Assortment";
    id: string;
    skus: {
      __typename?: "AssortmentSKUConnection";
      edges?: Array<{
        __typename?: "AssortmentSKUEdge";
        _id: string;
        color: {
          __typename?: "AssortmentSKUColor";
          id: string;
          sizeCurves: {
            __typename?: "RetailSizeCurves";
            missingFields: Array<RetailSizeCurvesMissingFields>;
            doorSizeCurves: Array<{
              __typename?: "RetailDoorSizeCurves";
              door: { __typename?: "Door"; id: string };
              curveRatios: Array<{
                __typename?: "SizeCurveRatio";
                ratio: string | number;
                retailSize: {
                  __typename?: "RetailSize";
                  id: string;
                  code?: string | null;
                  name?: string | null;
                };
              }>;
            }>;
          };
        };
      }> | null;
    };
  } | null;
};

export type AssortmentSkuDoorQuantitiesFragment = {
  __typename?: "AssortmentSKUEdge";
  doorQuantities: Array<{
    __typename?: "AssortmentSKUDoorQuantity";
    id: string;
    quantity: number;
    appliedSizeRatio?: string | number | null;
    door?: { __typename?: "Door"; id: string } | null;
  }>;
};

export type AssortmentSkuEdgeIDsQueryVariables = Exact<{
  assortmentId: Scalars["ID"];
}>;

export type AssortmentSkuEdgeIDsQuery = {
  __typename?: "Query";
  assortment?: {
    __typename?: "Assortment";
    id: string;
    skus: {
      __typename?: "AssortmentSKUConnection";
      edges?: Array<{ __typename?: "AssortmentSKUEdge"; _id: string }> | null;
    };
  } | null;
};

export type AssortmentSkusEdgesFragment = {
  __typename?: "Assortment";
  skus: {
    __typename?: "AssortmentSKUConnection";
    edges?: Array<{
      __typename?: "AssortmentSKUEdge";
      _id: string;
      legacyItemId: string;
      comment?: string | null;
      isCustom?: boolean | null;
      upc?: string | null;
      wholesaleCurrencyCode?: string | null;
      retailCurrencyCode?: string | null;
      bulkQuantity: number;
      node: {
        __typename?: "SKU";
        id: string;
        color: { __typename?: "Color"; id: string };
        size: { __typename?: "Size"; id: string; code: string; name: string };
      };
      style: {
        __typename?: "Style";
        name?: string | null;
        code?: string | null;
        id: string;
        description?: string | null;
        images: {
          __typename?: "ImageConnection";
          edges: Array<{
            __typename?: "ImageEdge";
            node: {
              __typename?: "Image";
              id: string;
              url: any;
              owner?: { __typename?: "ImageOwnerAccount"; id: string } | null;
            };
          }>;
        };
        details: {
          __typename?: "StyleDetails";
          countryOfOrigin?: string | null;
          furStatus?: FurStatus | null;
          heelHeight?: string | null;
          measurements?: string | null;
          modelHeightInches?: number | null;
          sourceOfMaterials?: string | null;
          categories: Array<{
            __typename?: "Category";
            id?: string | null;
            name: string;
          }>;
          materials?: Array<{
            __typename?: "Material";
            name: string;
          } | null> | null;
          silhouette?: { __typename?: "Silhouette"; name: string } | null;
          fabrication?: { __typename?: "Fabrication"; name: string } | null;
        };
      };
      color: {
        __typename?: "AssortmentSKUColor";
        id: string;
        name: string;
        code: string;
        comment?: string | null;
        totalSizedQuantity: number;
        bulkQuantity: number;
        swatch: {
          __typename?: "ColorSwatch";
          hex?: string | null;
          rgb?: {
            __typename?: "RGB";
            red: number;
            green: number;
            blue: number;
          } | null;
          image?: {
            __typename?: "ImageEdge";
            node: {
              __typename?: "Image";
              id: string;
              url: any;
              owner?: { __typename?: "ImageOwnerAccount"; id: string } | null;
            };
          } | null;
        };
        images: {
          __typename?: "ImageConnection";
          edges: Array<{
            __typename?: "ImageEdge";
            node: {
              __typename?: "Image";
              id: string;
              url: any;
              owner?: { __typename?: "ImageOwnerAccount"; id: string } | null;
            };
          }>;
        };
        doorQuantities: Array<{
          __typename?: "AssortmentSKUColorDoorQuantity";
          id: string;
          bulkQuantity: number;
          totalSizedQuantity: number;
          door?: { __typename?: "Door"; id: string } | null;
        }>;
        attributeOptions: {
          __typename?: "AttributeOptionConnection";
          edges?: Array<{
            __typename?: "AttributeOptionEdge";
            node?: {
              __typename?: "AttributeOption";
              id: string;
              value: string;
              attribute: {
                __typename?: "AttributeEdge";
                node?: {
                  __typename?: "Attribute";
                  id: string;
                  name: string;
                } | null;
              };
            } | null;
          }> | null;
        };
        sizeCurves: {
          __typename?: "RetailSizeCurves";
          missingFields: Array<RetailSizeCurvesMissingFields>;
          doorSizeCurves: Array<{
            __typename?: "RetailDoorSizeCurves";
            door: { __typename?: "Door"; id: string };
            curveRatios: Array<{
              __typename?: "SizeCurveRatio";
              ratio: string | number;
              retailSize: {
                __typename?: "RetailSize";
                id: string;
                code?: string | null;
                name?: string | null;
              };
            }>;
          }>;
        };
      };
      size: { __typename?: "Size"; id: string; code: string; name: string };
      sizeRun?: {
        __typename?: "SizeRunEdge";
        node?: {
          __typename?: "SizeRun";
          id: string;
          code?: string | null;
          name?: string | null;
        } | null;
      } | null;
      retailSize?: {
        __typename?: "RetailSize";
        code?: string | null;
        id: string;
        name?: string | null;
      } | null;
      availableRetailSizeOptions: Array<{
        __typename?: "RetailSize";
        code?: string | null;
        id: string;
        name?: string | null;
      }>;
      priceLevels: Array<{
        __typename?: "PriceLevel";
        id: string;
        name: FinancialPriceLevelName;
        extendedWholesale: string | number;
        extendedRetail: string | number;
        maxRetail: string | number;
        maxWholesale: string | number;
        currencyCode: string;
        currencySource?: CurrencyFilter | null;
      }>;
      doorQuantities: Array<{
        __typename?: "AssortmentSKUDoorQuantity";
        id: string;
        quantity: number;
        appliedSizeRatio?: string | number | null;
        door?: { __typename?: "Door"; id: string } | null;
      }>;
    }> | null;
  };
};

export type AssortmentSkusIsCustomQueryVariables = Exact<{
  assortmentId: Scalars["ID"];
}>;

export type AssortmentSkusIsCustomQuery = {
  __typename?: "Query";
  assortment?: {
    __typename?: "Assortment";
    id: string;
    skus: {
      __typename?: "AssortmentSKUConnection";
      edges?: Array<{
        __typename?: "AssortmentSKUEdge";
        _id: string;
        isCustom?: boolean | null;
      }> | null;
    };
  } | null;
};

export type AssortmentValidationRequirementsFragment = {
  __typename?: "Assortment";
  validationRequirements: Array<{
    __typename?: "Validation";
    field: AssortmentValidationField;
    valid: boolean;
  }>;
  attributeValidationRequirements: Array<{
    __typename?: "AttributeValidation";
    valid: boolean;
    attribute: { __typename?: "Attribute"; id: string };
  }>;
};

export type AssortmentValidationFieldsFragment = {
  __typename?: "Validation";
  field: AssortmentValidationField;
  valid: boolean;
};

export type AssortmentItemValidationFieldsFragment = {
  __typename?: "AttributeValidation";
  valid: boolean;
  attribute: { __typename?: "Attribute"; id: string };
};

export type AssortmentValidationRequirementsQueryVariables = Exact<{
  assortmentId: Scalars["ID"];
}>;

export type AssortmentValidationRequirementsQuery = {
  __typename?: "Query";
  assortment?: {
    __typename?: "Assortment";
    id: string;
    validationRequirements: Array<{
      __typename?: "Validation";
      field: AssortmentValidationField;
      valid: boolean;
    }>;
    attributeValidationRequirements: Array<{
      __typename?: "AttributeValidation";
      valid: boolean;
      attribute: { __typename?: "Attribute"; id: string };
    }>;
  } | null;
};

export type AttributeOptionsOnColorFragment = {
  __typename?: "AssortmentSKUColor";
  attributeOptions: {
    __typename?: "AttributeOptionConnection";
    edges?: Array<{
      __typename?: "AttributeOptionEdge";
      node?: {
        __typename?: "AttributeOption";
        id: string;
        value: string;
        attribute: {
          __typename?: "AttributeEdge";
          node?: { __typename?: "Attribute"; id: string; name: string } | null;
        };
      } | null;
    }> | null;
  };
};

export type AttributionQueryVariables = Exact<{
  assortmentId: Scalars["ID"];
  selectedOptionIds: Array<Scalars["ID"]> | Scalars["ID"];
}>;

export type AttributionQuery = {
  __typename?: "Query";
  assortment?: {
    __typename?: "Assortment";
    id: string;
    availableSkuColorAttributeOptions: {
      __typename?: "AttributeOptionConnection";
      edges?: Array<{
        __typename?: "AttributeOptionEdge";
        node?: {
          __typename?: "AttributeOption";
          id: string;
          code: string;
          value: string;
          attribute: {
            __typename?: "AttributeEdge";
            node?: {
              __typename?: "Attribute";
              id: string;
              code: string;
              name: string;
              position: number;
              isRequired: boolean;
              isMultiSelect: boolean;
              type: AttributeType;
              parent?: {
                __typename?: "AttributeEdge";
                node?: { __typename?: "Attribute"; id: string } | null;
              } | null;
            } | null;
          };
        } | null;
      }> | null;
    };
  } | null;
};

export type AvailableMerchandisingHierarchiesQueryVariables = Exact<{
  assortmentId: Scalars["ID"];
}>;

export type AvailableMerchandisingHierarchiesQuery = {
  __typename?: "Query";
  assortment?: {
    __typename?: "Assortment";
    id: string;
    availableMerchandisingHierarchy: {
      __typename?: "MerchandisingHierarchyNodeConnection";
      edges: Array<{
        __typename?: "MerchandisingHierarchyNodeEdge";
        node?: {
          __typename?: "MerchandisingHierarchyNode";
          name: string;
          code: string;
          id: string;
          parent?: {
            __typename?: "MerchandisingHierarchyNodeEdge";
            node?: {
              __typename?: "MerchandisingHierarchyNode";
              id: string;
            } | null;
          } | null;
          level?: {
            __typename?: "MerchandisingHierarchyLevelEdge";
            node?: {
              __typename?: "MerchandisingHierarchyLevel";
              id: string;
              code: string;
              name: string;
              depth: string;
            } | null;
          } | null;
        } | null;
      }>;
    };
  } | null;
};

export type AvailableSizeRunQueryVariables = Exact<{
  assortmentId: Scalars["ID"];
}>;

export type AvailableSizeRunQuery = {
  __typename?: "Query";
  assortment?: {
    __typename?: "Assortment";
    id: string;
    merchandisingHierarchy: {
      __typename?: "MerchandisingHierarchyNodeConnection";
      edges: Array<{
        __typename?: "MerchandisingHierarchyNodeEdge";
        node?: {
          __typename?: "MerchandisingHierarchyNode";
          id: string;
          level?: {
            __typename?: "MerchandisingHierarchyLevelEdge";
            node?: {
              __typename?: "MerchandisingHierarchyLevel";
              id: string;
              depth: string;
            } | null;
          } | null;
        } | null;
      }>;
    };
    brand?: {
      __typename?: "RetailerBrandEdge";
      id: string;
      node?: { __typename?: "Brand"; id: string } | null;
    } | null;
  } | null;
};

export type AssortmentSkuImageDataQueryVariables = Exact<{
  assortmentId: Scalars["ID"];
}>;

export type AssortmentSkuImageDataQuery = {
  __typename?: "Query";
  assortment?: {
    __typename?: "Assortment";
    id: string;
    skus: {
      __typename?: "AssortmentSKUConnection";
      edges?: Array<{
        __typename?: "AssortmentSKUEdge";
        _id: string;
        color: { __typename?: "AssortmentSKUColor"; id: string };
        mainImage?: {
          __typename?: "Image";
          id: string;
          url: any;
          base64Data?: string | null;
        } | null;
      }> | null;
    };
  } | null;
};

export type ColorAttributeOptionsFragment = {
  __typename?: "AssortmentSKUColor";
  attributeOptions: {
    __typename?: "AttributeOptionConnection";
    edges?: Array<{
      __typename?: "AttributeOptionEdge";
      node?: {
        __typename?: "AttributeOption";
        id: string;
        value: string;
        attribute: {
          __typename?: "AttributeEdge";
          node?: { __typename?: "Attribute"; id: string; name: string } | null;
        };
      } | null;
    }> | null;
  };
};

export type ColorBulkUpdateMutationVariables = Exact<{
  assortmentId: Scalars["ID"];
  updates:
    | Array<AssortmentUi__BulkColorUnitUpdate>
    | AssortmentUi__BulkColorUnitUpdate;
  assortmentSkuIds: Array<Scalars["ID"]> | Scalars["ID"];
}>;

export type ColorBulkUpdateMutation = {
  __typename?: "Mutation";
  AssortmentUI__updateRowColorBulk: {
    __typename?: "AssortmentUI_RowColorBulkQuantities";
    query?: {
      __typename?: "Query";
      assortmentSkus: {
        __typename?: "AssortmentSKUConnection";
        edges?: Array<{
          __typename?: "AssortmentSKUEdge";
          _id: string;
          bulkQuantity: number;
          node: { __typename?: "SKU"; id: string };
          color: {
            __typename?: "AssortmentSKUColor";
            id: string;
            totalSizedQuantity: number;
            bulkQuantity: number;
          };
          style: { __typename?: "Style"; id: string };
          priceLevels: Array<{
            __typename?: "PriceLevel";
            id: string;
            name: FinancialPriceLevelName;
            extendedWholesale: string | number;
            extendedRetail: string | number;
            maxRetail: string | number;
            maxWholesale: string | number;
            currencyCode: string;
            currencySource?: CurrencyFilter | null;
          }>;
        }> | null;
      };
    } | null;
  };
};

export type ColorBulkQueryVariables = Exact<{
  assortmentId: Scalars["ID"];
}>;

export type ColorBulkQuery = {
  __typename?: "Query";
  assortment?: {
    __typename?: "Assortment";
    id: string;
    skus: {
      __typename?: "AssortmentSKUConnection";
      edges?: Array<{
        __typename?: "AssortmentSKUEdge";
        _id: string;
        bulkQuantity: number;
        node: { __typename?: "SKU"; id: string };
        color: {
          __typename?: "AssortmentSKUColor";
          id: string;
          totalSizedQuantity: number;
          bulkQuantity: number;
        };
        style: { __typename?: "Style"; id: string };
        priceLevels: Array<{
          __typename?: "PriceLevel";
          id: string;
          name: FinancialPriceLevelName;
          extendedWholesale: string | number;
          extendedRetail: string | number;
          maxRetail: string | number;
          maxWholesale: string | number;
          currencyCode: string;
          currencySource?: CurrencyFilter | null;
        }>;
      }> | null;
    };
  } | null;
};

export type ColorSwatchFragment = {
  __typename?: "ColorSwatch";
  hex?: string | null;
  rgb?: { __typename?: "RGB"; red: number; green: number; blue: number } | null;
  image?: {
    __typename?: "ImageEdge";
    node: {
      __typename?: "Image";
      id: string;
      url: any;
      owner?: { __typename?: "ImageOwnerAccount"; id: string } | null;
    };
  } | null;
};

export type CreateAssortmentInWorkspaceMutationVariables = Exact<{
  retailerId: Scalars["ID"];
  assortmentName: Scalars["String"];
  seasonId: Scalars["ID"];
  workspaceId: Scalars["ID"];
}>;

export type CreateAssortmentInWorkspaceMutation = {
  __typename?: "Mutation";
  createAssortment: {
    __typename?: "CreateAssortmentPayload";
    assortment?: { __typename?: "Assortment"; id: string; name: string } | null;
  };
};

export type CreateAssortmentProductsMutationVariables = Exact<{
  input: AssortmentUi__BulkCreateAssortmentProductRequest;
}>;

export type CreateAssortmentProductsMutation = {
  __typename?: "Mutation";
  AssortmentUI__bulkCreateAssortmentProduct: {
    __typename?: "AssortmentUI__bulkCreateAssortmentProductResponse";
    assortment?: {
      __typename?: "Assortment";
      id: string;
      financialOverview: {
        __typename?: "AssortmentFinancialOverview";
        assortmentCurrencyCode: string;
        linesheetCurrencyCode: string;
        assortmentUnits: {
          __typename?: "AssortmentUnits";
          productCount?: number | null;
          colorCount?: number | null;
          skuCount?: number | null;
          unitCount?: number | null;
          unitDepth?: string | null;
        };
        financialDetails: Array<{
          __typename?: "AssortmentFinancialDetails";
          currencyCode: string;
          isBrandCurrency?: boolean | null;
          priceLevels: Array<{
            __typename?: "FinancialPriceLevel";
            name: FinancialPriceLevelName;
            initialMarkup: string | number;
            cost: { __typename?: "Money"; value: string | number };
            retail: { __typename?: "Money"; value: string | number };
            extendedCost: { __typename?: "Money"; value: string | number };
            extendedRetail: { __typename?: "Money"; value: string | number };
            averageUnitCost: { __typename?: "Money"; value: string | number };
            averageUnitRetail: { __typename?: "Money"; value: string | number };
          }>;
          units: {
            __typename?: "AssortmentUnits";
            productCount?: number | null;
            colorCount?: number | null;
            skuCount?: number | null;
            unitCount?: number | null;
            unitDepth?: string | null;
          };
        }>;
        financialTargets: {
          __typename?: "AssortmentFinancialTargets";
          priceTargets: {
            __typename?: "AssortmentFinancialPriceTargets";
            initialMarkup?: string | number | null;
            cost?: { __typename?: "Money"; value: string | number } | null;
            retail?: { __typename?: "Money"; value: string | number } | null;
            averageUnitCost?: {
              __typename?: "Money";
              value: string | number;
            } | null;
            averageUnitRetail?: {
              __typename?: "Money";
              value: string | number;
            } | null;
          };
          priceTargetsVariance: {
            __typename?: "AssortmentFinancialPriceTargets";
            initialMarkup?: string | number | null;
            cost?: { __typename?: "Money"; value: string | number } | null;
            retail?: { __typename?: "Money"; value: string | number } | null;
            averageUnitCost?: {
              __typename?: "Money";
              value: string | number;
            } | null;
            averageUnitRetail?: {
              __typename?: "Money";
              value: string | number;
            } | null;
          };
        };
      };
      validationRequirements: Array<{
        __typename?: "Validation";
        field: AssortmentValidationField;
        valid: boolean;
      }>;
      attributeValidationRequirements: Array<{
        __typename?: "AttributeValidation";
        valid: boolean;
        attribute: { __typename?: "Attribute"; id: string };
      }>;
      doorClusters: {
        __typename?: "AssortmentDoorClusterConnection";
        edges?: Array<{
          __typename?: "AssortmentDoorClusterEdge";
          node?: {
            __typename?: "DoorCluster";
            id: string;
            name?: string | null;
            code?: string | null;
            doors?: {
              __typename?: "DoorClusterDoorConnection";
              edges?: Array<{
                __typename?: "DoorClusterDoorEdge";
                node?: {
                  __typename?: "Door";
                  id: string;
                  name: string;
                  code: string;
                } | null;
              }> | null;
            } | null;
          } | null;
        }> | null;
      };
      doors: {
        __typename?: "AssortmentDoorConnection";
        edges?: Array<{
          __typename?: "AssortmentDoorEdge";
          node?: {
            __typename?: "Door";
            id: string;
            name: string;
            code: string;
          } | null;
        }> | null;
      };
      skus: {
        __typename?: "AssortmentSKUConnection";
        edges?: Array<{
          __typename?: "AssortmentSKUEdge";
          _id: string;
          legacyItemId: string;
          comment?: string | null;
          isCustom?: boolean | null;
          upc?: string | null;
          wholesaleCurrencyCode?: string | null;
          retailCurrencyCode?: string | null;
          bulkQuantity: number;
          node: {
            __typename?: "SKU";
            id: string;
            color: { __typename?: "Color"; id: string };
            size: {
              __typename?: "Size";
              id: string;
              code: string;
              name: string;
            };
          };
          style: {
            __typename?: "Style";
            name?: string | null;
            code?: string | null;
            id: string;
            description?: string | null;
            images: {
              __typename?: "ImageConnection";
              edges: Array<{
                __typename?: "ImageEdge";
                node: {
                  __typename?: "Image";
                  id: string;
                  url: any;
                  owner?: {
                    __typename?: "ImageOwnerAccount";
                    id: string;
                  } | null;
                };
              }>;
            };
            details: {
              __typename?: "StyleDetails";
              countryOfOrigin?: string | null;
              furStatus?: FurStatus | null;
              heelHeight?: string | null;
              measurements?: string | null;
              modelHeightInches?: number | null;
              sourceOfMaterials?: string | null;
              categories: Array<{
                __typename?: "Category";
                id?: string | null;
                name: string;
              }>;
              materials?: Array<{
                __typename?: "Material";
                name: string;
              } | null> | null;
              silhouette?: { __typename?: "Silhouette"; name: string } | null;
              fabrication?: { __typename?: "Fabrication"; name: string } | null;
            };
          };
          color: {
            __typename?: "AssortmentSKUColor";
            id: string;
            name: string;
            code: string;
            comment?: string | null;
            totalSizedQuantity: number;
            bulkQuantity: number;
            swatch: {
              __typename?: "ColorSwatch";
              hex?: string | null;
              rgb?: {
                __typename?: "RGB";
                red: number;
                green: number;
                blue: number;
              } | null;
              image?: {
                __typename?: "ImageEdge";
                node: {
                  __typename?: "Image";
                  id: string;
                  url: any;
                  owner?: {
                    __typename?: "ImageOwnerAccount";
                    id: string;
                  } | null;
                };
              } | null;
            };
            images: {
              __typename?: "ImageConnection";
              edges: Array<{
                __typename?: "ImageEdge";
                node: {
                  __typename?: "Image";
                  id: string;
                  url: any;
                  owner?: {
                    __typename?: "ImageOwnerAccount";
                    id: string;
                  } | null;
                };
              }>;
            };
            doorQuantities: Array<{
              __typename?: "AssortmentSKUColorDoorQuantity";
              id: string;
              bulkQuantity: number;
              totalSizedQuantity: number;
              door?: { __typename?: "Door"; id: string } | null;
            }>;
            attributeOptions: {
              __typename?: "AttributeOptionConnection";
              edges?: Array<{
                __typename?: "AttributeOptionEdge";
                node?: {
                  __typename?: "AttributeOption";
                  id: string;
                  value: string;
                  attribute: {
                    __typename?: "AttributeEdge";
                    node?: {
                      __typename?: "Attribute";
                      id: string;
                      name: string;
                    } | null;
                  };
                } | null;
              }> | null;
            };
            sizeCurves: {
              __typename?: "RetailSizeCurves";
              missingFields: Array<RetailSizeCurvesMissingFields>;
              doorSizeCurves: Array<{
                __typename?: "RetailDoorSizeCurves";
                door: { __typename?: "Door"; id: string };
                curveRatios: Array<{
                  __typename?: "SizeCurveRatio";
                  ratio: string | number;
                  retailSize: {
                    __typename?: "RetailSize";
                    id: string;
                    code?: string | null;
                    name?: string | null;
                  };
                }>;
              }>;
            };
          };
          size: { __typename?: "Size"; id: string; code: string; name: string };
          sizeRun?: {
            __typename?: "SizeRunEdge";
            node?: {
              __typename?: "SizeRun";
              id: string;
              code?: string | null;
              name?: string | null;
            } | null;
          } | null;
          retailSize?: {
            __typename?: "RetailSize";
            code?: string | null;
            id: string;
            name?: string | null;
          } | null;
          availableRetailSizeOptions: Array<{
            __typename?: "RetailSize";
            code?: string | null;
            id: string;
            name?: string | null;
          }>;
          priceLevels: Array<{
            __typename?: "PriceLevel";
            id: string;
            name: FinancialPriceLevelName;
            extendedWholesale: string | number;
            extendedRetail: string | number;
            maxRetail: string | number;
            maxWholesale: string | number;
            currencyCode: string;
            currencySource?: CurrencyFilter | null;
          }>;
          doorQuantities: Array<{
            __typename?: "AssortmentSKUDoorQuantity";
            id: string;
            quantity: number;
            appliedSizeRatio?: string | number | null;
            door?: { __typename?: "Door"; id: string } | null;
          }>;
        }> | null;
      };
    } | null;
  };
};

export type CreateSavedViewMutationVariables = Exact<{
  input: CreateConfigurationInput;
}>;

export type CreateSavedViewMutation = {
  __typename?: "Mutation";
  AssortmentUI__createConfiguration?: {
    __typename?: "Configuration";
    id: string;
    accountId: string;
    userId: string;
    name?: string | null;
    data: string;
    projectName?: string | null;
    visibility: ConfigurationVisibility;
    isDefault?: boolean | null;
  } | null;
};

export type DateFormatQueryVariables = Exact<{ [key: string]: never }>;

export type DateFormatQuery = {
  __typename?: "Query";
  viewingUser: {
    __typename?: "User";
    id: string;
    dateFormat?: DateFormat | null;
  };
};

export type DeleteProductColorsMutationVariables = Exact<{
  assortmentId: Scalars["ID"];
  colorIds: Array<Scalars["ID"]> | Scalars["ID"];
}>;

export type DeleteProductColorsMutation = {
  __typename?: "Mutation";
  AssortmentUI__deleteSkuColorsForAssortment?: {
    __typename?: "AssortmentUI__Assortment";
    query?: {
      __typename?: "Query";
      assortment?: {
        __typename?: "Assortment";
        id: string;
        skus: {
          __typename?: "AssortmentSKUConnection";
          edges?: Array<{
            __typename?: "AssortmentSKUEdge";
            _id: string;
            legacyItemId: string;
            comment?: string | null;
            isCustom?: boolean | null;
            upc?: string | null;
            wholesaleCurrencyCode?: string | null;
            retailCurrencyCode?: string | null;
            bulkQuantity: number;
            node: {
              __typename?: "SKU";
              id: string;
              color: { __typename?: "Color"; id: string };
              size: {
                __typename?: "Size";
                id: string;
                code: string;
                name: string;
              };
            };
            style: {
              __typename?: "Style";
              name?: string | null;
              code?: string | null;
              id: string;
              description?: string | null;
              images: {
                __typename?: "ImageConnection";
                edges: Array<{
                  __typename?: "ImageEdge";
                  node: {
                    __typename?: "Image";
                    id: string;
                    url: any;
                    owner?: {
                      __typename?: "ImageOwnerAccount";
                      id: string;
                    } | null;
                  };
                }>;
              };
              details: {
                __typename?: "StyleDetails";
                countryOfOrigin?: string | null;
                furStatus?: FurStatus | null;
                heelHeight?: string | null;
                measurements?: string | null;
                modelHeightInches?: number | null;
                sourceOfMaterials?: string | null;
                categories: Array<{
                  __typename?: "Category";
                  id?: string | null;
                  name: string;
                }>;
                materials?: Array<{
                  __typename?: "Material";
                  name: string;
                } | null> | null;
                silhouette?: { __typename?: "Silhouette"; name: string } | null;
                fabrication?: {
                  __typename?: "Fabrication";
                  name: string;
                } | null;
              };
            };
            color: {
              __typename?: "AssortmentSKUColor";
              id: string;
              name: string;
              code: string;
              comment?: string | null;
              totalSizedQuantity: number;
              bulkQuantity: number;
              swatch: {
                __typename?: "ColorSwatch";
                hex?: string | null;
                rgb?: {
                  __typename?: "RGB";
                  red: number;
                  green: number;
                  blue: number;
                } | null;
                image?: {
                  __typename?: "ImageEdge";
                  node: {
                    __typename?: "Image";
                    id: string;
                    url: any;
                    owner?: {
                      __typename?: "ImageOwnerAccount";
                      id: string;
                    } | null;
                  };
                } | null;
              };
              images: {
                __typename?: "ImageConnection";
                edges: Array<{
                  __typename?: "ImageEdge";
                  node: {
                    __typename?: "Image";
                    id: string;
                    url: any;
                    owner?: {
                      __typename?: "ImageOwnerAccount";
                      id: string;
                    } | null;
                  };
                }>;
              };
              doorQuantities: Array<{
                __typename?: "AssortmentSKUColorDoorQuantity";
                id: string;
                bulkQuantity: number;
                totalSizedQuantity: number;
                door?: { __typename?: "Door"; id: string } | null;
              }>;
              attributeOptions: {
                __typename?: "AttributeOptionConnection";
                edges?: Array<{
                  __typename?: "AttributeOptionEdge";
                  node?: {
                    __typename?: "AttributeOption";
                    id: string;
                    value: string;
                    attribute: {
                      __typename?: "AttributeEdge";
                      node?: {
                        __typename?: "Attribute";
                        id: string;
                        name: string;
                      } | null;
                    };
                  } | null;
                }> | null;
              };
              sizeCurves: {
                __typename?: "RetailSizeCurves";
                missingFields: Array<RetailSizeCurvesMissingFields>;
                doorSizeCurves: Array<{
                  __typename?: "RetailDoorSizeCurves";
                  door: { __typename?: "Door"; id: string };
                  curveRatios: Array<{
                    __typename?: "SizeCurveRatio";
                    ratio: string | number;
                    retailSize: {
                      __typename?: "RetailSize";
                      id: string;
                      code?: string | null;
                      name?: string | null;
                    };
                  }>;
                }>;
              };
            };
            size: {
              __typename?: "Size";
              id: string;
              code: string;
              name: string;
            };
            sizeRun?: {
              __typename?: "SizeRunEdge";
              node?: {
                __typename?: "SizeRun";
                id: string;
                code?: string | null;
                name?: string | null;
              } | null;
            } | null;
            retailSize?: {
              __typename?: "RetailSize";
              code?: string | null;
              id: string;
              name?: string | null;
            } | null;
            availableRetailSizeOptions: Array<{
              __typename?: "RetailSize";
              code?: string | null;
              id: string;
              name?: string | null;
            }>;
            priceLevels: Array<{
              __typename?: "PriceLevel";
              id: string;
              name: FinancialPriceLevelName;
              extendedWholesale: string | number;
              extendedRetail: string | number;
              maxRetail: string | number;
              maxWholesale: string | number;
              currencyCode: string;
              currencySource?: CurrencyFilter | null;
            }>;
            doorQuantities: Array<{
              __typename?: "AssortmentSKUDoorQuantity";
              id: string;
              quantity: number;
              appliedSizeRatio?: string | number | null;
              door?: { __typename?: "Door"; id: string } | null;
            }>;
          }> | null;
        };
      } | null;
    } | null;
  } | null;
};

export type DeleteSavedViewMutationVariables = Exact<{
  input: DeleteConfigurationInput;
}>;

export type DeleteSavedViewMutation = {
  __typename?: "Mutation";
  AssortmentUI__deleteConfiguration?: {
    __typename?: "DeletePayload";
    success?: boolean | null;
  } | null;
};

export type DeleteSkuColorsForAssortmentMutationVariables = Exact<{
  assortmentId: Scalars["ID"];
  colorIds: Array<Scalars["ID"]> | Scalars["ID"];
}>;

export type DeleteSkuColorsForAssortmentMutation = {
  __typename?: "Mutation";
  AssortmentUI__deleteSkuColorsForAssortment?: {
    __typename?: "AssortmentUI__Assortment";
    query?: {
      __typename?: "Query";
      assortment?: {
        __typename?: "Assortment";
        id: string;
        skus: {
          __typename?: "AssortmentSKUConnection";
          edges?: Array<{
            __typename?: "AssortmentSKUEdge";
            _id: string;
          }> | null;
        };
      } | null;
    } | null;
  } | null;
};

export type AssortmentDoorsFragment = {
  __typename?: "Assortment";
  doors: {
    __typename?: "AssortmentDoorConnection";
    edges?: Array<{
      __typename?: "AssortmentDoorEdge";
      node?: {
        __typename?: "Door";
        id: string;
        name: string;
        code: string;
      } | null;
    }> | null;
  };
};

export type DoorFragment = {
  __typename?: "Door";
  id: string;
  name: string;
  code: string;
};

export type DoorQuantitySkuFragment = {
  __typename?: "AssortmentSKUEdge";
  _id: string;
  bulkQuantity: number;
  node: { __typename?: "SKU"; id: string };
  color: {
    __typename?: "AssortmentSKUColor";
    id: string;
    totalSizedQuantity: number;
    bulkQuantity: number;
    sizeCurves: {
      __typename?: "RetailSizeCurves";
      missingFields: Array<RetailSizeCurvesMissingFields>;
      doorSizeCurves: Array<{
        __typename?: "RetailDoorSizeCurves";
        door: { __typename?: "Door"; id: string };
        curveRatios: Array<{
          __typename?: "SizeCurveRatio";
          ratio: string | number;
          retailSize: {
            __typename?: "RetailSize";
            id: string;
            code?: string | null;
            name?: string | null;
          };
        }>;
      }>;
    };
    doorQuantities: Array<{
      __typename?: "AssortmentSKUColorDoorQuantity";
      id: string;
      bulkQuantity: number;
      totalSizedQuantity: number;
      door?: { __typename?: "Door"; id: string } | null;
    }>;
  };
  priceLevels: Array<{
    __typename?: "PriceLevel";
    id: string;
    name: FinancialPriceLevelName;
    extendedWholesale: string | number;
    extendedRetail: string | number;
    maxRetail: string | number;
    maxWholesale: string | number;
    currencyCode: string;
    currencySource?: CurrencyFilter | null;
  }>;
  doorQuantities: Array<{
    __typename?: "AssortmentSKUDoorQuantity";
    id: string;
    quantity: number;
    appliedSizeRatio?: string | number | null;
    door?: { __typename?: "Door"; id: string } | null;
  }>;
};

export type DoorsModalQueryVariables = Exact<{
  assortmentId: Scalars["ID"];
  retailerId: Scalars["ID"];
}>;

export type DoorsModalQuery = {
  __typename?: "Query";
  assortment?: {
    __typename?: "Assortment";
    id: string;
    doors: {
      __typename?: "AssortmentDoorConnection";
      edges?: Array<{
        __typename?: "AssortmentDoorEdge";
        node?: {
          __typename?: "Door";
          id: string;
          name: string;
          code: string;
        } | null;
      }> | null;
    };
    doorClusters: {
      __typename?: "AssortmentDoorClusterConnection";
      edges?: Array<{
        __typename?: "AssortmentDoorClusterEdge";
        node?: {
          __typename?: "DoorCluster";
          id: string;
          name?: string | null;
          code?: string | null;
          doors?: {
            __typename?: "DoorClusterDoorConnection";
            edges?: Array<{
              __typename?: "DoorClusterDoorEdge";
              node?: {
                __typename?: "Door";
                id: string;
                name: string;
                code: string;
              } | null;
            }> | null;
          } | null;
        } | null;
      }> | null;
    };
  } | null;
  retailer?: {
    __typename?: "Retailer";
    id: string;
    doors: {
      __typename?: "DoorConnection";
      edges?: Array<{
        __typename?: "DoorEdge";
        node?: {
          __typename?: "Door";
          id: string;
          name: string;
          code: string;
        } | null;
      }> | null;
    };
  } | null;
};

export type FinancialCurrencyConversionsFragment = {
  __typename?: "Assortment";
  currencies: {
    __typename?: "AssortmentCurrencies";
    currencyConversions?: Array<{
      __typename?: "CurrencyConversion";
      conversionFactor: string | number;
      fromCurrency: string;
      toCurrency: string;
    }> | null;
  };
};

export type FinancialCurrencyConversionsQueryVariables = Exact<{
  assortmentId: Scalars["ID"];
}>;

export type FinancialCurrencyConversionsQuery = {
  __typename?: "Query";
  assortment?: {
    __typename?: "Assortment";
    id: string;
    currencies: {
      __typename?: "AssortmentCurrencies";
      currencyConversions?: Array<{
        __typename?: "CurrencyConversion";
        conversionFactor: string | number;
        fromCurrency: string;
        toCurrency: string;
      }> | null;
    };
    financialOverview: {
      __typename?: "AssortmentFinancialOverview";
      assortmentCurrencyCode: string;
      linesheetCurrencyCode: string;
      assortmentUnits: {
        __typename?: "AssortmentUnits";
        productCount?: number | null;
        colorCount?: number | null;
        skuCount?: number | null;
        unitCount?: number | null;
        unitDepth?: string | null;
      };
      financialDetails: Array<{
        __typename?: "AssortmentFinancialDetails";
        currencyCode: string;
        isBrandCurrency?: boolean | null;
        priceLevels: Array<{
          __typename?: "FinancialPriceLevel";
          name: FinancialPriceLevelName;
          initialMarkup: string | number;
          cost: { __typename?: "Money"; value: string | number };
          retail: { __typename?: "Money"; value: string | number };
          extendedCost: { __typename?: "Money"; value: string | number };
          extendedRetail: { __typename?: "Money"; value: string | number };
          averageUnitCost: { __typename?: "Money"; value: string | number };
          averageUnitRetail: { __typename?: "Money"; value: string | number };
        }>;
        units: {
          __typename?: "AssortmentUnits";
          productCount?: number | null;
          colorCount?: number | null;
          skuCount?: number | null;
          unitCount?: number | null;
          unitDepth?: string | null;
        };
      }>;
      financialTargets: {
        __typename?: "AssortmentFinancialTargets";
        priceTargets: {
          __typename?: "AssortmentFinancialPriceTargets";
          initialMarkup?: string | number | null;
          cost?: { __typename?: "Money"; value: string | number } | null;
          retail?: { __typename?: "Money"; value: string | number } | null;
          averageUnitCost?: {
            __typename?: "Money";
            value: string | number;
          } | null;
          averageUnitRetail?: {
            __typename?: "Money";
            value: string | number;
          } | null;
        };
        priceTargetsVariance: {
          __typename?: "AssortmentFinancialPriceTargets";
          initialMarkup?: string | number | null;
          cost?: { __typename?: "Money"; value: string | number } | null;
          retail?: { __typename?: "Money"; value: string | number } | null;
          averageUnitCost?: {
            __typename?: "Money";
            value: string | number;
          } | null;
          averageUnitRetail?: {
            __typename?: "Money";
            value: string | number;
          } | null;
        };
      };
    };
  } | null;
};

export type FinancialOverviewFragment = {
  __typename?: "Assortment";
  financialOverview: {
    __typename?: "AssortmentFinancialOverview";
    assortmentCurrencyCode: string;
    linesheetCurrencyCode: string;
    assortmentUnits: {
      __typename?: "AssortmentUnits";
      productCount?: number | null;
      colorCount?: number | null;
      skuCount?: number | null;
      unitCount?: number | null;
      unitDepth?: string | null;
    };
    financialDetails: Array<{
      __typename?: "AssortmentFinancialDetails";
      currencyCode: string;
      isBrandCurrency?: boolean | null;
      priceLevels: Array<{
        __typename?: "FinancialPriceLevel";
        name: FinancialPriceLevelName;
        initialMarkup: string | number;
        cost: { __typename?: "Money"; value: string | number };
        retail: { __typename?: "Money"; value: string | number };
        extendedCost: { __typename?: "Money"; value: string | number };
        extendedRetail: { __typename?: "Money"; value: string | number };
        averageUnitCost: { __typename?: "Money"; value: string | number };
        averageUnitRetail: { __typename?: "Money"; value: string | number };
      }>;
      units: {
        __typename?: "AssortmentUnits";
        productCount?: number | null;
        colorCount?: number | null;
        skuCount?: number | null;
        unitCount?: number | null;
        unitDepth?: string | null;
      };
    }>;
    financialTargets: {
      __typename?: "AssortmentFinancialTargets";
      priceTargets: {
        __typename?: "AssortmentFinancialPriceTargets";
        initialMarkup?: string | number | null;
        cost?: { __typename?: "Money"; value: string | number } | null;
        retail?: { __typename?: "Money"; value: string | number } | null;
        averageUnitCost?: {
          __typename?: "Money";
          value: string | number;
        } | null;
        averageUnitRetail?: {
          __typename?: "Money";
          value: string | number;
        } | null;
      };
      priceTargetsVariance: {
        __typename?: "AssortmentFinancialPriceTargets";
        initialMarkup?: string | number | null;
        cost?: { __typename?: "Money"; value: string | number } | null;
        retail?: { __typename?: "Money"; value: string | number } | null;
        averageUnitCost?: {
          __typename?: "Money";
          value: string | number;
        } | null;
        averageUnitRetail?: {
          __typename?: "Money";
          value: string | number;
        } | null;
      };
    };
  };
};

export type FinancialOverviewTableQueryVariables = Exact<{
  assortmentId: Scalars["ID"];
}>;

export type FinancialOverviewTableQuery = {
  __typename?: "Query";
  assortment?: {
    __typename?: "Assortment";
    id: string;
    financialOverview: {
      __typename?: "AssortmentFinancialOverview";
      assortmentCurrencyCode: string;
      linesheetCurrencyCode: string;
      assortmentUnits: {
        __typename?: "AssortmentUnits";
        productCount?: number | null;
        colorCount?: number | null;
        skuCount?: number | null;
        unitCount?: number | null;
        unitDepth?: string | null;
      };
      financialDetails: Array<{
        __typename?: "AssortmentFinancialDetails";
        currencyCode: string;
        isBrandCurrency?: boolean | null;
        priceLevels: Array<{
          __typename?: "FinancialPriceLevel";
          name: FinancialPriceLevelName;
          initialMarkup: string | number;
          cost: { __typename?: "Money"; value: string | number };
          retail: { __typename?: "Money"; value: string | number };
          extendedCost: { __typename?: "Money"; value: string | number };
          extendedRetail: { __typename?: "Money"; value: string | number };
          averageUnitCost: { __typename?: "Money"; value: string | number };
          averageUnitRetail: { __typename?: "Money"; value: string | number };
        }>;
        units: {
          __typename?: "AssortmentUnits";
          productCount?: number | null;
          colorCount?: number | null;
          skuCount?: number | null;
          unitCount?: number | null;
          unitDepth?: string | null;
        };
      }>;
      financialTargets: {
        __typename?: "AssortmentFinancialTargets";
        priceTargets: {
          __typename?: "AssortmentFinancialPriceTargets";
          initialMarkup?: string | number | null;
          cost?: { __typename?: "Money"; value: string | number } | null;
          retail?: { __typename?: "Money"; value: string | number } | null;
          averageUnitCost?: {
            __typename?: "Money";
            value: string | number;
          } | null;
          averageUnitRetail?: {
            __typename?: "Money";
            value: string | number;
          } | null;
        };
        priceTargetsVariance: {
          __typename?: "AssortmentFinancialPriceTargets";
          initialMarkup?: string | number | null;
          cost?: { __typename?: "Money"; value: string | number } | null;
          retail?: { __typename?: "Money"; value: string | number } | null;
          averageUnitCost?: {
            __typename?: "Money";
            value: string | number;
          } | null;
          averageUnitRetail?: {
            __typename?: "Money";
            value: string | number;
          } | null;
        };
      };
    };
  } | null;
};

export type FinancialPriceFragment = {
  __typename?: "FinancialPriceLevel";
  initialMarkup: string | number;
  cost: { __typename?: "Money"; value: string | number };
  retail: { __typename?: "Money"; value: string | number };
  extendedCost: { __typename?: "Money"; value: string | number };
  extendedRetail: { __typename?: "Money"; value: string | number };
  averageUnitCost: { __typename?: "Money"; value: string | number };
  averageUnitRetail: { __typename?: "Money"; value: string | number };
};

export type FinancialPriceModifierQueryVariables = Exact<{
  assortmentId: Scalars["ID"];
  retailerId: Scalars["ID"];
}>;

export type FinancialPriceModifierQuery = {
  __typename?: "Query";
  assortment?: {
    __typename?: "Assortment";
    id: string;
    priceModifiers: {
      __typename?: "PriceModifierConnection";
      edges?: Array<{
        __typename?: "PriceModifierEdge";
        node?: {
          __typename?: "PriceModifier";
          id: string;
          factor?: string | number | null;
          percent?: string | number | null;
          group: {
            __typename?: "PriceModifierGroupEdge";
            node: {
              __typename?: "PriceModifierGroup";
              id: string;
              name: string;
              adjustmentType?: AdjustmentTypeEnum | null;
              displayFormat?: DisplayFormatEnum | null;
            };
          };
        } | null;
      }> | null;
    };
  } | null;
  retailer?: {
    __typename?: "Retailer";
    id: string;
    assortmentPriceModifierGroups: {
      __typename?: "PriceModifierGroupConnection";
      edges?: Array<{
        __typename?: "PriceModifierGroupEdge";
        node: {
          __typename?: "PriceModifierGroup";
          id: string;
          code: string;
          name: string;
          type: PriceModifierGroupType;
          adjustmentType?: AdjustmentTypeEnum | null;
          displayFormat?: DisplayFormatEnum | null;
        };
      }> | null;
    };
  } | null;
};

export type FinancialPriceTargetFragment = {
  __typename?: "AssortmentFinancialPriceTargets";
  initialMarkup?: string | number | null;
  cost?: { __typename?: "Money"; value: string | number } | null;
  retail?: { __typename?: "Money"; value: string | number } | null;
  averageUnitCost?: { __typename?: "Money"; value: string | number } | null;
  averageUnitRetail?: { __typename?: "Money"; value: string | number } | null;
};

export type GenericSkuFieldsFragment = {
  __typename?: "AssortmentSKUEdge";
  _id: string;
  legacyItemId: string;
  comment?: string | null;
  style: {
    __typename?: "Style";
    id: string;
    name?: string | null;
    code?: string | null;
    description?: string | null;
    details: {
      __typename?: "StyleDetails";
      countryOfOrigin?: string | null;
      furStatus?: FurStatus | null;
      heelHeight?: string | null;
      measurements?: string | null;
      modelHeightInches?: number | null;
      sourceOfMaterials?: string | null;
      categories: Array<{
        __typename?: "Category";
        id?: string | null;
        name: string;
      }>;
      materials?: Array<{
        __typename?: "Material";
        name: string;
      } | null> | null;
      silhouette?: { __typename?: "Silhouette"; name: string } | null;
      fabrication?: { __typename?: "Fabrication"; name: string } | null;
    };
  };
  color: {
    __typename?: "AssortmentSKUColor";
    id: string;
    name: string;
    code: string;
    comment?: string | null;
  };
};

export type GetSavedViewsQueryVariables = Exact<{ [key: string]: never }>;

export type GetSavedViewsQuery = {
  __typename?: "Query";
  views?: Array<{
    __typename?: "Configuration";
    id: string;
    accountId: string;
    userId: string;
    name?: string | null;
    data: string;
    projectName?: string | null;
    visibility: ConfigurationVisibility;
    isDefault?: boolean | null;
  } | null> | null;
};

export type ImageFragment = {
  __typename?: "Image";
  id: string;
  url: any;
  owner?: { __typename?: "ImageOwnerAccount"; id: string } | null;
};

export type ImageDataFragment = {
  __typename?: "Image";
  id: string;
  url: any;
  base64Data?: string | null;
};

export type ListAvailableRetailSizesQueryVariables = Exact<{
  assortmentId: Scalars["ID"];
}>;

export type ListAvailableRetailSizesQuery = {
  __typename?: "Query";
  assortment?: {
    __typename?: "Assortment";
    id: string;
    skus: {
      __typename?: "AssortmentSKUConnection";
      edges?: Array<{
        __typename?: "AssortmentSKUEdge";
        _id: string;
        availableRetailSizeOptions: Array<{
          __typename?: "RetailSize";
          code?: string | null;
          id: string;
          name?: string | null;
        }>;
        node: { __typename?: "SKU"; id: string };
      }> | null;
    };
  } | null;
};

export type ListAvailableSizeRunsQueryVariables = Exact<{
  brandId?: InputMaybe<Scalars["ID"]>;
  hierarchyId?: InputMaybe<Scalars["ID"]>;
  attributeOptionIds?: InputMaybe<Array<Scalars["ID"]> | Scalars["ID"]>;
}>;

export type ListAvailableSizeRunsQuery = {
  __typename?: "Query";
  sizeRuns: Array<{
    __typename?: "SizeRun";
    id: string;
    code?: string | null;
    name?: string | null;
  }>;
};

export type ManageImagesPaneQueryVariables = Exact<{
  id: Scalars["String"];
}>;

export type ManageImagesPaneQuery = {
  __typename?: "Query";
  activeViewingAccount: {
    __typename?: "Account";
    id: string;
    name: string;
    type?: AccountType | null;
    tier?: AccountTier | null;
  };
  productDetail: {
    __typename?: "ProductDetail";
    id: string;
    images: Array<{
      __typename?: "Image";
      id: string;
      url: any;
      owner?: { __typename?: "ImageOwnerAccount"; id: string } | null;
    }>;
  };
};

export type RetailerMerchandisingHierarchyQueryVariables = Exact<{
  retailerId: Scalars["ID"];
}>;

export type RetailerMerchandisingHierarchyQuery = {
  __typename?: "Query";
  retailer?: {
    __typename?: "Retailer";
    id: string;
    merchandisingHierarchy: {
      __typename?: "MerchandisingHierarchyNodeConnection";
      edges: Array<{
        __typename?: "MerchandisingHierarchyNodeEdge";
        node?: {
          __typename?: "MerchandisingHierarchyNode";
          id: string;
          code: string;
          name: string;
          parent?: {
            __typename?: "MerchandisingHierarchyNodeEdge";
            node?: {
              __typename?: "MerchandisingHierarchyNode";
              id: string;
              code: string;
              name: string;
            } | null;
          } | null;
          level?: {
            __typename?: "MerchandisingHierarchyLevelEdge";
            node?: {
              __typename?: "MerchandisingHierarchyLevel";
              id: string;
              name: string;
              code: string;
              depth: string;
            } | null;
          } | null;
        } | null;
      }>;
    };
  } | null;
};

export type MissingRequiredAttributesFragment = {
  __typename?: "AssortmentSKUColor";
  missingRequiredAttributes: {
    __typename?: "AttributeConnection";
    edges?: Array<{
      __typename?: "AttributeEdge";
      node?: { __typename?: "Attribute"; id: string; name: string } | null;
    }> | null;
  };
};

export type OrderValidationRequirementsQueryVariables = Exact<{
  assortmentId: Scalars["ID"];
}>;

export type OrderValidationRequirementsQuery = {
  __typename?: "Query";
  assortment?: {
    __typename?: "Assortment";
    id: string;
    validationRequirements: Array<{
      __typename?: "Validation";
      field: AssortmentValidationField;
      valid: boolean;
    }>;
    attributeValidationRequirements: Array<{
      __typename?: "AttributeValidation";
      valid: boolean;
      attribute: { __typename?: "Attribute"; id: string };
    }>;
  } | null;
};

export type PriceLevelsFragment = {
  __typename?: "PriceLevel";
  id: string;
  name: FinancialPriceLevelName;
  extendedWholesale: string | number;
  extendedRetail: string | number;
  maxRetail: string | number;
  maxWholesale: string | number;
  currencyCode: string;
  currencySource?: CurrencyFilter | null;
};

export type PriceModifierFragment = {
  __typename?: "Assortment";
  priceModifiers: {
    __typename?: "PriceModifierConnection";
    edges?: Array<{
      __typename?: "PriceModifierEdge";
      node?: {
        __typename?: "PriceModifier";
        id: string;
        factor?: string | number | null;
        percent?: string | number | null;
        group: {
          __typename?: "PriceModifierGroupEdge";
          node: {
            __typename?: "PriceModifierGroup";
            id: string;
            name: string;
            adjustmentType?: AdjustmentTypeEnum | null;
            displayFormat?: DisplayFormatEnum | null;
          };
        };
      } | null;
    }> | null;
  };
};

export type ProductGridQueryVariables = Exact<{
  assortmentId: Scalars["ID"];
}>;

export type ProductGridQuery = {
  __typename?: "Query";
  assortment?: {
    __typename?: "Assortment";
    id: string;
    skus: {
      __typename?: "AssortmentSKUConnection";
      edges?: Array<{
        __typename?: "AssortmentSKUEdge";
        _id: string;
        node: { __typename?: "SKU"; id: string };
        style: {
          __typename?: "Style";
          id: string;
          name?: string | null;
          code?: string | null;
          images: {
            __typename?: "ImageConnection";
            edges: Array<{
              __typename?: "ImageEdge";
              node: {
                __typename?: "Image";
                id: string;
                url: any;
                owner?: { __typename?: "ImageOwnerAccount"; id: string } | null;
              };
            }>;
          };
        };
        color: {
          __typename?: "AssortmentSKUColor";
          id: string;
          code: string;
          name: string;
          bulkQuantity: number;
          images: {
            __typename?: "ImageConnection";
            edges: Array<{
              __typename?: "ImageEdge";
              node: {
                __typename?: "Image";
                id: string;
                url: any;
                owner?: { __typename?: "ImageOwnerAccount"; id: string } | null;
              };
            }>;
          };
          swatch: {
            __typename?: "ColorSwatch";
            hex?: string | null;
            rgb?: {
              __typename?: "RGB";
              red: number;
              green: number;
              blue: number;
            } | null;
            image?: {
              __typename?: "ImageEdge";
              node: {
                __typename?: "Image";
                id: string;
                url: any;
                owner?: { __typename?: "ImageOwnerAccount"; id: string } | null;
              };
            } | null;
          };
          missingRequiredAttributes: {
            __typename?: "AttributeConnection";
            edges?: Array<{
              __typename?: "AttributeEdge";
              node?: {
                __typename?: "Attribute";
                id: string;
                name: string;
              } | null;
            }> | null;
          };
          attributeOptions: {
            __typename?: "AttributeOptionConnection";
            edges?: Array<{
              __typename?: "AttributeOptionEdge";
              node?: {
                __typename?: "AttributeOption";
                id: string;
                value: string;
                attribute: {
                  __typename?: "AttributeEdge";
                  node?: {
                    __typename?: "Attribute";
                    id: string;
                    name: string;
                  } | null;
                };
              } | null;
            }> | null;
          };
        };
      }> | null;
    };
  } | null;
};

export type RemoveAttributeOptionsMutationVariables = Exact<{
  assortmentSkuIds: Array<Scalars["ID"]> | Scalars["ID"];
  input: RemoveAssortmentSkuAttributesInput;
}>;

export type RemoveAttributeOptionsMutation = {
  __typename?: "Mutation";
  removeAssortmentSkuColorAttributes: {
    __typename?: "RemoveAssortmentSkuColorAttributesPayload";
    assortment?: {
      __typename?: "Assortment";
      id: string;
      validationRequirements: Array<{
        __typename?: "Validation";
        field: AssortmentValidationField;
        valid: boolean;
      }>;
      attributeValidationRequirements: Array<{
        __typename?: "AttributeValidation";
        valid: boolean;
        attribute: { __typename?: "Attribute"; id: string };
      }>;
    } | null;
    query?: {
      __typename?: "Query";
      assortmentSkus: {
        __typename?: "AssortmentSKUConnection";
        edges?: Array<{
          __typename?: "AssortmentSKUEdge";
          _id: string;
          color: {
            __typename?: "AssortmentSKUColor";
            id: string;
            attributeOptions: {
              __typename?: "AttributeOptionConnection";
              edges?: Array<{
                __typename?: "AttributeOptionEdge";
                node?: {
                  __typename?: "AttributeOption";
                  id: string;
                  value: string;
                  attribute: {
                    __typename?: "AttributeEdge";
                    node?: {
                      __typename?: "Attribute";
                      id: string;
                      name: string;
                    } | null;
                  };
                } | null;
              }> | null;
            };
            missingRequiredAttributes: {
              __typename?: "AttributeConnection";
              edges?: Array<{
                __typename?: "AttributeEdge";
                node?: {
                  __typename?: "Attribute";
                  id: string;
                  name: string;
                } | null;
              }> | null;
            };
          };
        }> | null;
      };
    } | null;
    colors?: Array<{
      __typename?: "AssortmentSKUColor";
      id: string;
      attributeOptions: {
        __typename?: "AttributeOptionConnection";
        edges?: Array<{
          __typename?: "AttributeOptionEdge";
          node?: {
            __typename?: "AttributeOption";
            id: string;
            value: string;
            attribute: {
              __typename?: "AttributeEdge";
              node?: {
                __typename?: "Attribute";
                id: string;
                name: string;
              } | null;
            };
          } | null;
        }> | null;
      };
    }> | null;
  };
};

export type RemoveProductImageMutationVariables = Exact<{
  id: Scalars["String"];
}>;

export type RemoveProductImageMutation = {
  __typename?: "Mutation";
  AssortmentUI__removeProductImage?: {
    __typename?: "ImageRemoved";
    id: string;
  } | null;
};

export type RemoveSelectedAssortmentAttributeOptionsMutationVariables = Exact<{
  input: RemoveSelectedAssortmentAttributeOptionsInput;
}>;

export type RemoveSelectedAssortmentAttributeOptionsMutation = {
  __typename?: "Mutation";
  removeSelectedAssortmentAttributeOptions: {
    __typename?: "RemoveSelectedAssortmentAttributeOptionsPayload";
    assortment?: {
      __typename?: "Assortment";
      id: string;
      attributeOptions: {
        __typename?: "AttributeOptionConnection";
        edges?: Array<{
          __typename?: "AttributeOptionEdge";
          node?: { __typename?: "AttributeOption"; id: string } | null;
        }> | null;
      };
      priceModifiers: {
        __typename?: "PriceModifierConnection";
        edges?: Array<{
          __typename?: "PriceModifierEdge";
          node?: {
            __typename?: "PriceModifier";
            id: string;
            factor?: string | number | null;
            percent?: string | number | null;
            group: {
              __typename?: "PriceModifierGroupEdge";
              node: {
                __typename?: "PriceModifierGroup";
                id: string;
                name: string;
                adjustmentType?: AdjustmentTypeEnum | null;
                displayFormat?: DisplayFormatEnum | null;
              };
            };
          } | null;
        }> | null;
      };
      financialOverview: {
        __typename?: "AssortmentFinancialOverview";
        assortmentCurrencyCode: string;
        linesheetCurrencyCode: string;
        assortmentUnits: {
          __typename?: "AssortmentUnits";
          productCount?: number | null;
          colorCount?: number | null;
          skuCount?: number | null;
          unitCount?: number | null;
          unitDepth?: string | null;
        };
        financialDetails: Array<{
          __typename?: "AssortmentFinancialDetails";
          currencyCode: string;
          isBrandCurrency?: boolean | null;
          priceLevels: Array<{
            __typename?: "FinancialPriceLevel";
            name: FinancialPriceLevelName;
            initialMarkup: string | number;
            cost: { __typename?: "Money"; value: string | number };
            retail: { __typename?: "Money"; value: string | number };
            extendedCost: { __typename?: "Money"; value: string | number };
            extendedRetail: { __typename?: "Money"; value: string | number };
            averageUnitCost: { __typename?: "Money"; value: string | number };
            averageUnitRetail: { __typename?: "Money"; value: string | number };
          }>;
          units: {
            __typename?: "AssortmentUnits";
            productCount?: number | null;
            colorCount?: number | null;
            skuCount?: number | null;
            unitCount?: number | null;
            unitDepth?: string | null;
          };
        }>;
        financialTargets: {
          __typename?: "AssortmentFinancialTargets";
          priceTargets: {
            __typename?: "AssortmentFinancialPriceTargets";
            initialMarkup?: string | number | null;
            cost?: { __typename?: "Money"; value: string | number } | null;
            retail?: { __typename?: "Money"; value: string | number } | null;
            averageUnitCost?: {
              __typename?: "Money";
              value: string | number;
            } | null;
            averageUnitRetail?: {
              __typename?: "Money";
              value: string | number;
            } | null;
          };
          priceTargetsVariance: {
            __typename?: "AssortmentFinancialPriceTargets";
            initialMarkup?: string | number | null;
            cost?: { __typename?: "Money"; value: string | number } | null;
            retail?: { __typename?: "Money"; value: string | number } | null;
            averageUnitCost?: {
              __typename?: "Money";
              value: string | number;
            } | null;
            averageUnitRetail?: {
              __typename?: "Money";
              value: string | number;
            } | null;
          };
        };
      };
      validationRequirements: Array<{
        __typename?: "Validation";
        field: AssortmentValidationField;
        valid: boolean;
      }>;
      attributeValidationRequirements: Array<{
        __typename?: "AttributeValidation";
        valid: boolean;
        attribute: { __typename?: "Attribute"; id: string };
      }>;
    } | null;
  };
};

export type RetailBudgetQueryVariables = Exact<{
  assortmentOrWorkspaceId: Scalars["ID"];
}>;

export type RetailBudgetQuery = {
  __typename?: "Query";
  retailBudget?: {
    __typename?: "RetailBudget";
    id: string;
    workspaceOrAssortmentId: string;
    budgetType: BudgetType;
    finalExtCost?: string | number | null;
    finalExtRetail?: string | number | null;
    totalUnits?: string | number | null;
    finalExtCostCurrency?: string | null;
    finalExtRetailCurrency?: string | null;
    productTotals: {
      __typename?: "RetailBudgetCategoryTotals";
      finalExtCost: string | number;
      finalExtRetail: string | number;
      totalUnits: string | number;
    };
    categoryTotals: {
      __typename?: "RetailBudgetCategoryTotals";
      finalExtCost: string | number;
      finalExtRetail: string | number;
      totalUnits: string | number;
    };
    topLevelBudgetCategory?: {
      __typename?: "RetailBudgetCategory";
      id: string;
      categoryType: RetailBudgetCategoryType;
      child?: {
        __typename?: "RetailBudgetCategory";
        id: string;
        categoryType: RetailBudgetCategoryType;
        child?: {
          __typename?: "RetailBudgetCategory";
          id: string;
          categoryType: RetailBudgetCategoryType;
        } | null;
      } | null;
    } | null;
    categoryAmounts: Array<{
      __typename?: "RetailBudgetCategoryAmount";
      id: string;
      finalExtCost?: string | number | null;
      finalExtRetail?: string | number | null;
      totalUnits?: string | number | null;
      categoryAmounts?: Array<{
        __typename?: "RetailBudgetCategoryAmount";
        id: string;
        finalExtCost?: string | number | null;
        finalExtRetail?: string | number | null;
        totalUnits?: string | number | null;
        categoryAmounts?: Array<{
          __typename?: "RetailBudgetCategoryAmount";
          id: string;
          finalExtCost?: string | number | null;
          finalExtRetail?: string | number | null;
          totalUnits?: string | number | null;
          selection:
            | {
                __typename?: "AttributeOption";
                id: string;
                code: string;
                value: string;
              }
            | {
                __typename?: "MerchandisingHierarchyNode";
                id: string;
                name: string;
              }
            | { __typename?: "RetailerBrand"; id: string; name: string };
          categoryTotals: {
            __typename?: "RetailBudgetCategoryTotals";
            finalExtCost: string | number;
            finalExtRetail: string | number;
            totalUnits: string | number;
          };
          productTotals: {
            __typename?: "RetailBudgetCategoryTotals";
            finalExtCost: string | number;
            finalExtRetail: string | number;
            totalUnits: string | number;
          };
        }> | null;
        selection:
          | {
              __typename?: "AttributeOption";
              id: string;
              code: string;
              value: string;
            }
          | {
              __typename?: "MerchandisingHierarchyNode";
              id: string;
              name: string;
            }
          | { __typename?: "RetailerBrand"; id: string; name: string };
        categoryTotals: {
          __typename?: "RetailBudgetCategoryTotals";
          finalExtCost: string | number;
          finalExtRetail: string | number;
          totalUnits: string | number;
        };
        productTotals: {
          __typename?: "RetailBudgetCategoryTotals";
          finalExtCost: string | number;
          finalExtRetail: string | number;
          totalUnits: string | number;
        };
      }> | null;
      selection:
        | {
            __typename?: "AttributeOption";
            id: string;
            code: string;
            value: string;
          }
        | {
            __typename?: "MerchandisingHierarchyNode";
            id: string;
            name: string;
          }
        | { __typename?: "RetailerBrand"; id: string; name: string };
      categoryTotals: {
        __typename?: "RetailBudgetCategoryTotals";
        finalExtCost: string | number;
        finalExtRetail: string | number;
        totalUnits: string | number;
      };
      productTotals: {
        __typename?: "RetailBudgetCategoryTotals";
        finalExtCost: string | number;
        finalExtRetail: string | number;
        totalUnits: string | number;
      };
    }>;
  } | null;
};

export type RetailBudgetFragment = {
  __typename?: "RetailBudget";
  id: string;
  workspaceOrAssortmentId: string;
  budgetType: BudgetType;
  finalExtCost?: string | number | null;
  finalExtRetail?: string | number | null;
  totalUnits?: string | number | null;
  finalExtCostCurrency?: string | null;
  finalExtRetailCurrency?: string | null;
  productTotals: {
    __typename?: "RetailBudgetCategoryTotals";
    finalExtCost: string | number;
    finalExtRetail: string | number;
    totalUnits: string | number;
  };
  categoryTotals: {
    __typename?: "RetailBudgetCategoryTotals";
    finalExtCost: string | number;
    finalExtRetail: string | number;
    totalUnits: string | number;
  };
  topLevelBudgetCategory?: {
    __typename?: "RetailBudgetCategory";
    id: string;
    categoryType: RetailBudgetCategoryType;
    child?: {
      __typename?: "RetailBudgetCategory";
      id: string;
      categoryType: RetailBudgetCategoryType;
      child?: {
        __typename?: "RetailBudgetCategory";
        id: string;
        categoryType: RetailBudgetCategoryType;
      } | null;
    } | null;
  } | null;
  categoryAmounts: Array<{
    __typename?: "RetailBudgetCategoryAmount";
    id: string;
    finalExtCost?: string | number | null;
    finalExtRetail?: string | number | null;
    totalUnits?: string | number | null;
    categoryAmounts?: Array<{
      __typename?: "RetailBudgetCategoryAmount";
      id: string;
      finalExtCost?: string | number | null;
      finalExtRetail?: string | number | null;
      totalUnits?: string | number | null;
      categoryAmounts?: Array<{
        __typename?: "RetailBudgetCategoryAmount";
        id: string;
        finalExtCost?: string | number | null;
        finalExtRetail?: string | number | null;
        totalUnits?: string | number | null;
        selection:
          | {
              __typename?: "AttributeOption";
              id: string;
              code: string;
              value: string;
            }
          | {
              __typename?: "MerchandisingHierarchyNode";
              id: string;
              name: string;
            }
          | { __typename?: "RetailerBrand"; id: string; name: string };
        categoryTotals: {
          __typename?: "RetailBudgetCategoryTotals";
          finalExtCost: string | number;
          finalExtRetail: string | number;
          totalUnits: string | number;
        };
        productTotals: {
          __typename?: "RetailBudgetCategoryTotals";
          finalExtCost: string | number;
          finalExtRetail: string | number;
          totalUnits: string | number;
        };
      }> | null;
      selection:
        | {
            __typename?: "AttributeOption";
            id: string;
            code: string;
            value: string;
          }
        | {
            __typename?: "MerchandisingHierarchyNode";
            id: string;
            name: string;
          }
        | { __typename?: "RetailerBrand"; id: string; name: string };
      categoryTotals: {
        __typename?: "RetailBudgetCategoryTotals";
        finalExtCost: string | number;
        finalExtRetail: string | number;
        totalUnits: string | number;
      };
      productTotals: {
        __typename?: "RetailBudgetCategoryTotals";
        finalExtCost: string | number;
        finalExtRetail: string | number;
        totalUnits: string | number;
      };
    }> | null;
    selection:
      | {
          __typename?: "AttributeOption";
          id: string;
          code: string;
          value: string;
        }
      | { __typename?: "MerchandisingHierarchyNode"; id: string; name: string }
      | { __typename?: "RetailerBrand"; id: string; name: string };
    categoryTotals: {
      __typename?: "RetailBudgetCategoryTotals";
      finalExtCost: string | number;
      finalExtRetail: string | number;
      totalUnits: string | number;
    };
    productTotals: {
      __typename?: "RetailBudgetCategoryTotals";
      finalExtCost: string | number;
      finalExtRetail: string | number;
      totalUnits: string | number;
    };
  }>;
};

export type RetailBudgetCategoryFragment = {
  __typename?: "RetailBudgetCategory";
  id: string;
  categoryType: RetailBudgetCategoryType;
};

export type RetailBudgetCategoryAmountFragment = {
  __typename?: "RetailBudgetCategoryAmount";
  id: string;
  finalExtCost?: string | number | null;
  finalExtRetail?: string | number | null;
  totalUnits?: string | number | null;
  selection:
    | {
        __typename?: "AttributeOption";
        id: string;
        code: string;
        value: string;
      }
    | { __typename?: "MerchandisingHierarchyNode"; id: string; name: string }
    | { __typename?: "RetailerBrand"; id: string; name: string };
  categoryTotals: {
    __typename?: "RetailBudgetCategoryTotals";
    finalExtCost: string | number;
    finalExtRetail: string | number;
    totalUnits: string | number;
  };
  productTotals: {
    __typename?: "RetailBudgetCategoryTotals";
    finalExtCost: string | number;
    finalExtRetail: string | number;
    totalUnits: string | number;
  };
};

export type RetailerAssortmentAttributeOptionsFragment = {
  __typename?: "Retailer";
  assortmentAttributes: {
    __typename?: "AttributeConnection";
    edges?: Array<{
      __typename?: "AttributeEdge";
      node?: {
        __typename?: "Attribute";
        id: string;
        name: string;
        isRequired: boolean;
        availableOptions: {
          __typename?: "AttributeOptionConnection";
          edges?: Array<{
            __typename?: "AttributeOptionEdge";
            node?: {
              __typename?: "AttributeOption";
              id: string;
              value: string;
            } | null;
          }> | null;
        };
      } | null;
    }> | null;
  };
};

export type RetailerAttributesQueryVariables = Exact<{
  retailerId: Scalars["ID"];
}>;

export type RetailerAttributesQuery = {
  __typename?: "Query";
  retailer?: {
    __typename?: "Retailer";
    id: string;
    assortmentAttributes: {
      __typename?: "AttributeConnection";
      edges?: Array<{
        __typename?: "AttributeEdge";
        node?: {
          __typename?: "Attribute";
          id: string;
          name: string;
          availableOptions: {
            __typename?: "AttributeOptionConnection";
            edges?: Array<{
              __typename?: "AttributeOptionEdge";
              node?: {
                __typename?: "AttributeOption";
                id: string;
                code: string;
                value: string;
              } | null;
            }> | null;
          };
        } | null;
      }> | null;
    };
  } | null;
};

export type RetailerBrandsQueryVariables = Exact<{
  retailerId: Scalars["ID"];
}>;

export type RetailerBrandsQuery = {
  __typename?: "Query";
  retailer?: {
    __typename?: "Retailer";
    id: string;
    brands: {
      __typename?: "RetailerBrandConnection";
      edges: Array<{
        __typename?: "RetailerBrandEdge";
        id: string;
        code?: string | null;
        alias?: string | null;
        node?: { __typename?: "Brand"; id: string; name: string } | null;
      }>;
    };
  } | null;
};

export type RetailerDefaultExchangeCurrenciesQueryVariables = Exact<{
  retailerId: Scalars["ID"];
}>;

export type RetailerDefaultExchangeCurrenciesQuery = {
  __typename?: "Query";
  retailer?: {
    __typename?: "Retailer";
    id: string;
    currencyConversions: Array<{
      __typename?: "CurrencyConversion";
      fromCurrencyCode: string;
      toCurrencyCode: string;
      factor: string | number;
    }>;
  } | null;
};

export type SavedViewFragment = {
  __typename?: "Configuration";
  id: string;
  accountId: string;
  userId: string;
  name?: string | null;
  data: string;
  projectName?: string | null;
  visibility: ConfigurationVisibility;
  isDefault?: boolean | null;
};

export type SetAssortmentCurrencyConversionMutationVariables = Exact<{
  input:
    | Array<SetAssortmentCurrencyConversionInput>
    | SetAssortmentCurrencyConversionInput;
}>;

export type SetAssortmentCurrencyConversionMutation = {
  __typename?: "Mutation";
  setAssortmentCurrencyConversion: Array<{
    __typename?: "SetAssortmentCurrencyConversionPayload";
    assortmentCurrencyConversion?: {
      __typename?: "AssortmentCurrencyConversion";
      fromCurrencyCode: string;
      toCurrencyCode: string;
      factor: string | number;
      assortment: {
        __typename?: "Assortment";
        id: string;
        skus: {
          __typename?: "AssortmentSKUConnection";
          edges?: Array<{
            __typename?: "AssortmentSKUEdge";
            _id: string;
            priceLevels: Array<{
              __typename?: "PriceLevel";
              id: string;
              name: FinancialPriceLevelName;
              extendedWholesale: string | number;
              extendedRetail: string | number;
              maxRetail: string | number;
              maxWholesale: string | number;
              currencyCode: string;
              currencySource?: CurrencyFilter | null;
            }>;
          }> | null;
        };
        currencies: {
          __typename?: "AssortmentCurrencies";
          currencyConversions?: Array<{
            __typename?: "CurrencyConversion";
            conversionFactor: string | number;
            fromCurrency: string;
            toCurrency: string;
          }> | null;
        };
        financialOverview: {
          __typename?: "AssortmentFinancialOverview";
          assortmentCurrencyCode: string;
          linesheetCurrencyCode: string;
          assortmentUnits: {
            __typename?: "AssortmentUnits";
            productCount?: number | null;
            colorCount?: number | null;
            skuCount?: number | null;
            unitCount?: number | null;
            unitDepth?: string | null;
          };
          financialDetails: Array<{
            __typename?: "AssortmentFinancialDetails";
            currencyCode: string;
            isBrandCurrency?: boolean | null;
            priceLevels: Array<{
              __typename?: "FinancialPriceLevel";
              name: FinancialPriceLevelName;
              initialMarkup: string | number;
              cost: { __typename?: "Money"; value: string | number };
              retail: { __typename?: "Money"; value: string | number };
              extendedCost: { __typename?: "Money"; value: string | number };
              extendedRetail: { __typename?: "Money"; value: string | number };
              averageUnitCost: { __typename?: "Money"; value: string | number };
              averageUnitRetail: {
                __typename?: "Money";
                value: string | number;
              };
            }>;
            units: {
              __typename?: "AssortmentUnits";
              productCount?: number | null;
              colorCount?: number | null;
              skuCount?: number | null;
              unitCount?: number | null;
              unitDepth?: string | null;
            };
          }>;
          financialTargets: {
            __typename?: "AssortmentFinancialTargets";
            priceTargets: {
              __typename?: "AssortmentFinancialPriceTargets";
              initialMarkup?: string | number | null;
              cost?: { __typename?: "Money"; value: string | number } | null;
              retail?: { __typename?: "Money"; value: string | number } | null;
              averageUnitCost?: {
                __typename?: "Money";
                value: string | number;
              } | null;
              averageUnitRetail?: {
                __typename?: "Money";
                value: string | number;
              } | null;
            };
            priceTargetsVariance: {
              __typename?: "AssortmentFinancialPriceTargets";
              initialMarkup?: string | number | null;
              cost?: { __typename?: "Money"; value: string | number } | null;
              retail?: { __typename?: "Money"; value: string | number } | null;
              averageUnitCost?: {
                __typename?: "Money";
                value: string | number;
              } | null;
              averageUnitRetail?: {
                __typename?: "Money";
                value: string | number;
              } | null;
            };
          };
        };
      };
    } | null;
  }>;
};

export type SetAssortmentDoorsMutationVariables = Exact<{
  input: SetAssortmentDoorsInput;
}>;

export type SetAssortmentDoorsMutation = {
  __typename?: "Mutation";
  setAssortmentDoors: {
    __typename?: "SetAssortmentDoorsPayload";
    assortment: {
      __typename?: "Assortment";
      id: string;
      doors: {
        __typename?: "AssortmentDoorConnection";
        edges?: Array<{
          __typename?: "AssortmentDoorEdge";
          node?: {
            __typename?: "Door";
            id: string;
            name: string;
            code: string;
          } | null;
        }> | null;
      };
      skus: {
        __typename?: "AssortmentSKUConnection";
        edges?: Array<{
          __typename?: "AssortmentSKUEdge";
          _id: string;
          doorQuantities: Array<{
            __typename?: "AssortmentSKUDoorQuantity";
            id: string;
            quantity: number;
            appliedSizeRatio?: string | number | null;
            door?: { __typename?: "Door"; id: string } | null;
          }>;
        }> | null;
      };
      validationRequirements: Array<{
        __typename?: "Validation";
        field: AssortmentValidationField;
        valid: boolean;
      }>;
      doorClusters: {
        __typename?: "AssortmentDoorClusterConnection";
        edges?: Array<{
          __typename?: "AssortmentDoorClusterEdge";
          node?: {
            __typename?: "DoorCluster";
            id: string;
            name?: string | null;
            code?: string | null;
            doors?: {
              __typename?: "DoorClusterDoorConnection";
              edges?: Array<{
                __typename?: "DoorClusterDoorEdge";
                node?: {
                  __typename?: "Door";
                  id: string;
                  name: string;
                  code: string;
                } | null;
              }> | null;
            } | null;
          } | null;
        }> | null;
      };
    };
  };
};

export type SetAssortmentSkuFinalRetailPriceMutationVariables = Exact<{
  input: SetAssortmentSkuFinalRetailPriceInput;
  assortmentSkuIds: Array<Scalars["ID"]> | Scalars["ID"];
}>;

export type SetAssortmentSkuFinalRetailPriceMutation = {
  __typename?: "Mutation";
  setAssortmentSkuFinalRetailPrice: {
    __typename?: "SetAssortmentSkuFinalRetailPricePayload";
    query?: {
      __typename?: "Query";
      assortmentSkus: {
        __typename?: "AssortmentSKUConnection";
        edges?: Array<{
          __typename?: "AssortmentSKUEdge";
          _id: string;
          wholesaleCurrencyCode?: string | null;
          retailCurrencyCode?: string | null;
          node: { __typename?: "SKU"; id: string };
          style: { __typename?: "Style"; id: string };
          priceLevels: Array<{
            __typename?: "PriceLevel";
            id: string;
            name: FinancialPriceLevelName;
            extendedWholesale: string | number;
            extendedRetail: string | number;
            maxRetail: string | number;
            maxWholesale: string | number;
            currencyCode: string;
            currencySource?: CurrencyFilter | null;
          }>;
        }> | null;
      };
    } | null;
  };
};

export type SetAssortmentSkuUpcMutationVariables = Exact<{
  input: SetAssortmentSkuUpcInput;
  assortmentSkuIds: Array<Scalars["ID"]> | Scalars["ID"];
}>;

export type SetAssortmentSkuUpcMutation = {
  __typename?: "Mutation";
  setAssortmentSkuUpc: {
    __typename?: "SetAssortmentSkuUpcPayload";
    query?: {
      __typename?: "Query";
      assortmentSkus: {
        __typename?: "AssortmentSKUConnection";
        edges?: Array<{
          __typename?: "AssortmentSKUEdge";
          _id: string;
          upc?: string | null;
          node: { __typename?: "SKU"; id: string };
        }> | null;
      };
    } | null;
  };
};

export type SetDefaultDoorsAndClustersMutationVariables = Exact<{
  input: SetAssormentDefaultDoorClustersInput;
}>;

export type SetDefaultDoorsAndClustersMutation = {
  __typename?: "Mutation";
  setAssortmentDefaultDoorClusters: {
    __typename?: "SetAssortmentDefaultDoorClustersPayload";
    doorIds?: Array<string> | null;
    clusterIds?: Array<string> | null;
  };
};

export type SetDoorBulkQuantityMutationVariables = Exact<{
  input: SetAssortmentColorBulkDoorQuantityInput;
  assortmentSkuIds: Array<Scalars["ID"]> | Scalars["ID"];
}>;

export type SetDoorBulkQuantityMutation = {
  __typename?: "Mutation";
  setAssortmentColorBulkDoorQuantity?: {
    __typename?: "SetAssortmentColorBulkDoorQuantityPayload";
    query?: {
      __typename?: "Query";
      assortmentSkus: {
        __typename?: "AssortmentSKUConnection";
        edges?: Array<{
          __typename?: "AssortmentSKUEdge";
          _id: string;
          bulkQuantity: number;
          node: { __typename?: "SKU"; id: string };
          color: {
            __typename?: "AssortmentSKUColor";
            id: string;
            totalSizedQuantity: number;
            bulkQuantity: number;
            sizeCurves: {
              __typename?: "RetailSizeCurves";
              missingFields: Array<RetailSizeCurvesMissingFields>;
              doorSizeCurves: Array<{
                __typename?: "RetailDoorSizeCurves";
                door: { __typename?: "Door"; id: string };
                curveRatios: Array<{
                  __typename?: "SizeCurveRatio";
                  ratio: string | number;
                  retailSize: {
                    __typename?: "RetailSize";
                    id: string;
                    code?: string | null;
                    name?: string | null;
                  };
                }>;
              }>;
            };
            doorQuantities: Array<{
              __typename?: "AssortmentSKUColorDoorQuantity";
              id: string;
              bulkQuantity: number;
              totalSizedQuantity: number;
              door?: { __typename?: "Door"; id: string } | null;
            }>;
          };
          priceLevels: Array<{
            __typename?: "PriceLevel";
            id: string;
            name: FinancialPriceLevelName;
            extendedWholesale: string | number;
            extendedRetail: string | number;
            maxRetail: string | number;
            maxWholesale: string | number;
            currencyCode: string;
            currencySource?: CurrencyFilter | null;
          }>;
          doorQuantities: Array<{
            __typename?: "AssortmentSKUDoorQuantity";
            id: string;
            quantity: number;
            appliedSizeRatio?: string | number | null;
            door?: { __typename?: "Door"; id: string } | null;
          }>;
        }> | null;
      };
    } | null;
  } | null;
};

export type SetDoorSizeQuantityMutationVariables = Exact<{
  doorOrClusterId: Scalars["ID"];
  assortmentId: Scalars["ID"];
  skuId: Scalars["ID"];
  assortmentSkuIds: Array<Scalars["ID"]> | Scalars["ID"];
  quantity: Scalars["Int"];
}>;

export type SetDoorSizeQuantityMutation = {
  __typename?: "Mutation";
  setAssortmentSkuDoorLineItemQuantities: Array<{
    __typename?: "AssortmentSkuDoorLineItemQuantityPayload";
    assortment: {
      __typename?: "Assortment";
      id: string;
      validationRequirements: Array<{
        __typename?: "Validation";
        field: AssortmentValidationField;
        valid: boolean;
      }>;
      attributeValidationRequirements: Array<{
        __typename?: "AttributeValidation";
        valid: boolean;
        attribute: { __typename?: "Attribute"; id: string };
      }>;
    };
    query?: {
      __typename?: "Query";
      assortmentSkus: {
        __typename?: "AssortmentSKUConnection";
        edges?: Array<{
          __typename?: "AssortmentSKUEdge";
          _id: string;
          bulkQuantity: number;
          node: { __typename?: "SKU"; id: string };
          color: {
            __typename?: "AssortmentSKUColor";
            id: string;
            totalSizedQuantity: number;
            bulkQuantity: number;
            sizeCurves: {
              __typename?: "RetailSizeCurves";
              missingFields: Array<RetailSizeCurvesMissingFields>;
              doorSizeCurves: Array<{
                __typename?: "RetailDoorSizeCurves";
                door: { __typename?: "Door"; id: string };
                curveRatios: Array<{
                  __typename?: "SizeCurveRatio";
                  ratio: string | number;
                  retailSize: {
                    __typename?: "RetailSize";
                    id: string;
                    code?: string | null;
                    name?: string | null;
                  };
                }>;
              }>;
            };
            doorQuantities: Array<{
              __typename?: "AssortmentSKUColorDoorQuantity";
              id: string;
              bulkQuantity: number;
              totalSizedQuantity: number;
              door?: { __typename?: "Door"; id: string } | null;
            }>;
          };
          priceLevels: Array<{
            __typename?: "PriceLevel";
            id: string;
            name: FinancialPriceLevelName;
            extendedWholesale: string | number;
            extendedRetail: string | number;
            maxRetail: string | number;
            maxWholesale: string | number;
            currencyCode: string;
            currencySource?: CurrencyFilter | null;
          }>;
          doorQuantities: Array<{
            __typename?: "AssortmentSKUDoorQuantity";
            id: string;
            quantity: number;
            appliedSizeRatio?: string | number | null;
            door?: { __typename?: "Door"; id: string } | null;
          }>;
        }> | null;
      };
    } | null;
  }>;
};

export type SetPriceModifierValueMutationVariables = Exact<{
  input:
    | Array<GenericSetPriceModifierValueInput>
    | GenericSetPriceModifierValueInput;
}>;

export type SetPriceModifierValueMutation = {
  __typename?: "Mutation";
  genericSetPriceModifierValue: Array<{
    __typename?: "SetPriceModifierValuePayload";
    deletePriceModifierId?: string | null;
    priceModifier?: {
      __typename?: "PriceModifier";
      id: string;
      factor?: string | number | null;
      group: {
        __typename?: "PriceModifierGroupEdge";
        node: { __typename?: "PriceModifierGroup"; id: string };
      };
    } | null;
    assortment: {
      __typename?: "Assortment";
      id: string;
      skus: {
        __typename?: "AssortmentSKUConnection";
        edges?: Array<{
          __typename?: "AssortmentSKUEdge";
          _id: string;
          priceLevels: Array<{
            __typename?: "PriceLevel";
            id: string;
            name: FinancialPriceLevelName;
            extendedWholesale: string | number;
            extendedRetail: string | number;
            maxRetail: string | number;
            maxWholesale: string | number;
            currencyCode: string;
            currencySource?: CurrencyFilter | null;
          }>;
        }> | null;
      };
      financialOverview: {
        __typename?: "AssortmentFinancialOverview";
        assortmentCurrencyCode: string;
        linesheetCurrencyCode: string;
        assortmentUnits: {
          __typename?: "AssortmentUnits";
          productCount?: number | null;
          colorCount?: number | null;
          skuCount?: number | null;
          unitCount?: number | null;
          unitDepth?: string | null;
        };
        financialDetails: Array<{
          __typename?: "AssortmentFinancialDetails";
          currencyCode: string;
          isBrandCurrency?: boolean | null;
          priceLevels: Array<{
            __typename?: "FinancialPriceLevel";
            name: FinancialPriceLevelName;
            initialMarkup: string | number;
            cost: { __typename?: "Money"; value: string | number };
            retail: { __typename?: "Money"; value: string | number };
            extendedCost: { __typename?: "Money"; value: string | number };
            extendedRetail: { __typename?: "Money"; value: string | number };
            averageUnitCost: { __typename?: "Money"; value: string | number };
            averageUnitRetail: { __typename?: "Money"; value: string | number };
          }>;
          units: {
            __typename?: "AssortmentUnits";
            productCount?: number | null;
            colorCount?: number | null;
            skuCount?: number | null;
            unitCount?: number | null;
            unitDepth?: string | null;
          };
        }>;
        financialTargets: {
          __typename?: "AssortmentFinancialTargets";
          priceTargets: {
            __typename?: "AssortmentFinancialPriceTargets";
            initialMarkup?: string | number | null;
            cost?: { __typename?: "Money"; value: string | number } | null;
            retail?: { __typename?: "Money"; value: string | number } | null;
            averageUnitCost?: {
              __typename?: "Money";
              value: string | number;
            } | null;
            averageUnitRetail?: {
              __typename?: "Money";
              value: string | number;
            } | null;
          };
          priceTargetsVariance: {
            __typename?: "AssortmentFinancialPriceTargets";
            initialMarkup?: string | number | null;
            cost?: { __typename?: "Money"; value: string | number } | null;
            retail?: { __typename?: "Money"; value: string | number } | null;
            averageUnitCost?: {
              __typename?: "Money";
              value: string | number;
            } | null;
            averageUnitRetail?: {
              __typename?: "Money";
              value: string | number;
            } | null;
          };
        };
      };
      priceModifiers: {
        __typename?: "PriceModifierConnection";
        edges?: Array<{
          __typename?: "PriceModifierEdge";
          node?: {
            __typename?: "PriceModifier";
            id: string;
            factor?: string | number | null;
            percent?: string | number | null;
            group: {
              __typename?: "PriceModifierGroupEdge";
              node: {
                __typename?: "PriceModifierGroup";
                id: string;
                name: string;
                adjustmentType?: AdjustmentTypeEnum | null;
                displayFormat?: DisplayFormatEnum | null;
              };
            };
          } | null;
        }> | null;
      };
    };
  }>;
};

export type SetPriceSkuEdgesFragment = {
  __typename?: "AssortmentSKUEdge";
  _id: string;
  wholesaleCurrencyCode?: string | null;
  retailCurrencyCode?: string | null;
  node: { __typename?: "SKU"; id: string };
  style: { __typename?: "Style"; id: string };
  priceLevels: Array<{
    __typename?: "PriceLevel";
    id: string;
    name: FinancialPriceLevelName;
    extendedWholesale: string | number;
    extendedRetail: string | number;
    maxRetail: string | number;
    maxWholesale: string | number;
    currencyCode: string;
    currencySource?: CurrencyFilter | null;
  }>;
};

export type SetProductRetailPriceMutationVariables = Exact<{
  input: SetAssortmentProductRetailPriceInput;
  assortmentSkuIds: Array<Scalars["ID"]> | Scalars["ID"];
}>;

export type SetProductRetailPriceMutation = {
  __typename?: "Mutation";
  setAssortmentProductRetailPrice: {
    __typename?: "SetAssortmentProductPricePayload";
    query?: {
      __typename?: "Query";
      assortmentSkus: {
        __typename?: "AssortmentSKUConnection";
        edges?: Array<{
          __typename?: "AssortmentSKUEdge";
          _id: string;
          wholesaleCurrencyCode?: string | null;
          retailCurrencyCode?: string | null;
          node: { __typename?: "SKU"; id: string };
          style: { __typename?: "Style"; id: string };
          priceLevels: Array<{
            __typename?: "PriceLevel";
            id: string;
            name: FinancialPriceLevelName;
            extendedWholesale: string | number;
            extendedRetail: string | number;
            maxRetail: string | number;
            maxWholesale: string | number;
            currencyCode: string;
            currencySource?: CurrencyFilter | null;
          }>;
        }> | null;
      };
    } | null;
  };
};

export type SetProductSizeRunMutationVariables = Exact<{
  productId: Scalars["ID"];
  sizeRunId: Scalars["ID"];
  assortmentSkuIds: Array<Scalars["ID"]> | Scalars["ID"];
}>;

export type SetProductSizeRunMutation = {
  __typename?: "Mutation";
  setProductSizeRun?: {
    __typename?: "SetProductSizeRunResponse";
    query?: {
      __typename?: "Query";
      assortmentSkus: {
        __typename?: "AssortmentSKUConnection";
        edges?: Array<{
          __typename?: "AssortmentSKUEdge";
          _id: string;
          color: {
            __typename?: "AssortmentSKUColor";
            id: string;
            sizeCurves: {
              __typename?: "RetailSizeCurves";
              missingFields: Array<RetailSizeCurvesMissingFields>;
              doorSizeCurves: Array<{
                __typename?: "RetailDoorSizeCurves";
                door: { __typename?: "Door"; id: string };
                curveRatios: Array<{
                  __typename?: "SizeCurveRatio";
                  ratio: string | number;
                  retailSize: {
                    __typename?: "RetailSize";
                    id: string;
                    code?: string | null;
                    name?: string | null;
                  };
                }>;
              }>;
            };
          };
          node: { __typename?: "SKU"; id: string };
          style: { __typename?: "Style"; id: string };
          sizeRun?: {
            __typename?: "SizeRunEdge";
            node?: {
              __typename?: "SizeRun";
              id: string;
              code?: string | null;
              name?: string | null;
            } | null;
          } | null;
          retailSize?: {
            __typename?: "RetailSize";
            id: string;
            code?: string | null;
            name?: string | null;
          } | null;
          availableRetailSizeOptions: Array<{
            __typename?: "RetailSize";
            code?: string | null;
            id: string;
            name?: string | null;
          }>;
        }> | null;
      };
    } | null;
  } | null;
};

export type SetProductWholesalePriceMutationVariables = Exact<{
  input: SetAssortmentProductWholesalePriceInput;
  assortmentSkuIds: Array<Scalars["ID"]> | Scalars["ID"];
}>;

export type SetProductWholesalePriceMutation = {
  __typename?: "Mutation";
  setAssortmentProductWholesalePrice: {
    __typename?: "SetAssortmentProductWholesalePricePayload";
    query?: {
      __typename?: "Query";
      assortmentSkus: {
        __typename?: "AssortmentSKUConnection";
        edges?: Array<{
          __typename?: "AssortmentSKUEdge";
          _id: string;
          wholesaleCurrencyCode?: string | null;
          retailCurrencyCode?: string | null;
          node: { __typename?: "SKU"; id: string };
          style: { __typename?: "Style"; id: string };
          priceLevels: Array<{
            __typename?: "PriceLevel";
            id: string;
            name: FinancialPriceLevelName;
            extendedWholesale: string | number;
            extendedRetail: string | number;
            maxRetail: string | number;
            maxWholesale: string | number;
            currencyCode: string;
            currencySource?: CurrencyFilter | null;
          }>;
        }> | null;
      };
    } | null;
  };
};

export type SetRetailerProductSizesOnAssortmentMutationVariables = Exact<{
  input: SetRetailerProductSizesOnAssortmentInput;
}>;

export type SetRetailerProductSizesOnAssortmentMutation = {
  __typename?: "Mutation";
  setRetailerProductSizesOnAssortment: {
    __typename?: "SetRetailerProductSizesOnAssortmentPayload";
    assortment?: {
      __typename?: "Assortment";
      id: string;
      skus: {
        __typename?: "AssortmentSKUConnection";
        edges?: Array<{
          __typename?: "AssortmentSKUEdge";
          _id: string;
          legacyItemId: string;
          comment?: string | null;
          isCustom?: boolean | null;
          upc?: string | null;
          wholesaleCurrencyCode?: string | null;
          retailCurrencyCode?: string | null;
          bulkQuantity: number;
          node: {
            __typename?: "SKU";
            id: string;
            color: { __typename?: "Color"; id: string };
            size: {
              __typename?: "Size";
              id: string;
              code: string;
              name: string;
            };
          };
          style: {
            __typename?: "Style";
            name?: string | null;
            code?: string | null;
            id: string;
            description?: string | null;
            images: {
              __typename?: "ImageConnection";
              edges: Array<{
                __typename?: "ImageEdge";
                node: {
                  __typename?: "Image";
                  id: string;
                  url: any;
                  owner?: {
                    __typename?: "ImageOwnerAccount";
                    id: string;
                  } | null;
                };
              }>;
            };
            details: {
              __typename?: "StyleDetails";
              countryOfOrigin?: string | null;
              furStatus?: FurStatus | null;
              heelHeight?: string | null;
              measurements?: string | null;
              modelHeightInches?: number | null;
              sourceOfMaterials?: string | null;
              categories: Array<{
                __typename?: "Category";
                id?: string | null;
                name: string;
              }>;
              materials?: Array<{
                __typename?: "Material";
                name: string;
              } | null> | null;
              silhouette?: { __typename?: "Silhouette"; name: string } | null;
              fabrication?: { __typename?: "Fabrication"; name: string } | null;
            };
          };
          color: {
            __typename?: "AssortmentSKUColor";
            id: string;
            name: string;
            code: string;
            comment?: string | null;
            totalSizedQuantity: number;
            bulkQuantity: number;
            swatch: {
              __typename?: "ColorSwatch";
              hex?: string | null;
              rgb?: {
                __typename?: "RGB";
                red: number;
                green: number;
                blue: number;
              } | null;
              image?: {
                __typename?: "ImageEdge";
                node: {
                  __typename?: "Image";
                  id: string;
                  url: any;
                  owner?: {
                    __typename?: "ImageOwnerAccount";
                    id: string;
                  } | null;
                };
              } | null;
            };
            images: {
              __typename?: "ImageConnection";
              edges: Array<{
                __typename?: "ImageEdge";
                node: {
                  __typename?: "Image";
                  id: string;
                  url: any;
                  owner?: {
                    __typename?: "ImageOwnerAccount";
                    id: string;
                  } | null;
                };
              }>;
            };
            doorQuantities: Array<{
              __typename?: "AssortmentSKUColorDoorQuantity";
              id: string;
              bulkQuantity: number;
              totalSizedQuantity: number;
              door?: { __typename?: "Door"; id: string } | null;
            }>;
            attributeOptions: {
              __typename?: "AttributeOptionConnection";
              edges?: Array<{
                __typename?: "AttributeOptionEdge";
                node?: {
                  __typename?: "AttributeOption";
                  id: string;
                  value: string;
                  attribute: {
                    __typename?: "AttributeEdge";
                    node?: {
                      __typename?: "Attribute";
                      id: string;
                      name: string;
                    } | null;
                  };
                } | null;
              }> | null;
            };
            sizeCurves: {
              __typename?: "RetailSizeCurves";
              missingFields: Array<RetailSizeCurvesMissingFields>;
              doorSizeCurves: Array<{
                __typename?: "RetailDoorSizeCurves";
                door: { __typename?: "Door"; id: string };
                curveRatios: Array<{
                  __typename?: "SizeCurveRatio";
                  ratio: string | number;
                  retailSize: {
                    __typename?: "RetailSize";
                    id: string;
                    code?: string | null;
                    name?: string | null;
                  };
                }>;
              }>;
            };
          };
          size: { __typename?: "Size"; id: string; code: string; name: string };
          sizeRun?: {
            __typename?: "SizeRunEdge";
            node?: {
              __typename?: "SizeRun";
              id: string;
              code?: string | null;
              name?: string | null;
            } | null;
          } | null;
          retailSize?: {
            __typename?: "RetailSize";
            code?: string | null;
            id: string;
            name?: string | null;
          } | null;
          availableRetailSizeOptions: Array<{
            __typename?: "RetailSize";
            code?: string | null;
            id: string;
            name?: string | null;
          }>;
          priceLevels: Array<{
            __typename?: "PriceLevel";
            id: string;
            name: FinancialPriceLevelName;
            extendedWholesale: string | number;
            extendedRetail: string | number;
            maxRetail: string | number;
            maxWholesale: string | number;
            currencyCode: string;
            currencySource?: CurrencyFilter | null;
          }>;
          doorQuantities: Array<{
            __typename?: "AssortmentSKUDoorQuantity";
            id: string;
            quantity: number;
            appliedSizeRatio?: string | number | null;
            door?: { __typename?: "Door"; id: string } | null;
          }>;
        }> | null;
      };
      financialOverview: {
        __typename?: "AssortmentFinancialOverview";
        assortmentCurrencyCode: string;
        linesheetCurrencyCode: string;
        assortmentUnits: {
          __typename?: "AssortmentUnits";
          productCount?: number | null;
          colorCount?: number | null;
          skuCount?: number | null;
          unitCount?: number | null;
          unitDepth?: string | null;
        };
        financialDetails: Array<{
          __typename?: "AssortmentFinancialDetails";
          currencyCode: string;
          isBrandCurrency?: boolean | null;
          priceLevels: Array<{
            __typename?: "FinancialPriceLevel";
            name: FinancialPriceLevelName;
            initialMarkup: string | number;
            cost: { __typename?: "Money"; value: string | number };
            retail: { __typename?: "Money"; value: string | number };
            extendedCost: { __typename?: "Money"; value: string | number };
            extendedRetail: { __typename?: "Money"; value: string | number };
            averageUnitCost: { __typename?: "Money"; value: string | number };
            averageUnitRetail: { __typename?: "Money"; value: string | number };
          }>;
          units: {
            __typename?: "AssortmentUnits";
            productCount?: number | null;
            colorCount?: number | null;
            skuCount?: number | null;
            unitCount?: number | null;
            unitDepth?: string | null;
          };
        }>;
        financialTargets: {
          __typename?: "AssortmentFinancialTargets";
          priceTargets: {
            __typename?: "AssortmentFinancialPriceTargets";
            initialMarkup?: string | number | null;
            cost?: { __typename?: "Money"; value: string | number } | null;
            retail?: { __typename?: "Money"; value: string | number } | null;
            averageUnitCost?: {
              __typename?: "Money";
              value: string | number;
            } | null;
            averageUnitRetail?: {
              __typename?: "Money";
              value: string | number;
            } | null;
          };
          priceTargetsVariance: {
            __typename?: "AssortmentFinancialPriceTargets";
            initialMarkup?: string | number | null;
            cost?: { __typename?: "Money"; value: string | number } | null;
            retail?: { __typename?: "Money"; value: string | number } | null;
            averageUnitCost?: {
              __typename?: "Money";
              value: string | number;
            } | null;
            averageUnitRetail?: {
              __typename?: "Money";
              value: string | number;
            } | null;
          };
        };
      };
    } | null;
  };
};

export type SetSelectedAssortmentAttributeOptionsMutationVariables = Exact<{
  input: SetSelectedAssortmentAttributeOptionsInput;
  assortmentId: Scalars["ID"];
}>;

export type SetSelectedAssortmentAttributeOptionsMutation = {
  __typename?: "Mutation";
  setSelectedAssortmentAttributeOptions: {
    __typename?: "SetSelectedAssortmentAttributeOptionsPayload";
    assortment?: {
      __typename?: "Assortment";
      id: string;
      attributeOptions: {
        __typename?: "AttributeOptionConnection";
        edges?: Array<{
          __typename?: "AttributeOptionEdge";
          node?: {
            __typename?: "AttributeOption";
            id: string;
            value: string;
            name: string;
            attribute: {
              __typename?: "AttributeEdge";
              node?: { __typename?: "Attribute"; id: string } | null;
            };
          } | null;
        }> | null;
      };
      retailer: {
        __typename?: "RetailerEdge";
        node?: {
          __typename?: "Retailer";
          id: string;
          assortmentAttributes: {
            __typename?: "AttributeConnection";
            edges?: Array<{
              __typename?: "AttributeEdge";
              node?: {
                __typename?: "Attribute";
                id: string;
                name: string;
                isRequired: boolean;
                availableOptions: {
                  __typename?: "AttributeOptionConnection";
                  edges?: Array<{
                    __typename?: "AttributeOptionEdge";
                    node?: {
                      __typename?: "AttributeOption";
                      id: string;
                      value: string;
                    } | null;
                  }> | null;
                };
              } | null;
            }> | null;
          };
        } | null;
      };
      priceModifiers: {
        __typename?: "PriceModifierConnection";
        edges?: Array<{
          __typename?: "PriceModifierEdge";
          node?: {
            __typename?: "PriceModifier";
            id: string;
            factor?: string | number | null;
            percent?: string | number | null;
            group: {
              __typename?: "PriceModifierGroupEdge";
              node: {
                __typename?: "PriceModifierGroup";
                id: string;
                name: string;
                adjustmentType?: AdjustmentTypeEnum | null;
                displayFormat?: DisplayFormatEnum | null;
              };
            };
          } | null;
        }> | null;
      };
      financialOverview: {
        __typename?: "AssortmentFinancialOverview";
        assortmentCurrencyCode: string;
        linesheetCurrencyCode: string;
        assortmentUnits: {
          __typename?: "AssortmentUnits";
          productCount?: number | null;
          colorCount?: number | null;
          skuCount?: number | null;
          unitCount?: number | null;
          unitDepth?: string | null;
        };
        financialDetails: Array<{
          __typename?: "AssortmentFinancialDetails";
          currencyCode: string;
          isBrandCurrency?: boolean | null;
          priceLevels: Array<{
            __typename?: "FinancialPriceLevel";
            name: FinancialPriceLevelName;
            initialMarkup: string | number;
            cost: { __typename?: "Money"; value: string | number };
            retail: { __typename?: "Money"; value: string | number };
            extendedCost: { __typename?: "Money"; value: string | number };
            extendedRetail: { __typename?: "Money"; value: string | number };
            averageUnitCost: { __typename?: "Money"; value: string | number };
            averageUnitRetail: { __typename?: "Money"; value: string | number };
          }>;
          units: {
            __typename?: "AssortmentUnits";
            productCount?: number | null;
            colorCount?: number | null;
            skuCount?: number | null;
            unitCount?: number | null;
            unitDepth?: string | null;
          };
        }>;
        financialTargets: {
          __typename?: "AssortmentFinancialTargets";
          priceTargets: {
            __typename?: "AssortmentFinancialPriceTargets";
            initialMarkup?: string | number | null;
            cost?: { __typename?: "Money"; value: string | number } | null;
            retail?: { __typename?: "Money"; value: string | number } | null;
            averageUnitCost?: {
              __typename?: "Money";
              value: string | number;
            } | null;
            averageUnitRetail?: {
              __typename?: "Money";
              value: string | number;
            } | null;
          };
          priceTargetsVariance: {
            __typename?: "AssortmentFinancialPriceTargets";
            initialMarkup?: string | number | null;
            cost?: { __typename?: "Money"; value: string | number } | null;
            retail?: { __typename?: "Money"; value: string | number } | null;
            averageUnitCost?: {
              __typename?: "Money";
              value: string | number;
            } | null;
            averageUnitRetail?: {
              __typename?: "Money";
              value: string | number;
            } | null;
          };
        };
      };
      validationRequirements: Array<{
        __typename?: "Validation";
        field: AssortmentValidationField;
        valid: boolean;
      }>;
      attributeValidationRequirements: Array<{
        __typename?: "AttributeValidation";
        valid: boolean;
        attribute: { __typename?: "Attribute"; id: string };
      }>;
    } | null;
  };
};

export type SetSkuItemPropertyMutationVariables = Exact<{
  legacyDetailId: Scalars["ID"];
  name: Scalars["String"];
  value: Scalars["String"];
  assortmentSkuIds: Array<Scalars["ID"]> | Scalars["ID"];
}>;

export type SetSkuItemPropertyMutation = {
  __typename?: "Mutation";
  setSkuItemProperty: {
    __typename?: "SetSkuItemPropertyPayload";
    query?: {
      __typename?: "Query";
      assortmentSkus: {
        __typename?: "AssortmentSKUConnection";
        edges?: Array<{
          __typename?: "AssortmentSKUEdge";
          _id: string;
          legacyItemId: string;
          comment?: string | null;
          style: {
            __typename?: "Style";
            id: string;
            name?: string | null;
            code?: string | null;
            description?: string | null;
            details: {
              __typename?: "StyleDetails";
              countryOfOrigin?: string | null;
              furStatus?: FurStatus | null;
              heelHeight?: string | null;
              measurements?: string | null;
              modelHeightInches?: number | null;
              sourceOfMaterials?: string | null;
              categories: Array<{
                __typename?: "Category";
                id?: string | null;
                name: string;
              }>;
              materials?: Array<{
                __typename?: "Material";
                name: string;
              } | null> | null;
              silhouette?: { __typename?: "Silhouette"; name: string } | null;
              fabrication?: { __typename?: "Fabrication"; name: string } | null;
            };
          };
          color: {
            __typename?: "AssortmentSKUColor";
            id: string;
            name: string;
            code: string;
            comment?: string | null;
          };
        }> | null;
      };
    } | null;
  };
};

export type SetSkuRetailPriceMutationVariables = Exact<{
  input: SetAssortmentSkuRetailPriceInput;
  assortmentSkuIds: Array<Scalars["ID"]> | Scalars["ID"];
}>;

export type SetSkuRetailPriceMutation = {
  __typename?: "Mutation";
  setAssortmentSkuRetailPrice: {
    __typename?: "SetAssortmentSkuRetailPricePayload";
    query?: {
      __typename?: "Query";
      assortmentSkus: {
        __typename?: "AssortmentSKUConnection";
        edges?: Array<{
          __typename?: "AssortmentSKUEdge";
          _id: string;
          wholesaleCurrencyCode?: string | null;
          retailCurrencyCode?: string | null;
          node: { __typename?: "SKU"; id: string };
          style: { __typename?: "Style"; id: string };
          priceLevels: Array<{
            __typename?: "PriceLevel";
            id: string;
            name: FinancialPriceLevelName;
            extendedWholesale: string | number;
            extendedRetail: string | number;
            maxRetail: string | number;
            maxWholesale: string | number;
            currencyCode: string;
            currencySource?: CurrencyFilter | null;
          }>;
        }> | null;
      };
    } | null;
  };
};

export type SetSkuRetailSizeMutationVariables = Exact<{
  skuId: Scalars["ID"];
  retailSizeId: Scalars["ID"];
  assortmentId?: InputMaybe<Scalars["ID"]>;
  assortmentSkuIds: Array<Scalars["ID"]> | Scalars["ID"];
}>;

export type SetSkuRetailSizeMutation = {
  __typename?: "Mutation";
  setSkuRetailSize?: {
    __typename?: "SetSkuRetailSizeResponse";
    query?: {
      __typename?: "Query";
      assortmentSkus: {
        __typename?: "AssortmentSKUConnection";
        edges?: Array<{
          __typename?: "AssortmentSKUEdge";
          _id: string;
          color: {
            __typename?: "AssortmentSKUColor";
            id: string;
            sizeCurves: {
              __typename?: "RetailSizeCurves";
              missingFields: Array<RetailSizeCurvesMissingFields>;
              doorSizeCurves: Array<{
                __typename?: "RetailDoorSizeCurves";
                door: { __typename?: "Door"; id: string };
                curveRatios: Array<{
                  __typename?: "SizeCurveRatio";
                  ratio: string | number;
                  retailSize: {
                    __typename?: "RetailSize";
                    id: string;
                    code?: string | null;
                    name?: string | null;
                  };
                }>;
              }>;
            };
          };
          node: { __typename?: "SKU"; id: string };
          style: { __typename?: "Style"; id: string };
          sizeRun?: {
            __typename?: "SizeRunEdge";
            node?: {
              __typename?: "SizeRun";
              id: string;
              code?: string | null;
              name?: string | null;
            } | null;
          } | null;
          retailSize?: {
            __typename?: "RetailSize";
            id: string;
            code?: string | null;
            name?: string | null;
          } | null;
          availableRetailSizeOptions: Array<{
            __typename?: "RetailSize";
            code?: string | null;
            id: string;
            name?: string | null;
          }>;
        }> | null;
      };
    } | null;
  } | null;
};

export type SetSkuWholesalePriceMutationVariables = Exact<{
  input: SetAssortmentSkuWholesalePriceInput;
  assortmentSkuIds: Array<Scalars["ID"]> | Scalars["ID"];
}>;

export type SetSkuWholesalePriceMutation = {
  __typename?: "Mutation";
  setAssortmentSkuWholesalePrice: {
    __typename?: "SetAssortmentSkuWholesalePricePayload";
    query?: {
      __typename?: "Query";
      assortmentSkus: {
        __typename?: "AssortmentSKUConnection";
        edges?: Array<{
          __typename?: "AssortmentSKUEdge";
          _id: string;
          wholesaleCurrencyCode?: string | null;
          retailCurrencyCode?: string | null;
          node: { __typename?: "SKU"; id: string };
          style: { __typename?: "Style"; id: string };
          priceLevels: Array<{
            __typename?: "PriceLevel";
            id: string;
            name: FinancialPriceLevelName;
            extendedWholesale: string | number;
            extendedRetail: string | number;
            maxRetail: string | number;
            maxWholesale: string | number;
            currencyCode: string;
            currencySource?: CurrencyFilter | null;
          }>;
        }> | null;
      };
    } | null;
  };
};

export type SetWorkspaceMerchandisingHierarchyMutationVariables = Exact<{
  input: SetAssortmentMerchandisingHierarchyInput;
  assortmentId: Scalars["ID"];
}>;

export type SetWorkspaceMerchandisingHierarchyMutation = {
  __typename?: "Mutation";
  setAssortmentMerchandisingHierarchy: {
    __typename?: "SetAssortmentMerchandisingHierarchyPayload";
    assortment?: {
      __typename?: "Assortment";
      id: string;
      merchandisingHierarchy: {
        __typename?: "MerchandisingHierarchyNodeConnection";
        edges: Array<{
          __typename?: "MerchandisingHierarchyNodeEdge";
          node?: {
            __typename?: "MerchandisingHierarchyNode";
            name: string;
            id: string;
            parent?: {
              __typename?: "MerchandisingHierarchyNodeEdge";
              node?: {
                __typename?: "MerchandisingHierarchyNode";
                id: string;
              } | null;
            } | null;
            level?: {
              __typename?: "MerchandisingHierarchyLevelEdge";
              node?: {
                __typename?: "MerchandisingHierarchyLevel";
                id: string;
                name: string;
                code: string;
                depth: string;
              } | null;
            } | null;
          } | null;
        }>;
      };
      retailer: {
        __typename?: "RetailerEdge";
        node?: {
          __typename?: "Retailer";
          id: string;
          assortmentAttributes: {
            __typename?: "AttributeConnection";
            edges?: Array<{
              __typename?: "AttributeEdge";
              node?: {
                __typename?: "Attribute";
                id: string;
                name: string;
                isRequired: boolean;
                availableOptions: {
                  __typename?: "AttributeOptionConnection";
                  edges?: Array<{
                    __typename?: "AttributeOptionEdge";
                    node?: {
                      __typename?: "AttributeOption";
                      id: string;
                      value: string;
                    } | null;
                  }> | null;
                };
              } | null;
            }> | null;
          };
        } | null;
      };
      attributeOptions: {
        __typename?: "AttributeOptionConnection";
        edges?: Array<{
          __typename?: "AttributeOptionEdge";
          node?: {
            __typename?: "AttributeOption";
            id: string;
            value: string;
            attribute: {
              __typename?: "AttributeEdge";
              node?: { __typename?: "Attribute"; id: string } | null;
            };
          } | null;
        }> | null;
      };
      skus: {
        __typename?: "AssortmentSKUConnection";
        edges?: Array<{
          __typename?: "AssortmentSKUEdge";
          _id: string;
          color: {
            __typename?: "AssortmentSKUColor";
            id: string;
            sizeCurves: {
              __typename?: "RetailSizeCurves";
              missingFields: Array<RetailSizeCurvesMissingFields>;
              doorSizeCurves: Array<{
                __typename?: "RetailDoorSizeCurves";
                door: { __typename?: "Door"; id: string };
                curveRatios: Array<{
                  __typename?: "SizeCurveRatio";
                  ratio: string | number;
                  retailSize: {
                    __typename?: "RetailSize";
                    id: string;
                    code?: string | null;
                    name?: string | null;
                  };
                }>;
              }>;
            };
          };
        }> | null;
      };
      priceModifiers: {
        __typename?: "PriceModifierConnection";
        edges?: Array<{
          __typename?: "PriceModifierEdge";
          node?: {
            __typename?: "PriceModifier";
            id: string;
            factor?: string | number | null;
            percent?: string | number | null;
            group: {
              __typename?: "PriceModifierGroupEdge";
              node: {
                __typename?: "PriceModifierGroup";
                id: string;
                name: string;
                adjustmentType?: AdjustmentTypeEnum | null;
                displayFormat?: DisplayFormatEnum | null;
              };
            };
          } | null;
        }> | null;
      };
      financialOverview: {
        __typename?: "AssortmentFinancialOverview";
        assortmentCurrencyCode: string;
        linesheetCurrencyCode: string;
        assortmentUnits: {
          __typename?: "AssortmentUnits";
          productCount?: number | null;
          colorCount?: number | null;
          skuCount?: number | null;
          unitCount?: number | null;
          unitDepth?: string | null;
        };
        financialDetails: Array<{
          __typename?: "AssortmentFinancialDetails";
          currencyCode: string;
          isBrandCurrency?: boolean | null;
          priceLevels: Array<{
            __typename?: "FinancialPriceLevel";
            name: FinancialPriceLevelName;
            initialMarkup: string | number;
            cost: { __typename?: "Money"; value: string | number };
            retail: { __typename?: "Money"; value: string | number };
            extendedCost: { __typename?: "Money"; value: string | number };
            extendedRetail: { __typename?: "Money"; value: string | number };
            averageUnitCost: { __typename?: "Money"; value: string | number };
            averageUnitRetail: { __typename?: "Money"; value: string | number };
          }>;
          units: {
            __typename?: "AssortmentUnits";
            productCount?: number | null;
            colorCount?: number | null;
            skuCount?: number | null;
            unitCount?: number | null;
            unitDepth?: string | null;
          };
        }>;
        financialTargets: {
          __typename?: "AssortmentFinancialTargets";
          priceTargets: {
            __typename?: "AssortmentFinancialPriceTargets";
            initialMarkup?: string | number | null;
            cost?: { __typename?: "Money"; value: string | number } | null;
            retail?: { __typename?: "Money"; value: string | number } | null;
            averageUnitCost?: {
              __typename?: "Money";
              value: string | number;
            } | null;
            averageUnitRetail?: {
              __typename?: "Money";
              value: string | number;
            } | null;
          };
          priceTargetsVariance: {
            __typename?: "AssortmentFinancialPriceTargets";
            initialMarkup?: string | number | null;
            cost?: { __typename?: "Money"; value: string | number } | null;
            retail?: { __typename?: "Money"; value: string | number } | null;
            averageUnitCost?: {
              __typename?: "Money";
              value: string | number;
            } | null;
            averageUnitRetail?: {
              __typename?: "Money";
              value: string | number;
            } | null;
          };
        };
      };
    } | null;
  };
};

export type SetWorkspaceOverviewMerchandisingHierarchyMutationVariables =
  Exact<{
    input: SetAssortmentMerchandisingHierarchyInput;
  }>;

export type SetWorkspaceOverviewMerchandisingHierarchyMutation = {
  __typename?: "Mutation";
  setAssortmentMerchandisingHierarchy: {
    __typename?: "SetAssortmentMerchandisingHierarchyPayload";
    assortment?: {
      __typename?: "Assortment";
      id: string;
      collectionName?: string | null;
      status: AssortmentStatus;
      name: string;
      poNumber: string;
      modifiedDate: any;
      brand?: {
        __typename?: "RetailerBrandEdge";
        id: string;
        code?: string | null;
        alias?: string | null;
        node?: { __typename?: "Brand"; id: string; name: string } | null;
      } | null;
      season?: {
        __typename?: "SeasonEdge";
        node: {
          __typename?: "Season";
          id: string;
          code: string;
          name: string;
          year?: number | null;
        };
      } | null;
      financials: {
        __typename?: "AssortmentFinancials";
        id: string;
        total: {
          __typename?: "TotalPriceLevels";
          id: string;
          quantity: number;
          skuCount: number;
          final: Array<{
            __typename?: "PriceLevel";
            id: string;
            currencyCode: string;
            currencySource?: CurrencyFilter | null;
            extCost: string | number;
            extRetail: string | number;
          }>;
        };
        products: Array<{
          __typename?: "ProductPriceLevels";
          id: string;
          colorPriceLevels: Array<{
            __typename?: "ProductColorPriceLevels";
            id: string;
            quantity: number;
          }>;
        }>;
      };
      merchandisingHierarchy: {
        __typename?: "MerchandisingHierarchyNodeConnection";
        edges: Array<{
          __typename?: "MerchandisingHierarchyNodeEdge";
          node?: {
            __typename?: "MerchandisingHierarchyNode";
            name: string;
            code: string;
            id: string;
            parent?: {
              __typename?: "MerchandisingHierarchyNodeEdge";
              node?: {
                __typename?: "MerchandisingHierarchyNode";
                id: string;
              } | null;
            } | null;
            level?: {
              __typename?: "MerchandisingHierarchyLevelEdge";
              node?: {
                __typename?: "MerchandisingHierarchyLevel";
                id: string;
                code: string;
                name: string;
                depth: string;
              } | null;
            } | null;
          } | null;
        }>;
      };
      createdByUser: {
        __typename?: "RetailerUserEdge";
        node?: {
          __typename?: "RetailerUser";
          id: string;
          code: string;
          email: string;
          displayName: string;
        } | null;
      };
      attributeOptions: {
        __typename?: "AttributeOptionConnection";
        edges?: Array<{
          __typename?: "AttributeOptionEdge";
          node?: {
            __typename?: "AttributeOption";
            code: string;
            id: string;
            name: string;
            attribute: {
              __typename?: "AttributeEdge";
              node?: {
                __typename?: "Attribute";
                id: string;
                name: string;
                position: number;
                isRequired: boolean;
                type: AttributeType;
                isMultiSelect: boolean;
                parent?: {
                  __typename?: "AttributeEdge";
                  node?: { __typename?: "Attribute"; id: string } | null;
                } | null;
              } | null;
            };
          } | null;
        }> | null;
      };
      attributeValidationRequirements: Array<{
        __typename?: "AttributeValidation";
        valid: boolean;
        required: {
          __typename?: "Attribute";
          id: string;
          name: string;
          position: number;
          isRequired: boolean;
          type: AttributeType;
          isMultiSelect: boolean;
          parent?: {
            __typename?: "AttributeEdge";
            node?: { __typename?: "Attribute"; id: string } | null;
          } | null;
        };
        attribute: { __typename?: "Attribute"; id: string };
      }>;
      retailer: {
        __typename?: "RetailerEdge";
        node?: {
          __typename?: "Retailer";
          id: string;
          assortmentAttributes: {
            __typename?: "AttributeConnection";
            edges?: Array<{
              __typename?: "AttributeEdge";
              node?: {
                __typename?: "Attribute";
                id: string;
                name: string;
                position: number;
                isRequired: boolean;
                type: AttributeType;
                isMultiSelect: boolean;
                parent?: {
                  __typename?: "AttributeEdge";
                  node?: { __typename?: "Attribute"; id: string } | null;
                } | null;
              } | null;
            }> | null;
          };
        } | null;
      };
      deliveryWindow: {
        __typename?: "AssortmentDeliveryWindow";
        startShip?: any | null;
        completeShip?: any | null;
        due?: any | null;
      };
      validationRequirements: Array<{
        __typename?: "Validation";
        field: AssortmentValidationField;
        valid: boolean;
      }>;
    } | null;
  };
};

export type SizeBulkQueryVariables = Exact<{
  assortmentId: Scalars["ID"];
}>;

export type SizeBulkQuery = {
  __typename?: "Query";
  assortment?: {
    __typename?: "Assortment";
    id: string;
    skus: {
      __typename?: "AssortmentSKUConnection";
      edges?: Array<{
        __typename?: "AssortmentSKUEdge";
        _id: string;
        bulkQuantity: number;
        node: { __typename?: "SKU"; id: string };
        color: {
          __typename?: "AssortmentSKUColor";
          id: string;
          totalSizedQuantity: number;
          bulkQuantity: number;
        };
        style: { __typename?: "Style"; id: string };
        priceLevels: Array<{
          __typename?: "PriceLevel";
          id: string;
          name: FinancialPriceLevelName;
          extendedWholesale: string | number;
          extendedRetail: string | number;
          maxRetail: string | number;
          maxWholesale: string | number;
          currencyCode: string;
          currencySource?: CurrencyFilter | null;
        }>;
      }> | null;
    };
  } | null;
};

export type SizeRunFragment = {
  __typename?: "AssortmentSKUEdge";
  _id: string;
  node: { __typename?: "SKU"; id: string };
  style: { __typename?: "Style"; id: string };
  sizeRun?: {
    __typename?: "SizeRunEdge";
    node?: {
      __typename?: "SizeRun";
      id: string;
      code?: string | null;
      name?: string | null;
    } | null;
  } | null;
  retailSize?: {
    __typename?: "RetailSize";
    id: string;
    code?: string | null;
    name?: string | null;
  } | null;
  availableRetailSizeOptions: Array<{
    __typename?: "RetailSize";
    code?: string | null;
    id: string;
    name?: string | null;
  }>;
};

export type SkuBulkUnitsFragment = {
  __typename?: "AssortmentSKUEdge";
  _id: string;
  bulkQuantity: number;
  node: { __typename?: "SKU"; id: string };
  color: {
    __typename?: "AssortmentSKUColor";
    id: string;
    totalSizedQuantity: number;
    bulkQuantity: number;
  };
  style: { __typename?: "Style"; id: string };
  priceLevels: Array<{
    __typename?: "PriceLevel";
    id: string;
    name: FinancialPriceLevelName;
    extendedWholesale: string | number;
    extendedRetail: string | number;
    maxRetail: string | number;
    maxWholesale: string | number;
    currencyCode: string;
    currencySource?: CurrencyFilter | null;
  }>;
};

export type StyleDetailsFragment = {
  __typename?: "Style";
  details: {
    __typename?: "StyleDetails";
    countryOfOrigin?: string | null;
    furStatus?: FurStatus | null;
    heelHeight?: string | null;
    measurements?: string | null;
    modelHeightInches?: number | null;
    sourceOfMaterials?: string | null;
    categories: Array<{
      __typename?: "Category";
      id?: string | null;
      name: string;
    }>;
    materials?: Array<{ __typename?: "Material"; name: string } | null> | null;
    silhouette?: { __typename?: "Silhouette"; name: string } | null;
    fabrication?: { __typename?: "Fabrication"; name: string } | null;
  };
};

export type UnitFragment = {
  __typename?: "AssortmentUnits";
  productCount?: number | null;
  colorCount?: number | null;
  skuCount?: number | null;
  unitCount?: number | null;
  unitDepth?: string | null;
};

export type UpdatePoBasicDetailsMutationVariables = Exact<{
  assortmentId: Scalars["ID"];
  startShip?: InputMaybe<Scalars["String"]>;
  completeShip?: InputMaybe<Scalars["String"]>;
  due?: InputMaybe<Scalars["String"]>;
  name?: InputMaybe<Scalars["String"]>;
  poNumber?: InputMaybe<Scalars["String"]>;
}>;

export type UpdatePoBasicDetailsMutation = {
  __typename?: "Mutation";
  updateAssortmentDetails: {
    __typename?: "UpdateAssortmentDetailsPayload";
    assortment?: {
      __typename?: "Assortment";
      id: string;
      name: string;
      poNumber: string;
      modifiedDate: any;
      deliveryWindow: {
        __typename?: "AssortmentDeliveryWindow";
        startShip?: any | null;
        completeShip?: any | null;
        due?: any | null;
      };
    } | null;
  };
};

export type UpdatePoDetailsMutationVariables = Exact<{
  assortmentId: Scalars["ID"];
  brandId?: InputMaybe<Scalars["ID"]>;
  editableByUserIds?: InputMaybe<Array<Scalars["ID"]> | Scalars["ID"]>;
  startShip?: InputMaybe<Scalars["String"]>;
  completeShip?: InputMaybe<Scalars["String"]>;
  dueDate?: InputMaybe<Scalars["String"]>;
  seasonId?: InputMaybe<Scalars["ID"]>;
  name?: InputMaybe<Scalars["String"]>;
  poNumber?: InputMaybe<Scalars["String"]>;
  status?: InputMaybe<AssortmentStatus>;
  version?: InputMaybe<Scalars["String"]>;
}>;

export type UpdatePoDetailsMutation = {
  __typename?: "Mutation";
  updateAssortmentDetails: {
    __typename?: "UpdateAssortmentDetailsPayload";
    assortment?: {
      __typename?: "Assortment";
      id: string;
      collectionName?: string | null;
      status: AssortmentStatus;
      name: string;
      poNumber: string;
      modifiedDate: any;
      brand?: {
        __typename?: "RetailerBrandEdge";
        id: string;
        code?: string | null;
        alias?: string | null;
        node?: { __typename?: "Brand"; id: string; name: string } | null;
      } | null;
      season?: {
        __typename?: "SeasonEdge";
        node: {
          __typename?: "Season";
          id: string;
          code: string;
          name: string;
          year?: number | null;
        };
      } | null;
      financials: {
        __typename?: "AssortmentFinancials";
        id: string;
        total: {
          __typename?: "TotalPriceLevels";
          id: string;
          quantity: number;
          skuCount: number;
          final: Array<{
            __typename?: "PriceLevel";
            id: string;
            currencyCode: string;
            currencySource?: CurrencyFilter | null;
            extCost: string | number;
            extRetail: string | number;
          }>;
        };
        products: Array<{
          __typename?: "ProductPriceLevels";
          id: string;
          colorPriceLevels: Array<{
            __typename?: "ProductColorPriceLevels";
            id: string;
            quantity: number;
          }>;
        }>;
      };
      merchandisingHierarchy: {
        __typename?: "MerchandisingHierarchyNodeConnection";
        edges: Array<{
          __typename?: "MerchandisingHierarchyNodeEdge";
          node?: {
            __typename?: "MerchandisingHierarchyNode";
            name: string;
            code: string;
            id: string;
            parent?: {
              __typename?: "MerchandisingHierarchyNodeEdge";
              node?: {
                __typename?: "MerchandisingHierarchyNode";
                id: string;
              } | null;
            } | null;
            level?: {
              __typename?: "MerchandisingHierarchyLevelEdge";
              node?: {
                __typename?: "MerchandisingHierarchyLevel";
                id: string;
                code: string;
                name: string;
                depth: string;
              } | null;
            } | null;
          } | null;
        }>;
      };
      createdByUser: {
        __typename?: "RetailerUserEdge";
        node?: {
          __typename?: "RetailerUser";
          id: string;
          code: string;
          email: string;
          displayName: string;
        } | null;
      };
      attributeOptions: {
        __typename?: "AttributeOptionConnection";
        edges?: Array<{
          __typename?: "AttributeOptionEdge";
          node?: {
            __typename?: "AttributeOption";
            code: string;
            id: string;
            name: string;
            attribute: {
              __typename?: "AttributeEdge";
              node?: {
                __typename?: "Attribute";
                id: string;
                name: string;
                position: number;
                isRequired: boolean;
                type: AttributeType;
                isMultiSelect: boolean;
                parent?: {
                  __typename?: "AttributeEdge";
                  node?: { __typename?: "Attribute"; id: string } | null;
                } | null;
              } | null;
            };
          } | null;
        }> | null;
      };
      attributeValidationRequirements: Array<{
        __typename?: "AttributeValidation";
        valid: boolean;
        required: {
          __typename?: "Attribute";
          id: string;
          name: string;
          position: number;
          isRequired: boolean;
          type: AttributeType;
          isMultiSelect: boolean;
          parent?: {
            __typename?: "AttributeEdge";
            node?: { __typename?: "Attribute"; id: string } | null;
          } | null;
        };
        attribute: { __typename?: "Attribute"; id: string };
      }>;
      retailer: {
        __typename?: "RetailerEdge";
        node?: {
          __typename?: "Retailer";
          id: string;
          assortmentAttributes: {
            __typename?: "AttributeConnection";
            edges?: Array<{
              __typename?: "AttributeEdge";
              node?: {
                __typename?: "Attribute";
                id: string;
                name: string;
                position: number;
                isRequired: boolean;
                type: AttributeType;
                isMultiSelect: boolean;
                parent?: {
                  __typename?: "AttributeEdge";
                  node?: { __typename?: "Attribute"; id: string } | null;
                } | null;
              } | null;
            }> | null;
          };
        } | null;
      };
      deliveryWindow: {
        __typename?: "AssortmentDeliveryWindow";
        startShip?: any | null;
        completeShip?: any | null;
        due?: any | null;
      };
      validationRequirements: Array<{
        __typename?: "Validation";
        field: AssortmentValidationField;
        valid: boolean;
      }>;
    } | null;
  };
};

export type UpdateProductColorImageMutationVariables = Exact<{
  colorId: Scalars["String"];
  file: Scalars["Upload"];
}>;

export type UpdateProductColorImageMutation = {
  __typename?: "Mutation";
  AssortmentUI__uploadProductColorImage?: {
    __typename?: "UploadColorImage";
    colorId?: string | null;
    image?: {
      __typename?: "Image";
      id: string;
      url: any;
      owner?: { __typename?: "ImageOwnerAccount"; id: string } | null;
    } | null;
  } | null;
};

export type UpdateRetailWorkspaceNameMutationVariables = Exact<{
  workspaceId: Scalars["ID"];
  name: Scalars["String"];
}>;

export type UpdateRetailWorkspaceNameMutation = {
  __typename?: "Mutation";
  updateRetailWorkspaceName: {
    __typename?: "RetailWorkspacePayload";
    retailWorkspace?: {
      __typename: "RetailWorkspace";
      id: string;
      name: string;
    } | null;
  };
};

export type UpdateRowSizeBulkMutationVariables = Exact<{
  assortmentId: Scalars["ID"];
  updates:
    | Array<AssortmentUi__BulkSizeUnitUpdate>
    | AssortmentUi__BulkSizeUnitUpdate;
  assortmentSkuIds: Array<Scalars["ID"]> | Scalars["ID"];
}>;

export type UpdateRowSizeBulkMutation = {
  __typename?: "Mutation";
  AssortmentUI__updateRowSizeBulk: {
    __typename?: "AssortmentUI_RowSizeBulkQuantities";
    query?: {
      __typename?: "Query";
      assortmentSkus: {
        __typename?: "AssortmentSKUConnection";
        edges?: Array<{
          __typename?: "AssortmentSKUEdge";
          _id: string;
          bulkQuantity: number;
          node: { __typename?: "SKU"; id: string };
          color: {
            __typename?: "AssortmentSKUColor";
            id: string;
            totalSizedQuantity: number;
            bulkQuantity: number;
          };
          style: { __typename?: "Style"; id: string };
          priceLevels: Array<{
            __typename?: "PriceLevel";
            id: string;
            name: FinancialPriceLevelName;
            extendedWholesale: string | number;
            extendedRetail: string | number;
            maxRetail: string | number;
            maxWholesale: string | number;
            currencyCode: string;
            currencySource?: CurrencyFilter | null;
          }>;
        }> | null;
      };
    } | null;
  };
};

export type UpdateSavedViewMutationVariables = Exact<{
  input: UpdateConfigurationInput;
}>;

export type UpdateSavedViewMutation = {
  __typename?: "Mutation";
  AssortmentUI__updateConfiguration?: {
    __typename?: "Configuration";
    id: string;
    accountId: string;
    userId: string;
    name?: string | null;
    data: string;
    projectName?: string | null;
    visibility: ConfigurationVisibility;
    isDefault?: boolean | null;
  } | null;
};

export type UpdateWorkspaceDetailsMutationVariables = Exact<{
  assortmentId: Scalars["ID"];
  brandId?: InputMaybe<Scalars["ID"]>;
  editableByUserIds?: InputMaybe<Array<Scalars["ID"]> | Scalars["ID"]>;
  startShip?: InputMaybe<Scalars["String"]>;
  completeShip?: InputMaybe<Scalars["String"]>;
  dueDate?: InputMaybe<Scalars["String"]>;
  seasonId?: InputMaybe<Scalars["ID"]>;
  name?: InputMaybe<Scalars["String"]>;
  poNumber?: InputMaybe<Scalars["String"]>;
  status?: InputMaybe<AssortmentStatus>;
  version?: InputMaybe<Scalars["String"]>;
}>;

export type UpdateWorkspaceDetailsMutation = {
  __typename?: "Mutation";
  updateAssortmentDetails: {
    __typename?: "UpdateAssortmentDetailsPayload";
    assortment?: {
      __typename?: "Assortment";
      id: string;
      status: AssortmentStatus;
      assortmentName: string;
      joorPo: string;
      version: string;
      availableMerchandisingHierarchy: {
        __typename?: "MerchandisingHierarchyNodeConnection";
        edges: Array<{
          __typename?: "MerchandisingHierarchyNodeEdge";
          node?: {
            __typename?: "MerchandisingHierarchyNode";
            name: string;
            code: string;
            id: string;
            parent?: {
              __typename?: "MerchandisingHierarchyNodeEdge";
              node?: {
                __typename?: "MerchandisingHierarchyNode";
                id: string;
                code: string;
                name: string;
              } | null;
            } | null;
            level?: {
              __typename?: "MerchandisingHierarchyLevelEdge";
              node?: {
                __typename?: "MerchandisingHierarchyLevel";
                id: string;
                name: string;
                code: string;
                depth: string;
              } | null;
            } | null;
          } | null;
        }>;
      };
      attributeOptions: {
        __typename?: "AttributeOptionConnection";
        edges?: Array<{
          __typename?: "AttributeOptionEdge";
          node?: {
            __typename?: "AttributeOption";
            id: string;
            value: string;
            attribute: {
              __typename?: "AttributeEdge";
              node?: { __typename?: "Attribute"; id: string } | null;
            };
          } | null;
        }> | null;
      };
      brand?: {
        __typename?: "RetailerBrandEdge";
        id: string;
        code?: string | null;
        brandAlias?: string | null;
        node?: { __typename?: "Brand"; id: string; brandName: string } | null;
      } | null;
      createdByUser: {
        __typename?: "RetailerUserEdge";
        node?: {
          __typename?: "RetailerUser";
          id: string;
          email: string;
          displayName: string;
        } | null;
      };
      deliveryWindow: {
        __typename?: "AssortmentDeliveryWindow";
        startShip?: any | null;
        completeShip?: any | null;
        due?: any | null;
      };
      merchandisingHierarchy: {
        __typename?: "MerchandisingHierarchyNodeConnection";
        edges: Array<{
          __typename?: "MerchandisingHierarchyNodeEdge";
          node?: {
            __typename?: "MerchandisingHierarchyNode";
            name: string;
            id: string;
            parent?: {
              __typename?: "MerchandisingHierarchyNodeEdge";
              node?: {
                __typename?: "MerchandisingHierarchyNode";
                id: string;
              } | null;
            } | null;
            level?: {
              __typename?: "MerchandisingHierarchyLevelEdge";
              node?: {
                __typename?: "MerchandisingHierarchyLevel";
                id: string;
                name: string;
                code: string;
                depth: string;
              } | null;
            } | null;
          } | null;
        }>;
      };
      retailer: {
        __typename?: "RetailerEdge";
        node?: {
          __typename?: "Retailer";
          id: string;
          name: string;
          displayName: string;
          brands: {
            __typename?: "RetailerBrandConnection";
            edges: Array<{
              __typename?: "RetailerBrandEdge";
              id: string;
              code?: string | null;
              brandAlias?: string | null;
              node?: {
                __typename?: "Brand";
                id: string;
                brandName: string;
              } | null;
            }>;
          };
          seasons: {
            __typename?: "SeasonConnection";
            edges: Array<{
              __typename?: "SeasonEdge";
              node: {
                __typename?: "Season";
                id: string;
                seasonName: string;
                seasonYear?: number | null;
              };
            }>;
          };
          assortmentAttributes: {
            __typename?: "AttributeConnection";
            edges?: Array<{
              __typename?: "AttributeEdge";
              node?: {
                __typename?: "Attribute";
                id: string;
                name: string;
                isRequired: boolean;
                availableOptions: {
                  __typename?: "AttributeOptionConnection";
                  edges?: Array<{
                    __typename?: "AttributeOptionEdge";
                    node?: {
                      __typename?: "AttributeOption";
                      id: string;
                      value: string;
                    } | null;
                  }> | null;
                };
              } | null;
            }> | null;
          };
        } | null;
      };
      season?: {
        __typename?: "SeasonEdge";
        node: {
          __typename?: "Season";
          id: string;
          seasonName: string;
          seasonYear?: number | null;
        };
      } | null;
      skus: {
        __typename?: "AssortmentSKUConnection";
        edges?: Array<{
          __typename?: "AssortmentSKUEdge";
          _id: string;
          isCustom?: boolean | null;
          node: { __typename?: "SKU"; id: string };
          color: {
            __typename?: "AssortmentSKUColor";
            id: string;
            sizeCurves: {
              __typename?: "RetailSizeCurves";
              missingFields: Array<RetailSizeCurvesMissingFields>;
              doorSizeCurves: Array<{
                __typename?: "RetailDoorSizeCurves";
                door: { __typename?: "Door"; id: string };
                curveRatios: Array<{
                  __typename?: "SizeCurveRatio";
                  ratio: string | number;
                  retailSize: {
                    __typename?: "RetailSize";
                    id: string;
                    code?: string | null;
                    name?: string | null;
                  };
                }>;
              }>;
            };
          };
        }> | null;
      };
      validationRequirements: Array<{
        __typename?: "Validation";
        field: AssortmentValidationField;
        valid: boolean;
      }>;
      attributeValidationRequirements: Array<{
        __typename?: "AttributeValidation";
        valid: boolean;
        attribute: { __typename?: "Attribute"; id: string };
      }>;
    } | null;
  };
};

export type UpdateWorkspaceNameMutationVariables = Exact<{
  assortmentId: Scalars["ID"];
  name?: InputMaybe<Scalars["String"]>;
}>;

export type UpdateWorkspaceNameMutation = {
  __typename?: "Mutation";
  updateAssortmentDetails: {
    __typename?: "UpdateAssortmentDetailsPayload";
    assortment?: { __typename?: "Assortment"; id: string; name: string } | null;
  };
};

export type UploadProductImageMutationVariables = Exact<{
  assortmentId: Scalars["String"];
  productId: Scalars["String"];
  file: Scalars["Upload"];
}>;

export type UploadProductImageMutation = {
  __typename?: "Mutation";
  AssortmentUI__uploadProductImage?: {
    __typename?: "UploadItemImage";
    assortmentId: string;
  } | null;
};

export type UploadSwatchImageMutationVariables = Exact<{
  assortmentId: Scalars["String"];
  colorId: Scalars["String"];
  file: Scalars["Upload"];
}>;

export type UploadSwatchImageMutation = {
  __typename?: "Mutation";
  AssortmentUI__uploadSwatchImage?: {
    __typename?: "UploadSwatchImage";
    image?: {
      __typename?: "Image";
      id: string;
      url: any;
      owner?: { __typename?: "ImageOwnerAccount"; id: string } | null;
    } | null;
  } | null;
};

export type UpsertRetailBudgetMutationVariables = Exact<{
  input: RetailBudgetInput;
}>;

export type UpsertRetailBudgetMutation = {
  __typename?: "Mutation";
  upsertRetailBudget?: {
    __typename?: "RetailBudget";
    id: string;
    workspaceOrAssortmentId: string;
    budgetType: BudgetType;
    finalExtCost?: string | number | null;
    finalExtRetail?: string | number | null;
    totalUnits?: string | number | null;
    finalExtCostCurrency?: string | null;
    finalExtRetailCurrency?: string | null;
    categoryTotals: {
      __typename?: "RetailBudgetCategoryTotals";
      finalExtCost: string | number;
      finalExtRetail: string | number;
      totalUnits: string | number;
    };
    topLevelBudgetCategory?: {
      __typename?: "RetailBudgetCategory";
      id: string;
      categoryType: RetailBudgetCategoryType;
    } | null;
  } | null;
};

export type WorkspaceDetailsQueryVariables = Exact<{
  assortmentId: Scalars["ID"];
}>;

export type WorkspaceDetailsQuery = {
  __typename?: "Query";
  assortment?: {
    __typename?: "Assortment";
    id: string;
    status: AssortmentStatus;
    assortmentName: string;
    joorPo: string;
    version: string;
    availableMerchandisingHierarchy: {
      __typename?: "MerchandisingHierarchyNodeConnection";
      edges: Array<{
        __typename?: "MerchandisingHierarchyNodeEdge";
        node?: {
          __typename?: "MerchandisingHierarchyNode";
          name: string;
          code: string;
          id: string;
          parent?: {
            __typename?: "MerchandisingHierarchyNodeEdge";
            node?: {
              __typename?: "MerchandisingHierarchyNode";
              id: string;
              code: string;
              name: string;
            } | null;
          } | null;
          level?: {
            __typename?: "MerchandisingHierarchyLevelEdge";
            node?: {
              __typename?: "MerchandisingHierarchyLevel";
              id: string;
              name: string;
              code: string;
              depth: string;
            } | null;
          } | null;
        } | null;
      }>;
    };
    attributeOptions: {
      __typename?: "AttributeOptionConnection";
      edges?: Array<{
        __typename?: "AttributeOptionEdge";
        node?: {
          __typename?: "AttributeOption";
          id: string;
          value: string;
          attribute: {
            __typename?: "AttributeEdge";
            node?: { __typename?: "Attribute"; id: string } | null;
          };
        } | null;
      }> | null;
    };
    brand?: {
      __typename?: "RetailerBrandEdge";
      id: string;
      code?: string | null;
      brandAlias?: string | null;
      node?: { __typename?: "Brand"; id: string; brandName: string } | null;
    } | null;
    createdByUser: {
      __typename?: "RetailerUserEdge";
      node?: {
        __typename?: "RetailerUser";
        id: string;
        email: string;
        displayName: string;
      } | null;
    };
    deliveryWindow: {
      __typename?: "AssortmentDeliveryWindow";
      startShip?: any | null;
      completeShip?: any | null;
      due?: any | null;
    };
    merchandisingHierarchy: {
      __typename?: "MerchandisingHierarchyNodeConnection";
      edges: Array<{
        __typename?: "MerchandisingHierarchyNodeEdge";
        node?: {
          __typename?: "MerchandisingHierarchyNode";
          name: string;
          id: string;
          parent?: {
            __typename?: "MerchandisingHierarchyNodeEdge";
            node?: {
              __typename?: "MerchandisingHierarchyNode";
              id: string;
            } | null;
          } | null;
          level?: {
            __typename?: "MerchandisingHierarchyLevelEdge";
            node?: {
              __typename?: "MerchandisingHierarchyLevel";
              id: string;
              name: string;
              code: string;
              depth: string;
            } | null;
          } | null;
        } | null;
      }>;
    };
    retailer: {
      __typename?: "RetailerEdge";
      node?: {
        __typename?: "Retailer";
        id: string;
        name: string;
        displayName: string;
        brands: {
          __typename?: "RetailerBrandConnection";
          edges: Array<{
            __typename?: "RetailerBrandEdge";
            id: string;
            code?: string | null;
            brandAlias?: string | null;
            node?: {
              __typename?: "Brand";
              id: string;
              brandName: string;
            } | null;
          }>;
        };
        seasons: {
          __typename?: "SeasonConnection";
          edges: Array<{
            __typename?: "SeasonEdge";
            node: {
              __typename?: "Season";
              id: string;
              seasonName: string;
              seasonYear?: number | null;
            };
          }>;
        };
        assortmentAttributes: {
          __typename?: "AttributeConnection";
          edges?: Array<{
            __typename?: "AttributeEdge";
            node?: {
              __typename?: "Attribute";
              id: string;
              name: string;
              isRequired: boolean;
              availableOptions: {
                __typename?: "AttributeOptionConnection";
                edges?: Array<{
                  __typename?: "AttributeOptionEdge";
                  node?: {
                    __typename?: "AttributeOption";
                    id: string;
                    value: string;
                  } | null;
                }> | null;
              };
            } | null;
          }> | null;
        };
      } | null;
    };
    season?: {
      __typename?: "SeasonEdge";
      node: {
        __typename?: "Season";
        id: string;
        seasonName: string;
        seasonYear?: number | null;
      };
    } | null;
    skus: {
      __typename?: "AssortmentSKUConnection";
      edges?: Array<{
        __typename?: "AssortmentSKUEdge";
        _id: string;
        isCustom?: boolean | null;
        node: { __typename?: "SKU"; id: string };
        color: {
          __typename?: "AssortmentSKUColor";
          id: string;
          sizeCurves: {
            __typename?: "RetailSizeCurves";
            missingFields: Array<RetailSizeCurvesMissingFields>;
            doorSizeCurves: Array<{
              __typename?: "RetailDoorSizeCurves";
              door: { __typename?: "Door"; id: string };
              curveRatios: Array<{
                __typename?: "SizeCurveRatio";
                ratio: string | number;
                retailSize: {
                  __typename?: "RetailSize";
                  id: string;
                  code?: string | null;
                  name?: string | null;
                };
              }>;
            }>;
          };
        };
      }> | null;
    };
    financialOverview: {
      __typename?: "AssortmentFinancialOverview";
      assortmentCurrencyCode: string;
      linesheetCurrencyCode: string;
      assortmentUnits: {
        __typename?: "AssortmentUnits";
        productCount?: number | null;
        colorCount?: number | null;
        skuCount?: number | null;
        unitCount?: number | null;
        unitDepth?: string | null;
      };
      financialDetails: Array<{
        __typename?: "AssortmentFinancialDetails";
        currencyCode: string;
        isBrandCurrency?: boolean | null;
        priceLevels: Array<{
          __typename?: "FinancialPriceLevel";
          name: FinancialPriceLevelName;
          initialMarkup: string | number;
          cost: { __typename?: "Money"; value: string | number };
          retail: { __typename?: "Money"; value: string | number };
          extendedCost: { __typename?: "Money"; value: string | number };
          extendedRetail: { __typename?: "Money"; value: string | number };
          averageUnitCost: { __typename?: "Money"; value: string | number };
          averageUnitRetail: { __typename?: "Money"; value: string | number };
        }>;
        units: {
          __typename?: "AssortmentUnits";
          productCount?: number | null;
          colorCount?: number | null;
          skuCount?: number | null;
          unitCount?: number | null;
          unitDepth?: string | null;
        };
      }>;
      financialTargets: {
        __typename?: "AssortmentFinancialTargets";
        priceTargets: {
          __typename?: "AssortmentFinancialPriceTargets";
          initialMarkup?: string | number | null;
          cost?: { __typename?: "Money"; value: string | number } | null;
          retail?: { __typename?: "Money"; value: string | number } | null;
          averageUnitCost?: {
            __typename?: "Money";
            value: string | number;
          } | null;
          averageUnitRetail?: {
            __typename?: "Money";
            value: string | number;
          } | null;
        };
        priceTargetsVariance: {
          __typename?: "AssortmentFinancialPriceTargets";
          initialMarkup?: string | number | null;
          cost?: { __typename?: "Money"; value: string | number } | null;
          retail?: { __typename?: "Money"; value: string | number } | null;
          averageUnitCost?: {
            __typename?: "Money";
            value: string | number;
          } | null;
          averageUnitRetail?: {
            __typename?: "Money";
            value: string | number;
          } | null;
        };
      };
    };
    validationRequirements: Array<{
      __typename?: "Validation";
      field: AssortmentValidationField;
      valid: boolean;
    }>;
    attributeValidationRequirements: Array<{
      __typename?: "AttributeValidation";
      valid: boolean;
      attribute: { __typename?: "Attribute"; id: string };
    }>;
    doorClusters: {
      __typename?: "AssortmentDoorClusterConnection";
      edges?: Array<{
        __typename?: "AssortmentDoorClusterEdge";
        node?: {
          __typename?: "DoorCluster";
          id: string;
          name?: string | null;
          code?: string | null;
          doors?: {
            __typename?: "DoorClusterDoorConnection";
            edges?: Array<{
              __typename?: "DoorClusterDoorEdge";
              node?: {
                __typename?: "Door";
                id: string;
                name: string;
                code: string;
              } | null;
            }> | null;
          } | null;
        } | null;
      }> | null;
    };
  } | null;
};

export type WorkspaceDetailsAssortmentFragment = {
  __typename?: "Assortment";
  status: AssortmentStatus;
  assortmentName: string;
  joorPo: string;
  version: string;
  availableMerchandisingHierarchy: {
    __typename?: "MerchandisingHierarchyNodeConnection";
    edges: Array<{
      __typename?: "MerchandisingHierarchyNodeEdge";
      node?: {
        __typename?: "MerchandisingHierarchyNode";
        name: string;
        code: string;
        id: string;
        parent?: {
          __typename?: "MerchandisingHierarchyNodeEdge";
          node?: {
            __typename?: "MerchandisingHierarchyNode";
            id: string;
            code: string;
            name: string;
          } | null;
        } | null;
        level?: {
          __typename?: "MerchandisingHierarchyLevelEdge";
          node?: {
            __typename?: "MerchandisingHierarchyLevel";
            id: string;
            name: string;
            code: string;
            depth: string;
          } | null;
        } | null;
      } | null;
    }>;
  };
  attributeOptions: {
    __typename?: "AttributeOptionConnection";
    edges?: Array<{
      __typename?: "AttributeOptionEdge";
      node?: {
        __typename?: "AttributeOption";
        id: string;
        value: string;
        attribute: {
          __typename?: "AttributeEdge";
          node?: { __typename?: "Attribute"; id: string } | null;
        };
      } | null;
    }> | null;
  };
  brand?: {
    __typename?: "RetailerBrandEdge";
    id: string;
    code?: string | null;
    brandAlias?: string | null;
    node?: { __typename?: "Brand"; id: string; brandName: string } | null;
  } | null;
  createdByUser: {
    __typename?: "RetailerUserEdge";
    node?: {
      __typename?: "RetailerUser";
      id: string;
      email: string;
      displayName: string;
    } | null;
  };
  deliveryWindow: {
    __typename?: "AssortmentDeliveryWindow";
    startShip?: any | null;
    completeShip?: any | null;
    due?: any | null;
  };
  merchandisingHierarchy: {
    __typename?: "MerchandisingHierarchyNodeConnection";
    edges: Array<{
      __typename?: "MerchandisingHierarchyNodeEdge";
      node?: {
        __typename?: "MerchandisingHierarchyNode";
        name: string;
        id: string;
        parent?: {
          __typename?: "MerchandisingHierarchyNodeEdge";
          node?: {
            __typename?: "MerchandisingHierarchyNode";
            id: string;
          } | null;
        } | null;
        level?: {
          __typename?: "MerchandisingHierarchyLevelEdge";
          node?: {
            __typename?: "MerchandisingHierarchyLevel";
            id: string;
            name: string;
            code: string;
            depth: string;
          } | null;
        } | null;
      } | null;
    }>;
  };
  retailer: {
    __typename?: "RetailerEdge";
    node?: {
      __typename?: "Retailer";
      id: string;
      name: string;
      displayName: string;
      brands: {
        __typename?: "RetailerBrandConnection";
        edges: Array<{
          __typename?: "RetailerBrandEdge";
          id: string;
          code?: string | null;
          brandAlias?: string | null;
          node?: { __typename?: "Brand"; id: string; brandName: string } | null;
        }>;
      };
      seasons: {
        __typename?: "SeasonConnection";
        edges: Array<{
          __typename?: "SeasonEdge";
          node: {
            __typename?: "Season";
            id: string;
            seasonName: string;
            seasonYear?: number | null;
          };
        }>;
      };
      assortmentAttributes: {
        __typename?: "AttributeConnection";
        edges?: Array<{
          __typename?: "AttributeEdge";
          node?: {
            __typename?: "Attribute";
            id: string;
            name: string;
            isRequired: boolean;
            availableOptions: {
              __typename?: "AttributeOptionConnection";
              edges?: Array<{
                __typename?: "AttributeOptionEdge";
                node?: {
                  __typename?: "AttributeOption";
                  id: string;
                  value: string;
                } | null;
              }> | null;
            };
          } | null;
        }> | null;
      };
    } | null;
  };
  season?: {
    __typename?: "SeasonEdge";
    node: {
      __typename?: "Season";
      id: string;
      seasonName: string;
      seasonYear?: number | null;
    };
  } | null;
  skus: {
    __typename?: "AssortmentSKUConnection";
    edges?: Array<{
      __typename?: "AssortmentSKUEdge";
      _id: string;
      isCustom?: boolean | null;
      node: { __typename?: "SKU"; id: string };
      color: {
        __typename?: "AssortmentSKUColor";
        id: string;
        sizeCurves: {
          __typename?: "RetailSizeCurves";
          missingFields: Array<RetailSizeCurvesMissingFields>;
          doorSizeCurves: Array<{
            __typename?: "RetailDoorSizeCurves";
            door: { __typename?: "Door"; id: string };
            curveRatios: Array<{
              __typename?: "SizeCurveRatio";
              ratio: string | number;
              retailSize: {
                __typename?: "RetailSize";
                id: string;
                code?: string | null;
                name?: string | null;
              };
            }>;
          }>;
        };
      };
    }> | null;
  };
};

export type OrderHeaderAssortmentDetailsQueryVariables = Exact<{
  assortmentId: Scalars["ID"];
}>;

export type OrderHeaderAssortmentDetailsQuery = {
  __typename?: "Query";
  assortment?: {
    __typename?: "Assortment";
    id: string;
    name: string;
    workspace?: {
      __typename?: "RetailWorkspace";
      id: string;
      name: string;
    } | null;
  } | null;
};

export type AccountPrimaryFragment = {
  __typename?: "Account";
  id: string;
  name: string;
  type?: AccountType | null;
  tier?: AccountTier | null;
};

export type AssortmentDoorsClustersFragment = {
  __typename?: "Assortment";
  doorClusters: {
    __typename?: "AssortmentDoorClusterConnection";
    edges?: Array<{
      __typename?: "AssortmentDoorClusterEdge";
      node?: {
        __typename?: "DoorCluster";
        id: string;
        name?: string | null;
        code?: string | null;
        doors?: {
          __typename?: "DoorClusterDoorConnection";
          edges?: Array<{
            __typename?: "DoorClusterDoorEdge";
            node?: {
              __typename?: "Door";
              id: string;
              name: string;
              code: string;
            } | null;
          }> | null;
        } | null;
      } | null;
    }> | null;
  };
};

export type DoorClusterFragment = {
  __typename?: "DoorCluster";
  id: string;
  name?: string | null;
  code?: string | null;
  doors?: {
    __typename?: "DoorClusterDoorConnection";
    edges?: Array<{
      __typename?: "DoorClusterDoorEdge";
      node?: {
        __typename?: "Door";
        id: string;
        name: string;
        code: string;
      } | null;
    }> | null;
  } | null;
};

export type AssortmentDoorRunsFragment = {
  __typename?: "Assortment";
  doorRuns: {
    __typename?: "AssortmentDoorRunConnection";
    edges?: Array<{
      __typename?: "AssortmentDoorRunEdge";
      node?: {
        __typename?: "AssortmentDoorRun";
        id: string;
        orderNbr?: number | null;
      } | null;
    }> | null;
  };
};

export type DoorRunFragment = {
  __typename?: "AssortmentDoorRun";
  id: string;
  orderNbr?: number | null;
};

export type UserPrimaryFragment = {
  __typename?: "User";
  code?: string | null;
  displayName?: string | null;
  email?: string | null;
  assortmentPlanning: boolean;
  id: string;
};

export type DoorActualUnitsQueryVariables = Exact<{
  assortmentId: Scalars["ID"];
}>;

export type DoorActualUnitsQuery = {
  __typename?: "Query";
  assortment?: {
    __typename?: "Assortment";
    id: string;
    skus: {
      __typename?: "AssortmentSKUConnection";
      edges?: Array<{
        __typename?: "AssortmentSKUEdge";
        _id: string;
        doorQuantities: Array<{
          __typename?: "AssortmentSKUDoorQuantity";
          id: string;
          quantity: number;
          appliedSizeRatio?: string | number | null;
          door?: { __typename?: "Door"; id: string } | null;
        }>;
      }> | null;
    };
  } | null;
};

export type ActiveProfileQueryVariables = Exact<{ [key: string]: never }>;

export type ActiveProfileQuery = {
  __typename?: "Query";
  account: {
    __typename?: "Account";
    id: string;
    name: string;
    type?: AccountType | null;
    tier?: AccountTier | null;
  };
  otherAccounts: Array<{
    __typename?: "Account";
    id: string;
    name: string;
    type?: AccountType | null;
    tier?: AccountTier | null;
  }>;
  user: {
    __typename?: "User";
    code?: string | null;
    displayName?: string | null;
    email?: string | null;
    assortmentPlanning: boolean;
    id: string;
  };
};

export type AssortmentWorkspaceCheckQueryVariables = Exact<{
  assortmentId: Scalars["ID"];
}>;

export type AssortmentWorkspaceCheckQuery = {
  __typename?: "Query";
  assortment?: {
    __typename?: "Assortment";
    id: string;
    workspace?: { __typename?: "RetailWorkspace"; id: string } | null;
  } | null;
};

export type WorkspaceBrandNamesQueryVariables = Exact<{
  workspaceId: Scalars["ID"];
}>;

export type WorkspaceBrandNamesQuery = {
  __typename?: "Query";
  retailWorkspace?: {
    __typename?: "RetailWorkspace";
    id: string;
    assortments: Array<{
      __typename?: "Assortment";
      id: string;
      brand?: {
        __typename?: "RetailerBrandEdge";
        id: string;
        alias?: string | null;
        code?: string | null;
        node?: { __typename?: "Brand"; id: string; name: string } | null;
      } | null;
    }>;
  } | null;
};

export type WorkspaceBrandNamesAssortmentBrandFragment = {
  __typename?: "RetailerBrandEdge";
  id: string;
  alias?: string | null;
  code?: string | null;
  node?: { __typename?: "Brand"; id: string; name: string } | null;
};

export type WorkspaceCurrenciesQueryVariables = Exact<{
  workspaceId: Scalars["ID"];
}>;

export type WorkspaceCurrenciesQuery = {
  __typename?: "Query";
  retailWorkspace?: {
    __typename?: "RetailWorkspace";
    id: string;
    assortments: Array<{
      __typename?: "Assortment";
      id: string;
      financialOverview: {
        __typename?: "AssortmentFinancialOverview";
        financialDetails: Array<{
          __typename?: "AssortmentFinancialDetails";
          currencyCode: string;
          isBrandCurrency?: boolean | null;
        }>;
      };
    }>;
  } | null;
};

export type WorkspaceCurrenciesFragment = {
  __typename?: "Assortment";
  id: string;
  financialOverview: {
    __typename?: "AssortmentFinancialOverview";
    financialDetails: Array<{
      __typename?: "AssortmentFinancialDetails";
      currencyCode: string;
      isBrandCurrency?: boolean | null;
    }>;
  };
};

export type WorkspaceDeliveryWindowQueryVariables = Exact<{
  workspaceId: Scalars["ID"];
}>;

export type WorkspaceDeliveryWindowQuery = {
  __typename?: "Query";
  retailWorkspace?: {
    __typename?: "RetailWorkspace";
    id: string;
    assortments: Array<{
      __typename?: "Assortment";
      id: string;
      deliveryWindow: {
        __typename?: "AssortmentDeliveryWindow";
        startShip?: any | null;
        completeShip?: any | null;
      };
    }>;
  } | null;
};

export type WorkspaceDeliveryWindowFragment = {
  __typename?: "AssortmentDeliveryWindow";
  startShip?: any | null;
  completeShip?: any | null;
};

export type WorkspaceDeliveryWindowAssortmentFragment = {
  __typename?: "Assortment";
  id: string;
  deliveryWindow: {
    __typename?: "AssortmentDeliveryWindow";
    startShip?: any | null;
    completeShip?: any | null;
  };
};

export type WorkspaceFinancialsQueryVariables = Exact<{
  workspaceId: Scalars["ID"];
}>;

export type WorkspaceFinancialsQuery = {
  __typename?: "Query";
  retailWorkspace?: {
    __typename?: "RetailWorkspace";
    id: string;
    assortments: Array<{
      __typename?: "Assortment";
      id: string;
      financials: {
        __typename?: "AssortmentFinancials";
        id: string;
        total: {
          __typename?: "TotalPriceLevels";
          id: string;
          final: Array<{
            __typename?: "PriceLevel";
            id: string;
            currencyCode: string;
            currencySource?: CurrencyFilter | null;
            extCost: string | number;
            extRetail: string | number;
          }>;
          modified: Array<{
            __typename?: "PriceLevel";
            id: string;
            currencyCode: string;
            currencySource?: CurrencyFilter | null;
            extCost: string | number;
            extRetail: string | number;
          }>;
        };
      };
      financialOverview: {
        __typename?: "AssortmentFinancialOverview";
        financialDetails: Array<{
          __typename?: "AssortmentFinancialDetails";
          isBrandCurrency?: boolean | null;
          currencyCode: string;
          units: {
            __typename?: "AssortmentUnits";
            productCount?: number | null;
            colorCount?: number | null;
            skuCount?: number | null;
            unitCount?: number | null;
            unitDepth?: string | null;
          };
          priceLevels: Array<{
            __typename?: "FinancialPriceLevel";
            name: FinancialPriceLevelName;
            initialMarkup: string | number;
            cost: { __typename?: "Money"; value: string | number };
            retail: { __typename?: "Money"; value: string | number };
            extendedCost: { __typename?: "Money"; value: string | number };
            extendedRetail: { __typename?: "Money"; value: string | number };
            averageUnitCost: { __typename?: "Money"; value: string | number };
            averageUnitRetail: { __typename?: "Money"; value: string | number };
          }>;
        }>;
      };
    }>;
  } | null;
};

export type WorkspaceFinancialsAssortmentFragment = {
  __typename?: "Assortment";
  id: string;
  financials: {
    __typename?: "AssortmentFinancials";
    id: string;
    total: {
      __typename?: "TotalPriceLevels";
      id: string;
      final: Array<{
        __typename?: "PriceLevel";
        id: string;
        currencyCode: string;
        currencySource?: CurrencyFilter | null;
        extCost: string | number;
        extRetail: string | number;
      }>;
      modified: Array<{
        __typename?: "PriceLevel";
        id: string;
        currencyCode: string;
        currencySource?: CurrencyFilter | null;
        extCost: string | number;
        extRetail: string | number;
      }>;
    };
  };
};

export type WorkspaceFinancialsPriceLevelFragment = {
  __typename?: "PriceLevel";
  id: string;
  currencyCode: string;
  currencySource?: CurrencyFilter | null;
  extCost: string | number;
  extRetail: string | number;
};

export type WorkspaceUnitsCountFragment = {
  __typename?: "Assortment";
  id: string;
  financialOverview: {
    __typename?: "AssortmentFinancialOverview";
    financialDetails: Array<{
      __typename?: "AssortmentFinancialDetails";
      isBrandCurrency?: boolean | null;
      currencyCode: string;
      units: {
        __typename?: "AssortmentUnits";
        productCount?: number | null;
        colorCount?: number | null;
        skuCount?: number | null;
        unitCount?: number | null;
        unitDepth?: string | null;
      };
      priceLevels: Array<{
        __typename?: "FinancialPriceLevel";
        name: FinancialPriceLevelName;
        initialMarkup: string | number;
        cost: { __typename?: "Money"; value: string | number };
        retail: { __typename?: "Money"; value: string | number };
        extendedCost: { __typename?: "Money"; value: string | number };
        extendedRetail: { __typename?: "Money"; value: string | number };
        averageUnitCost: { __typename?: "Money"; value: string | number };
        averageUnitRetail: { __typename?: "Money"; value: string | number };
      }>;
    }>;
  };
};

export type WorkspaceNameQueryVariables = Exact<{
  workspaceId: Scalars["ID"];
}>;

export type WorkspaceNameQuery = {
  __typename?: "Query";
  retailWorkspace?: {
    __typename?: "RetailWorkspace";
    id: string;
    name: string;
  } | null;
};

export type WorkspaceOverviewQueryVariables = Exact<{
  workspaceId: Scalars["ID"];
}>;

export type WorkspaceOverviewQuery = {
  __typename?: "Query";
  retailWorkspace?: {
    __typename?: "RetailWorkspace";
    id: string;
    assortments: Array<{
      __typename?: "Assortment";
      collectionName?: string | null;
      id: string;
      status: AssortmentStatus;
      name: string;
      poNumber: string;
      modifiedDate: any;
      brand?: {
        __typename?: "RetailerBrandEdge";
        id: string;
        code?: string | null;
        alias?: string | null;
        node?: { __typename?: "Brand"; id: string; name: string } | null;
      } | null;
      season?: {
        __typename?: "SeasonEdge";
        node: {
          __typename?: "Season";
          id: string;
          code: string;
          name: string;
          year?: number | null;
        };
      } | null;
      financials: {
        __typename?: "AssortmentFinancials";
        id: string;
        total: {
          __typename?: "TotalPriceLevels";
          id: string;
          quantity: number;
          skuCount: number;
          final: Array<{
            __typename?: "PriceLevel";
            id: string;
            currencyCode: string;
            currencySource?: CurrencyFilter | null;
            extCost: string | number;
            extRetail: string | number;
          }>;
        };
        products: Array<{
          __typename?: "ProductPriceLevels";
          id: string;
          colorPriceLevels: Array<{
            __typename?: "ProductColorPriceLevels";
            id: string;
            quantity: number;
          }>;
        }>;
      };
      merchandisingHierarchy: {
        __typename?: "MerchandisingHierarchyNodeConnection";
        edges: Array<{
          __typename?: "MerchandisingHierarchyNodeEdge";
          node?: {
            __typename?: "MerchandisingHierarchyNode";
            name: string;
            code: string;
            id: string;
            parent?: {
              __typename?: "MerchandisingHierarchyNodeEdge";
              node?: {
                __typename?: "MerchandisingHierarchyNode";
                id: string;
              } | null;
            } | null;
            level?: {
              __typename?: "MerchandisingHierarchyLevelEdge";
              node?: {
                __typename?: "MerchandisingHierarchyLevel";
                id: string;
                code: string;
                name: string;
                depth: string;
              } | null;
            } | null;
          } | null;
        }>;
      };
      createdByUser: {
        __typename?: "RetailerUserEdge";
        node?: {
          __typename?: "RetailerUser";
          id: string;
          code: string;
          email: string;
          displayName: string;
        } | null;
      };
      attributeOptions: {
        __typename?: "AttributeOptionConnection";
        edges?: Array<{
          __typename?: "AttributeOptionEdge";
          node?: {
            __typename?: "AttributeOption";
            code: string;
            id: string;
            name: string;
            attribute: {
              __typename?: "AttributeEdge";
              node?: {
                __typename?: "Attribute";
                id: string;
                name: string;
                position: number;
                isRequired: boolean;
                type: AttributeType;
                isMultiSelect: boolean;
                parent?: {
                  __typename?: "AttributeEdge";
                  node?: { __typename?: "Attribute"; id: string } | null;
                } | null;
              } | null;
            };
          } | null;
        }> | null;
      };
      attributeValidationRequirements: Array<{
        __typename?: "AttributeValidation";
        valid: boolean;
        required: {
          __typename?: "Attribute";
          id: string;
          name: string;
          position: number;
          isRequired: boolean;
          type: AttributeType;
          isMultiSelect: boolean;
          parent?: {
            __typename?: "AttributeEdge";
            node?: { __typename?: "Attribute"; id: string } | null;
          } | null;
        };
        attribute: { __typename?: "Attribute"; id: string };
      }>;
      retailer: {
        __typename?: "RetailerEdge";
        node?: {
          __typename?: "Retailer";
          id: string;
          assortmentAttributes: {
            __typename?: "AttributeConnection";
            edges?: Array<{
              __typename?: "AttributeEdge";
              node?: {
                __typename?: "Attribute";
                id: string;
                name: string;
                position: number;
                isRequired: boolean;
                type: AttributeType;
                isMultiSelect: boolean;
                parent?: {
                  __typename?: "AttributeEdge";
                  node?: { __typename?: "Attribute"; id: string } | null;
                } | null;
              } | null;
            }> | null;
          };
        } | null;
      };
      deliveryWindow: {
        __typename?: "AssortmentDeliveryWindow";
        startShip?: any | null;
        completeShip?: any | null;
        due?: any | null;
      };
      validationRequirements: Array<{
        __typename?: "Validation";
        field: AssortmentValidationField;
        valid: boolean;
      }>;
    }>;
  } | null;
};

export type WorkspaceOverviewAssortmentFragment = {
  __typename?: "Assortment";
  collectionName?: string | null;
  id: string;
  status: AssortmentStatus;
  name: string;
  poNumber: string;
  modifiedDate: any;
  brand?: {
    __typename?: "RetailerBrandEdge";
    id: string;
    code?: string | null;
    alias?: string | null;
    node?: { __typename?: "Brand"; id: string; name: string } | null;
  } | null;
  season?: {
    __typename?: "SeasonEdge";
    node: {
      __typename?: "Season";
      id: string;
      code: string;
      name: string;
      year?: number | null;
    };
  } | null;
  financials: {
    __typename?: "AssortmentFinancials";
    id: string;
    total: {
      __typename?: "TotalPriceLevels";
      id: string;
      quantity: number;
      skuCount: number;
      final: Array<{
        __typename?: "PriceLevel";
        id: string;
        currencyCode: string;
        currencySource?: CurrencyFilter | null;
        extCost: string | number;
        extRetail: string | number;
      }>;
    };
    products: Array<{
      __typename?: "ProductPriceLevels";
      id: string;
      colorPriceLevels: Array<{
        __typename?: "ProductColorPriceLevels";
        id: string;
        quantity: number;
      }>;
    }>;
  };
  merchandisingHierarchy: {
    __typename?: "MerchandisingHierarchyNodeConnection";
    edges: Array<{
      __typename?: "MerchandisingHierarchyNodeEdge";
      node?: {
        __typename?: "MerchandisingHierarchyNode";
        name: string;
        code: string;
        id: string;
        parent?: {
          __typename?: "MerchandisingHierarchyNodeEdge";
          node?: {
            __typename?: "MerchandisingHierarchyNode";
            id: string;
          } | null;
        } | null;
        level?: {
          __typename?: "MerchandisingHierarchyLevelEdge";
          node?: {
            __typename?: "MerchandisingHierarchyLevel";
            id: string;
            code: string;
            name: string;
            depth: string;
          } | null;
        } | null;
      } | null;
    }>;
  };
  createdByUser: {
    __typename?: "RetailerUserEdge";
    node?: {
      __typename?: "RetailerUser";
      id: string;
      code: string;
      email: string;
      displayName: string;
    } | null;
  };
  attributeOptions: {
    __typename?: "AttributeOptionConnection";
    edges?: Array<{
      __typename?: "AttributeOptionEdge";
      node?: {
        __typename?: "AttributeOption";
        code: string;
        id: string;
        name: string;
        attribute: {
          __typename?: "AttributeEdge";
          node?: {
            __typename?: "Attribute";
            id: string;
            name: string;
            position: number;
            isRequired: boolean;
            type: AttributeType;
            isMultiSelect: boolean;
            parent?: {
              __typename?: "AttributeEdge";
              node?: { __typename?: "Attribute"; id: string } | null;
            } | null;
          } | null;
        };
      } | null;
    }> | null;
  };
  attributeValidationRequirements: Array<{
    __typename?: "AttributeValidation";
    valid: boolean;
    required: {
      __typename?: "Attribute";
      id: string;
      name: string;
      position: number;
      isRequired: boolean;
      type: AttributeType;
      isMultiSelect: boolean;
      parent?: {
        __typename?: "AttributeEdge";
        node?: { __typename?: "Attribute"; id: string } | null;
      } | null;
    };
    attribute: { __typename?: "Attribute"; id: string };
  }>;
  retailer: {
    __typename?: "RetailerEdge";
    node?: {
      __typename?: "Retailer";
      id: string;
      assortmentAttributes: {
        __typename?: "AttributeConnection";
        edges?: Array<{
          __typename?: "AttributeEdge";
          node?: {
            __typename?: "Attribute";
            id: string;
            name: string;
            position: number;
            isRequired: boolean;
            type: AttributeType;
            isMultiSelect: boolean;
            parent?: {
              __typename?: "AttributeEdge";
              node?: { __typename?: "Attribute"; id: string } | null;
            } | null;
          } | null;
        }> | null;
      };
    } | null;
  };
  deliveryWindow: {
    __typename?: "AssortmentDeliveryWindow";
    startShip?: any | null;
    completeShip?: any | null;
    due?: any | null;
  };
  validationRequirements: Array<{
    __typename?: "Validation";
    field: AssortmentValidationField;
    valid: boolean;
  }>;
};

export type WorkspaceOverviewAssortmentBaseFragment = {
  __typename?: "Assortment";
  name: string;
  poNumber: string;
  modifiedDate: any;
  deliveryWindow: {
    __typename?: "AssortmentDeliveryWindow";
    startShip?: any | null;
    completeShip?: any | null;
    due?: any | null;
  };
};

export type WorkspaceOverviewAttributeFragment = {
  __typename?: "Attribute";
  id: string;
  name: string;
  position: number;
  isRequired: boolean;
  type: AttributeType;
  isMultiSelect: boolean;
  parent?: {
    __typename?: "AttributeEdge";
    node?: { __typename?: "Attribute"; id: string } | null;
  } | null;
};

export type WorkspaceOverviewAttributeOptionFragment = {
  __typename?: "AttributeOption";
  code: string;
  id: string;
  name: string;
  attribute: {
    __typename?: "AttributeEdge";
    node?: {
      __typename?: "Attribute";
      id: string;
      name: string;
      position: number;
      isRequired: boolean;
      type: AttributeType;
      isMultiSelect: boolean;
      parent?: {
        __typename?: "AttributeEdge";
        node?: { __typename?: "Attribute"; id: string } | null;
      } | null;
    } | null;
  };
};

export type WorkspaceOverviewBrandFragment = {
  __typename?: "RetailerBrandEdge";
  id: string;
  code?: string | null;
  alias?: string | null;
  node?: { __typename?: "Brand"; id: string; name: string } | null;
};

export type WorkspaceOverviewDeliveryWindowFragment = {
  __typename?: "AssortmentDeliveryWindow";
  startShip?: any | null;
  completeShip?: any | null;
  due?: any | null;
};

export type WorkspaceOverviewFinancialsFragment = {
  __typename?: "AssortmentFinancials";
  id: string;
  total: {
    __typename?: "TotalPriceLevels";
    id: string;
    quantity: number;
    skuCount: number;
    final: Array<{
      __typename?: "PriceLevel";
      id: string;
      currencyCode: string;
      currencySource?: CurrencyFilter | null;
      extCost: string | number;
      extRetail: string | number;
    }>;
  };
  products: Array<{
    __typename?: "ProductPriceLevels";
    id: string;
    colorPriceLevels: Array<{
      __typename?: "ProductColorPriceLevels";
      id: string;
      quantity: number;
    }>;
  }>;
};

export type WorkspaceOverviewHierarchyFragment = {
  __typename?: "MerchandisingHierarchyNode";
  name: string;
  code: string;
  id: string;
  parent?: {
    __typename?: "MerchandisingHierarchyNodeEdge";
    node?: { __typename?: "MerchandisingHierarchyNode"; id: string } | null;
  } | null;
  level?: {
    __typename?: "MerchandisingHierarchyLevelEdge";
    node?: {
      __typename?: "MerchandisingHierarchyLevel";
      id: string;
      code: string;
      name: string;
      depth: string;
    } | null;
  } | null;
};

export type WorkspaceOverviewPriceLevelFragment = {
  __typename?: "PriceLevel";
  id: string;
  currencyCode: string;
  currencySource?: CurrencyFilter | null;
  extCost: string | number;
  extRetail: string | number;
};

export type SeasonFragment = {
  __typename?: "Season";
  id: string;
  code: string;
  name: string;
  year?: number | null;
};

export type WorkspaceOverviewTotalPriceLevelFragment = {
  __typename?: "TotalPriceLevels";
  id: string;
  quantity: number;
  skuCount: number;
  final: Array<{
    __typename?: "PriceLevel";
    id: string;
    currencyCode: string;
    currencySource?: CurrencyFilter | null;
    extCost: string | number;
    extRetail: string | number;
  }>;
};

export type WorkspaceOverviewUserFragment = {
  __typename?: "RetailerUser";
  id: string;
  code: string;
  email: string;
  displayName: string;
};

export type WorkspaceOverviewAvailableAttributesQueryVariables = Exact<{
  workspaceId: Scalars["ID"];
}>;

export type WorkspaceOverviewAvailableAttributesQuery = {
  __typename?: "Query";
  assortment?: {
    __typename?: "Assortment";
    id: string;
    retailer: {
      __typename?: "RetailerEdge";
      node?: {
        __typename?: "Retailer";
        id: string;
        assortmentAttributes: {
          __typename?: "AttributeConnection";
          edges?: Array<{
            __typename?: "AttributeEdge";
            node?: {
              __typename?: "Attribute";
              id: string;
              availableOptions: {
                __typename?: "AttributeOptionConnection";
                edges?: Array<{
                  __typename?: "AttributeOptionEdge";
                  node?: {
                    __typename?: "AttributeOption";
                    id: string;
                    code: string;
                    name: string;
                    attribute: {
                      __typename?: "AttributeEdge";
                      node?: {
                        __typename?: "Attribute";
                        id: string;
                        name: string;
                        position: number;
                        isRequired: boolean;
                        type: AttributeType;
                        isMultiSelect: boolean;
                        parent?: {
                          __typename?: "AttributeEdge";
                          node?: {
                            __typename?: "Attribute";
                            id: string;
                          } | null;
                        } | null;
                      } | null;
                    };
                  } | null;
                }> | null;
              };
            } | null;
          }> | null;
        };
      } | null;
    };
  } | null;
};

export type WorkspacePurchaseOrderCountQueryVariables = Exact<{
  workspaceId: Scalars["ID"];
}>;

export type WorkspacePurchaseOrderCountQuery = {
  __typename?: "Query";
  retailWorkspace?: {
    __typename?: "RetailWorkspace";
    id: string;
    assortments: Array<{ __typename?: "Assortment"; id: string }>;
  } | null;
};

export type WorkspaceRetailerNamesQueryVariables = Exact<{
  workspaceId: Scalars["ID"];
}>;

export type WorkspaceRetailerNamesQuery = {
  __typename?: "Query";
  retailWorkspace?: {
    __typename?: "RetailWorkspace";
    id: string;
    assortments: Array<{
      __typename?: "Assortment";
      id: string;
      retailer: {
        __typename?: "RetailerEdge";
        node?: {
          __typename?: "Retailer";
          id: string;
          name: string;
          displayName: string;
        } | null;
      };
    }>;
  } | null;
};

export type WorkspaceRetailerNamesAssortmentRetailerFragment = {
  __typename?: "Retailer";
  id: string;
  name: string;
  displayName: string;
};

export type WorkspaceTotalUnitsQueryVariables = Exact<{
  workspaceId: Scalars["ID"];
}>;

export type WorkspaceTotalUnitsQuery = {
  __typename?: "Query";
  retailWorkspace?: {
    __typename?: "RetailWorkspace";
    id: string;
    assortments: Array<{
      __typename?: "Assortment";
      id: string;
      financials: {
        __typename?: "AssortmentFinancials";
        id: string;
        products: Array<{
          __typename?: "ProductPriceLevels";
          id: string;
          colorPriceLevels: Array<{
            __typename?: "ProductColorPriceLevels";
            id: string;
            quantity: number;
          }>;
        }>;
        total: {
          __typename?: "TotalPriceLevels";
          id: string;
          quantity: number;
        };
      };
    }>;
  } | null;
};

export type WorkspaceValidationRequirementsQueryVariables = Exact<{
  workspaceId: Scalars["ID"];
}>;

export type WorkspaceValidationRequirementsQuery = {
  __typename?: "Query";
  retailWorkspace?: {
    __typename?: "RetailWorkspace";
    id: string;
    assortments: Array<{
      __typename?: "Assortment";
      id: string;
      validationRequirements: Array<{
        __typename?: "Validation";
        field: AssortmentValidationField;
        valid: boolean;
      }>;
      attributeValidationRequirements: Array<{
        __typename?: "AttributeValidation";
        valid: boolean;
        attribute: { __typename?: "Attribute"; id: string };
      }>;
    }>;
  } | null;
};

export const UpdateCurrencyCodesDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UpdateCurrencyCodes" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "AssortmentSKUEdge" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "wholesaleCurrencyCode" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "retailCurrencyCode" },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UpdateCurrencyCodesFragment, unknown>;
export const UpdateSizeNameDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UpdateSizeName" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Size" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }],
      },
    },
  ],
} as unknown as DocumentNode<UpdateSizeNameFragment, unknown>;
export const UpdateColorBulkQuantityDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UpdateColorBulkQuantity" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "AssortmentSKUColor" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "bulkQuantity" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UpdateColorBulkQuantityFragment, unknown>;
export const UpdateSizeBulkDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UpdateSizeBulk" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "AssortmentSKUEdge" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "bulkQuantity" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UpdateSizeBulkFragment, unknown>;
export const UpdateUpcDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UpdateUpc" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "AssortmentSKUEdge" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [{ kind: "Field", name: { kind: "Name", value: "upc" } }],
      },
    },
  ],
} as unknown as DocumentNode<UpdateUpcFragment, unknown>;
export const ManageImagesRemoveTestProductImagesDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ManageImagesRemoveTestProductImages" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Style" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "images" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "edges" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "node" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ManageImagesRemoveTestProductImagesFragment,
  unknown
>;
export const UpdateStyleNameDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UpdateStyleName" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Style" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }],
      },
    },
  ],
} as unknown as DocumentNode<UpdateStyleNameFragment, unknown>;
export const UpdateStyleCodeDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UpdateStyleCode" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Style" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [{ kind: "Field", name: { kind: "Name", value: "code" } }],
      },
    },
  ],
} as unknown as DocumentNode<UpdateStyleCodeFragment, unknown>;
export const UpdateColorNameDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UpdateColorName" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "AssortmentSKUColor" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }],
      },
    },
  ],
} as unknown as DocumentNode<UpdateColorNameFragment, unknown>;
export const UpdateColorCodeDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UpdateColorCode" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "AssortmentSKUColor" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [{ kind: "Field", name: { kind: "Name", value: "code" } }],
      },
    },
  ],
} as unknown as DocumentNode<UpdateColorCodeFragment, unknown>;
export const UpdateStyleDescriptionDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UpdateStyleDescription" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Style" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "description" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UpdateStyleDescriptionFragment, unknown>;
export const UpdateColorCommentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UpdateColorComment" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "AssortmentSKUColor" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "comment" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UpdateColorCommentFragment, unknown>;
export const UpdateSkuCommentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UpdateSkuComment" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "AssortmentSKUEdge" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "comment" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UpdateSkuCommentFragment, unknown>;
export const ProductAssortmentSkusFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ProductAssortmentSkusFragment" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Assortment" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "skus" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "edges" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "_id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "style" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "images" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "edges" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "node" },
                                          selectionSet: {
                                            kind: "SelectionSet",
                                            selections: [
                                              {
                                                kind: "Field",
                                                name: {
                                                  kind: "Name",
                                                  value: "id",
                                                },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "color" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "code" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "name" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "swatch" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "hex" },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "rgb" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "red" },
                                        },
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "green",
                                          },
                                        },
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "blue" },
                                        },
                                      ],
                                    },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "image" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "node" },
                                          selectionSet: {
                                            kind: "SelectionSet",
                                            selections: [
                                              {
                                                kind: "Field",
                                                name: {
                                                  kind: "Name",
                                                  value: "id",
                                                },
                                              },
                                              {
                                                kind: "Field",
                                                name: {
                                                  kind: "Name",
                                                  value: "url",
                                                },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "images" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "edges" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "node" },
                                          selectionSet: {
                                            kind: "SelectionSet",
                                            selections: [
                                              {
                                                kind: "Field",
                                                name: {
                                                  kind: "Name",
                                                  value: "id",
                                                },
                                              },
                                              {
                                                kind: "Field",
                                                name: {
                                                  kind: "Name",
                                                  value: "url",
                                                },
                                              },
                                              {
                                                kind: "Field",
                                                name: {
                                                  kind: "Name",
                                                  value: "owner",
                                                },
                                                selectionSet: {
                                                  kind: "SelectionSet",
                                                  selections: [
                                                    {
                                                      kind: "Field",
                                                      name: {
                                                        kind: "Name",
                                                        value: "id",
                                                      },
                                                    },
                                                  ],
                                                },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ProductAssortmentSkusFragment, unknown>;
export const UploadedSwatchImageDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UploadedSwatchImage" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Image" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "url" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "owner" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UploadedSwatchImageFragment, unknown>;
export const UpdatePriceLevelsDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UpdatePriceLevels" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "AssortmentSKUEdge" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "priceLevels" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "extendedWholesale" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "extendedRetail" },
                },
                { kind: "Field", name: { kind: "Name", value: "maxRetail" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "maxWholesale" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "currencyCode" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "currencySource" },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UpdatePriceLevelsFragment, unknown>;
export const ImageFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ImageFragment" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Image" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "url" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "owner" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ImageFragment, unknown>;
export const AlProductDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ALProduct" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Style" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "images" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "edges" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "node" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "FragmentSpread",
                              name: { kind: "Name", value: "ImageFragment" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "details" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "fabrication" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "materials" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<AlProductFragment, unknown>;
export const ColorSwatchFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ColorSwatchFragment" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "ColorSwatch" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "hex" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "rgb" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "red" } },
                { kind: "Field", name: { kind: "Name", value: "green" } },
                { kind: "Field", name: { kind: "Name", value: "blue" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "image" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "node" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "ImageFragment" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ColorSwatchFragment, unknown>;
export const AlAttributeDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ALAttribute" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Attribute" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "position" } },
          { kind: "Field", name: { kind: "Name", value: "isRequired" } },
          { kind: "Field", name: { kind: "Name", value: "type" } },
          { kind: "Field", name: { kind: "Name", value: "isMultiSelect" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "parent" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "node" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<AlAttributeFragment, unknown>;
export const AlOptionDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ALOption" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "AttributeOption" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "attribute" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "node" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "ALAttribute" },
                      },
                    ],
                  },
                },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "code" } },
          {
            kind: "Field",
            alias: { kind: "Name", value: "name" },
            name: { kind: "Name", value: "value" },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<AlOptionFragment, unknown>;
export const AlColorDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ALColor" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "AssortmentSKUColor" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "images" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "edges" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "node" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "FragmentSpread",
                              name: { kind: "Name", value: "ImageFragment" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "swatch" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "ColorSwatchFragment" },
                },
              ],
            },
          },
          {
            kind: "Field",
            alias: { kind: "Name", value: "attributes" },
            name: { kind: "Name", value: "attributeOptions" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "edges" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "node" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "FragmentSpread",
                              name: { kind: "Name", value: "ALOption" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            alias: { kind: "Name", value: "required" },
            name: { kind: "Name", value: "missingRequiredAttributes" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "edges" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "node" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "FragmentSpread",
                              name: { kind: "Name", value: "ALAttribute" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "skus" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "_id" } },
                {
                  kind: "Field",
                  alias: { kind: "Name", value: "catalogSku" },
                  name: { kind: "Name", value: "node" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "size" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "name" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            alias: { kind: "Name", value: "price" },
            name: { kind: "Name", value: "priceLevels" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                {
                  kind: "Field",
                  alias: { kind: "Name", value: "levels" },
                  name: { kind: "Name", value: "priceLevels" },
                  arguments: [
                    {
                      kind: "Argument",
                      name: { kind: "Name", value: "filters" },
                      value: {
                        kind: "ObjectValue",
                        fields: [
                          {
                            kind: "ObjectField",
                            name: { kind: "Name", value: "name" },
                            value: { kind: "EnumValue", value: "FINAL" },
                          },
                        ],
                      },
                    },
                  ],
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        alias: { kind: "Name", value: "source" },
                        name: { kind: "Name", value: "currencySource" },
                      },
                      {
                        kind: "Field",
                        alias: { kind: "Name", value: "currency" },
                        name: { kind: "Name", value: "currencyCode" },
                      },
                      {
                        kind: "Field",
                        alias: { kind: "Name", value: "wholesale" },
                        name: { kind: "Name", value: "maxWholesale" },
                      },
                      {
                        kind: "Field",
                        alias: { kind: "Name", value: "retail" },
                        name: { kind: "Name", value: "maxRetail" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<AlColorFragment, unknown>;
export const AlRowDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ALRow" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "AssortmentSKUEdge" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "_id" } },
          {
            kind: "Field",
            alias: { kind: "Name", value: "product" },
            name: { kind: "Name", value: "style" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "ALProduct" },
                },
              ],
            },
          },
          {
            kind: "Field",
            alias: { kind: "Name", value: "color" },
            name: { kind: "Name", value: "colorV2" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "ALColor" },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<AlRowFragment, unknown>;
export const StyleDetailsFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "StyleDetailsFragment" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Style" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "details" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "categories" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "countryOfOrigin" },
                },
                { kind: "Field", name: { kind: "Name", value: "furStatus" } },
                { kind: "Field", name: { kind: "Name", value: "heelHeight" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "materials" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "measurements" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "modelHeightInches" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "silhouette" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "sourceOfMaterials" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "fabrication" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<StyleDetailsFragment, unknown>;
export const AssortmentColorDoorQuantitiesFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "AssortmentColorDoorQuantitiesFragment" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "AssortmentSKUColor" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "doorQuantities" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "door" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "bulkQuantity" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "totalSizedQuantity" },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<AssortmentColorDoorQuantitiesFragment, unknown>;
export const ColorAttributeOptionsFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ColorAttributeOptionsFragment" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "AssortmentSKUColor" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "attributeOptions" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "edges" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "node" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "attribute" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "node" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "id" },
                                        },
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "name" },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "value" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ColorAttributeOptionsFragment, unknown>;
export const SizeCurvesFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "SizeCurvesFragment" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "AssortmentSKUColor" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "sizeCurves" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "missingFields" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "doorSizeCurves" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "door" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "curveRatios" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "retailSize" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "id" },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "code" },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "name" },
                                  },
                                ],
                              },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "ratio" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<SizeCurvesFragment, unknown>;
export const AssortmentSkuDoorQuantitiesFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "AssortmentSkuDoorQuantitiesFragment" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "AssortmentSKUEdge" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "doorQuantities" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "door" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                    ],
                  },
                },
                { kind: "Field", name: { kind: "Name", value: "quantity" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "appliedSizeRatio" },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<AssortmentSkuDoorQuantitiesFragment, unknown>;
export const PriceLevelsFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "PriceLevelsFragment" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "PriceLevel" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "extendedWholesale" } },
          { kind: "Field", name: { kind: "Name", value: "extendedRetail" } },
          { kind: "Field", name: { kind: "Name", value: "maxRetail" } },
          { kind: "Field", name: { kind: "Name", value: "maxWholesale" } },
          { kind: "Field", name: { kind: "Name", value: "currencyCode" } },
          { kind: "Field", name: { kind: "Name", value: "currencySource" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<PriceLevelsFragment, unknown>;
export const AssortmentSkusEdgesFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "AssortmentSkusEdgesFragment" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Assortment" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "skus" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "edges" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "_id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "legacyItemId" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "comment" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "isCustom" },
                      },
                      { kind: "Field", name: { kind: "Name", value: "upc" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "node" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "color" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "id" },
                                  },
                                ],
                              },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "size" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "id" },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "code" },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "name" },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "style" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "name" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "code" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "images" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "edges" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "node" },
                                          selectionSet: {
                                            kind: "SelectionSet",
                                            selections: [
                                              {
                                                kind: "FragmentSpread",
                                                name: {
                                                  kind: "Name",
                                                  value: "ImageFragment",
                                                },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: "FragmentSpread",
                              name: {
                                kind: "Name",
                                value: "StyleDetailsFragment",
                              },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "description" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        alias: { kind: "Name", value: "color" },
                        name: { kind: "Name", value: "colorV2" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "name" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "code" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "comment" },
                            },
                            {
                              kind: "Field",
                              name: {
                                kind: "Name",
                                value: "totalSizedQuantity",
                              },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "bulkQuantity" },
                            },
                            {
                              kind: "FragmentSpread",
                              name: {
                                kind: "Name",
                                value: "AssortmentColorDoorQuantitiesFragment",
                              },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "swatch" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "FragmentSpread",
                                    name: {
                                      kind: "Name",
                                      value: "ColorSwatchFragment",
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "images" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "edges" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "node" },
                                          selectionSet: {
                                            kind: "SelectionSet",
                                            selections: [
                                              {
                                                kind: "FragmentSpread",
                                                name: {
                                                  kind: "Name",
                                                  value: "ImageFragment",
                                                },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: "FragmentSpread",
                              name: {
                                kind: "Name",
                                value: "ColorAttributeOptionsFragment",
                              },
                            },
                            {
                              kind: "FragmentSpread",
                              name: {
                                kind: "Name",
                                value: "SizeCurvesFragment",
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "size" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "code" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "name" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "sizeRun" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "node" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "id" },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "code" },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "name" },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "retailSize" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "code" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "name" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "availableRetailSizeOptions",
                        },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "code" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "name" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "wholesaleCurrencyCode" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "retailCurrencyCode" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "bulkQuantity" },
                      },
                      {
                        kind: "FragmentSpread",
                        name: {
                          kind: "Name",
                          value: "AssortmentSkuDoorQuantitiesFragment",
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "priceLevels" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "FragmentSpread",
                              name: {
                                kind: "Name",
                                value: "PriceLevelsFragment",
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<AssortmentSkusEdgesFragment, unknown>;
export const AttributeOptionsOnColorFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "AttributeOptionsOnColorFragment" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "AssortmentSKUColor" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "attributeOptions" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "edges" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "node" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "attribute" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "node" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "id" },
                                        },
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "name" },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "value" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<AttributeOptionsOnColorFragment, unknown>;
export const DoorFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "DoorFragment" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Door" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "code" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<DoorFragment, unknown>;
export const AssortmentDoorsFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "AssortmentDoorsFragment" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Assortment" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "doors" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "edges" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "node" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "FragmentSpread",
                              name: { kind: "Name", value: "DoorFragment" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<AssortmentDoorsFragment, unknown>;
export const DoorQuantitySkuFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "DoorQuantitySkuFragment" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "AssortmentSKUEdge" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "_id" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "node" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "bulkQuantity" } },
          {
            kind: "FragmentSpread",
            name: {
              kind: "Name",
              value: "AssortmentSkuDoorQuantitiesFragment",
            },
          },
          {
            kind: "Field",
            alias: { kind: "Name", value: "color" },
            name: { kind: "Name", value: "colorV2" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "totalSizedQuantity" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "bulkQuantity" },
                },
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "SizeCurvesFragment" },
                },
                {
                  kind: "FragmentSpread",
                  name: {
                    kind: "Name",
                    value: "AssortmentColorDoorQuantitiesFragment",
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "priceLevels" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "PriceLevelsFragment" },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<DoorQuantitySkuFragment, unknown>;
export const FinancialCurrencyConversionsFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "FinancialCurrencyConversionsFragment" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Assortment" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "currencies" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "currencyConversions" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        alias: { kind: "Name", value: "conversionFactor" },
                        name: { kind: "Name", value: "factor" },
                      },
                      {
                        kind: "Field",
                        alias: { kind: "Name", value: "fromCurrency" },
                        name: { kind: "Name", value: "fromCurrencyCode" },
                      },
                      {
                        kind: "Field",
                        alias: { kind: "Name", value: "toCurrency" },
                        name: { kind: "Name", value: "toCurrencyCode" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<FinancialCurrencyConversionsFragment, unknown>;
export const UnitFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UnitFragment" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "AssortmentUnits" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "productCount" } },
          { kind: "Field", name: { kind: "Name", value: "colorCount" } },
          { kind: "Field", name: { kind: "Name", value: "skuCount" } },
          { kind: "Field", name: { kind: "Name", value: "unitCount" } },
          { kind: "Field", name: { kind: "Name", value: "unitDepth" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UnitFragment, unknown>;
export const FinancialPriceFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "FinancialPriceFragment" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "FinancialPriceLevel" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "cost" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "value" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "retail" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "value" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "extendedCost" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "value" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "extendedRetail" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "value" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "averageUnitCost" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "value" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "averageUnitRetail" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "value" } },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "initialMarkup" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<FinancialPriceFragment, unknown>;
export const FinancialPriceTargetFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "FinancialPriceTargetFragment" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "AssortmentFinancialPriceTargets" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "cost" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "value" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "retail" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "value" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "averageUnitCost" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "value" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "averageUnitRetail" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "value" } },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "initialMarkup" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<FinancialPriceTargetFragment, unknown>;
export const FinancialOverviewFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "FinancialOverviewFragment" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Assortment" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "financialOverview" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "assortmentCurrencyCode" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "linesheetCurrencyCode" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "assortmentUnits" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "UnitFragment" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "financialDetails" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "currencyCode" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "priceLevels" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "name" },
                            },
                            {
                              kind: "FragmentSpread",
                              name: {
                                kind: "Name",
                                value: "FinancialPriceFragment",
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "isBrandCurrency" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "units" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "FragmentSpread",
                              name: { kind: "Name", value: "UnitFragment" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "financialTargets" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "priceTargets" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "FragmentSpread",
                              name: {
                                kind: "Name",
                                value: "FinancialPriceTargetFragment",
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "priceTargetsVariance" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "FragmentSpread",
                              name: {
                                kind: "Name",
                                value: "FinancialPriceTargetFragment",
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<FinancialOverviewFragment, unknown>;
export const GenericSkuFieldsFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "GenericSkuFieldsFragment" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "AssortmentSKUEdge" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "_id" } },
          { kind: "Field", name: { kind: "Name", value: "legacyItemId" } },
          { kind: "Field", name: { kind: "Name", value: "comment" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "style" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "code" } },
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "StyleDetailsFragment" },
                },
                { kind: "Field", name: { kind: "Name", value: "description" } },
              ],
            },
          },
          {
            kind: "Field",
            alias: { kind: "Name", value: "color" },
            name: { kind: "Name", value: "colorV2" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "code" } },
                { kind: "Field", name: { kind: "Name", value: "comment" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GenericSkuFieldsFragment, unknown>;
export const ImageDataFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ImageDataFragment" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Image" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "url" } },
          { kind: "Field", name: { kind: "Name", value: "base64Data" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ImageDataFragment, unknown>;
export const MissingRequiredAttributesFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "MissingRequiredAttributesFragment" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "AssortmentSKUColor" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "missingRequiredAttributes" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "edges" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "node" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "name" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<MissingRequiredAttributesFragment, unknown>;
export const PriceModifierFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "PriceModifierFragment" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Assortment" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "priceModifiers" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "edges" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "node" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "factor" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "percent" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "group" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "node" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "id" },
                                        },
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "name" },
                                        },
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "adjustmentType",
                                          },
                                        },
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "displayFormat",
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<PriceModifierFragment, unknown>;
export const RetailBudgetCategoryFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "RetailBudgetCategoryFragment" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "RetailBudgetCategory" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "categoryType" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<RetailBudgetCategoryFragment, unknown>;
export const RetailBudgetCategoryAmountFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "RetailBudgetCategoryAmountFragment" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "RetailBudgetCategoryAmount" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "selection" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: { kind: "Name", value: "RetailerBrand" },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                    ],
                  },
                },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: { kind: "Name", value: "MerchandisingHierarchyNode" },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                    ],
                  },
                },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: { kind: "Name", value: "AttributeOption" },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "code" } },
                      { kind: "Field", name: { kind: "Name", value: "value" } },
                    ],
                  },
                },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "finalExtCost" } },
          { kind: "Field", name: { kind: "Name", value: "finalExtRetail" } },
          { kind: "Field", name: { kind: "Name", value: "totalUnits" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "categoryTotals" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "finalExtCost" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "finalExtRetail" },
                },
                { kind: "Field", name: { kind: "Name", value: "totalUnits" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "productTotals" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "finalExtCost" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "finalExtRetail" },
                },
                { kind: "Field", name: { kind: "Name", value: "totalUnits" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<RetailBudgetCategoryAmountFragment, unknown>;
export const RetailBudgetFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "RetailBudgetFragment" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "RetailBudget" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "workspaceOrAssortmentId" },
          },
          { kind: "Field", name: { kind: "Name", value: "budgetType" } },
          { kind: "Field", name: { kind: "Name", value: "finalExtCost" } },
          { kind: "Field", name: { kind: "Name", value: "finalExtRetail" } },
          { kind: "Field", name: { kind: "Name", value: "totalUnits" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "productTotals" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "finalExtCost" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "finalExtRetail" },
                },
                { kind: "Field", name: { kind: "Name", value: "totalUnits" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "categoryTotals" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "finalExtCost" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "finalExtRetail" },
                },
                { kind: "Field", name: { kind: "Name", value: "totalUnits" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "finalExtCostCurrency" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "finalExtRetailCurrency" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "topLevelBudgetCategory" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "RetailBudgetCategoryFragment" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "child" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: {
                          kind: "Name",
                          value: "RetailBudgetCategoryFragment",
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "child" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "FragmentSpread",
                              name: {
                                kind: "Name",
                                value: "RetailBudgetCategoryFragment",
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "categoryAmounts" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: {
                    kind: "Name",
                    value: "RetailBudgetCategoryAmountFragment",
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "categoryAmounts" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: {
                          kind: "Name",
                          value: "RetailBudgetCategoryAmountFragment",
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "categoryAmounts" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "FragmentSpread",
                              name: {
                                kind: "Name",
                                value: "RetailBudgetCategoryAmountFragment",
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<RetailBudgetFragment, unknown>;
export const SavedViewFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "SavedViewFragment" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Configuration" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "accountId" } },
          { kind: "Field", name: { kind: "Name", value: "userId" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          {
            kind: "Field",
            alias: { kind: "Name", value: "isDefault" },
            name: { kind: "Name", value: "default" },
          },
          { kind: "Field", name: { kind: "Name", value: "data" } },
          { kind: "Field", name: { kind: "Name", value: "projectName" } },
          { kind: "Field", name: { kind: "Name", value: "visibility" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<SavedViewFragment, unknown>;
export const SetPriceSkuEdgesFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "SetPriceSkuEdgesFragment" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "AssortmentSKUEdge" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "_id" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "node" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "style" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "wholesaleCurrencyCode" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "retailCurrencyCode" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "priceLevels" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "PriceLevelsFragment" },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<SetPriceSkuEdgesFragment, unknown>;
export const SizeRunFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "SizeRunFragment" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "AssortmentSKUEdge" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "_id" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "node" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "style" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "sizeRun" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "node" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "code" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "retailSize" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "code" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "availableRetailSizeOptions" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "code" } },
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<SizeRunFragment, unknown>;
export const SkuBulkUnitsFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "SkuBulkUnitsFragment" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "AssortmentSKUEdge" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "_id" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "node" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "bulkQuantity" } },
          {
            kind: "Field",
            alias: { kind: "Name", value: "color" },
            name: { kind: "Name", value: "colorV2" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "totalSizedQuantity" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "bulkQuantity" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "style" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "priceLevels" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "PriceLevelsFragment" },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<SkuBulkUnitsFragment, unknown>;
export const RetailerAssortmentAttributeOptionsFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: {
        kind: "Name",
        value: "RetailerAssortmentAttributeOptionsFragment",
      },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Retailer" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "assortmentAttributes" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "edges" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "node" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "name" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "isRequired" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "availableOptions" },
                              arguments: [
                                {
                                  kind: "Argument",
                                  name: { kind: "Name", value: "assortmentId" },
                                  value: {
                                    kind: "Variable",
                                    name: {
                                      kind: "Name",
                                      value: "assortmentId",
                                    },
                                  },
                                },
                              ],
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "edges" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "node" },
                                          selectionSet: {
                                            kind: "SelectionSet",
                                            selections: [
                                              {
                                                kind: "Field",
                                                name: {
                                                  kind: "Name",
                                                  value: "id",
                                                },
                                              },
                                              {
                                                kind: "Field",
                                                name: {
                                                  kind: "Name",
                                                  value: "value",
                                                },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  RetailerAssortmentAttributeOptionsFragment,
  unknown
>;
export const WorkspaceDetailsAssortmentFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "WorkspaceDetailsAssortmentFragment" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Assortment" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            alias: { kind: "Name", value: "assortmentName" },
            name: { kind: "Name", value: "name" },
          },
          {
            kind: "Field",
            alias: { kind: "Name", value: "joorPo" },
            name: { kind: "Name", value: "poNumber" },
          },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          {
            kind: "Field",
            alias: { kind: "Name", value: "version" },
            name: { kind: "Name", value: "_version" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "availableMerchandisingHierarchy" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "edges" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "node" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "name" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "code" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "parent" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "node" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "id" },
                                        },
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "code" },
                                        },
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "name" },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "level" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "node" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "id" },
                                        },
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "name" },
                                        },
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "code" },
                                        },
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "depth",
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "attributeOptions" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "edges" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "node" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "value" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "attribute" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "node" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "id" },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "brand" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                {
                  kind: "Field",
                  alias: { kind: "Name", value: "brandAlias" },
                  name: { kind: "Name", value: "alias" },
                },
                { kind: "Field", name: { kind: "Name", value: "code" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "node" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        alias: { kind: "Name", value: "brandName" },
                        name: { kind: "Name", value: "name" },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "createdByUser" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "node" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "email" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "displayName" },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "deliveryWindow" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "startShip" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "completeShip" },
                },
                { kind: "Field", name: { kind: "Name", value: "due" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "merchandisingHierarchy" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "edges" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "node" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "name" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "parent" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "node" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "id" },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "level" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "node" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "id" },
                                        },
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "name" },
                                        },
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "code" },
                                        },
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "depth",
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "retailer" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "node" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "displayName" },
                      },
                      {
                        kind: "FragmentSpread",
                        name: {
                          kind: "Name",
                          value: "RetailerAssortmentAttributeOptionsFragment",
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "brands" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "edges" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "id" },
                                  },
                                  {
                                    kind: "Field",
                                    alias: {
                                      kind: "Name",
                                      value: "brandAlias",
                                    },
                                    name: { kind: "Name", value: "alias" },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "code" },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "node" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "id" },
                                        },
                                        {
                                          kind: "Field",
                                          alias: {
                                            kind: "Name",
                                            value: "brandName",
                                          },
                                          name: { kind: "Name", value: "name" },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "seasons" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "edges" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "node" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "id" },
                                        },
                                        {
                                          kind: "Field",
                                          alias: {
                                            kind: "Name",
                                            value: "seasonName",
                                          },
                                          name: { kind: "Name", value: "name" },
                                        },
                                        {
                                          kind: "Field",
                                          alias: {
                                            kind: "Name",
                                            value: "seasonYear",
                                          },
                                          name: { kind: "Name", value: "year" },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "season" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "node" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        alias: { kind: "Name", value: "seasonName" },
                        name: { kind: "Name", value: "name" },
                      },
                      {
                        kind: "Field",
                        alias: { kind: "Name", value: "seasonYear" },
                        name: { kind: "Name", value: "year" },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "skus" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "edges" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "_id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "isCustom" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "node" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        alias: { kind: "Name", value: "color" },
                        name: { kind: "Name", value: "colorV2" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" },
                            },
                            {
                              kind: "FragmentSpread",
                              name: {
                                kind: "Name",
                                value: "SizeCurvesFragment",
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<WorkspaceDetailsAssortmentFragment, unknown>;
export const AccountPrimaryFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "AccountPrimaryFragment" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Account" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "type" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "tier" },
            directives: [
              { kind: "Directive", name: { kind: "Name", value: "client" } },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<AccountPrimaryFragment, unknown>;
export const DoorClusterFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "DoorClusterFragment" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "DoorCluster" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "code" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "doors" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "edges" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "node" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "FragmentSpread",
                              name: { kind: "Name", value: "DoorFragment" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<DoorClusterFragment, unknown>;
export const AssortmentDoorsClustersFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "AssortmentDoorsClustersFragment" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Assortment" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "doorClusters" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "edges" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "node" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "FragmentSpread",
                              name: {
                                kind: "Name",
                                value: "DoorClusterFragment",
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<AssortmentDoorsClustersFragment, unknown>;
export const DoorRunFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "DoorRunFragment" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "AssortmentDoorRun" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "orderNbr" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<DoorRunFragment, unknown>;
export const AssortmentDoorRunsFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "AssortmentDoorRunsFragment" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Assortment" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "doorRuns" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "edges" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "node" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "FragmentSpread",
                              name: { kind: "Name", value: "DoorRunFragment" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<AssortmentDoorRunsFragment, unknown>;
export const UserPrimaryFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UserPrimaryFragment" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "User" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "code" } },
          { kind: "Field", name: { kind: "Name", value: "displayName" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "assortmentPlanning" },
          },
          { kind: "Field", name: { kind: "Name", value: "id" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UserPrimaryFragment, unknown>;
export const WorkspaceBrandNamesAssortmentBrandDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "WorkspaceBrandNamesAssortmentBrand" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "RetailerBrandEdge" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "alias" } },
          { kind: "Field", name: { kind: "Name", value: "code" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "node" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  WorkspaceBrandNamesAssortmentBrandFragment,
  unknown
>;
export const WorkspaceCurrenciesFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "WorkspaceCurrenciesFragment" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Assortment" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "financialOverview" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "financialDetails" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "currencyCode" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "isBrandCurrency" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<WorkspaceCurrenciesFragment, unknown>;
export const WorkspaceDeliveryWindowFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "WorkspaceDeliveryWindowFragment" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "AssortmentDeliveryWindow" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "startShip" } },
          { kind: "Field", name: { kind: "Name", value: "completeShip" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<WorkspaceDeliveryWindowFragment, unknown>;
export const WorkspaceDeliveryWindowAssortmentFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: {
        kind: "Name",
        value: "WorkspaceDeliveryWindowAssortmentFragment",
      },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Assortment" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "deliveryWindow" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: {
                    kind: "Name",
                    value: "WorkspaceDeliveryWindowFragment",
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  WorkspaceDeliveryWindowAssortmentFragment,
  unknown
>;
export const WorkspaceFinancialsPriceLevelFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "WorkspaceFinancialsPriceLevelFragment" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "PriceLevel" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "currencyCode" } },
          {
            kind: "Field",
            alias: { kind: "Name", value: "extCost" },
            name: { kind: "Name", value: "extendedWholesale" },
          },
          {
            kind: "Field",
            alias: { kind: "Name", value: "extRetail" },
            name: { kind: "Name", value: "extendedRetail" },
          },
          { kind: "Field", name: { kind: "Name", value: "currencySource" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<WorkspaceFinancialsPriceLevelFragment, unknown>;
export const WorkspaceFinancialsAssortmentFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "WorkspaceFinancialsAssortmentFragment" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Assortment" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "financials" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "total" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        alias: { kind: "Name", value: "final" },
                        name: { kind: "Name", value: "priceLevels" },
                        arguments: [
                          {
                            kind: "Argument",
                            name: { kind: "Name", value: "filters" },
                            value: {
                              kind: "ObjectValue",
                              fields: [
                                {
                                  kind: "ObjectField",
                                  name: { kind: "Name", value: "name" },
                                  value: { kind: "EnumValue", value: "FINAL" },
                                },
                              ],
                            },
                          },
                        ],
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "FragmentSpread",
                              name: {
                                kind: "Name",
                                value: "WorkspaceFinancialsPriceLevelFragment",
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        alias: { kind: "Name", value: "modified" },
                        name: { kind: "Name", value: "priceLevels" },
                        arguments: [
                          {
                            kind: "Argument",
                            name: { kind: "Name", value: "filters" },
                            value: {
                              kind: "ObjectValue",
                              fields: [
                                {
                                  kind: "ObjectField",
                                  name: { kind: "Name", value: "name" },
                                  value: {
                                    kind: "EnumValue",
                                    value: "MODIFIED",
                                  },
                                },
                              ],
                            },
                          },
                        ],
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "FragmentSpread",
                              name: {
                                kind: "Name",
                                value: "WorkspaceFinancialsPriceLevelFragment",
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<WorkspaceFinancialsAssortmentFragment, unknown>;
export const WorkspaceUnitsCountFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "WorkspaceUnitsCountFragment" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Assortment" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "financialOverview" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "financialDetails" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "isBrandCurrency" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "currencyCode" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "units" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "productCount" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "colorCount" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "skuCount" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "unitCount" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "unitDepth" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "priceLevels" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "name" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "cost" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "value" },
                                  },
                                ],
                              },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "retail" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "value" },
                                  },
                                ],
                              },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "extendedCost" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "value" },
                                  },
                                ],
                              },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "extendedRetail" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "value" },
                                  },
                                ],
                              },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "averageUnitCost" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "value" },
                                  },
                                ],
                              },
                            },
                            {
                              kind: "Field",
                              name: {
                                kind: "Name",
                                value: "averageUnitRetail",
                              },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "value" },
                                  },
                                ],
                              },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "initialMarkup" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<WorkspaceUnitsCountFragment, unknown>;
export const WorkspaceOverviewDeliveryWindowFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "WorkspaceOverviewDeliveryWindowFragment" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "AssortmentDeliveryWindow" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "startShip" } },
          { kind: "Field", name: { kind: "Name", value: "completeShip" } },
          { kind: "Field", name: { kind: "Name", value: "due" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<WorkspaceOverviewDeliveryWindowFragment, unknown>;
export const WorkspaceOverviewAssortmentBaseFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "WorkspaceOverviewAssortmentBaseFragment" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Assortment" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "poNumber" } },
          { kind: "Field", name: { kind: "Name", value: "modifiedDate" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "deliveryWindow" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: {
                    kind: "Name",
                    value: "WorkspaceOverviewDeliveryWindowFragment",
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<WorkspaceOverviewAssortmentBaseFragment, unknown>;
export const WorkspaceOverviewBrandFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "WorkspaceOverviewBrandFragment" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "RetailerBrandEdge" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "code" } },
          { kind: "Field", name: { kind: "Name", value: "alias" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "node" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<WorkspaceOverviewBrandFragment, unknown>;
export const SeasonFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "SeasonFragment" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Season" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "code" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "year" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<SeasonFragment, unknown>;
export const WorkspaceOverviewPriceLevelFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "WorkspaceOverviewPriceLevelFragment" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "PriceLevel" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          {
            kind: "Field",
            alias: { kind: "Name", value: "extCost" },
            name: { kind: "Name", value: "extendedWholesale" },
          },
          {
            kind: "Field",
            alias: { kind: "Name", value: "extRetail" },
            name: { kind: "Name", value: "extendedRetail" },
          },
          { kind: "Field", name: { kind: "Name", value: "currencyCode" } },
          { kind: "Field", name: { kind: "Name", value: "currencySource" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<WorkspaceOverviewPriceLevelFragment, unknown>;
export const WorkspaceOverviewTotalPriceLevelFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "WorkspaceOverviewTotalPriceLevelFragment" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "TotalPriceLevels" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          {
            kind: "Field",
            alias: { kind: "Name", value: "final" },
            name: { kind: "Name", value: "priceLevels" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "filters" },
                value: {
                  kind: "ObjectValue",
                  fields: [
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "name" },
                      value: { kind: "EnumValue", value: "FINAL" },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: {
                    kind: "Name",
                    value: "WorkspaceOverviewPriceLevelFragment",
                  },
                },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "quantity" } },
          { kind: "Field", name: { kind: "Name", value: "skuCount" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<WorkspaceOverviewTotalPriceLevelFragment, unknown>;
export const WorkspaceOverviewFinancialsFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "WorkspaceOverviewFinancialsFragment" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "AssortmentFinancials" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "total" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: {
                    kind: "Name",
                    value: "WorkspaceOverviewTotalPriceLevelFragment",
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "products" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "colorPriceLevels" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "quantity" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<WorkspaceOverviewFinancialsFragment, unknown>;
export const WorkspaceOverviewHierarchyFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "WorkspaceOverviewHierarchyFragment" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "MerchandisingHierarchyNode" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "code" } },
          { kind: "Field", name: { kind: "Name", value: "id" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "parent" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "node" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "level" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "node" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "code" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      { kind: "Field", name: { kind: "Name", value: "depth" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<WorkspaceOverviewHierarchyFragment, unknown>;
export const WorkspaceOverviewUserFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "WorkspaceOverviewUserFragment" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "RetailerUser" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "code" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          { kind: "Field", name: { kind: "Name", value: "displayName" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<WorkspaceOverviewUserFragment, unknown>;
export const WorkspaceOverviewAttributeFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "WorkspaceOverviewAttributeFragment" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Attribute" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "position" } },
          { kind: "Field", name: { kind: "Name", value: "isRequired" } },
          { kind: "Field", name: { kind: "Name", value: "type" } },
          { kind: "Field", name: { kind: "Name", value: "isMultiSelect" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "parent" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "node" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<WorkspaceOverviewAttributeFragment, unknown>;
export const WorkspaceOverviewAttributeOptionFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "WorkspaceOverviewAttributeOptionFragment" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "AttributeOption" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "code" } },
          { kind: "Field", name: { kind: "Name", value: "id" } },
          {
            kind: "Field",
            alias: { kind: "Name", value: "name" },
            name: { kind: "Name", value: "value" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "attribute" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "node" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: {
                          kind: "Name",
                          value: "WorkspaceOverviewAttributeFragment",
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<WorkspaceOverviewAttributeOptionFragment, unknown>;
export const AssortmentValidationFieldsFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "AssortmentValidationFieldsFragment" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Validation" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "field" } },
          { kind: "Field", name: { kind: "Name", value: "valid" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<AssortmentValidationFieldsFragment, unknown>;
export const AssortmentItemValidationFieldsFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "AssortmentItemValidationFieldsFragment" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "AttributeValidation" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "attribute" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "valid" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<AssortmentItemValidationFieldsFragment, unknown>;
export const AssortmentValidationRequirementsFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "AssortmentValidationRequirementsFragment" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Assortment" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "validationRequirements" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: {
                    kind: "Name",
                    value: "AssortmentValidationFieldsFragment",
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "attributeValidationRequirements" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: {
                    kind: "Name",
                    value: "AssortmentItemValidationFieldsFragment",
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<AssortmentValidationRequirementsFragment, unknown>;
export const WorkspaceOverviewAssortmentFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "WorkspaceOverviewAssortmentFragment" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Assortment" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "collectionName" } },
          { kind: "Field", name: { kind: "Name", value: "id" } },
          {
            kind: "FragmentSpread",
            name: {
              kind: "Name",
              value: "WorkspaceOverviewAssortmentBaseFragment",
            },
          },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "brand" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: {
                    kind: "Name",
                    value: "WorkspaceOverviewBrandFragment",
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "season" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "node" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "SeasonFragment" },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "financials" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: {
                    kind: "Name",
                    value: "WorkspaceOverviewFinancialsFragment",
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "merchandisingHierarchy" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "edges" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "node" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "FragmentSpread",
                              name: {
                                kind: "Name",
                                value: "WorkspaceOverviewHierarchyFragment",
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "createdByUser" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "node" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: {
                          kind: "Name",
                          value: "WorkspaceOverviewUserFragment",
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "attributeOptions" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "edges" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "node" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "FragmentSpread",
                              name: {
                                kind: "Name",
                                value:
                                  "WorkspaceOverviewAttributeOptionFragment",
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "attributeValidationRequirements" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "valid" } },
                {
                  kind: "Field",
                  alias: { kind: "Name", value: "required" },
                  name: { kind: "Name", value: "attribute" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: {
                          kind: "Name",
                          value: "WorkspaceOverviewAttributeFragment",
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "retailer" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "node" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "assortmentAttributes" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "edges" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "node" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "FragmentSpread",
                                          name: {
                                            kind: "Name",
                                            value:
                                              "WorkspaceOverviewAttributeFragment",
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "FragmentSpread",
            name: {
              kind: "Name",
              value: "AssortmentValidationRequirementsFragment",
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<WorkspaceOverviewAssortmentFragment, unknown>;
export const WorkspaceRetailerNamesAssortmentRetailerDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "WorkspaceRetailerNamesAssortmentRetailer" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Retailer" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "displayName" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  WorkspaceRetailerNamesAssortmentRetailerFragment,
  unknown
>;
export const AlAddAttributeOptionDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "ALAddAttributeOption" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "assortmentSkuIds" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "ListType",
              type: {
                kind: "NonNullType",
                type: {
                  kind: "NamedType",
                  name: { kind: "Name", value: "ID" },
                },
              },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "input" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: {
                kind: "Name",
                value: "ApplyAssortmentSkuAttributesInput",
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "applyAssortmentSkuColorAttributes" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "input" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "colors" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "ALColor" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "query" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "assortmentSkus" },
                        arguments: [
                          {
                            kind: "Argument",
                            name: { kind: "Name", value: "ids" },
                            value: {
                              kind: "Variable",
                              name: { kind: "Name", value: "assortmentSkuIds" },
                            },
                          },
                        ],
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "edges" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "_id" },
                                  },
                                  {
                                    kind: "Field",
                                    alias: { kind: "Name", value: "color" },
                                    name: { kind: "Name", value: "colorV2" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "FragmentSpread",
                                          name: {
                                            kind: "Name",
                                            value: "ALColor",
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    ...AlColorDoc.definitions,
    ...ImageFragmentDoc.definitions,
    ...ColorSwatchFragmentDoc.definitions,
    ...AlOptionDoc.definitions,
    ...AlAttributeDoc.definitions,
  ],
} as unknown as DocumentNode<
  AlAddAttributeOptionMutation,
  AlAddAttributeOptionMutationVariables
>;
export const AlAvailableAttributesDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "ALAvailableAttributes" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "workspaceId" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "optionIds" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "ListType",
              type: {
                kind: "NonNullType",
                type: {
                  kind: "NamedType",
                  name: { kind: "Name", value: "ID" },
                },
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            alias: { kind: "Name", value: "workspace" },
            name: { kind: "Name", value: "assortment" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "workspaceId" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                {
                  kind: "Field",
                  alias: { kind: "Name", value: "availableOptions" },
                  name: {
                    kind: "Name",
                    value: "availableSkuColorAttributeOptions",
                  },
                  arguments: [
                    {
                      kind: "Argument",
                      name: { kind: "Name", value: "selectedOptionIds" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "optionIds" },
                      },
                    },
                  ],
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "edges" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "node" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "FragmentSpread",
                                    name: { kind: "Name", value: "ALOption" },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    ...AlOptionDoc.definitions,
    ...AlAttributeDoc.definitions,
  ],
} as unknown as DocumentNode<
  AlAvailableAttributesQuery,
  AlAvailableAttributesQueryVariables
>;
export const AlRemoveAttributeOptionDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "ALRemoveAttributeOption" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "assortmentSkuIds" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "ListType",
              type: {
                kind: "NonNullType",
                type: {
                  kind: "NamedType",
                  name: { kind: "Name", value: "ID" },
                },
              },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "input" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: {
                kind: "Name",
                value: "RemoveAssortmentSkuAttributesInput",
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "removeAssortmentSkuColorAttributes" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "input" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "colors" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "ALColor" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "query" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "assortmentSkus" },
                        arguments: [
                          {
                            kind: "Argument",
                            name: { kind: "Name", value: "ids" },
                            value: {
                              kind: "Variable",
                              name: { kind: "Name", value: "assortmentSkuIds" },
                            },
                          },
                        ],
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "edges" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "_id" },
                                  },
                                  {
                                    kind: "Field",
                                    alias: { kind: "Name", value: "color" },
                                    name: { kind: "Name", value: "colorV2" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "FragmentSpread",
                                          name: {
                                            kind: "Name",
                                            value: "ALColor",
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    ...AlColorDoc.definitions,
    ...ImageFragmentDoc.definitions,
    ...ColorSwatchFragmentDoc.definitions,
    ...AlOptionDoc.definitions,
    ...AlAttributeDoc.definitions,
  ],
} as unknown as DocumentNode<
  AlRemoveAttributeOptionMutation,
  AlRemoveAttributeOptionMutationVariables
>;
export const AlTableRowsDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "ALTableRows" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "workspaceId" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            alias: { kind: "Name", value: "workspace" },
            name: { kind: "Name", value: "assortment" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "workspaceId" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "skus" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "edges" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "FragmentSpread",
                              name: { kind: "Name", value: "ALRow" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    ...AlRowDoc.definitions,
    ...AlProductDoc.definitions,
    ...ImageFragmentDoc.definitions,
    ...AlColorDoc.definitions,
    ...ColorSwatchFragmentDoc.definitions,
    ...AlOptionDoc.definitions,
    ...AlAttributeDoc.definitions,
  ],
} as unknown as DocumentNode<AlTableRowsQuery, AlTableRowsQueryVariables>;
export const AccountSeasonsDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "AccountSeasons" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "seasons" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "edges" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "node" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "FragmentSpread",
                              name: { kind: "Name", value: "SeasonFragment" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    ...SeasonFragmentDoc.definitions,
  ],
} as unknown as DocumentNode<AccountSeasonsQuery, AccountSeasonsQueryVariables>;
export const AddColorsToAssortmentProductDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "AddColorsToAssortmentProduct" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "input" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: {
                kind: "Name",
                value: "AssortmentUI__BulkAddColorsToAssortmentProductRequest",
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: {
              kind: "Name",
              value: "AssortmentUI__bulkAddColorsToAssortmentProduct",
            },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "input" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "assortment" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "FragmentSpread",
                        name: {
                          kind: "Name",
                          value: "FinancialOverviewFragment",
                        },
                      },
                      {
                        kind: "FragmentSpread",
                        name: {
                          kind: "Name",
                          value: "AssortmentValidationRequirementsFragment",
                        },
                      },
                      {
                        kind: "FragmentSpread",
                        name: {
                          kind: "Name",
                          value: "AssortmentDoorsClustersFragment",
                        },
                      },
                      {
                        kind: "FragmentSpread",
                        name: {
                          kind: "Name",
                          value: "AssortmentDoorsFragment",
                        },
                      },
                      {
                        kind: "FragmentSpread",
                        name: {
                          kind: "Name",
                          value: "AssortmentSkusEdgesFragment",
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    ...FinancialOverviewFragmentDoc.definitions,
    ...UnitFragmentDoc.definitions,
    ...FinancialPriceFragmentDoc.definitions,
    ...FinancialPriceTargetFragmentDoc.definitions,
    ...AssortmentValidationRequirementsFragmentDoc.definitions,
    ...AssortmentValidationFieldsFragmentDoc.definitions,
    ...AssortmentItemValidationFieldsFragmentDoc.definitions,
    ...AssortmentDoorsClustersFragmentDoc.definitions,
    ...DoorClusterFragmentDoc.definitions,
    ...DoorFragmentDoc.definitions,
    ...AssortmentDoorsFragmentDoc.definitions,
    ...AssortmentSkusEdgesFragmentDoc.definitions,
    ...ImageFragmentDoc.definitions,
    ...StyleDetailsFragmentDoc.definitions,
    ...AssortmentColorDoorQuantitiesFragmentDoc.definitions,
    ...ColorSwatchFragmentDoc.definitions,
    ...ColorAttributeOptionsFragmentDoc.definitions,
    ...SizeCurvesFragmentDoc.definitions,
    ...AssortmentSkuDoorQuantitiesFragmentDoc.definitions,
    ...PriceLevelsFragmentDoc.definitions,
  ],
} as unknown as DocumentNode<
  AddColorsToAssortmentProductMutation,
  AddColorsToAssortmentProductMutationVariables
>;
export const ApplyAttributeOptionsMutationDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "ApplyAttributeOptionsMutation" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "assortmentSkuIds" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "ListType",
              type: {
                kind: "NonNullType",
                type: {
                  kind: "NamedType",
                  name: { kind: "Name", value: "ID" },
                },
              },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "input" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: {
                kind: "Name",
                value: "ApplyAssortmentSkuAttributesInput",
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "applyAssortmentSkuColorAttributes" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "input" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "query" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "assortmentSkus" },
                        arguments: [
                          {
                            kind: "Argument",
                            name: { kind: "Name", value: "ids" },
                            value: {
                              kind: "Variable",
                              name: { kind: "Name", value: "assortmentSkuIds" },
                            },
                          },
                        ],
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "edges" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "_id" },
                                  },
                                  {
                                    kind: "Field",
                                    alias: { kind: "Name", value: "color" },
                                    name: { kind: "Name", value: "colorV2" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "id" },
                                        },
                                        {
                                          kind: "FragmentSpread",
                                          name: {
                                            kind: "Name",
                                            value: "SizeCurvesFragment",
                                          },
                                        },
                                        {
                                          kind: "FragmentSpread",
                                          name: {
                                            kind: "Name",
                                            value:
                                              "AttributeOptionsOnColorFragment",
                                          },
                                        },
                                        {
                                          kind: "FragmentSpread",
                                          name: {
                                            kind: "Name",
                                            value:
                                              "MissingRequiredAttributesFragment",
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "colors" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "FragmentSpread",
                        name: {
                          kind: "Name",
                          value: "AttributeOptionsOnColorFragment",
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    ...SizeCurvesFragmentDoc.definitions,
    ...AttributeOptionsOnColorFragmentDoc.definitions,
    ...MissingRequiredAttributesFragmentDoc.definitions,
  ],
} as unknown as DocumentNode<
  ApplyAttributeOptionsMutation,
  ApplyAttributeOptionsMutationVariables
>;
export const ApplySizeCurveToDoorColorsMutationDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "ApplySizeCurveToDoorColorsMutation" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "input" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: {
                kind: "Name",
                value: "ApplySizeCurveToDoorColorsRequest",
              },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "assortmentSkuIds" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "ListType",
              type: {
                kind: "NonNullType",
                type: {
                  kind: "NamedType",
                  name: { kind: "Name", value: "ID" },
                },
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "applySizeCurveToDoorColors" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "input" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "query" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "assortmentSkus" },
                        arguments: [
                          {
                            kind: "Argument",
                            name: { kind: "Name", value: "ids" },
                            value: {
                              kind: "Variable",
                              name: { kind: "Name", value: "assortmentSkuIds" },
                            },
                          },
                        ],
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "edges" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "_id" },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "node" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "id" },
                                        },
                                      ],
                                    },
                                  },
                                  {
                                    kind: "Field",
                                    alias: { kind: "Name", value: "color" },
                                    name: { kind: "Name", value: "colorV2" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "id" },
                                        },
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "bulkQuantity",
                                          },
                                        },
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "totalSizedQuantity",
                                          },
                                        },
                                        {
                                          kind: "FragmentSpread",
                                          name: {
                                            kind: "Name",
                                            value:
                                              "AssortmentColorDoorQuantitiesFragment",
                                          },
                                        },
                                      ],
                                    },
                                  },
                                  {
                                    kind: "FragmentSpread",
                                    name: {
                                      kind: "Name",
                                      value:
                                        "AssortmentSkuDoorQuantitiesFragment",
                                    },
                                  },
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "priceLevels",
                                    },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "FragmentSpread",
                                          name: {
                                            kind: "Name",
                                            value: "PriceLevelsFragment",
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    ...AssortmentColorDoorQuantitiesFragmentDoc.definitions,
    ...AssortmentSkuDoorQuantitiesFragmentDoc.definitions,
    ...PriceLevelsFragmentDoc.definitions,
  ],
} as unknown as DocumentNode<
  ApplySizeCurveToDoorColorsMutation,
  ApplySizeCurveToDoorColorsMutationVariables
>;
export const AssortmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "Assortment" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "assortmentId" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "assortment" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "assortmentId" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "AssortmentSkusEdgesFragment" },
                },
                {
                  kind: "FragmentSpread",
                  name: {
                    kind: "Name",
                    value: "AssortmentDoorsClustersFragment",
                  },
                },
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "AssortmentDoorsFragment" },
                },
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "AssortmentDoorRunsFragment" },
                },
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "FinancialOverviewFragment" },
                },
                {
                  kind: "FragmentSpread",
                  name: {
                    kind: "Name",
                    value: "AssortmentValidationRequirementsFragment",
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "retailer" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "node" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" },
                            },
                            {
                              kind: "Field",
                              name: {
                                kind: "Name",
                                value: "itemColorAttributes",
                              },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "edges" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "node" },
                                          selectionSet: {
                                            kind: "SelectionSet",
                                            selections: [
                                              {
                                                kind: "Field",
                                                name: {
                                                  kind: "Name",
                                                  value: "id",
                                                },
                                              },
                                              {
                                                kind: "Field",
                                                name: {
                                                  kind: "Name",
                                                  value: "name",
                                                },
                                              },
                                              {
                                                kind: "Field",
                                                name: {
                                                  kind: "Name",
                                                  value: "isRequired",
                                                },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "brand" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "code" } },
                      { kind: "Field", name: { kind: "Name", value: "alias" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "node" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "name" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    ...AssortmentSkusEdgesFragmentDoc.definitions,
    ...ImageFragmentDoc.definitions,
    ...StyleDetailsFragmentDoc.definitions,
    ...AssortmentColorDoorQuantitiesFragmentDoc.definitions,
    ...ColorSwatchFragmentDoc.definitions,
    ...ColorAttributeOptionsFragmentDoc.definitions,
    ...SizeCurvesFragmentDoc.definitions,
    ...AssortmentSkuDoorQuantitiesFragmentDoc.definitions,
    ...PriceLevelsFragmentDoc.definitions,
    ...AssortmentDoorsClustersFragmentDoc.definitions,
    ...DoorClusterFragmentDoc.definitions,
    ...DoorFragmentDoc.definitions,
    ...AssortmentDoorsFragmentDoc.definitions,
    ...AssortmentDoorRunsFragmentDoc.definitions,
    ...DoorRunFragmentDoc.definitions,
    ...FinancialOverviewFragmentDoc.definitions,
    ...UnitFragmentDoc.definitions,
    ...FinancialPriceFragmentDoc.definitions,
    ...FinancialPriceTargetFragmentDoc.definitions,
    ...AssortmentValidationRequirementsFragmentDoc.definitions,
    ...AssortmentValidationFieldsFragmentDoc.definitions,
    ...AssortmentItemValidationFieldsFragmentDoc.definitions,
  ],
} as unknown as DocumentNode<AssortmentQuery, AssortmentQueryVariables>;
export const AssortmentFinancialsAndSkusDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "AssortmentFinancialsAndSkus" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "assortmentId" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "assortment" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "assortmentId" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "AssortmentSkusEdgesFragment" },
                },
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "FinancialOverviewFragment" },
                },
              ],
            },
          },
        ],
      },
    },
    ...AssortmentSkusEdgesFragmentDoc.definitions,
    ...ImageFragmentDoc.definitions,
    ...StyleDetailsFragmentDoc.definitions,
    ...AssortmentColorDoorQuantitiesFragmentDoc.definitions,
    ...ColorSwatchFragmentDoc.definitions,
    ...ColorAttributeOptionsFragmentDoc.definitions,
    ...SizeCurvesFragmentDoc.definitions,
    ...AssortmentSkuDoorQuantitiesFragmentDoc.definitions,
    ...PriceLevelsFragmentDoc.definitions,
    ...FinancialOverviewFragmentDoc.definitions,
    ...UnitFragmentDoc.definitions,
    ...FinancialPriceFragmentDoc.definitions,
    ...FinancialPriceTargetFragmentDoc.definitions,
  ],
} as unknown as DocumentNode<
  AssortmentFinancialsAndSkusQuery,
  AssortmentFinancialsAndSkusQueryVariables
>;
export const AssortmentSeasonsDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "AssortmentSeasons" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "assortmentId" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "assortment" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "assortmentId" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "retailer" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "node" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "seasons" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "edges" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "node" },
                                          selectionSet: {
                                            kind: "SelectionSet",
                                            selections: [
                                              {
                                                kind: "Field",
                                                name: {
                                                  kind: "Name",
                                                  value: "id",
                                                },
                                              },
                                              {
                                                kind: "Field",
                                                name: {
                                                  kind: "Name",
                                                  value: "name",
                                                },
                                              },
                                              {
                                                kind: "Field",
                                                name: {
                                                  kind: "Name",
                                                  value: "code",
                                                },
                                              },
                                              {
                                                kind: "Field",
                                                name: {
                                                  kind: "Name",
                                                  value: "year",
                                                },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AssortmentSeasonsQuery,
  AssortmentSeasonsQueryVariables
>;
export const AssortmentSizeCurvesDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "AssortmentSizeCurves" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "assortmentId" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "assortment" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "assortmentId" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "skus" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "edges" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "_id" },
                            },
                            {
                              kind: "Field",
                              alias: { kind: "Name", value: "color" },
                              name: { kind: "Name", value: "colorV2" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "id" },
                                  },
                                  {
                                    kind: "FragmentSpread",
                                    name: {
                                      kind: "Name",
                                      value: "SizeCurvesFragment",
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    ...SizeCurvesFragmentDoc.definitions,
  ],
} as unknown as DocumentNode<
  AssortmentSizeCurvesQuery,
  AssortmentSizeCurvesQueryVariables
>;
export const AssortmentSkuEdgeIDsDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "AssortmentSkuEdgeIDs" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "assortmentId" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "assortment" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "assortmentId" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "skus" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "edges" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "_id" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AssortmentSkuEdgeIDsQuery,
  AssortmentSkuEdgeIDsQueryVariables
>;
export const AssortmentSkusIsCustomDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "AssortmentSkusIsCustom" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "assortmentId" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "assortment" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "assortmentId" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "skus" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "edges" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "_id" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "isCustom" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AssortmentSkusIsCustomQuery,
  AssortmentSkusIsCustomQueryVariables
>;
export const AssortmentValidationRequirementsQueryDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "AssortmentValidationRequirementsQuery" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "assortmentId" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "assortment" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "assortmentId" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                {
                  kind: "FragmentSpread",
                  name: {
                    kind: "Name",
                    value: "AssortmentValidationRequirementsFragment",
                  },
                },
              ],
            },
          },
        ],
      },
    },
    ...AssortmentValidationRequirementsFragmentDoc.definitions,
    ...AssortmentValidationFieldsFragmentDoc.definitions,
    ...AssortmentItemValidationFieldsFragmentDoc.definitions,
  ],
} as unknown as DocumentNode<
  AssortmentValidationRequirementsQuery,
  AssortmentValidationRequirementsQueryVariables
>;
export const AttributionDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "Attribution" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "assortmentId" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "selectedOptionIds" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "ListType",
              type: {
                kind: "NonNullType",
                type: {
                  kind: "NamedType",
                  name: { kind: "Name", value: "ID" },
                },
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "assortment" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "assortmentId" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                {
                  kind: "Field",
                  name: {
                    kind: "Name",
                    value: "availableSkuColorAttributeOptions",
                  },
                  arguments: [
                    {
                      kind: "Argument",
                      name: { kind: "Name", value: "selectedOptionIds" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "selectedOptionIds" },
                      },
                    },
                  ],
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "edges" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "node" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "id" },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "code" },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "value" },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "attribute" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "node" },
                                          selectionSet: {
                                            kind: "SelectionSet",
                                            selections: [
                                              {
                                                kind: "Field",
                                                name: {
                                                  kind: "Name",
                                                  value: "id",
                                                },
                                              },
                                              {
                                                kind: "Field",
                                                name: {
                                                  kind: "Name",
                                                  value: "code",
                                                },
                                              },
                                              {
                                                kind: "Field",
                                                name: {
                                                  kind: "Name",
                                                  value: "name",
                                                },
                                              },
                                              {
                                                kind: "Field",
                                                name: {
                                                  kind: "Name",
                                                  value: "position",
                                                },
                                              },
                                              {
                                                kind: "Field",
                                                name: {
                                                  kind: "Name",
                                                  value: "parent",
                                                },
                                                selectionSet: {
                                                  kind: "SelectionSet",
                                                  selections: [
                                                    {
                                                      kind: "Field",
                                                      name: {
                                                        kind: "Name",
                                                        value: "node",
                                                      },
                                                      selectionSet: {
                                                        kind: "SelectionSet",
                                                        selections: [
                                                          {
                                                            kind: "Field",
                                                            name: {
                                                              kind: "Name",
                                                              value: "id",
                                                            },
                                                          },
                                                        ],
                                                      },
                                                    },
                                                  ],
                                                },
                                              },
                                              {
                                                kind: "Field",
                                                name: {
                                                  kind: "Name",
                                                  value: "isRequired",
                                                },
                                              },
                                              {
                                                kind: "Field",
                                                name: {
                                                  kind: "Name",
                                                  value: "isMultiSelect",
                                                },
                                              },
                                              {
                                                kind: "Field",
                                                name: {
                                                  kind: "Name",
                                                  value: "type",
                                                },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<AttributionQuery, AttributionQueryVariables>;
export const AvailableMerchandisingHierarchiesDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "AvailableMerchandisingHierarchies" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "assortmentId" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "assortment" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "assortmentId" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                {
                  kind: "Field",
                  name: {
                    kind: "Name",
                    value: "availableMerchandisingHierarchy",
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "edges" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "node" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "FragmentSpread",
                                    name: {
                                      kind: "Name",
                                      value:
                                        "WorkspaceOverviewHierarchyFragment",
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    ...WorkspaceOverviewHierarchyFragmentDoc.definitions,
  ],
} as unknown as DocumentNode<
  AvailableMerchandisingHierarchiesQuery,
  AvailableMerchandisingHierarchiesQueryVariables
>;
export const AvailableSizeRunQueryDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "AvailableSizeRunQuery" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "assortmentId" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "assortment" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "assortmentId" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "merchandisingHierarchy" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "edges" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "node" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "id" },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "level" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "node" },
                                          selectionSet: {
                                            kind: "SelectionSet",
                                            selections: [
                                              {
                                                kind: "Field",
                                                name: {
                                                  kind: "Name",
                                                  value: "id",
                                                },
                                              },
                                              {
                                                kind: "Field",
                                                name: {
                                                  kind: "Name",
                                                  value: "depth",
                                                },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "brand" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "node" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AvailableSizeRunQuery,
  AvailableSizeRunQueryVariables
>;
export const AssortmentSkuImageDataDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "AssortmentSkuImageData" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "assortmentId" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "assortment" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "assortmentId" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "skus" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "edges" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "_id" },
                            },
                            {
                              kind: "Field",
                              alias: { kind: "Name", value: "color" },
                              name: { kind: "Name", value: "colorV2" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "id" },
                                  },
                                ],
                              },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "mainImage" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "FragmentSpread",
                                    name: {
                                      kind: "Name",
                                      value: "ImageDataFragment",
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    ...ImageDataFragmentDoc.definitions,
  ],
} as unknown as DocumentNode<
  AssortmentSkuImageDataQuery,
  AssortmentSkuImageDataQueryVariables
>;
export const ColorBulkUpdateMutationDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "ColorBulkUpdateMutation" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "assortmentId" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "updates" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "ListType",
              type: {
                kind: "NonNullType",
                type: {
                  kind: "NamedType",
                  name: {
                    kind: "Name",
                    value: "AssortmentUI__BulkColorUnitUpdate",
                  },
                },
              },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "assortmentSkuIds" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "ListType",
              type: {
                kind: "NonNullType",
                type: {
                  kind: "NamedType",
                  name: { kind: "Name", value: "ID" },
                },
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "AssortmentUI__updateRowColorBulk" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "assortmentId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "assortmentId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "updates" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "updates" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "query" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "assortmentSkus" },
                        arguments: [
                          {
                            kind: "Argument",
                            name: { kind: "Name", value: "ids" },
                            value: {
                              kind: "Variable",
                              name: { kind: "Name", value: "assortmentSkuIds" },
                            },
                          },
                        ],
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "edges" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "FragmentSpread",
                                    name: {
                                      kind: "Name",
                                      value: "SkuBulkUnitsFragment",
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    ...SkuBulkUnitsFragmentDoc.definitions,
    ...PriceLevelsFragmentDoc.definitions,
  ],
} as unknown as DocumentNode<
  ColorBulkUpdateMutation,
  ColorBulkUpdateMutationVariables
>;
export const ColorBulkQueryDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "ColorBulkQuery" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "assortmentId" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "assortment" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "assortmentId" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "skus" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "edges" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "FragmentSpread",
                              name: {
                                kind: "Name",
                                value: "SkuBulkUnitsFragment",
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    ...SkuBulkUnitsFragmentDoc.definitions,
    ...PriceLevelsFragmentDoc.definitions,
  ],
} as unknown as DocumentNode<ColorBulkQuery, ColorBulkQueryVariables>;
export const CreateAssortmentInWorkspaceDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "CreateAssortmentInWorkspace" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "retailerId" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "assortmentName" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "seasonId" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "workspaceId" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "createAssortment" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: {
                  kind: "ObjectValue",
                  fields: [
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "retailerId" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "retailerId" },
                      },
                    },
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "assortmentName" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "assortmentName" },
                      },
                    },
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "seasonId" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "seasonId" },
                      },
                    },
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "workspaceId" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "workspaceId" },
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "assortment" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  CreateAssortmentInWorkspaceMutation,
  CreateAssortmentInWorkspaceMutationVariables
>;
export const CreateAssortmentProductsDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "CreateAssortmentProducts" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "input" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: {
                kind: "Name",
                value: "AssortmentUI__BulkCreateAssortmentProductRequest",
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: {
              kind: "Name",
              value: "AssortmentUI__bulkCreateAssortmentProduct",
            },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "input" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "assortment" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "FragmentSpread",
                        name: {
                          kind: "Name",
                          value: "FinancialOverviewFragment",
                        },
                      },
                      {
                        kind: "FragmentSpread",
                        name: {
                          kind: "Name",
                          value: "AssortmentValidationRequirementsFragment",
                        },
                      },
                      {
                        kind: "FragmentSpread",
                        name: {
                          kind: "Name",
                          value: "AssortmentDoorsClustersFragment",
                        },
                      },
                      {
                        kind: "FragmentSpread",
                        name: {
                          kind: "Name",
                          value: "AssortmentDoorsFragment",
                        },
                      },
                      {
                        kind: "FragmentSpread",
                        name: {
                          kind: "Name",
                          value: "AssortmentSkusEdgesFragment",
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    ...FinancialOverviewFragmentDoc.definitions,
    ...UnitFragmentDoc.definitions,
    ...FinancialPriceFragmentDoc.definitions,
    ...FinancialPriceTargetFragmentDoc.definitions,
    ...AssortmentValidationRequirementsFragmentDoc.definitions,
    ...AssortmentValidationFieldsFragmentDoc.definitions,
    ...AssortmentItemValidationFieldsFragmentDoc.definitions,
    ...AssortmentDoorsClustersFragmentDoc.definitions,
    ...DoorClusterFragmentDoc.definitions,
    ...DoorFragmentDoc.definitions,
    ...AssortmentDoorsFragmentDoc.definitions,
    ...AssortmentSkusEdgesFragmentDoc.definitions,
    ...ImageFragmentDoc.definitions,
    ...StyleDetailsFragmentDoc.definitions,
    ...AssortmentColorDoorQuantitiesFragmentDoc.definitions,
    ...ColorSwatchFragmentDoc.definitions,
    ...ColorAttributeOptionsFragmentDoc.definitions,
    ...SizeCurvesFragmentDoc.definitions,
    ...AssortmentSkuDoorQuantitiesFragmentDoc.definitions,
    ...PriceLevelsFragmentDoc.definitions,
  ],
} as unknown as DocumentNode<
  CreateAssortmentProductsMutation,
  CreateAssortmentProductsMutationVariables
>;
export const CreateSavedViewMutationDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "CreateSavedViewMutation" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "input" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "CreateConfigurationInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "AssortmentUI__createConfiguration" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "input" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "SavedViewFragment" },
                },
              ],
            },
          },
        ],
      },
    },
    ...SavedViewFragmentDoc.definitions,
  ],
} as unknown as DocumentNode<
  CreateSavedViewMutation,
  CreateSavedViewMutationVariables
>;
export const DateFormatDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "DateFormat" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "viewingUser" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "dateFormat" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<DateFormatQuery, DateFormatQueryVariables>;
export const DeleteProductColorsDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "DeleteProductColors" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "assortmentId" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "colorIds" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "ListType",
              type: {
                kind: "NonNullType",
                type: {
                  kind: "NamedType",
                  name: { kind: "Name", value: "ID" },
                },
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: {
              kind: "Name",
              value: "AssortmentUI__deleteSkuColorsForAssortment",
            },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "assortmentId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "assortmentId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "colorIds" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "colorIds" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "query" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "assortment" },
                        arguments: [
                          {
                            kind: "Argument",
                            name: { kind: "Name", value: "id" },
                            value: {
                              kind: "Variable",
                              name: { kind: "Name", value: "assortmentId" },
                            },
                          },
                        ],
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" },
                            },
                            {
                              kind: "FragmentSpread",
                              name: {
                                kind: "Name",
                                value: "AssortmentSkusEdgesFragment",
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    ...AssortmentSkusEdgesFragmentDoc.definitions,
    ...ImageFragmentDoc.definitions,
    ...StyleDetailsFragmentDoc.definitions,
    ...AssortmentColorDoorQuantitiesFragmentDoc.definitions,
    ...ColorSwatchFragmentDoc.definitions,
    ...ColorAttributeOptionsFragmentDoc.definitions,
    ...SizeCurvesFragmentDoc.definitions,
    ...AssortmentSkuDoorQuantitiesFragmentDoc.definitions,
    ...PriceLevelsFragmentDoc.definitions,
  ],
} as unknown as DocumentNode<
  DeleteProductColorsMutation,
  DeleteProductColorsMutationVariables
>;
export const DeleteSavedViewMutationDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "DeleteSavedViewMutation" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "input" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "DeleteConfigurationInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "AssortmentUI__deleteConfiguration" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "input" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "success" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  DeleteSavedViewMutation,
  DeleteSavedViewMutationVariables
>;
export const DeleteSkuColorsForAssortmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "DeleteSkuColorsForAssortment" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "assortmentId" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "colorIds" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "ListType",
              type: {
                kind: "NonNullType",
                type: {
                  kind: "NamedType",
                  name: { kind: "Name", value: "ID" },
                },
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: {
              kind: "Name",
              value: "AssortmentUI__deleteSkuColorsForAssortment",
            },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "assortmentId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "assortmentId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "colorIds" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "colorIds" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "query" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "assortment" },
                        arguments: [
                          {
                            kind: "Argument",
                            name: { kind: "Name", value: "id" },
                            value: {
                              kind: "Variable",
                              name: { kind: "Name", value: "assortmentId" },
                            },
                          },
                        ],
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "skus" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "edges" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "_id" },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  DeleteSkuColorsForAssortmentMutation,
  DeleteSkuColorsForAssortmentMutationVariables
>;
export const DoorsModalDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "DoorsModal" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "assortmentId" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "retailerId" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "assortment" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "assortmentId" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "AssortmentDoorsFragment" },
                },
                {
                  kind: "FragmentSpread",
                  name: {
                    kind: "Name",
                    value: "AssortmentDoorsClustersFragment",
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "retailer" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "retailerId" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "doors" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "edges" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "node" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "FragmentSpread",
                                    name: {
                                      kind: "Name",
                                      value: "DoorFragment",
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    ...AssortmentDoorsFragmentDoc.definitions,
    ...DoorFragmentDoc.definitions,
    ...AssortmentDoorsClustersFragmentDoc.definitions,
    ...DoorClusterFragmentDoc.definitions,
  ],
} as unknown as DocumentNode<DoorsModalQuery, DoorsModalQueryVariables>;
export const FinancialCurrencyConversionsQueryDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "FinancialCurrencyConversionsQuery" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "assortmentId" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "assortment" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "assortmentId" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                {
                  kind: "FragmentSpread",
                  name: {
                    kind: "Name",
                    value: "FinancialCurrencyConversionsFragment",
                  },
                },
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "FinancialOverviewFragment" },
                },
              ],
            },
          },
        ],
      },
    },
    ...FinancialCurrencyConversionsFragmentDoc.definitions,
    ...FinancialOverviewFragmentDoc.definitions,
    ...UnitFragmentDoc.definitions,
    ...FinancialPriceFragmentDoc.definitions,
    ...FinancialPriceTargetFragmentDoc.definitions,
  ],
} as unknown as DocumentNode<
  FinancialCurrencyConversionsQuery,
  FinancialCurrencyConversionsQueryVariables
>;
export const FinancialOverviewTableQueryDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "FinancialOverviewTableQuery" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "assortmentId" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "assortment" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "assortmentId" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "FinancialOverviewFragment" },
                },
              ],
            },
          },
        ],
      },
    },
    ...FinancialOverviewFragmentDoc.definitions,
    ...UnitFragmentDoc.definitions,
    ...FinancialPriceFragmentDoc.definitions,
    ...FinancialPriceTargetFragmentDoc.definitions,
  ],
} as unknown as DocumentNode<
  FinancialOverviewTableQuery,
  FinancialOverviewTableQueryVariables
>;
export const FinancialPriceModifierDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "FinancialPriceModifier" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "assortmentId" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "retailerId" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "assortment" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "assortmentId" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "PriceModifierFragment" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "retailer" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "retailerId" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                {
                  kind: "Field",
                  name: {
                    kind: "Name",
                    value: "assortmentPriceModifierGroups",
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "edges" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "node" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "id" },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "code" },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "name" },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "type" },
                                  },
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "adjustmentType",
                                    },
                                  },
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "displayFormat",
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    ...PriceModifierFragmentDoc.definitions,
  ],
} as unknown as DocumentNode<
  FinancialPriceModifierQuery,
  FinancialPriceModifierQueryVariables
>;
export const GetSavedViewsQueryDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetSavedViewsQuery" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            alias: { kind: "Name", value: "views" },
            name: { kind: "Name", value: "AssortmentUI__configurations" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "SavedViewFragment" },
                },
              ],
            },
          },
        ],
      },
    },
    ...SavedViewFragmentDoc.definitions,
  ],
} as unknown as DocumentNode<GetSavedViewsQuery, GetSavedViewsQueryVariables>;
export const ListAvailableRetailSizesQueryDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "ListAvailableRetailSizesQuery" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "assortmentId" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "assortment" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "assortmentId" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "skus" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "edges" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "_id" },
                            },
                            {
                              kind: "Field",
                              name: {
                                kind: "Name",
                                value: "availableRetailSizeOptions",
                              },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "code" },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "id" },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "name" },
                                  },
                                ],
                              },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "node" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "id" },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ListAvailableRetailSizesQuery,
  ListAvailableRetailSizesQueryVariables
>;
export const ListAvailableSizeRunsQueryDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "ListAvailableSizeRunsQuery" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "brandId" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "hierarchyId" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "attributeOptionIds" },
          },
          type: {
            kind: "ListType",
            type: {
              kind: "NonNullType",
              type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "sizeRuns" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "filters" },
                value: {
                  kind: "ObjectValue",
                  fields: [
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "brandId" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "brandId" },
                      },
                    },
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "merchandisingHierarchyId" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "hierarchyId" },
                      },
                    },
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "attributeOptionIds" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "attributeOptionIds" },
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "code" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ListAvailableSizeRunsQuery,
  ListAvailableSizeRunsQueryVariables
>;
export const ManageImagesPaneDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "ManageImagesPane" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "activeViewingAccount" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "AccountPrimaryFragment" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "productDetail" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
            ],
            directives: [
              { kind: "Directive", name: { kind: "Name", value: "client" } },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "images" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "ImageFragment" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    ...AccountPrimaryFragmentDoc.definitions,
    ...ImageFragmentDoc.definitions,
  ],
} as unknown as DocumentNode<
  ManageImagesPaneQuery,
  ManageImagesPaneQueryVariables
>;
export const RetailerMerchandisingHierarchyDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "RetailerMerchandisingHierarchy" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "retailerId" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "retailer" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "retailerId" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "merchandisingHierarchy" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "edges" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "node" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "id" },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "code" },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "name" },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "parent" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "node" },
                                          selectionSet: {
                                            kind: "SelectionSet",
                                            selections: [
                                              {
                                                kind: "Field",
                                                name: {
                                                  kind: "Name",
                                                  value: "id",
                                                },
                                              },
                                              {
                                                kind: "Field",
                                                name: {
                                                  kind: "Name",
                                                  value: "code",
                                                },
                                              },
                                              {
                                                kind: "Field",
                                                name: {
                                                  kind: "Name",
                                                  value: "name",
                                                },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "level" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "node" },
                                          selectionSet: {
                                            kind: "SelectionSet",
                                            selections: [
                                              {
                                                kind: "Field",
                                                name: {
                                                  kind: "Name",
                                                  value: "id",
                                                },
                                              },
                                              {
                                                kind: "Field",
                                                name: {
                                                  kind: "Name",
                                                  value: "name",
                                                },
                                              },
                                              {
                                                kind: "Field",
                                                name: {
                                                  kind: "Name",
                                                  value: "code",
                                                },
                                              },
                                              {
                                                kind: "Field",
                                                name: {
                                                  kind: "Name",
                                                  value: "depth",
                                                },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  RetailerMerchandisingHierarchyQuery,
  RetailerMerchandisingHierarchyQueryVariables
>;
export const OrderValidationRequirementsDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "OrderValidationRequirements" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "assortmentId" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "assortment" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "assortmentId" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                {
                  kind: "FragmentSpread",
                  name: {
                    kind: "Name",
                    value: "AssortmentValidationRequirementsFragment",
                  },
                },
              ],
            },
          },
        ],
      },
    },
    ...AssortmentValidationRequirementsFragmentDoc.definitions,
    ...AssortmentValidationFieldsFragmentDoc.definitions,
    ...AssortmentItemValidationFieldsFragmentDoc.definitions,
  ],
} as unknown as DocumentNode<
  OrderValidationRequirementsQuery,
  OrderValidationRequirementsQueryVariables
>;
export const ProductGridDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "ProductGrid" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "assortmentId" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "assortment" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "assortmentId" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "skus" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "edges" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "_id" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "node" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "id" },
                                  },
                                ],
                              },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "style" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "id" },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "name" },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "code" },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "images" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "edges",
                                          },
                                          selectionSet: {
                                            kind: "SelectionSet",
                                            selections: [
                                              {
                                                kind: "Field",
                                                name: {
                                                  kind: "Name",
                                                  value: "node",
                                                },
                                                selectionSet: {
                                                  kind: "SelectionSet",
                                                  selections: [
                                                    {
                                                      kind: "FragmentSpread",
                                                      name: {
                                                        kind: "Name",
                                                        value: "ImageFragment",
                                                      },
                                                    },
                                                  ],
                                                },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: "Field",
                              alias: { kind: "Name", value: "color" },
                              name: { kind: "Name", value: "colorV2" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "id" },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "code" },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "name" },
                                  },
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "bulkQuantity",
                                    },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "images" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "edges",
                                          },
                                          selectionSet: {
                                            kind: "SelectionSet",
                                            selections: [
                                              {
                                                kind: "Field",
                                                name: {
                                                  kind: "Name",
                                                  value: "node",
                                                },
                                                selectionSet: {
                                                  kind: "SelectionSet",
                                                  selections: [
                                                    {
                                                      kind: "FragmentSpread",
                                                      name: {
                                                        kind: "Name",
                                                        value: "ImageFragment",
                                                      },
                                                    },
                                                  ],
                                                },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "swatch" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "FragmentSpread",
                                          name: {
                                            kind: "Name",
                                            value: "ColorSwatchFragment",
                                          },
                                        },
                                      ],
                                    },
                                  },
                                  {
                                    kind: "FragmentSpread",
                                    name: {
                                      kind: "Name",
                                      value:
                                        "MissingRequiredAttributesFragment",
                                    },
                                  },
                                  {
                                    kind: "FragmentSpread",
                                    name: {
                                      kind: "Name",
                                      value: "AttributeOptionsOnColorFragment",
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    ...ImageFragmentDoc.definitions,
    ...ColorSwatchFragmentDoc.definitions,
    ...MissingRequiredAttributesFragmentDoc.definitions,
    ...AttributeOptionsOnColorFragmentDoc.definitions,
  ],
} as unknown as DocumentNode<ProductGridQuery, ProductGridQueryVariables>;
export const RemoveAttributeOptionsMutationDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "RemoveAttributeOptionsMutation" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "assortmentSkuIds" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "ListType",
              type: {
                kind: "NonNullType",
                type: {
                  kind: "NamedType",
                  name: { kind: "Name", value: "ID" },
                },
              },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "input" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: {
                kind: "Name",
                value: "RemoveAssortmentSkuAttributesInput",
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "removeAssortmentSkuColorAttributes" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "input" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "assortment" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "FragmentSpread",
                        name: {
                          kind: "Name",
                          value: "AssortmentValidationRequirementsFragment",
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "query" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "assortmentSkus" },
                        arguments: [
                          {
                            kind: "Argument",
                            name: { kind: "Name", value: "ids" },
                            value: {
                              kind: "Variable",
                              name: { kind: "Name", value: "assortmentSkuIds" },
                            },
                          },
                        ],
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "edges" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "_id" },
                                  },
                                  {
                                    kind: "Field",
                                    alias: { kind: "Name", value: "color" },
                                    name: { kind: "Name", value: "colorV2" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "id" },
                                        },
                                        {
                                          kind: "FragmentSpread",
                                          name: {
                                            kind: "Name",
                                            value:
                                              "AttributeOptionsOnColorFragment",
                                          },
                                        },
                                        {
                                          kind: "FragmentSpread",
                                          name: {
                                            kind: "Name",
                                            value:
                                              "MissingRequiredAttributesFragment",
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "colors" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "FragmentSpread",
                        name: {
                          kind: "Name",
                          value: "AttributeOptionsOnColorFragment",
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    ...AssortmentValidationRequirementsFragmentDoc.definitions,
    ...AssortmentValidationFieldsFragmentDoc.definitions,
    ...AssortmentItemValidationFieldsFragmentDoc.definitions,
    ...AttributeOptionsOnColorFragmentDoc.definitions,
    ...MissingRequiredAttributesFragmentDoc.definitions,
  ],
} as unknown as DocumentNode<
  RemoveAttributeOptionsMutation,
  RemoveAttributeOptionsMutationVariables
>;
export const RemoveProductImageMutationDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "RemoveProductImageMutation" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "AssortmentUI__removeProductImage" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "imageId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  RemoveProductImageMutation,
  RemoveProductImageMutationVariables
>;
export const RemoveSelectedAssortmentAttributeOptionsDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "RemoveSelectedAssortmentAttributeOptions" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "input" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: {
                kind: "Name",
                value: "RemoveSelectedAssortmentAttributeOptionsInput",
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: {
              kind: "Name",
              value: "removeSelectedAssortmentAttributeOptions",
            },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "input" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "assortment" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "attributeOptions" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "edges" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "node" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "id" },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "PriceModifierFragment" },
                      },
                      {
                        kind: "FragmentSpread",
                        name: {
                          kind: "Name",
                          value: "FinancialOverviewFragment",
                        },
                      },
                      {
                        kind: "FragmentSpread",
                        name: {
                          kind: "Name",
                          value: "AssortmentValidationRequirementsFragment",
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    ...PriceModifierFragmentDoc.definitions,
    ...FinancialOverviewFragmentDoc.definitions,
    ...UnitFragmentDoc.definitions,
    ...FinancialPriceFragmentDoc.definitions,
    ...FinancialPriceTargetFragmentDoc.definitions,
    ...AssortmentValidationRequirementsFragmentDoc.definitions,
    ...AssortmentValidationFieldsFragmentDoc.definitions,
    ...AssortmentItemValidationFieldsFragmentDoc.definitions,
  ],
} as unknown as DocumentNode<
  RemoveSelectedAssortmentAttributeOptionsMutation,
  RemoveSelectedAssortmentAttributeOptionsMutationVariables
>;
export const RetailBudgetDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "RetailBudget" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "assortmentOrWorkspaceId" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "retailBudget" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "assortmentOrWorkspaceId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "assortmentOrWorkspaceId" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "RetailBudgetFragment" },
                },
              ],
            },
          },
        ],
      },
    },
    ...RetailBudgetFragmentDoc.definitions,
    ...RetailBudgetCategoryFragmentDoc.definitions,
    ...RetailBudgetCategoryAmountFragmentDoc.definitions,
  ],
} as unknown as DocumentNode<RetailBudgetQuery, RetailBudgetQueryVariables>;
export const RetailerAttributesDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "RetailerAttributes" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "retailerId" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "retailer" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "retailerId" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "assortmentAttributes" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "edges" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "node" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "id" },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "name" },
                                  },
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "availableOptions",
                                    },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "edges",
                                          },
                                          selectionSet: {
                                            kind: "SelectionSet",
                                            selections: [
                                              {
                                                kind: "Field",
                                                name: {
                                                  kind: "Name",
                                                  value: "node",
                                                },
                                                selectionSet: {
                                                  kind: "SelectionSet",
                                                  selections: [
                                                    {
                                                      kind: "Field",
                                                      name: {
                                                        kind: "Name",
                                                        value: "id",
                                                      },
                                                    },
                                                    {
                                                      kind: "Field",
                                                      name: {
                                                        kind: "Name",
                                                        value: "code",
                                                      },
                                                    },
                                                    {
                                                      kind: "Field",
                                                      name: {
                                                        kind: "Name",
                                                        value: "value",
                                                      },
                                                    },
                                                  ],
                                                },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  RetailerAttributesQuery,
  RetailerAttributesQueryVariables
>;
export const RetailerBrandsDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "RetailerBrands" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "retailerId" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "retailer" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "retailerId" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "brands" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "edges" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "code" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "alias" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "node" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "id" },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "name" },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<RetailerBrandsQuery, RetailerBrandsQueryVariables>;
export const RetailerDefaultExchangeCurrenciesDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "RetailerDefaultExchangeCurrencies" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "retailerId" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "retailer" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "retailerId" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "currencyConversions" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "fromCurrencyCode" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "toCurrencyCode" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "factor" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  RetailerDefaultExchangeCurrenciesQuery,
  RetailerDefaultExchangeCurrenciesQueryVariables
>;
export const SetAssortmentCurrencyConversionDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "SetAssortmentCurrencyConversion" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "input" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "ListType",
              type: {
                kind: "NonNullType",
                type: {
                  kind: "NamedType",
                  name: {
                    kind: "Name",
                    value: "SetAssortmentCurrencyConversionInput",
                  },
                },
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "setAssortmentCurrencyConversion" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "input" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "assortmentCurrencyConversion" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "assortment" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "skus" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "edges" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "_id" },
                                        },
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "priceLevels",
                                          },
                                          selectionSet: {
                                            kind: "SelectionSet",
                                            selections: [
                                              {
                                                kind: "FragmentSpread",
                                                name: {
                                                  kind: "Name",
                                                  value: "PriceLevelsFragment",
                                                },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: "FragmentSpread",
                              name: {
                                kind: "Name",
                                value: "FinancialCurrencyConversionsFragment",
                              },
                            },
                            {
                              kind: "FragmentSpread",
                              name: {
                                kind: "Name",
                                value: "FinancialOverviewFragment",
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "fromCurrencyCode" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "toCurrencyCode" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "factor" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    ...PriceLevelsFragmentDoc.definitions,
    ...FinancialCurrencyConversionsFragmentDoc.definitions,
    ...FinancialOverviewFragmentDoc.definitions,
    ...UnitFragmentDoc.definitions,
    ...FinancialPriceFragmentDoc.definitions,
    ...FinancialPriceTargetFragmentDoc.definitions,
  ],
} as unknown as DocumentNode<
  SetAssortmentCurrencyConversionMutation,
  SetAssortmentCurrencyConversionMutationVariables
>;
export const SetAssortmentDoorsMutationDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "SetAssortmentDoorsMutation" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "input" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "SetAssortmentDoorsInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "setAssortmentDoors" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "input" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "assortment" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "FragmentSpread",
                        name: {
                          kind: "Name",
                          value: "AssortmentDoorsClustersFragment",
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "doors" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "edges" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "node" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "FragmentSpread",
                                          name: {
                                            kind: "Name",
                                            value: "DoorFragment",
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "skus" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "edges" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "_id" },
                                  },
                                  {
                                    kind: "FragmentSpread",
                                    name: {
                                      kind: "Name",
                                      value:
                                        "AssortmentSkuDoorQuantitiesFragment",
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "validationRequirements" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "FragmentSpread",
                              name: {
                                kind: "Name",
                                value: "AssortmentValidationFieldsFragment",
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    ...AssortmentDoorsClustersFragmentDoc.definitions,
    ...DoorClusterFragmentDoc.definitions,
    ...DoorFragmentDoc.definitions,
    ...AssortmentSkuDoorQuantitiesFragmentDoc.definitions,
    ...AssortmentValidationFieldsFragmentDoc.definitions,
  ],
} as unknown as DocumentNode<
  SetAssortmentDoorsMutation,
  SetAssortmentDoorsMutationVariables
>;
export const SetAssortmentSkuFinalRetailPriceDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "SetAssortmentSkuFinalRetailPrice" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "input" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: {
                kind: "Name",
                value: "SetAssortmentSkuFinalRetailPriceInput",
              },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "assortmentSkuIds" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "ListType",
              type: {
                kind: "NonNullType",
                type: {
                  kind: "NamedType",
                  name: { kind: "Name", value: "ID" },
                },
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "setAssortmentSkuFinalRetailPrice" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "input" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "query" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "assortmentSkus" },
                        arguments: [
                          {
                            kind: "Argument",
                            name: { kind: "Name", value: "ids" },
                            value: {
                              kind: "Variable",
                              name: { kind: "Name", value: "assortmentSkuIds" },
                            },
                          },
                        ],
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "edges" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "FragmentSpread",
                                    name: {
                                      kind: "Name",
                                      value: "SetPriceSkuEdgesFragment",
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    ...SetPriceSkuEdgesFragmentDoc.definitions,
    ...PriceLevelsFragmentDoc.definitions,
  ],
} as unknown as DocumentNode<
  SetAssortmentSkuFinalRetailPriceMutation,
  SetAssortmentSkuFinalRetailPriceMutationVariables
>;
export const SetAssortmentSkuUpcMutationDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "SetAssortmentSkuUpcMutation" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "input" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "SetAssortmentSkuUpcInput" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "assortmentSkuIds" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "ListType",
              type: {
                kind: "NonNullType",
                type: {
                  kind: "NamedType",
                  name: { kind: "Name", value: "ID" },
                },
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "setAssortmentSkuUpc" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "input" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "query" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "assortmentSkus" },
                        arguments: [
                          {
                            kind: "Argument",
                            name: { kind: "Name", value: "ids" },
                            value: {
                              kind: "Variable",
                              name: { kind: "Name", value: "assortmentSkuIds" },
                            },
                          },
                        ],
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "edges" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "_id" },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "upc" },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "node" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "id" },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  SetAssortmentSkuUpcMutation,
  SetAssortmentSkuUpcMutationVariables
>;
export const SetDefaultDoorsAndClustersMutationDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "SetDefaultDoorsAndClustersMutation" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "input" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: {
                kind: "Name",
                value: "SetAssormentDefaultDoorClustersInput",
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "setAssortmentDefaultDoorClusters" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "input" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "doorIds" } },
                { kind: "Field", name: { kind: "Name", value: "clusterIds" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  SetDefaultDoorsAndClustersMutation,
  SetDefaultDoorsAndClustersMutationVariables
>;
export const SetDoorBulkQuantityMutationDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "SetDoorBulkQuantityMutation" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "input" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: {
                kind: "Name",
                value: "SetAssortmentColorBulkDoorQuantityInput",
              },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "assortmentSkuIds" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "ListType",
              type: {
                kind: "NonNullType",
                type: {
                  kind: "NamedType",
                  name: { kind: "Name", value: "ID" },
                },
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "setAssortmentColorBulkDoorQuantity" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "input" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "query" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "assortmentSkus" },
                        arguments: [
                          {
                            kind: "Argument",
                            name: { kind: "Name", value: "ids" },
                            value: {
                              kind: "Variable",
                              name: { kind: "Name", value: "assortmentSkuIds" },
                            },
                          },
                        ],
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "edges" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "FragmentSpread",
                                    name: {
                                      kind: "Name",
                                      value: "DoorQuantitySkuFragment",
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    ...DoorQuantitySkuFragmentDoc.definitions,
    ...AssortmentSkuDoorQuantitiesFragmentDoc.definitions,
    ...SizeCurvesFragmentDoc.definitions,
    ...AssortmentColorDoorQuantitiesFragmentDoc.definitions,
    ...PriceLevelsFragmentDoc.definitions,
  ],
} as unknown as DocumentNode<
  SetDoorBulkQuantityMutation,
  SetDoorBulkQuantityMutationVariables
>;
export const SetDoorSizeQuantityMutationDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "SetDoorSizeQuantityMutation" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "doorOrClusterId" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "assortmentId" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "skuId" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "assortmentSkuIds" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "ListType",
              type: {
                kind: "NonNullType",
                type: {
                  kind: "NamedType",
                  name: { kind: "Name", value: "ID" },
                },
              },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "quantity" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: {
              kind: "Name",
              value: "setAssortmentSkuDoorLineItemQuantities",
            },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: {
                  kind: "ObjectValue",
                  fields: [
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "doorOrClusterId" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "doorOrClusterId" },
                      },
                    },
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "assortmentId" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "assortmentId" },
                      },
                    },
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "skuId" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "skuId" },
                      },
                    },
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "quantity" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "quantity" },
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "assortment" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "FragmentSpread",
                        name: {
                          kind: "Name",
                          value: "AssortmentValidationRequirementsFragment",
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "query" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "assortmentSkus" },
                        arguments: [
                          {
                            kind: "Argument",
                            name: { kind: "Name", value: "ids" },
                            value: {
                              kind: "Variable",
                              name: { kind: "Name", value: "assortmentSkuIds" },
                            },
                          },
                        ],
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "edges" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "FragmentSpread",
                                    name: {
                                      kind: "Name",
                                      value: "DoorQuantitySkuFragment",
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    ...AssortmentValidationRequirementsFragmentDoc.definitions,
    ...AssortmentValidationFieldsFragmentDoc.definitions,
    ...AssortmentItemValidationFieldsFragmentDoc.definitions,
    ...DoorQuantitySkuFragmentDoc.definitions,
    ...AssortmentSkuDoorQuantitiesFragmentDoc.definitions,
    ...SizeCurvesFragmentDoc.definitions,
    ...AssortmentColorDoorQuantitiesFragmentDoc.definitions,
    ...PriceLevelsFragmentDoc.definitions,
  ],
} as unknown as DocumentNode<
  SetDoorSizeQuantityMutation,
  SetDoorSizeQuantityMutationVariables
>;
export const SetPriceModifierValueDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "SetPriceModifierValue" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "input" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "ListType",
              type: {
                kind: "NonNullType",
                type: {
                  kind: "NamedType",
                  name: {
                    kind: "Name",
                    value: "GenericSetPriceModifierValueInput",
                  },
                },
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "genericSetPriceModifierValue" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "input" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "priceModifier" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "factor" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "group" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "node" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "id" },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "deletePriceModifierId" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "assortment" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "skus" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "edges" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "_id" },
                                  },
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "priceLevels",
                                    },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "FragmentSpread",
                                          name: {
                                            kind: "Name",
                                            value: "PriceLevelsFragment",
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: "FragmentSpread",
                        name: {
                          kind: "Name",
                          value: "FinancialOverviewFragment",
                        },
                      },
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "PriceModifierFragment" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    ...PriceLevelsFragmentDoc.definitions,
    ...FinancialOverviewFragmentDoc.definitions,
    ...UnitFragmentDoc.definitions,
    ...FinancialPriceFragmentDoc.definitions,
    ...FinancialPriceTargetFragmentDoc.definitions,
    ...PriceModifierFragmentDoc.definitions,
  ],
} as unknown as DocumentNode<
  SetPriceModifierValueMutation,
  SetPriceModifierValueMutationVariables
>;
export const SetProductRetailPriceMutationDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "SetProductRetailPriceMutation" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "input" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: {
                kind: "Name",
                value: "SetAssortmentProductRetailPriceInput",
              },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "assortmentSkuIds" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "ListType",
              type: {
                kind: "NonNullType",
                type: {
                  kind: "NamedType",
                  name: { kind: "Name", value: "ID" },
                },
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "setAssortmentProductRetailPrice" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "input" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "query" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "assortmentSkus" },
                        arguments: [
                          {
                            kind: "Argument",
                            name: { kind: "Name", value: "ids" },
                            value: {
                              kind: "Variable",
                              name: { kind: "Name", value: "assortmentSkuIds" },
                            },
                          },
                        ],
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "edges" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "FragmentSpread",
                                    name: {
                                      kind: "Name",
                                      value: "SetPriceSkuEdgesFragment",
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    ...SetPriceSkuEdgesFragmentDoc.definitions,
    ...PriceLevelsFragmentDoc.definitions,
  ],
} as unknown as DocumentNode<
  SetProductRetailPriceMutation,
  SetProductRetailPriceMutationVariables
>;
export const SetProductSizeRunMutationDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "SetProductSizeRunMutation" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "productId" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "sizeRunId" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "assortmentSkuIds" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "ListType",
              type: {
                kind: "NonNullType",
                type: {
                  kind: "NamedType",
                  name: { kind: "Name", value: "ID" },
                },
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "setProductSizeRun" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "productId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "productId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "sizeRunId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "sizeRunId" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "query" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "assortmentSkus" },
                        arguments: [
                          {
                            kind: "Argument",
                            name: { kind: "Name", value: "ids" },
                            value: {
                              kind: "Variable",
                              name: { kind: "Name", value: "assortmentSkuIds" },
                            },
                          },
                        ],
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "edges" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "FragmentSpread",
                                    name: {
                                      kind: "Name",
                                      value: "SizeRunFragment",
                                    },
                                  },
                                  {
                                    kind: "Field",
                                    alias: { kind: "Name", value: "color" },
                                    name: { kind: "Name", value: "colorV2" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "id" },
                                        },
                                        {
                                          kind: "FragmentSpread",
                                          name: {
                                            kind: "Name",
                                            value: "SizeCurvesFragment",
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    ...SizeRunFragmentDoc.definitions,
    ...SizeCurvesFragmentDoc.definitions,
  ],
} as unknown as DocumentNode<
  SetProductSizeRunMutation,
  SetProductSizeRunMutationVariables
>;
export const SetProductWholesalePriceMutationDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "SetProductWholesalePriceMutation" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "input" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: {
                kind: "Name",
                value: "SetAssortmentProductWholesalePriceInput",
              },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "assortmentSkuIds" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "ListType",
              type: {
                kind: "NonNullType",
                type: {
                  kind: "NamedType",
                  name: { kind: "Name", value: "ID" },
                },
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "setAssortmentProductWholesalePrice" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "input" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "query" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "assortmentSkus" },
                        arguments: [
                          {
                            kind: "Argument",
                            name: { kind: "Name", value: "ids" },
                            value: {
                              kind: "Variable",
                              name: { kind: "Name", value: "assortmentSkuIds" },
                            },
                          },
                        ],
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "edges" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "FragmentSpread",
                                    name: {
                                      kind: "Name",
                                      value: "SetPriceSkuEdgesFragment",
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    ...SetPriceSkuEdgesFragmentDoc.definitions,
    ...PriceLevelsFragmentDoc.definitions,
  ],
} as unknown as DocumentNode<
  SetProductWholesalePriceMutation,
  SetProductWholesalePriceMutationVariables
>;
export const SetRetailerProductSizesOnAssortmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "SetRetailerProductSizesOnAssortment" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "input" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: {
                kind: "Name",
                value: "SetRetailerProductSizesOnAssortmentInput",
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: {
              kind: "Name",
              value: "setRetailerProductSizesOnAssortment",
            },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "input" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "assortment" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "FragmentSpread",
                        name: {
                          kind: "Name",
                          value: "AssortmentSkusEdgesFragment",
                        },
                      },
                      {
                        kind: "FragmentSpread",
                        name: {
                          kind: "Name",
                          value: "FinancialOverviewFragment",
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    ...AssortmentSkusEdgesFragmentDoc.definitions,
    ...ImageFragmentDoc.definitions,
    ...StyleDetailsFragmentDoc.definitions,
    ...AssortmentColorDoorQuantitiesFragmentDoc.definitions,
    ...ColorSwatchFragmentDoc.definitions,
    ...ColorAttributeOptionsFragmentDoc.definitions,
    ...SizeCurvesFragmentDoc.definitions,
    ...AssortmentSkuDoorQuantitiesFragmentDoc.definitions,
    ...PriceLevelsFragmentDoc.definitions,
    ...FinancialOverviewFragmentDoc.definitions,
    ...UnitFragmentDoc.definitions,
    ...FinancialPriceFragmentDoc.definitions,
    ...FinancialPriceTargetFragmentDoc.definitions,
  ],
} as unknown as DocumentNode<
  SetRetailerProductSizesOnAssortmentMutation,
  SetRetailerProductSizesOnAssortmentMutationVariables
>;
export const SetSelectedAssortmentAttributeOptionsDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "SetSelectedAssortmentAttributeOptions" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "input" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: {
                kind: "Name",
                value: "SetSelectedAssortmentAttributeOptionsInput",
              },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "assortmentId" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: {
              kind: "Name",
              value: "setSelectedAssortmentAttributeOptions",
            },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "input" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "assortment" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "attributeOptions" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "edges" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "node" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "id" },
                                        },
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "value",
                                          },
                                        },
                                        {
                                          kind: "Field",
                                          alias: {
                                            kind: "Name",
                                            value: "name",
                                          },
                                          name: {
                                            kind: "Name",
                                            value: "value",
                                          },
                                        },
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "attribute",
                                          },
                                          selectionSet: {
                                            kind: "SelectionSet",
                                            selections: [
                                              {
                                                kind: "Field",
                                                name: {
                                                  kind: "Name",
                                                  value: "node",
                                                },
                                                selectionSet: {
                                                  kind: "SelectionSet",
                                                  selections: [
                                                    {
                                                      kind: "Field",
                                                      name: {
                                                        kind: "Name",
                                                        value: "id",
                                                      },
                                                    },
                                                  ],
                                                },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "retailer" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "node" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "id" },
                                  },
                                  {
                                    kind: "FragmentSpread",
                                    name: {
                                      kind: "Name",
                                      value:
                                        "RetailerAssortmentAttributeOptionsFragment",
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "PriceModifierFragment" },
                      },
                      {
                        kind: "FragmentSpread",
                        name: {
                          kind: "Name",
                          value: "FinancialOverviewFragment",
                        },
                      },
                      {
                        kind: "FragmentSpread",
                        name: {
                          kind: "Name",
                          value: "AssortmentValidationRequirementsFragment",
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    ...RetailerAssortmentAttributeOptionsFragmentDoc.definitions,
    ...PriceModifierFragmentDoc.definitions,
    ...FinancialOverviewFragmentDoc.definitions,
    ...UnitFragmentDoc.definitions,
    ...FinancialPriceFragmentDoc.definitions,
    ...FinancialPriceTargetFragmentDoc.definitions,
    ...AssortmentValidationRequirementsFragmentDoc.definitions,
    ...AssortmentValidationFieldsFragmentDoc.definitions,
    ...AssortmentItemValidationFieldsFragmentDoc.definitions,
  ],
} as unknown as DocumentNode<
  SetSelectedAssortmentAttributeOptionsMutation,
  SetSelectedAssortmentAttributeOptionsMutationVariables
>;
export const SetSkuItemPropertyMutationDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "SetSkuItemPropertyMutation" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "legacyDetailId" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "name" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "value" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "assortmentSkuIds" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "ListType",
              type: {
                kind: "NonNullType",
                type: {
                  kind: "NamedType",
                  name: { kind: "Name", value: "ID" },
                },
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "setSkuItemProperty" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: {
                  kind: "ObjectValue",
                  fields: [
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "propertyName" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "name" },
                      },
                    },
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "propertyValue" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "value" },
                      },
                    },
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "id" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "legacyDetailId" },
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "query" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "assortmentSkus" },
                        arguments: [
                          {
                            kind: "Argument",
                            name: { kind: "Name", value: "ids" },
                            value: {
                              kind: "Variable",
                              name: { kind: "Name", value: "assortmentSkuIds" },
                            },
                          },
                        ],
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "edges" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "_id" },
                                  },
                                  {
                                    kind: "FragmentSpread",
                                    name: {
                                      kind: "Name",
                                      value: "GenericSkuFieldsFragment",
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    ...GenericSkuFieldsFragmentDoc.definitions,
    ...StyleDetailsFragmentDoc.definitions,
  ],
} as unknown as DocumentNode<
  SetSkuItemPropertyMutation,
  SetSkuItemPropertyMutationVariables
>;
export const SetSkuRetailPriceMutationDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "SetSkuRetailPriceMutation" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "input" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "SetAssortmentSkuRetailPriceInput" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "assortmentSkuIds" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "ListType",
              type: {
                kind: "NonNullType",
                type: {
                  kind: "NamedType",
                  name: { kind: "Name", value: "ID" },
                },
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "setAssortmentSkuRetailPrice" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "input" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "query" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "assortmentSkus" },
                        arguments: [
                          {
                            kind: "Argument",
                            name: { kind: "Name", value: "ids" },
                            value: {
                              kind: "Variable",
                              name: { kind: "Name", value: "assortmentSkuIds" },
                            },
                          },
                        ],
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "edges" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "FragmentSpread",
                                    name: {
                                      kind: "Name",
                                      value: "SetPriceSkuEdgesFragment",
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    ...SetPriceSkuEdgesFragmentDoc.definitions,
    ...PriceLevelsFragmentDoc.definitions,
  ],
} as unknown as DocumentNode<
  SetSkuRetailPriceMutation,
  SetSkuRetailPriceMutationVariables
>;
export const SetSkuRetailSizeMutationDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "SetSkuRetailSizeMutation" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "skuId" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "retailSizeId" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "assortmentId" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "assortmentSkuIds" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "ListType",
              type: {
                kind: "NonNullType",
                type: {
                  kind: "NamedType",
                  name: { kind: "Name", value: "ID" },
                },
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "setSkuRetailSize" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "skuId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "skuId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "retailSizeId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "retailSizeId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "assortmentId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "assortmentId" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "query" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "assortmentSkus" },
                        arguments: [
                          {
                            kind: "Argument",
                            name: { kind: "Name", value: "ids" },
                            value: {
                              kind: "Variable",
                              name: { kind: "Name", value: "assortmentSkuIds" },
                            },
                          },
                        ],
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "edges" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "FragmentSpread",
                                    name: {
                                      kind: "Name",
                                      value: "SizeRunFragment",
                                    },
                                  },
                                  {
                                    kind: "Field",
                                    alias: { kind: "Name", value: "color" },
                                    name: { kind: "Name", value: "colorV2" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "id" },
                                        },
                                        {
                                          kind: "FragmentSpread",
                                          name: {
                                            kind: "Name",
                                            value: "SizeCurvesFragment",
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    ...SizeRunFragmentDoc.definitions,
    ...SizeCurvesFragmentDoc.definitions,
  ],
} as unknown as DocumentNode<
  SetSkuRetailSizeMutation,
  SetSkuRetailSizeMutationVariables
>;
export const SetSkuWholesalePriceMutationDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "SetSkuWholesalePriceMutation" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "input" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: {
                kind: "Name",
                value: "SetAssortmentSkuWholesalePriceInput",
              },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "assortmentSkuIds" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "ListType",
              type: {
                kind: "NonNullType",
                type: {
                  kind: "NamedType",
                  name: { kind: "Name", value: "ID" },
                },
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "setAssortmentSkuWholesalePrice" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "input" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "query" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "assortmentSkus" },
                        arguments: [
                          {
                            kind: "Argument",
                            name: { kind: "Name", value: "ids" },
                            value: {
                              kind: "Variable",
                              name: { kind: "Name", value: "assortmentSkuIds" },
                            },
                          },
                        ],
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "edges" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "FragmentSpread",
                                    name: {
                                      kind: "Name",
                                      value: "SetPriceSkuEdgesFragment",
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    ...SetPriceSkuEdgesFragmentDoc.definitions,
    ...PriceLevelsFragmentDoc.definitions,
  ],
} as unknown as DocumentNode<
  SetSkuWholesalePriceMutation,
  SetSkuWholesalePriceMutationVariables
>;
export const SetWorkspaceMerchandisingHierarchyDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "SetWorkspaceMerchandisingHierarchy" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "input" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: {
                kind: "Name",
                value: "SetAssortmentMerchandisingHierarchyInput",
              },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "assortmentId" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: {
              kind: "Name",
              value: "setAssortmentMerchandisingHierarchy",
            },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "input" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "assortment" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "merchandisingHierarchy" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "edges" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "node" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "name" },
                                        },
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "id" },
                                        },
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "parent",
                                          },
                                          selectionSet: {
                                            kind: "SelectionSet",
                                            selections: [
                                              {
                                                kind: "Field",
                                                name: {
                                                  kind: "Name",
                                                  value: "node",
                                                },
                                                selectionSet: {
                                                  kind: "SelectionSet",
                                                  selections: [
                                                    {
                                                      kind: "Field",
                                                      name: {
                                                        kind: "Name",
                                                        value: "id",
                                                      },
                                                    },
                                                  ],
                                                },
                                              },
                                            ],
                                          },
                                        },
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "level",
                                          },
                                          selectionSet: {
                                            kind: "SelectionSet",
                                            selections: [
                                              {
                                                kind: "Field",
                                                name: {
                                                  kind: "Name",
                                                  value: "node",
                                                },
                                                selectionSet: {
                                                  kind: "SelectionSet",
                                                  selections: [
                                                    {
                                                      kind: "Field",
                                                      name: {
                                                        kind: "Name",
                                                        value: "id",
                                                      },
                                                    },
                                                    {
                                                      kind: "Field",
                                                      name: {
                                                        kind: "Name",
                                                        value: "name",
                                                      },
                                                    },
                                                    {
                                                      kind: "Field",
                                                      name: {
                                                        kind: "Name",
                                                        value: "code",
                                                      },
                                                    },
                                                    {
                                                      kind: "Field",
                                                      name: {
                                                        kind: "Name",
                                                        value: "depth",
                                                      },
                                                    },
                                                  ],
                                                },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "retailer" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "node" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "id" },
                                  },
                                  {
                                    kind: "FragmentSpread",
                                    name: {
                                      kind: "Name",
                                      value:
                                        "RetailerAssortmentAttributeOptionsFragment",
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "attributeOptions" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "edges" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "node" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "id" },
                                        },
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "value",
                                          },
                                        },
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "attribute",
                                          },
                                          selectionSet: {
                                            kind: "SelectionSet",
                                            selections: [
                                              {
                                                kind: "Field",
                                                name: {
                                                  kind: "Name",
                                                  value: "node",
                                                },
                                                selectionSet: {
                                                  kind: "SelectionSet",
                                                  selections: [
                                                    {
                                                      kind: "Field",
                                                      name: {
                                                        kind: "Name",
                                                        value: "id",
                                                      },
                                                    },
                                                  ],
                                                },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "PriceModifierFragment" },
                      },
                      {
                        kind: "FragmentSpread",
                        name: {
                          kind: "Name",
                          value: "FinancialOverviewFragment",
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "skus" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "edges" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "_id" },
                                  },
                                  {
                                    kind: "Field",
                                    alias: { kind: "Name", value: "color" },
                                    name: { kind: "Name", value: "colorV2" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "id" },
                                        },
                                        {
                                          kind: "FragmentSpread",
                                          name: {
                                            kind: "Name",
                                            value: "SizeCurvesFragment",
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    ...RetailerAssortmentAttributeOptionsFragmentDoc.definitions,
    ...PriceModifierFragmentDoc.definitions,
    ...FinancialOverviewFragmentDoc.definitions,
    ...UnitFragmentDoc.definitions,
    ...FinancialPriceFragmentDoc.definitions,
    ...FinancialPriceTargetFragmentDoc.definitions,
    ...SizeCurvesFragmentDoc.definitions,
  ],
} as unknown as DocumentNode<
  SetWorkspaceMerchandisingHierarchyMutation,
  SetWorkspaceMerchandisingHierarchyMutationVariables
>;
export const SetWorkspaceOverviewMerchandisingHierarchyDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: {
        kind: "Name",
        value: "SetWorkspaceOverviewMerchandisingHierarchy",
      },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "input" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: {
                kind: "Name",
                value: "SetAssortmentMerchandisingHierarchyInput",
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: {
              kind: "Name",
              value: "setAssortmentMerchandisingHierarchy",
            },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "input" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "assortment" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "FragmentSpread",
                        name: {
                          kind: "Name",
                          value: "WorkspaceOverviewAssortmentFragment",
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    ...WorkspaceOverviewAssortmentFragmentDoc.definitions,
    ...WorkspaceOverviewAssortmentBaseFragmentDoc.definitions,
    ...WorkspaceOverviewDeliveryWindowFragmentDoc.definitions,
    ...WorkspaceOverviewBrandFragmentDoc.definitions,
    ...SeasonFragmentDoc.definitions,
    ...WorkspaceOverviewFinancialsFragmentDoc.definitions,
    ...WorkspaceOverviewTotalPriceLevelFragmentDoc.definitions,
    ...WorkspaceOverviewPriceLevelFragmentDoc.definitions,
    ...WorkspaceOverviewHierarchyFragmentDoc.definitions,
    ...WorkspaceOverviewUserFragmentDoc.definitions,
    ...WorkspaceOverviewAttributeOptionFragmentDoc.definitions,
    ...WorkspaceOverviewAttributeFragmentDoc.definitions,
    ...AssortmentValidationRequirementsFragmentDoc.definitions,
    ...AssortmentValidationFieldsFragmentDoc.definitions,
    ...AssortmentItemValidationFieldsFragmentDoc.definitions,
  ],
} as unknown as DocumentNode<
  SetWorkspaceOverviewMerchandisingHierarchyMutation,
  SetWorkspaceOverviewMerchandisingHierarchyMutationVariables
>;
export const SizeBulkQueryDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "SizeBulkQuery" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "assortmentId" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "assortment" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "assortmentId" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "skus" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "edges" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "FragmentSpread",
                              name: {
                                kind: "Name",
                                value: "SkuBulkUnitsFragment",
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    ...SkuBulkUnitsFragmentDoc.definitions,
    ...PriceLevelsFragmentDoc.definitions,
  ],
} as unknown as DocumentNode<SizeBulkQuery, SizeBulkQueryVariables>;
export const UpdatePoBasicDetailsDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "updatePOBasicDetails" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "assortmentId" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "startShip" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "completeShip" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "due" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "name" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "poNumber" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "updateAssortmentDetails" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: {
                  kind: "ObjectValue",
                  fields: [
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "assortmentId" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "assortmentId" },
                      },
                    },
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "startShip" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "startShip" },
                      },
                    },
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "completeShip" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "completeShip" },
                      },
                    },
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "dueDate" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "due" },
                      },
                    },
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "name" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "name" },
                      },
                    },
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "poNumber" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "poNumber" },
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "assortment" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "FragmentSpread",
                        name: {
                          kind: "Name",
                          value: "WorkspaceOverviewAssortmentBaseFragment",
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    ...WorkspaceOverviewAssortmentBaseFragmentDoc.definitions,
    ...WorkspaceOverviewDeliveryWindowFragmentDoc.definitions,
  ],
} as unknown as DocumentNode<
  UpdatePoBasicDetailsMutation,
  UpdatePoBasicDetailsMutationVariables
>;
export const UpdatePoDetailsDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "updatePODetails" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "assortmentId" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "brandId" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "editableByUserIds" },
          },
          type: {
            kind: "ListType",
            type: {
              kind: "NonNullType",
              type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "startShip" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "completeShip" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "dueDate" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "seasonId" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "name" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "poNumber" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "status" },
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "AssortmentStatus" },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "version" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "updateAssortmentDetails" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: {
                  kind: "ObjectValue",
                  fields: [
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "assortmentId" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "assortmentId" },
                      },
                    },
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "brandId" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "brandId" },
                      },
                    },
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "editableByUserIds" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "editableByUserIds" },
                      },
                    },
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "startShip" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "startShip" },
                      },
                    },
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "completeShip" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "completeShip" },
                      },
                    },
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "dueDate" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "dueDate" },
                      },
                    },
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "seasonId" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "seasonId" },
                      },
                    },
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "name" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "name" },
                      },
                    },
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "poNumber" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "poNumber" },
                      },
                    },
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "status" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "status" },
                      },
                    },
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "version" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "version" },
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "assortment" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "FragmentSpread",
                        name: {
                          kind: "Name",
                          value: "WorkspaceOverviewAssortmentFragment",
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    ...WorkspaceOverviewAssortmentFragmentDoc.definitions,
    ...WorkspaceOverviewAssortmentBaseFragmentDoc.definitions,
    ...WorkspaceOverviewDeliveryWindowFragmentDoc.definitions,
    ...WorkspaceOverviewBrandFragmentDoc.definitions,
    ...SeasonFragmentDoc.definitions,
    ...WorkspaceOverviewFinancialsFragmentDoc.definitions,
    ...WorkspaceOverviewTotalPriceLevelFragmentDoc.definitions,
    ...WorkspaceOverviewPriceLevelFragmentDoc.definitions,
    ...WorkspaceOverviewHierarchyFragmentDoc.definitions,
    ...WorkspaceOverviewUserFragmentDoc.definitions,
    ...WorkspaceOverviewAttributeOptionFragmentDoc.definitions,
    ...WorkspaceOverviewAttributeFragmentDoc.definitions,
    ...AssortmentValidationRequirementsFragmentDoc.definitions,
    ...AssortmentValidationFieldsFragmentDoc.definitions,
    ...AssortmentItemValidationFieldsFragmentDoc.definitions,
  ],
} as unknown as DocumentNode<
  UpdatePoDetailsMutation,
  UpdatePoDetailsMutationVariables
>;
export const UpdateProductColorImageMutationDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "UpdateProductColorImageMutation" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "colorId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "file" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "Upload" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: {
              kind: "Name",
              value: "AssortmentUI__uploadProductColorImage",
            },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "productColorId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "colorId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "file" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "file" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "colorId" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "image" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "ImageFragment" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    ...ImageFragmentDoc.definitions,
  ],
} as unknown as DocumentNode<
  UpdateProductColorImageMutation,
  UpdateProductColorImageMutationVariables
>;
export const UpdateRetailWorkspaceNameDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "updateRetailWorkspaceName" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "workspaceId" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "name" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "updateRetailWorkspaceName" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: {
                  kind: "ObjectValue",
                  fields: [
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "retailWorkspaceId" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "workspaceId" },
                      },
                    },
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "name" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "name" },
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "retailWorkspace" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "__typename" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  UpdateRetailWorkspaceNameMutation,
  UpdateRetailWorkspaceNameMutationVariables
>;
export const UpdateRowSizeBulkDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "updateRowSizeBulk" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "assortmentId" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "updates" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "ListType",
              type: {
                kind: "NonNullType",
                type: {
                  kind: "NamedType",
                  name: {
                    kind: "Name",
                    value: "AssortmentUI__BulkSizeUnitUpdate",
                  },
                },
              },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "assortmentSkuIds" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "ListType",
              type: {
                kind: "NonNullType",
                type: {
                  kind: "NamedType",
                  name: { kind: "Name", value: "ID" },
                },
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "AssortmentUI__updateRowSizeBulk" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "assortmentId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "assortmentId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "updates" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "updates" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "query" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "assortmentSkus" },
                        arguments: [
                          {
                            kind: "Argument",
                            name: { kind: "Name", value: "ids" },
                            value: {
                              kind: "Variable",
                              name: { kind: "Name", value: "assortmentSkuIds" },
                            },
                          },
                        ],
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "edges" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "FragmentSpread",
                                    name: {
                                      kind: "Name",
                                      value: "SkuBulkUnitsFragment",
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    ...SkuBulkUnitsFragmentDoc.definitions,
    ...PriceLevelsFragmentDoc.definitions,
  ],
} as unknown as DocumentNode<
  UpdateRowSizeBulkMutation,
  UpdateRowSizeBulkMutationVariables
>;
export const UpdateSavedViewMutationDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "UpdateSavedViewMutation" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "input" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "UpdateConfigurationInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "AssortmentUI__updateConfiguration" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "input" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "SavedViewFragment" },
                },
              ],
            },
          },
        ],
      },
    },
    ...SavedViewFragmentDoc.definitions,
  ],
} as unknown as DocumentNode<
  UpdateSavedViewMutation,
  UpdateSavedViewMutationVariables
>;
export const UpdateWorkspaceDetailsDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "UpdateWorkspaceDetails" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "assortmentId" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "brandId" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "editableByUserIds" },
          },
          type: {
            kind: "ListType",
            type: {
              kind: "NonNullType",
              type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "startShip" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "completeShip" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "dueDate" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "seasonId" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "name" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "poNumber" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "status" },
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "AssortmentStatus" },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "version" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "updateAssortmentDetails" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: {
                  kind: "ObjectValue",
                  fields: [
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "assortmentId" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "assortmentId" },
                      },
                    },
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "brandId" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "brandId" },
                      },
                    },
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "editableByUserIds" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "editableByUserIds" },
                      },
                    },
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "startShip" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "startShip" },
                      },
                    },
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "completeShip" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "completeShip" },
                      },
                    },
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "dueDate" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "dueDate" },
                      },
                    },
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "seasonId" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "seasonId" },
                      },
                    },
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "name" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "name" },
                      },
                    },
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "poNumber" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "poNumber" },
                      },
                    },
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "status" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "status" },
                      },
                    },
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "version" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "version" },
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "assortment" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "FragmentSpread",
                        name: {
                          kind: "Name",
                          value: "WorkspaceDetailsAssortmentFragment",
                        },
                      },
                      {
                        kind: "FragmentSpread",
                        name: {
                          kind: "Name",
                          value: "AssortmentValidationRequirementsFragment",
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    ...WorkspaceDetailsAssortmentFragmentDoc.definitions,
    ...RetailerAssortmentAttributeOptionsFragmentDoc.definitions,
    ...SizeCurvesFragmentDoc.definitions,
    ...AssortmentValidationRequirementsFragmentDoc.definitions,
    ...AssortmentValidationFieldsFragmentDoc.definitions,
    ...AssortmentItemValidationFieldsFragmentDoc.definitions,
  ],
} as unknown as DocumentNode<
  UpdateWorkspaceDetailsMutation,
  UpdateWorkspaceDetailsMutationVariables
>;
export const UpdateWorkspaceNameDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "UpdateWorkspaceName" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "assortmentId" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "name" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "updateAssortmentDetails" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: {
                  kind: "ObjectValue",
                  fields: [
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "assortmentId" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "assortmentId" },
                      },
                    },
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "name" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "name" },
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "assortment" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  UpdateWorkspaceNameMutation,
  UpdateWorkspaceNameMutationVariables
>;
export const UploadProductImageMutationDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "UploadProductImageMutation" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "assortmentId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "productId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "file" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "Upload" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "AssortmentUI__uploadProductImage" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "assortmentId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "assortmentId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "productId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "productId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "file" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "file" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "assortmentId" },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  UploadProductImageMutation,
  UploadProductImageMutationVariables
>;
export const UploadSwatchImageMutationDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "UploadSwatchImageMutation" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "assortmentId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "colorId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "file" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "Upload" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "AssortmentUI__uploadSwatchImage" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "assortmentId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "assortmentId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "colorId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "colorId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "file" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "file" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "image" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "ImageFragment" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    ...ImageFragmentDoc.definitions,
  ],
} as unknown as DocumentNode<
  UploadSwatchImageMutation,
  UploadSwatchImageMutationVariables
>;
export const UpsertRetailBudgetMutationDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "UpsertRetailBudgetMutation" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "input" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "RetailBudgetInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "upsertRetailBudget" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "input" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "workspaceOrAssortmentId" },
                },
                { kind: "Field", name: { kind: "Name", value: "budgetType" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "finalExtCost" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "finalExtRetail" },
                },
                { kind: "Field", name: { kind: "Name", value: "totalUnits" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "categoryTotals" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "finalExtCost" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "finalExtRetail" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "totalUnits" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "finalExtCostCurrency" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "finalExtRetailCurrency" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "topLevelBudgetCategory" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "categoryType" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  UpsertRetailBudgetMutation,
  UpsertRetailBudgetMutationVariables
>;
export const WorkspaceDetailsQueryDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "WorkspaceDetailsQuery" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "assortmentId" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "assortment" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "assortmentId" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                {
                  kind: "FragmentSpread",
                  name: {
                    kind: "Name",
                    value: "WorkspaceDetailsAssortmentFragment",
                  },
                },
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "FinancialOverviewFragment" },
                },
                {
                  kind: "FragmentSpread",
                  name: {
                    kind: "Name",
                    value: "AssortmentValidationRequirementsFragment",
                  },
                },
                {
                  kind: "FragmentSpread",
                  name: {
                    kind: "Name",
                    value: "AssortmentDoorsClustersFragment",
                  },
                },
              ],
            },
          },
        ],
      },
    },
    ...WorkspaceDetailsAssortmentFragmentDoc.definitions,
    ...RetailerAssortmentAttributeOptionsFragmentDoc.definitions,
    ...SizeCurvesFragmentDoc.definitions,
    ...FinancialOverviewFragmentDoc.definitions,
    ...UnitFragmentDoc.definitions,
    ...FinancialPriceFragmentDoc.definitions,
    ...FinancialPriceTargetFragmentDoc.definitions,
    ...AssortmentValidationRequirementsFragmentDoc.definitions,
    ...AssortmentValidationFieldsFragmentDoc.definitions,
    ...AssortmentItemValidationFieldsFragmentDoc.definitions,
    ...AssortmentDoorsClustersFragmentDoc.definitions,
    ...DoorClusterFragmentDoc.definitions,
    ...DoorFragmentDoc.definitions,
  ],
} as unknown as DocumentNode<
  WorkspaceDetailsQuery,
  WorkspaceDetailsQueryVariables
>;
export const OrderHeaderAssortmentDetailsDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "OrderHeaderAssortmentDetails" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "assortmentId" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "assortment" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "assortmentId" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "workspace" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  OrderHeaderAssortmentDetailsQuery,
  OrderHeaderAssortmentDetailsQueryVariables
>;
export const DoorActualUnitsQueryDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "DoorActualUnitsQuery" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "assortmentId" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "assortment" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "assortmentId" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "skus" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "edges" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "_id" },
                            },
                            {
                              kind: "FragmentSpread",
                              name: {
                                kind: "Name",
                                value: "AssortmentSkuDoorQuantitiesFragment",
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    ...AssortmentSkuDoorQuantitiesFragmentDoc.definitions,
  ],
} as unknown as DocumentNode<
  DoorActualUnitsQuery,
  DoorActualUnitsQueryVariables
>;
export const ActiveProfileDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "ActiveProfile" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            alias: { kind: "Name", value: "account" },
            name: { kind: "Name", value: "activeViewingAccount" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "AccountPrimaryFragment" },
                },
              ],
            },
          },
          {
            kind: "Field",
            alias: { kind: "Name", value: "otherAccounts" },
            name: { kind: "Name", value: "viewingAccounts" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "AccountPrimaryFragment" },
                },
              ],
            },
          },
          {
            kind: "Field",
            alias: { kind: "Name", value: "user" },
            name: { kind: "Name", value: "viewingUser" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "UserPrimaryFragment" },
                },
              ],
            },
          },
        ],
      },
    },
    ...AccountPrimaryFragmentDoc.definitions,
    ...UserPrimaryFragmentDoc.definitions,
  ],
} as unknown as DocumentNode<ActiveProfileQuery, ActiveProfileQueryVariables>;
export const AssortmentWorkspaceCheckDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "AssortmentWorkspaceCheck" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "assortmentId" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "assortment" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "assortmentId" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "workspace" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AssortmentWorkspaceCheckQuery,
  AssortmentWorkspaceCheckQueryVariables
>;
export const WorkspaceBrandNamesDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "WorkspaceBrandNames" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "workspaceId" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "retailWorkspace" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "workspaceId" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "assortments" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "brand" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "FragmentSpread",
                              name: {
                                kind: "Name",
                                value: "WorkspaceBrandNamesAssortmentBrand",
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    ...WorkspaceBrandNamesAssortmentBrandDoc.definitions,
  ],
} as unknown as DocumentNode<
  WorkspaceBrandNamesQuery,
  WorkspaceBrandNamesQueryVariables
>;
export const WorkspaceCurrenciesDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "WorkspaceCurrencies" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "workspaceId" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "retailWorkspace" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "workspaceId" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "assortments" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: {
                          kind: "Name",
                          value: "WorkspaceCurrenciesFragment",
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    ...WorkspaceCurrenciesFragmentDoc.definitions,
  ],
} as unknown as DocumentNode<
  WorkspaceCurrenciesQuery,
  WorkspaceCurrenciesQueryVariables
>;
export const WorkspaceDeliveryWindowDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "WorkspaceDeliveryWindow" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "workspaceId" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "retailWorkspace" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "workspaceId" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "assortments" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: {
                          kind: "Name",
                          value: "WorkspaceDeliveryWindowAssortmentFragment",
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    ...WorkspaceDeliveryWindowAssortmentFragmentDoc.definitions,
    ...WorkspaceDeliveryWindowFragmentDoc.definitions,
  ],
} as unknown as DocumentNode<
  WorkspaceDeliveryWindowQuery,
  WorkspaceDeliveryWindowQueryVariables
>;
export const WorkspaceFinancialsDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "WorkspaceFinancials" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "workspaceId" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "retailWorkspace" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "workspaceId" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "assortments" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: {
                          kind: "Name",
                          value: "WorkspaceFinancialsAssortmentFragment",
                        },
                      },
                      {
                        kind: "FragmentSpread",
                        name: {
                          kind: "Name",
                          value: "WorkspaceUnitsCountFragment",
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    ...WorkspaceFinancialsAssortmentFragmentDoc.definitions,
    ...WorkspaceFinancialsPriceLevelFragmentDoc.definitions,
    ...WorkspaceUnitsCountFragmentDoc.definitions,
  ],
} as unknown as DocumentNode<
  WorkspaceFinancialsQuery,
  WorkspaceFinancialsQueryVariables
>;
export const WorkspaceNameDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "WorkspaceName" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "workspaceId" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "retailWorkspace" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "workspaceId" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<WorkspaceNameQuery, WorkspaceNameQueryVariables>;
export const WorkspaceOverviewDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "WorkspaceOverview" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "workspaceId" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "retailWorkspace" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "workspaceId" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "assortments" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: {
                          kind: "Name",
                          value: "WorkspaceOverviewAssortmentFragment",
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    ...WorkspaceOverviewAssortmentFragmentDoc.definitions,
    ...WorkspaceOverviewAssortmentBaseFragmentDoc.definitions,
    ...WorkspaceOverviewDeliveryWindowFragmentDoc.definitions,
    ...WorkspaceOverviewBrandFragmentDoc.definitions,
    ...SeasonFragmentDoc.definitions,
    ...WorkspaceOverviewFinancialsFragmentDoc.definitions,
    ...WorkspaceOverviewTotalPriceLevelFragmentDoc.definitions,
    ...WorkspaceOverviewPriceLevelFragmentDoc.definitions,
    ...WorkspaceOverviewHierarchyFragmentDoc.definitions,
    ...WorkspaceOverviewUserFragmentDoc.definitions,
    ...WorkspaceOverviewAttributeOptionFragmentDoc.definitions,
    ...WorkspaceOverviewAttributeFragmentDoc.definitions,
    ...AssortmentValidationRequirementsFragmentDoc.definitions,
    ...AssortmentValidationFieldsFragmentDoc.definitions,
    ...AssortmentItemValidationFieldsFragmentDoc.definitions,
  ],
} as unknown as DocumentNode<
  WorkspaceOverviewQuery,
  WorkspaceOverviewQueryVariables
>;
export const WorkspaceOverviewAvailableAttributesDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "WorkspaceOverviewAvailableAttributes" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "workspaceId" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "assortment" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "workspaceId" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "retailer" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "node" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" },
                            },
                            {
                              kind: "Field",
                              name: {
                                kind: "Name",
                                value: "assortmentAttributes",
                              },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "edges" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "node" },
                                          selectionSet: {
                                            kind: "SelectionSet",
                                            selections: [
                                              {
                                                kind: "Field",
                                                name: {
                                                  kind: "Name",
                                                  value: "id",
                                                },
                                              },
                                              {
                                                kind: "Field",
                                                name: {
                                                  kind: "Name",
                                                  value: "availableOptions",
                                                },
                                                arguments: [
                                                  {
                                                    kind: "Argument",
                                                    name: {
                                                      kind: "Name",
                                                      value: "assortmentId",
                                                    },
                                                    value: {
                                                      kind: "Variable",
                                                      name: {
                                                        kind: "Name",
                                                        value: "workspaceId",
                                                      },
                                                    },
                                                  },
                                                ],
                                                selectionSet: {
                                                  kind: "SelectionSet",
                                                  selections: [
                                                    {
                                                      kind: "Field",
                                                      name: {
                                                        kind: "Name",
                                                        value: "edges",
                                                      },
                                                      selectionSet: {
                                                        kind: "SelectionSet",
                                                        selections: [
                                                          {
                                                            kind: "Field",
                                                            name: {
                                                              kind: "Name",
                                                              value: "node",
                                                            },
                                                            selectionSet: {
                                                              kind: "SelectionSet",
                                                              selections: [
                                                                {
                                                                  kind: "Field",
                                                                  name: {
                                                                    kind: "Name",
                                                                    value: "id",
                                                                  },
                                                                },
                                                                {
                                                                  kind: "Field",
                                                                  name: {
                                                                    kind: "Name",
                                                                    value:
                                                                      "code",
                                                                  },
                                                                },
                                                                {
                                                                  kind: "Field",
                                                                  alias: {
                                                                    kind: "Name",
                                                                    value:
                                                                      "name",
                                                                  },
                                                                  name: {
                                                                    kind: "Name",
                                                                    value:
                                                                      "value",
                                                                  },
                                                                },
                                                                {
                                                                  kind: "Field",
                                                                  name: {
                                                                    kind: "Name",
                                                                    value:
                                                                      "attribute",
                                                                  },
                                                                  selectionSet:
                                                                    {
                                                                      kind: "SelectionSet",
                                                                      selections:
                                                                        [
                                                                          {
                                                                            kind: "Field",
                                                                            name: {
                                                                              kind: "Name",
                                                                              value:
                                                                                "node",
                                                                            },
                                                                            selectionSet:
                                                                              {
                                                                                kind: "SelectionSet",
                                                                                selections:
                                                                                  [
                                                                                    {
                                                                                      kind: "FragmentSpread",
                                                                                      name: {
                                                                                        kind: "Name",
                                                                                        value:
                                                                                          "WorkspaceOverviewAttributeFragment",
                                                                                      },
                                                                                    },
                                                                                  ],
                                                                              },
                                                                          },
                                                                        ],
                                                                    },
                                                                },
                                                              ],
                                                            },
                                                          },
                                                        ],
                                                      },
                                                    },
                                                  ],
                                                },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    ...WorkspaceOverviewAttributeFragmentDoc.definitions,
  ],
} as unknown as DocumentNode<
  WorkspaceOverviewAvailableAttributesQuery,
  WorkspaceOverviewAvailableAttributesQueryVariables
>;
export const WorkspacePurchaseOrderCountDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "WorkspacePurchaseOrderCount" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "workspaceId" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "retailWorkspace" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "workspaceId" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "assortments" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  WorkspacePurchaseOrderCountQuery,
  WorkspacePurchaseOrderCountQueryVariables
>;
export const WorkspaceRetailerNamesDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "WorkspaceRetailerNames" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "workspaceId" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "retailWorkspace" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "workspaceId" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "assortments" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "retailer" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "node" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "FragmentSpread",
                                    name: {
                                      kind: "Name",
                                      value:
                                        "WorkspaceRetailerNamesAssortmentRetailer",
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    ...WorkspaceRetailerNamesAssortmentRetailerDoc.definitions,
  ],
} as unknown as DocumentNode<
  WorkspaceRetailerNamesQuery,
  WorkspaceRetailerNamesQueryVariables
>;
export const WorkspaceTotalUnitsDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "WorkspaceTotalUnits" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "workspaceId" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "retailWorkspace" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "workspaceId" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "assortments" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "financials" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "products" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "id" },
                                  },
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "colorPriceLevels",
                                    },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "id" },
                                        },
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "quantity",
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "total" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "id" },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "quantity" },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  WorkspaceTotalUnitsQuery,
  WorkspaceTotalUnitsQueryVariables
>;
export const WorkspaceValidationRequirementsDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "WorkspaceValidationRequirements" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "workspaceId" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "retailWorkspace" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "workspaceId" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "assortments" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "FragmentSpread",
                        name: {
                          kind: "Name",
                          value: "AssortmentValidationRequirementsFragment",
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    ...AssortmentValidationRequirementsFragmentDoc.definitions,
    ...AssortmentValidationFieldsFragmentDoc.definitions,
    ...AssortmentItemValidationFieldsFragmentDoc.definitions,
  ],
} as unknown as DocumentNode<
  WorkspaceValidationRequirementsQuery,
  WorkspaceValidationRequirementsQueryVariables
>;
